import { Grade } from 'types/graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  InsightsJson: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Json: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  OrganizationJson: { input: any; output: any };
  Void: { input: any; output: any };
};

export type Account = {
  __typename?: 'Account';
  countryCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type AccountDto = {
  __typename?: 'AccountDto';
  /** 아바타 프로필 이미지 URL */
  avatarImage?: Maybe<Scalars['String']['output']>;
  /** 생일 */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** 국가 코드 */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** 생성일 */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** 소개글 */
  description?: Maybe<Scalars['String']['output']>;
  /** 이메일 */
  email?: Maybe<Scalars['String']['output']>;
  /** 이메일 인증 여부 */
  emailVerified: Scalars['Boolean']['output'];
  /** 소속 엔터프라이즈 정보 */
  enterprise?: Maybe<Enterprise>;
  /** 성별 */
  gender?: Maybe<Gender>;
  grade?: Maybe<SchoolGrade>;
  /** 식별자 */
  id: Scalars['String']['output'];
  /** 소셜 로그인 정보 */
  identities: Array<Maybe<SocialIdentity>>;
  /** 광고 제거 상품 구독 여부 */
  isAdFreeSubscribed: Scalars['Boolean']['output'];
  /** 클래스팅 관리자 여부 */
  isAdmin: Scalars['Boolean']['output'];
  /** 언어 */
  language?: Maybe<Scalars['String']['output']>;
  /** 마케팅 수신 정보 채널별 동의 여부 */
  marketingAgreement?: Maybe<MarketingAgreement>;
  /** 모바일 정보 */
  mobile?: Maybe<Mobile>;
  /** 이름 */
  name?: Maybe<Scalars['String']['output']>;
  personalCertificate?: Maybe<PersonalCertificate>;
  /** 개인정보 이용약관 동의일 */
  privacyTermsAgreedAt?: Maybe<Scalars['String']['output']>;
  /** 프로필 이미지 URL */
  profileImage?: Maybe<Scalars['String']['output']>;
  role: AccountRole;
  schoolInfo?: Maybe<SchoolInfo>;
  /** 소속 학교 정보 */
  schoolInfoDto?: Maybe<SchoolInfoDto>;
  /** 자녀 학교 정보 리스트 */
  schoolInfoDtoForChildren: Array<Maybe<SchoolInfoDto2>>;
  schoolInfoForChildren: Array<Maybe<SchoolInfo2>>;
  /** 회원가입일 */
  signedUpAt?: Maybe<Scalars['String']['output']>;
  /** 학생코드 */
  studentRegistrationCode?: Maybe<Scalars['String']['output']>;
  /** 이용약관 동의일 */
  termsOfUseAgreedAt?: Maybe<Scalars['String']['output']>;
  /** 수정일 */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** 아이디 */
  username?: Maybe<Scalars['String']['output']>;
};

export enum AccountRole {
  Parent = 'PARENT',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export type AccountSchool = {
  __typename?: 'AccountSchool';
  admissionAge: Scalars['Float']['output'];
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  regularCourseYear: Scalars['Float']['output'];
  zipcode: Scalars['String']['output'];
};

export type AccountServiceAccountCertificate = {
  __typename?: 'AccountServiceAccountCertificate';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ActivityStreamDto = {
  __typename?: 'ActivityStreamDto';
  actor: Scalars['Json']['output'];
  content?: Maybe<Scalars['String']['output']>;
  generator: Scalars['Json']['output'];
  id: Scalars['String']['output'];
  object: Scalars['Json']['output'];
  publishedAt: Scalars['String']['output'];
  recipientId: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  target: Scalars['Json']['output'];
  type: Scalars['String']['output'];
};

export type ActivityStreamsCollectionDto = {
  __typename?: 'ActivityStreamsCollectionDto';
  activityStreams: Array<Maybe<ActivityStreamDto>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type AddAttendeeToMeetingDtoInput = {
  classroomId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AddDeviceRequestDtoInput = {
  deviceModel: Scalars['String']['input'];
  deviceOs: Scalars['String']['input'];
  deviceType: Scalars['Float']['input'];
  gameVersion: Scalars['String']['input'];
  isRelease?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  sdk: Scalars['String']['input'];
  timezone: Scalars['Float']['input'];
  voipDeviceToken: Scalars['String']['input'];
};

export type AddDeviceResponseDto = {
  __typename?: 'AddDeviceResponseDto';
  playerId: Scalars['String']['output'];
};

export type AddReactionToCommentDtoInput = {
  name: Scalars['String']['input'];
};

export type AddReactionToPostDtoInput = {
  name: Scalars['String']['input'];
};

export type AddReactionToReplyDtoInput = {
  name: Scalars['String']['input'];
};

export type AiAssignment = {
  __typename?: 'AiAssignment';
  aiAssignmentType?: Maybe<Scalars['String']['output']>;
  completedStudentsCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isReserved?: Maybe<Scalars['Boolean']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  studentsCount?: Maybe<Scalars['Int']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<AiAssignmentSubject>;
  title?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Array<Maybe<AiAssignmentSubject>>>;
};

export type AiAssignmentSubject = {
  __typename?: 'AiAssignmentSubject';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type AiTestCollection = {
  __typename?: 'AiTestCollection';
  aiTests?: Maybe<Array<Maybe<AiTestItem>>>;
  page?: Maybe<Scalars['Int']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
};

export type AiTestCreated = {
  __typename?: 'AiTestCreated';
  id?: Maybe<Scalars['Int']['output']>;
};

export type AiTestItem = {
  __typename?: 'AiTestItem';
  assigneesCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  questionsCount?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<AiTestItemSubject>;
  submissionCount?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Array<Maybe<AiTestItemSubject>>>;
};

export type AiTestItemSubject = {
  __typename?: 'AiTestItemSubject';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type AiTestPolicy = {
  __typename?: 'AiTestPolicy';
  allowedSubjectIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableCount?: Maybe<Scalars['Int']['output']>;
  isSubjectRestricted: Scalars['Boolean']['output'];
  remainingRenewTime: Scalars['Int']['output'];
  renewAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AiTestSubject = {
  __typename?: 'AiTestSubject';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hasUnit?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AiTestUnit = {
  __typename?: 'AiTestUnit';
  coreConcepts?: Maybe<Array<Maybe<AiTestUnitCoreConceptsItems>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AiTestUnitCoreConceptsItems = {
  __typename?: 'AiTestUnitCoreConceptsItems';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  keywords?: Maybe<Array<Maybe<AiTestUnitCoreConceptsItemsKeywordsItems>>>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  quizzesCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AiTestUnitCoreConceptsItemsKeywordsItems = {
  __typename?: 'AiTestUnitCoreConceptsItemsKeywordsItems';
  coreConceptId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pagesCount?: Maybe<Scalars['Int']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AppearanceInfo = {
  __typename?: 'AppearanceInfo';
  appIconUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  signInLogoUrl?: Maybe<Scalars['String']['output']>;
};

export type ArticleDto = {
  __typename?: 'ArticleDto';
  blocks: Scalars['Json']['output'];
  files: Array<FileMetaDto>;
  id: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  publishedAt: Scalars['Date']['output'];
  publisher: PublisherDto;
  revision: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ArticlesCollectionDto = {
  __typename?: 'ArticlesCollectionDto';
  articles: Array<ArticleDto>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type AssignAssignmentDtoInput = {
  assigneeIds: Array<InputMaybe<Scalars['String']['input']>>;
  channelId: Scalars['String']['input'];
};

export type AssignMemberRoleDtoInput = {
  role: Role;
};

export type AssignmentDto = {
  __typename?: 'AssignmentDto';
  /** 과제를 할당받은 학생 구성원 전체 식별자 목록 */
  assigneeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** 과제를 할당받은 전체 학생 수 */
  assigneesCount: Scalars['Float']['output'];
  /** 각 학생이 제출한 과제 제출물 목록 */
  assignmentSubmissions: Array<Maybe<AssignmentSubmissionDto>>;
  /** 과제를 작성한 선생님의 식별자 */
  authorId: Scalars['String']['output'];
  /** 과제가 작성된 공간의 식별자 */
  channelId?: Maybe<Scalars['String']['output']>;
  /** 과제가 작성된 클래스룸의 식별자 */
  classroomId: Scalars['String']['output'];
  /** 과제가 작성된 시각 */
  createdAt: Scalars['String']['output'];
  /** 제출물 제출 마감 시각 */
  dueDateTime?: Maybe<Scalars['String']['output']>;
  /** 최대 점수가 있는지 표시 */
  hasMaxPoints: Scalars['Boolean']['output'];
  /** 과제 식별자 */
  id: Scalars['String']['output'];
  /** 한 명 이상의 학생에게 할당되었는지 표시 */
  isAssigned: Scalars['Boolean']['output'];
  /** 과제에 설정된 최대 점수 */
  maxPoints: Scalars['Float']['output'];
  /** 제출물을 제출한 학생 수 */
  membersSubmittedCount: Scalars['Float']['output'];
  /** 과제 메타 정보 */
  meta?: Maybe<Scalars['Json']['output']>;
  /** 과제의 내용이 작성된 게시글의 식별자 */
  postId: Scalars['String']['output'];
  /** 과제의 제목 */
  title?: Maybe<Scalars['String']['output']>;
  type: AssignmentType;
  /** 과제가 마지막으로 수정된 시각 */
  updatedAt: Scalars['String']['output'];
};

export type AssignmentPermissionDto = {
  __typename?: 'AssignmentPermissionDto';
  canGrade: Scalars['Boolean']['output'];
  canSubmit: Scalars['Boolean']['output'];
};

export type AssignmentSubmissionCommentDto = {
  __typename?: 'AssignmentSubmissionCommentDto';
  assigneeId: Scalars['String']['output'];
  assignmentId: Scalars['String']['output'];
  author: MemberDto;
  authorId: Scalars['String']['output'];
  classroomId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  repliesCount: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export type AssignmentSubmissionCommentPermissionDto = {
  __typename?: 'AssignmentSubmissionCommentPermissionDto';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
};

export type AssignmentSubmissionCommentsCollectionDto = {
  __typename?: 'AssignmentSubmissionCommentsCollectionDto';
  assignmentSubmissionComments: Array<Maybe<AssignmentSubmissionCommentDto>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type AssignmentSubmissionDto = {
  __typename?: 'AssignmentSubmissionDto';
  /** 과제를 할당받은 학생 구성원 식별자 */
  assigneeId: Scalars['String']['output'];
  /** 출제된 과제의 식별자 */
  assignmentId: Scalars['String']['output'];
  /** 과제 제출물이 제출된 클래스의 식별자 */
  classroomId: Scalars['String']['output'];
  /** 과제 제출물에 달린 댓글 수 */
  commentsCount?: Maybe<Scalars['Float']['output']>;
  /** 과제 제출물이 생성된 시각 */
  createdAt: Scalars['String']['output'];
  gradingStatus: GradingStatus;
  /** 과제 제출물 식별자 */
  id: Scalars['String']['output'];
  /** 해당 학생이 제출물을 제출했는지 표시 */
  isSubmitted: Scalars['Boolean']['output'];
  lastSubmission?: Maybe<SubmissionDto>;
  learningSubmission?: Maybe<LearningSubmissionDto>;
  /** 과제 제출물 채점 점수 */
  points?: Maybe<Scalars['Float']['output']>;
  /** 과제 제출물에 달린 답글 수 */
  repliesCount?: Maybe<Scalars['Float']['output']>;
  status: AssignmentSubmissionStatus;
  /** 과제에 제출된 전체 제출물 목록 */
  submissions: Array<Maybe<SubmissionDto>>;
  /** 과제 제출물이 마지막으로 수정된 시각 */
  updatedAt: Scalars['String']['output'];
};

export enum AssignmentSubmissionStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Prepared = 'PREPARED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
}

export enum AssignmentType {
  Assignment = 'ASSIGNMENT',
  Learning = 'LEARNING',
}

export type AssignmentsSearchCollectionDto = {
  __typename?: 'AssignmentsSearchCollectionDto';
  assignments: Array<Maybe<AssignmentDto>>;
  /** 현재 페이지 */
  page?: Maybe<Scalars['Float']['output']>;
  /** 페이지당 과제의 최대 개수 */
  perPage?: Maybe<Scalars['Float']['output']>;
  /** 검색된 과제의 총 페이지 수 */
  totalPages?: Maybe<Scalars['Float']['output']>;
  /** 검색된 과제의 총 개수 */
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type AttendanceDto = {
  __typename?: 'AttendanceDto';
  attendedAt?: Maybe<Scalars['String']['output']>;
  attendee?: Maybe<MemberDto>;
  attendeeId: Scalars['String']['output'];
  classroomId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  status: Status;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AttendanceSummaryDto = {
  __typename?: 'AttendanceSummaryDto';
  attendanceRatio: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  numberOfAttendedStudents: Scalars['Float']['output'];
  numberOfStudents: Scalars['Float']['output'];
};

export type ChangeEmailAdminDtoInput = {
  email: Scalars['String']['input'];
};

export type ChangeEmailDtoInput = {
  code: Scalars['String']['input'];
};

export type ChangeMobileDtoInput = {
  code: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};

export type ChangePasswordDtoInput = {
  newPasswordConfirm: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ChangeUsernameAdminDtoInput = {
  username: Scalars['String']['input'];
};

export type Channel = {
  __typename?: 'Channel';
  archived: Scalars['Boolean']['output'];
  autoJoin: Scalars['Boolean']['output'];
  canMemberReactToPost: Scalars['Boolean']['output'];
  canMemberWriteComment: Scalars['Boolean']['output'];
  canMemberWritePost: Scalars['Boolean']['output'];
  channelGroupId?: Maybe<Scalars['String']['output']>;
  classroomId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editorMode?: Maybe<Scalars['Json']['output']>;
  general: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inactiveMembersCount: Scalars['Float']['output'];
  isCommon: Scalars['Boolean']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  meeting?: Maybe<Meeting>;
  meetingId?: Maybe<Scalars['String']['output']>;
  memberIds: Array<Maybe<Scalars['String']['output']>>;
  membersCount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Float']['output']>;
  postPins: Array<Maybe<Scalars['Json']['output']>>;
  purpose?: Maybe<Scalars['String']['output']>;
  type: Type;
  updatedAt: Scalars['String']['output'];
};

export type ChannelDto = {
  __typename?: 'ChannelDto';
  /** 비활성 구성원 수를 제외한 활성 구성원 수 */
  activeMembersCount: Scalars['Float']['output'];
  archived: Scalars['Boolean']['output'];
  autoJoin: Scalars['Boolean']['output'];
  canMemberReactToPost: Scalars['Boolean']['output'];
  canMemberWriteComment: Scalars['Boolean']['output'];
  canMemberWritePost: Scalars['Boolean']['output'];
  channelGroupId?: Maybe<Scalars['String']['output']>;
  channelType: ChannelType;
  classroomId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  /** 게시글 작성 시 사용될 에디터 모드를 결정하는 값. "default" | "presentation"  */
  editorMode: Scalars['String']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isCommon: Scalars['Boolean']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  meeting?: Maybe<Meeting2>;
  meetingId?: Maybe<Scalars['String']['output']>;
  /** 유지관리되지 않는 필드. 대체제로 `ChannelMember` 관련 API를 사용 */
  memberIds: Array<Maybe<Scalars['String']['output']>>;
  membersCount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ChannelGroupDto = {
  __typename?: 'ChannelGroupDto';
  channelIds: Array<Maybe<Scalars['String']['output']>>;
  channels: Array<Maybe<ChannelDto>>;
  classroomId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primary: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ChannelPostPinDto = {
  __typename?: 'ChannelPostPinDto';
  channelId: Scalars['String']['output'];
  classroomId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  post?: Maybe<PostDto>;
  postId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum ChannelType {
  Announcement = 'ANNOUNCEMENT',
  Legacy = 'LEGACY',
  Post = 'POST',
}

export type ChatUser = {
  __typename?: 'ChatUser';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type CheckedOnboardingPinnedPost = {
  __typename?: 'CheckedOnboardingPinnedPost';
  isChecked: Scalars['Boolean']['output'];
};

export type ChildAccountDto = {
  __typename?: 'ChildAccountDto';
  avatarImage?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mobile?: Maybe<Mobile2>;
  name: Scalars['String']['output'];
  schoolInfo?: Maybe<SchoolInfo4>;
  signInMethods: Array<Maybe<SignInMethod>>;
  signedUpAt?: Maybe<Scalars['String']['output']>;
};

export type ChildCodeResponseDto = {
  __typename?: 'ChildCodeResponseDto';
  childId: Scalars['String']['output'];
  childName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  expireAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  verifiedGuardianId: Scalars['String']['output'];
};

export type Class = {
  __typename?: 'Class';
  class?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
};

export type ClassCodeDto = {
  __typename?: 'ClassCodeDto';
  /** 해당 코드의 클래스룸 식별자 */
  classroomId: Scalars['String']['output'];
  /** 클래스코드 */
  code: Scalars['String']['output'];
  enterprise?: Maybe<ClassroomEnterpriseDto>;
  /** 클래스코드 만료일 */
  expiresAt?: Maybe<Scalars['String']['output']>;
};

export type ClassCollection = {
  __typename?: 'ClassCollection';
  classes?: Maybe<Array<Maybe<Class>>>;
};

export type ClassroomBookmarkStatusDto = {
  __typename?: 'ClassroomBookmarkStatusDto';
  /** 북마크 여부 */
  bookmarkStatus: Scalars['Boolean']['output'];
  /** 북마크된 클래스의 식별자 */
  classroomId: Scalars['String']['output'];
  /** 북마크한 구성원의 식별자 */
  userId: Scalars['String']['output'];
};

export type ClassroomDto = {
  __typename?: 'ClassroomDto';
  /** 클래스룸 소개글 */
  about?: Maybe<Scalars['String']['output']>;
  /** 클래스룸 관리자 수 */
  adminsCount: Scalars['Float']['output'];
  /** 클래스룸 보관 여부 */
  archived: Scalars['Boolean']['output'];
  /** 클래스룸 국가 코드 */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** 클래스룸 생성일자 */
  createdAt: Scalars['String']['output'];
  /** 클래스룸이 소속된 엔터프라이즈의 식별자 */
  enterpriseId?: Maybe<Scalars['String']['output']>;
  /** 클래스룸 학년 */
  grade: Grade2;
  /** 클래스룸 식별자 */
  id: Scalars['String']['output'];
  /** 구 클래스 여부 */
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  legacyClassRelation?: Maybe<LegacyClassRelation>;
  /**
   * 클래스룸의 구성원 목록
   *
   * * 유효한 API: 클래스룸 개설 API
   *
   * * 그 외의 API: 항상 빈 배열
   */
  members: Array<Maybe<Member>>;
  /** 클래스룸 전체 멤버 수. *관리자 포함* */
  membersCount: Scalars['Float']['output'];
  /** 클래스룸 이름 */
  name: Scalars['String']['output'];
  /** 클래스룸이 소속된 기관의 식별자 */
  orgId?: Maybe<Scalars['String']['output']>;
  /** 클래스룸 고정된 태그 수 */
  pinnedTagsCount: Scalars['Float']['output'];
  /** 미디어 서비스 내의 클래스룸 프로필 이미지 식별자 */
  profileImageId?: Maybe<Scalars['String']['output']>;
  /** 클래스룸 프로필 이미지 URL */
  profileImageUrl: Scalars['String']['output'];
  /** 클래스룸 생성 관련 작업들의 진행 상태 */
  provisioningStatus: Scalars['String']['output'];
  /** 클래스룸이 소속된 기관의 식별자. *orgId로 네이밍 변경 예정* */
  schoolId?: Maybe<Scalars['String']['output']>;
  /** 클래스룸이 소속된 기관의 이름 */
  schoolName?: Maybe<Scalars['String']['output']>;
  /** 클래스룸 교육년도 */
  schoolYear?: Maybe<Scalars['Int']['output']>;
  /** 클래스룸 학생 수 */
  studentsCount: Scalars['Float']['output'];
  /** 클래스룸 태그 수 */
  tagsCount: Scalars['Float']['output'];
  type: ClassroomType;
  /** 클래스룸 최근 수정일자 */
  updatedAt: Scalars['String']['output'];
  /**
   * 클래스룸 기능 버전
   *
   * v2: 공통 공간(알림장 공간 및 공지 공간) 기능 제공
   */
  version: Scalars['Float']['output'];
};

export type ClassroomEnterpriseDto = {
  __typename?: 'ClassroomEnterpriseDto';
  /** 사람이 읽을 수 있는 엔터프라이즈 식별자 */
  slug: Scalars['String']['output'];
};

export type ClassroomFavoriteDto = {
  __typename?: 'ClassroomFavoriteDto';
  classroom: ClassroomDto;
  /** 즐겨찾기된 클래스룸의 식별자 */
  classroomId: Scalars['String']['output'];
  /** 클래스룸을 즐겨찾기한 시각 */
  createdAt: Scalars['String']['output'];
  /** 클래스룸 즐겨찾기 식별자 */
  id: Scalars['String']['output'];
  /** 클래스룸을 즐겨찾기한 구성원의 식별자 */
  userId: Scalars['String']['output'];
};

export type ClassroomFavoritesCollectionDto = {
  __typename?: 'ClassroomFavoritesCollectionDto';
  classroomFavorites: Array<Maybe<ClassroomFavoriteDto>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type ClassroomFeaturePreferencesDto = {
  __typename?: 'ClassroomFeaturePreferencesDto';
  aiTest: ClassroomFeaturePreferencesOptionDto;
  assignment: ClassroomFeaturePreferencesOptionDto;
  attendance: ClassroomFeaturePreferencesOptionDto;
  /** 클래스 식별자 */
  classroomId: Scalars['String']['output'];
  classroomSettings: ClassroomFeaturePreferencesOptionDto;
  classtalk: ClassroomFeaturePreferencesOptionDto;
  cumulativeRecord: ClassroomFeaturePreferencesOptionDto;
  /** 클래스 기능 설정 식별자 */
  id: Scalars['String']['output'];
  insights: ClassroomFeaturePreferencesOptionDto;
  jello: ClassroomFeaturePreferencesOptionDto;
  memberList: ClassroomFeaturePreferencesOptionDto;
  zoomMeeting: ClassroomFeaturePreferencesOptionDto;
};

export type ClassroomFeaturePreferencesOptionDto = {
  __typename?: 'ClassroomFeaturePreferencesOptionDto';
  /** 해당 기능 활성화 여부 */
  enabled: Scalars['Boolean']['output'];
};

export enum ClassroomType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export type ClassroomsCollectionDto = {
  __typename?: 'ClassroomsCollectionDto';
  classrooms: Array<Maybe<ClassroomDto>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type ClassroomsSearchCollectionDto = {
  __typename?: 'ClassroomsSearchCollectionDto';
  classrooms: Array<Maybe<ClassroomDto>>;
  page?: Maybe<Scalars['Float']['output']>;
  perPage?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ClasstalkMeetingDto = {
  __typename?: 'ClasstalkMeetingDto';
  classroomId?: Maybe<Scalars['String']['output']>;
  classroomName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  externalServiceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCaller: Scalars['Boolean']['output'];
  isMissed: Scalars['Boolean']['output'];
  opponentId?: Maybe<Scalars['String']['output']>;
  opponentName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ClasstalkMeetingsCollectionDto = {
  __typename?: 'ClasstalkMeetingsCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  meetings: Array<Maybe<ClasstalkMeetingDto>>;
};

export type ClasstalkUserDto = {
  __typename?: 'ClasstalkUserDto';
  callable: Scalars['Boolean']['output'];
  callableCurrently: Scalars['Boolean']['output'];
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** 클래스톡 유저의 활성 상태. 클래스팅에서 탈퇴 등의 경우 해당 값이 false로 설정됨 */
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  setting: ClasstalkUserSettingDto;
  updatedAt: Scalars['String']['output'];
  workdays: Array<Maybe<WorkdayDto>>;
};

export type ClasstalkUserSettingDto = {
  __typename?: 'ClasstalkUserSettingDto';
  autoRecordingTermsAgreedAt?: Maybe<Scalars['String']['output']>;
  isAutoRecordingActive: Scalars['Boolean']['output'];
};

export type CommentDto = {
  __typename?: 'CommentDto';
  author: MemberDto;
  authorId: Scalars['String']['output'];
  classroomId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  postId: Scalars['String']['output'];
  reactions: Array<Maybe<CommentReactionDto>>;
  reactionsCount: Scalars['Json']['output'];
  repliesCount: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CommentPermissionDto = {
  __typename?: 'CommentPermissionDto';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  canReact: Scalars['Boolean']['output'];
  canWriteReply: Scalars['Boolean']['output'];
};

export type CommentReactionDto = {
  __typename?: 'CommentReactionDto';
  createdAt: Scalars['String']['output'];
  member?: Maybe<MemberDto>;
  memberId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CommentReactionsCollectionDto = {
  __typename?: 'CommentReactionsCollectionDto';
  reactions: Array<Maybe<CommentReactionDto>>;
};

export type CommentsCollectionDto = {
  __typename?: 'CommentsCollectionDto';
  comments: Array<Maybe<CommentDto>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type CompleteAssignmentSubmissionDtoInput = {
  assigneeId: Scalars['String']['input'];
};

export type CompleteOnboardingChecklistActionDtoInput = {
  /**
   *
   *     완료할 체크리스트의 액션,
   *     허용되는 값들:
   *       | 'distribute-ai-test'
   *       | 'visit-product-tour-page'
   *
   */
  action: Scalars['String']['input'];
};

export type CreateAiTestDtoInput = {
  classroomId: Scalars['String']['input'];
  studentIds: Array<InputMaybe<Scalars['String']['input']>>;
  subjectId: Scalars['Int']['input'];
  testConfiguration?: InputMaybe<
    Array<InputMaybe<CreateAiTestDtoTestConfigurationItemsInput>>
  >;
};

export type CreateAiTestDtoTestConfigurationItemsInput = {
  coreConceptId?: InputMaybe<Scalars['Int']['input']>;
  questionCount?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAssignmentDtoInput = {
  postId: Scalars['String']['input'];
  type?: InputMaybe<AssignmentType>;
};

export type CreateAssignmentSubmissionCommentDtoInput = {
  content: Scalars['String']['input'];
};

export type CreateAttendanceDtoInput = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChannelDtoInput = {
  autoJoin?: InputMaybe<Scalars['Boolean']['input']>;
  canMemberReactToPost?: InputMaybe<Scalars['Boolean']['input']>;
  canMemberWriteComment?: InputMaybe<Scalars['Boolean']['input']>;
  canMemberWritePost?: InputMaybe<Scalars['Boolean']['input']>;
  channelGroupId: Scalars['String']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  purpose?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChannelGroupDtoInput = {
  name: Scalars['String']['input'];
};

export type CreateClassroomDtoInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Grade>;
  name: Scalars['String']['input'];
  schoolId?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCommentDtoInput = {
  content: Scalars['String']['input'];
};

export type CreateFileDtoInput = {
  categoryId: Scalars['String']['input'];
  categoryType: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  originalFileName: Scalars['String']['input'];
  totalSize: Scalars['Float']['input'];
};

export type CreateImageDtoInput = {
  categoryId: Scalars['String']['input'];
  categoryType: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  totalSize: Scalars['Float']['input'];
};

export type CreateMeetingDtoInput = {
  classroomId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePostDtoInput = {
  isAssignment: Scalars['Boolean']['input'];
};

export type CreateReplyDtoInput = {
  content: Scalars['String']['input'];
};

export type CreateTagDtoInput = {
  name: Scalars['String']['input'];
};

export type CreateVideoDtoInput = {
  categoryId: Scalars['String']['input'];
  categoryType: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  totalSize: Scalars['Float']['input'];
};

export type DistributeAiTestDtoInput = {
  classroomId: Scalars['String']['input'];
  resourceScope?: InputMaybe<DistributeAiTestDtoResourceScope>;
  studentIds: Array<InputMaybe<Scalars['String']['input']>>;
  testConfiguration?: InputMaybe<
    Array<InputMaybe<DistributeAiTestDtoTestConfigurationItemsInput>>
  >;
};

export enum DistributeAiTestDtoResourceScope {
  CoreConcept = 'CoreConcept',
  Keyword = 'Keyword',
}

export type DistributeAiTestDtoTestConfigurationItemsInput = {
  questionCount?: InputMaybe<Scalars['Int']['input']>;
  resourceId?: InputMaybe<Scalars['Int']['input']>;
};

/** 소속 엔터프라이즈 정보 */
export type Enterprise = {
  __typename?: 'Enterprise';
  createdAt: Scalars['String']['output'];
  homeUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isWhiteLabeled: Scalars['Boolean']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type EnterpriseBranding = {
  __typename?: 'EnterpriseBranding';
  /** 심볼 형태의 엔터프라이즈 로고 이미지 URL */
  appIconUrl?: Maybe<Scalars['String']['output']>;
  /** 심볼과 워드마크가 조합된 형태의 엔터프라이즈 로고 이미지 URL */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** 엔터프라이즈의 브랜드 이름 */
  name?: Maybe<Scalars['String']['output']>;
  /** 엔터프라이즈 브랜드 대표 색상의 HEX 코드 */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** 전용 로그인 페이지에 사용되는 엔터프라이즈 로그인 로고 이미지 URL */
  signInLogoUrl?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseContractDto = {
  __typename?: 'EnterpriseContractDto';
  /** 계약 종료 일시 */
  endsAt: Scalars['String']['output'];
  /** 엔터프라이즈 계약 식별자 */
  id: Scalars['String']['output'];
  /** 계약 시작 일시 */
  startsAt: Scalars['String']['output'];
  type: EnterpriseContractType;
};

export enum EnterpriseContractType {
  AiLearning = 'AI_LEARNING',
  Bass = 'BASS',
  ClassroomPostTranslation = 'CLASSROOM_POST_TRANSLATION',
  Mou = 'MOU',
}

export type EnterpriseDto = {
  __typename?: 'EnterpriseDto';
  appearanceInfo: AppearanceInfo;
  branding: EnterpriseBranding;
  contracts: Array<Maybe<EnterpriseContractDto>>;
  /** 엔터프라이즈 생성 일시 */
  createdAt: Scalars['String']['output'];
  /** 엔터프라이즈의 기본 홈 URL */
  homeUrl: Scalars['String']['output'];
  /** 엔터프라이즈 식별자 */
  id: Scalars['String']['output'];
  /** 화이트라벨링 적용 대상 엔터프라이즈 여부 */
  isWhiteLabeled: Scalars['Boolean']['output'];
  /** 엔터프라이즈의 로고 URL */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** 엔터프라이즈 이름 */
  name: Scalars['String']['output'];
  /** 사람이 읽고 이해하기 쉬운 형태의 엔터프라이즈 식별자 */
  slug: Scalars['String']['output'];
  /** 엔터프라이즈 최근 수정 일시 */
  updatedAt: Scalars['String']['output'];
};

export type EnterpriseMemberDto = {
  __typename?: 'EnterpriseMemberDto';
  /** 구성원 생성 일시 */
  createdAt: Scalars['String']['output'];
  /** 구성원이 소속된 엔터프라이즈 식별자 */
  enterpriseId: Scalars['String']['output'];
  /** 엔터프라이즈 구성원 식별자 */
  id: Scalars['String']['output'];
  role: EnterpriseMemberRole;
  /** 구성원 최근 수정 일시 */
  updatedAt: Scalars['String']['output'];
};

export enum EnterpriseMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
}

export type EnterprisePermissionDto = {
  __typename?: 'EnterprisePermissionDto';
  /** 현재 사용자가 최소 한 개의 엔터프라이즈 소속 기관에서 관리 권한을 가졌는지의 여부 */
  canAdministerOrganization: Scalars['Boolean']['output'];
};

export type ExcelExportJobStateDto = {
  __typename?: 'ExcelExportJobStateDto';
  createdAt: Scalars['String']['output'];
  /** 내려받기 작업 상태가 제거될 시각 */
  deleteAt?: Maybe<Scalars['String']['output']>;
  /** 생성된 파일을 다운받을 경로. 내려받기 상태가 완료 시 반환됨 */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** 내려받기 진행 상태를 나타내는 상태값. "processing" | "success" | "failure" */
  jobStatus: Scalars['String']['output'];
  numOfCompletedTasks: Scalars['Float']['output'];
  numOfTotalTasks: Scalars['Float']['output'];
  /** 내려받기 진행도를 나타내는 값. 백분율로 표시 */
  progress: Scalars['Float']['output'];
};

export type ExcuseAttendanceDtoInput = {
  attendedAt: Scalars['String']['input'];
  attendeeId: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type File = {
  __typename?: 'File';
  categoryId: Scalars['String']['output'];
  categoryType: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalFileName: Scalars['String']['output'];
  presignedPost?: Maybe<Scalars['Json']['output']>;
  totalSize: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
  urls: Scalars['Json']['output'];
  userId: Scalars['String']['output'];
};

export type FileMetaDto = {
  __typename?: 'FileMetaDto';
  name: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  src: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export enum Filter {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
}

export enum Gender2 {
  Female = 'FEMALE',
  Male = 'MALE',
}

export type GenerateRecordingDownloadUrlDtoInput = {
  externalServiceId: Scalars['String']['input'];
  meetingId: Scalars['String']['input'];
};

export type GeneratorDto = {
  __typename?: 'GeneratorDto';
  hasUnreadNews: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export { Grade };

export enum Grade2 {
  Adult = 'ADULT',
  Eighth = 'EIGHTH',
  Eleventh = 'ELEVENTH',
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  HigherEducation = 'HIGHER_EDUCATION',
  Kindergarten = 'KINDERGARTEN',
  Ninth = 'NINTH',
  None = 'NONE',
  PreKindergarten = 'PRE_KINDERGARTEN',
  Second = 'SECOND',
  Seventh = 'SEVENTH',
  Sixth = 'SIXTH',
  Tenth = 'TENTH',
  Third = 'THIRD',
  Twelfth = 'TWELFTH',
}

export enum Grade3 {
  Adult = 'ADULT',
  Eighth = 'EIGHTH',
  Eleventh = 'ELEVENTH',
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  HigherEducation = 'HIGHER_EDUCATION',
  Kindergarten = 'KINDERGARTEN',
  Ninth = 'NINTH',
  None = 'NONE',
  PreKindergarten = 'PRE_KINDERGARTEN',
  Second = 'SECOND',
  Seventh = 'SEVENTH',
  Sixth = 'SIXTH',
  Tenth = 'TENTH',
  Third = 'THIRD',
  Twelfth = 'TWELFTH',
}

export enum GradingStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

export enum Group {
  Guardian = 'GUARDIAN',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export enum Group2 {
  Guardian = 'GUARDIAN',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export type GuardianAccountDto = {
  __typename?: 'GuardianAccountDto';
  avatarImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GuardianRelationshipDto = {
  __typename?: 'GuardianRelationshipDto';
  childAccount?: Maybe<ChildAccountDto>;
  createdAt: Scalars['String']['output'];
  guardianAccount?: Maybe<GuardianAccountDto>;
  id: Scalars['String']['output'];
  relationshipType: RelationshipType;
};

export type Image = {
  __typename?: 'Image';
  categoryId: Scalars['String']['output'];
  categoryType: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalFileName: Scalars['String']['output'];
  presignedPost?: Maybe<Scalars['Json']['output']>;
  totalSize: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
  urls: Scalars['Json']['output'];
  userId: Scalars['String']['output'];
};

export type ImageDto = {
  __typename?: 'ImageDto';
  /** 이미지가 첨부된 상위 리소스 식별자 */
  categoryId: Scalars['String']['output'];
  /** 이미지가 첨부된 상위 리소스 */
  categoryType: Scalars['String']['output'];
  /** 이미지의 MIME 타입 */
  contentType: Scalars['String']['output'];
  /** 이미지가 생성된 시각 */
  createdAt: Scalars['String']['output'];
  /** 이미지가 저장된 경로 */
  filePath: Scalars['String']['output'];
  /** 이미지 식별자 */
  id: Scalars['String']['output'];
  /** 이미지의 원본 파일명 */
  originalFileName: Scalars['String']['output'];
  /** 이미지의 크기 */
  totalSize: Scalars['Float']['output'];
  /** 이미지가 최근 수정된 시각 */
  updatedAt: Scalars['String']['output'];
  /** 다양한 크기의 이미지 URL 목록 */
  urls: Scalars['Json']['output'];
  /** 이미지를 업로드한 사용자의 식별자 */
  userId: Scalars['String']['output'];
};

export type InitiateExportAttendancesDtoInput = {
  fileName: Scalars['String']['input'];
  /** comma separated string으로 월 지정. 예시) "1,2" */
  months: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Float']['input'];
};

export type InsightsAccountDto = {
  __typename?: 'InsightsAccountDto';
  guardianIds: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  role: InsightsAccountRole;
};

export enum InsightsAccountRole {
  Child = 'CHILD',
  Guardian = 'GUARDIAN',
}

export type InsightsActivitiesCollectionDto = {
  __typename?: 'InsightsActivitiesCollectionDto';
  activities: Array<Maybe<InsightsActivityDto>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type InsightsActivityDto = {
  __typename?: 'InsightsActivityDto';
  actor: Scalars['InsightsJson']['output'];
  childId: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  generator: Scalars['InsightsJson']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  object: Scalars['InsightsJson']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
  stickers?: Maybe<Array<Maybe<InsightsStickerDto>>>;
  summary?: Maybe<Scalars['String']['output']>;
  target: Scalars['InsightsJson']['output'];
  type: Scalars['String']['output'];
};

export enum InsightsBillingPeriodDuration {
  P1M = 'P1M',
  P1Y = 'P1Y',
}

export type InsightsChildDto = {
  __typename?: 'InsightsChildDto';
  avatarImage: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  schoolInfo?: Maybe<InsightsSchoolInfoDto>;
};

export type InsightsCreateCumulativeRecordDtoInput = {
  contents: Scalars['String']['input'];
  recordedAt: Scalars['String']['input'];
};

export type InsightsCreateFreePlanSubscriptionDtoInput = {
  childIds: Array<InputMaybe<Scalars['String']['input']>>;
  endAt: Scalars['String']['input'];
  ordererId: Scalars['String']['input'];
  packageName: Scalars['String']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  startAt: Scalars['String']['input'];
};

export type InsightsCreateGoalDtoInput = {
  reward?: InputMaybe<Scalars['String']['input']>;
  targetStampCount: Scalars['Float']['input'];
};

export type InsightsCumulativeRecordDto = {
  __typename?: 'InsightsCumulativeRecordDto';
  adminId: Scalars['String']['output'];
  classroomId: Scalars['String']['output'];
  contents: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  recordedAt: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type InsightsCumulativeRecordsCollectionDto = {
  __typename?: 'InsightsCumulativeRecordsCollectionDto';
  cumulativeRecords: Array<Maybe<InsightsCumulativeRecordDto>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type InsightsEstimatedOrderDto = {
  __typename?: 'InsightsEstimatedOrderDto';
  currencyCode: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type InsightsGoalDto = {
  __typename?: 'InsightsGoalDto';
  childId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  endAt?: Maybe<Scalars['String']['output']>;
  guardianId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reward?: Maybe<Scalars['String']['output']>;
  stamps: Array<Maybe<InsightsStampDto>>;
  startAt?: Maybe<Scalars['String']['output']>;
  status: InsightsGoalStatus;
  targetStampCount: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum InsightsGoalStatus {
  Complete = 'COMPLETE',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS',
  Suspended = 'SUSPENDED',
}

export type InsightsOrderDto = {
  __typename?: 'InsightsOrderDto';
  billingPeriodDuration?: Maybe<InsightsBillingPeriodDuration>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ordererId: Scalars['String']['output'];
  paymentMethod: InsightsPaymentMethod;
  price?: Maybe<Scalars['Float']['output']>;
  status: InsightsOrderStatus;
  subscription?: Maybe<InsightsSubscriptionDto>;
  subscriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum InsightsOrderStatus {
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Draft = 'DRAFT',
}

export enum InsightsPaymentMethod {
  AndroidInApp = 'ANDROID_IN_APP',
  None = 'NONE',
}

export type InsightsPostReadDto = {
  __typename?: 'InsightsPostReadDto';
  postCreatedAt: Scalars['String']['output'];
  postId: Scalars['String']['output'];
  postReadRate: Scalars['Float']['output'];
  postTitle?: Maybe<Scalars['String']['output']>;
  postUrl: Scalars['String']['output'];
};

export type InsightsPostReadsCollectionDto = {
  __typename?: 'InsightsPostReadsCollectionDto';
  classroomId: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  postReadRates: Array<Maybe<InsightsPostReadDto>>;
  startDate: Scalars['String']['output'];
  totalPostCount: Scalars['Float']['output'];
};

export type InsightsPraiseChildActivityDtoInput = {
  stickerCode: InsightsStickerCode;
};

export type InsightsSchoolDto = {
  __typename?: 'InsightsSchoolDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum InsightsSchoolGrade {
  Adult = 'ADULT',
  Eighth = 'EIGHTH',
  Eleventh = 'ELEVENTH',
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  HigherEducation = 'HIGHER_EDUCATION',
  Kindergarten = 'KINDERGARTEN',
  Ninth = 'NINTH',
  None = 'NONE',
  PreKindergarten = 'PRE_KINDERGARTEN',
  Second = 'SECOND',
  Seventh = 'SEVENTH',
  Sixth = 'SIXTH',
  Tenth = 'TENTH',
  Third = 'THIRD',
  Twelfth = 'TWELFTH',
}

export type InsightsSchoolInfoDto = {
  __typename?: 'InsightsSchoolInfoDto';
  grade?: Maybe<InsightsSchoolGrade>;
  school?: Maybe<InsightsSchoolDto>;
};

export type InsightsStampDto = {
  __typename?: 'InsightsStampDto';
  activityId: Scalars['String']['output'];
  type: InsightsStampType;
};

export enum InsightsStampType {
  Admire = 'ADMIRE',
  Encourage = 'ENCOURAGE',
  PraiseHighest = 'PRAISE_HIGHEST',
  PraiseNormal = 'PRAISE_NORMAL',
  Thank = 'THANK',
}

export enum InsightsStickerCode {
  Admire = 'ADMIRE',
  Encourage = 'ENCOURAGE',
  PraiseHighest = 'PRAISE_HIGHEST',
  PraiseNormal = 'PRAISE_NORMAL',
  Thank = 'THANK',
}

export type InsightsStickerDto = {
  __typename?: 'InsightsStickerDto';
  code: InsightsStickerCode;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  senderId: Scalars['String']['output'];
};

export type InsightsSubscriptionDto = {
  __typename?: 'InsightsSubscriptionDto';
  childIds: Array<Maybe<Scalars['String']['output']>>;
  createdAt: Scalars['String']['output'];
  endAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  orderId: Scalars['String']['output'];
  plan?: Maybe<InsightsSubscriptionPlan>;
  platformStatus?: Maybe<InsightsSubscriptionPlatformStatus>;
  startAt?: Maybe<Scalars['String']['output']>;
  status: InsightsSubscriptionStatus;
  subscriberId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum InsightsSubscriptionPlan {
  Free = 'FREE',
  Pro = 'PRO',
}

export enum InsightsSubscriptionPlatformStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  InGracePeriod = 'IN_GRACE_PERIOD',
  OnHold = 'ON_HOLD',
}

export type InsightsSubscriptionProductDto = {
  __typename?: 'InsightsSubscriptionProductDto';
  basePlanId: Scalars['String']['output'];
  billingPeriodDuration: InsightsBillingPeriodDuration;
  currencyCode: Scalars['String']['output'];
  fixedPrice: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  offerId?: Maybe<Scalars['String']['output']>;
  plan: InsightsSubscriptionPlan;
  sellingPrice: Scalars['Float']['output'];
};

export enum InsightsSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
}

export type InsightsTodoDto = {
  __typename?: 'InsightsTodoDto';
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  dueAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: InsightsTodoType;
  updatedAt: Scalars['String']['output'];
};

export enum InsightsTodoType {
  Announcement = 'ANNOUNCEMENT',
  Assignment = 'ASSIGNMENT',
}

export type InsightsTodosCollectionDto = {
  __typename?: 'InsightsTodosCollectionDto';
  todos: Array<Maybe<InsightsTodoDto>>;
};

export type InsightsVerifyOrderDtoInput = {
  packageName: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  purchaseToken: Scalars['String']['input'];
};

export type IntegrateZoomDtoInput = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};

export type InviteMembersDtoInput = {
  phoneNumbers: Array<InputMaybe<Scalars['String']['input']>>;
};

export type JoinLegacyClassDtoInput = {
  childName?: InputMaybe<Scalars['String']['input']>;
  classcode: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type LearningCard = {
  __typename?: 'LearningCard';
  audioCount?: Maybe<Scalars['Int']['output']>;
  authorId?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  chapterId?: Maybe<Scalars['Int']['output']>;
  chapterName?: Maybe<Scalars['String']['output']>;
  chapterPosition?: Maybe<Scalars['Int']['output']>;
  copyId?: Maybe<Scalars['Int']['output']>;
  coreConcept?: Maybe<LearningCardCoreConcept>;
  coreConceptCode?: Maybe<Scalars['String']['output']>;
  coreConceptId?: Maybe<Scalars['Int']['output']>;
  coreConceptPosition?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  coverImageLarge?: Maybe<Scalars['String']['output']>;
  coverImageMedium?: Maybe<Scalars['String']['output']>;
  coverImageMini?: Maybe<Scalars['String']['output']>;
  coverImageSmall?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<LearningCardGrade>;
  gradeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageCount?: Maybe<Scalars['Int']['output']>;
  isAutograde?: Maybe<Scalars['Boolean']['output']>;
  isFinalCopy?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  maxPoints?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  publisherId?: Maybe<Scalars['Int']['output']>;
  publisherName?: Maybe<Scalars['String']['output']>;
  quizCount?: Maybe<Scalars['Int']['output']>;
  schoolId?: Maybe<Scalars['String']['output']>;
  searchKeywords?: Maybe<Scalars['String']['output']>;
  seriesId?: Maybe<Scalars['Int']['output']>;
  shareLevel?: Maybe<Scalars['Int']['output']>;
  storeCardId?: Maybe<Scalars['Int']['output']>;
  storeCardUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<LearningCardSubject>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoCount?: Maybe<Scalars['Int']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type LearningCardAnswer = {
  __typename?: 'LearningCardAnswer';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  storeOptionId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearningCardAudio = {
  __typename?: 'LearningCardAudio';
  audioFile?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  durationMillis?: Maybe<Scalars['Float']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  storeAudioId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearningCardCollection = {
  __typename?: 'LearningCardCollection';
  learningCards?: Maybe<Array<Maybe<LearningCard>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type LearningCardCoreConcept = {
  __typename?: 'LearningCardCoreConcept';
  chapterPosition?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domainConceptId?: Maybe<Scalars['Int']['output']>;
  domainId?: Maybe<Scalars['Int']['output']>;
  gradeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  quizzesCount?: Maybe<Scalars['Int']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoCoursesCount?: Maybe<Scalars['Int']['output']>;
};

export type LearningCardGrade = {
  __typename?: 'LearningCardGrade';
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  schoolYear?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usersCount?: Maybe<Scalars['Int']['output']>;
};

export type LearningCardImage = {
  __typename?: 'LearningCardImage';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageFile?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  largeUrl?: Maybe<Scalars['String']['output']>;
  mediumUrl?: Maybe<Scalars['String']['output']>;
  miniUrl?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  smallUrl?: Maybe<Scalars['String']['output']>;
  storeImageId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type LearningCardPage = {
  __typename?: 'LearningCardPage';
  answerCriteria?: Maybe<Scalars['Int']['output']>;
  answerViewType?: Maybe<Scalars['String']['output']>;
  answers?: Maybe<Array<Maybe<LearningCardAnswer>>>;
  audioCount?: Maybe<Scalars['Int']['output']>;
  audios?: Maybe<Array<Maybe<LearningCardAudio>>>;
  authorId?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  cardId?: Maybe<Scalars['Int']['output']>;
  chapterName?: Maybe<Scalars['String']['output']>;
  chapterPosition?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  coreConceptId?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<Scalars['Int']['output']>;
  gradeId?: Maybe<Scalars['Int']['output']>;
  gradingKeywords?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageCount?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<Maybe<LearningCardImage>>>;
  isAutograde?: Maybe<Scalars['Boolean']['output']>;
  isCopiedPage?: Maybe<Scalars['Boolean']['output']>;
  isQuiz?: Maybe<Scalars['Boolean']['output']>;
  isStorePage?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  pageType?: Maybe<LearningCardPagePageType>;
  pageTypeId?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  publisherId?: Maybe<Scalars['Int']['output']>;
  publisherName?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  searchKeywords?: Maybe<Scalars['String']['output']>;
  shareLevel?: Maybe<Scalars['Int']['output']>;
  storePageId?: Maybe<Scalars['Int']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoCount?: Maybe<Scalars['Int']['output']>;
  videos?: Maybe<Array<Maybe<LearningCardVideo>>>;
};

export type LearningCardPagePageType = {
  __typename?: 'LearningCardPagePageType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAutograde?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum LearningCardPageType {
  Essay = 'ESSAY',
  MultipleChoice = 'MULTIPLE_CHOICE',
  NonQuiz = 'NON_QUIZ',
  TextEntry = 'TEXT_ENTRY',
}

export type LearningCardSubject = {
  __typename?: 'LearningCardSubject';
  alias?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<Scalars['String']['output']>;
  assetBackground?: Maybe<Scalars['String']['output']>;
  colorCode?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gradeLowerBound?: Maybe<Scalars['Int']['output']>;
  gradeUpperBound?: Maybe<Scalars['Int']['output']>;
  hasCardLectures?: Maybe<Scalars['Boolean']['output']>;
  hasCourseGroup?: Maybe<Scalars['Boolean']['output']>;
  hasUnit?: Maybe<Scalars['Boolean']['output']>;
  hasVideoLectures?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSpecialized?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearningCardVideo = {
  __typename?: 'LearningCardVideo';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  durationMillis?: Maybe<Scalars['Float']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  posterPath?: Maybe<Scalars['String']['output']>;
  posterUrl?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  storeVideoId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoFile?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type LearningCoreConcept = {
  __typename?: 'LearningCoreConcept';
  chapterPosition?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domainConceptId?: Maybe<Scalars['Int']['output']>;
  domainId?: Maybe<Scalars['Int']['output']>;
  gradeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pivotCoreConceptId?: Maybe<Scalars['Int']['output']>;
  pivotUnitId?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  quizzesCount?: Maybe<Scalars['Int']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoCoursesCount?: Maybe<Scalars['Int']['output']>;
};

export type LearningGrade = {
  __typename?: 'LearningGrade';
  countryCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  schoolYear?: Maybe<Scalars['Int']['output']>;
};

export type LearningStoreCardAnswer = {
  __typename?: 'LearningStoreCardAnswer';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  storeOptionId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearningStoreCardAudio = {
  __typename?: 'LearningStoreCardAudio';
  audioFile?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  durationMillis?: Maybe<Scalars['Float']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  storeAudioId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearningStoreCardCollection = {
  __typename?: 'LearningStoreCardCollection';
  learningStoreCards?: Maybe<Array<Maybe<LearningCard>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type LearningStoreCardImage = {
  __typename?: 'LearningStoreCardImage';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageFile?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  largeUrl?: Maybe<Scalars['String']['output']>;
  mediumUrl?: Maybe<Scalars['String']['output']>;
  miniUrl?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  smallUrl?: Maybe<Scalars['String']['output']>;
  storeImageId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type LearningStoreCardPage = {
  __typename?: 'LearningStoreCardPage';
  answerCriteria?: Maybe<Scalars['Int']['output']>;
  answerViewType?: Maybe<Scalars['String']['output']>;
  answers?: Maybe<Array<Maybe<LearningStoreCardAnswer>>>;
  audioCount?: Maybe<Scalars['Int']['output']>;
  audios?: Maybe<Array<Maybe<LearningStoreCardAudio>>>;
  authorId?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  cardId?: Maybe<Scalars['Int']['output']>;
  chapterName?: Maybe<Scalars['String']['output']>;
  chapterPosition?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  copyId?: Maybe<Scalars['Int']['output']>;
  coreConceptId?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<Scalars['Int']['output']>;
  gradeId?: Maybe<Scalars['Int']['output']>;
  gradingKeywords?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageCount?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<Maybe<LearningStoreCardImage>>>;
  isAutograde?: Maybe<Scalars['Boolean']['output']>;
  isCopiedPage?: Maybe<Scalars['Boolean']['output']>;
  isQuiz?: Maybe<Scalars['Boolean']['output']>;
  isStorePage?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  optionViewType?: Maybe<Scalars['String']['output']>;
  options?: Maybe<LearningStoreCardPageOptions>;
  pageType?: Maybe<LearningStoreCardPagePageType>;
  pageTypeId?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  publisherId?: Maybe<Scalars['Int']['output']>;
  publisherName?: Maybe<Scalars['String']['output']>;
  quizType?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  searchKeywords?: Maybe<Scalars['String']['output']>;
  shareLevel?: Maybe<Scalars['Int']['output']>;
  storePageId?: Maybe<Scalars['Int']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  unitId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoCount?: Maybe<Scalars['Int']['output']>;
  videos?: Maybe<Array<Maybe<LearningStoreCardVideo>>>;
};

export type LearningStoreCardPageOptions = {
  __typename?: 'LearningStoreCardPageOptions';
  content?: Maybe<Scalars['String']['output']>;
  copyId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAnswer?: Maybe<Scalars['Boolean']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  storeOptionId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LearningStoreCardPagePageType = {
  __typename?: 'LearningStoreCardPagePageType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAutograde?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearningStoreCardVideo = {
  __typename?: 'LearningStoreCardVideo';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  durationMillis?: Maybe<Scalars['Float']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  posterPath?: Maybe<Scalars['String']['output']>;
  posterUrl?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  storeVideoId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoFile?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type LearningSubject = {
  __typename?: 'LearningSubject';
  backgroundIconUrl?: Maybe<Scalars['String']['output']>;
  colorCode?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  gradeLowerBound?: Maybe<Scalars['Int']['output']>;
  gradeUpperBound?: Maybe<Scalars['Int']['output']>;
  hasCardLectures?: Maybe<Scalars['Boolean']['output']>;
  hasUnit?: Maybe<Scalars['Boolean']['output']>;
  hasVideoLectures?: Maybe<Scalars['Boolean']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSpecialized?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type LearningSubmissionDto = {
  __typename?: 'LearningSubmissionDto';
  answers: Array<Maybe<LearningUserAnswerDto>>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type LearningUnit = {
  __typename?: 'LearningUnit';
  coreConceptId?: Maybe<Scalars['Int']['output']>;
  coreConcepts?: Maybe<Array<Maybe<LearningCoreConcept>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  curriculum?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['Int']['output']>;
  gradeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isGradeless?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearningUserAnswerDto = {
  __typename?: 'LearningUserAnswerDto';
  correctOptions?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  duration: Scalars['Float']['output'];
  essay?: Maybe<Scalars['String']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  maxPoints: Scalars['Float']['output'];
  multipleChoiceOption?: Maybe<Scalars['Json']['output']>;
  pageId: Scalars['Float']['output'];
  pageIndex: Scalars['Float']['output'];
  pageType: LearningCardPageType;
  points: Scalars['Float']['output'];
  textEntry?: Maybe<Scalars['String']['output']>;
  userInput: Scalars['String']['output'];
};

export type LegacyBookmarkResult = {
  __typename?: 'LegacyBookmarkResult';
  classId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LegacyClassMember = {
  __typename?: 'LegacyClassMember';
  child?: Maybe<Scalars['String']['output']>;
  classId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum LegacyClassRelation {
  Invited = 'INVITED',
  Joined = 'JOINED',
  Waiting = 'WAITING',
}

export type LinkChildRequestDtoInput = {
  childId: Scalars['String']['input'];
  relationshipType: RelationshipType;
};

export type LinkChildResponseDto = {
  __typename?: 'LinkChildResponseDto';
  childId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  guardianId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  relationshipType: RelationshipType;
};

export type LinkGuardianRequestDtoInput = {
  guardianId: Scalars['String']['input'];
  relationshipType: RelationshipType;
};

/** 마케팅 수신 정보 채널별 동의 여부 */
export type MarketingAgreement = {
  __typename?: 'MarketingAgreement';
  /** 마케팅 수신 정보 동의 여부(email) */
  isEmailAgreed: Scalars['Boolean']['output'];
  /** 마케팅 수신 정보 동의 여부(앱 푸시) */
  isPushAgreed: Scalars['Boolean']['output'];
  /** 마케팅 수신 정보 동의 여부(SMS) */
  isSmsAgreed: Scalars['Boolean']['output'];
};

export type MarketingAgreement2Input = {
  /** 마케팅 수신 정보 동의 여부(email) */
  isEmailAgreed: Scalars['Boolean']['input'];
  /** 마케팅 수신 정보 동의 여부(앱 푸시) */
  isPushAgreed: Scalars['Boolean']['input'];
  /** 마케팅 수신 정보 동의 여부(SMS) */
  isSmsAgreed: Scalars['Boolean']['input'];
};

export type MealFeedDto = {
  __typename?: 'MealFeedDto';
  actor: Scalars['Json']['output'];
  content: Scalars['String']['output'];
  generator: Scalars['Json']['output'];
  id: Scalars['String']['output'];
  object: Scalars['Json']['output'];
  publishedAt: Scalars['String']['output'];
  recipientId: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  target: Scalars['Json']['output'];
  type: Scalars['String']['output'];
};

export type MealFeedsCollectionDto = {
  __typename?: 'MealFeedsCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  mealFeeds: Array<Maybe<MealFeedDto>>;
};

export type MealPost = {
  __typename?: 'MealPost';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MealPostCollection = {
  __typename?: 'MealPostCollection';
  mealPosts?: Maybe<Array<Maybe<MealPost>>>;
};

export type Meeting = {
  __typename?: 'Meeting';
  channelId: Scalars['String']['output'];
  classroomId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  status: Status2;
  zoomMeeting: Scalars['Json']['output'];
  zoomSignature: Scalars['String']['output'];
};

export type Meeting2 = {
  __typename?: 'Meeting2';
  channelId: Scalars['String']['output'];
  classroomId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  joinUrl: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  status: Status2;
  zoomMeeting: Scalars['Json']['output'];
  zoomSignature: Scalars['String']['output'];
};

export type MeetingDto = {
  __typename?: 'MeetingDto';
  channelId: Scalars['String']['output'];
  classroomId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  joinUrl: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  status: Status2;
  zoomMeeting: Scalars['Json']['output'];
  zoomSignature: Scalars['String']['output'];
};

export type Member = {
  __typename?: 'Member';
  active: Scalars['Boolean']['output'];
  blocked: Scalars['Json']['output'];
  canStartMeeting?: Maybe<Scalars['Boolean']['output']>;
  classroomId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  group?: Maybe<Group>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profileImageId?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  roleId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type MemberAttendancesCollectionDto = {
  __typename?: 'MemberAttendancesCollectionDto';
  attendances: Array<Maybe<AttendanceDto>>;
};

export type MemberDto = {
  __typename?: 'MemberDto';
  /** 구성원 활성화 여부 */
  active: Scalars['Boolean']['output'];
  /** 구성원 차단 유무 */
  blocked: Scalars['Boolean']['output'];
  /** 줌 미팅 시작 권한 */
  canStartMeeting?: Maybe<Scalars['Boolean']['output']>;
  /** 구성원이 속한 클래스룸 식별자 */
  classroomId: Scalars['String']['output'];
  /** 구성원 가입 일자 */
  createdAt: Scalars['String']['output'];
  group?: Maybe<Group>;
  /** 구성원 식별자 */
  id: Scalars['String']['output'];
  /** 구성원 가입 프로비저닝 완료 유무 */
  isProvisioningCompleted: Scalars['Boolean']['output'];
  /** 구성원 이름 */
  name?: Maybe<Scalars['String']['output']>;
  /** 미디어 서비스 내의 구성원 프로필 이미지 식별자 */
  profileImageId?: Maybe<Scalars['String']['output']>;
  /** 구성원 프로필 이미지 URL */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: Role;
  roleId?: Maybe<Scalars['String']['output']>;
  /** 구성원 최근 수정일자 */
  updatedAt: Scalars['String']['output'];
};

export enum MemberGroup {
  Guardian = 'GUARDIAN',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export type MemberPushNotificationSettingsDto = {
  __typename?: 'MemberPushNotificationSettingsDto';
  id: Scalars['String']['output'];
  pushNotificationSettings: PushNotificationSettings;
};

export enum MemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
}

export type MembersCollectionDto = {
  __typename?: 'MembersCollectionDto';
  /** 다음 페이지 검색을 위한 커서 */
  cursor?: Maybe<Scalars['String']['output']>;
  members: Array<Maybe<MemberDto>>;
};

/** 모바일 정보 */
export type Mobile = {
  __typename?: 'Mobile';
  /** 휴대폰 국가 코드입니다. */
  countryCode: Scalars['String']['output'];
  /** 휴대폰 번호입니다. */
  number: Scalars['String']['output'];
};

export type Mobile2 = {
  __typename?: 'Mobile2';
  /** 휴대폰 국가 코드입니다. */
  countryCode: Scalars['String']['output'];
  /** 휴대폰 번호입니다. */
  number: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   *
   *
   * Equivalent to DELETE /account-service/private/accounts/{id}
   */
  accountPrivateControllerDeleteAccount?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /classtalk-service/meetings/{meetingId}/attendees
   */
  addAttendeeToClasstalkMeeting?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /notification-service/push-notification/devices
   */
  addDevice?: Maybe<AddDeviceResponseDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/posts/{postId}/comments/{commentId}/actions/react
   */
  addReactionToComment?: Maybe<CommentDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/react
   */
  addReactionToPost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/posts/{postId}/comments/{commentId}/replies/{replyId}/actions/react
   */
  addReactionToReply?: Maybe<ReplyDto>;
  /**
   *
   *
   * Equivalent to POST /media-service/admin/images
   */
  adminApiCreateImage?: Maybe<Image>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels/{channelId}/actions/archive
   */
  archiveChannel?: Maybe<Channel>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels-dto/{channelId}/actions/archive
   */
  archiveChannelDto?: Maybe<ChannelDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/actions/archiveClassroom
   */
  archiveClassroom?: Maybe<ClassroomDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/actions/assign
   */
  assignAssignment?: Maybe<AssignmentDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/members/{memberId}/actions/assign-role
   */
  assignMemberRole?: Maybe<MemberDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/members/{memberId}/actions/block
   */
  blockMember?: Maybe<MemberDto>;
  /**
   * 클래스룸 즐겨찾기
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/bookmark
   */
  bookmarkClassroom?: Maybe<ClassroomFavoriteDto>;
  /** POST /users/me/favorited_classes/{args.classId} */
  bookmarkLegacyClass?: Maybe<LegacyBookmarkResult>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/legacy-classrooms/{classroomId}/bookmark
   */
  bookmarkLegacyClassroom?: Maybe<ClassroomFavoriteDto>;
  /**
   *
   *
   * Equivalent to POST /account-service/accounts/{id}/change-email
   */
  changeEmail?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /account-service/accounts/{id}/change-mobile
   */
  changeMobile?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to PUT /account-service/accounts/{id}/password
   */
  changePassword?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/assignment-submission/actions/complete-all
   */
  completeAllAssignmentSubmission?: Maybe<
    Array<Maybe<AssignmentSubmissionDto>>
  >;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/assignment-submission/actions/complete
   */
  completeAssignmentSubmission?: Maybe<AssignmentSubmissionDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/onboarding-checklist/actions/complete-action
   */
  completeOnboardingChecklistAction?: Maybe<OnboardingChecklistDto>;
  /** POST /ai_assignments */
  createAiTest?: Maybe<AiTestCreated>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/assignments
   */
  createAssignment?: Maybe<AssignmentDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/assignment-submissions/{assignmentSubmissionId}/comments
   */
  createAssignmentSubmissionComment?: Maybe<AssignmentSubmissionCommentDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/attendances
   */
  createAttendance?: Maybe<AttendanceDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels
   */
  createChannel?: Maybe<Channel>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels-dto
   */
  createChannelDto?: Maybe<ChannelDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channel-groups
   */
  createChannelGroup?: Maybe<ChannelGroupDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channel-groups-dto
   */
  createChannelGroupDto?: Maybe<ChannelGroupDto>;
  /**
   *
   *
   * Equivalent to POST /account-service/accounts/{id}/child-code
   */
  createChildCode?: Maybe<ChildCodeResponseDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms
   */
  createClassroom?: Maybe<ClassroomDto>;
  /**
   *
   *
   * Equivalent to POST /classtalk-service/meetings
   */
  createClasstalkMeeting?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/posts/{postId}/comments
   */
  createComment?: Maybe<CommentDto>;
  /**
   *
   *
   * Equivalent to POST /insights-service/classrooms/{classroomId}/members/{memberId}/cumulative-record
   */
  createCumulativeRecord?: Maybe<InsightsCumulativeRecordDto>;
  /**
   *
   *
   * Equivalent to POST /media-service/files
   */
  createFile?: Maybe<File>;
  /**
   *
   *
   * Equivalent to POST /insights-service/subscription/free-plan
   */
  createFreePlanSubscription?: Maybe<InsightsOrderDto>;
  /**
   *
   *
   * Equivalent to POST /insights-service/goals
   */
  createGoal?: Maybe<InsightsGoalDto>;
  /**
   *
   *
   * Equivalent to POST /media-service/images
   */
  createImage?: Maybe<Image>;
  /**
   *
   *
   * Equivalent to POST /account-service/accounts/{id}/certificate
   */
  createPersonalCertificate?: Maybe<AccountServiceAccountCertificate>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/posts
   */
  createPost?: Maybe<PostDto>;
  createPublisherSubscription: PublisherSubscriptionDto;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/posts/{postId}/comments/{commentId}/replies
   */
  createReply?: Maybe<ReplyDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/tags
   */
  createTag?: Maybe<TagDto>;
  /**
   *
   *
   * Equivalent to POST /media-service/videos
   */
  createVideo?: Maybe<Video>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/members/{memberId}/actions/deactivate
   */
  deactivateClassroomMember?: Maybe<MemberDto>;
  /**
   *
   *
   * Equivalent to DELETE /account-service/accounts/{id}
   */
  deleteAccount?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}
   */
  deleteAssignment?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/assignment-submissions/{assignmentSubmissionId}/comments/{commentId}
   */
  deleteAssignmentSubmissionComment?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/classrooms/{classroomId}/channel-groups/{channelGroupId}/channels/{channelId}
   */
  deleteChannel?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/classrooms/{classroomId}/channel-groups/{channelGroupId}
   */
  deleteChannelGroup?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/classrooms/{classroomId}
   */
  deleteClassroom?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /classtalk-service/internal-meetings/{meetingId}
   */
  deleteClasstalkMeeting?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/posts/{postId}/comments/{commentId}
   */
  deleteComment?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /insights-service/classrooms/{classroomId}/cumulative-records/{cumulativeRecordId}
   */
  deleteCumulativeRecord?: Maybe<Scalars['InsightsJson']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /media-service/files/{fileId}
   */
  deleteFile?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /media-service/images/{imageId}
   */
  deleteImage?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/classrooms/{classroomId}/posts/{postId}
   */
  deletePost?: Maybe<Scalars['Json']['output']>;
  deletePublisherSubscription?: Maybe<Scalars['Void']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/comments/{commentId}/replies/{replyId}
   */
  deleteReply?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /media-service/videos/{videoId}
   */
  deleteVideo?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/actions/disintegrate-zoom
   */
  disintegrateZoom?: Maybe<Scalars['Json']['output']>;
  /** POST /ai_assignments */
  distributeAiTest?: Maybe<AiTestCreated>;
  /**
   *
   *
   * Equivalent to POST /insights-service/orders
   */
  draftOrder?: Maybe<InsightsOrderDto>;
  /**
   *
   *
   * Equivalent to DELETE /classtalk-service/meetings/{meetingId}
   */
  endClasstalkMeeting?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels/{channelId}/actions/end-meeting
   */
  endMeeting?: Maybe<ChannelDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/excused-attendances
   */
  excuseAttendance?: Maybe<AttendanceDto>;
  /**
   *
   *
   * Equivalent to POST /classtalk-service/recordings/actions/generate-download-url
   */
  generateRecordingDownloadUrl?: Maybe<RecordingDownloadUrlDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/onboarding-checklist/actions/hide
   */
  hideOnboardingChecklist?: Maybe<OnboardingChecklistDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/attendances/initiate-export
   */
  initiateExportAttendances?: Maybe<ExcelExportJobStateDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/actions/integrate-zoom
   */
  integrateZoom?: Maybe<ZoomIntegrationDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/invitations
   */
  inviteMembers?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels/{channelId}/actions/join
   */
  joinChannel?: Maybe<Channel>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels-dto/{channelId}/actions/join
   */
  joinChannelDto?: Maybe<ChannelDto>;
  /** POST /classes/{args.classId}/members/{args.userId} */
  joinLegacyClass?: Maybe<LegacyClassMember>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels/{channelId}/actions/join-meeting
   */
  joinMeeting?: Maybe<MeetingDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels/{channelId}/actions/leave
   */
  leaveChannel?: Maybe<Channel>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels-dto/{channelId}/actions/leave
   */
  leaveChannelDto?: Maybe<ChannelDto>;
  /**
   * 현재 사용자의 엔터프라이즈 나가기
   *
   * Equivalent to DELETE /enterprise-service/enterprises/{enterpriseId}/actions/leave
   */
  leaveEnterprise?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /account-service/guardian-relationships
   */
  linkChild?: Maybe<LinkChildResponseDto>;
  /**
   *
   *
   * Equivalent to POST /account-service/guardian-relationships/link-guardian
   */
  linkGuardian?: Maybe<LinkChildResponseDto>;
  /**
   *
   *
   * Equivalent to POST /notification-service/generators/{generatorType}/{generatorId}/actions/mark-as-read
   */
  markNewsAsRead?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /notification-service/notice-feeds/{noticeFeedId}/actions/mark-as-read
   */
  markNoticeFeedAsRead?: Maybe<NoticeFeedDto>;
  /**
   *
   *
   * Equivalent to POST /notification-service/notifications/{notificationId}/actions/mark-as-read
   */
  markNotificationAsRead?: Maybe<NotificationDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/mark-as-read
   */
  markPostAsRead?: Maybe<Scalars['Json']['output']>;
  /**
   * 클래스 구성원의 역할을 할당
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/classrooms/{classroomId}/members/{memberId}/actions/assign-role
   */
  organizationAssignClassroomMemberRole?: Maybe<OrganizationClassroomMemberDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{organizationId}/members/{memberId}/actions/cancel-deletion
   */
  organizationCancelMemberAccountDeletion?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{organizationId}/member-bulk-update-jobs/{memberBulkUpdateJobId}/actions/cancel-member-bulk-update-job
   */
  organizationCancelMemberBulkUpdateJob?: Maybe<OrganizationMemberBulkUpdateJobDto>;
  /**
   *
   *
   * Equivalent to PUT /organization-service/organizations/{organizationId}/members/{memberId}/actions/change-member-account-email
   */
  organizationChangeMemberAccountEmail?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to PUT /organization-service/organizations/{organizationId}/members/{memberId}/actions/change-member-account-password
   */
  organizationChangeMemberAccountPassword?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to PUT /organization-service/organizations/{organizationId}/members/{memberId}/actions/change-member-account-username
   */
  organizationChangeMemberAccountUsername?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to PUT /organization-service/organizations/{orgId}/members/{memberId}/actions/change-member-org-role
   */
  organizationChangeMemberOrgRole?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{organizationId}/member-bulk-update-jobs/{memberBulkUpdateJobId}/actions/check-member-bulk-update-job
   */
  organizationCheckMemberBulkUpdateJob?: Maybe<OrganizationMemberBulkUpdateJobDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/orders/{orderId}/actions/complete
   */
  organizationCompleteOrder?: Maybe<OrganizationOrderDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{organizationId}/members
   */
  organizationCreateMember?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{organizationId}/member-bulk-update-jobs
   */
  organizationCreateMemberBulkUpdateJobControllerCreateMemberBulkUpdateJob?: Maybe<OrganizationMemberBulkUpdateJobDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/orders
   */
  organizationCreateOrder?: Maybe<OrganizationOrderDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/classrooms
   */
  organizationCreateOrgClassroom?: Maybe<OrganizationClassroomWithAdminDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/org-units
   */
  organizationCreateOrgUnit?: Maybe<OrganizationOrganizationalUnitDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/plans
   */
  organizationCreatePlan?: Maybe<OrganizationPlanDto>;
  /**
   *
   *
   * Equivalent to DELETE /organization-service/organizations/{orgId}/classrooms/{classroomId}
   */
  organizationDeleteOrgClassroom?: Maybe<Scalars['OrganizationJson']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /organization-service/organizations/{orgId}/org-units/{orgUnitId}
   */
  organizationDeleteOrgUnit?: Maybe<Scalars['OrganizationJson']['output']>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/contracts/{contractId}/actions/grant-license
   */
  organizationGrantLicense?: Maybe<OrganizationMemberLicenseDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/invitations
   */
  organizationInviteMembers?: Maybe<Scalars['OrganizationJson']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /organization-service/organizations/{orgId}/actions/leave
   */
  organizationLeaveOrg?: Maybe<Scalars['OrganizationJson']['output']>;
  /**
   *
   *
   * Equivalent to POST /organization-service/admin/organizations/{orgId}/actions/manage
   */
  organizationManageOrg?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to PUT /organization-service/organizations/{orgId}/actions/mark-as-primary
   */
  organizationMarkOrgAsPrimary?: Maybe<OrganizationPrimaryOrgMembershipDto>;
  /**
   *
   *
   * Equivalent to PUT /organization-service/private/organizations/{orgId}/actions/mark-as-primary
   */
  organizationPrivateMarkOrgAsPrimaryControllerMarkOrgAsPrimary?: Maybe<OrganizationPrimaryOrgMembershipDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/org-code
   */
  organizationRecreateOrgCode?: Maybe<OrganizationOrgCodeDto>;
  /**
   * 클래스에 구성원을 등록합니다.
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/classrooms/{classroomId}/members
   */
  organizationRegisterClassroomMember?: Maybe<OrganizationClassroomMemberDto>;
  /**
   * 클래스에 복수의 구성원을 등록합니다.
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/classrooms/{classroomId}/members/batch
   */
  organizationRegisterClassroomMembers?: Maybe<
    Array<Maybe<OrganizationClassroomMemberDto>>
  >;
  /**
   *
   *
   * Equivalent to POST /organization-service/registration
   */
  organizationRegisterForOrg?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to DELETE /organization-service/organizations/{orgId}/members/{memberId}
   */
  organizationRemoveMember?: Maybe<Scalars['OrganizationJson']['output']>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{organizationId}/members/{memberId}/actions/reserve-deletion
   */
  organizationReserveMemberAccountDeletion?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/contracts/{contractId}/actions/revoke-license
   */
  organizationRevokeLicense?: Maybe<OrganizationContractDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{orgId}/messages
   */
  organizationSendMessage?: Maybe<OrganizationMessageDto>;
  /**
   *
   *
   * Equivalent to POST /organization-service/organizations/{organizationId}/members/{memberId}
   */
  organizationUpdateMember?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to PATCH /organization-service/admin/organizations/{orgId}/message-service
   */
  organizationUpdateMessageService?: Maybe<OrganizationMessageServiceDto>;
  /**
   *
   *
   * Equivalent to PATCH /organization-service/organizations/{orgId}/classrooms/{classroomId}
   */
  organizationUpdateOrgClassroom?: Maybe<OrganizationClassroomWithAdminDto>;
  /**
   *
   *
   * Equivalent to PATCH /organization-service/organizations/{orgId}/policy-consent
   */
  organizationUpdateOrgPolicyConsent?: Maybe<OrganizationOrganizationDto>;
  /**
   *
   *
   * Equivalent to PUT /organization-service/organizations/{orgId}/org-units/{orgUnitId}
   */
  organizationUpdateOrgUnit?: Maybe<OrganizationOrganizationalUnitDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/channels/{channelId}/actions/pin-post
   */
  pinPost?: Maybe<ChannelPostPinDto>;
  /**
   *
   *
   * Equivalent to POST /insights-service/activities/{activityId}/praise
   */
  praiseChildActivity?: Maybe<InsightsActivityDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/privates/classrooms/{classroomId}/members/{memberId}/actions/assign-role
   */
  privateAssignMemberRoleControllerAssignMemberRole?: Maybe<MemberDto>;
  /**
   *
   *
   * Equivalent to PUT /account-service/private/accounts/{id}/email
   */
  privateChangeEmailAdminControllerChangeEmail?: Maybe<
    Scalars['Json']['output']
  >;
  /**
   *
   *
   * Equivalent to PUT /account-service/private/accounts/{id}/username
   */
  privateChangeUsernameAdminControllerChangeUsername?: Maybe<
    Scalars['Json']['output']
  >;
  /**
   *
   *
   * Equivalent to POST /classroom-service/privates/classrooms
   */
  privateCreateClassroom?: Maybe<ClassroomDto>;
  /**
   *
   *
   * Equivalent to POST /enterprise-service/privates/enterprises/{enterpriseId}/members
   */
  privateCreateMemberControllerPrivateCreateMember?: Maybe<EnterpriseMemberDto>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/privates/classrooms/{classroomId}
   */
  privateDeleteClassroomControllerPrivateDeleteClassroom?: Maybe<
    Scalars['Json']['output']
  >;
  /**
   *
   *
   * Equivalent to POST /classroom-service/privates/classrooms/{classroomId}/registration
   */
  privateRegisterForClassroom?: Maybe<MemberDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/privates/classrooms/{classroomId}
   */
  privateUpdateClassroom?: Maybe<ClassroomDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/publish
   */
  publishPost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/class-code/actions/recreate
   */
  recreateClassroomClassCode?: Maybe<ClassCodeDto>;
  /**
   * 구성원 가입
   *
   * Equivalent to POST /classroom-service/registration
   */
  registerForClassroom?: Maybe<MemberDto>;
  /** POST /schools */
  registerSchool?: Maybe<SchoolRegistration>;
  /**
   *
   *
   * Equivalent to POST /classtalk-service/register
   */
  registerToClasstalk?: Maybe<ClasstalkUserDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/assignees/{assigneeId}/actions/regrade
   */
  regradeAssignmentSubmission?: Maybe<AssignmentSubmissionDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/remind
   */
  remindPost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to DELETE /notification-service/push-notification/devices/{playerId}
   */
  removeDevice?: Maybe<RemoveDeviceResponseDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/posts/{postId}/comments/{commentId}/actions/unreact
   */
  removeReactionFromComment?: Maybe<CommentDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/unreact
   */
  removeReactionFromPost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/posts/{postId}/comments/{commentId}/replies/{replyId}/actions/unreact
   */
  removeReactionFromReply?: Maybe<ReplyDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/report
   */
  reportPost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to POST /account-service/accounts/{id}/request-email-change
   */
  requestEmailChange?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /account-service/accounts/{id}/request-mobile-change
   */
  requestMobileChange?: Maybe<PinCodeDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/assignees/{assigneeId}/actions/save-points
   */
  saveAssignmentSubmissionPoints?: Maybe<AssignmentSubmissionDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/assignees/{assigneeId}/actions/save-essay-answer-points-to-learning-assignment
   */
  saveEssayAnswerPointsToLearningAssignment?: Maybe<AssignmentSubmissionDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/actions/save-answer-to-learning-assignment
   */
  saveMemberAnswerToLearningAssignment?: Maybe<AssignmentSubmissionDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/save-as-draft
   */
  savePostAsDraft?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/schedule
   */
  schedulePost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to POST /classtalk-service/meetings/actions/start
   */
  startClasstalkMeeting?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels/{channelId}/actions/start-meeting
   */
  startMeeting?: Maybe<MeetingDto>;
  /**
   *
   *
   * Equivalent to POST /account-service/student-registration-codes
   */
  studentRegistrationCodesControllerCreateStudentRegistrationCode?: Maybe<StudentRegistrationCodeDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/submit-learning-assignment
   */
  submitLearningSubmission?: Maybe<AssignmentSubmissionDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/submit
   */
  submitSubmission?: Maybe<AssignmentSubmissionDto>;
  /**
   *
   *
   * Equivalent to POST /insights-service/goals/{goalId}/actions/suspended
   */
  suspendGoal?: Maybe<InsightsGoalDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/translate
   */
  translatePost?: Maybe<TranslatedPostDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels/{channelId}/actions/unarchive
   */
  unarchiveChannel?: Maybe<Channel>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/channels-dto/{channelId}/actions/unarchive
   */
  unarchiveChannelDto?: Maybe<ChannelDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/actions/unarchiveClassroom
   */
  unarchiveClassroom?: Maybe<ClassroomDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/members/{memberId}/actions/unblock
   */
  unblockMember?: Maybe<MemberDto>;
  /**
   * 클래스룸 즐겨찾기 해제
   *
   * Equivalent to DELETE /classroom-service/classrooms/{classroomId}/bookmark
   */
  unbookmarkClassroom?: Maybe<Scalars['Json']['output']>;
  /** DELETE /users/me/favorited_classes/{args.classId} */
  unbookmarkLegacyClass?: Maybe<LegacyBookmarkResult>;
  /**
   *
   *
   * Equivalent to DELETE /classroom-service/legacy-classrooms/{classroomId}/bookmark
   */
  unbookmarkLegacyClassroom?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to DELETE /account-service/guardian-relationships/{id}
   */
  unlinkChild?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/channels/{channelId}/actions/unpin-post
   */
  unpinPost?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/posts/{postId}/actions/unschedule
   */
  unschedulePost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to PATCH /account-service/accounts/{id}
   */
  updateAccount?: Maybe<AccountDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}
   */
  updateAssignedAssignment?: Maybe<AssignmentDto>;
  /**
   *
   *
   * Equivalent to PUT /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}
   */
  updateAssignment?: Maybe<AssignmentDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/assignment-submissions/{assignmentSubmissionId}/comments/{commentId}
   */
  updateAssignmentSubmissionComment?: Maybe<AssignmentSubmissionCommentDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}/channels/{channelId}
   */
  updateChannel?: Maybe<Channel>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}/channels-dto/{channelId}
   */
  updateChannelDto?: Maybe<ChannelDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}/channel-groups/{channelGroupId}
   */
  updateChannelGroup?: Maybe<ChannelGroupDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}/channel-groups-dto/{channelGroupId}
   */
  updateChannelGroupDto?: Maybe<ChannelGroupDto>;
  /**
   *
   *
   * Equivalent to PUT /account-service/accounts/{id}/child-school-info
   */
  updateChildSchoolInfo?: Maybe<AccountDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}
   */
  updateClassroom?: Maybe<ClassroomDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}/members/{memberId}
   */
  updateClassroomMember?: Maybe<MemberDto>;
  /**
   *
   *
   * Equivalent to PATCH /classtalk-service/classtalk-users/{userId}
   */
  updateClasstalkUser?: Maybe<ClasstalkUserDto>;
  /**
   *
   *
   * Equivalent to PATCH /classtalk-service/classtalk-users/settings/auto-recording
   */
  updateClasstalkUserAutoRecordingSetting?: Maybe<ClasstalkUserDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/posts/{postId}/comments/{commentId}
   */
  updateComment?: Maybe<CommentDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}/settings/push-notifications
   */
  updateMemberPushNotificationSettings?: Maybe<MemberPushNotificationSettingsDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}/posts/{postId}
   */
  updatePost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/posts/{postId}/action/update-admin-exclusive-by-admin
   */
  updatePostAdminExclusiveByAdmin?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to POST /classroom-service/classrooms/{classroomId}/posts/{postId}/action/update-channel-by-admin
   */
  updatePostChannelAdmin?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/comments/{commentId}/replies/{replyId}
   */
  updateReply?: Maybe<ReplyDto>;
  /**
   *
   *
   * Equivalent to PATCH /classroom-service/classrooms/{classroomId}/tags/{tag}
   */
  updateTag?: Maybe<TagDto>;
  /**
   *
   *
   * Equivalent to POST /account-service/accounts/{id}/child-code/{code}/verify
   */
  verifyChildCode?: Maybe<ChildCodeResponseDto>;
  /**
   *
   *
   * Equivalent to POST /insights-service/orders/{orderId}/verify
   */
  verifyOrderControllerVerifyOrder?: Maybe<Scalars['InsightsJson']['output']>;
};

export type MutationAccountPrivateControllerDeleteAccountArgs = {
  id: Scalars['String']['input'];
};

export type MutationAddAttendeeToClasstalkMeetingArgs = {
  addAttendeeToMeetingDtoInput: AddAttendeeToMeetingDtoInput;
  meetingId: Scalars['String']['input'];
};

export type MutationAddDeviceArgs = {
  addDeviceRequestDtoInput?: InputMaybe<AddDeviceRequestDtoInput>;
};

export type MutationAddReactionToCommentArgs = {
  addReactionToCommentDtoInput: AddReactionToCommentDtoInput;
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type MutationAddReactionToPostArgs = {
  addReactionToPostDtoInput: AddReactionToPostDtoInput;
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type MutationAddReactionToReplyArgs = {
  addReactionToReplyDtoInput: AddReactionToReplyDtoInput;
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
};

export type MutationAdminApiCreateImageArgs = {
  createImageDtoInput: CreateImageDtoInput;
};

export type MutationArchiveChannelArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationArchiveChannelDtoArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationArchiveClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationAssignAssignmentArgs = {
  assignAssignmentDtoInput: AssignAssignmentDtoInput;
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationAssignMemberRoleArgs = {
  assignMemberRoleDtoInput: AssignMemberRoleDtoInput;
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export type MutationBlockMemberArgs = {
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export type MutationBookmarkClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationBookmarkLegacyClassArgs = {
  classId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationBookmarkLegacyClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationChangeEmailArgs = {
  changeEmailDtoInput: ChangeEmailDtoInput;
  id: Scalars['String']['input'];
};

export type MutationChangeMobileArgs = {
  changeMobileDtoInput: ChangeMobileDtoInput;
  id: Scalars['String']['input'];
};

export type MutationChangePasswordArgs = {
  changePasswordDtoInput: ChangePasswordDtoInput;
  id: Scalars['String']['input'];
};

export type MutationCompleteAllAssignmentSubmissionArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCompleteAssignmentSubmissionArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  completeAssignmentSubmissionDtoInput: CompleteAssignmentSubmissionDtoInput;
};

export type MutationCompleteOnboardingChecklistActionArgs = {
  classroomId: Scalars['String']['input'];
  completeOnboardingChecklistActionDtoInput: CompleteOnboardingChecklistActionDtoInput;
};

export type MutationCreateAiTestArgs = {
  input?: InputMaybe<CreateAiTestDtoInput>;
};

export type MutationCreateAssignmentArgs = {
  classroomId: Scalars['String']['input'];
  createAssignmentDtoInput: CreateAssignmentDtoInput;
};

export type MutationCreateAssignmentSubmissionCommentArgs = {
  assignmentSubmissionId: Scalars['String']['input'];
  createAssignmentSubmissionCommentDtoInput: CreateAssignmentSubmissionCommentDtoInput;
};

export type MutationCreateAttendanceArgs = {
  classroomId: Scalars['String']['input'];
  createAttendanceDtoInput?: InputMaybe<CreateAttendanceDtoInput>;
};

export type MutationCreateChannelArgs = {
  classroomId: Scalars['String']['input'];
  createChannelDtoInput: CreateChannelDtoInput;
};

export type MutationCreateChannelDtoArgs = {
  classroomId: Scalars['String']['input'];
  createChannelDtoInput: CreateChannelDtoInput;
};

export type MutationCreateChannelGroupArgs = {
  classroomId: Scalars['String']['input'];
  createChannelGroupDtoInput: CreateChannelGroupDtoInput;
};

export type MutationCreateChannelGroupDtoArgs = {
  classroomId: Scalars['String']['input'];
  createChannelGroupDtoInput: CreateChannelGroupDtoInput;
};

export type MutationCreateChildCodeArgs = {
  id: Scalars['String']['input'];
};

export type MutationCreateClassroomArgs = {
  createClassroomDtoInput: CreateClassroomDtoInput;
};

export type MutationCreateClasstalkMeetingArgs = {
  createMeetingDtoInput?: InputMaybe<CreateMeetingDtoInput>;
};

export type MutationCreateCommentArgs = {
  classroomId: Scalars['String']['input'];
  createCommentDtoInput: CreateCommentDtoInput;
  postId: Scalars['String']['input'];
};

export type MutationCreateCumulativeRecordArgs = {
  classroomId: Scalars['String']['input'];
  createCumulativeRecordDtoInput: InsightsCreateCumulativeRecordDtoInput;
  memberId: Scalars['String']['input'];
};

export type MutationCreateFileArgs = {
  createFileDtoInput: CreateFileDtoInput;
};

export type MutationCreateFreePlanSubscriptionArgs = {
  createFreePlanSubscriptionDtoInput: InsightsCreateFreePlanSubscriptionDtoInput;
};

export type MutationCreateGoalArgs = {
  childId: Scalars['String']['input'];
  createGoalDtoInput: InsightsCreateGoalDtoInput;
};

export type MutationCreateImageArgs = {
  createImageDtoInput: CreateImageDtoInput;
};

export type MutationCreatePersonalCertificateArgs = {
  createPersonalCertificateDtoInput: Scalars['Json']['input'];
  id: Scalars['String']['input'];
};

export type MutationCreatePostArgs = {
  classroomId: Scalars['String']['input'];
  createPostDtoInput?: InputMaybe<CreatePostDtoInput>;
};

export type MutationCreatePublisherSubscriptionArgs = {
  locale: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
};

export type MutationCreateReplyArgs = {
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  createReplyDtoInput: CreateReplyDtoInput;
  postId: Scalars['String']['input'];
};

export type MutationCreateTagArgs = {
  classroomId: Scalars['String']['input'];
  createTagDtoInput: CreateTagDtoInput;
};

export type MutationCreateVideoArgs = {
  createVideoDtoInput: CreateVideoDtoInput;
};

export type MutationDeactivateClassroomMemberArgs = {
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export type MutationDeleteAccountArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationDeleteAssignmentSubmissionCommentArgs = {
  assignmentSubmissionId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
};

export type MutationDeleteChannelArgs = {
  channelGroupId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationDeleteChannelGroupArgs = {
  channelGroupId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationDeleteClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationDeleteClasstalkMeetingArgs = {
  meetingId: Scalars['String']['input'];
};

export type MutationDeleteCommentArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type MutationDeleteCumulativeRecordArgs = {
  classroomId: Scalars['String']['input'];
  cumulativeRecordId: Scalars['String']['input'];
};

export type MutationDeleteFileArgs = {
  fileId: Scalars['String']['input'];
};

export type MutationDeleteImageArgs = {
  imageId: Scalars['String']['input'];
};

export type MutationDeletePostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type MutationDeletePublisherSubscriptionArgs = {
  locale: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
};

export type MutationDeleteReplyArgs = {
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
};

export type MutationDeleteVideoArgs = {
  videoId: Scalars['String']['input'];
};

export type MutationDisintegrateZoomArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationDistributeAiTestArgs = {
  input?: InputMaybe<DistributeAiTestDtoInput>;
};

export type MutationDraftOrderArgs = {
  childIds: Array<InputMaybe<Scalars['String']['input']>>;
  paymentMethod: InsightsPaymentMethod;
};

export type MutationEndClasstalkMeetingArgs = {
  meetingId: Scalars['String']['input'];
};

export type MutationEndMeetingArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationExcuseAttendanceArgs = {
  classroomId: Scalars['String']['input'];
  excuseAttendanceDtoInput: ExcuseAttendanceDtoInput;
};

export type MutationGenerateRecordingDownloadUrlArgs = {
  generateRecordingDownloadUrlDtoInput: GenerateRecordingDownloadUrlDtoInput;
};

export type MutationHideOnboardingChecklistArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationInitiateExportAttendancesArgs = {
  classroomId: Scalars['String']['input'];
  initiateExportAttendancesDtoInput: InitiateExportAttendancesDtoInput;
};

export type MutationIntegrateZoomArgs = {
  classroomId: Scalars['String']['input'];
  integrateZoomDtoInput: IntegrateZoomDtoInput;
};

export type MutationInviteMembersArgs = {
  classroomId: Scalars['String']['input'];
  inviteMembersDtoInput: InviteMembersDtoInput;
};

export type MutationJoinChannelArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationJoinChannelDtoArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationJoinLegacyClassArgs = {
  classId?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<JoinLegacyClassDtoInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationJoinMeetingArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationLeaveChannelArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationLeaveChannelDtoArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationLeaveEnterpriseArgs = {
  enterpriseId: Scalars['String']['input'];
};

export type MutationLinkChildArgs = {
  linkChildRequestDtoInput: LinkChildRequestDtoInput;
};

export type MutationLinkGuardianArgs = {
  linkGuardianRequestDtoInput: LinkGuardianRequestDtoInput;
};

export type MutationMarkNewsAsReadArgs = {
  generatorId: Scalars['String']['input'];
  generatorType: Scalars['String']['input'];
};

export type MutationMarkNoticeFeedAsReadArgs = {
  noticeFeedId: Scalars['String']['input'];
};

export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['String']['input'];
};

export type MutationMarkPostAsReadArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type MutationOrganizationAssignClassroomMemberRoleArgs = {
  assignClassroomMemberRoleDtoInput: OrganizationAssignClassroomMemberRoleDtoInput;
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationCancelMemberAccountDeletionArgs = {
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type MutationOrganizationCancelMemberBulkUpdateJobArgs = {
  memberBulkUpdateJobId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type MutationOrganizationChangeMemberAccountEmailArgs = {
  changeMemberAccountEmailDtoInput: OrganizationChangeMemberAccountEmailDtoInput;
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type MutationOrganizationChangeMemberAccountPasswordArgs = {
  changeMemberAccountPasswordDtoInput: OrganizationChangeMemberAccountPasswordDtoInput;
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type MutationOrganizationChangeMemberAccountUsernameArgs = {
  changeMemberAccountUsernameDtoInput: OrganizationChangeMemberAccountUsernameDtoInput;
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type MutationOrganizationChangeMemberOrgRoleArgs = {
  changeMemberOrgRoleDtoInput: OrganizationChangeMemberOrgRoleDtoInput;
  memberId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationCheckMemberBulkUpdateJobArgs = {
  memberBulkUpdateJobId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type MutationOrganizationCompleteOrderArgs = {
  completeOrderDtoInput: OrganizationCompleteOrderDtoInput;
  orderId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationCreateMemberArgs = {
  createMemberDtoInput: OrganizationCreateMemberDtoInput;
  organizationId: Scalars['String']['input'];
};

export type MutationOrganizationCreateMemberBulkUpdateJobControllerCreateMemberBulkUpdateJobArgs =
  {
    multipartFormDataInput: Scalars['String']['input'];
    organizationId: Scalars['String']['input'];
  };

export type MutationOrganizationCreateOrderArgs = {
  createOrderDtoInput: OrganizationCreateOrderDtoInput;
};

export type MutationOrganizationCreateOrgClassroomArgs = {
  createOrgClassroomDtoInput: OrganizationCreateOrgClassroomDtoInput;
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationCreateOrgUnitArgs = {
  createOrgUnitDtoInput: OrganizationCreateOrgUnitDtoInput;
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationCreatePlanArgs = {
  createPlanDtoInput: OrganizationCreatePlanDtoInput;
};

export type MutationOrganizationDeleteOrgClassroomArgs = {
  classroomId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationDeleteOrgUnitArgs = {
  orgId: Scalars['String']['input'];
  orgUnitId: Scalars['String']['input'];
};

export type MutationOrganizationGrantLicenseArgs = {
  contractId: Scalars['String']['input'];
  grantLicenseDtoInput: OrganizationGrantLicenseDtoInput;
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationInviteMembersArgs = {
  inviteMembersDtoInput: OrganizationInviteMembersDtoInput;
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationLeaveOrgArgs = {
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationManageOrgArgs = {
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationMarkOrgAsPrimaryArgs = {
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationPrivateMarkOrgAsPrimaryControllerMarkOrgAsPrimaryArgs =
  {
    orgId: Scalars['String']['input'];
    privateMarkOrgAsPrimaryDtoInput: OrganizationPrivateMarkOrgAsPrimaryDtoInput;
  };

export type MutationOrganizationRecreateOrgCodeArgs = {
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationRegisterClassroomMemberArgs = {
  classroomId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
  registerClassroomMemberDtoInput: OrganizationRegisterClassroomMemberDtoInput;
};

export type MutationOrganizationRegisterClassroomMembersArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['String']['input'];
  registerClassroomMembersDtoInput: OrganizationRegisterClassroomMembersDtoInput;
};

export type MutationOrganizationRegisterForOrgArgs = {
  registerForOrgDtoInput: OrganizationRegisterForOrgDtoInput;
};

export type MutationOrganizationRemoveMemberArgs = {
  memberId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type MutationOrganizationReserveMemberAccountDeletionArgs = {
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type MutationOrganizationRevokeLicenseArgs = {
  contractId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
  revokeLicenseDtoInput: OrganizationRevokeLicenseDtoInput;
};

export type MutationOrganizationSendMessageArgs = {
  orgId: Scalars['String']['input'];
  sendMessageDtoInput: OrganizationSendMessageDtoInput;
};

export type MutationOrganizationUpdateMemberArgs = {
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  updateMemberDtoInput: OrganizationUpdateMemberDtoInput;
};

export type MutationOrganizationUpdateMessageServiceArgs = {
  orgId: Scalars['String']['input'];
  updateMessageServiceDtoInput: OrganizationUpdateMessageServiceDtoInput;
};

export type MutationOrganizationUpdateOrgClassroomArgs = {
  classroomId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
  updateOrgClassroomDtoInput: OrganizationUpdateOrgClassroomDtoInput;
};

export type MutationOrganizationUpdateOrgPolicyConsentArgs = {
  orgId: Scalars['String']['input'];
  updateOrgPolicyConsentDtoInput: OrganizationUpdateOrgPolicyConsentDtoInput;
};

export type MutationOrganizationUpdateOrgUnitArgs = {
  orgId: Scalars['String']['input'];
  orgUnitId: Scalars['String']['input'];
  updateOrgUnitDtoInput: OrganizationUpdateOrgUnitDtoInput;
};

export type MutationPinPostArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  pinPostDtoInput: PinPostDtoInput;
};

export type MutationPraiseChildActivityArgs = {
  activityId: Scalars['String']['input'];
  childId: Scalars['String']['input'];
  praiseChildActivityDtoInput: InsightsPraiseChildActivityDtoInput;
};

export type MutationPrivateAssignMemberRoleControllerAssignMemberRoleArgs = {
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  privateAssignMemberRoleDtoInput: PrivateAssignMemberRoleDtoInput;
};

export type MutationPrivateChangeEmailAdminControllerChangeEmailArgs = {
  changeEmailAdminDtoInput: ChangeEmailAdminDtoInput;
  id: Scalars['String']['input'];
};

export type MutationPrivateChangeUsernameAdminControllerChangeUsernameArgs = {
  changeUsernameAdminDtoInput: ChangeUsernameAdminDtoInput;
  id: Scalars['String']['input'];
};

export type MutationPrivateCreateClassroomArgs = {
  privateCreateClassroomDtoInput: PrivateCreateClassroomDtoInput;
};

export type MutationPrivateCreateMemberControllerPrivateCreateMemberArgs = {
  enterpriseId: Scalars['String']['input'];
  privateCreateEnterpriseMemberDtoInput: PrivateCreateEnterpriseMemberDtoInput;
};

export type MutationPrivateDeleteClassroomControllerPrivateDeleteClassroomArgs =
  {
    classroomId: Scalars['String']['input'];
  };

export type MutationPrivateRegisterForClassroomArgs = {
  classroomId: Scalars['String']['input'];
  privateRegisterDtoInput: PrivateRegisterDtoInput;
};

export type MutationPrivateUpdateClassroomArgs = {
  classroomId: Scalars['String']['input'];
  updateClassroomDtoInput: UpdateClassroomDtoInput;
};

export type MutationPublishPostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type MutationRecreateClassroomClassCodeArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationRegisterForClassroomArgs = {
  registerDtoInput: RegisterDtoInput;
};

export type MutationRegisterSchoolArgs = {
  input?: InputMaybe<RegisterSchoolDtoInput>;
};

export type MutationRegisterToClasstalkArgs = {
  registerToClasstalkDtoInput: RegisterToClasstalkDtoInput;
};

export type MutationRegradeAssignmentSubmissionArgs = {
  assigneeId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  regradeAssignmentSubmissionDtoInput: RegradeAssignmentSubmissionDtoInput;
};

export type MutationRemindPostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type MutationRemoveDeviceArgs = {
  playerId: Scalars['String']['input'];
};

export type MutationRemoveReactionFromCommentArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  removeReactionFromCommentDtoInput: RemoveReactionFromCommentDtoInput;
};

export type MutationRemoveReactionFromPostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  removeReactionFromPostDtoInput: RemoveReactionFromPostDtoInput;
};

export type MutationRemoveReactionFromReplyArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  removeReactionFromReplyDtoInput: RemoveReactionFromReplyDtoInput;
  replyId: Scalars['String']['input'];
};

export type MutationReportPostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  reportPostDtoInput: ReportPostDtoInput;
};

export type MutationRequestEmailChangeArgs = {
  id: Scalars['String']['input'];
  requestEmailChangeDtoInput: RequestEmailChangeDtoInput;
};

export type MutationRequestMobileChangeArgs = {
  id: Scalars['String']['input'];
  requestMobileChangeDtoInput: RequestMobileChangeDtoInput;
};

export type MutationSaveAssignmentSubmissionPointsArgs = {
  assigneeId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  saveAssignmentSubmissionPointsDtoInput: SaveAssignmentSubmissionPointsDtoInput;
};

export type MutationSaveEssayAnswerPointsToLearningAssignmentArgs = {
  assigneeId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  saveEssayAnswerPointsToLearningAssignmentDtoInput: SaveEssayAnswerPointsToLearningAssignmentDtoInput;
};

export type MutationSaveMemberAnswerToLearningAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  saveMemberAnswerToLearningAssignmentDtoInput: SaveMemberAnswerToLearningAssignmentDtoInput;
};

export type MutationSavePostAsDraftArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  savePostAsDraftDtoInput: SavePostAsDraftDtoInput;
};

export type MutationSchedulePostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type MutationStartClasstalkMeetingArgs = {
  startMeetingDtoInput: StartMeetingDtoInput;
};

export type MutationStartMeetingArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationSubmitLearningSubmissionArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationSubmitSubmissionArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  submitSubmissionDtoInput: SubmitSubmissionDtoInput;
};

export type MutationSuspendGoalArgs = {
  childId: Scalars['String']['input'];
  goalId: Scalars['String']['input'];
};

export type MutationTranslatePostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  translatePostDtoInput: TranslatePostDtoInput;
};

export type MutationUnarchiveChannelArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationUnarchiveChannelDtoArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type MutationUnarchiveClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationUnblockMemberArgs = {
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export type MutationUnbookmarkClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationUnbookmarkLegacyClassArgs = {
  classId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUnbookmarkLegacyClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type MutationUnlinkChildArgs = {
  id: Scalars['String']['input'];
};

export type MutationUnpinPostArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  unpinPostDtoInput: UnpinPostDtoInput;
};

export type MutationUnschedulePostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type MutationUpdateAccountArgs = {
  id: Scalars['String']['input'];
  updateAccountDtoInput: UpdateAccountDtoInput;
};

export type MutationUpdateAssignedAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  updateAssignedAssignmentDtoInput: UpdateAssignedAssignmentDtoInput;
};

export type MutationUpdateAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  updateAssignmentDtoInput: UpdateAssignmentDtoInput;
};

export type MutationUpdateAssignmentSubmissionCommentArgs = {
  assignmentSubmissionId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  updateAssignmentSubmissionCommentDtoInput: UpdateAssignmentSubmissionCommentDtoInput;
};

export type MutationUpdateChannelArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  updateChannelDtoInput: UpdateChannelDtoInput;
};

export type MutationUpdateChannelDtoArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  updateChannelDtoInput: UpdateChannelDtoInput;
};

export type MutationUpdateChannelGroupArgs = {
  channelGroupId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  updateChannelGroupDtoInput: UpdateChannelGroupDtoInput;
};

export type MutationUpdateChannelGroupDtoArgs = {
  channelGroupId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  updateChannelGroupDtoInput: UpdateChannelGroupDtoInput;
};

export type MutationUpdateChildSchoolInfoArgs = {
  id: Scalars['String']['input'];
  updateChildSchoolInfoDtoInput: UpdateChildSchoolInfoDtoInput;
};

export type MutationUpdateClassroomArgs = {
  classroomId: Scalars['String']['input'];
  updateClassroomDtoInput: UpdateClassroomDtoInput;
};

export type MutationUpdateClassroomMemberArgs = {
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  updateMemberDtoInput: UpdateMemberDtoInput;
};

export type MutationUpdateClasstalkUserArgs = {
  updateClasstalkUserDtoInput: UpdateClasstalkUserDtoInput;
  userId: Scalars['String']['input'];
};

export type MutationUpdateClasstalkUserAutoRecordingSettingArgs = {
  updateAutoRecordingSettingDtoInput: UpdateAutoRecordingSettingDtoInput;
};

export type MutationUpdateCommentArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updateCommentDtoInput: UpdateCommentDtoInput;
};

export type MutationUpdateMemberPushNotificationSettingsArgs = {
  classroomId: Scalars['String']['input'];
  updateMemberPushNotificationSettingsDtoInput: UpdateMemberPushNotificationSettingsDtoInput;
};

export type MutationUpdatePostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updatePostDtoInput: UpdatePostDtoInput;
};

export type MutationUpdatePostAdminExclusiveByAdminArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updatePostAdminExclusiveByAdminDtoInput: UpdatePostAdminExclusiveByAdminDtoInput;
};

export type MutationUpdatePostChannelAdminArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updatePostChannelAdminDtoInput: UpdatePostChannelAdminDtoInput;
};

export type MutationUpdateReplyArgs = {
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
  updateReplyDtoInput: UpdateReplyDtoInput;
};

export type MutationUpdateTagArgs = {
  classroomId: Scalars['String']['input'];
  tag: Scalars['String']['input'];
  updateTagDtoInput: UpdateTagDtoInput;
};

export type MutationVerifyChildCodeArgs = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type MutationVerifyOrderControllerVerifyOrderArgs = {
  orderId: Scalars['String']['input'];
  verifyOrderDtoInput: InsightsVerifyOrderDtoInput;
};

export type MyClassroomsCollectionDto = {
  __typename?: 'MyClassroomsCollectionDto';
  classrooms: Array<Maybe<ClassroomDto>>;
};

export type NewsletterSubscriberDto = {
  __typename?: 'NewsletterSubscriberDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NoticeFeedDto = {
  __typename?: 'NoticeFeedDto';
  /** 활동을 수행하는 주체나 참여자 */
  actor: Scalars['Json']['output'];
  /** 활동 정보 */
  content?: Maybe<Scalars['String']['output']>;
  /** 활동을 발행한 주체 */
  generator?: Maybe<Scalars['Json']['output']>;
  /** 고유 아이디 */
  id: Scalars['String']['output'];
  /** 활동을 담는 객체 */
  object?: Maybe<Scalars['Json']['output']>;
  /** 공지 발생일 */
  publishedAt: Scalars['String']['output'];
  /** 공지 읽음 여부 */
  read: Scalars['Boolean']['output'];
  /** 수신자 아이디 */
  recipientId: Scalars['String']['output'];
  /** 활동 요약 정보 */
  summary?: Maybe<Scalars['String']['output']>;
  /** 활동의 대상 ex) John added a movie to his wishlist에서 target은 John wishlist */
  target: Scalars['Json']['output'];
  /** 활동 타입 */
  type: Scalars['String']['output'];
};

export type NoticeFeedsCollectionDto = {
  __typename?: 'NoticeFeedsCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  noticeFeeds: Array<Maybe<NoticeFeedDto>>;
};

export type NotificationDto = {
  __typename?: 'NotificationDto';
  /** 활동을 수행하는 주체나 참여자 */
  actor: Scalars['Json']['output'];
  /** 활동 정보 */
  content?: Maybe<Scalars['String']['output']>;
  /** 활동을 발행한 주체 */
  generator?: Maybe<Scalars['Json']['output']>;
  /** 고유 아이디 */
  id: Scalars['String']['output'];
  /** 활동을 담는 객체 */
  object?: Maybe<Scalars['Json']['output']>;
  /** 알림 발생일 */
  publishedAt: Scalars['String']['output'];
  /** 알림 읽음 여부 */
  read: Scalars['Boolean']['output'];
  /** 수신자 아이디 */
  recipientId: Scalars['String']['output'];
  /** 활동 요약 정보 */
  summary?: Maybe<Scalars['String']['output']>;
  /** 활동의 대상 ex) John added a movie to his wishlist에서 target은 John wishlist */
  target: Scalars['Json']['output'];
  /** 활동 타입 */
  type: Scalars['String']['output'];
};

export type NotificationLastSeen = {
  __typename?: 'NotificationLastSeen';
  timestamp: Scalars['String']['output'];
};

export type NotificationsCollectionDto = {
  __typename?: 'NotificationsCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  notifications: Array<Maybe<NotificationDto>>;
};

export enum OAuthProvider {
  Apple = 'APPLE',
  AuthBridge = 'AUTH_BRIDGE',
  Azure = 'AZURE',
  Google = 'GOOGLE',
  Kakao = 'KAKAO',
  Naver = 'NAVER',
  Saml = 'SAML',
  Whalespace = 'WHALESPACE',
}

export type OnboardingChecklistDto = {
  __typename?: 'OnboardingChecklistDto';
  /**
   *
   *     해당 클래스룸에서 보여질 수 있는 순서가 정의된 스탭들,
   *     허용되는 값들:
   *       | 'invite-member'
   *       | 'publish-post'
   *       | 'distribute-ai-test'
   *       | 'visit-product-tour-page'
   *
   */
  availableActions: Array<Maybe<Scalars['String']['output']>>;
  classroomId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** 체크리스트를 노출할지 여부 */
  isActive: Scalars['Boolean']['output'];
  /** 체크리스트의 모든 스텝이 완료되었는지 여부 */
  isComplete: Scalars['Boolean']['output'];
  /**
   *
   *       각 체크리스트 액션의 완료 여부 상태를 저장하고 있는 map
   *       availableActions에 포함된 값들을 키로 사용함
   *
   */
  progress: Scalars['Json']['output'];
};

export enum OrganizationAccountRole {
  Parent = 'PARENT',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export type OrganizationAssignClassroomMemberRoleDtoInput = {
  role: OrganizationClassroomMemberRole;
};

export type OrganizationChangeMemberAccountEmailDtoInput = {
  email: Scalars['String']['input'];
};

export type OrganizationChangeMemberAccountPasswordDtoInput = {
  changePasswordAtNextSignIn?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
};

export type OrganizationChangeMemberAccountUsernameDtoInput = {
  username: Scalars['String']['input'];
};

export type OrganizationChangeMemberOrgRoleDtoInput = {
  orgRole?: InputMaybe<OrganizationOrganizationMemberRole>;
};

export enum OrganizationClassroomGrade {
  Adult = 'ADULT',
  Eighth = 'EIGHTH',
  Eleventh = 'ELEVENTH',
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  HigherEducation = 'HIGHER_EDUCATION',
  Kindergarten = 'KINDERGARTEN',
  Ninth = 'NINTH',
  None = 'NONE',
  PreKindergarten = 'PRE_KINDERGARTEN',
  Second = 'SECOND',
  Seventh = 'SEVENTH',
  Sixth = 'SIXTH',
  Tenth = 'TENTH',
  Third = 'THIRD',
  Twelfth = 'TWELFTH',
}

export type OrganizationClassroomMemberDto = {
  __typename?: 'OrganizationClassroomMemberDto';
  classroomId: Scalars['String']['output'];
  group?: Maybe<OrganizationClassroomMemberGroup>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: OrganizationClassroomMemberRole;
};

export enum OrganizationClassroomMemberGroup {
  Guardian = 'GUARDIAN',
  Parent = 'PARENT',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export enum OrganizationClassroomMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
}

export type OrganizationClassroomMembersCollectionDto = {
  __typename?: 'OrganizationClassroomMembersCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  members: Array<Maybe<OrganizationClassroomMemberDto>>;
};

export enum OrganizationClassroomOrderField {
  Name = 'NAME',
}

export type OrganizationClassroomWithAdminDto = {
  __typename?: 'OrganizationClassroomWithAdminDto';
  about?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  grade: OrganizationClassroomGrade;
  id: Scalars['String']['output'];
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  membersCount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  orgId?: Maybe<Scalars['String']['output']>;
  profileImageUrl: Scalars['String']['output'];
  schoolYear?: Maybe<Scalars['Float']['output']>;
  studentsCount: Scalars['Float']['output'];
};

export type OrganizationClassroomsWithAdminCollectionDto = {
  __typename?: 'OrganizationClassroomsWithAdminCollectionDto';
  classrooms: Array<Maybe<OrganizationClassroomWithAdminDto>>;
  page?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationCompleteOrderDtoInput = {
  paymentId: Scalars['String']['input'];
};

export enum OrganizationContractCustomType {
  None = 'NONE',
  Pen = 'PEN',
  '2024Ice' = '_2024_ICE',
  '2024Jbe' = '_2024_JBE',
  '2024Pen' = '_2024_PEN',
  '2025Ice' = '_2025_ICE',
  '2025Jbe' = '_2025_JBE',
}

export type OrganizationContractDto = {
  __typename?: 'OrganizationContractDto';
  createdAt: Scalars['String']['output'];
  customType: OrganizationContractCustomType;
  /** 이용권 종료일시 */
  endsAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  licenseName: Scalars['String']['output'];
  licenses: Array<Maybe<OrganizationLicenseDto>>;
  orgId: Scalars['String']['output'];
  /** 이용권 이용 가능 개월 수 */
  periodInMonth: Scalars['Int']['output'];
  /** 구매한 학생 이용권 총 수량 */
  quantity: Scalars['Int']['output'];
  /** 이용권 시작일시 */
  startsAt: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  variantCode: OrganizationVariantCode;
  variants: Array<Maybe<OrganizationContractVariantDto>>;
};

export enum OrganizationContractStatus {
  Active = 'ACTIVE',
}

export type OrganizationContractVariantDto = {
  __typename?: 'OrganizationContractVariantDto';
  serviceType?: Maybe<OrganizationServiceType>;
  variantCode: OrganizationVariantCode;
  /** 구체적인 이용권 제한의 조건. IP 주소 또는 과목명 또는 문항 수 */
  variantOption?: Maybe<Scalars['String']['output']>;
};

export type OrganizationContractsCollectionDto = {
  __typename?: 'OrganizationContractsCollectionDto';
  contracts: Array<Maybe<OrganizationContractDto>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export type OrganizationCreateMemberDtoInput = {
  accountRole: OrganizationMemberAccountRole;
  /** 다음 로그인 시 비밀번호 변경 필요 여부 */
  changePasswordAtNextSignIn?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<OrganizationMemberGrade>;
  /** 학번, 사번 등 구성원을 기관에서 식별하는 번호 또는 문자열 */
  identityNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orgUnitPath: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateOrderDtoInput = {
  orgId: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type OrganizationCreateOrgClassroomDtoInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  adminId: Scalars['String']['input'];
  grade: OrganizationClassroomGrade;
  name: Scalars['String']['input'];
  schoolYear: Scalars['Float']['input'];
};

export type OrganizationCreateOrgUnitDtoInput = {
  name: Scalars['String']['input'];
  parentOrgUnitPath: Scalars['String']['input'];
};

export type OrganizationCreatePlanDtoInput = {
  annualBillingPrice: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  featureId: Scalars['String']['input'];
  monthlyBillingPrice: Scalars['Float']['input'];
  name: Scalars['String']['input'];
};

export enum OrganizationGrade {
  Adult = 'ADULT',
  Eighth = 'EIGHTH',
  Eleventh = 'ELEVENTH',
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  HigherEducation = 'HIGHER_EDUCATION',
  Kindergarten = 'KINDERGARTEN',
  Ninth = 'NINTH',
  None = 'NONE',
  PreKindergarten = 'PRE_KINDERGARTEN',
  Second = 'SECOND',
  Seventh = 'SEVENTH',
  Sixth = 'SIXTH',
  Tenth = 'TENTH',
  Third = 'THIRD',
  Twelfth = 'TWELFTH',
}

export type OrganizationGrantLicenseDtoInput = {
  accountId: Scalars['String']['input'];
  licenseId: Scalars['String']['input'];
};

export type OrganizationInviteMembersDtoInput = {
  phoneNumbers: Array<InputMaybe<Scalars['String']['input']>>;
};

export enum OrganizationLicenseCode {
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export type OrganizationLicenseDto = {
  __typename?: 'OrganizationLicenseDto';
  code: OrganizationLicenseCode;
  createdAt: Scalars['String']['output'];
  endsAt: Scalars['String']['output'];
  /** 구성원에게 할당된 수량 */
  grantedCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startsAt: Scalars['String']['output'];
  /** 각 이용권의 구매 수량 */
  totalCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  /** 구체적인 이용권 제한의 조건 */
  variantOption?: Maybe<Scalars['String']['output']>;
};

export enum OrganizationMemberAccountRole {
  Parent = 'PARENT',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
}

export type OrganizationMemberBulkUpdateJobDto = {
  __typename?: 'OrganizationMemberBulkUpdateJobDto';
  createdAt: Scalars['String']['output'];
  /** 업데이트에 실패한 구성원 업데이트 개수 */
  failCount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  /** 일괄 업데이트에 포함된 구성원 업데이트 개수 */
  jobCount: Scalars['Float']['output'];
  memberBulkUpdateJobStatus: OrganizationMemberBulkUpdateJobStatus;
  /** 일괄 업데이트를 생성한 구성원의 식별자 */
  requestorId: Scalars['String']['output'];
  /** 업데이트에 성공한 구성원 업데이트 개수 */
  successCount: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum OrganizationMemberBulkUpdateJobStatus {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  Processing = 'PROCESSING',
  RequestCancel = 'REQUEST_CANCEL',
}

export type OrganizationMemberDto = {
  __typename?: 'OrganizationMemberDto';
  accountId: Scalars['String']['output'];
  accountRole: OrganizationMemberAccountRole;
  avatarImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** 구성원 계정 삭제 예정 일시 */
  deletionScheduledAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<OrganizationMemberGrade>;
  id: Scalars['String']['output'];
  identityNumber?: Maybe<Scalars['String']['output']>;
  lastAccessAt?: Maybe<Scalars['String']['output']>;
  lastActivatedAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orgUnitPath?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  organizationRole: OrganizationOrganizationMemberRole;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  status: OrganizationOrganizationMemberStatus;
  updatedAt: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export enum OrganizationMemberGrade {
  Adult = 'ADULT',
  Eighth = 'EIGHTH',
  Eleventh = 'ELEVENTH',
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  HigherEducation = 'HIGHER_EDUCATION',
  Kindergarten = 'KINDERGARTEN',
  Ninth = 'NINTH',
  None = 'NONE',
  PreKindergarten = 'PRE_KINDERGARTEN',
  Second = 'SECOND',
  Seventh = 'SEVENTH',
  Sixth = 'SIXTH',
  Tenth = 'TENTH',
  Third = 'THIRD',
  Twelfth = 'TWELFTH',
}

export type OrganizationMemberLicenseDto = {
  __typename?: 'OrganizationMemberLicenseDto';
  accountId: Scalars['String']['output'];
  code: OrganizationLicenseCode;
  contractCustomType?: Maybe<OrganizationContractCustomType>;
  contractId: Scalars['String']['output'];
  /** 구성원이 부여 받은 이용권의 옵션 */
  contractVariants?: Maybe<Array<Maybe<OrganizationContractVariantDto>>>;
  createdAt: Scalars['String']['output'];
  endsAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** 24학년도 신규계약과 이전 계약을 구분하기 위한 속성 */
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  licenseId: Scalars['String']['output'];
  /** 구성원이 부여 받은 이용권의 이름 */
  licenseName?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  startsAt: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum OrganizationMemberOrderField {
  Name = 'NAME',
}

export type OrganizationMemberPermissionDto = {
  __typename?: 'OrganizationMemberPermissionDto';
  /** 대상이 되는 구성원의 권한 변경 권한 */
  canChangeRole: Scalars['Boolean']['output'];
  /** 대상이 되는 구성원의 계정 삭제 권한 */
  canDeleteAccount: Scalars['Boolean']['output'];
  /** 대상이 되는 구성원을 내보낼 수 있는 권한 */
  canRemove: Scalars['Boolean']['output'];
  /** 대상이 되는 구성원의 정보 및 비밀번호 변경 권한 */
  canUpdate: Scalars['Boolean']['output'];
  memberId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type OrganizationMemberSearchCollectionDto = {
  __typename?: 'OrganizationMemberSearchCollectionDto';
  members: Array<Maybe<OrganizationMemberDto>>;
  page?: Maybe<Scalars['Float']['output']>;
  perPage?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationMemberUpdateJobCollectionDto = {
  __typename?: 'OrganizationMemberUpdateJobCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  memberUpdateJobs: Array<Maybe<OrganizationMemberUpdateJobDto>>;
};

export type OrganizationMemberUpdateJobDto = {
  __typename?: 'OrganizationMemberUpdateJobDto';
  accountId?: Maybe<Scalars['String']['output']>;
  accountRole?: Maybe<OrganizationMemberAccountRole>;
  email?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<OrganizationMemberGrade>;
  id: Scalars['String']['output'];
  identityNumber?: Maybe<Scalars['String']['output']>;
  /** 업데이트 요청한 구성원 역할 */
  memberUpdateJobAccountRole?: Maybe<Scalars['String']['output']>;
  memberUpdateJobErrors?: Maybe<Array<Maybe<OrganizationMemberUpdateJobError>>>;
  /** 업데이트 요청한 구성원 학년 */
  memberUpdateJobGrade?: Maybe<Scalars['String']['output']>;
  memberUpdateJobResultCode: OrganizationMemberUpdateJobResultCode;
  memberUpdateJobStatus: OrganizationMemberUpdateJobStatus;
  name?: Maybe<Scalars['String']['output']>;
  orgUnitPath?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMemberUpdateJobError = {
  __typename?: 'OrganizationMemberUpdateJobError';
  code: OrganizationMemberUpdateJobErrorCode;
  details: Array<Maybe<OrganizationMemberUpdateJobErrorDetail>>;
};

export enum OrganizationMemberUpdateJobErrorCode {
  EmailAlreadyInUse = 'EMAIL_ALREADY_IN_USE',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidInput = 'INVALID_INPUT',
  MemberNotFound = 'MEMBER_NOT_FOUND',
  PasswordAlreadyInUse = 'PASSWORD_ALREADY_IN_USE',
  RequiredInput = 'REQUIRED_INPUT',
  UsernameAlreadyInUse = 'USERNAME_ALREADY_IN_USE',
}

export type OrganizationMemberUpdateJobErrorDetail = {
  __typename?: 'OrganizationMemberUpdateJobErrorDetail';
  message: Scalars['String']['output'];
  property: Scalars['String']['output'];
};

export enum OrganizationMemberUpdateJobResultCode {
  Canceled = 'CANCELED',
  Error = 'ERROR',
  Success = 'SUCCESS',
}

export enum OrganizationMemberUpdateJobStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS',
}

export type OrganizationMessageDto = {
  __typename?: 'OrganizationMessageDto';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  failCount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  pendingCount: Scalars['Float']['output'];
  sender?: Maybe<OrganizationMemberDto>;
  senderId: Scalars['String']['output'];
  senderNumber: Scalars['String']['output'];
  successCount: Scalars['Float']['output'];
  title?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Float']['output'];
  type: OrganizationMessageType;
  updatedAt: Scalars['String']['output'];
};

export type OrganizationMessageRecipientDto = {
  __typename?: 'OrganizationMessageRecipientDto';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  status: OrganizationMessageSentStatusType;
  statusDetail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type OrganizationMessageRecipientsCollectionDto = {
  __typename?: 'OrganizationMessageRecipientsCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  messageRecipients: Array<Maybe<OrganizationMessageRecipientDto>>;
};

export enum OrganizationMessageSentStatusType {
  Fail = 'FAIL',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type OrganizationMessageServiceDto = {
  __typename?: 'OrganizationMessageServiceDto';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  points: Scalars['Float']['output'];
  remainingLmsSendLimit: Scalars['Float']['output'];
  remainingSmsSendLimit: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum OrganizationMessageType {
  Lms = 'LMS',
  Sms = 'SMS',
}

export type OrganizationMessagesCollectionDto = {
  __typename?: 'OrganizationMessagesCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  messages: Array<Maybe<OrganizationMessageDto>>;
};

export enum OrganizationOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type OrganizationOrderDto = {
  __typename?: 'OrganizationOrderDto';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum OrganizationOrgCategory {
  NonSchool = 'NON_SCHOOL',
  School = 'SCHOOL',
}

export type OrganizationOrgCodeDto = {
  __typename?: 'OrganizationOrgCodeDto';
  code: Scalars['String']['output'];
  enterprise?: Maybe<OrganizationOrgEnterpriseDto>;
  expiresAt: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
};

export type OrganizationOrgEnterpriseDto = {
  __typename?: 'OrganizationOrgEnterpriseDto';
  slug: Scalars['String']['output'];
};

export type OrganizationOrgPermissionDto = {
  __typename?: 'OrganizationOrgPermissionDto';
  /** 기관 구성원을 일괄 생성할 수 있는 권한 */
  canBulkCreateMembers: Scalars['Boolean']['output'];
  /** 구성원이 기관에서 스스로 나갈 수 있는 권한 */
  canLeave: Scalars['Boolean']['output'];
};

export enum OrganizationOrgRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  SuperAdmin = 'SUPER_ADMIN',
}

export enum OrganizationOrgRoles3 {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  SuperAdmin = 'SUPER_ADMIN',
}

export type OrganizationOrganizationDto = {
  __typename?: 'OrganizationOrganizationDto';
  /** 기관 주소 */
  address?: Maybe<Scalars['String']['output']>;
  /** 입학 연령으로 표기되는 기관의 학교급, 공교육 기관일 경우 값을 가짐 */
  admissionAge?: Maybe<Scalars['Float']['output']>;
  category: OrganizationOrgCategory;
  /** 기관이 위치한 도시명 */
  city?: Maybe<Scalars['String']['output']>;
  /** 기관이 속한 국가 코드 */
  countryCode: Scalars['String']['output'];
  /**
   * 기관이 소속된 엔터프라이즈의 하위 카테고리 중 해당 기관이 속한 카테고리 이름,
   *
   * 엔터프라이즈에 소속된 기관이며 속한 카테고리가 있을 경우 값을 가짐
   */
  enterpriseCategory?: Maybe<Scalars['String']['output']>;
  /** 기관이 소속된 엔터프라이즈 식별자, 엔터프라이즈에 소속된 기관인 경우 값을 가짐 */
  enterpriseId?: Maybe<Scalars['String']['output']>;
  /** 기관의 첫 학년, 공교육 기관일 경우 값을 가짐 */
  firstGrade?: Maybe<Scalars['Float']['output']>;
  /** 기관 식별자 */
  id: Scalars['String']['output'];
  /** 기관 차단 여부 */
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  /** 기관 승인 여부 */
  isCertified?: Maybe<Scalars['Boolean']['output']>;
  /** 현재 기관이 이용 중인 계약 존재 여부 */
  licensed?: Maybe<Scalars['Boolean']['output']>;
  /** 기관의 학기 시작 월, 공교육 기관일 경우 값을 가짐 */
  monthAcademicYearStartsFrom?: Maybe<Scalars['Float']['output']>;
  /** 기관 이름 */
  name: Scalars['String']['output'];
  /** 기관이 소속된 교육청의 기관 식별자, 공교육 기관일 경우 값을 가짐 */
  officeOfEducation?: Maybe<Scalars['String']['output']>;
  /** 개인정보 위탁 정책 동의 일시 */
  personalInfoConsignmentAt?: Maybe<Scalars['String']['output']>;
  /** 기관의 대표 전화번호 */
  phone?: Maybe<Scalars['String']['output']>;
  /** 기관의 프로필 이미지 URL */
  profileImage: Scalars['String']['output'];
  /** 기관의 전체 학년 수, 공교육 기관일 경우 값을 가짐 */
  regularCourseYear?: Maybe<Scalars['Float']['output']>;
  /** 대표 발신자 번호, 메시지 서비스를 이용하는 기관일 경우 등록 가능 */
  senderNumber?: Maybe<Scalars['String']['output']>;
  /** 기관 검색 시 해당 기관에 적용 가능한 검색 태그 목록 */
  tags: Array<Maybe<Scalars['String']['output']>>;
  /** 기관 웹사이트 URL */
  website?: Maybe<Scalars['String']['output']>;
  /** 기관이 위치한 주소의 우편번호 */
  zipcode: Scalars['String']['output'];
};

export enum OrganizationOrganizationMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  SuperAdmin = 'SUPER_ADMIN',
}

export enum OrganizationOrganizationMemberStatus {
  Active = 'ACTIVE',
  PendingDeletion = 'PENDING_DELETION',
}

export type OrganizationOrganizationalUnitDto = {
  __typename?: 'OrganizationOrganizationalUnitDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationalUnitPath: Scalars['String']['output'];
  parentOrganizationalUnitId?: Maybe<Scalars['String']['output']>;
  parentOrganizationalUnitPath?: Maybe<Scalars['String']['output']>;
};

export type OrganizationOrganizationsSearchCollectionDto = {
  __typename?: 'OrganizationOrganizationsSearchCollectionDto';
  /** 현재 검색 결과 내의 모든 엔터프라이즈 하위 카테고리의 목록, 이름 기준으로 오름차순 정렬 */
  facets: Scalars['OrganizationJson']['output'];
  /** 기관 이름 기준으로 오름차순 정렬, 전문 검색시 관련도 기준 정렬 */
  organizations: Array<Maybe<OrganizationOrganizationDto>>;
  /** 현재 페이지 */
  page?: Maybe<Scalars['Float']['output']>;
  /** 페이지당 기관의 최대 개수 */
  perPage?: Maybe<Scalars['Float']['output']>;
  /** 검색된 기관의 총 페이지 수 */
  totalPages?: Maybe<Scalars['Float']['output']>;
  /** 검색된 기관의 총 개수 */
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationPlanDto = {
  __typename?: 'OrganizationPlanDto';
  annualBillingPrice: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  featureId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  monthlyBillingPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type OrganizationPrimaryOrgMembershipDto = {
  __typename?: 'OrganizationPrimaryOrgMembershipDto';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type OrganizationPrivateMarkOrgAsPrimaryDtoInput = {
  accountId: Scalars['String']['input'];
};

export type OrganizationRegisterClassroomMemberDtoInput = {
  memberId: Scalars['String']['input'];
  role: OrganizationClassroomMemberRole;
};

export type OrganizationRegisterClassroomMembersDtoInput = {
  memberIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type OrganizationRegisterForOrgDtoInput = {
  orgCode: Scalars['String']['input'];
};

export type OrganizationRevokeLicenseDtoInput = {
  licenseId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export type OrganizationSendMessageDtoInput = {
  content: Scalars['String']['input'];
  recipients: Array<InputMaybe<OrganizationSendMessageRecipientDtoInput>>;
  senderNumber: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: OrganizationMessageType;
};

export type OrganizationSendMessageRecipientDtoInput = {
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum OrganizationServiceType {
  Jello = 'JELLO',
  Learning = 'LEARNING',
  Writing = 'WRITING',
}

export enum OrganizationStatus2 {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type OrganizationSubscribedFeatureDto = {
  __typename?: 'OrganizationSubscribedFeatureDto';
  code: Scalars['String']['output'];
  tier: Scalars['Float']['output'];
};

export type OrganizationUpdateMemberDtoInput = {
  accountRole?: InputMaybe<OrganizationMemberAccountRole>;
  grade?: InputMaybe<OrganizationMemberGrade>;
  /** 학번, 사번 등 구성원을 기관에서 식별하는 번호 또는 문자열 */
  identityNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgUnitPath: Scalars['String']['input'];
};

export type OrganizationUpdateMessageServiceDtoInput = {
  pointsToAdd?: InputMaybe<Scalars['Float']['input']>;
};

export type OrganizationUpdateOrgClassroomDtoInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<OrganizationClassroomGrade>;
  name?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationUpdateOrgPolicyConsentDtoInput = {
  isPersonalInfoConsignmentConsent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationUpdateOrgUnitDtoInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  parentOrgUnitPath?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganizationVariantCode {
  Network = 'NETWORK',
  Quota = 'QUOTA',
  Subject = 'SUBJECT',
  Unlimited = 'UNLIMITED',
}

export type Passcode = {
  __typename?: 'Passcode';
  code?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<PasscodeOwner>;
};

export type PasscodeOwner = {
  __typename?: 'PasscodeOwner';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PersonalCertificate = {
  __typename?: 'PersonalCertificate';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PinCodeDto = {
  __typename?: 'PinCodeDto';
  expireAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isGlobalSms: Scalars['Boolean']['output'];
};

export type PinPostDtoInput = {
  postId: Scalars['String']['input'];
};

export type PostDto = {
  __typename?: 'PostDto';
  /** 관리자만 읽기 가능 여부 */
  adminExclusive: Scalars['Boolean']['output'];
  /** 게시글이 공지된 시각 */
  announcedAt?: Maybe<Scalars['String']['output']>;
  /** 과제 타입 게시글일때, 연결된 과제의 식별자 */
  assignmentId?: Maybe<Scalars['String']['output']>;
  author: MemberDto;
  /** 게시글 작성자의 식별자 */
  authorId: Scalars['String']['output'];
  /** 게시글이 작성된 공간의 식별자 */
  channelId?: Maybe<Scalars['String']['output']>;
  /** 게시글이 작성된 클래스룸의 식별자 */
  classroomId: Scalars['String']['output'];
  /** 게시글의 댓글 수 */
  commentsCount: Scalars['Float']['output'];
  /** 게시글 본문 */
  content?: Maybe<Scalars['String']['output']>;
  /** 첫 번째로 첨부된 미디어의 이미지 URL */
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  /** 게시글이 생성된 시각 */
  createdAt: Scalars['String']['output'];
  /** 게시글에 첨부된 파일 식별자 목록 */
  fileIds: Array<Maybe<Scalars['String']['output']>>;
  /** 게시글 식별자 */
  id: Scalars['String']['output'];
  /** 게시글에 첨부된 이미지 식별자 목록 */
  imageIds: Array<Maybe<Scalars['String']['output']>>;
  images?: Maybe<Array<Maybe<ImageDto>>>;
  /** 공지사항 여부 */
  isAnnouncement: Scalars['Boolean']['output'];
  /** 게시글 고정 여부 */
  isPinned: Scalars['Boolean']['output'];
  /** 게시글의 마지막 재알림 시각 */
  lastNotifiedAt?: Maybe<Scalars['String']['output']>;
  /** 게시글이 발행된 시각 */
  publishedAt?: Maybe<Scalars['String']['output']>;
  /** 게시글의 전체 반응 목록 */
  reactions: Array<Maybe<PostReactionDto>>;
  /** 게시글의 전체 반응 수 */
  reactionsCount: Scalars['Json']['output'];
  /** 게시글을 읽은 구성원 수 */
  readsCount: Scalars['Float']['output'];
  /** 게시글의 답글 수 */
  repliesCount: Scalars['Float']['output'];
  /** 게시글을 신고한 구성원 식별자 목록 */
  reporterIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** 게시글의 발행이 예정된 시각 */
  scheduledAt?: Maybe<Scalars['String']['output']>;
  /** 게시글의 상태 */
  status: Status3;
  /** 게시글 본문 요약 */
  summary?: Maybe<Scalars['String']['output']>;
  /** 게시글 태그 목록 */
  tags: Array<Maybe<Scalars['String']['output']>>;
  /** 게시글 제목 */
  title?: Maybe<Scalars['String']['output']>;
  type: PostType;
  /** 게시글이 최근 수정된 시각 */
  updatedAt: Scalars['String']['output'];
  /** 게시글에 첨부된 동영상 식별자 목록 */
  videoIds: Array<Maybe<Scalars['String']['output']>>;
  videos?: Maybe<Array<Maybe<VideoDto>>>;
};

export type PostPermissionDto = {
  __typename?: 'PostPermissionDto';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  canMarkAsAnnouncement: Scalars['Boolean']['output'];
  canMarkAsRead: Scalars['Boolean']['output'];
  canPin: Scalars['Boolean']['output'];
  canReact: Scalars['Boolean']['output'];
  canReport: Scalars['Boolean']['output'];
  canWriteComment: Scalars['Boolean']['output'];
  postId?: Maybe<Scalars['String']['output']>;
};

export type PostReactionDto = {
  __typename?: 'PostReactionDto';
  /** 반응한 시각 */
  createdAt: Scalars['String']['output'];
  member?: Maybe<MemberDto>;
  /** 반응한 구성원 식별자 */
  memberId: Scalars['String']['output'];
  /** 반응의 종류 */
  name: Scalars['String']['output'];
};

export type PostReactionsCollectionDto = {
  __typename?: 'PostReactionsCollectionDto';
  reactions: Array<Maybe<PostReactionDto>>;
};

export type PostReadStatusDto = {
  __typename?: 'PostReadStatusDto';
  postId: Scalars['String']['output'];
  readStatus: ReadStatus;
};

export enum PostType {
  Announcement = 'ANNOUNCEMENT',
  Assignment = 'ASSIGNMENT',
  Post = 'POST',
}

export type PostsCollectionDto = {
  __typename?: 'PostsCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  posts: Array<Maybe<PostDto>>;
};

export type PostsSearchCollectionDto = {
  __typename?: 'PostsSearchCollectionDto';
  page?: Maybe<Scalars['Float']['output']>;
  perPage?: Maybe<Scalars['Float']['output']>;
  posts: Array<Maybe<PostDto>>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type PrivateAssignMemberRoleDtoInput = {
  role: Role;
};

export type PrivateCreateClassroomDtoInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  adminId: Scalars['String']['input'];
  grade?: InputMaybe<Grade>;
  name: Scalars['String']['input'];
  schoolId?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<Scalars['Int']['input']>;
};

export type PrivateCreateEnterpriseMemberDtoInput = {
  /** 클래스팅 계정의 식별자 */
  accountId: Scalars['String']['input'];
};

export type PrivateRegisterDtoInput = {
  group?: InputMaybe<MemberGroup>;
  name: Scalars['String']['input'];
  profileImageId?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  role: MemberRole;
  userId: Scalars['String']['input'];
};

export type PublisherDto = {
  __typename?: 'PublisherDto';
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profileImage: Scalars['String']['output'];
  subscriptionCount: Scalars['Float']['output'];
};

export type PublisherSubscriptionDto = {
  __typename?: 'PublisherSubscriptionDto';
  publisher: PublisherDto;
  subscribedAt: Scalars['Date']['output'];
  subscriber?: Maybe<NewsletterSubscriberDto>;
  user: UserDto;
};

export type PublisherSubscriptionsCollectionDto = {
  __typename?: 'PublisherSubscriptionsCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  publisherSubscriptions: Array<PublisherSubscriptionDto>;
};

export type PublishersCollectionDto = {
  __typename?: 'PublishersCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  publishers: Array<PublisherDto>;
};

export type PushNotificationSettings = {
  __typename?: 'PushNotificationSettings';
  announcementsEnabled?: Maybe<Scalars['Boolean']['output']>;
  commentsAndRepliesEnabled?: Maybe<Scalars['Boolean']['output']>;
  postCommentsAndRepliesEnabled?: Maybe<Scalars['Boolean']['output']>;
  postReactionsEnabled?: Maybe<Scalars['Boolean']['output']>;
  postsEnabled?: Maybe<Scalars['Boolean']['output']>;
  reactionsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   *
   *
   * Equivalent to GET /media-service/admin/images/{imageId}
   */
  adminApiGetImage?: Maybe<Image>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/admin/classrooms/{classroomId}
   */
  adminGetClassroom?: Maybe<ClassroomDto>;
  /**
   *
   *
   * Equivalent to GET /classtalk-service/test
   */
  appControllerGetHello?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/assignment-submissions/{assignmentSubmissionId}
   */
  assignmentSubmission?: Maybe<AssignmentSubmissionDto>;
  /**
   * 공간의 특정 구성원 조회
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channels/{channelId}/members/{memberId}
   */
  channelMember?: Maybe<MemberDto>;
  /**
   * 클래스 기능 설정 조회
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/feature-preferences
   */
  classroomFeaturePreferences?: Maybe<ClassroomFeaturePreferencesDto>;
  /** GET /users/me */
  currentChatUser?: Maybe<ChatUser>;
  /**
   * 엔터프라이즈 조회
   *
   * Equivalent to GET /enterprise-service/enterprises/{enterpriseId}
   */
  enterprise?: Maybe<EnterpriseDto>;
  /**
   * 현재 사용자의 엔터프라이즈 구성원 정보 조회
   *
   * Equivalent to GET /enterprise-service/enterprises/{enterpriseId}/members/me
   */
  enterpriseMe?: Maybe<EnterpriseMemberDto>;
  /**
   * 엔터프라이즈 구성원 정보 조회
   *
   * Equivalent to GET /enterprise-service/enterprises/{enterpriseId}/members/{memberId}
   */
  enterpriseMember?: Maybe<EnterpriseMemberDto>;
  /**
   * 현재 사용자의 엔터프라이즈 권한 조회
   *
   * Equivalent to GET /enterprise-service/enterprises/{enterpriseId}/permission
   */
  enterprisePermission?: Maybe<EnterprisePermissionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/attendances/export
   */
  exportClassroomAttendances?: Maybe<Scalars['Json']['output']>;
  /**
   *
   *
   * Equivalent to GET /account-service/accounts/{id}
   */
  getAccount?: Maybe<SimpleAccountDto>;
  /** GET /ai_assignment_policy?target_id={args.classroomId} */
  getAiTestPolicy?: Maybe<AiTestPolicy>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}
   */
  getAssignment?: Maybe<AssignmentDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/permission
   */
  getAssignmentPermission?: Maybe<AssignmentPermissionDto>;
  /**
   * 학생의 과제 제출물 목록 조회
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/assignees/{assigneeId}/assignment-submission
   */
  getAssignmentSubmission?: Maybe<AssignmentSubmissionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/assignment-submissions/{assignmentSubmissionId}/comments/{commentId}/permission
   */
  getAssignmentSubmissionCommentPermission?: Maybe<AssignmentSubmissionCommentPermissionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/attendances/summary
   */
  getAttendanceSummary?: Maybe<AttendanceSummaryDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channels/{channelId}
   */
  getChannel?: Maybe<Channel>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channels-dto/{channelId}
   */
  getChannelDto?: Maybe<ChannelDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channel-groups/{channelGroupId}
   */
  getChannelGroup?: Maybe<ChannelGroupDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channel-groups-dto/{channelGroupId}
   */
  getChannelGroupDto?: Maybe<ChannelGroupDto>;
  getCheckedOnboardingPinnedPost?: Maybe<CheckedOnboardingPinnedPost>;
  /**
   * 클래스코드 조회
   *
   * Equivalent to GET /classroom-service/class-codes/{code}
   */
  getClassCode?: Maybe<ClassCodeDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}
   */
  getClassroom?: Maybe<ClassroomDto>;
  /**
   * 클래스 북마크 여부 확인
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/bookmark-status
   */
  getClassroomBookmarkStatus?: Maybe<ClassroomBookmarkStatusDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{id}/class-code
   */
  getClassroomClassCode?: Maybe<ClassCodeDto>;
  /**
   * :memberId에 `me` 할당 시 요청자의 구성원 정보 조회
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/members/{memberId}
   */
  getClassroomMember?: Maybe<MemberDto>;
  /**
   *
   *
   * Equivalent to GET /classtalk-service/users/{userId}
   */
  getClasstalkUser?: Maybe<ClasstalkUserDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}/comments/{commentId}
   */
  getComment?: Maybe<CommentDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/posts/{postId}/comments/{commentId}/permission
   */
  getCommentPermission?: Maybe<CommentPermissionDto>;
  /**
   *
   *
   * Equivalent to GET /insights-service/estimated-orders
   */
  getEstimatedOrder?: Maybe<InsightsEstimatedOrderDto>;
  /** GET /users/me/favorited_classes */
  getFavoritedClasses?: Maybe<ClassCollection>;
  /**
   *
   *
   * Equivalent to GET /media-service/files/{fileId}
   */
  getFile?: Maybe<File>;
  /**
   *
   *
   * Equivalent to GET /insights-service/goals/{goalId}
   */
  getGoal?: Maybe<InsightsGoalDto>;
  /**
   *
   *
   * Equivalent to GET /media-service/images/{imageId}
   */
  getImage?: Maybe<Image>;
  /**
   *
   *
   * Equivalent to GET /insights-service/me
   */
  getInsightsAccount?: Maybe<InsightsAccountDto>;
  /** GET /users/me/joined_classes */
  getJoinedClasses?: Maybe<ClassCollection>;
  /**
   *
   *
   * Equivalent to GET /insights-service/latest-goals
   */
  getLatestGoal?: Maybe<InsightsGoalDto>;
  /**
   *
   *
   * Equivalent to GET /insights-service/latest-subscriptions
   */
  getLatestSubscription?: Maybe<InsightsSubscriptionDto>;
  /** GET /cards/{args.learningCardId} */
  getLearningCard?: Maybe<LearningCard>;
  /** GET /store-cards/{args.learningStoreCardId} */
  getLearningStoreCard?: Maybe<LearningCard>;
  /**
   * 내 계정 정보 확인
   *
   * Equivalent to GET /account-service/accounts/me
   */
  getMe?: Maybe<AccountDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/settings/push-notifications
   */
  getMemberPushNotificationSettings?: Maybe<MemberPushNotificationSettingsDto>;
  /**
   * 사용자가 받은 Generator별 새소식 조회
   *
   * Equivalent to GET /notification-service/generators/{generator_id}/news
   */
  getNewsGenerator?: Maybe<GeneratorDto>;
  /**
   *
   *
   * Equivalent to GET /notification-service/notice-feeds/{id}
   */
  getNoticeFeed?: Maybe<NoticeFeedDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/onboarding-checklist
   */
  getOnboardingChecklist?: Maybe<OnboardingChecklistDto>;
  /**
   *
   *
   * Equivalent to GET /insights-service/orders/{orderId}
   */
  getOrder?: Maybe<InsightsOrderDto>;
  /**
   * 게시글 조회
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}
   */
  getPost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}/permission
   */
  getPostPermission?: Maybe<PostPermissionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/posts/{postId}/read-status
   */
  getPostReadStatus?: Maybe<PostReadStatusDto>;
  getPublisher?: Maybe<PublisherDto>;
  getPublisherArticle?: Maybe<ArticleDto>;
  getPublisherSubscription?: Maybe<PublisherSubscriptionDto>;
  /**
   *
   *
   * Equivalent to GET /classtalk-service/meetings/{meetingId}/recordings/{externalServiceId}
   */
  getRecording?: Maybe<RecordingDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/comments/{commentId}/replies/{replyId}
   */
  getReply?: Maybe<ReplyDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}/comments/{commentId}/replies/{replyId}/permission
   */
  getReplyPermission?: Maybe<ReplyPermissionDto>;
  /** GET /posts?fields=id,message,created_at&owner_type=school&owner_id={args.schoolId}&postwall=news&limit={args.limit} */
  getSchoolMealPosts?: Maybe<MealPostCollection>;
  /** GET /subscribing_schools */
  getSubscribingSchools?: Maybe<SchoolCollection>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/tags/{tag}
   */
  getTag?: Maybe<TagDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/translation/permission
   */
  getTranslationPermission?: Maybe<TranslationPermissionDto>;
  /**
   *
   *
   * Equivalent to GET /media-service/url-metadata
   */
  getUrlMetadata?: Maybe<UrlMetadata>;
  /**
   *
   *
   * Equivalent to GET /media-service/videos/{videoId}
   */
  getVideo?: Maybe<Video>;
  /** GET /latest_ai_assignment?target_id={args.classroomId} */
  latestAiAssignment?: Maybe<AiAssignment>;
  /** GET /search?type=passcode&q={args.q} */
  legacyPasscode?: Maybe<Passcode>;
  /**
   *
   *
   * Equivalent to GET /activity-stream-service/activity-streams
   */
  listActivityStreams?: Maybe<ActivityStreamsCollectionDto>;
  /** GET /subject_grades?grade_id={args.grade}&is_activated=true&is_assignable=true */
  listAiTestSubjects?: Maybe<Array<Maybe<AiTestSubject>>>;
  /** GET /units?grade_id={args.grade}&subject_id={args.subjectId} */
  listAiTestUnits?: Maybe<Array<Maybe<AiTestUnit>>>;
  /** GET /ai_assignments?target_id={args.classroomId}&page={args.page}&per_page={args.perPage} */
  listAiTests?: Maybe<AiTestCollection>;
  /**
   *
   *
   * Equivalent to GET /insights-service/classrooms/{classroomId}/all-cumulative-records
   */
  listAllCumulativeRecords?: Maybe<Array<Maybe<InsightsCumulativeRecordDto>>>;
  listArticles: ArticlesCollectionDto;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/assignees
   */
  listAssignmentAssignees?: Maybe<Array<Maybe<MemberDto>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/assignment-submissions/{assignmentSubmissionId}/comments
   */
  listAssignmentSubmissionComments?: Maybe<AssignmentSubmissionCommentsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/assignment-submissions
   */
  listAssignmentSubmissions?: Maybe<Array<Maybe<AssignmentSubmissionDto>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/bookmarks
   */
  listBookmarkedClassrooms?: Maybe<ClassroomFavoritesCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channel-groups
   */
  listChannelGroups?: Maybe<Array<Maybe<ChannelGroupDto>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channel-groups-dto
   */
  listChannelGroupsDto?: Maybe<Array<Maybe<ChannelGroupDto>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channels/{channelId}/media-posts
   */
  listChannelMediaPosts?: Maybe<PostsSearchCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channels/{channelId}/members
   */
  listChannelMembers?: Maybe<Array<Maybe<MemberDto>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channels
   */
  listChannels?: Maybe<Array<Maybe<Channel>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/channels-dto
   */
  listChannelsDto?: Maybe<Array<Maybe<ChannelDto>>>;
  /**
   *
   *
   * Equivalent to GET /insights-service/children/{childId}/activities
   */
  listChildActivities?: Maybe<InsightsActivitiesCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /insights-service/childrens
   */
  listChildren?: Maybe<Array<Maybe<InsightsChildDto>>>;
  /**
   * 정렬 순서: 가장 최근에 작성된 과제순
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/assignments
   */
  listClassroomAssignments?: Maybe<AssignmentsSearchCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/blocked-members
   */
  listClassroomBlockedMembers?: Maybe<MembersCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/media-posts
   */
  listClassroomMediaPosts?: Maybe<PostsSearchCollectionDto>;
  /**
   * 구성원 이름 순으로 정렬. 비활성 구성원은 제외
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/members
   */
  listClassroomMembers?: Maybe<MembersCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/admin/classrooms/{classroomId}/members
   */
  listClassroomMembersControllerAdminListClassroomMembers?: Maybe<MembersCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/roles
   */
  listClassroomRoles?: Maybe<Array<Maybe<RoleDto>>>;
  /**
   * 정렬 순서: 최근에 개설된 클래스 순
   *
   * Equivalent to GET /classroom-service/classrooms
   */
  listClassrooms?: Maybe<ClassroomsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classtalk-service/meetings
   */
  listClasstalkMeetings?: Maybe<ClasstalkMeetingsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}/comments/{commentId}/reactions
   */
  listCommentReactions?: Maybe<CommentReactionsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/common-channels
   */
  listCommonChannels?: Maybe<Array<Maybe<ChannelDto>>>;
  /**
   *
   *
   * Equivalent to GET /insights-service/classrooms/{classroomId}/cumulative-records
   */
  listCumulativeRecords?: Maybe<InsightsCumulativeRecordsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /account-service/guardian-relationships
   */
  listGuardianRelationships?: Maybe<Array<Maybe<GuardianRelationshipDto>>>;
  /**
   *
   *
   * Equivalent to GET /media-service/images
   */
  listImages?: Maybe<Array<Maybe<Image>>>;
  /** GET /cards/{args.learningCardId}/pages */
  listLearningCardPages?: Maybe<Array<Maybe<LearningCardPage>>>;
  /** GET /cards?author_id={args.authorId}&core_concept_id={args.coreConceptId}&grade_id={args.gradeId}&media_type={args.mediaType}&offset={args.offset}&limit={args.limit}&order_by={args.orderBy}&publisher_id={args.publisherId}&school_id={args.schoolId}&searchKeywords={args.searchKeywords}&share_level={args.shareLevel}&subject_id={args.subjectId}&unit_id={args.unitId} */
  listLearningCards?: Maybe<LearningCardCollection>;
  /** GET /cards?core_concept_id={args.coreConceptId}&grade_id={args.gradeId}&media_type={args.mediaType}&offset={args.offset}&limit={args.limit}&order_by={args.orderBy}&publisher_id={args.publisherId}&school_id={args.schoolId}&searchKeywords={args.searchKeywords}&share_level={args.shareLevel}&subject_id={args.subjectId}&unit_id={args.unitId} */
  listLearningCommunityCards?: Maybe<LearningCardCollection>;
  /** GET /grades */
  listLearningGrades?: Maybe<Array<Maybe<LearningGrade>>>;
  /** GET /cards?core_concept_id={args.coreConceptId}&grade_id={args.gradeId}&media_type={args.mediaType}&offset={args.offset}&limit={args.limit}&order_by={args.orderBy}&publisher_id={args.publisherId}&school_id={args.schoolId}&searchKeywords={args.searchKeywords}}&share_level={args.shareLevel}&subject_id={args.subjectId}&unit_id={args.unitId} */
  listLearningSchoolCards?: Maybe<LearningCardCollection>;
  /** GET /store-cards/{args.learningStoreCardId}/pages */
  listLearningStoreCardPages?: Maybe<Array<Maybe<LearningStoreCardPage>>>;
  /** GET /store-cards?core_concept_id={args.coreConceptId}&grade_id={args.gradeId}&media_type={args.mediaType}&offset={args.offset}&limit={args.limit}&order_by={args.orderBy}&publisher_id={args.publisherId}&school_id={args.schoolId}&search_keywords={args.searchKeywords}&share_level={args.shareLevel}&subject_id={args.subjectId}&unit_id={args.unitId} */
  listLearningStoreCards?: Maybe<LearningStoreCardCollection>;
  /** GET /subjects */
  listLearningSubjects?: Maybe<Array<Maybe<LearningSubject>>>;
  /** GET /units?subject_id={args.subjectId}&grade_id={args.gradeId} */
  listLearningUnits?: Maybe<Array<Maybe<LearningUnit>>>;
  /**
   *
   *
   * Equivalent to GET /notification-service/meal-feeds
   */
  listMealFeeds?: Maybe<MealFeedsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /insights-service/members/{memberId}/activities
   */
  listMemberActivities?: Maybe<InsightsActivitiesCollectionDto>;
  /**
   * 나에게 할당된 과제 목록 조회
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/my-assignments
   */
  listMemberAssignments?: Maybe<AssignmentsSearchCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/attendances
   */
  listMemberAttendances?: Maybe<MemberAttendancesCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/assignments/{assignmentId}/my-submissions
   */
  listMemberSubmissions?: Maybe<Array<Maybe<SubmissionDto>>>;
  /**
   * 정렬 순서: 즐겨찾기한 순서, 구 클래스는 항상 하단에 위치
   *
   * Equivalent to GET /classroom-service/my-classrooms/bookmarks
   */
  listMyBookmarkedClassrooms?: Maybe<MyClassroomsCollectionDto>;
  /**
   * 정렬 순서: 최근에 개설된 클래스 순
   *
   * Equivalent to GET /classroom-service/my-classrooms
   */
  listMyClassrooms?: Maybe<MyClassroomsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/newsfeed
   */
  listNewsfeedPosts?: Maybe<PostsCollectionDto>;
  /**
   * 사용자가 받은 공지의 피드
   *
   * Equivalent to GET /notification-service/notice-feeds
   */
  listNoticeFeeds?: Maybe<NoticeFeedsCollectionDto>;
  /**
   * 수신한 알림 리스트
   *
   * Equivalent to GET /notification-service/notifications
   */
  listNotifications?: Maybe<NotificationsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}/comments
   */
  listPostComments?: Maybe<CommentsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/post-drafts
   */
  listPostDrafts?: Maybe<PostsSearchCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/post-pins
   */
  listPostPins?: Maybe<Array<Maybe<ChannelPostPinDto>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}/reactions
   */
  listPostReactions?: Maybe<PostReactionsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}/reads
   */
  listPostReads?: Maybe<Array<Maybe<MemberDto>>>;
  /**
   *
   *
   * Equivalent to GET /insights-service/statistics/classrooms/{classroomId}/post-reads-by-post
   */
  listPostReadsByPost?: Maybe<InsightsPostReadsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/post-schedules
   */
  listPostSchedules?: Maybe<PostsSearchCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}/unreads
   */
  listPostUnreads?: Maybe<Array<Maybe<MemberDto>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts
   */
  listPosts?: Maybe<PostsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/{postType}/posts
   */
  listPostsByPostType?: Maybe<PostsSearchCollectionDto>;
  listPublisherArticles: ArticlesCollectionDto;
  listPublisherSubscriptions: PublisherSubscriptionsCollectionDto;
  listPublishers: PublishersCollectionDto;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/{postId}/comments/{commentId}/replies
   */
  listReplies?: Maybe<RepliesCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/comments/{commentId}/replies/{replyId}/reactions
   */
  listReplyReactions?: Maybe<ReplyReactionsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/schools/{schoolId}/classrooms
   */
  listSchoolClassrooms?: Maybe<ClassroomsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/admin/schools/{schoolId}/classrooms
   */
  listSchoolClassroomsControllerAdminListSchoolClassrooms?: Maybe<ClassroomsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /insights-service/subscription-products
   */
  listSubscriptionProducts?: Maybe<
    Array<Maybe<InsightsSubscriptionProductDto>>
  >;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/tags
   */
  listTags?: Maybe<Array<Maybe<TagDto>>>;
  /**
   *
   *
   * Equivalent to GET /insights-service/todos
   */
  listTodos?: Maybe<InsightsTodosCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /media-service/videos
   */
  listVideos?: Maybe<Array<Maybe<Video>>>;
  /** GET /account-service/accounts/me */
  me?: Maybe<Account>;
  notificationLastSeen?: Maybe<NotificationLastSeen>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{organizationId}/members/me
   */
  organizationCurrentMember?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{organizationId}/member-bulk-update-jobs
   */
  organizationCurrentMemberBulkUpdateJob?: Maybe<OrganizationMemberBulkUpdateJobDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{organizationId}/member-bulk-update-jobs/actions/export-member-bulk-update-template
   */
  organizationExportBulkUpdateMemberTemplateControllerExportMemberBulkUpdateTemplate?: Maybe<
    Scalars['OrganizationJson']['output']
  >;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{organizationId}/members/{memberId}
   */
  organizationMember?: Maybe<OrganizationMemberDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{organizationId}/member-bulk-update-jobs/{memberBulkUpdateJobId}
   */
  organizationMemberBulkUpdateJob?: Maybe<OrganizationMemberBulkUpdateJobDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/members/{memberId}/permission
   */
  organizationMemberPermission?: Maybe<OrganizationMemberPermissionDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{organizationId}/member-bulk-update-jobs/{memberBulkUpdateJobId}/member-update-jobs
   */
  organizationMemberUpdateJobs?: Maybe<OrganizationMemberUpdateJobCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/messages/{messageId}
   */
  organizationMessage?: Maybe<OrganizationMessageDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/messages/{messageId}/recipients
   */
  organizationMessageRecipients?: Maybe<OrganizationMessageRecipientsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/message-service
   */
  organizationMessageService?: Maybe<OrganizationMessageServiceDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/messages
   */
  organizationMessages?: Maybe<OrganizationMessagesCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/my-license
   */
  organizationMyLicense?: Maybe<OrganizationMemberLicenseDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/orders/{orderId}
   */
  organizationOrder?: Maybe<OrganizationOrderDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/classrooms/{classroomId}
   */
  organizationOrgClassroom?: Maybe<OrganizationClassroomWithAdminDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/classrooms/{classroomId}/members/{memberId}
   */
  organizationOrgClassroomMember?: Maybe<OrganizationClassroomMemberDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/classrooms/{classroomId}/members
   */
  organizationOrgClassroomMembers?: Maybe<OrganizationClassroomMembersCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/classrooms
   */
  organizationOrgClassrooms?: Maybe<OrganizationClassroomsWithAdminCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/org-code
   */
  organizationOrgCode?: Maybe<OrganizationOrgCodeDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/contracts
   */
  organizationOrgContracts?: Maybe<OrganizationContractsCollectionDto>;
  /**
   * 기관의 구성원 라이센스 목록 조회
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/member-licenses
   */
  organizationOrgMemberLicenses?: Maybe<
    Array<Maybe<OrganizationMemberLicenseDto>>
  >;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/members
   */
  organizationOrgMembers?: Maybe<OrganizationMemberSearchCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/permission
   */
  organizationOrgPermission?: Maybe<OrganizationOrgPermissionDto>;
  /**
   * 기관 조회
   *
   * Equivalent to GET /organization-service/organizations/{organizationId}
   */
  organizationOrganization?: Maybe<OrganizationOrganizationDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{organizationId}/org-units
   */
  organizationOrganizationalUnits?: Maybe<
    Array<Maybe<OrganizationOrganizationalUnitDto>>
  >;
  /**
   * 현재 사용자의 소속 기관 목록 조회
   *
   * Equivalent to GET /organization-service/organizations
   */
  organizationOrgs?: Maybe<Array<Maybe<OrganizationOrganizationDto>>>;
  /**
   *
   *
   * Equivalent to GET /organization-service/plans
   */
  organizationPlans?: Maybe<Array<Maybe<OrganizationPlanDto>>>;
  /**
   * 현재 사용자의 대표기관 조회
   *
   * Equivalent to GET /organization-service/organizations/primary-org
   */
  organizationPrimaryOrg?: Maybe<OrganizationOrganizationDto>;
  /**
   * 기관 조회
   *
   * Equivalent to GET /organization-service/private/organizations/{organizationId}
   */
  organizationPrivateGetOrganizationControllerPrivateGetOrganization?: Maybe<OrganizationOrganizationDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/private/organizations/{organizationId}/members
   */
  organizationPrivateListOrgMembersControllerPrivateListOrgMembers?: Maybe<OrganizationMemberSearchCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/private/organizations/{organizationId}/org-units
   */
  organizationPrivateListOrgUnitsControllerListOrganizationalUnits?: Maybe<
    Array<Maybe<OrganizationOrganizationalUnitDto>>
  >;
  /**
   * 사용자의 소속 기관 목록 조회
   *
   * Equivalent to GET /organization-service/private/organizations
   */
  organizationPrivateListOrgsControllerPrivateListOrgs?: Maybe<
    Array<Maybe<OrganizationOrganizationDto>>
  >;
  /**
   *
   *
   * Equivalent to GET /organization-service/private/organizations/search
   */
  organizationPrivateSearchOrganizationsControllerSearchOrganizations?: Maybe<OrganizationOrganizationsSearchCollectionDto>;
  /**
   * 기관 검색
   *
   * Equivalent to GET /organization-service/organizations/search
   */
  organizationSearchOrganizations?: Maybe<OrganizationOrganizationsSearchCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /organization-service/organizations/{orgId}/features
   */
  organizationSubscribedFeatures?: Maybe<
    Array<Maybe<OrganizationSubscribedFeatureDto>>
  >;
  /**
   *
   *
   * Equivalent to GET /organization-service/org-codes/{orgCode}
   */
  organizationVerifiedOrgCode?: Maybe<OrganizationOrgCodeDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/classrooms/{classroomId}/assignments/{assignmentId}
   */
  privateGetAssignment?: Maybe<AssignmentDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/assignment-submissions/{assignmentSubmissionId}
   */
  privateGetAssignmentSubmission?: Maybe<AssignmentSubmissionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/classrooms/{classroomId}
   */
  privateGetClassroom?: Maybe<ClassroomDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/classrooms/{classroomId}/posts/{postId}/comments/{commentId}
   */
  privateGetComment?: Maybe<CommentDto>;
  /**
   *
   *
   * Equivalent to GET /enterprise-service/privates/enterprises/{enterpriseId}
   */
  privateGetEnterpriseControllerPrivateGetEnterprise?: Maybe<EnterpriseDto>;
  /**
   *
   *
   * Equivalent to GET /enterprise-service/privates/enterprises/{enterpriseId}/members/{memberId}
   */
  privateGetMemberControllerPrivateGetMember?: Maybe<EnterpriseMemberDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/classrooms/{classroomId}/posts/{postId}
   */
  privateGetPost?: Maybe<PostDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/classrooms/{classroomId}/channels/{channelId}/members
   */
  privateListChannelMembers?: Maybe<Array<Maybe<MemberDto>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/classrooms/{classroomId}/members
   */
  privateListClassroomMembers?: Maybe<MembersCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/organizations/{organizationId}/classrooms
   */
  privateListOrganizationClassrooms?: Maybe<ClassroomsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/classrooms/{classroomId}/posts
   */
  privateListPosts?: Maybe<PostsCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/privates/classrooms/search
   */
  privateSearchClassrooms?: Maybe<ClassroomsSearchCollectionDto>;
  /** GET /schools/{args.schoolId} */
  school?: Maybe<School>;
  /** GET /institute_types/school/categories */
  schoolCategories?: Maybe<Array<Maybe<SchoolCategory>>>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/search
   */
  searchClassrooms?: Maybe<ClassroomsSearchCollectionDto>;
  /**
   *
   *
   * Equivalent to GET /classroom-service/classrooms/{classroomId}/posts/search
   */
  searchPosts?: Maybe<PostsSearchCollectionDto>;
  /** GET /search?type=school&q={args.q}&offset={args.offset}&limit={args.limit} */
  searchSchools?: Maybe<SchoolCollection>;
  /**
   *
   *
   * Equivalent to GET /account-service/student-registration-codes
   */
  studentRegistrationCodesControllerListStudentRegistrationCodes?: Maybe<
    Array<Maybe<StudentRegistrationCodeDto>>
  >;
  taskItemStatus?: Maybe<TaskItemStatus>;
};

export type QueryAdminApiGetImageArgs = {
  imageId: Scalars['String']['input'];
};

export type QueryAdminGetClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type QueryAssignmentSubmissionArgs = {
  assignmentSubmissionId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type QueryChannelMemberArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export type QueryClassroomFeaturePreferencesArgs = {
  classroomId: Scalars['String']['input'];
};

export type QueryEnterpriseArgs = {
  enterpriseId: Scalars['String']['input'];
};

export type QueryEnterpriseMeArgs = {
  enterpriseId: Scalars['String']['input'];
};

export type QueryEnterpriseMemberArgs = {
  enterpriseId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export type QueryEnterprisePermissionArgs = {
  enterpriseId: Scalars['String']['input'];
};

export type QueryExportClassroomAttendancesArgs = {
  classroomId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  months: Array<InputMaybe<Scalars['Float']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Float']['input'];
};

export type QueryGetAccountArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetAiTestPolicyArgs = {
  classroomId: Scalars['ID']['input'];
};

export type QueryGetAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type QueryGetAssignmentPermissionArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type QueryGetAssignmentSubmissionArgs = {
  assigneeId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type QueryGetAssignmentSubmissionCommentPermissionArgs = {
  assignmentSubmissionId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
};

export type QueryGetAttendanceSummaryArgs = {
  classroomId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetChannelArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type QueryGetChannelDtoArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type QueryGetChannelGroupArgs = {
  channelGroupId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type QueryGetChannelGroupDtoArgs = {
  channelGroupId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type QueryGetCheckedOnboardingPinnedPostArgs = {
  classroomId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QueryGetClassCodeArgs = {
  code: Scalars['String']['input'];
};

export type QueryGetClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type QueryGetClassroomBookmarkStatusArgs = {
  classroomId: Scalars['String']['input'];
};

export type QueryGetClassroomClassCodeArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetClassroomMemberArgs = {
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export type QueryGetClasstalkUserArgs = {
  userId: Scalars['String']['input'];
};

export type QueryGetCommentArgs = {
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type QueryGetCommentPermissionArgs = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type QueryGetEstimatedOrderArgs = {
  orderId: Scalars['String']['input'];
};

export type QueryGetFileArgs = {
  fileId: Scalars['String']['input'];
};

export type QueryGetGoalArgs = {
  childId: Scalars['String']['input'];
  goalId: Scalars['String']['input'];
};

export type QueryGetImageArgs = {
  imageId: Scalars['String']['input'];
};

export type QueryGetLatestGoalArgs = {
  childId: Scalars['String']['input'];
  guardianId: Scalars['String']['input'];
};

export type QueryGetLearningCardArgs = {
  learningCardId?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryGetLearningStoreCardArgs = {
  learningStoreCardId?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryGetMemberPushNotificationSettingsArgs = {
  classroomId: Scalars['String']['input'];
};

export type QueryGetNewsGeneratorArgs = {
  generatorId: Scalars['String']['input'];
  generatorType: Scalars['String']['input'];
};

export type QueryGetNoticeFeedArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetOnboardingChecklistArgs = {
  classroomId: Scalars['String']['input'];
};

export type QueryGetOrderArgs = {
  orderId: Scalars['String']['input'];
};

export type QueryGetPostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type QueryGetPostPermissionArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type QueryGetPostReadStatusArgs = {
  postId: Scalars['String']['input'];
};

export type QueryGetPublisherArgs = {
  publisherId: Scalars['String']['input'];
  publisherLocale: Scalars['String']['input'];
};

export type QueryGetPublisherArticleArgs = {
  articleId: Scalars['String']['input'];
  publisherId: Scalars['String']['input'];
  publisherLocale: Scalars['String']['input'];
};

export type QueryGetPublisherSubscriptionArgs = {
  publisherId: Scalars['String']['input'];
};

export type QueryGetRecordingArgs = {
  externalServiceId: Scalars['String']['input'];
  meetingId: Scalars['String']['input'];
};

export type QueryGetReplyArgs = {
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
};

export type QueryGetReplyPermissionArgs = {
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
};

export type QueryGetSchoolMealPostsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTagArgs = {
  classroomId: Scalars['String']['input'];
  tag: Scalars['String']['input'];
};

export type QueryGetTranslationPermissionArgs = {
  classroomId: Scalars['String']['input'];
};

export type QueryGetUrlMetadataArgs = {
  url: Scalars['String']['input'];
};

export type QueryGetVideoArgs = {
  videoId: Scalars['String']['input'];
};

export type QueryLatestAiAssignmentArgs = {
  classroomId: Scalars['ID']['input'];
};

export type QueryLegacyPasscodeArgs = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListActivityStreamsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  generatorId?: InputMaybe<Scalars['String']['input']>;
  generatorType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  objectTypes?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  targetTypes?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListAiTestSubjectsArgs = {
  grade?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListAiTestUnitsArgs = {
  grade: Scalars['Float']['input'];
  subjectId: Scalars['Float']['input'];
};

export type QueryListAiTestsArgs = {
  classroomId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListAllCumulativeRecordsArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListArticlesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  locale: Scalars['String']['input'];
};

export type QueryListAssignmentAssigneesArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListAssignmentSubmissionCommentsArgs = {
  assignmentSubmissionId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListAssignmentSubmissionsArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  submitted?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListBookmarkedClassroomsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListChannelGroupsArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scope2>;
};

export type QueryListChannelGroupsDtoArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scope2>;
};

export type QueryListChannelMediaPostsArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListChannelMembersArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  groups?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListChannelsArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListChannelsDtoArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListChildActivitiesArgs = {
  childId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  generatorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListClassroomAssignmentsArgs = {
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListClassroomBlockedMembersArgs = {
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListClassroomMediaPostsArgs = {
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListClassroomMembersArgs = {
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListClassroomMembersControllerAdminListClassroomMembersArgs = {
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListClassroomRolesArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListClassroomsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Filter>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListClasstalkMeetingsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListCommentReactionsArgs = {
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
};

export type QueryListCommonChannelsArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListCumulativeRecordsArgs = {
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListGuardianRelationshipsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type: Type;
};

export type QueryListImagesArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListLearningCardPagesArgs = {
  learningCardId: Scalars['ID']['input'];
};

export type QueryListLearningCardsArgs = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  coreConceptId?: InputMaybe<Scalars['String']['input']>;
  gradeId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['Float']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
  shareLevel?: InputMaybe<Scalars['Float']['input']>;
  subjectId?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListLearningCommunityCardsArgs = {
  coreConceptId?: InputMaybe<Scalars['String']['input']>;
  gradeId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['Float']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
  shareLevel?: InputMaybe<Scalars['Float']['input']>;
  subjectId?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListLearningSchoolCardsArgs = {
  coreConceptId?: InputMaybe<Scalars['String']['input']>;
  gradeId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['Float']['input']>;
  schoolId: Scalars['String']['input'];
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
  shareLevel?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListLearningStoreCardPagesArgs = {
  learningStoreCardId: Scalars['ID']['input'];
};

export type QueryListLearningStoreCardsArgs = {
  coreConceptId?: InputMaybe<Scalars['String']['input']>;
  gradeId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['Float']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
  shareLevel?: InputMaybe<Scalars['Float']['input']>;
  subjectId?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListLearningUnitsArgs = {
  gradeId: Scalars['ID']['input'];
  subjectId: Scalars['ID']['input'];
};

export type QueryListMealFeedsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  generatorId?: InputMaybe<Scalars['String']['input']>;
  generatorType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListMemberActivitiesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  generatorId: Scalars['String']['input'];
  generatorType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  memberId: Scalars['String']['input'];
};

export type QueryListMemberAssignmentsArgs = {
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListMemberAttendancesArgs = {
  classroomId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListMemberSubmissionsArgs = {
  assignmentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListMyBookmarkedClassroomsArgs = {
  includeLegacyClassrooms?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListMyClassroomsArgs = {
  filter?: InputMaybe<Filter>;
  includeLegacyClassrooms?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryListNewsfeedPostsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  postIds?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status4>;
};

export type QueryListNoticeFeedsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  generatorId?: InputMaybe<Scalars['String']['input']>;
  generatorType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListNotificationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  generatorId?: InputMaybe<Scalars['String']['input']>;
  generatorType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListPostCommentsArgs = {
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  postId: Scalars['String']['input'];
};

export type QueryListPostDraftsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  postType?: InputMaybe<PostType>;
};

export type QueryListPostPinsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListPostReactionsArgs = {
  classroomId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
};

export type QueryListPostReadsArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['String']['input'];
};

export type QueryListPostReadsByPostArgs = {
  classroomId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListPostSchedulesArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  postType?: InputMaybe<PostType>;
};

export type QueryListPostUnreadsArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['String']['input'];
};

export type QueryListPostsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  postIds?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status4>;
};

export type QueryListPostsByPostTypeArgs = {
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  postType: Scalars['String']['input'];
};

export type QueryListPublisherArticlesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  publisherId: Scalars['String']['input'];
  publisherLocale: Scalars['String']['input'];
};

export type QueryListPublisherSubscriptionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListPublishersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  publisherLocale: Scalars['String']['input'];
};

export type QueryListRepliesArgs = {
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  postId: Scalars['String']['input'];
};

export type QueryListReplyReactionsArgs = {
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  replyId: Scalars['String']['input'];
};

export type QueryListSchoolClassroomsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  schoolId: Scalars['String']['input'];
};

export type QueryListSchoolClassroomsControllerAdminListSchoolClassroomsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  schoolId: Scalars['String']['input'];
};

export type QueryListSubscriptionProductsArgs = {
  currencyCode: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  packageName: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
};

export type QueryListTagsArgs = {
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryListTodosArgs = {
  childId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryListVideosArgs = {
  ids?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryNotificationLastSeenArgs = {
  userId: Scalars['String']['input'];
};

export type QueryOrganizationCurrentMemberArgs = {
  organizationId: Scalars['String']['input'];
};

export type QueryOrganizationCurrentMemberBulkUpdateJobArgs = {
  organizationId: Scalars['String']['input'];
};

export type QueryOrganizationExportBulkUpdateMemberTemplateControllerExportMemberBulkUpdateTemplateArgs =
  {
    orgUnitIds: Scalars['String']['input'];
    organizationId: Scalars['String']['input'];
  };

export type QueryOrganizationMemberArgs = {
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type QueryOrganizationMemberBulkUpdateJobArgs = {
  memberBulkUpdateJobId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type QueryOrganizationMemberPermissionArgs = {
  memberId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationMemberUpdateJobsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  memberBulkUpdateJobId: Scalars['String']['input'];
  memberUpdateJobStatus?: InputMaybe<OrganizationMemberUpdateJobStatus>;
  organizationId: Scalars['String']['input'];
};

export type QueryOrganizationMessageArgs = {
  messageId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationMessageRecipientsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  messageId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationMessageServiceArgs = {
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationMessagesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationMyLicenseArgs = {
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationOrderArgs = {
  orderId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationOrgClassroomArgs = {
  classroomId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationOrgClassroomMemberArgs = {
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationOrgClassroomMembersArgs = {
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  orgId: Scalars['String']['input'];
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrganizationOrgClassroomsArgs = {
  classroomOrderField?: InputMaybe<OrganizationClassroomOrderField>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<OrganizationGrade>;
  orderDirection?: InputMaybe<OrganizationOrderDirection>;
  orgId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  schoolYear?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<OrganizationStatus2>;
};

export type QueryOrganizationOrgCodeArgs = {
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationOrgContractsArgs = {
  contractStatus?: InputMaybe<OrganizationContractStatus>;
  contractStatusFilters?: InputMaybe<Scalars['String']['input']>;
  contractVersion?: InputMaybe<Scalars['Float']['input']>;
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationOrgMemberLicensesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  memberIds?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationOrgMembersArgs = {
  accountIds?: InputMaybe<Scalars['String']['input']>;
  accountRole?: InputMaybe<OrganizationAccountRole>;
  memberOrderField?: InputMaybe<OrganizationMemberOrderField>;
  orderDirection?: InputMaybe<OrganizationOrderDirection>;
  orgId: Scalars['String']['input'];
  orgRole?: InputMaybe<OrganizationOrgRole>;
  orgUnitId?: InputMaybe<Scalars['String']['input']>;
  organizationMemberStatus?: InputMaybe<OrganizationOrganizationMemberStatus>;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrganizationOrgPermissionArgs = {
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};

export type QueryOrganizationOrganizationalUnitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};

export type QueryOrganizationOrgsArgs = {
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orgRoles?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrganizationPlansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryOrganizationPrivateGetOrganizationControllerPrivateGetOrganizationArgs =
  {
    organizationId: Scalars['String']['input'];
  };

export type QueryOrganizationPrivateListOrgMembersControllerPrivateListOrgMembersArgs =
  {
    accountId?: InputMaybe<Scalars['String']['input']>;
    accountRole?: InputMaybe<OrganizationAccountRole>;
    orgRole?: InputMaybe<OrganizationOrgRole>;
    orgRoles?: InputMaybe<OrganizationOrgRoles3>;
    orgUnitId?: InputMaybe<Scalars['String']['input']>;
    organizationId: Scalars['String']['input'];
    page?: InputMaybe<Scalars['Float']['input']>;
    perPage?: InputMaybe<Scalars['Float']['input']>;
    q?: InputMaybe<Scalars['String']['input']>;
  };

export type QueryOrganizationPrivateListOrgUnitsControllerListOrganizationalUnitsArgs =
  {
    limit?: InputMaybe<Scalars['Int']['input']>;
    organizationId: Scalars['String']['input'];
  };

export type QueryOrganizationPrivateListOrgsControllerPrivateListOrgsArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orgRoles?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrganizationPrivateSearchOrganizationsControllerSearchOrganizationsArgs =
  {
    enterpriseCategory?: InputMaybe<Scalars['String']['input']>;
    enterpriseId?: InputMaybe<Scalars['String']['input']>;
    page?: InputMaybe<Scalars['Float']['input']>;
    perPage?: InputMaybe<Scalars['Float']['input']>;
    q?: InputMaybe<Scalars['String']['input']>;
    tag?: InputMaybe<Scalars['String']['input']>;
  };

export type QueryOrganizationSearchOrganizationsArgs = {
  enterpriseCategory?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrganizationSubscribedFeaturesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['String']['input'];
};

export type QueryOrganizationVerifiedOrgCodeArgs = {
  orgCode: Scalars['String']['input'];
};

export type QueryPrivateGetAssignmentArgs = {
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
};

export type QueryPrivateGetAssignmentSubmissionArgs = {
  assignmentSubmissionId: Scalars['String']['input'];
};

export type QueryPrivateGetClassroomArgs = {
  classroomId: Scalars['String']['input'];
};

export type QueryPrivateGetCommentArgs = {
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type QueryPrivateGetEnterpriseControllerPrivateGetEnterpriseArgs = {
  enterpriseId: Scalars['String']['input'];
};

export type QueryPrivateGetMemberControllerPrivateGetMemberArgs = {
  enterpriseId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export type QueryPrivateGetPostArgs = {
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type QueryPrivateListChannelMembersArgs = {
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPrivateListClassroomMembersArgs = {
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPrivateListOrganizationClassroomsArgs = {
  active?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Grade3>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  organizationId: Scalars['String']['input'];
  schoolYear?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryPrivateListPostsArgs = {
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  publishedAtGt?: InputMaybe<Scalars['String']['input']>;
  publishedAtLt?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPrivateSearchClassroomsArgs = {
  active?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Grade3>;
  isLegacy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  schoolYear?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
};

export type QuerySchoolArgs = {
  schoolId?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySearchClassroomsArgs = {
  active?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Grade3>;
  isLegacy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  schoolYear?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
};

export type QuerySearchPostsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  classroomId: Scalars['String']['input'];
  isAnnouncement?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySearchSchoolsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryStudentRegistrationCodesControllerListStudentRegistrationCodesArgs =
  {
    limit?: InputMaybe<Scalars['Int']['input']>;
  };

export type QueryTaskItemStatusArgs = {
  taskItemId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum ReadStatus {
  Read = 'READ',
  Unread = 'UNREAD',
}

export type RecordingDownloadUrlDto = {
  __typename?: 'RecordingDownloadUrlDto';
  presignedUrl: Scalars['String']['output'];
};

export type RecordingDto = {
  __typename?: 'RecordingDto';
  createdAt: Scalars['String']['output'];
  externalServiceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  meetingId: Scalars['String']['output'];
  /**
   *
   *     녹음 파일 상태값
   *       'in-progress' | 'success' | 'failure'
   *
   */
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type RegisterDtoInput = {
  /** 가입할 클래스의 클래스코드 */
  classCode?: InputMaybe<Scalars['String']['input']>;
  /** 가입할 클래스의 식별자 */
  classroomId?: InputMaybe<Scalars['String']['input']>;
  /** 구성원 클래스 내 역할 */
  group?: InputMaybe<Group2>;
  /** 구성원 이름 */
  name: Scalars['String']['input'];
  /** 미디어 서비스 내의 구성원 프로필 이미지 식별자 */
  profileImageId?: InputMaybe<Scalars['String']['input']>;
  /** 구성원 프로필 이미지 URL */
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterSchoolDtoInput = {
  academicYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  address: Scalars['String']['input'];
  addressDetail: Scalars['String']['input'];
  admissionAge?: InputMaybe<Scalars['Int']['input']>;
  categoryId: Scalars['Int']['input'];
  countryCode: Scalars['String']['input'];
  firstGrade?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  regularCourseYear?: InputMaybe<Scalars['Int']['input']>;
  website: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type RegisterToClasstalkDtoInput = {
  callable?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  workdays?: InputMaybe<Array<InputMaybe<RegisterWorkdayDtoInput>>>;
};

export type RegisterWorkdayDtoInput = {
  available: Scalars['Boolean']['input'];
  day: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type RegradeAssignmentSubmissionDtoInput = {
  points: Scalars['Float']['input'];
};

export enum RelationshipType {
  Father = 'FATHER',
  GrandFather = 'GRAND_FATHER',
  GrandMother = 'GRAND_MOTHER',
  Guardian = 'GUARDIAN',
  Mother = 'MOTHER',
}

export type RemoveDeviceResponseDto = {
  __typename?: 'RemoveDeviceResponseDto';
  success: Scalars['Boolean']['output'];
};

export type RemoveReactionFromCommentDtoInput = {
  name: Scalars['String']['input'];
};

export type RemoveReactionFromPostDtoInput = {
  name: Scalars['String']['input'];
};

export type RemoveReactionFromReplyDtoInput = {
  name: Scalars['String']['input'];
};

export type RepliesCollectionDto = {
  __typename?: 'RepliesCollectionDto';
  cursor?: Maybe<Scalars['String']['output']>;
  replies: Array<Maybe<ReplyDto>>;
};

export type ReplyDto = {
  __typename?: 'ReplyDto';
  author: MemberDto;
  authorId: Scalars['String']['output'];
  commentId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  postId: Scalars['String']['output'];
  reactions: Array<Maybe<ReplyReactionDto>>;
  reactionsCount: Scalars['Json']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ReplyPermissionDto = {
  __typename?: 'ReplyPermissionDto';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  canReact: Scalars['Boolean']['output'];
};

export type ReplyReactionDto = {
  __typename?: 'ReplyReactionDto';
  createdAt: Scalars['String']['output'];
  member?: Maybe<MemberDto>;
  memberId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReplyReactionsCollectionDto = {
  __typename?: 'ReplyReactionsCollectionDto';
  reactions: Array<Maybe<ReplyReactionDto>>;
};

export type ReportPostDtoInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RequestEmailChangeDtoInput = {
  email: Scalars['String']['input'];
  isEnterprise: Scalars['Boolean']['input'];
};

export type RequestMobileChangeDtoInput = {
  countryCode: Scalars['String']['input'];
  isEnterprise: Scalars['String']['input'];
  number: Scalars['String']['input'];
};

export enum Role {
  Admin = 'ADMIN',
  Member = 'MEMBER',
}

export enum RoleCategory {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Moderator = 'MODERATOR',
  Visitor = 'VISITOR',
}

export type RoleDto = {
  __typename?: 'RoleDto';
  category: RoleCategory;
  classroomId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** 역할을 지칭하기 위한 수정 가능한 이름 */
  name: Scalars['String']['output'];
  /** 목록내의 정렬순서를 나타냄 */
  position: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SaveAssignmentSubmissionPointsDtoInput = {
  points?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveEssayAnswerPointsToLearningAssignmentDtoInput = {
  pageId: Scalars['Float']['input'];
  points?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveMemberAnswerToLearningAssignmentDtoInput = {
  correctOptions?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  duration: Scalars['Float']['input'];
  essay?: InputMaybe<Scalars['String']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  maxPoints?: InputMaybe<Scalars['Float']['input']>;
  multipleChoiceOption?: InputMaybe<Scalars['Json']['input']>;
  pageId: Scalars['Float']['input'];
  pageIndex: Scalars['Float']['input'];
  pageType: LearningCardPageType;
  textEntry?: InputMaybe<Scalars['String']['input']>;
  userInput?: InputMaybe<Scalars['String']['input']>;
};

export type SavePostAsDraftDtoInput = {
  adminExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isAnnouncement?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type School = {
  __typename?: 'School';
  admissionAge?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  firstGrade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  isCertified?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  monthAcademicYearStartsFrom?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  regularCourseYear?: Maybe<Scalars['Int']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type SchoolCategory = {
  __typename?: 'SchoolCategory';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameLabel?: Maybe<Scalars['String']['output']>;
};

export type SchoolCollection = {
  __typename?: 'SchoolCollection';
  schools?: Maybe<Array<Maybe<School>>>;
};

export type SchoolDto = {
  __typename?: 'SchoolDto';
  /** 입학 연령 */
  admissionAge: Scalars['Float']['output'];
  /** 소속 도시 */
  city: Scalars['String']['output'];
  /** 국가 코드 */
  countryCode: Scalars['String']['output'];
  /** 학교 식별자 */
  id: Scalars['String']['output'];
  /** 학교 이름 */
  name: Scalars['String']['output'];
  /** 교육 과정 년도 */
  regularCourseYear: Scalars['Float']['output'];
  /** 우편변호 */
  zipcode: Scalars['String']['output'];
};

export type SchoolDtoInput = {
  /** 입학 연령 */
  admissionAge: Scalars['Float']['input'];
  /** 소속 도시 */
  city: Scalars['String']['input'];
  /** 국가 코드 */
  countryCode: Scalars['String']['input'];
  /** 학교 식별자 */
  id: Scalars['String']['input'];
  /** 학교 이름 */
  name: Scalars['String']['input'];
  /** 교육 과정 년도 */
  regularCourseYear: Scalars['Float']['input'];
  /** 우편변호 */
  zipcode: Scalars['String']['input'];
};

export enum SchoolGrade {
  Adult = 'ADULT',
  Eighth = 'EIGHTH',
  Eleventh = 'ELEVENTH',
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  HigherEducation = 'HIGHER_EDUCATION',
  Kindergarten = 'KINDERGARTEN',
  Ninth = 'NINTH',
  None = 'NONE',
  PreKindergarten = 'PRE_KINDERGARTEN',
  Second = 'SECOND',
  Seventh = 'SEVENTH',
  Sixth = 'SIXTH',
  Tenth = 'TENTH',
  Third = 'THIRD',
  Twelfth = 'TWELFTH',
}

export type SchoolInfo = {
  __typename?: 'SchoolInfo';
  grade: SchoolGrade;
  school?: Maybe<AccountSchool>;
};

export type SchoolInfo2 = {
  __typename?: 'SchoolInfo2';
  grade: SchoolGrade;
  school?: Maybe<AccountSchool>;
};

export type SchoolInfo3Input = {
  grade: SchoolGrade;
  school?: InputMaybe<SchoolDtoInput>;
};

export type SchoolInfo4 = {
  __typename?: 'SchoolInfo4';
  grade: SchoolGrade;
  school?: Maybe<SchoolDto>;
};

export type SchoolInfoByIdDtoInput = {
  grade: SchoolGrade;
  schoolId: Scalars['String']['input'];
};

export type SchoolInfoByIdInput = {
  grade: SchoolGrade;
  schoolId: Scalars['String']['input'];
};

/** 소속 학교 정보 */
export type SchoolInfoDto = {
  __typename?: 'SchoolInfoDto';
  grade: SchoolGrade;
  school?: Maybe<SchoolDto>;
};

export type SchoolInfoDto2 = {
  __typename?: 'SchoolInfoDto2';
  grade: SchoolGrade;
  school?: Maybe<SchoolDto>;
};

export type SchoolInfoDto2Input = {
  grade: SchoolGrade;
  school?: InputMaybe<SchoolDtoInput>;
};

export type SchoolRegistration = {
  __typename?: 'SchoolRegistration';
  academicYearStartMonth?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  addressDetail?: Maybe<Scalars['String']['output']>;
  admissionAge?: Maybe<Scalars['Int']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  firstGrade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  regularCourseYear?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export enum Scope2 {
  All = 'ALL',
  Joined = 'JOINED',
}

export enum SignInMethod {
  Apple = 'APPLE',
  AuthBridge = 'AUTH_BRIDGE',
  Azure = 'AZURE',
  Email = 'EMAIL',
  Google = 'GOOGLE',
  Id = 'ID',
  Kakao = 'KAKAO',
  Mobile = 'MOBILE',
  Naver = 'NAVER',
  Username = 'USERNAME',
  Whalespace = 'WHALESPACE',
}

export type SimpleAccountDto = {
  __typename?: 'SimpleAccountDto';
  avatarImage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  role: AccountRole;
  username?: Maybe<Scalars['String']['output']>;
};

export type SocialIdentity = {
  __typename?: 'SocialIdentity';
  createdAt?: Maybe<Scalars['String']['output']>;
  /** 소셜 Provider 계정의 소유권을 가진 기관의 식별자 */
  organizationIdentifier?: Maybe<Scalars['String']['output']>;
  provider: OAuthProvider;
  /** 소셜 로그인 Provider 고유 아이디 */
  uid: Scalars['String']['output'];
};

export type StartMeetingDtoInput = {
  classroomId: Scalars['String']['input'];
  receiverId: Scalars['String']['input'];
};

export enum Status {
  Absent = 'ABSENT',
  Attended = 'ATTENDED',
  Excused = 'EXCUSED',
  Unknown = 'UNKNOWN',
}

export enum Status2 {
  Ended = 'ENDED',
  Started = 'STARTED',
  Waiting = 'WAITING',
}

export enum Status3 {
  Created = 'CREATED',
  Drafted = 'DRAFTED',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED',
}

export enum Status4 {
  Drafted = 'DRAFTED',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED',
}

export type StudentRegistrationCodeDto = {
  __typename?: 'StudentRegistrationCodeDto';
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  expireAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  studentAccountId?: Maybe<Scalars['String']['output']>;
  teacherAccountId: Scalars['String']['output'];
  teacherAgreedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SubmissionDto = {
  __typename?: 'SubmissionDto';
  /** 제출물이 제출된 시각 */
  createdAt: Scalars['String']['output'];
  /** 제출물에 첨부된 파일 식별자 목록 */
  fileIds: Array<Maybe<Scalars['String']['output']>>;
  /** 제출물 식별자 */
  id: Scalars['String']['output'];
  /** 제출물에 첨부된 이미지 식별자 목록 */
  imageIds: Array<Maybe<Scalars['String']['output']>>;
  /** 제출물 내용 */
  text: Scalars['String']['output'];
};

export type SubmitSubmissionDtoInput = {
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TagDto = {
  __typename?: 'TagDto';
  classroomId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  postsCount: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export type TaskItemStatus = {
  __typename?: 'TaskItemStatus';
  checked: Scalars['Boolean']['output'];
};

export type TranslatePostDtoInput = {
  targetLanguage: Scalars['String']['input'];
};

export type TranslatedPostDto = {
  __typename?: 'TranslatedPostDto';
  classroomId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  postId: Scalars['String']['output'];
  targetLanguage: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type TranslationPermissionDto = {
  __typename?: 'TranslationPermissionDto';
  canTranslatePost: Scalars['Boolean']['output'];
  memberId: Scalars['String']['output'];
};

export enum Type {
  Announcement = 'ANNOUNCEMENT',
  Child = 'CHILD',
  Guardian = 'GUARDIAN',
  Legacy = 'LEGACY',
  Post = 'POST',
}

export type UnpinPostDtoInput = {
  postId: Scalars['String']['input'];
};

export type UpdateAccountDtoInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender2>;
  grade?: InputMaybe<SchoolGrade>;
  isMarketingTermsAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  marketingAgreement?: InputMaybe<MarketingAgreement2Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  schoolInfo?: InputMaybe<SchoolInfo3Input>;
  schoolInfoById?: InputMaybe<SchoolInfoByIdInput>;
  schoolInfoForChildren?: InputMaybe<Array<InputMaybe<SchoolInfoDto2Input>>>;
};

export type UpdateAssignedAssignmentDtoInput = {
  dueDateTime?: InputMaybe<Scalars['String']['input']>;
  maxPoints?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAssignmentDtoInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  dueDateTime: Scalars['String']['input'];
  maxPoints: Scalars['Float']['input'];
};

export type UpdateAssignmentSubmissionCommentDtoInput = {
  content: Scalars['String']['input'];
};

export type UpdateAutoRecordingSettingDtoInput = {
  agreeAutoRecordingTerms?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRecordingActive: Scalars['Boolean']['input'];
};

export type UpdateChannelDtoInput = {
  autoJoin?: InputMaybe<Scalars['Boolean']['input']>;
  canMemberReactToPost?: InputMaybe<Scalars['Boolean']['input']>;
  canMemberWriteComment?: InputMaybe<Scalars['Boolean']['input']>;
  canMemberWritePost?: InputMaybe<Scalars['Boolean']['input']>;
  channelGroupId?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChannelGroupDtoInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChildSchoolInfoDtoInput = {
  schoolInfoForChildren: Array<InputMaybe<SchoolInfoByIdDtoInput>>;
};

export type UpdateClassroomDtoInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Grade3>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileImageId?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateClasstalkUserDtoInput = {
  callable?: InputMaybe<Scalars['Boolean']['input']>;
  workdays?: InputMaybe<Array<InputMaybe<UpdateClasstalkUserWorkdayDtoInput>>>;
};

export type UpdateClasstalkUserWorkdayDtoInput = {
  available: Scalars['Boolean']['input'];
  day: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type UpdateCommentDtoInput = {
  content: Scalars['String']['input'];
};

export type UpdateMemberDtoInput = {
  group?: InputMaybe<Group>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileImageId?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMemberPushNotificationSettingsDtoInput = {
  announcementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  commentsAndRepliesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  postCommentsAndRepliesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  postReactionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  postsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reactionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePostAdminExclusiveByAdminDtoInput = {
  adminExclusive: Scalars['Boolean']['input'];
};

export type UpdatePostChannelAdminDtoInput = {
  channelId: Scalars['String']['input'];
};

export type UpdatePostDtoInput = {
  adminExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isAnnouncement?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateReplyDtoInput = {
  content: Scalars['String']['input'];
};

export type UpdateTagDtoInput = {
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UrlMetadata = {
  __typename?: 'UrlMetadata';
  author?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  video?: Maybe<Scalars['String']['output']>;
};

export type UserDto = {
  __typename?: 'UserDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Video = {
  __typename?: 'Video';
  categoryId: Scalars['String']['output'];
  categoryType: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  conversionStatus?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalFileName: Scalars['String']['output'];
  posterUrl?: Maybe<Scalars['String']['output']>;
  presignedPost?: Maybe<Scalars['Json']['output']>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  streamUrl?: Maybe<Scalars['String']['output']>;
  totalSize: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
  urls: Scalars['Json']['output'];
  userId: Scalars['String']['output'];
};

export type VideoDto = {
  __typename?: 'VideoDto';
  /** 비디오가 첨부된 상위 리소스 식별자 */
  categoryId: Scalars['String']['output'];
  /** 비디오가 첨부된 상위 리소스 */
  categoryType: Scalars['String']['output'];
  /** 비디오의 MIME 타입 */
  contentType: Scalars['String']['output'];
  /** 비디오의 변환 상태 */
  conversionStatus?: Maybe<Scalars['String']['output']>;
  /** 비디오가 생성된 시각 */
  createdAt: Scalars['String']['output'];
  /** 비디오가 저장된 경로 */
  filePath: Scalars['String']['output'];
  /** 동영상 식별자 */
  id: Scalars['String']['output'];
  /** 비디오의 원본 파일명 */
  originalFileName: Scalars['String']['output'];
  /** 비디오의 썸네일 URL */
  posterUrl?: Maybe<Scalars['String']['output']>;
  /** 비디오의 스트리밍 URL */
  streamUrl?: Maybe<Scalars['String']['output']>;
  /** 비디오의 크기 */
  totalSize: Scalars['Float']['output'];
  /** 비디오가 최근 수정된 시각 */
  updatedAt: Scalars['String']['output'];
  /** 비디오의 다양한 URL 목록 */
  urls: Scalars['Json']['output'];
  /** 동영상을 업로드한 사용자의 식별자 */
  userId: Scalars['String']['output'];
};

export type WorkdayDto = {
  __typename?: 'WorkdayDto';
  available: Scalars['Boolean']['output'];
  day: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type ZoomIntegrationDto = {
  __typename?: 'ZoomIntegrationDto';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  memberId: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UpdatePostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updatePostDtoInput: UpdatePostDtoInput;
}>;

export type UpdatePostMutation = {
  __typename?: 'Mutation';
  post?: {
    __typename?: 'PostDto';
    id: string;
    content?: string | null;
    title?: string | null;
    imageIds: Array<string | null>;
    videoIds: Array<string | null>;
    fileIds: Array<string | null>;
    createdAt: string;
    updatedAt: string;
    channelId?: string | null;
  } | null;
};

export type UpdateClassroomMemberMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  updateMemberDtoInput: UpdateMemberDtoInput;
}>;

export type UpdateClassroomMemberMutation = {
  __typename?: 'Mutation';
  member?: {
    __typename?: 'MemberDto';
    classroomId: string;
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    role: Role;
  } | null;
};

export type CreateImageMutationVariables = Exact<{
  createImageDtoInput: CreateImageDtoInput;
}>;

export type CreateImageMutation = {
  __typename?: 'Mutation';
  image?: {
    __typename?: 'Image';
    id: string;
    userId: string;
    contentType: string;
    categoryId: string;
    categoryType: string;
    totalSize: number;
    originalFileName: string;
    createdAt: string;
    presignedPost?: any | null;
    urls: any;
  } | null;
};

export type CreateFileMutationVariables = Exact<{
  createFileDtoInput: CreateFileDtoInput;
}>;

export type CreateFileMutation = {
  __typename?: 'Mutation';
  file?: {
    __typename?: 'File';
    id: string;
    userId: string;
    contentType: string;
    categoryId: string;
    categoryType: string;
    totalSize: number;
    originalFileName: string;
    createdAt: string;
    presignedPost?: any | null;
    urls: any;
  } | null;
};

export type CreateVideoMutationVariables = Exact<{
  createVideoDtoInput: CreateVideoDtoInput;
}>;

export type CreateVideoMutation = {
  __typename?: 'Mutation';
  video?: {
    __typename?: 'Video';
    id: string;
    userId: string;
    contentType: string;
    categoryId: string;
    categoryType: string;
    totalSize: number;
    originalFileName: string;
    createdAt: string;
    presignedPost?: any | null;
    urls: any;
    resourceKey?: string | null;
    posterUrl?: string | null;
  } | null;
};

export type InviteMembersMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  inviteMembersDtoInput: InviteMembersDtoInput;
}>;

export type InviteMembersMutation = {
  __typename?: 'Mutation';
  inviteMembers?: any | null;
};

export type FetchClassCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type FetchClassCodeQuery = {
  __typename?: 'Query';
  classCode?: {
    __typename?: 'ClassCodeDto';
    classroomId: string;
    code: string;
  } | null;
};

export type FetchPostQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type FetchPostQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    channelId?: string | null;
    classroomId: string;
    id: string;
    content?: string | null;
    title?: string | null;
    tags: Array<string | null>;
    commentsCount: number;
    repliesCount: number;
    createdAt: string;
    updatedAt: string;
    imageIds: Array<string | null>;
    videoIds: Array<string | null>;
    fileIds: Array<string | null>;
    readsCount: number;
    status: Status3;
    reactionsCount: any;
    isAnnouncement: boolean;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
    };
    reactions: Array<{
      __typename?: 'PostReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type CurrentMemberQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type CurrentMemberQuery = {
  __typename?: 'Query';
  currentMember?: {
    __typename?: 'MemberDto';
    classroomId: string;
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    role: Role;
    active: boolean;
    createdAt: string;
    updatedAt: string;
    group?: Group | null;
  } | null;
};

export type FetchUrlMetadataQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;

export type FetchUrlMetadataQuery = {
  __typename?: 'Query';
  urlMetadata?: {
    __typename?: 'UrlMetadata';
    url: string;
    title?: string | null;
    description?: string | null;
    author?: string | null;
    image?: string | null;
    logo?: string | null;
    video?: string | null;
    publisher?: string | null;
  } | null;
};

export type FetchListClassroomsQueryVariables = Exact<{ [key: string]: never }>;

export type FetchListClassroomsQuery = {
  __typename?: 'Query';
  managingClassrooms?: {
    __typename?: 'ClassroomsCollectionDto';
    cursor?: string | null;
    classrooms: Array<{
      __typename?: 'ClassroomDto';
      id: string;
      name: string;
      grade: Grade2;
      about?: string | null;
      schoolYear?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
  } | null;
  joinedClassrooms?: {
    __typename?: 'ClassroomsCollectionDto';
    cursor?: string | null;
    classrooms: Array<{
      __typename?: 'ClassroomDto';
      id: string;
      name: string;
      grade: Grade2;
      about?: string | null;
      schoolYear?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
  } | null;
};

export type ClassroomVersionQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassroomVersionQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    version: number;
  } | null;
};

export type ClassroomFeaturesContextClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  type: ClassroomType;
};

export type ClassroomFeaturesContextClassroomFeaturePreferencesFieldsFragment =
  {
    __typename?: 'ClassroomFeaturePreferencesDto';
    aiTest: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    assignment: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    insights: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    cumulativeRecord: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    jello: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    classtalk: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    memberList: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    classroomSettings: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
  };

export type ClassroomFeaturesContextQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassroomFeaturesContextQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    type: ClassroomType;
  } | null;
  featurePreferences?: {
    __typename?: 'ClassroomFeaturePreferencesDto';
    id: string;
    aiTest: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    assignment: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    insights: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    cumulativeRecord: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    jello: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    classtalk: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    memberList: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
    classroomSettings: {
      __typename?: 'ClassroomFeaturePreferencesOptionDto';
      enabled: boolean;
    };
  } | null;
};

export type GrowthBookProviderQueryVariables = Exact<{ [key: string]: never }>;

export type GrowthBookProviderQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    enterprise?: { __typename?: 'Enterprise'; id: string } | null;
  } | null;
};

export type SeoQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type SeoQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    enterpriseId?: string | null;
  } | null;
};

export type SeoClassCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type SeoClassCodeQuery = {
  __typename?: 'Query';
  classCode?: {
    __typename?: 'ClassCodeDto';
    classroomId: string;
    code: string;
  } | null;
};

export type SeoEnterpriseQueryVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
}>;

export type SeoEnterpriseQuery = {
  __typename?: 'Query';
  enterprise?: {
    __typename?: 'EnterpriseDto';
    id: string;
    isWhiteLabeled: boolean;
    branding: {
      __typename?: 'EnterpriseBranding';
      name?: string | null;
      appIconUrl?: string | null;
    };
  } | null;
};

export type SetupSentryQueryVariables = Exact<{ [key: string]: never }>;

export type SetupSentryQuery = {
  __typename?: 'Query';
  me?: { __typename?: 'AccountDto'; id: string; email?: string | null } | null;
};

export type AdManagerQueryVariables = Exact<{ [key: string]: never }>;

export type AdManagerQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    role: AccountRole;
    isAdFreeSubscribed: boolean;
    schoolInfo?: { __typename?: 'SchoolInfo'; grade: SchoolGrade } | null;
    schoolInfoForChildren: Array<{
      __typename?: 'SchoolInfo2';
      grade: SchoolGrade;
    } | null>;
  } | null;
};

export type TaskItemExtensionQueryVariables = Exact<{ [key: string]: never }>;

export type TaskItemExtensionQuery = {
  __typename?: 'Query';
  me?: { __typename?: 'AccountDto'; id: string } | null;
};

export type TaskItemExtensionStatusQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  taskItemId: Scalars['String']['input'];
}>;

export type TaskItemExtensionStatusQuery = {
  __typename?: 'Query';
  taskItemStatus?: { __typename?: 'TaskItemStatus'; checked: boolean } | null;
};

export type VideoExtensionQueryVariables = Exact<{
  videoId: Scalars['String']['input'];
}>;

export type VideoExtensionQuery = {
  __typename?: 'Query';
  video?: {
    __typename?: 'Video';
    id: string;
    streamUrl?: string | null;
    posterUrl?: string | null;
    conversionStatus?: string | null;
    urls: any;
    originalFileName: string;
  } | null;
};

export type TrackingPixelQueryVariables = Exact<{ [key: string]: never }>;

export type TrackingPixelQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    name?: string | null;
    role: AccountRole;
    profileImage?: string | null;
    countryCode?: string | null;
    language?: string | null;
    email?: string | null;
  } | null;
};

export type SchoolInfoForChildrenFormSchoolInfo2FieldsFragment = {
  __typename?: 'SchoolInfo2';
  grade: SchoolGrade;
  school?: { __typename?: 'AccountSchool'; id: string; name: string } | null;
};

export type SchoolInfoFormSchoolInfoFieldsFragment = {
  __typename?: 'SchoolInfo';
  grade: SchoolGrade;
  school?: { __typename?: 'AccountSchool'; id: string; name: string } | null;
};

export type SchoolInfoFormMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  group?: Group | null;
};

export type UpdateSchoolInfoMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateAccountDtoInput: UpdateAccountDtoInput;
}>;

export type UpdateSchoolInfoMutation = {
  __typename?: 'Mutation';
  account?: {
    __typename?: 'AccountDto';
    id: string;
    name?: string | null;
    schoolInfo?: {
      __typename?: 'SchoolInfo';
      grade: SchoolGrade;
      school?: {
        __typename?: 'AccountSchool';
        id: string;
        name: string;
      } | null;
    } | null;
    schoolInfoForChildren: Array<{
      __typename?: 'SchoolInfo2';
      grade: SchoolGrade;
      school?: {
        __typename?: 'AccountSchool';
        id: string;
        name: string;
      } | null;
    } | null>;
  } | null;
};

export type UpdateSchoolInfoForChildrenMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateChildSchoolInfoDtoInput: UpdateChildSchoolInfoDtoInput;
}>;

export type UpdateSchoolInfoForChildrenMutation = {
  __typename?: 'Mutation';
  updateChildSchoolInfo?: {
    __typename?: 'AccountDto';
    id: string;
    schoolInfoForChildren: Array<{
      __typename?: 'SchoolInfo2';
      grade: SchoolGrade;
      school?: {
        __typename?: 'AccountSchool';
        id: string;
        name: string;
      } | null;
    } | null>;
  } | null;
};

export type UpdateSchoolInfoPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type UpdateSchoolInfoPageQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    schoolInfo?: {
      __typename?: 'SchoolInfo';
      grade: SchoolGrade;
      school?: {
        __typename?: 'AccountSchool';
        id: string;
        name: string;
      } | null;
    } | null;
    schoolInfoForChildren: Array<{
      __typename?: 'SchoolInfo2';
      grade: SchoolGrade;
      school?: {
        __typename?: 'AccountSchool';
        id: string;
        name: string;
      } | null;
    } | null>;
  } | null;
  classroom?: {
    __typename?: 'ClassroomDto';
    grade: Grade2;
    id: string;
    schoolId?: string | null;
    schoolName?: string | null;
  } | null;
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    role: Role;
    group?: Group | null;
  } | null;
};

export type UpdateSchoolInfoPageOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;

export type UpdateSchoolInfoPageOrganizationQuery = {
  __typename?: 'Query';
  organization?: {
    __typename?: 'OrganizationOrganizationDto';
    id: string;
    name: string;
  } | null;
};

export type AdProviderQueryVariables = Exact<{ [key: string]: never }>;

export type AdProviderQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    role: AccountRole;
    grade?: SchoolGrade | null;
    language?: string | null;
    countryCode?: string | null;
    schoolInfoDto?: {
      __typename?: 'SchoolInfoDto';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null;
    schoolInfoDtoForChildren: Array<{
      __typename?: 'SchoolInfoDto2';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null>;
  } | null;
};

export type AiTestHistoryQueryVariables = Exact<{
  classroomId: Scalars['ID']['input'];
}>;

export type AiTestHistoryQuery = {
  __typename?: 'Query';
  latestAiAssignment?: {
    __typename?: 'AiAssignment';
    id?: string | null;
    title?: string | null;
    subTitle?: string | null;
    startAt?: any | null;
    studentsCount?: number | null;
    completedStudentsCount?: number | null;
    isReserved?: boolean | null;
    aiAssignmentType?: string | null;
    subject?: {
      __typename?: 'AiAssignmentSubject';
      id?: number | null;
      name?: string | null;
    } | null;
    units?: Array<{
      __typename?: 'AiAssignmentSubject';
      id?: number | null;
      position?: number | null;
    } | null> | null;
  } | null;
};

export type DistributeAiTestMutationVariables = Exact<{
  input: DistributeAiTestDtoInput;
}>;

export type DistributeAiTestMutation = {
  __typename?: 'Mutation';
  distributeAiTest?: {
    __typename?: 'AiTestCreated';
    id?: number | null;
  } | null;
};

export type CompleteDistributeAiTestChecklistMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type CompleteDistributeAiTestChecklistMutation = {
  __typename?: 'Mutation';
  completeOnboardingChecklistAction?: {
    __typename?: 'OnboardingChecklistDto';
    id: string;
  } | null;
};

export type AiTestPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AiTestPageQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; grade: Grade2 } | null;
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    role: Role;
    group?: Group | null;
  } | null;
};

export type AssignmentFormPostDtoFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  title?: string | null;
  content?: string | null;
  channelId?: string | null;
  status: Status3;
  authorId: string;
};

export type AssignmentFormAssignmentDtoFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  postId: string;
  dueDateTime?: string | null;
  maxPoints: number;
  assigneeIds?: Array<string | null> | null;
  type: AssignmentType;
};

export type AssignmentFormQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type AssignmentFormQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    isPrivate: boolean;
  } | null;
  channelGroups?: Array<{
    __typename?: 'ChannelGroupDto';
    name: string;
    id: string;
    channels: Array<{
      __typename?: 'ChannelDto';
      id: string;
      name: string;
      archived: boolean;
      canMemberWritePost: boolean;
      isPrivate: boolean;
      canMemberWriteComment: boolean;
      canMemberReactToPost: boolean;
    } | null>;
  } | null> | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type ChannelAssigneeListMemberDtoFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  name?: string | null;
  role: Role;
  group?: Group | null;
  profileImageUrl?: string | null;
  active: boolean;
  blocked: boolean;
};

export type ChannelAssigneeListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type ChannelAssigneeListQuery = {
  __typename?: 'Query';
  assignedMemberList?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    role: Role;
    group?: Group | null;
    profileImageUrl?: string | null;
    active: boolean;
    blocked: boolean;
  } | null> | null;
};

export type ChannelSelectDrawerMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  name?: string | null;
  role: Role;
  group?: Group | null;
  profileImageUrl?: string | null;
};

export type ChannelSelectDrawerChannelMemberListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type ChannelSelectDrawerChannelMemberListQuery = {
  __typename?: 'Query';
  channelMembers?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    role: Role;
    group?: Group | null;
    profileImageUrl?: string | null;
  } | null> | null;
};

export type ChannelSelectDrawerCurrentMemberQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ChannelSelectDrawerCurrentMemberQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type AssignmentInfoAssignmentDtoFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  assigneeIds?: Array<string | null> | null;
  assigneesCount: number;
  authorId: string;
  channelId?: string | null;
  classroomId: string;
  createdAt: string;
  dueDateTime?: string | null;
  maxPoints: number;
  membersSubmittedCount: number;
  postId: string;
  updatedAt: string;
  type: AssignmentType;
  meta?: any | null;
};

export type AssignmentInfoQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type AssignmentInfoQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    assigneeIds?: Array<string | null> | null;
    assigneesCount: number;
    authorId: string;
    channelId?: string | null;
    classroomId: string;
    createdAt: string;
    dueDateTime?: string | null;
    maxPoints: number;
    membersSubmittedCount: number;
    postId: string;
    updatedAt: string;
    type: AssignmentType;
    meta?: any | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type AssignmentInfoForAssigneeAssignmentSubmissionDtoFieldsFragment = {
  __typename?: 'AssignmentSubmissionDto';
  id: string;
  assignmentId: string;
  assigneeId: string;
  classroomId: string;
  points?: number | null;
  isSubmitted: boolean;
  status: AssignmentSubmissionStatus;
  gradingStatus: GradingStatus;
  createdAt: string;
  updatedAt: string;
  commentsCount?: number | null;
  repliesCount?: number | null;
  submissions: Array<{
    __typename?: 'SubmissionDto';
    id: string;
    text: string;
    fileIds: Array<string | null>;
    imageIds: Array<string | null>;
    createdAt: string;
  } | null>;
  learningSubmission?: {
    __typename?: 'LearningSubmissionDto';
    id: string;
    createdAt: string;
  } | null;
  lastSubmission?: {
    __typename?: 'SubmissionDto';
    id: string;
    text: string;
    fileIds: Array<string | null>;
    imageIds: Array<string | null>;
    createdAt: string;
  } | null;
};

export type AssignmentInfoForAssigneeSubmissionDtoFieldsFragment = {
  __typename?: 'SubmissionDto';
  id: string;
  text: string;
  fileIds: Array<string | null>;
  imageIds: Array<string | null>;
  createdAt: string;
};

export type AssignmentInfoForAssigneeLearningSubmissionDtoFieldsFragment = {
  __typename?: 'LearningSubmissionDto';
  id: string;
  createdAt: string;
};

export type SubmitSubmissionMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  submitSubmissionDtoInput: SubmitSubmissionDtoInput;
}>;

export type SubmitSubmissionMutation = {
  __typename?: 'Mutation';
  submitSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assignmentId: string;
    assigneeId: string;
    classroomId: string;
    points?: number | null;
    isSubmitted: boolean;
    status: AssignmentSubmissionStatus;
    gradingStatus: GradingStatus;
    createdAt: string;
    updatedAt: string;
    commentsCount?: number | null;
    repliesCount?: number | null;
    submissions: Array<{
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null>;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
      createdAt: string;
    } | null;
    lastSubmission?: {
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null;
  } | null;
};

export type AssignmentInfoForAssigneeQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type AssignmentInfoForAssigneeQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  permission?: {
    __typename?: 'AssignmentPermissionDto';
    canSubmit: boolean;
  } | null;
};

export type AssignmentInfoForAssigneeAssignmentSubmissionQueryVariables =
  Exact<{
    classroomId: Scalars['String']['input'];
    assignmentId: Scalars['String']['input'];
    assigneeId: Scalars['String']['input'];
  }>;

export type AssignmentInfoForAssigneeAssignmentSubmissionQuery = {
  __typename?: 'Query';
  assignmentSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assignmentId: string;
    assigneeId: string;
    classroomId: string;
    points?: number | null;
    isSubmitted: boolean;
    status: AssignmentSubmissionStatus;
    gradingStatus: GradingStatus;
    createdAt: string;
    updatedAt: string;
    commentsCount?: number | null;
    repliesCount?: number | null;
    submissions: Array<{
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null>;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
      createdAt: string;
    } | null;
    lastSubmission?: {
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null;
  } | null;
};

export type AssignmentInfoForGraderQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type AssignmentInfoForGraderQuery = {
  __typename?: 'Query';
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type AssignmentInfoForGraderAssignmentSubmissionsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type AssignmentInfoForGraderAssignmentSubmissionsQuery = {
  __typename?: 'Query';
  assignmentSubmissions?: Array<{
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assignmentId: string;
    assigneeId: string;
    classroomId: string;
    status: AssignmentSubmissionStatus;
    points?: number | null;
    createdAt: string;
    updatedAt: string;
    gradingStatus: GradingStatus;
  } | null> | null;
};

export type AssignmentItemPostQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type AssignmentItemPostQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    classroomId: string;
    channelId?: string | null;
    isAnnouncement: boolean;
    summary?: string | null;
    coverImageUrl?: string | null;
    tags: Array<string | null>;
    type: PostType;
    assignmentId?: string | null;
    fileIds: Array<string | null>;
    publishedAt?: string | null;
    commentsCount: number;
    reactionsCount: any;
    title?: string | null;
    adminExclusive: boolean;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      blocked: boolean;
    };
  } | null;
};

export type AssignmentItemAssignmentQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type AssignmentItemAssignmentQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    postId: string;
    dueDateTime?: string | null;
    classroomId: string;
    assigneesCount: number;
    membersSubmittedCount: number;
    type: AssignmentType;
  } | null;
};

export type AssignmentListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AssignmentListQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type MemberAssignmentListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
}>;

export type MemberAssignmentListQuery = {
  __typename?: 'Query';
  assignmentsCollection?: {
    __typename?: 'AssignmentsSearchCollectionDto';
    page?: number | null;
    perPage?: number | null;
    totalPages?: number | null;
    assignments: Array<{
      __typename?: 'AssignmentDto';
      id: string;
      postId: string;
      dueDateTime?: string | null;
      classroomId: string;
      assigneesCount: number;
      membersSubmittedCount: number;
      type: AssignmentType;
    } | null>;
  } | null;
};

export type ClassroomAssignmentListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
}>;

export type ClassroomAssignmentListQuery = {
  __typename?: 'Query';
  assignmentsCollection?: {
    __typename?: 'AssignmentsSearchCollectionDto';
    page?: number | null;
    perPage?: number | null;
    totalPages?: number | null;
    assignments: Array<{
      __typename?: 'AssignmentDto';
      id: string;
      postId: string;
      dueDateTime?: string | null;
      classroomId: string;
      assigneesCount: number;
      membersSubmittedCount: number;
      type: AssignmentType;
    } | null>;
  } | null;
};

export type AssignmentListPageHeaderQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AssignmentListPageHeaderQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    countryCode?: string | null;
  } | null;
};

export type AssignmentSubmissionCommentItemAssignmentSubmissionCommentFieldsFragment =
  {
    __typename?: 'AssignmentSubmissionCommentDto';
    id: string;
    assigneeId: string;
    assignmentId: string;
    classroomId: string;
    content: string;
    createdAt: string;
    updatedAt: string;
    repliesCount: number;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      role: Role;
    };
  };

export type DeleteAssignmentSubmissionCommentMutationVariables = Exact<{
  assignmentSubmissionId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
}>;

export type DeleteAssignmentSubmissionCommentMutation = {
  __typename?: 'Mutation';
  deleteAssignmentSubmissionComment?: any | null;
};

export type UpdateAssignmentSubmissionCommentMutationVariables = Exact<{
  assignmentSubmissionId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  updateAssignmentSubmissionCommentDtoInput: UpdateAssignmentSubmissionCommentDtoInput;
}>;

export type UpdateAssignmentSubmissionCommentMutation = {
  __typename?: 'Mutation';
  comment?: {
    __typename?: 'AssignmentSubmissionCommentDto';
    id: string;
    content: string;
  } | null;
};

export type AssignmentSubmissionCommentItemQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentSubmissionId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
}>;

export type AssignmentSubmissionCommentItemQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string } | null;
  commentPermission?: {
    __typename?: 'AssignmentSubmissionCommentPermissionDto';
    canDelete: boolean;
    canEdit: boolean;
  } | null;
};

export type AssignmentSubmissionCommentListCurrentMemberQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AssignmentSubmissionCommentListCurrentMemberQuery = {
  __typename?: 'Query';
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    group?: Group | null;
  } | null;
};

export type AssignmentSubmissionCommentListQueryVariables = Exact<{
  assignmentSubmissionId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type AssignmentSubmissionCommentListQuery = {
  __typename?: 'Query';
  assignmentSubmissionCommentsCollection?: {
    __typename?: 'AssignmentSubmissionCommentsCollectionDto';
    cursor?: string | null;
    assignmentSubmissionComments: Array<{
      __typename?: 'AssignmentSubmissionCommentDto';
      id: string;
      assigneeId: string;
      assignmentId: string;
      classroomId: string;
      content: string;
      createdAt: string;
      updatedAt: string;
      repliesCount: number;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        role: Role;
      };
    } | null>;
  } | null;
};

export type CompleteAssignmentSubmissionMutationVariables = Exact<{
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  completeAssignmentSubmissionDtoInput: CompleteAssignmentSubmissionDtoInput;
}>;

export type CompleteAssignmentSubmissionMutation = {
  __typename?: 'Mutation';
  completeAssignmentSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assigneeId: string;
    assignmentId: string;
    points?: number | null;
    createdAt: string;
    gradingStatus: GradingStatus;
    status: AssignmentSubmissionStatus;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        pageType: LearningCardPageType;
        points: number;
      } | null>;
    } | null;
  } | null;
};

export type SaveAssignmentSubmissionPointsMutationVariables = Exact<{
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  assigneeId: Scalars['String']['input'];
  saveAssignmentSubmissionPointsDtoInput: SaveAssignmentSubmissionPointsDtoInput;
}>;

export type SaveAssignmentSubmissionPointsMutation = {
  __typename?: 'Mutation';
  saveAssignmentSubmissionPoints?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assigneeId: string;
    assignmentId: string;
    points?: number | null;
    createdAt: string;
    gradingStatus: GradingStatus;
    status: AssignmentSubmissionStatus;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        pageType: LearningCardPageType;
        points: number;
      } | null>;
    } | null;
  } | null;
};

export type AssignmentSubmissionNavItemQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;

export type AssignmentSubmissionNavItemQuery = {
  __typename?: 'Query';
  member?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
  } | null;
};

export type AssignmentSubmissionNavItemAssignmentSubmissionDtoFieldsFragment = {
  __typename?: 'AssignmentSubmissionDto';
  id: string;
  assigneeId: string;
  assignmentId: string;
  points?: number | null;
  createdAt: string;
  gradingStatus: GradingStatus;
  status: AssignmentSubmissionStatus;
  learningSubmission?: {
    __typename?: 'LearningSubmissionDto';
    answers: Array<{
      __typename?: 'LearningUserAnswerDto';
      pageType: LearningCardPageType;
      points: number;
    } | null>;
  } | null;
};

export type AssignmentSubmissionNavItemAssignmentDtoFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  maxPoints: number;
  dueDateTime?: string | null;
  type: AssignmentType;
};

export type CompleteAllAssignmentSubmissionMutationVariables = Exact<{
  assignmentId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
}>;

export type CompleteAllAssignmentSubmissionMutation = {
  __typename?: 'Mutation';
  completeAllAssignmentSubmission?: Array<{
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    gradingStatus: GradingStatus;
  } | null> | null;
};

export type CommunityLearningCardListQueryVariables = Exact<{
  coreConceptId?: InputMaybe<Scalars['String']['input']>;
  gradeId?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['Float']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
  shareLevel?: InputMaybe<Scalars['Float']['input']>;
  subjectId?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['Float']['input']>;
}>;

export type CommunityLearningCardListQuery = {
  __typename?: 'Query';
  learningCardCollection?: {
    __typename?: 'LearningCardCollection';
    offset?: number | null;
    limit?: number | null;
    learningCards?: Array<{
      __typename?: 'LearningCard';
      id?: string | null;
      title?: string | null;
      authorName?: string | null;
      chapterName?: string | null;
      pageCount?: number | null;
      quizCount?: number | null;
      coverImageSmall?: string | null;
      coverImageLarge?: string | null;
      storeCardId?: number | null;
      shareLevel?: number | null;
      grade?: {
        __typename?: 'LearningCardGrade';
        id?: number | null;
        name?: string | null;
      } | null;
      subject?: {
        __typename?: 'LearningCardSubject';
        id?: number | null;
        name?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type EditableLearningCardLearningCardFieldsFragment = {
  __typename?: 'LearningCard';
  id?: string | null;
  maxPoints?: number | null;
};

export type EditableLearningCardMyLearningCardQueryVariables = Exact<{
  learningCardId: Scalars['Float']['input'];
}>;

export type EditableLearningCardMyLearningCardQuery = {
  __typename?: 'Query';
  learningCard?: {
    __typename?: 'LearningCard';
    id?: string | null;
    maxPoints?: number | null;
  } | null;
};

export type SubmitLearningCardAnswerMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type SubmitLearningCardAnswerMutation = {
  __typename?: 'Mutation';
  assignmentSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assigneeId: string;
    status: AssignmentSubmissionStatus;
    gradingStatus: GradingStatus;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
    } | null;
  } | null;
};

export type LearningCardExtensionLearningCardFieldsFragment = {
  __typename?: 'LearningCard';
  id?: string | null;
  title?: string | null;
  authorName?: string | null;
  chapterName?: string | null;
  pageCount?: number | null;
  quizCount?: number | null;
  coverImageSmall?: string | null;
  coverImageLarge?: string | null;
  storeCardId?: number | null;
  shareLevel?: number | null;
  maxPoints?: number | null;
  grade?: {
    __typename?: 'LearningCardGrade';
    id?: number | null;
    name?: string | null;
  } | null;
  subject?: {
    __typename?: 'LearningCardSubject';
    id?: number | null;
    name?: string | null;
  } | null;
};

export type LearningCardExtensionLearningStoreCardQueryVariables = Exact<{
  learningStoreCardId: Scalars['Float']['input'];
}>;

export type LearningCardExtensionLearningStoreCardQuery = {
  __typename?: 'Query';
  learningCard?: {
    __typename?: 'LearningCard';
    id?: string | null;
    title?: string | null;
    authorName?: string | null;
    chapterName?: string | null;
    pageCount?: number | null;
    quizCount?: number | null;
    coverImageSmall?: string | null;
    coverImageLarge?: string | null;
    storeCardId?: number | null;
    shareLevel?: number | null;
    maxPoints?: number | null;
    grade?: {
      __typename?: 'LearningCardGrade';
      id?: number | null;
      name?: string | null;
    } | null;
    subject?: {
      __typename?: 'LearningCardSubject';
      id?: number | null;
      name?: string | null;
    } | null;
  } | null;
};

export type LearningCardExtensionLearningCardQueryVariables = Exact<{
  learningCardId: Scalars['Float']['input'];
}>;

export type LearningCardExtensionLearningCardQuery = {
  __typename?: 'Query';
  learningCard?: {
    __typename?: 'LearningCard';
    id?: string | null;
    title?: string | null;
    authorName?: string | null;
    chapterName?: string | null;
    pageCount?: number | null;
    quizCount?: number | null;
    coverImageSmall?: string | null;
    coverImageLarge?: string | null;
    storeCardId?: number | null;
    shareLevel?: number | null;
    maxPoints?: number | null;
    grade?: {
      __typename?: 'LearningCardGrade';
      id?: number | null;
      name?: string | null;
    } | null;
    subject?: {
      __typename?: 'LearningCardSubject';
      id?: number | null;
      name?: string | null;
    } | null;
  } | null;
};

export type LearningCardFilterQueryVariables = Exact<{ [key: string]: never }>;

export type LearningCardFilterQuery = {
  __typename?: 'Query';
  grades?: Array<{
    __typename?: 'LearningGrade';
    id?: number | null;
    name?: string | null;
    schoolYear?: number | null;
  } | null> | null;
  subjects?: Array<{
    __typename?: 'LearningSubject';
    id?: number | null;
    name?: string | null;
    gradeLowerBound?: number | null;
    gradeUpperBound?: number | null;
  } | null> | null;
};

export type LearningCardFilterUnitsQueryVariables = Exact<{
  gradeId: Scalars['ID']['input'];
  subjectId: Scalars['ID']['input'];
}>;

export type LearningCardFilterUnitsQuery = {
  __typename?: 'Query';
  units?: Array<{
    __typename?: 'LearningUnit';
    id?: number | null;
    name?: string | null;
  } | null> | null;
};

export type LearningCardItemLearningCardFieldsFragment = {
  __typename?: 'LearningCard';
  id?: string | null;
  title?: string | null;
  authorName?: string | null;
  chapterName?: string | null;
  pageCount?: number | null;
  quizCount?: number | null;
  coverImageSmall?: string | null;
  coverImageLarge?: string | null;
  storeCardId?: number | null;
  shareLevel?: number | null;
  grade?: {
    __typename?: 'LearningCardGrade';
    id?: number | null;
    name?: string | null;
  } | null;
  subject?: {
    __typename?: 'LearningCardSubject';
    id?: number | null;
    name?: string | null;
  } | null;
};

export type LearningCardPreviewPopupLearningStoreCardQueryVariables = Exact<{
  learningStoreCardId: Scalars['Float']['input'];
}>;

export type LearningCardPreviewPopupLearningStoreCardQuery = {
  __typename?: 'Query';
  learningCard?: {
    __typename?: 'LearningCard';
    id?: string | null;
    title?: string | null;
    pageCount?: number | null;
    copyId?: number | null;
  } | null;
};

export type LearningCardPreviewPopupMyLearningCardQueryVariables = Exact<{
  learningCardId: Scalars['Float']['input'];
}>;

export type LearningCardPreviewPopupMyLearningCardQuery = {
  __typename?: 'Query';
  learningCard?: {
    __typename?: 'LearningCard';
    id?: string | null;
    title?: string | null;
    pageCount?: number | null;
  } | null;
};

export type LearningCardViewModeQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type LearningCardViewModeQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    assignmentId?: string | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type LearningCardViewModeAssignmentQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type LearningCardViewModeAssignmentQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    assigneeIds?: Array<string | null> | null;
  } | null;
};

export type LearningCardViewModeAssignmentSubmissionQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  assigneeId: Scalars['String']['input'];
}>;

export type LearningCardViewModeAssignmentSubmissionQuery = {
  __typename?: 'Query';
  assignmentSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    isSubmitted: boolean;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
    } | null;
  } | null;
};

export type LearningCardViewerIframeLearningUserAnswerDtoFieldsFragment = {
  __typename?: 'LearningUserAnswerDto';
  essay?: string | null;
  textEntry?: string | null;
  multipleChoiceOption?: any | null;
  pageIndex: number;
  pageId: number;
  duration: number;
  isCorrect?: boolean | null;
  pageType: LearningCardPageType;
};

export type SavePageResultMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  saveMemberAnswerToLearningAssignmentDtoInput: SaveMemberAnswerToLearningAssignmentDtoInput;
}>;

export type SavePageResultMutation = {
  __typename?: 'Mutation';
  saveMemberAnswerToLearningAssignment?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
  } | null;
};

export type LearningCardViewerIframeQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  assigneeId: Scalars['String']['input'];
}>;

export type LearningCardViewerIframeQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    assigneeIds?: Array<string | null> | null;
    meta?: any | null;
    type: AssignmentType;
  } | null;
  assignmentSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    isSubmitted: boolean;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        essay?: string | null;
        textEntry?: string | null;
        multipleChoiceOption?: any | null;
        pageIndex: number;
        pageId: number;
        duration: number;
        isCorrect?: boolean | null;
        pageType: LearningCardPageType;
      } | null>;
    } | null;
  } | null;
};

export type LearningSubmissionContentQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;

export type LearningSubmissionContentQuery = {
  __typename?: 'Query';
  member?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type EssayUserAnswerItemQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type EssayUserAnswerItemQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type LearningSubmissionUserAnswerItemLearningUserAnswerDtoFieldsFragment =
  {
    __typename?: 'LearningUserAnswerDto';
    userInput: string;
    duration: number;
    isCorrect?: boolean | null;
    pageType: LearningCardPageType;
    pageId: number;
    multipleChoiceOption?: any | null;
    textEntry?: string | null;
    essay?: string | null;
    pageIndex: number;
    maxPoints: number;
    points: number;
    correctOptions?: Array<any | null> | null;
  };

export type SaveEssayAnswerPointsMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assigneeId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  saveEssayAnswerPoints: SaveEssayAnswerPointsToLearningAssignmentDtoInput;
}>;

export type SaveEssayAnswerPointsMutation = {
  __typename?: 'Mutation';
  saveEssayAnswerPointsToLearningAssignment?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        userInput: string;
        duration: number;
        isCorrect?: boolean | null;
        pageType: LearningCardPageType;
        pageId: number;
        multipleChoiceOption?: any | null;
        textEntry?: string | null;
        essay?: string | null;
        pageIndex: number;
        maxPoints: number;
        points: number;
        correctOptions?: Array<any | null> | null;
      } | null>;
    } | null;
  } | null;
};

export type MyLearningCardListQueryVariables = Exact<{
  coreConceptId?: InputMaybe<Scalars['String']['input']>;
  gradeId?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['Float']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
  shareLevel?: InputMaybe<Scalars['Float']['input']>;
  subjectId?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['Float']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type MyLearningCardListQuery = {
  __typename?: 'Query';
  learningCardCollection?: {
    __typename?: 'LearningCardCollection';
    offset?: number | null;
    limit?: number | null;
    learningCards?: Array<{
      __typename?: 'LearningCard';
      id?: string | null;
      title?: string | null;
      authorName?: string | null;
      chapterName?: string | null;
      pageCount?: number | null;
      quizCount?: number | null;
      coverImageSmall?: string | null;
      coverImageLarge?: string | null;
      storeCardId?: number | null;
      shareLevel?: number | null;
      grade?: {
        __typename?: 'LearningCardGrade';
        id?: number | null;
        name?: string | null;
      } | null;
      subject?: {
        __typename?: 'LearningCardSubject';
        id?: number | null;
        name?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type MyLearningCardListCurrentMemberQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type MyLearningCardListCurrentMemberQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type PostFeedAssignmentItemPostQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PostFeedAssignmentItemPostQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    classroomId: string;
    channelId?: string | null;
    isAnnouncement: boolean;
    summary?: string | null;
    content?: string | null;
    coverImageUrl?: string | null;
    tags: Array<string | null>;
    type: PostType;
    fileIds: Array<string | null>;
    publishedAt?: string | null;
    readsCount: number;
    commentsCount: number;
    reactionsCount: any;
    title?: string | null;
    adminExclusive: boolean;
    assignmentId?: string | null;
    isPinned: boolean;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      blocked: boolean;
    };
  } | null;
};

export type PostFeedAssignmentItemAssignmentQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type PostFeedAssignmentItemAssignmentQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    postId: string;
    dueDateTime?: string | null;
    classroomId: string;
    assigneesCount: number;
    membersSubmittedCount: number;
    type: AssignmentType;
  } | null;
};

export type PostFeedAssignmentListAccountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PostFeedAssignmentListAccountQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    role: AccountRole;
    isAdFreeSubscribed: boolean;
    grade?: SchoolGrade | null;
    language?: string | null;
    countryCode?: string | null;
    schoolInfoDto?: {
      __typename?: 'SchoolInfoDto';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null;
    schoolInfoDtoForChildren: Array<{
      __typename?: 'SchoolInfoDto2';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null>;
  } | null;
};

export type SchoolLearningCardListQueryVariables = Exact<{
  coreConceptId?: InputMaybe<Scalars['String']['input']>;
  gradeId?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['Float']['input']>;
  schoolId: Scalars['String']['input'];
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
  shareLevel?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['Float']['input']>;
}>;

export type SchoolLearningCardListQuery = {
  __typename?: 'Query';
  learningCardCollection?: {
    __typename?: 'LearningCardCollection';
    offset?: number | null;
    limit?: number | null;
    learningCards?: Array<{
      __typename?: 'LearningCard';
      id?: string | null;
      title?: string | null;
      authorName?: string | null;
      chapterName?: string | null;
      pageCount?: number | null;
      quizCount?: number | null;
      coverImageSmall?: string | null;
      coverImageLarge?: string | null;
      storeCardId?: number | null;
      shareLevel?: number | null;
      grade?: {
        __typename?: 'LearningCardGrade';
        id?: number | null;
        name?: string | null;
      } | null;
      subject?: {
        __typename?: 'LearningCardSubject';
        id?: number | null;
        name?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type SchoolLearningCardListMeQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SchoolLearningCardListMeQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    schoolInfo?: {
      __typename?: 'SchoolInfo';
      school?: { __typename?: 'AccountSchool'; id: string } | null;
    } | null;
  } | null;
};

export type SubmissionContentSubmissionDtoFieldsFragment = {
  __typename?: 'SubmissionDto';
  id: string;
  text: string;
  fileIds: Array<string | null>;
  imageIds: Array<string | null>;
  createdAt: string;
};

export type SubmissionContentAssignmentSubmissionDtoFieldsFragment = {
  __typename?: 'AssignmentSubmissionDto';
  id: string;
  createdAt: string;
  assigneeId: string;
  assignmentId: string;
  points?: number | null;
  gradingStatus: GradingStatus;
  commentsCount?: number | null;
  submissions: Array<{
    __typename?: 'SubmissionDto';
    id: string;
    text: string;
    fileIds: Array<string | null>;
    imageIds: Array<string | null>;
    createdAt: string;
  } | null>;
  learningSubmission?: {
    __typename?: 'LearningSubmissionDto';
    id: string;
    createdAt: string;
    updatedAt: string;
    answers: Array<{
      __typename?: 'LearningUserAnswerDto';
      userInput: string;
      duration: number;
      isCorrect?: boolean | null;
      pageType: LearningCardPageType;
      pageId: number;
      multipleChoiceOption?: any | null;
      textEntry?: string | null;
      essay?: string | null;
      pageIndex: number;
      maxPoints: number;
      points: number;
      correctOptions?: Array<any | null> | null;
    } | null>;
  } | null;
  lastSubmission?: {
    __typename?: 'SubmissionDto';
    id: string;
    text: string;
    fileIds: Array<string | null>;
    imageIds: Array<string | null>;
    createdAt: string;
  } | null;
};

export type SubmissionContentAssignmentDtoFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  dueDateTime?: string | null;
  maxPoints: number;
  type: AssignmentType;
};

export type SubmissionContentQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;

export type SubmissionContentQuery = {
  __typename?: 'Query';
  member?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type SubmissionMediaFileQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;

export type SubmissionMediaFileQuery = {
  __typename?: 'Query';
  file?: {
    __typename?: 'File';
    id: string;
    originalFileName: string;
    totalSize: number;
    urls: any;
  } | null;
};

export type SubmissionMediaImageQueryVariables = Exact<{
  imageId: Scalars['String']['input'];
}>;

export type SubmissionMediaImageQuery = {
  __typename?: 'Query';
  image?: { __typename?: 'Image'; id: string; urls: any } | null;
};

export type CreateAssignmentSubmissionCommentMutationVariables = Exact<{
  assignmentSubmissionId: Scalars['String']['input'];
  createAssignmentSubmissionCommentDtoInput: CreateAssignmentSubmissionCommentDtoInput;
}>;

export type CreateAssignmentSubmissionCommentMutation = {
  __typename?: 'Mutation';
  comment?: {
    __typename?: 'AssignmentSubmissionCommentDto';
    id: string;
    assigneeId: string;
    assignmentId: string;
    classroomId: string;
    content: string;
    createdAt: string;
    updatedAt: string;
    repliesCount: number;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      role: Role;
    };
  } | null;
};

export type AssignmentListPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AssignmentListPageQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    countryCode?: string | null;
    isAdFreeSubscribed: boolean;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type AssignmentReportAssignmentDtoFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  assigneesCount: number;
  assigneeIds?: Array<string | null> | null;
  channelId?: string | null;
  classroomId: string;
  createdAt: string;
  dueDateTime?: string | null;
  maxPoints: number;
  membersSubmittedCount: number;
  postId: string;
  updatedAt: string;
  type: AssignmentType;
  assignmentSubmissions: Array<{
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assignmentId: string;
    assigneeId: string;
    classroomId: string;
    points?: number | null;
    status: AssignmentSubmissionStatus;
    gradingStatus: GradingStatus;
    isSubmitted: boolean;
    createdAt: string;
    updatedAt: string;
    lastSubmission?: {
      __typename?: 'SubmissionDto';
      id: string;
      createdAt: string;
    } | null;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        pageType: LearningCardPageType;
        pageId: number;
      } | null>;
    } | null;
  } | null>;
};

export type AssignmentReportMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  profileImageUrl?: string | null;
  active: boolean;
  name?: string | null;
  role: Role;
};

export type AssignmentReportAssignmentSubmissionDtoFieldsFragment = {
  __typename?: 'AssignmentSubmissionDto';
  id: string;
  assignmentId: string;
  assigneeId: string;
  classroomId: string;
  points?: number | null;
  status: AssignmentSubmissionStatus;
  gradingStatus: GradingStatus;
  isSubmitted: boolean;
  createdAt: string;
  updatedAt: string;
  lastSubmission?: {
    __typename?: 'SubmissionDto';
    id: string;
    createdAt: string;
  } | null;
  learningSubmission?: {
    __typename?: 'LearningSubmissionDto';
    id: string;
    answers: Array<{
      __typename?: 'LearningUserAnswerDto';
      pageType: LearningCardPageType;
      pageId: number;
    } | null>;
  } | null;
};

export type AssignmentReportPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  title?: string | null;
  assignmentId?: string | null;
};

export type AssignmentReportPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AssignmentReportPageQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
  classroomMembers?: {
    __typename?: 'MembersCollectionDto';
    members: Array<{
      __typename?: 'MemberDto';
      id: string;
      profileImageUrl?: string | null;
      active: boolean;
      name?: string | null;
      role: Role;
    } | null>;
  } | null;
};

export type AssignmentReportAssignmentListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
}>;

export type AssignmentReportAssignmentListQuery = {
  __typename?: 'Query';
  classroomAssignments?: {
    __typename?: 'AssignmentsSearchCollectionDto';
    assignments: Array<{ __typename?: 'AssignmentDto'; id: string } | null>;
  } | null;
};

export type AssignmentReportAssigneeAssignmentSubmissionQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  assigneeId: Scalars['String']['input'];
}>;

export type AssignmentReportAssigneeAssignmentSubmissionQuery = {
  __typename?: 'Query';
  assignmentSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assignmentId: string;
    assigneeId: string;
    classroomId: string;
    points?: number | null;
    status: AssignmentSubmissionStatus;
    gradingStatus: GradingStatus;
    isSubmitted: boolean;
    createdAt: string;
    updatedAt: string;
    lastSubmission?: {
      __typename?: 'SubmissionDto';
      id: string;
      createdAt: string;
    } | null;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        pageType: LearningCardPageType;
        pageId: number;
      } | null>;
    } | null;
  } | null;
};

export type AssignmentReportPostQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type AssignmentReportPostQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    assignmentId?: string | null;
  } | null;
};

export type AssignmentReportAssignmentQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type AssignmentReportAssignmentQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    assigneesCount: number;
    assigneeIds?: Array<string | null> | null;
    channelId?: string | null;
    classroomId: string;
    createdAt: string;
    dueDateTime?: string | null;
    maxPoints: number;
    membersSubmittedCount: number;
    postId: string;
    updatedAt: string;
    type: AssignmentType;
    assignmentSubmissions: Array<{
      __typename?: 'AssignmentSubmissionDto';
      id: string;
      assignmentId: string;
      assigneeId: string;
      classroomId: string;
      points?: number | null;
      status: AssignmentSubmissionStatus;
      gradingStatus: GradingStatus;
      isSubmitted: boolean;
      createdAt: string;
      updatedAt: string;
      lastSubmission?: {
        __typename?: 'SubmissionDto';
        id: string;
        createdAt: string;
      } | null;
      learningSubmission?: {
        __typename?: 'LearningSubmissionDto';
        id: string;
        answers: Array<{
          __typename?: 'LearningUserAnswerDto';
          pageType: LearningCardPageType;
          pageId: number;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type AssignmentSubmissionPageAssignmentSubmissionDtoFieldsFragment = {
  __typename?: 'AssignmentSubmissionDto';
  id: string;
  assigneeId: string;
  assignmentId: string;
  points?: number | null;
  createdAt: string;
  gradingStatus: GradingStatus;
  status: AssignmentSubmissionStatus;
  commentsCount?: number | null;
  learningSubmission?: {
    __typename?: 'LearningSubmissionDto';
    id: string;
    createdAt: string;
    updatedAt: string;
    answers: Array<{
      __typename?: 'LearningUserAnswerDto';
      pageType: LearningCardPageType;
      points: number;
      userInput: string;
      duration: number;
      isCorrect?: boolean | null;
      pageId: number;
      multipleChoiceOption?: any | null;
      textEntry?: string | null;
      essay?: string | null;
      pageIndex: number;
      maxPoints: number;
      correctOptions?: Array<any | null> | null;
    } | null>;
  } | null;
  submissions: Array<{
    __typename?: 'SubmissionDto';
    id: string;
    text: string;
    fileIds: Array<string | null>;
    imageIds: Array<string | null>;
    createdAt: string;
  } | null>;
  lastSubmission?: {
    __typename?: 'SubmissionDto';
    id: string;
    text: string;
    fileIds: Array<string | null>;
    imageIds: Array<string | null>;
    createdAt: string;
  } | null;
};

export type AssignmentSubmissionPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AssignmentSubmissionPageQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    postId: string;
    channelId?: string | null;
    dueDateTime?: string | null;
    maxPoints: number;
    type: AssignmentType;
  } | null;
  submittedAssignmentSubmissions?: Array<{
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assigneeId: string;
    assignmentId: string;
    points?: number | null;
    createdAt: string;
    gradingStatus: GradingStatus;
    status: AssignmentSubmissionStatus;
    commentsCount?: number | null;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
      createdAt: string;
      updatedAt: string;
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        pageType: LearningCardPageType;
        points: number;
        userInput: string;
        duration: number;
        isCorrect?: boolean | null;
        pageId: number;
        multipleChoiceOption?: any | null;
        textEntry?: string | null;
        essay?: string | null;
        pageIndex: number;
        maxPoints: number;
        correctOptions?: Array<any | null> | null;
      } | null>;
    } | null;
    submissions: Array<{
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null>;
    lastSubmission?: {
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null;
  } | null> | null;
  notSubmittedAssignmentSubmissions?: Array<{
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assigneeId: string;
    assignmentId: string;
    points?: number | null;
    createdAt: string;
    gradingStatus: GradingStatus;
    status: AssignmentSubmissionStatus;
    commentsCount?: number | null;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
      createdAt: string;
      updatedAt: string;
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        pageType: LearningCardPageType;
        points: number;
        userInput: string;
        duration: number;
        isCorrect?: boolean | null;
        pageId: number;
        multipleChoiceOption?: any | null;
        textEntry?: string | null;
        essay?: string | null;
        pageIndex: number;
        maxPoints: number;
        correctOptions?: Array<any | null> | null;
      } | null>;
    } | null;
    submissions: Array<{
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null>;
    lastSubmission?: {
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null;
  } | null> | null;
};

export type AssignmentSubmissionPagePostQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type AssignmentSubmissionPagePostQuery = {
  __typename?: 'Query';
  post?: { __typename?: 'PostDto'; id: string; title?: string | null } | null;
};

export type AssignmentSubmissionPageAssignmentSubmissionQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentSubmissionId: Scalars['String']['input'];
}>;

export type AssignmentSubmissionPageAssignmentSubmissionQuery = {
  __typename?: 'Query';
  assignmentSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assigneeId: string;
    assignmentId: string;
    points?: number | null;
    createdAt: string;
    gradingStatus: GradingStatus;
    status: AssignmentSubmissionStatus;
    commentsCount?: number | null;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
      createdAt: string;
      updatedAt: string;
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        pageType: LearningCardPageType;
        points: number;
        userInput: string;
        duration: number;
        isCorrect?: boolean | null;
        pageId: number;
        multipleChoiceOption?: any | null;
        textEntry?: string | null;
        essay?: string | null;
        pageIndex: number;
        maxPoints: number;
        correctOptions?: Array<any | null> | null;
      } | null>;
    } | null;
    submissions: Array<{
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null>;
    lastSubmission?: {
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null;
  } | null;
};

export type AssignmentSubmissionRoutePageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type AssignmentSubmissionRoutePageQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    assigneeIds?: Array<string | null> | null;
  } | null;
};

export type UpdateAssignedAssignmentMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  updateAssignedAssignmentDtoInput: UpdateAssignedAssignmentDtoInput;
}>;

export type UpdateAssignedAssignmentMutation = {
  __typename?: 'Mutation';
  updateAssignedAssignment?: {
    __typename?: 'AssignmentDto';
    id: string;
  } | null;
};

export type UpdateAssignedAssignmentPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updatePostDtoInput: UpdatePostDtoInput;
}>;

export type UpdateAssignedAssignmentPostMutation = {
  __typename?: 'Mutation';
  updatePost?: { __typename?: 'PostDto'; id: string } | null;
};

export type EditAssignmentPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type EditAssignmentPageQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    postId: string;
    dueDateTime?: string | null;
    maxPoints: number;
    assigneeIds?: Array<string | null> | null;
    type: AssignmentType;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string } | null;
};

export type EditAssignmentPagePostQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type EditAssignmentPagePostQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    content?: string | null;
    channelId?: string | null;
    status: Status3;
    authorId: string;
  } | null;
};

export type LearningCardViewerPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type LearningCardViewerPageQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    assignmentId?: string | null;
    type: PostType;
    channelId?: string | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type LearningCardViewerPageAssignmentQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type LearningCardViewerPageAssignmentQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    assigneeIds?: Array<string | null> | null;
    type: AssignmentType;
  } | null;
};

export type SubmissionDetailPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  assignmentSubmissionId: Scalars['String']['input'];
}>;

export type SubmissionDetailPageQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    postId: string;
    channelId?: string | null;
    dueDateTime?: string | null;
    maxPoints: number;
    type: AssignmentType;
  } | null;
  assignmentSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    createdAt: string;
    assigneeId: string;
    assignmentId: string;
    points?: number | null;
    gradingStatus: GradingStatus;
    commentsCount?: number | null;
    submissions: Array<{
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null>;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
      createdAt: string;
      updatedAt: string;
      answers: Array<{
        __typename?: 'LearningUserAnswerDto';
        userInput: string;
        duration: number;
        isCorrect?: boolean | null;
        pageType: LearningCardPageType;
        pageId: number;
        multipleChoiceOption?: any | null;
        textEntry?: string | null;
        essay?: string | null;
        pageIndex: number;
        maxPoints: number;
        points: number;
        correctOptions?: Array<any | null> | null;
      } | null>;
    } | null;
    lastSubmission?: {
      __typename?: 'SubmissionDto';
      id: string;
      text: string;
      fileIds: Array<string | null>;
      imageIds: Array<string | null>;
      createdAt: string;
    } | null;
  } | null;
};

export type SubmissionDetailPagePostQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type SubmissionDetailPagePostQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    channelId?: string | null;
  } | null;
};

export type SubmissionDetailPageCurrentMemberQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type SubmissionDetailPageCurrentMemberQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type UpdateAssignmentMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  updateAssignmentDtoInput: UpdateAssignmentDtoInput;
}>;

export type UpdateAssignmentMutation = {
  __typename?: 'Mutation';
  assignment?: {
    __typename?: 'AssignmentDto';
    createdAt: string;
    id: string;
    postId: string;
    dueDateTime?: string | null;
    maxPoints: number;
    assigneeIds?: Array<string | null> | null;
    type: AssignmentType;
  } | null;
};

export type DraftAssignmentMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  savePostAsDraftDtoInput: SavePostAsDraftDtoInput;
}>;

export type DraftAssignmentMutation = {
  __typename?: 'Mutation';
  post?: {
    __typename?: 'PostDto';
    createdAt: string;
    id: string;
    title?: string | null;
    content?: string | null;
    channelId?: string | null;
    status: Status3;
    authorId: string;
  } | null;
};

export type PublishAssignmentPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PublishAssignmentPostMutation = {
  __typename?: 'Mutation';
  post?: {
    __typename?: 'PostDto';
    createdAt: string;
    id: string;
    title?: string | null;
    content?: string | null;
    channelId?: string | null;
    status: Status3;
    authorId: string;
  } | null;
};

export type AssignAssignmentMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  assignAssignmentDtoInput: AssignAssignmentDtoInput;
}>;

export type AssignAssignmentMutation = {
  __typename?: 'Mutation';
  assignment?: { __typename?: 'AssignmentDto'; id: string } | null;
};

export type WriteAssignmentPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type WriteAssignmentPageQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    postId: string;
    dueDateTime?: string | null;
    maxPoints: number;
    assigneeIds?: Array<string | null> | null;
    type: AssignmentType;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type WriteAssignmentPagePostQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type WriteAssignmentPagePostQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    content?: string | null;
    channelId?: string | null;
    status: Status3;
    authorId: string;
  } | null;
};

export type SubmitAssignmentSubmissionMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  submitSubmissionDtoInput: SubmitSubmissionDtoInput;
}>;

export type SubmitAssignmentSubmissionMutation = {
  __typename?: 'Mutation';
  submitSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    assignmentId: string;
    classroomId: string;
    points?: number | null;
    isSubmitted: boolean;
    status: AssignmentSubmissionStatus;
    gradingStatus: GradingStatus;
    createdAt: string;
  } | null;
};

export type ArchiveChannelMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type ArchiveChannelMutation = {
  __typename?: 'Mutation';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    channelGroupId?: string | null;
    classroomId: string;
    name: string;
    archived: boolean;
    isPrivate: boolean;
  } | null;
};

export type UnarchiveChannelMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type UnarchiveChannelMutation = {
  __typename?: 'Mutation';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    channelGroupId?: string | null;
    classroomId: string;
    name: string;
    archived: boolean;
    isPrivate: boolean;
  } | null;
};

export type ChannelFormClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  name: string;
};

export type ChannelFormChannelGroupFieldsFragment = {
  __typename?: 'ChannelGroupDto';
  id: string;
  name: string;
  primary: boolean;
};

export type ChannelFormChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  classroomId: string;
  id: string;
  name: string;
  purpose?: string | null;
  canMemberWritePost: boolean;
  canMemberWriteComment: boolean;
  canMemberReactToPost: boolean;
  archived: boolean;
  autoJoin: boolean;
  channelGroupId?: string | null;
  isPrivate: boolean;
  isCommon: boolean;
};

export type ChannelFormQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type ChannelFormQuery = {
  __typename?: 'Query';
  channelMembers?: Array<{
    __typename?: 'MemberDto';
    id: string;
  } | null> | null;
};

export type ChannelGroupFormChannelGroupFieldsFragment = {
  __typename?: 'ChannelGroupDto';
  id: string;
  name: string;
};

export type ChannelListItemChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  name: string;
  purpose?: string | null;
  membersCount: number;
  archived: boolean;
  isPrivate: boolean;
};

export type ChannelMemberListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type ChannelMemberListQuery = {
  __typename?: 'Query';
  members?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    group?: Group | null;
    role: Role;
    active: boolean;
  } | null> | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  channel?: { __typename?: 'ChannelDto'; id: string; isCommon: boolean } | null;
};

export type ChannelMembersSelectorMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  name?: string | null;
  profileImageUrl?: string | null;
  group?: Group | null;
  role: Role;
};

export type ChannelMembersSelectorByGroupQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ChannelMembersSelectorByGroupQuery = {
  __typename?: 'Query';
  me?: { __typename?: 'AccountDto'; id: string } | null;
  studentsCollection?: {
    __typename?: 'MembersCollectionDto';
    members: Array<{
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      group?: Group | null;
      role: Role;
    } | null>;
  } | null;
  guardiansCollection?: {
    __typename?: 'MembersCollectionDto';
    members: Array<{
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      group?: Group | null;
      role: Role;
    } | null>;
  } | null;
  teachersCollection?: {
    __typename?: 'MembersCollectionDto';
    members: Array<{
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      group?: Group | null;
      role: Role;
    } | null>;
  } | null;
};

export type ChannelMembersSelectorByGroupChannelMembersQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type ChannelMembersSelectorByGroupChannelMembersQuery = {
  __typename?: 'Query';
  joinedStudents?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    group?: Group | null;
    role: Role;
  } | null> | null;
  joinedGuardians?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    group?: Group | null;
    role: Role;
  } | null> | null;
  joinedTeachers?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    group?: Group | null;
    role: Role;
  } | null> | null;
};

export type ChannelNavQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ChannelNavQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    archived: boolean;
  } | null;
  channelGroups?: Array<{
    __typename?: 'ChannelGroupDto';
    id: string;
    name: string;
    primary: boolean;
    channels: Array<{
      __typename?: 'ChannelDto';
      id: string;
      channelGroupId?: string | null;
      classroomId: string;
      name: string;
      archived: boolean;
      isPrivate: boolean;
    } | null>;
  } | null> | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type ChannelNavItemChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  channelGroupId?: string | null;
  classroomId: string;
  name: string;
  archived: boolean;
  isPrivate: boolean;
};

export type ChannelNavItemMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
};

export type JoinChannelMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type JoinChannelMutation = {
  __typename?: 'Mutation';
  channel?: { __typename?: 'ChannelDto'; id: string } | null;
};

export type ChannelPageHeaderQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type ChannelPageHeaderQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    archived: boolean;
  } | null;
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    purpose?: string | null;
    channelGroupId?: string | null;
    isPrivate: boolean;
    channelType: ChannelType;
    isCommon: boolean;
    meeting?: { __typename?: 'Meeting2'; id: string; status: Status2 } | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  currentChannelMember?: { __typename?: 'MemberDto'; id: string } | null;
};

export type ChannelGroupNameQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelGroupId: Scalars['String']['input'];
}>;

export type ChannelGroupNameQuery = {
  __typename?: 'Query';
  channelGroup?: {
    __typename?: 'ChannelGroupDto';
    id: string;
    name: string;
  } | null;
};

export type ClassGuideQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassGuideQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type DeleteChannelMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelGroupId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type DeleteChannelMutation = {
  __typename?: 'Mutation';
  deleteChannel?: any | null;
};

export type DeleteChannelGroupMutationVariables = Exact<{
  channelGroupId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
}>;

export type DeleteChannelGroupMutation = {
  __typename?: 'Mutation';
  deleteChannelGroup?: any | null;
};

export type LeaveChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
}>;

export type LeaveChannelMutation = {
  __typename?: 'Mutation';
  leaveChannelDto?: {
    __typename?: 'ChannelDto';
    id: string;
    channelGroupId?: string | null;
    classroomId: string;
    name: string;
    archived: boolean;
    isPrivate: boolean;
  } | null;
};

export type ChannelListPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ChannelListPageQuery = {
  __typename?: 'Query';
  channelGroups?: Array<{
    __typename?: 'ChannelGroupDto';
    id: string;
    name: string;
    channels: Array<{
      __typename?: 'ChannelDto';
      id: string;
      name: string;
      purpose?: string | null;
      membersCount: number;
      archived: boolean;
      isPrivate: boolean;
    } | null>;
  } | null> | null;
};

export type ChannelPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ChannelPageQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    archived: boolean;
    schoolId?: string | null;
    schoolName?: string | null;
    profileImageUrl: string;
    membersCount: number;
    grade: Grade2;
    countryCode?: string | null;
  } | null;
  me?: {
    __typename?: 'AccountDto';
    id: string;
    isAdFreeSubscribed: boolean;
  } | null;
};

export type CreateChannelGroupMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  createChannelGroupDtoInput: CreateChannelGroupDtoInput;
}>;

export type CreateChannelGroupMutation = {
  __typename?: 'Mutation';
  channelGroup?: {
    __typename?: 'ChannelGroupDto';
    primary: boolean;
    classroomId: string;
    channelIds: Array<string | null>;
    id: string;
    name: string;
    channels: Array<{
      __typename?: 'ChannelDto';
      id: string;
      channelGroupId?: string | null;
      classroomId: string;
      name: string;
      archived: boolean;
      isPrivate: boolean;
    } | null>;
  } | null;
};

export type CreateChannelMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  createChannelDtoInput: CreateChannelDtoInput;
}>;

export type CreateChannelMutation = {
  __typename?: 'Mutation';
  channel?: {
    __typename?: 'ChannelDto';
    classroomId: string;
    id: string;
    name: string;
    purpose?: string | null;
    canMemberWritePost: boolean;
    canMemberWriteComment: boolean;
    canMemberReactToPost: boolean;
    archived: boolean;
    autoJoin: boolean;
    channelGroupId?: string | null;
    isPrivate: boolean;
    isCommon: boolean;
  } | null;
};

export type CreateChannelPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type CreateChannelPageQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
  channelGroupCollection?: Array<{
    __typename?: 'ChannelGroupDto';
    id: string;
    name: string;
    primary: boolean;
    channels: Array<{
      __typename?: 'ChannelDto';
      classroomId: string;
      id: string;
      name: string;
      purpose?: string | null;
      canMemberWritePost: boolean;
      canMemberWriteComment: boolean;
      canMemberReactToPost: boolean;
      archived: boolean;
      autoJoin: boolean;
      channelGroupId?: string | null;
      isPrivate: boolean;
      isCommon: boolean;
    } | null>;
  } | null> | null;
};

export type UpdateChannelGroupMutationVariables = Exact<{
  channelGroupId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
  updateChannelGroupDtoInput: UpdateChannelGroupDtoInput;
}>;

export type UpdateChannelGroupMutation = {
  __typename?: 'Mutation';
  channelGroup?: {
    __typename?: 'ChannelGroupDto';
    id: string;
    name: string;
  } | null;
};

export type EditChannelGroupPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelGroupId: Scalars['String']['input'];
}>;

export type EditChannelGroupPageQuery = {
  __typename?: 'Query';
  channelGroup?: {
    __typename?: 'ChannelGroupDto';
    classroomId: string;
    id: string;
    primary: boolean;
    name: string;
  } | null;
};

export type UpdateChannelMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  updateChannelDtoInput: UpdateChannelDtoInput;
}>;

export type UpdateChannelMutation = {
  __typename?: 'Mutation';
  channel?: {
    __typename?: 'ChannelDto';
    classroomId: string;
    id: string;
    name: string;
    purpose?: string | null;
    canMemberWritePost: boolean;
    canMemberWriteComment: boolean;
    canMemberReactToPost: boolean;
    archived: boolean;
    autoJoin: boolean;
    channelGroupId?: string | null;
    isPrivate: boolean;
    isCommon: boolean;
  } | null;
};

export type EditChannelPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type EditChannelPageQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
  currentChannelMember?: {
    __typename?: 'MemberDto';
    id: string;
    role: Role;
  } | null;
  channelGroups?: Array<{
    __typename?: 'ChannelGroupDto';
    id: string;
    name: string;
    primary: boolean;
  } | null> | null;
};

export type EditChannelPageChannelQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type EditChannelPageChannelQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    classroomId: string;
    id: string;
    name: string;
    purpose?: string | null;
    canMemberWritePost: boolean;
    canMemberWriteComment: boolean;
    canMemberReactToPost: boolean;
    archived: boolean;
    autoJoin: boolean;
    channelGroupId?: string | null;
    isPrivate: boolean;
    isCommon: boolean;
  } | null;
};

export type ClassAiTutorBannerQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassAiTutorBannerQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    grade: Grade2;
    schoolId?: string | null;
    schoolName?: string | null;
  } | null;
};

export type ClassAiTutorBannerCurrentMemberQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassAiTutorBannerCurrentMemberQuery = {
  __typename?: 'Query';
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    group?: Group | null;
    role: Role;
  } | null;
};

export type ClassAiTutorFloatingButtonQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassAiTutorFloatingButtonQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    grade: Grade2;
    schoolId?: string | null;
    schoolName?: string | null;
  } | null;
};

export type ClassAiTutorFloatingButtonCurrentMemberQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassAiTutorFloatingButtonCurrentMemberQuery = {
  __typename?: 'Query';
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    group?: Group | null;
    role: Role;
  } | null;
};

export type WritePostChannelSelectorChannelGroupFieldsFragment = {
  __typename?: 'ChannelGroupDto';
  id: string;
  name: string;
  channels: Array<{
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    canMemberWritePost: boolean;
    isPrivate: boolean;
    channelType: ChannelType;
  } | null>;
};

export type WritePostChannelSelectorChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  name: string;
  canMemberWritePost: boolean;
  isPrivate: boolean;
  channelType: ChannelType;
};

export type WritePostChannelSelectorQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type WritePostChannelSelectorQuery = {
  __typename?: 'Query';
  commonChannels?: Array<{
    __typename?: 'ChannelDto';
    id: string;
    channelType: ChannelType;
    name: string;
    canMemberWritePost: boolean;
  } | null> | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type WritePostPopupChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  channelType: ChannelType;
};

export type ClassAiTutorDrawerQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassAiTutorDrawerQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    grade: Grade2;
    orgId?: string | null;
    schoolName?: string | null;
  } | null;
  me?: {
    __typename?: 'MemberDto';
    id: string;
    role: Role;
    group?: Group | null;
  } | null;
};

export type ClassAiTutorDrawerMyLicenseQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;

export type ClassAiTutorDrawerMyLicenseQuery = {
  __typename?: 'Query';
  myLicense?: {
    __typename?: 'OrganizationMemberLicenseDto';
    id: string;
  } | null;
};

export type ClassAiTutorDrawerClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  name: string;
  grade: Grade2;
  orgId?: string | null;
  schoolName?: string | null;
};

export type AppBarBottomQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AppBarBottomQuery = {
  __typename?: 'Query';
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
  } | null;
};

export type UnblockMemberMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;

export type UnblockMemberMutation = {
  __typename?: 'Mutation';
  member?: {
    __typename?: 'MemberDto';
    id: string;
    active: boolean;
    blocked: boolean;
  } | null;
};

export type BlockedMemberListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type BlockedMemberListQuery = {
  __typename?: 'Query';
  membersCollection?: {
    __typename?: 'MembersCollectionDto';
    cursor?: string | null;
    members: Array<{
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      group?: Group | null;
      role: Role;
      active: boolean;
    } | null>;
  } | null;
};

export type ClassroomArchiveBannerQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassroomArchiveBannerQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    archived: boolean;
  } | null;
};

export type ClassroomFormClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  name: string;
  schoolId?: string | null;
  schoolName?: string | null;
  schoolYear?: number | null;
  grade: Grade2;
  about?: string | null;
};

export type ClassroomInfoClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  name: string;
  schoolId?: string | null;
  schoolName?: string | null;
  profileImageUrl: string;
  membersCount: number;
};

export type ClassroomProfileImageClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  profileImageUrl: string;
};

export type CreateClassroomWizardQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type CreateClassroomWizardQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    provisioningStatus: string;
  } | null;
};

export type SelectBelongedOrganizationOrganizationDtoFieldsFragment = {
  __typename?: 'OrganizationOrganizationDto';
  id: string;
  name: string;
  city?: string | null;
};

export type SelectBelongedOrganizationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SelectBelongedOrganizationQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    name?: string | null;
    schoolInfo?: {
      __typename?: 'SchoolInfo';
      school?: { __typename?: 'AccountSchool'; id: string } | null;
    } | null;
  } | null;
};

export type SelectBelongedOrganizationOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;

export type SelectBelongedOrganizationOrganizationQuery = {
  __typename?: 'Query';
  organization?: {
    __typename?: 'OrganizationOrganizationDto';
    id: string;
    name: string;
    city?: string | null;
  } | null;
};

export type DeactivateMyselfMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  role: Role;
};

export type DeactivateMyselfMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;

export type DeactivateMyselfMutation = {
  __typename?: 'Mutation';
  member?: { __typename?: 'MemberDto'; id: string; active: boolean } | null;
};

export type DeactivateMyselfQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type DeactivateMyselfQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    type: ClassroomType;
    name: string;
  } | null;
};

export type DeleteClassroomMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type DeleteClassroomMutation = {
  __typename?: 'Mutation';
  deleteClassroom?: any | null;
};

export type HideOnboardingChecklistMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type HideOnboardingChecklistMutation = {
  __typename?: 'Mutation';
  hideOnboardingChecklist?: {
    __typename?: 'OnboardingChecklistDto';
    id: string;
    isActive: boolean;
  } | null;
};

export type HomePageHeaderQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type HomePageHeaderQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    about?: string | null;
    profileImageUrl: string;
    archived: boolean;
    schoolName?: string | null;
  } | null;
};

export type ReissueClassCodeMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ReissueClassCodeMutation = {
  __typename?: 'Mutation';
  recreateClassroomClassCode?: {
    __typename?: 'ClassCodeDto';
    code: string;
    classroomId: string;
    expiresAt?: string | null;
  } | null;
};

export type InvitationByClassCodeClassroomQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type InvitationByClassCodeClassroomQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    grade: Grade2;
    id: string;
    name: string;
    schoolName?: string | null;
  } | null;
};

export type InvitationByClassCodeQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type InvitationByClassCodeQuery = {
  __typename?: 'Query';
  classCode?: {
    __typename?: 'ClassCodeDto';
    classroomId: string;
    code: string;
    expiresAt?: string | null;
    enterprise?: { __typename?: 'ClassroomEnterpriseDto'; slug: string } | null;
  } | null;
};

export type InvitationByQrCodeClassroomEnterpriseDtoFieldsFragment = {
  __typename?: 'ClassroomEnterpriseDto';
  slug: string;
};

export type DeactivateClassroomMemberMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;

export type DeactivateClassroomMemberMutation = {
  __typename?: 'Mutation';
  member?: { __typename?: 'MemberDto'; id: string; active: boolean } | null;
};

export type BlockClassroomMemberMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;

export type BlockClassroomMemberMutation = {
  __typename?: 'Mutation';
  member?: { __typename?: 'MemberDto'; id: string; blocked: boolean } | null;
};

export type MemberListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  groups?: InputMaybe<Scalars['String']['input']>;
}>;

export type MemberListQuery = {
  __typename?: 'Query';
  membersCollection?: {
    __typename?: 'MembersCollectionDto';
    cursor?: string | null;
    members: Array<{
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      group?: Group | null;
      role: Role;
      active: boolean;
    } | null>;
  } | null;
};

export type MemberItemQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type MemberItemQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type AssignMemberRoleMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  assignMemberRoleDtoInput: AssignMemberRoleDtoInput;
}>;

export type AssignMemberRoleMutation = {
  __typename?: 'Mutation';
  member?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type NavbarClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  name: string;
  schoolId?: string | null;
  schoolName?: string | null;
  profileImageUrl: string;
  membersCount: number;
  grade: Grade2;
  countryCode?: string | null;
};

export type NavigationMenuClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  grade: Grade2;
  countryCode?: string | null;
};

export type NavigationMenuQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type NavigationMenuQuery = {
  __typename?: 'Query';
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    role: Role;
    group?: Group | null;
  } | null;
  me?: {
    __typename?: 'AccountDto';
    id: string;
    language?: string | null;
  } | null;
  checklist?: {
    __typename?: 'OnboardingChecklistDto';
    id: string;
    isActive: boolean;
  } | null;
};

export type NavigationMenuCommonChannelsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type NavigationMenuCommonChannelsQuery = {
  __typename?: 'Query';
  commonChannels?: Array<{
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    iconUrl?: string | null;
  } | null> | null;
};

export type CompleteVisitAiTestPageChecklistMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type CompleteVisitAiTestPageChecklistMutation = {
  __typename?: 'Mutation';
  completeOnboardingChecklistAction?: {
    __typename?: 'OnboardingChecklistDto';
    id: string;
    availableActions: Array<string | null>;
    isComplete: boolean;
    progress: any;
  } | null;
};

export type OnboardingChecklistProgressOnboardingChecklistFieldsFragment = {
  __typename?: 'OnboardingChecklistDto';
  id: string;
  progress: any;
};

export type CompleteVisitProductTourPageChecklistMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type CompleteVisitProductTourPageChecklistMutation = {
  __typename?: 'Mutation';
  completeOnboardingChecklistAction?: {
    __typename?: 'OnboardingChecklistDto';
    id: string;
    availableActions: Array<string | null>;
    isComplete: boolean;
    progress: any;
  } | null;
};

export type PostFeedMemberListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  groups?: InputMaybe<Scalars['String']['input']>;
}>;

export type PostFeedMemberListQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    membersCount: number;
  } | null;
  membersCollection?: {
    __typename?: 'MembersCollectionDto';
    members: Array<{
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      group?: Group | null;
      role: Role;
      active: boolean;
    } | null>;
  } | null;
};

export type UpdatePushNotificationSettingsMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  dto: UpdateMemberPushNotificationSettingsDtoInput;
}>;

export type UpdatePushNotificationSettingsMutation = {
  __typename?: 'Mutation';
  result?: {
    __typename?: 'MemberPushNotificationSettingsDto';
    id: string;
    pushNotificationSettings: {
      __typename?: 'PushNotificationSettings';
      commentsAndRepliesEnabled?: boolean | null;
      reactionsEnabled?: boolean | null;
      postsEnabled?: boolean | null;
      announcementsEnabled?: boolean | null;
    };
  } | null;
};

export type PushNotificationSettingsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type PushNotificationSettingsQuery = {
  __typename?: 'Query';
  result?: {
    __typename?: 'MemberPushNotificationSettingsDto';
    id: string;
    pushNotificationSettings: {
      __typename?: 'PushNotificationSettings';
      commentsAndRepliesEnabled?: boolean | null;
      reactionsEnabled?: boolean | null;
      postsEnabled?: boolean | null;
      announcementsEnabled?: boolean | null;
    };
  } | null;
};

export type RegisterForClassroomFormAccountFieldsFragment = {
  __typename?: 'AccountDto';
  id: string;
  name?: string | null;
  profileImage?: string | null;
  role: AccountRole;
};

export type SearchSchoolOrganizationDtoFieldsFragment = {
  __typename?: 'OrganizationOrganizationDto';
  id: string;
  name: string;
  countryCode: string;
  city?: string | null;
};

export type SearchSchoolsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
}>;

export type SearchSchoolsQuery = {
  __typename?: 'Query';
  schoolCollection?: {
    __typename?: 'OrganizationOrganizationsSearchCollectionDto';
    organizations: Array<{
      __typename?: 'OrganizationOrganizationDto';
      id: string;
      name: string;
      countryCode: string;
      city?: string | null;
    } | null>;
  } | null;
};

export type SideNavigationMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  role: Role;
  group?: Group | null;
  name?: string | null;
  profileImageUrl?: string | null;
};

export type SideNavigationClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  name: string;
  schoolId?: string | null;
  schoolName?: string | null;
  profileImageUrl: string;
  membersCount: number;
  grade: Grade2;
  countryCode?: string | null;
};

export type SideNavigationCommonChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  name: string;
  channelType: ChannelType;
  iconUrl?: string | null;
};

export type HomePageTabQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type HomePageTabQuery = {
  __typename?: 'Query';
  commonChannels?: Array<{
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    channelType: ChannelType;
  } | null> | null;
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    role: Role;
    group?: Group | null;
  } | null;
};

export type LogoQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type LogoQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    enterpriseId?: string | null;
  } | null;
};

export type LogoEnterpriseQueryVariables = Exact<{
  enterpriseId: Scalars['String']['input'];
}>;

export type LogoEnterpriseQuery = {
  __typename?: 'Query';
  enterprise?: {
    __typename?: 'EnterpriseDto';
    id: string;
    homeUrl: string;
    isWhiteLabeled: boolean;
    branding: { __typename?: 'EnterpriseBranding'; appIconUrl?: string | null };
  } | null;
};

export type SideMenuClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  grade: Grade2;
  countryCode?: string | null;
};

export type SideMenuCheckListFieldsFragment = {
  __typename?: 'OnboardingChecklistDto';
  id: string;
  isActive: boolean;
};

export type ClassroomInfoPageClassroomFieldsFragment = {
  __typename?: 'ClassroomDto';
  id: string;
  name: string;
  profileImageUrl: string;
  schoolName?: string | null;
  schoolYear?: number | null;
  membersCount: number;
  grade: Grade2;
};

export type ClassroomListPageQueryVariables = Exact<{ [key: string]: never }>;

export type ClassroomListPageQuery = {
  __typename?: 'Query';
  me?: { __typename?: 'AccountDto'; id: string; role: AccountRole } | null;
  managingClassrooms?: {
    __typename?: 'ClassroomsCollectionDto';
    cursor?: string | null;
    classrooms: Array<{
      __typename?: 'ClassroomDto';
      id: string;
      name: string;
      grade: Grade2;
      about?: string | null;
      schoolYear?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
  } | null;
  joinedClassrooms?: {
    __typename?: 'ClassroomsCollectionDto';
    cursor?: string | null;
    classrooms: Array<{
      __typename?: 'ClassroomDto';
      id: string;
      name: string;
      grade: Grade2;
      about?: string | null;
      schoolYear?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
  } | null;
};

export type ClassroomPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassroomPageQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    isAdFreeSubscribed: boolean;
  } | null;
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    grade: Grade2;
    archived: boolean;
    version: number;
    schoolId?: string | null;
    schoolName?: string | null;
    profileImageUrl: string;
    schoolYear?: number | null;
    membersCount: number;
    countryCode?: string | null;
  } | null;
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    active: boolean;
    blocked: boolean;
    isProvisioningCompleted: boolean;
    role: Role;
    group?: Group | null;
    name?: string | null;
    profileImageUrl?: string | null;
  } | null;
};

export type ClassroomPageOrganizationInfoQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;

export type ClassroomPageOrganizationInfoQuery = {
  __typename?: 'Query';
  organizationMyLicense?: {
    __typename?: 'OrganizationMemberLicenseDto';
    id: string;
  } | null;
  organization?: {
    __typename?: 'OrganizationOrganizationDto';
    id: string;
    category: OrganizationOrgCategory;
    address?: string | null;
    licensed?: boolean | null;
  } | null;
};

export type ClassroomRegistrationPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassroomRegistrationPageQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    type: ClassroomType;
  } | null;
};

export type UpdateClassroomMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  updateClassroomDtoInput: UpdateClassroomDtoInput;
}>;

export type UpdateClassroomMutation = {
  __typename?: 'Mutation';
  classroom?: {
    __typename?: 'ClassroomDto';
    profileImageUrl: string;
    id: string;
    name: string;
    schoolId?: string | null;
    schoolName?: string | null;
    schoolYear?: number | null;
    grade: Grade2;
    about?: string | null;
  } | null;
};

export type ArchiveClassroomMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ArchiveClassroomMutation = {
  __typename?: 'Mutation';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    archived: boolean;
  } | null;
};

export type UnarchiveClassroomMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type UnarchiveClassroomMutation = {
  __typename?: 'Mutation';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    archived: boolean;
  } | null;
};

export type ClassroomSettingPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassroomSettingPageQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    archived: boolean;
    profileImageUrl: string;
    name: string;
    schoolId?: string | null;
    schoolName?: string | null;
    schoolYear?: number | null;
    grade: Grade2;
    about?: string | null;
  } | null;
  member?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type CreateClassroomMutationVariables = Exact<{
  createClassroomDtoInput: CreateClassroomDtoInput;
}>;

export type CreateClassroomMutation = {
  __typename?: 'Mutation';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type EditProfileForClassroomPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type EditProfileForClassroomPageQuery = {
  __typename?: 'Query';
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    classroomId: string;
    profileImageId?: string | null;
    profileImageUrl?: string | null;
  } | null;
};

export type HomePageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type HomePageQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    isAdFreeSubscribed: boolean;
  } | null;
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    archived: boolean;
  } | null;
};

export type InvitationHandoutPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type InvitationHandoutPageQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    countryCode?: string | null;
    name: string;
    schoolName?: string | null;
  } | null;
  classroomClassCode?: {
    __typename?: 'ClassCodeDto';
    classroomId: string;
    code: string;
    expiresAt?: string | null;
    enterprise?: { __typename?: 'ClassroomEnterpriseDto'; slug: string } | null;
  } | null;
};

export type InvitationPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type InvitationPageQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    countryCode?: string | null;
  } | null;
  classCode?: {
    __typename?: 'ClassCodeDto';
    classroomId: string;
    code: string;
    enterprise?: { __typename?: 'ClassroomEnterpriseDto'; slug: string } | null;
  } | null;
};

export type MemberListPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type MemberListPageQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    membersCount: number;
    countryCode?: string | null;
  } | null;
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    role: Role;
  } | null;
};

export type MobileNavigationMenuCommonChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  name: string;
  channelType: ChannelType;
  iconUrl?: string | null;
};

export type MobileNavigationMenuQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type MobileNavigationMenuQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    schoolId?: string | null;
    schoolName?: string | null;
    profileImageUrl: string;
    membersCount: number;
    grade: Grade2;
    countryCode?: string | null;
  } | null;
  me?: {
    __typename?: 'AccountDto';
    id: string;
    isAdFreeSubscribed: boolean;
  } | null;
};

export type OnboardingChecklistPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type OnboardingChecklistPageQuery = {
  __typename?: 'Query';
  checklist?: {
    __typename?: 'OnboardingChecklistDto';
    id: string;
    isActive: boolean;
    isComplete: boolean;
    availableActions: Array<string | null>;
    progress: any;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type OnboardingLoadingPageMemberQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type OnboardingLoadingPageMemberQuery = {
  __typename?: 'Query';
  currentMember?: {
    __typename?: 'MemberDto';
    isProvisioningCompleted: boolean;
  } | null;
};

export type RegisterForClassroomMutationVariables = Exact<{
  registerDtoInput: RegisterDtoInput;
}>;

export type RegisterForClassroomMutation = {
  __typename?: 'Mutation';
  member?: {
    __typename?: 'MemberDto';
    classroomId: string;
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
  } | null;
};

export type RegisterForClassroomPageQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type RegisterForClassroomPageQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    name?: string | null;
    profileImage?: string | null;
    role: AccountRole;
  } | null;
  classCode?: {
    __typename?: 'ClassCodeDto';
    classroomId: string;
    code: string;
  } | null;
};

export type RegisterForClassroomPageClassroomQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type RegisterForClassroomPageClassroomQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    schoolId?: string | null;
  } | null;
};

export type RegisterForClassroomPageClassroomOrganizationQueryVariables =
  Exact<{
    organizationId: Scalars['String']['input'];
  }>;

export type RegisterForClassroomPageClassroomOrganizationQuery = {
  __typename?: 'Query';
  organization?: {
    __typename?: 'OrganizationOrganizationDto';
    id: string;
    enterpriseId?: string | null;
  } | null;
};

export type RegisterForPublicClassroomPageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type RegisterForPublicClassroomPageQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    name?: string | null;
    profileImage?: string | null;
  } | null;
};

export type RegisterForPublicClassroomPageMutationVariables = Exact<{
  registerDtoInput: RegisterDtoInput;
}>;

export type RegisterForPublicClassroomPageMutation = {
  __typename?: 'Mutation';
  member?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
  } | null;
};

export type SignUpAdminPageMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  name?: string | null;
  profileImageUrl?: string | null;
  profileImageId?: string | null;
  classroomId: string;
};

export type SignUpAdminPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type SignUpAdminPageQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    schoolId?: string | null;
    schoolName?: string | null;
  } | null;
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    profileImageId?: string | null;
    classroomId: string;
  } | null;
};

export type IntegrateZoomMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  integrateZoomDtoInput: IntegrateZoomDtoInput;
}>;

export type IntegrateZoomMutation = {
  __typename?: 'Mutation';
  integrateZoom?: { __typename?: 'ZoomIntegrationDto'; userId: string } | null;
};

export type ClassTalkButtonQueryVariables = Exact<{ [key: string]: never }>;

export type ClassTalkButtonQuery = {
  __typename?: 'Query';
  currentChatUser?: {
    __typename?: 'ChatUser';
    unreadCount?: number | null;
  } | null;
};

export type ClassTalkMobileButtonQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ClassTalkMobileButtonQuery = {
  __typename?: 'Query';
  currentChatUser?: {
    __typename?: 'ChatUser';
    unreadCount?: number | null;
  } | null;
};

export type ClasstalkChatButtonMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  name?: string | null;
  profileImageUrl?: string | null;
  role: Role;
  active: boolean;
  group?: Group | null;
  blocked: boolean;
  classroomId: string;
};

export type ClasstalkChatButtonQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClasstalkChatButtonQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    name: string;
    profileImageUrl: string;
  } | null;
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    role: Role;
    active: boolean;
    group?: Group | null;
    blocked: boolean;
    classroomId: string;
  } | null;
};

export type CommentItemCommentFieldsFragment = {
  __typename?: 'CommentDto';
  id: string;
  postId: string;
  classroomId: string;
  content: string;
  createdAt: string;
  updatedAt: string;
  repliesCount: number;
  reactionsCount: any;
  author: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    role: Role;
    blocked: boolean;
    active: boolean;
  };
  reactions: Array<{
    __typename?: 'CommentReactionDto';
    memberId: string;
    name: string;
  } | null>;
};

export type CommentItemCommentReactionFieldsFragment = {
  __typename?: 'CommentReactionDto';
  name: string;
  member?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    role: Role;
    profileImageUrl?: string | null;
    group?: Group | null;
    blocked: boolean;
    active: boolean;
  } | null;
};

export type CommentItemPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
};

export type DeleteCommentMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
}>;

export type DeleteCommentMutation = {
  __typename?: 'Mutation';
  deleteComment?: any | null;
};

export type UpdateCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updateCommentDtoInput: UpdateCommentDtoInput;
}>;

export type UpdateCommentMutation = {
  __typename?: 'Mutation';
  comment?: {
    __typename?: 'CommentDto';
    id: string;
    postId: string;
    classroomId: string;
    content: string;
    createdAt: string;
    updatedAt: string;
    repliesCount: number;
    reactionsCount: any;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      role: Role;
      blocked: boolean;
      active: boolean;
    };
    reactions: Array<{
      __typename?: 'CommentReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type AddReactionToCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  addReactionToCommentDtoInput: AddReactionToCommentDtoInput;
}>;

export type AddReactionToCommentMutation = {
  __typename?: 'Mutation';
  addReactionToComment?: {
    __typename?: 'CommentDto';
    id: string;
    reactionsCount: any;
    reactions: Array<{
      __typename?: 'CommentReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type RemoveReactionFromCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  removeReactionFromCommentDtoInput: RemoveReactionFromCommentDtoInput;
}>;

export type RemoveReactionFromCommentMutation = {
  __typename?: 'Mutation';
  removeReactionFromComment?: {
    __typename?: 'CommentDto';
    id: string;
    reactionsCount: any;
    reactions: Array<{
      __typename?: 'CommentReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type CommentItemQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type CommentItemQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string } | null;
  commentPermission?: {
    __typename?: 'CommentPermissionDto';
    canEdit: boolean;
    canDelete: boolean;
    canReact: boolean;
    canWriteReply: boolean;
  } | null;
};

export type CommentListPostDtoFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  commentsCount: number;
  repliesCount: number;
};

export type CommentListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type CommentListQuery = {
  __typename?: 'Query';
  postPermission?: {
    __typename?: 'PostPermissionDto';
    canWriteComment: boolean;
  } | null;
};

export type PostCommentsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type PostCommentsQuery = {
  __typename?: 'Query';
  postComments?: {
    __typename?: 'CommentsCollectionDto';
    cursor?: string | null;
    comments: Array<{
      __typename?: 'CommentDto';
      id: string;
      postId: string;
      classroomId: string;
      content: string;
      createdAt: string;
      updatedAt: string;
      repliesCount: number;
      reactionsCount: any;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        role: Role;
        blocked: boolean;
        active: boolean;
      };
      reactions: Array<{
        __typename?: 'CommentReactionDto';
        memberId: string;
        name: string;
      } | null>;
    } | null>;
  } | null;
};

export type ReplyItemReplyFieldsFragment = {
  __typename?: 'ReplyDto';
  id: string;
  commentId: string;
  postId: string;
  content: string;
  createdAt: string;
  updatedAt: string;
  reactionsCount: any;
  author: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    blocked: boolean;
    active: boolean;
  };
  reactions: Array<{
    __typename?: 'ReplyReactionDto';
    memberId: string;
    name: string;
  } | null>;
};

export type ReplyItemReplyReactionFieldsFragment = {
  __typename?: 'ReplyReactionDto';
  name: string;
  member?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    role: Role;
    profileImageUrl?: string | null;
    blocked: boolean;
    group?: Group | null;
    active: boolean;
  } | null;
};

export type UpdateReplyMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
  updateReplyDtoInput: UpdateReplyDtoInput;
}>;

export type UpdateReplyMutation = {
  __typename?: 'Mutation';
  reply?: {
    __typename?: 'ReplyDto';
    id: string;
    commentId: string;
    postId: string;
    content: string;
    createdAt: string;
    updatedAt: string;
    reactionsCount: any;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      blocked: boolean;
      active: boolean;
    };
    reactions: Array<{
      __typename?: 'ReplyReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type DeleteReplyMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
}>;

export type DeleteReplyMutation = {
  __typename?: 'Mutation';
  deleteReply?: any | null;
};

export type AddReactionToReplyMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
  addReactionToReplyDtoInput: AddReactionToReplyDtoInput;
}>;

export type AddReactionToReplyMutation = {
  __typename?: 'Mutation';
  addReactionToReply?: {
    __typename?: 'ReplyDto';
    id: string;
    reactionsCount: any;
    reactions: Array<{
      __typename?: 'ReplyReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type RemoveReactionFromReplyMutationVariables = Exact<{
  postId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
  removeReactionFromReplyDtoInput: RemoveReactionFromReplyDtoInput;
}>;

export type RemoveReactionFromReplyMutation = {
  __typename?: 'Mutation';
  removeReactionFromReply?: {
    __typename?: 'ReplyDto';
    id: string;
    reactionsCount: any;
    reactions: Array<{
      __typename?: 'ReplyReactionDto';
      name: string;
      memberId: string;
    } | null>;
  } | null;
};

export type ReplyItemQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
}>;

export type ReplyItemQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string } | null;
  replyPermission?: {
    __typename?: 'ReplyPermissionDto';
    canDelete: boolean;
    canEdit: boolean;
    canReact: boolean;
  } | null;
};

export type ReplyListQueryVariables = Exact<{
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type ReplyListQuery = {
  __typename?: 'Query';
  commentPermission?: {
    __typename?: 'CommentPermissionDto';
    canEdit: boolean;
    canDelete: boolean;
    canReact: boolean;
    canWriteReply: boolean;
  } | null;
};

export type RepliesQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type RepliesQuery = {
  __typename?: 'Query';
  replyList?: {
    __typename?: 'RepliesCollectionDto';
    cursor?: string | null;
    replies: Array<{
      __typename?: 'ReplyDto';
      id: string;
      commentId: string;
      postId: string;
      content: string;
      createdAt: string;
      updatedAt: string;
      reactionsCount: any;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
        active: boolean;
      };
      reactions: Array<{
        __typename?: 'ReplyReactionDto';
        memberId: string;
        name: string;
      } | null>;
    } | null>;
  } | null;
};

export type WriteCommentPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
};

export type CreateCommentMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  createCommentDtoInput: CreateCommentDtoInput;
}>;

export type CreateCommentMutation = {
  __typename?: 'Mutation';
  comment?: {
    __typename?: 'CommentDto';
    id: string;
    postId: string;
    classroomId: string;
    content: string;
    createdAt: string;
    updatedAt: string;
    repliesCount: number;
    reactionsCount: any;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      role: Role;
      blocked: boolean;
      active: boolean;
    };
    reactions: Array<{
      __typename?: 'CommentReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type CreateReplyMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  createReplyDtoInput: CreateReplyDtoInput;
}>;

export type CreateReplyMutation = {
  __typename?: 'Mutation';
  reply?: {
    __typename?: 'ReplyDto';
    id: string;
    commentId: string;
    postId: string;
    content: string;
    createdAt: string;
    updatedAt: string;
    reactionsCount: any;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      blocked: boolean;
      active: boolean;
    };
    reactions: Array<{
      __typename?: 'ReplyReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type CommentReactionsPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
}>;

export type CommentReactionsPageQuery = {
  __typename?: 'Query';
  clap?: {
    __typename?: 'CommentReactionsCollectionDto';
    reactions: Array<{
      __typename?: 'CommentReactionDto';
      name: string;
      member?: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        role: Role;
        profileImageUrl?: string | null;
        group?: Group | null;
        blocked: boolean;
        active: boolean;
      } | null;
    } | null>;
  } | null;
  check?: {
    __typename?: 'CommentReactionsCollectionDto';
    reactions: Array<{
      __typename?: 'CommentReactionDto';
      name: string;
      member?: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        role: Role;
        profileImageUrl?: string | null;
        group?: Group | null;
        blocked: boolean;
        active: boolean;
      } | null;
    } | null>;
  } | null;
};

export type ReplyReactionsPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
}>;

export type ReplyReactionsPageQuery = {
  __typename?: 'Query';
  clap?: {
    __typename?: 'ReplyReactionsCollectionDto';
    reactions: Array<{
      __typename?: 'ReplyReactionDto';
      name: string;
      member?: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        role: Role;
        profileImageUrl?: string | null;
        blocked: boolean;
        group?: Group | null;
        active: boolean;
      } | null;
    } | null>;
  } | null;
  check?: {
    __typename?: 'ReplyReactionsCollectionDto';
    reactions: Array<{
      __typename?: 'ReplyReactionDto';
      name: string;
      member?: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        role: Role;
        profileImageUrl?: string | null;
        blocked: boolean;
        group?: Group | null;
        active: boolean;
      } | null;
    } | null>;
  } | null;
};

export type CumulativeRecordsPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type CumulativeRecordsPageQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type InsightsPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type InsightsPageQuery = {
  __typename?: 'Query';
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    role: Role;
    group?: Group | null;
  } | null;
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    countryCode?: string | null;
  } | null;
  me?: {
    __typename?: 'AccountDto';
    id: string;
    language?: string | null;
  } | null;
};

export type MemberInfoQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;

export type MemberInfoQuery = {
  __typename?: 'Query';
  targetMember?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    role: Role;
    active: boolean;
    group?: Group | null;
    blocked: boolean;
    classroomId: string;
  } | null;
  currentMember?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    role: Role;
    active: boolean;
    group?: Group | null;
    blocked: boolean;
    classroomId: string;
  } | null;
};

export type MemberInfoChangePopupMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  updateMemberDtoInput: UpdateMemberDtoInput;
}>;

export type MemberInfoChangePopupMutation = {
  __typename?: 'Mutation';
  member?: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    group?: Group | null;
    role: Role;
    active: boolean;
  } | null;
};

export type MemberInfoChangePopupQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type MemberInfoChangePopupQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type MemberInsightsTabsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;

export type MemberInsightsTabsQuery = {
  __typename?: 'Query';
  member?: {
    __typename?: 'MemberDto';
    id: string;
    role: Role;
    group?: Group | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type MemberItemMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  name?: string | null;
  profileImageUrl?: string | null;
  group?: Group | null;
  role: Role;
  active: boolean;
};

export type MemberProfileMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  name?: string | null;
  profileImageUrl?: string | null;
  role: Role;
  active: boolean;
  group?: Group | null;
  blocked: boolean;
};

export type MemberProfileImageMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  name?: string | null;
  classroomId: string;
  profileImageId?: string | null;
  profileImageUrl?: string | null;
};

export type MemberProfileImageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type MemberProfileImageQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type NotificationBellQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type NotificationBellQuery = {
  __typename?: 'Query';
  notificationsCollection?: {
    __typename?: 'NotificationsCollectionDto';
    cursor?: string | null;
    notifications: Array<{
      __typename?: 'NotificationDto';
      id: string;
      type: string;
      object?: any | null;
      publishedAt: string;
      actor: any;
      target: any;
      summary?: string | null;
      read: boolean;
      content?: string | null;
      generator?: any | null;
    } | null>;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string } | null;
};

export type NotificationLastSeenQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type NotificationLastSeenQuery = {
  __typename?: 'Query';
  notificationLastSeen?: {
    __typename?: 'NotificationLastSeen';
    timestamp: string;
  } | null;
};

export type NotificationItemNotificationFieldsFragment = {
  __typename?: 'NotificationDto';
  id: string;
  type: string;
  object?: any | null;
  publishedAt: string;
  actor: any;
  target: any;
  summary?: string | null;
  read: boolean;
  content?: string | null;
  generator?: any | null;
};

export type MarkNotificationAsReadMutationVariables = Exact<{
  notificationId: Scalars['String']['input'];
}>;

export type MarkNotificationAsReadMutation = {
  __typename?: 'Mutation';
  markNotificationAsRead?: {
    __typename?: 'NotificationDto';
    id: string;
    read: boolean;
  } | null;
};

export type NotificationListNotificationsCollectionFieldsFragment = {
  __typename?: 'NotificationsCollectionDto';
  cursor?: string | null;
  notifications: Array<{
    __typename?: 'NotificationDto';
    id: string;
    type: string;
    object?: any | null;
    publishedAt: string;
    actor: any;
    target: any;
    summary?: string | null;
    read: boolean;
    content?: string | null;
    generator?: any | null;
  } | null>;
};

export type NotificationListAccountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type NotificationListAccountQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    role: AccountRole;
    isAdFreeSubscribed: boolean;
    grade?: SchoolGrade | null;
    language?: string | null;
    countryCode?: string | null;
    schoolInfoDto?: {
      __typename?: 'SchoolInfoDto';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null;
    schoolInfoDtoForChildren: Array<{
      __typename?: 'SchoolInfoDto2';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null>;
  } | null;
};

export type ClassroomNotificationsPageQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type ClassroomNotificationsPageQuery = {
  __typename?: 'Query';
  notificationsCollection?: {
    __typename?: 'NotificationsCollectionDto';
    cursor?: string | null;
    notifications: Array<{
      __typename?: 'NotificationDto';
      id: string;
      type: string;
      object?: any | null;
      publishedAt: string;
      actor: any;
      target: any;
      summary?: string | null;
      read: boolean;
      content?: string | null;
      generator?: any | null;
    } | null>;
  } | null;
};

export type NotificationsPageQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;

export type NotificationsPageQuery = {
  __typename?: 'Query';
  notificationsCollection?: {
    __typename?: 'NotificationsCollectionDto';
    cursor?: string | null;
    notifications: Array<{
      __typename?: 'NotificationDto';
      id: string;
      type: string;
      object?: any | null;
      publishedAt: string;
      actor: any;
      target: any;
      summary?: string | null;
      read: boolean;
      content?: string | null;
      generator?: any | null;
    } | null>;
  } | null;
  me?: { __typename?: 'AccountDto'; isAdFreeSubscribed: boolean } | null;
};

export type AuthorInfoPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  publishedAt?: string | null;
  updatedAt: string;
  adminExclusive: boolean;
  classroomId: string;
  channelId?: string | null;
  readsCount: number;
  lastNotifiedAt?: string | null;
  author: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    blocked: boolean;
  };
};

export type AuthorInfoQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AuthorInfoQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type ChannelGalleryQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type ChannelGalleryQuery = {
  __typename?: 'Query';
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type ChannelMediaPostsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
}>;

export type ChannelMediaPostsQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsSearchCollectionDto';
    page?: number | null;
    totalPages?: number | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      title?: string | null;
      summary?: string | null;
      classroomId: string;
      channelId?: string | null;
      createdAt: string;
      images?: Array<{
        __typename?: 'ImageDto';
        id: string;
        originalFileName: string;
        urls: any;
      } | null> | null;
      videos?: Array<{
        __typename?: 'VideoDto';
        id: string;
        originalFileName: string;
        posterUrl?: string | null;
        streamUrl?: string | null;
        urls: any;
      } | null> | null;
    } | null>;
  } | null;
};

export type ChannelLinkQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type ChannelLinkQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    channelType: ChannelType;
  } | null;
};

export type ClassroomGalleryQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type ClassroomGalleryQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type ClassroomMediaPostsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
}>;

export type ClassroomMediaPostsQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsSearchCollectionDto';
    page?: number | null;
    totalPages?: number | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      title?: string | null;
      summary?: string | null;
      classroomId: string;
      channelId?: string | null;
      createdAt: string;
      images?: Array<{
        __typename?: 'ImageDto';
        id: string;
        originalFileName: string;
        urls: any;
      } | null> | null;
      videos?: Array<{
        __typename?: 'VideoDto';
        id: string;
        originalFileName: string;
        posterUrl?: string | null;
        streamUrl?: string | null;
        urls: any;
      } | null> | null;
    } | null>;
  } | null;
};

export type DraftPostItemPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  channelId?: string | null;
  title?: string | null;
  summary?: string | null;
  updatedAt: string;
  tags: Array<string | null>;
  coverImageUrl?: string | null;
  type: PostType;
  assignmentId?: string | null;
  adminExclusive: boolean;
  status: Status3;
  scheduledAt?: string | null;
  publishedAt?: string | null;
  isAnnouncement: boolean;
};

export type DraftPostItemChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  name: string;
  isPrivate: boolean;
  channelType: ChannelType;
};

export type DeleteDraftPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type DeleteDraftPostMutation = {
  __typename?: 'Mutation';
  deletePost?: any | null;
};

export type DraftPostItemQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type DraftPostItemQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    isPrivate: boolean;
    channelType: ChannelType;
  } | null;
};

export type DraftPostListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['String']['input']>;
  postType?: InputMaybe<PostType>;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
}>;

export type DraftPostListQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsSearchCollectionDto';
    page?: number | null;
    totalPages?: number | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      title?: string | null;
      summary?: string | null;
      updatedAt: string;
      tags: Array<string | null>;
      coverImageUrl?: string | null;
      type: PostType;
      assignmentId?: string | null;
      adminExclusive: boolean;
      status: Status3;
      scheduledAt?: string | null;
      publishedAt?: string | null;
      isAnnouncement: boolean;
    } | null>;
  } | null;
};

export type DraftPostsButtonQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type DraftPostsButtonQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    archived: boolean;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type DraftPostsButtonChannelQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type DraftPostsButtonChannelQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    canMemberWritePost: boolean;
    archived: boolean;
  } | null;
  currentChannelMember?: { __typename?: 'MemberDto'; id: string } | null;
};

export type GalleryPostDtoFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  title?: string | null;
  summary?: string | null;
  classroomId: string;
  channelId?: string | null;
  createdAt: string;
  images?: Array<{
    __typename?: 'ImageDto';
    id: string;
    originalFileName: string;
    urls: any;
  } | null> | null;
  videos?: Array<{
    __typename?: 'VideoDto';
    id: string;
    originalFileName: string;
    posterUrl?: string | null;
    streamUrl?: string | null;
    urls: any;
  } | null> | null;
};

export type MarkPostAsReadPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  title?: string | null;
};

export type MarkPostAsReadMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type MarkPostAsReadMutation = {
  __typename?: 'Mutation';
  markPostAsRead?: any | null;
};

export type PinnedPostItemPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  title?: string | null;
  isAnnouncement: boolean;
  summary?: string | null;
  coverImageUrl?: string | null;
  fileIds: Array<string | null>;
  publishedAt?: string | null;
  classroomId: string;
  channelId?: string | null;
};

export type PinnedPostItemQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PinnedPostItemQuery = {
  __typename?: 'Query';
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type PinnedPostListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type PinnedPostListQuery = {
  __typename?: 'Query';
  postPins?: Array<{
    __typename?: 'ChannelPostPinDto';
    id: string;
    postId: string;
    post?: {
      __typename?: 'PostDto';
      id: string;
      title?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      coverImageUrl?: string | null;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      classroomId: string;
      channelId?: string | null;
    } | null;
  } | null> | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type PinnedPostListCheckedOnboardingPinnedPostQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  classroomId: Scalars['String']['input'];
}>;

export type PinnedPostListCheckedOnboardingPinnedPostQuery = {
  __typename?: 'Query';
  CheckedOnboardingPinnedPost?: {
    __typename?: 'CheckedOnboardingPinnedPost';
    isChecked: boolean;
  } | null;
};

export type PostContentPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  content?: string | null;
  imageIds: Array<string | null>;
  classroomId: string;
  title?: string | null;
};

export type PostFeedAssignmentStatusAssignmentDtoFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  dueDateTime?: string | null;
  assigneesCount: number;
  membersSubmittedCount: number;
};

export type PostFeedAssignmentStatusPostDtoFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  assignmentId?: string | null;
  content?: string | null;
};

export type PostFeedAssignmentStatusQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type PostFeedAssignmentStatusQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    dueDateTime?: string | null;
    assigneesCount: number;
    membersSubmittedCount: number;
  } | null;
};

export type PostFeedItemPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  channelId?: string | null;
  isAnnouncement: boolean;
  summary?: string | null;
  content?: string | null;
  coverImageUrl?: string | null;
  tags: Array<string | null>;
  type: PostType;
  fileIds: Array<string | null>;
  publishedAt?: string | null;
  readsCount: number;
  commentsCount: number;
  reactionsCount: any;
  title?: string | null;
  adminExclusive: boolean;
  assignmentId?: string | null;
  isPinned: boolean;
  author: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    blocked: boolean;
  };
};

export type PostFeedItemBodyQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type PostFeedItemBodyQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type PostFeedItemFooterPostFieldsFragment = {
  __typename?: 'PostDto';
  commentsCount: number;
  reactionsCount: any;
  readsCount: number;
};

export type PostFeedItemHeaderPostFieldsFragment = {
  __typename?: 'PostDto';
  classroomId: string;
  channelId?: string | null;
  title?: string | null;
  publishedAt?: string | null;
  summary?: string | null;
  adminExclusive: boolean;
  id: string;
  assignmentId?: string | null;
  type: PostType;
  isPinned: boolean;
  isAnnouncement: boolean;
  author: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    blocked: boolean;
  };
};

export type PostFeedItemHeaderQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostFeedItemHeaderQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    isPrivate: boolean;
  } | null;
};

export type PostFeedItemHeaderAssignmentQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type PostFeedItemHeaderAssignmentQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    type: AssignmentType;
    classroomId: string;
    dueDateTime?: string | null;
  } | null;
};

export type PostFeedListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type PostFeedListQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsCollectionDto';
    cursor?: string | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      content?: string | null;
      coverImageUrl?: string | null;
      tags: Array<string | null>;
      type: PostType;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      readsCount: number;
      assignmentId?: string | null;
      isPinned: boolean;
      adminExclusive: boolean;
      commentsCount: number;
      reactionsCount: any;
      title?: string | null;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
      };
    } | null>;
  } | null;
};

export type PostFeedListChannelQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostFeedListChannelQuery = {
  __typename?: 'Query';
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type PostFeedListAccountQueryVariables = Exact<{ [key: string]: never }>;

export type PostFeedListAccountQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    role: AccountRole;
    isAdFreeSubscribed: boolean;
    grade?: SchoolGrade | null;
    language?: string | null;
    countryCode?: string | null;
    schoolInfoDto?: {
      __typename?: 'SchoolInfoDto';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null;
    schoolInfoDtoForChildren: Array<{
      __typename?: 'SchoolInfoDto2';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null>;
  } | null;
};

export type PostFeedListSearchedByTagQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  tag: Scalars['String']['input'];
  page: Scalars['Float']['input'];
  perPage: Scalars['Float']['input'];
}>;

export type PostFeedListSearchedByTagQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsSearchCollectionDto';
    totalPages?: number | null;
    perPage?: number | null;
    page?: number | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      content?: string | null;
      coverImageUrl?: string | null;
      tags: Array<string | null>;
      type: PostType;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      readsCount: number;
      commentsCount: number;
      reactionsCount: any;
      title?: string | null;
      adminExclusive: boolean;
      assignmentId?: string | null;
      isPinned: boolean;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
      };
    } | null>;
  } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type PostFeedListSearchedByTagChannelNameQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostFeedListSearchedByTagChannelNameQuery = {
  __typename?: 'Query';
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type PostFeedListSearchedByTagAccountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PostFeedListSearchedByTagAccountQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    role: AccountRole;
    isAdFreeSubscribed: boolean;
    grade?: SchoolGrade | null;
    language?: string | null;
    countryCode?: string | null;
    schoolInfoDto?: {
      __typename?: 'SchoolInfoDto';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null;
    schoolInfoDtoForChildren: Array<{
      __typename?: 'SchoolInfoDto2';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null>;
  } | null;
};

export type PostFeedPinnedPostItemChannelPostPinDtoFieldsFragment = {
  __typename?: 'ChannelPostPinDto';
  id: string;
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    isAnnouncement: boolean;
    summary?: string | null;
    coverImageUrl?: string | null;
    fileIds: Array<string | null>;
    publishedAt?: string | null;
    classroomId: string;
    channelId?: string | null;
  } | null;
};

export type PostFeedPinnedPostItemPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  title?: string | null;
  isAnnouncement: boolean;
  summary?: string | null;
  coverImageUrl?: string | null;
  fileIds: Array<string | null>;
  publishedAt?: string | null;
  classroomId: string;
  channelId?: string | null;
};

export type PostFeedPinnedPostItemQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostFeedPinnedPostItemQuery = {
  __typename?: 'Query';
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type PostFeedPinnedPostListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type PostFeedPinnedPostListQuery = {
  __typename?: 'Query';
  postPins?: Array<{
    __typename?: 'ChannelPostPinDto';
    id: string;
    post?: {
      __typename?: 'PostDto';
      id: string;
      title?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      coverImageUrl?: string | null;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      classroomId: string;
      channelId?: string | null;
    } | null;
  } | null> | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryVariables =
  Exact<{
    userId: Scalars['String']['input'];
    classroomId: Scalars['String']['input'];
  }>;

export type PostFeedPinnedPostListCheckedOnboardingPinnedPostQuery = {
  __typename?: 'Query';
  CheckedOnboardingPinnedPost?: {
    __typename?: 'CheckedOnboardingPinnedPost';
    isChecked: boolean;
  } | null;
};

export type PostFeedSearchPostsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  q: Scalars['String']['input'];
  page: Scalars['Float']['input'];
  perPage: Scalars['Float']['input'];
}>;

export type PostFeedSearchPostsQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsSearchCollectionDto';
    totalPages?: number | null;
    perPage?: number | null;
    page?: number | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      content?: string | null;
      coverImageUrl?: string | null;
      tags: Array<string | null>;
      type: PostType;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      readsCount: number;
      commentsCount: number;
      reactionsCount: any;
      title?: string | null;
      adminExclusive: boolean;
      assignmentId?: string | null;
      isPinned: boolean;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
      };
    } | null>;
  } | null;
};

export type PostFeedSearchPostsClassroomQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type PostFeedSearchPostsClassroomQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type PostFeedSearchPostsAccountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PostFeedSearchPostsAccountQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    role: AccountRole;
    isAdFreeSubscribed: boolean;
    grade?: SchoolGrade | null;
    language?: string | null;
    countryCode?: string | null;
    schoolInfoDto?: {
      __typename?: 'SchoolInfoDto';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null;
    schoolInfoDtoForChildren: Array<{
      __typename?: 'SchoolInfoDto2';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null>;
  } | null;
};

export type UpdateTranslationLanguageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  updateAccountDtoInput: UpdateAccountDtoInput;
}>;

export type UpdateTranslationLanguageMutation = {
  __typename?: 'Mutation';
  updateTranslationLanguage?: {
    __typename?: 'AccountDto';
    id: string;
    language?: string | null;
  } | null;
};

export type ChangeLanguageToTranslationPopupQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ChangeLanguageToTranslationPopupQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    language?: string | null;
  } | null;
};

export type ChannelSelectChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  name: string;
  isPrivate: boolean;
  channelType: ChannelType;
  canMemberWritePost: boolean;
  archived: boolean;
};

export type InsertLinkPopupUrlMetadataFieldsFragment = {
  __typename?: 'UrlMetadata';
  url: string;
  title?: string | null;
  description?: string | null;
  image?: string | null;
  logo?: string | null;
};

export type InsertLinkPopupQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;

export type InsertLinkPopupQuery = {
  __typename?: 'Query';
  urlMetadata?: {
    __typename?: 'UrlMetadata';
    id: string;
    url: string;
    title?: string | null;
    description?: string | null;
    image?: string | null;
    logo?: string | null;
  } | null;
};

export type PostFormPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  title?: string | null;
  content?: string | null;
  channelId?: string | null;
  status: Status3;
  tags: Array<string | null>;
  isAnnouncement: boolean;
  adminExclusive: boolean;
  scheduledAt?: string | null;
};

export type PostFormChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  name: string;
  isPrivate: boolean;
  channelType: ChannelType;
};

export type PostFormMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  role: Role;
};

export type PostFormChannelGroupFieldsFragment = {
  __typename?: 'ChannelGroupDto';
  id: string;
  name: string;
  channels: Array<{
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    isPrivate: boolean;
    channelType: ChannelType;
    canMemberWritePost: boolean;
    archived: boolean;
  } | null>;
};

export type PostFormQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostFormQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    canMemberWriteComment: boolean;
    canMemberReactToPost: boolean;
    id: string;
    name: string;
    isPrivate: boolean;
    channelType: ChannelType;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type PostFormChannelQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostFormChannelQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    canMemberWriteComment: boolean;
    canMemberReactToPost: boolean;
    id: string;
    name: string;
    isPrivate: boolean;
    channelType: ChannelType;
  } | null;
};

export type PostHeaderPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  title?: string | null;
  isAnnouncement: boolean;
  adminExclusive: boolean;
  assignmentId?: string | null;
  type: PostType;
  publishedAt?: string | null;
  updatedAt: string;
  channelId?: string | null;
  classroomId: string;
  isPinned: boolean;
  readsCount: number;
  lastNotifiedAt?: string | null;
  author: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    blocked: boolean;
  };
};

export type PostHeaderAssignmentFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  type: AssignmentType;
};

export type PostHeaderQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type PostHeaderQuery = {
  __typename?: 'Query';
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    type: AssignmentType;
  } | null;
};

export type PostItemPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  channelId?: string | null;
  isAnnouncement: boolean;
  summary?: string | null;
  coverImageUrl?: string | null;
  tags: Array<string | null>;
  type: PostType;
  assignmentId?: string | null;
  fileIds: Array<string | null>;
  publishedAt?: string | null;
  commentsCount: number;
  reactionsCount: any;
  title?: string | null;
  adminExclusive: boolean;
  author: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    blocked: boolean;
  };
};

export type PostItemReadStatusQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;

export type PostItemReadStatusQuery = {
  __typename?: 'Query';
  postReadStatus?: {
    __typename?: 'PostReadStatusDto';
    postId: string;
    readStatus: ReadStatus;
  } | null;
};

export type AssignmentStatusTagAssignmentDtoFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  classroomId: string;
  dueDateTime?: string | null;
};

export type AssignmentStatusTagQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AssignmentStatusTagQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type AssignmentStatusTagAssigneeQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  assigneeId: Scalars['String']['input'];
}>;

export type AssignmentStatusTagAssigneeQuery = {
  __typename?: 'Query';
  assignmentSubmission?: {
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    isSubmitted: boolean;
    submissions: Array<{ __typename?: 'SubmissionDto'; id: string } | null>;
    learningSubmission?: {
      __typename?: 'LearningSubmissionDto';
      id: string;
    } | null;
  } | null;
};

export type AssignmentStatusTagGraderQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AssignmentStatusTagGraderQuery = {
  __typename?: 'Query';
  submittedAssignmentSubmissions?: Array<{
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    gradingStatus: GradingStatus;
  } | null> | null;
  notSubmittedAssignmentSubmissions?: Array<{
    __typename?: 'AssignmentSubmissionDto';
    id: string;
    gradingStatus: GradingStatus;
  } | null> | null;
};

export type PostItemBodyAssignmentDtoFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  postId: string;
  dueDateTime?: string | null;
  classroomId: string;
  assigneesCount: number;
  membersSubmittedCount: number;
  type: AssignmentType;
};

export type PostItemBodyQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  assignmentId: Scalars['String']['input'];
}>;

export type PostItemBodyQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  assignment?: {
    __typename?: 'AssignmentDto';
    id: string;
    postId: string;
    dueDateTime?: string | null;
    classroomId: string;
    assigneesCount: number;
    membersSubmittedCount: number;
    type: AssignmentType;
  } | null;
};

export type PostTypeTagPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  assignmentId?: string | null;
  isAnnouncement: boolean;
};

export type PostTypeTagAssignmentDtoFieldsFragment = {
  __typename?: 'AssignmentDto';
  id: string;
  type: AssignmentType;
};

export type PostItemHeaderPostFieldsFragment = {
  __typename?: 'PostDto';
  classroomId: string;
  channelId?: string | null;
  title?: string | null;
  publishedAt?: string | null;
  adminExclusive: boolean;
  author: {
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    blocked: boolean;
  };
};

export type PostItemHeaderQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostItemHeaderQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    isPrivate: boolean;
  } | null;
};

export type PostMetaPostFieldsFragment = {
  __typename?: 'PostDto';
  commentsCount: number;
  reactionsCount: any;
};

export type PostListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type PostListQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsCollectionDto';
    cursor?: string | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      coverImageUrl?: string | null;
      tags: Array<string | null>;
      type: PostType;
      assignmentId?: string | null;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      commentsCount: number;
      reactionsCount: any;
      title?: string | null;
      adminExclusive: boolean;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
      };
    } | null>;
  } | null;
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type PostListSearchedByTagQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  tag: Scalars['String']['input'];
  page: Scalars['Float']['input'];
  perPage: Scalars['Float']['input'];
}>;

export type PostListSearchedByTagQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsSearchCollectionDto';
    totalPages?: number | null;
    perPage?: number | null;
    page?: number | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      coverImageUrl?: string | null;
      tags: Array<string | null>;
      type: PostType;
      assignmentId?: string | null;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      commentsCount: number;
      reactionsCount: any;
      title?: string | null;
      adminExclusive: boolean;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
      };
    } | null>;
  } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type PostChannelNameQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostChannelNameQuery = {
  __typename?: 'Query';
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type PostMoreMenuPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  channelId?: string | null;
  classroomId: string;
  assignmentId?: string | null;
  type: PostType;
  isPinned: boolean;
  adminExclusive: boolean;
  author: { __typename?: 'MemberDto'; id: string; name?: string | null };
};

export type ReportPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  reportPostDtoInput: ReportPostDtoInput;
}>;

export type ReportPostMutation = {
  __typename?: 'Mutation';
  reportPost?: { __typename?: 'PostDto'; id: string } | null;
};

export type DeletePostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type DeletePostMutation = {
  __typename?: 'Mutation';
  deletePost?: any | null;
};

export type PinPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  pinPostDtoInput: PinPostDtoInput;
}>;

export type PinPostMutation = {
  __typename?: 'Mutation';
  pinPost?: {
    __typename?: 'ChannelPostPinDto';
    id: string;
    post?: {
      __typename?: 'PostDto';
      id: string;
      title?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      coverImageUrl?: string | null;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      classroomId: string;
      channelId?: string | null;
    } | null;
  } | null;
};

export type UnpinPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  unpinPostDtoInput: UnpinPostDtoInput;
}>;

export type UnpinPostMutation = {
  __typename?: 'Mutation';
  unpinPost?: any | null;
};

export type UpdatePostChannelAdminMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updatePostChannelAdminDtoInput: UpdatePostChannelAdminDtoInput;
}>;

export type UpdatePostChannelAdminMutation = {
  __typename?: 'Mutation';
  updatePostChannelAdmin?: {
    __typename?: 'PostDto';
    channelId?: string | null;
  } | null;
};

export type UpdateAdminExclusiveMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updatePostAdminExclusiveByAdminDtoInput: UpdatePostAdminExclusiveByAdminDtoInput;
}>;

export type UpdateAdminExclusiveMutation = {
  __typename?: 'Mutation';
  updateAdminExclusive?: {
    __typename?: 'PostDto';
    adminExclusive: boolean;
    id: string;
  } | null;
};

export type PostMoreMenuQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type PostMoreMenuQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type PostMoreMenuPostPermissionAndChannelQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PostMoreMenuPostPermissionAndChannelQuery = {
  __typename?: 'Query';
  postPermission?: {
    __typename?: 'PostPermissionDto';
    canDelete: boolean;
    canEdit: boolean;
    canPin: boolean;
  } | null;
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    channelType: ChannelType;
    name: string;
    isCommon: boolean;
  } | null;
};

export type PostReactionPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  reactionsCount: any;
  reactions: Array<{
    __typename?: 'PostReactionDto';
    memberId: string;
    name: string;
  } | null>;
};

export type AddReactionToPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  addReactionToPostDtoInput: AddReactionToPostDtoInput;
}>;

export type AddReactionToPostMutation = {
  __typename?: 'Mutation';
  addReactionToPost?: {
    __typename?: 'PostDto';
    id: string;
    classroomId: string;
    reactionsCount: any;
    reactions: Array<{
      __typename?: 'PostReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type RemoveReactionFromPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  removeReactionFromPostDtoInput: RemoveReactionFromPostDtoInput;
}>;

export type RemoveReactionFromPostMutation = {
  __typename?: 'Mutation';
  removeReactionFromPost?: {
    __typename?: 'PostDto';
    id: string;
    classroomId: string;
    reactionsCount: any;
    reactions: Array<{
      __typename?: 'PostReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type PostReactionQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PostReactionQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string } | null;
  post?: {
    __typename?: 'PostDto';
    id: string;
    classroomId: string;
    reactionsCount: any;
    reactions: Array<{
      __typename?: 'PostReactionDto';
      memberId: string;
      name: string;
    } | null>;
  } | null;
};

export type PostReactionListPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
};

export type PostReactionListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PostReactionListQuery = {
  __typename?: 'Query';
  postReactions?: {
    __typename?: 'PostReactionsCollectionDto';
    reactions: Array<{
      __typename?: 'PostReactionDto';
      name: string;
      member?: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
        group?: Group | null;
        role: Role;
        active: boolean;
      } | null;
    } | null>;
  } | null;
};

export type PostRecipientsPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  channelId?: string | null;
  readsCount: number;
  lastNotifiedAt?: string | null;
};

export type PostRecipientsMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  name?: string | null;
  profileImageUrl?: string | null;
  group?: Group | null;
  role: Role;
  active: boolean;
  blocked: boolean;
};

export type PostRecipientsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostRecipientsQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type PostReadUnreadMembersQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PostReadUnreadMembersQuery = {
  __typename?: 'Query';
  readMembers?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    group?: Group | null;
    role: Role;
    active: boolean;
    blocked: boolean;
  } | null> | null;
  unreadMembers?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    group?: Group | null;
    role: Role;
    active: boolean;
    blocked: boolean;
  } | null> | null;
};

export type PostReminderPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  classroomId: string;
  lastNotifiedAt?: string | null;
};

export type RemindPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type RemindPostMutation = {
  __typename?: 'Mutation';
  post?: {
    __typename?: 'PostDto';
    id: string;
    lastNotifiedAt?: string | null;
  } | null;
};

export type CreateTagMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  createTagDtoInput: CreateTagDtoInput;
}>;

export type CreateTagMutation = {
  __typename?: 'Mutation';
  createTag?: { __typename?: 'TagDto'; id: string; name: string } | null;
};

export type PostWriteCommentAndReactChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  canMemberWriteComment: boolean;
  canMemberReactToPost: boolean;
};

export type RecentPostListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type RecentPostListQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsCollectionDto';
    cursor?: string | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      coverImageUrl?: string | null;
      tags: Array<string | null>;
      type: PostType;
      assignmentId?: string | null;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      commentsCount: number;
      reactionsCount: any;
      title?: string | null;
      adminExclusive: boolean;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
      };
    } | null>;
  } | null;
};

export type ScheduledPostListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['String']['input']>;
  postType?: InputMaybe<PostType>;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
}>;

export type ScheduledPostListQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsSearchCollectionDto';
    page?: number | null;
    totalPages?: number | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      title?: string | null;
      summary?: string | null;
      updatedAt: string;
      tags: Array<string | null>;
      coverImageUrl?: string | null;
      type: PostType;
      assignmentId?: string | null;
      adminExclusive: boolean;
      status: Status3;
      scheduledAt?: string | null;
      publishedAt?: string | null;
      isAnnouncement: boolean;
    } | null>;
  } | null;
};

export type TranslatePostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  translatePostDtoInput: TranslatePostDtoInput;
}>;

export type TranslatePostMutation = {
  __typename?: 'Mutation';
  translatePost?: {
    __typename?: 'TranslatedPostDto';
    id: string;
    content: string;
    classroomId: string;
  } | null;
};

export type TranslationPostContentQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type TranslationPostContentQuery = {
  __typename?: 'Query';
  translationPermission?: {
    __typename?: 'TranslationPermissionDto';
    canTranslatePost: boolean;
    memberId: string;
  } | null;
  me?: {
    __typename?: 'AccountDto';
    id: string;
    language?: string | null;
  } | null;
};

export type WriteAllTypePostButtonQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type WriteAllTypePostButtonQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    archived: boolean;
    countryCode?: string | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  commonChannels?: Array<{
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    channelType: ChannelType;
  } | null> | null;
};

export type WritePostButtonChannelFragment = {
  __typename?: 'ChannelDto';
  id: string;
  channelType: ChannelType;
  name: string;
};

export type WritePostButtonQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type WritePostButtonQuery = {
  __typename?: 'Query';
  classroom?: {
    __typename?: 'ClassroomDto';
    id: string;
    archived: boolean;
    countryCode?: string | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  currentChannelMember?: { __typename?: 'MemberDto'; id: string } | null;
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    canMemberWritePost: boolean;
    archived: boolean;
    channelType: ChannelType;
  } | null;
};

export type AnnouncementFormPostFieldsFragment = {
  __typename?: 'PostDto';
  id: string;
  title?: string | null;
  content?: string | null;
  channelId?: string | null;
  status: Status3;
  tags: Array<string | null>;
  isAnnouncement: boolean;
  scheduledAt?: string | null;
};

export type AnnouncementPostListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  page: Scalars['Float']['input'];
  perPage: Scalars['Float']['input'];
}>;

export type AnnouncementPostListQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsSearchCollectionDto';
    totalPages?: number | null;
    perPage?: number | null;
    page?: number | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      coverImageUrl?: string | null;
      tags: Array<string | null>;
      type: PostType;
      assignmentId?: string | null;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      commentsCount: number;
      reactionsCount: any;
      title?: string | null;
      adminExclusive: boolean;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
      };
    } | null>;
  } | null;
};

export type AnnouncementsPageHeaderCurrentMemberFieldsFragment = {
  __typename?: 'MemberDto';
  id: string;
  role: Role;
};

export type AnnouncementsPageHeaderQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AnnouncementsPageHeaderQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type PostFeedAnnouncementPostListQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  page: Scalars['Float']['input'];
  perPage: Scalars['Float']['input'];
}>;

export type PostFeedAnnouncementPostListQuery = {
  __typename?: 'Query';
  postsCollection?: {
    __typename?: 'PostsSearchCollectionDto';
    totalPages?: number | null;
    perPage?: number | null;
    page?: number | null;
    posts: Array<{
      __typename?: 'PostDto';
      id: string;
      classroomId: string;
      channelId?: string | null;
      isAnnouncement: boolean;
      summary?: string | null;
      content?: string | null;
      coverImageUrl?: string | null;
      tags: Array<string | null>;
      type: PostType;
      fileIds: Array<string | null>;
      publishedAt?: string | null;
      readsCount: number;
      commentsCount: number;
      reactionsCount: any;
      title?: string | null;
      adminExclusive: boolean;
      assignmentId?: string | null;
      isPinned: boolean;
      author: {
        __typename?: 'MemberDto';
        id: string;
        name?: string | null;
        profileImageUrl?: string | null;
        blocked: boolean;
      };
    } | null>;
  } | null;
};

export type PostFeedAnnouncementPostListAccountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PostFeedAnnouncementPostListAccountQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'AccountDto';
    id: string;
    role: AccountRole;
    isAdFreeSubscribed: boolean;
    grade?: SchoolGrade | null;
    language?: string | null;
    countryCode?: string | null;
    schoolInfoDto?: {
      __typename?: 'SchoolInfoDto';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null;
    schoolInfoDtoForChildren: Array<{
      __typename?: 'SchoolInfoDto2';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null>;
  } | null;
};

export type CanWritePostChannelsChannelGroupFieldsFragment = {
  __typename?: 'ChannelGroupDto';
  id: string;
  name: string;
  channels: Array<{
    __typename?: 'ChannelDto';
    id: string;
    canMemberWritePost: boolean;
    archived: boolean;
    name: string;
    isPrivate: boolean;
    channelType: ChannelType;
  } | null>;
};

export type CanWritePostChannelsChannelFieldsFragment = {
  __typename?: 'ChannelDto';
  id: string;
  canMemberWritePost: boolean;
  archived: boolean;
  name: string;
  isPrivate: boolean;
  channelType: ChannelType;
};

export type CanWritePostChannelsQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type CanWritePostChannelsQuery = {
  __typename?: 'Query';
  channelGroups?: Array<{
    __typename?: 'ChannelGroupDto';
    id: string;
    name: string;
    channels: Array<{
      __typename?: 'ChannelDto';
      id: string;
      canMemberWritePost: boolean;
      archived: boolean;
      name: string;
      isPrivate: boolean;
      channelType: ChannelType;
    } | null>;
  } | null> | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type AnnouncementsPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type AnnouncementsPageQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
  me?: {
    __typename?: 'AccountDto';
    id: string;
    isAdFreeSubscribed: boolean;
  } | null;
};

export type CreateAnnouncementMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  createPostDtoInput: CreatePostDtoInput;
}>;

export type CreateAnnouncementMutation = {
  __typename?: 'Mutation';
  post?: { __typename?: 'PostDto'; id: string } | null;
};

export type CreatePostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  createPostDtoInput: CreatePostDtoInput;
}>;

export type CreatePostMutation = {
  __typename?: 'Mutation';
  post?: { __typename?: 'PostDto'; id: string } | null;
};

export type CreateAssignmentMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  createAssignmentDtoInput: CreateAssignmentDtoInput;
}>;

export type CreateAssignmentMutation = {
  __typename?: 'Mutation';
  assignment?: { __typename?: 'AssignmentDto'; id: string } | null;
};

export type DraftPostListPopupQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
}>;

export type DraftPostListPopupQuery = {
  __typename?: 'Query';
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
};

export type UpdateAnnouncementMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  updatePostDtoInput: UpdatePostDtoInput;
}>;

export type UpdateAnnouncementMutation = {
  __typename?: 'Mutation';
  post?: {
    __typename?: 'PostDto';
    id: string;
    content?: string | null;
    title?: string | null;
    imageIds: Array<string | null>;
    videoIds: Array<string | null>;
    fileIds: Array<string | null>;
    createdAt: string;
    updatedAt: string;
    channelId?: string | null;
  } | null;
};

export type EditAnnouncementPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type EditAnnouncementPageQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    content?: string | null;
    channelId?: string | null;
    status: Status3;
    tags: Array<string | null>;
    isAnnouncement: boolean;
    scheduledAt?: string | null;
    author: { __typename?: 'MemberDto'; id: string };
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type EditAnnouncementPageChannelQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type EditAnnouncementPageChannelQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    editorMode: string;
  } | null;
};

export type EditPostPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type EditPostPageQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    content?: string | null;
    channelId?: string | null;
    status: Status3;
    tags: Array<string | null>;
    isAnnouncement: boolean;
    adminExclusive: boolean;
    scheduledAt?: string | null;
    author: { __typename?: 'MemberDto'; id: string };
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export type PostDetailPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PostDetailPageQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
  post?: {
    __typename?: 'PostDto';
    id: string;
    tags: Array<string | null>;
    readsCount: number;
    assignmentId?: string | null;
    type: PostType;
    title?: string | null;
    isAnnouncement: boolean;
    adminExclusive: boolean;
    content?: string | null;
    imageIds: Array<string | null>;
    classroomId: string;
    commentsCount: number;
    repliesCount: number;
    publishedAt?: string | null;
    updatedAt: string;
    channelId?: string | null;
    isPinned: boolean;
    lastNotifiedAt?: string | null;
    author: {
      __typename?: 'MemberDto';
      id: string;
      name?: string | null;
      profileImageUrl?: string | null;
      blocked: boolean;
    };
  } | null;
  me?: {
    __typename?: 'AccountDto';
    id: string;
    role: AccountRole;
    isAdFreeSubscribed: boolean;
    grade?: SchoolGrade | null;
    language?: string | null;
    countryCode?: string | null;
    schoolInfoDto?: {
      __typename?: 'SchoolInfoDto';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null;
    schoolInfoDtoForChildren: Array<{
      __typename?: 'SchoolInfoDto2';
      grade: SchoolGrade;
      school?: { __typename?: 'SchoolDto'; zipcode: string } | null;
    } | null>;
  } | null;
};

export type PostDetailPagePostPermissionQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PostDetailPagePostPermissionQuery = {
  __typename?: 'Query';
  postPermission?: {
    __typename?: 'PostPermissionDto';
    canReact: boolean;
  } | null;
};

export type PostDetailPageChannelQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostDetailPageChannelQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    canMemberWriteComment: boolean;
    isPrivate: boolean;
  } | null;
};

export type PostListSearchedByTagPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostListSearchedByTagPageQuery = {
  __typename?: 'Query';
  channel?: { __typename?: 'ChannelDto'; id: string; name: string } | null;
};

export type PostPresentationModePageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PostPresentationModePageQuery = {
  __typename?: 'Query';
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    channelId?: string | null;
    content?: string | null;
    imageIds: Array<string | null>;
    classroomId: string;
  } | null;
};

export type PostPresentationModePageChannelQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type PostPresentationModePageChannelQuery = {
  __typename?: 'Query';
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    name: string;
    isPrivate: boolean;
  } | null;
};

export type PostRecipientsPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PostRecipientsPageQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    classroomId: string;
    channelId?: string | null;
    readsCount: number;
    lastNotifiedAt?: string | null;
  } | null;
  readMembers?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    group?: Group | null;
    role: Role;
    active: boolean;
    blocked: boolean;
  } | null> | null;
  unreadMembers?: Array<{
    __typename?: 'MemberDto';
    id: string;
    name?: string | null;
    profileImageUrl?: string | null;
    group?: Group | null;
    role: Role;
    active: boolean;
    blocked: boolean;
  } | null> | null;
};

export type SavePostAsDraftMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  savePostAsDraftDtoInput: SavePostAsDraftDtoInput;
}>;

export type SavePostAsDraftMutation = {
  __typename?: 'Mutation';
  post?: {
    __typename?: 'PostDto';
    id: string;
    authorId: string;
    channelId?: string | null;
    title?: string | null;
    content?: string | null;
    status: Status3;
    createdAt: string;
  } | null;
};

export type PublishPostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type PublishPostMutation = {
  __typename?: 'Mutation';
  post?: {
    __typename?: 'PostDto';
    id: string;
    authorId: string;
    channelId?: string | null;
    title?: string | null;
    content?: string | null;
    status: Status3;
    createdAt: string;
  } | null;
};

export type SchedulePostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type SchedulePostMutation = {
  __typename?: 'Mutation';
  post?: {
    __typename?: 'PostDto';
    id: string;
    channelId?: string | null;
    title?: string | null;
    content?: string | null;
    status: Status3;
    scheduledAt?: string | null;
  } | null;
};

export type UnschedulePostMutationVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type UnschedulePostMutation = {
  __typename?: 'Mutation';
  post?: {
    __typename?: 'PostDto';
    id: string;
    channelId?: string | null;
    title?: string | null;
    content?: string | null;
    status: Status3;
    scheduledAt?: string | null;
  } | null;
};

export type WriteAnnouncementPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type WriteAnnouncementPageQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    content?: string | null;
    channelId?: string | null;
    status: Status3;
    tags: Array<string | null>;
    isAnnouncement: boolean;
    adminExclusive: boolean;
    scheduledAt?: string | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
  channel?: {
    __typename?: 'ChannelDto';
    id: string;
    editorMode: string;
  } | null;
};

export type WritePostPageQueryVariables = Exact<{
  classroomId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}>;

export type WritePostPageQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'PostDto';
    id: string;
    title?: string | null;
    content?: string | null;
    channelId?: string | null;
    status: Status3;
    tags: Array<string | null>;
    isAnnouncement: boolean;
    adminExclusive: boolean;
    scheduledAt?: string | null;
  } | null;
  currentMember?: { __typename?: 'MemberDto'; id: string; role: Role } | null;
  classroom?: { __typename?: 'ClassroomDto'; id: string; name: string } | null;
};

export const ClassroomFeaturesContextClassroomFieldsFragmentDoc = gql`
  fragment ClassroomFeaturesContextClassroomFields on ClassroomDto {
    type
  }
`;
export const ClassroomFeaturesContextClassroomFeaturePreferencesFieldsFragmentDoc = gql`
  fragment ClassroomFeaturesContextClassroomFeaturePreferencesFields on ClassroomFeaturePreferencesDto {
    aiTest {
      enabled
    }
    assignment {
      enabled
    }
    insights {
      enabled
    }
    cumulativeRecord {
      enabled
    }
    jello {
      enabled
    }
    classtalk {
      enabled
    }
    memberList {
      enabled
    }
    classroomSettings {
      enabled
    }
  }
`;
export const SchoolInfoForChildrenFormSchoolInfo2FieldsFragmentDoc = gql`
  fragment SchoolInfoForChildrenFormSchoolInfo2Fields on SchoolInfo2 {
    grade
    school {
      id
      name
    }
  }
`;
export const SchoolInfoFormSchoolInfoFieldsFragmentDoc = gql`
  fragment SchoolInfoFormSchoolInfoFields on SchoolInfo {
    grade
    school {
      id
      name
    }
  }
`;
export const SchoolInfoFormMemberFieldsFragmentDoc = gql`
  fragment SchoolInfoFormMemberFields on MemberDto {
    id
    group
  }
`;
export const AssignmentFormPostDtoFieldsFragmentDoc = gql`
  fragment AssignmentFormPostDtoFields on PostDto {
    id
    title
    content
    channelId
    status
    authorId
  }
`;
export const AssignmentFormAssignmentDtoFieldsFragmentDoc = gql`
  fragment AssignmentFormAssignmentDtoFields on AssignmentDto {
    id
    postId
    dueDateTime
    maxPoints
    assigneeIds
    type
  }
`;
export const ChannelAssigneeListMemberDtoFieldsFragmentDoc = gql`
  fragment ChannelAssigneeListMemberDtoFields on MemberDto {
    id
    name
    role
    group
    profileImageUrl
    active
    blocked
  }
`;
export const ChannelSelectDrawerMemberFieldsFragmentDoc = gql`
  fragment ChannelSelectDrawerMemberFields on MemberDto {
    id
    name
    role
    group
    profileImageUrl
  }
`;
export const AssignmentInfoAssignmentDtoFieldsFragmentDoc = gql`
  fragment AssignmentInfoAssignmentDtoFields on AssignmentDto {
    id
    assigneeIds
    assigneesCount
    authorId
    channelId
    classroomId
    createdAt
    dueDateTime
    maxPoints
    membersSubmittedCount
    postId
    updatedAt
    type
    meta
  }
`;
export const AssignmentInfoForAssigneeSubmissionDtoFieldsFragmentDoc = gql`
  fragment AssignmentInfoForAssigneeSubmissionDtoFields on SubmissionDto {
    id
    text
    fileIds
    imageIds
    createdAt
  }
`;
export const AssignmentInfoForAssigneeLearningSubmissionDtoFieldsFragmentDoc = gql`
  fragment AssignmentInfoForAssigneeLearningSubmissionDtoFields on LearningSubmissionDto {
    id
    createdAt
  }
`;
export const AssignmentInfoForAssigneeAssignmentSubmissionDtoFieldsFragmentDoc = gql`
  fragment AssignmentInfoForAssigneeAssignmentSubmissionDtoFields on AssignmentSubmissionDto {
    id
    assignmentId
    assigneeId
    classroomId
    points
    submissions {
      ...AssignmentInfoForAssigneeSubmissionDtoFields
    }
    learningSubmission {
      ...AssignmentInfoForAssigneeLearningSubmissionDtoFields
    }
    lastSubmission {
      ...AssignmentInfoForAssigneeSubmissionDtoFields
    }
    isSubmitted
    status
    gradingStatus
    createdAt
    updatedAt
    commentsCount
    repliesCount
  }
  ${AssignmentInfoForAssigneeSubmissionDtoFieldsFragmentDoc}
  ${AssignmentInfoForAssigneeLearningSubmissionDtoFieldsFragmentDoc}
`;
export const AssignmentSubmissionCommentItemAssignmentSubmissionCommentFieldsFragmentDoc = gql`
  fragment AssignmentSubmissionCommentItemAssignmentSubmissionCommentFields on AssignmentSubmissionCommentDto {
    id
    assigneeId
    assignmentId
    classroomId
    content
    createdAt
    updatedAt
    repliesCount
    author {
      id
      name
      profileImageUrl
      role
    }
  }
`;
export const AssignmentSubmissionNavItemAssignmentDtoFieldsFragmentDoc = gql`
  fragment AssignmentSubmissionNavItemAssignmentDtoFields on AssignmentDto {
    id
    maxPoints
    dueDateTime
    type
  }
`;
export const EditableLearningCardLearningCardFieldsFragmentDoc = gql`
  fragment EditableLearningCardLearningCardFields on LearningCard {
    id
    maxPoints
  }
`;
export const LearningCardExtensionLearningCardFieldsFragmentDoc = gql`
  fragment LearningCardExtensionLearningCardFields on LearningCard {
    id
    title
    authorName
    chapterName
    pageCount
    quizCount
    coverImageSmall
    coverImageLarge
    storeCardId
    shareLevel
    maxPoints
    grade {
      id
      name
    }
    subject {
      id
      name
    }
  }
`;
export const LearningCardItemLearningCardFieldsFragmentDoc = gql`
  fragment LearningCardItemLearningCardFields on LearningCard {
    id
    title
    authorName
    chapterName
    pageCount
    quizCount
    coverImageSmall
    coverImageLarge
    storeCardId
    shareLevel
    grade {
      id
      name
    }
    subject {
      id
      name
    }
  }
`;
export const LearningCardViewerIframeLearningUserAnswerDtoFieldsFragmentDoc = gql`
  fragment LearningCardViewerIframeLearningUserAnswerDtoFields on LearningUserAnswerDto {
    essay
    textEntry
    multipleChoiceOption
    pageIndex
    pageId
    duration
    isCorrect
    pageType
  }
`;
export const SubmissionContentAssignmentDtoFieldsFragmentDoc = gql`
  fragment SubmissionContentAssignmentDtoFields on AssignmentDto {
    id
    dueDateTime
    maxPoints
    type
  }
`;
export const AssignmentReportAssignmentSubmissionDtoFieldsFragmentDoc = gql`
  fragment AssignmentReportAssignmentSubmissionDtoFields on AssignmentSubmissionDto {
    id
    assignmentId
    assigneeId
    classroomId
    points
    status
    gradingStatus
    isSubmitted
    lastSubmission {
      id
      createdAt
    }
    learningSubmission {
      id
      answers {
        pageType
        pageId
      }
    }
    createdAt
    updatedAt
  }
`;
export const AssignmentReportAssignmentDtoFieldsFragmentDoc = gql`
  fragment AssignmentReportAssignmentDtoFields on AssignmentDto {
    id
    assigneesCount
    assigneeIds
    channelId
    classroomId
    createdAt
    dueDateTime
    maxPoints
    membersSubmittedCount
    postId
    updatedAt
    type
    assignmentSubmissions {
      ...AssignmentReportAssignmentSubmissionDtoFields
    }
  }
  ${AssignmentReportAssignmentSubmissionDtoFieldsFragmentDoc}
`;
export const AssignmentReportMemberFieldsFragmentDoc = gql`
  fragment AssignmentReportMemberFields on MemberDto {
    id
    profileImageUrl
    active
    name
    role
  }
`;
export const AssignmentReportPostFieldsFragmentDoc = gql`
  fragment AssignmentReportPostFields on PostDto {
    id
    title
    assignmentId
  }
`;
export const AssignmentSubmissionNavItemAssignmentSubmissionDtoFieldsFragmentDoc = gql`
  fragment AssignmentSubmissionNavItemAssignmentSubmissionDtoFields on AssignmentSubmissionDto {
    id
    assigneeId
    assignmentId
    points
    createdAt
    gradingStatus
    status
    learningSubmission {
      answers {
        pageType
        points
      }
    }
  }
`;
export const SubmissionContentSubmissionDtoFieldsFragmentDoc = gql`
  fragment SubmissionContentSubmissionDtoFields on SubmissionDto {
    id
    text
    fileIds
    imageIds
    createdAt
  }
`;
export const LearningSubmissionUserAnswerItemLearningUserAnswerDtoFieldsFragmentDoc = gql`
  fragment LearningSubmissionUserAnswerItemLearningUserAnswerDtoFields on LearningUserAnswerDto {
    userInput
    duration
    isCorrect
    pageType
    pageId
    multipleChoiceOption
    textEntry
    essay
    pageIndex
    maxPoints
    points
    correctOptions
  }
`;
export const SubmissionContentAssignmentSubmissionDtoFieldsFragmentDoc = gql`
  fragment SubmissionContentAssignmentSubmissionDtoFields on AssignmentSubmissionDto {
    id
    createdAt
    assigneeId
    assignmentId
    points
    gradingStatus
    submissions {
      ...SubmissionContentSubmissionDtoFields
    }
    learningSubmission {
      id
      answers {
        ...LearningSubmissionUserAnswerItemLearningUserAnswerDtoFields
      }
      createdAt
      updatedAt
    }
    lastSubmission {
      ...SubmissionContentSubmissionDtoFields
    }
    commentsCount
  }
  ${SubmissionContentSubmissionDtoFieldsFragmentDoc}
  ${LearningSubmissionUserAnswerItemLearningUserAnswerDtoFieldsFragmentDoc}
`;
export const AssignmentSubmissionPageAssignmentSubmissionDtoFieldsFragmentDoc = gql`
  fragment AssignmentSubmissionPageAssignmentSubmissionDtoFields on AssignmentSubmissionDto {
    id
    ...AssignmentSubmissionNavItemAssignmentSubmissionDtoFields
    ...SubmissionContentAssignmentSubmissionDtoFields
  }
  ${AssignmentSubmissionNavItemAssignmentSubmissionDtoFieldsFragmentDoc}
  ${SubmissionContentAssignmentSubmissionDtoFieldsFragmentDoc}
`;
export const ChannelFormClassroomFieldsFragmentDoc = gql`
  fragment ChannelFormClassroomFields on ClassroomDto {
    id
    name
  }
`;
export const ChannelFormChannelGroupFieldsFragmentDoc = gql`
  fragment ChannelFormChannelGroupFields on ChannelGroupDto {
    id
    name
    primary
  }
`;
export const ChannelFormChannelFieldsFragmentDoc = gql`
  fragment ChannelFormChannelFields on ChannelDto {
    classroomId
    id
    name
    purpose
    canMemberWritePost
    canMemberWriteComment
    canMemberReactToPost
    archived
    autoJoin
    channelGroupId
    isPrivate
    isCommon
  }
`;
export const ChannelGroupFormChannelGroupFieldsFragmentDoc = gql`
  fragment ChannelGroupFormChannelGroupFields on ChannelGroupDto {
    id
    name
  }
`;
export const ChannelListItemChannelFieldsFragmentDoc = gql`
  fragment ChannelListItemChannelFields on ChannelDto {
    id
    name
    purpose
    membersCount
    archived
    isPrivate
  }
`;
export const ChannelMembersSelectorMemberFieldsFragmentDoc = gql`
  fragment ChannelMembersSelectorMemberFields on MemberDto {
    id
    name
    profileImageUrl
    group
    role
  }
`;
export const ChannelNavItemChannelFieldsFragmentDoc = gql`
  fragment ChannelNavItemChannelFields on ChannelDto {
    id
    channelGroupId
    classroomId
    name
    archived
    isPrivate
  }
`;
export const ChannelNavItemMemberFieldsFragmentDoc = gql`
  fragment ChannelNavItemMemberFields on MemberDto {
    id
  }
`;
export const ClassAiTutorDrawerClassroomFieldsFragmentDoc = gql`
  fragment ClassAiTutorDrawerClassroomFields on ClassroomDto {
    id
    name
    grade
    orgId
    schoolName
  }
`;
export const ClassroomFormClassroomFieldsFragmentDoc = gql`
  fragment ClassroomFormClassroomFields on ClassroomDto {
    id
    name
    schoolId
    schoolName
    schoolYear
    grade
    about
  }
`;
export const ClassroomProfileImageClassroomFieldsFragmentDoc = gql`
  fragment ClassroomProfileImageClassroomFields on ClassroomDto {
    id
    profileImageUrl
  }
`;
export const SelectBelongedOrganizationOrganizationDtoFieldsFragmentDoc = gql`
  fragment SelectBelongedOrganizationOrganizationDtoFields on OrganizationOrganizationDto {
    id
    name
    city
  }
`;
export const DeactivateMyselfMemberFieldsFragmentDoc = gql`
  fragment DeactivateMyselfMemberFields on MemberDto {
    id
    role
  }
`;
export const InvitationByQrCodeClassroomEnterpriseDtoFieldsFragmentDoc = gql`
  fragment InvitationByQrCodeClassroomEnterpriseDtoFields on ClassroomEnterpriseDto {
    slug
  }
`;
export const ClassroomInfoClassroomFieldsFragmentDoc = gql`
  fragment ClassroomInfoClassroomFields on ClassroomDto {
    id
    name
    schoolId
    schoolName
    profileImageUrl
    membersCount
  }
`;
export const SideMenuClassroomFieldsFragmentDoc = gql`
  fragment SideMenuClassroomFields on ClassroomDto {
    id
    grade
    countryCode
  }
`;
export const NavigationMenuClassroomFieldsFragmentDoc = gql`
  fragment NavigationMenuClassroomFields on ClassroomDto {
    id
    ...SideMenuClassroomFields
  }
  ${SideMenuClassroomFieldsFragmentDoc}
`;
export const SideNavigationClassroomFieldsFragmentDoc = gql`
  fragment SideNavigationClassroomFields on ClassroomDto {
    id
    ...ClassroomInfoClassroomFields
    ...NavigationMenuClassroomFields
  }
  ${ClassroomInfoClassroomFieldsFragmentDoc}
  ${NavigationMenuClassroomFieldsFragmentDoc}
`;
export const NavbarClassroomFieldsFragmentDoc = gql`
  fragment NavbarClassroomFields on ClassroomDto {
    id
    name
    ...SideNavigationClassroomFields
  }
  ${SideNavigationClassroomFieldsFragmentDoc}
`;
export const OnboardingChecklistProgressOnboardingChecklistFieldsFragmentDoc = gql`
  fragment OnboardingChecklistProgressOnboardingChecklistFields on OnboardingChecklistDto {
    id
    progress
  }
`;
export const RegisterForClassroomFormAccountFieldsFragmentDoc = gql`
  fragment RegisterForClassroomFormAccountFields on AccountDto {
    id
    name
    profileImage
    role
  }
`;
export const SearchSchoolOrganizationDtoFieldsFragmentDoc = gql`
  fragment SearchSchoolOrganizationDtoFields on OrganizationOrganizationDto {
    id
    name
    countryCode
    city
  }
`;
export const SideNavigationMemberFieldsFragmentDoc = gql`
  fragment SideNavigationMemberFields on MemberDto {
    id
    role
    group
    name
    profileImageUrl
  }
`;
export const SideNavigationCommonChannelFieldsFragmentDoc = gql`
  fragment SideNavigationCommonChannelFields on ChannelDto {
    id
    name
    channelType
    iconUrl
  }
`;
export const SideMenuCheckListFieldsFragmentDoc = gql`
  fragment SideMenuCheckListFields on OnboardingChecklistDto {
    id
    isActive
  }
`;
export const ClassroomInfoPageClassroomFieldsFragmentDoc = gql`
  fragment ClassroomInfoPageClassroomFields on ClassroomDto {
    id
    name
    profileImageUrl
    schoolName
    schoolYear
    membersCount
    grade
  }
`;
export const MobileNavigationMenuCommonChannelFieldsFragmentDoc = gql`
  fragment MobileNavigationMenuCommonChannelFields on ChannelDto {
    id
    name
    channelType
    iconUrl
  }
`;
export const SignUpAdminPageMemberFieldsFragmentDoc = gql`
  fragment SignUpAdminPageMemberFields on MemberDto {
    id
    name
    profileImageUrl
    profileImageId
    classroomId
  }
`;
export const ClasstalkChatButtonMemberFieldsFragmentDoc = gql`
  fragment ClasstalkChatButtonMemberFields on MemberDto {
    id
    name
    profileImageUrl
    role
    active
    group
    blocked
    classroomId
  }
`;
export const CommentItemCommentFieldsFragmentDoc = gql`
  fragment CommentItemCommentFields on CommentDto {
    id
    postId
    classroomId
    content
    createdAt
    updatedAt
    repliesCount
    author {
      id
      name
      profileImageUrl
      role
      blocked
      active
    }
    reactions {
      memberId
      name
    }
    reactionsCount
  }
`;
export const MemberItemMemberFieldsFragmentDoc = gql`
  fragment MemberItemMemberFields on MemberDto {
    id
    name
    profileImageUrl
    group
    role
    active
  }
`;
export const CommentItemCommentReactionFieldsFragmentDoc = gql`
  fragment CommentItemCommentReactionFields on CommentReactionDto {
    name
    member {
      id
      name
      role
      profileImageUrl
      group
      blocked
      ...MemberItemMemberFields
    }
  }
  ${MemberItemMemberFieldsFragmentDoc}
`;
export const WriteCommentPostFieldsFragmentDoc = gql`
  fragment WriteCommentPostFields on PostDto {
    id
  }
`;
export const CommentItemPostFieldsFragmentDoc = gql`
  fragment CommentItemPostFields on PostDto {
    id
    classroomId
  }
`;
export const CommentListPostDtoFieldsFragmentDoc = gql`
  fragment CommentListPostDtoFields on PostDto {
    id
    classroomId
    commentsCount
    repliesCount
    ...WriteCommentPostFields
    ...CommentItemPostFields
  }
  ${WriteCommentPostFieldsFragmentDoc}
  ${CommentItemPostFieldsFragmentDoc}
`;
export const ReplyItemReplyFieldsFragmentDoc = gql`
  fragment ReplyItemReplyFields on ReplyDto {
    id
    commentId
    postId
    author {
      id
      name
      profileImageUrl
      blocked
      active
    }
    content
    createdAt
    updatedAt
    reactions {
      memberId
      name
    }
    reactionsCount
  }
`;
export const ReplyItemReplyReactionFieldsFragmentDoc = gql`
  fragment ReplyItemReplyReactionFields on ReplyReactionDto {
    name
    member {
      id
      name
      role
      profileImageUrl
      blocked
      ...MemberItemMemberFields
    }
  }
  ${MemberItemMemberFieldsFragmentDoc}
`;
export const MemberProfileMemberFieldsFragmentDoc = gql`
  fragment MemberProfileMemberFields on MemberDto {
    id
    name
    profileImageUrl
    role
    active
    group
    blocked
  }
`;
export const MemberProfileImageMemberFieldsFragmentDoc = gql`
  fragment MemberProfileImageMemberFields on MemberDto {
    id
    name
    classroomId
    profileImageId
    profileImageUrl
  }
`;
export const NotificationItemNotificationFieldsFragmentDoc = gql`
  fragment NotificationItemNotificationFields on NotificationDto {
    id
    type
    object
    publishedAt
    actor
    target
    summary
    read
    content
    generator
  }
`;
export const NotificationListNotificationsCollectionFieldsFragmentDoc = gql`
  fragment NotificationListNotificationsCollectionFields on NotificationsCollectionDto {
    notifications {
      ...NotificationItemNotificationFields
    }
    cursor
  }
  ${NotificationItemNotificationFieldsFragmentDoc}
`;
export const PostTypeTagPostFieldsFragmentDoc = gql`
  fragment PostTypeTagPostFields on PostDto {
    id
    classroomId
    assignmentId
    isAnnouncement
  }
`;
export const DraftPostItemPostFieldsFragmentDoc = gql`
  fragment DraftPostItemPostFields on PostDto {
    id
    classroomId
    channelId
    title
    summary
    updatedAt
    tags
    coverImageUrl
    type
    assignmentId
    adminExclusive
    status
    scheduledAt
    publishedAt
    ...PostTypeTagPostFields
  }
  ${PostTypeTagPostFieldsFragmentDoc}
`;
export const DraftPostItemChannelFieldsFragmentDoc = gql`
  fragment DraftPostItemChannelFields on ChannelDto {
    id
    name
    isPrivate
    channelType
  }
`;
export const GalleryPostDtoFieldsFragmentDoc = gql`
  fragment GalleryPostDtoFields on PostDto {
    id
    title
    summary
    classroomId
    channelId
    createdAt
    images {
      id
      originalFileName
      urls
    }
    videos {
      id
      originalFileName
      posterUrl
      streamUrl
      urls
    }
  }
`;
export const MarkPostAsReadPostFieldsFragmentDoc = gql`
  fragment MarkPostAsReadPostFields on PostDto {
    id
    classroomId
    title
  }
`;
export const PinnedPostItemPostFieldsFragmentDoc = gql`
  fragment PinnedPostItemPostFields on PostDto {
    id
    title
    isAnnouncement
    summary
    coverImageUrl
    fileIds
    publishedAt
    classroomId
    channelId
  }
`;
export const PostContentPostFieldsFragmentDoc = gql`
  fragment PostContentPostFields on PostDto {
    id
    content
    imageIds
    classroomId
    title
  }
`;
export const PostFeedAssignmentStatusAssignmentDtoFieldsFragmentDoc = gql`
  fragment PostFeedAssignmentStatusAssignmentDtoFields on AssignmentDto {
    id
    dueDateTime
    assigneesCount
    membersSubmittedCount
  }
`;
export const PostFeedItemFooterPostFieldsFragmentDoc = gql`
  fragment PostFeedItemFooterPostFields on PostDto {
    commentsCount
    reactionsCount
    readsCount
  }
`;
export const PostMoreMenuPostFieldsFragmentDoc = gql`
  fragment PostMoreMenuPostFields on PostDto {
    id
    channelId
    classroomId
    assignmentId
    type
    isPinned
    author {
      id
      name
    }
    adminExclusive
  }
`;
export const PostFeedItemHeaderPostFieldsFragmentDoc = gql`
  fragment PostFeedItemHeaderPostFields on PostDto {
    classroomId
    channelId
    title
    publishedAt
    summary
    author {
      id
      name
      profileImageUrl
      blocked
    }
    adminExclusive
    ...PostMoreMenuPostFields
    ...PostTypeTagPostFields
  }
  ${PostMoreMenuPostFieldsFragmentDoc}
  ${PostTypeTagPostFieldsFragmentDoc}
`;
export const PostFeedAssignmentStatusPostDtoFieldsFragmentDoc = gql`
  fragment PostFeedAssignmentStatusPostDtoFields on PostDto {
    id
    classroomId
    assignmentId
    content
  }
`;
export const PostFeedItemPostFieldsFragmentDoc = gql`
  fragment PostFeedItemPostFields on PostDto {
    id
    classroomId
    channelId
    isAnnouncement
    summary
    content
    coverImageUrl
    tags
    type
    fileIds
    publishedAt
    readsCount
    ...PostFeedItemFooterPostFields
    ...PostFeedItemHeaderPostFields
    ...PostTypeTagPostFields
    ...PostFeedAssignmentStatusPostDtoFields
  }
  ${PostFeedItemFooterPostFieldsFragmentDoc}
  ${PostFeedItemHeaderPostFieldsFragmentDoc}
  ${PostTypeTagPostFieldsFragmentDoc}
  ${PostFeedAssignmentStatusPostDtoFieldsFragmentDoc}
`;
export const PostFeedPinnedPostItemPostFieldsFragmentDoc = gql`
  fragment PostFeedPinnedPostItemPostFields on PostDto {
    id
    title
    isAnnouncement
    summary
    coverImageUrl
    fileIds
    publishedAt
    classroomId
    channelId
  }
`;
export const PostFeedPinnedPostItemChannelPostPinDtoFieldsFragmentDoc = gql`
  fragment PostFeedPinnedPostItemChannelPostPinDtoFields on ChannelPostPinDto {
    id
    post {
      ...PostFeedPinnedPostItemPostFields
    }
  }
  ${PostFeedPinnedPostItemPostFieldsFragmentDoc}
`;
export const InsertLinkPopupUrlMetadataFieldsFragmentDoc = gql`
  fragment InsertLinkPopupUrlMetadataFields on UrlMetadata {
    url
    title
    description
    image
    logo
  }
`;
export const PostFormPostFieldsFragmentDoc = gql`
  fragment PostFormPostFields on PostDto {
    id
    title
    content
    channelId
    status
    tags
    isAnnouncement
    adminExclusive
    scheduledAt
  }
`;
export const PostFormChannelFieldsFragmentDoc = gql`
  fragment PostFormChannelFields on ChannelDto {
    id
    name
    isPrivate
    channelType
  }
`;
export const PostFormMemberFieldsFragmentDoc = gql`
  fragment PostFormMemberFields on MemberDto {
    id
    role
  }
`;
export const ChannelSelectChannelFieldsFragmentDoc = gql`
  fragment ChannelSelectChannelFields on ChannelDto {
    id
    name
    isPrivate
    channelType
    canMemberWritePost
    archived
  }
`;
export const PostFormChannelGroupFieldsFragmentDoc = gql`
  fragment PostFormChannelGroupFields on ChannelGroupDto {
    id
    name
    channels {
      ...ChannelSelectChannelFields
    }
  }
  ${ChannelSelectChannelFieldsFragmentDoc}
`;
export const PostReminderPostFieldsFragmentDoc = gql`
  fragment PostReminderPostFields on PostDto {
    id
    classroomId
    lastNotifiedAt
  }
`;
export const PostRecipientsPostFieldsFragmentDoc = gql`
  fragment PostRecipientsPostFields on PostDto {
    id
    classroomId
    channelId
    readsCount
    ...PostReminderPostFields
  }
  ${PostReminderPostFieldsFragmentDoc}
`;
export const AuthorInfoPostFieldsFragmentDoc = gql`
  fragment AuthorInfoPostFields on PostDto {
    id
    publishedAt
    updatedAt
    author {
      id
      name
      profileImageUrl
      blocked
    }
    adminExclusive
    ...PostRecipientsPostFields
  }
  ${PostRecipientsPostFieldsFragmentDoc}
`;
export const PostHeaderPostFieldsFragmentDoc = gql`
  fragment PostHeaderPostFields on PostDto {
    id
    title
    isAnnouncement
    adminExclusive
    assignmentId
    type
    ...AuthorInfoPostFields
    ...PostMoreMenuPostFields
  }
  ${AuthorInfoPostFieldsFragmentDoc}
  ${PostMoreMenuPostFieldsFragmentDoc}
`;
export const PostHeaderAssignmentFieldsFragmentDoc = gql`
  fragment PostHeaderAssignmentFields on AssignmentDto {
    id
    type
  }
`;
export const PostMetaPostFieldsFragmentDoc = gql`
  fragment PostMetaPostFields on PostDto {
    commentsCount
    reactionsCount
  }
`;
export const PostItemHeaderPostFieldsFragmentDoc = gql`
  fragment PostItemHeaderPostFields on PostDto {
    classroomId
    channelId
    title
    publishedAt
    author {
      id
      name
      profileImageUrl
      blocked
    }
    adminExclusive
  }
`;
export const PostItemPostFieldsFragmentDoc = gql`
  fragment PostItemPostFields on PostDto {
    id
    classroomId
    channelId
    isAnnouncement
    summary
    coverImageUrl
    tags
    type
    assignmentId
    fileIds
    publishedAt
    ...PostMetaPostFields
    ...PostItemHeaderPostFields
    ...PostTypeTagPostFields
  }
  ${PostMetaPostFieldsFragmentDoc}
  ${PostItemHeaderPostFieldsFragmentDoc}
  ${PostTypeTagPostFieldsFragmentDoc}
`;
export const PostTypeTagAssignmentDtoFieldsFragmentDoc = gql`
  fragment PostTypeTagAssignmentDtoFields on AssignmentDto {
    id
    type
  }
`;
export const AssignmentStatusTagAssignmentDtoFieldsFragmentDoc = gql`
  fragment AssignmentStatusTagAssignmentDtoFields on AssignmentDto {
    id
    classroomId
    dueDateTime
  }
`;
export const PostItemBodyAssignmentDtoFieldsFragmentDoc = gql`
  fragment PostItemBodyAssignmentDtoFields on AssignmentDto {
    id
    postId
    dueDateTime
    classroomId
    assigneesCount
    membersSubmittedCount
    type
    ...PostTypeTagAssignmentDtoFields
    ...AssignmentStatusTagAssignmentDtoFields
  }
  ${PostTypeTagAssignmentDtoFieldsFragmentDoc}
  ${AssignmentStatusTagAssignmentDtoFieldsFragmentDoc}
`;
export const PostReactionPostFieldsFragmentDoc = gql`
  fragment PostReactionPostFields on PostDto {
    id
    classroomId
    reactionsCount
    reactions {
      memberId
      name
    }
  }
`;
export const PostReactionListPostFieldsFragmentDoc = gql`
  fragment PostReactionListPostFields on PostDto {
    id
    classroomId
  }
`;
export const PostRecipientsMemberFieldsFragmentDoc = gql`
  fragment PostRecipientsMemberFields on MemberDto {
    id
    name
    profileImageUrl
    group
    role
    active
    blocked
  }
`;
export const PostWriteCommentAndReactChannelFieldsFragmentDoc = gql`
  fragment PostWriteCommentAndReactChannelFields on ChannelDto {
    canMemberWriteComment
    canMemberReactToPost
  }
`;
export const WritePostButtonChannelFragmentDoc = gql`
  fragment WritePostButtonChannelFragment on ChannelDto {
    id
    channelType
    name
  }
`;
export const AnnouncementFormPostFieldsFragmentDoc = gql`
  fragment AnnouncementFormPostFields on PostDto {
    id
    title
    content
    channelId
    status
    tags
    isAnnouncement
    scheduledAt
  }
`;
export const AnnouncementsPageHeaderCurrentMemberFieldsFragmentDoc = gql`
  fragment AnnouncementsPageHeaderCurrentMemberFields on MemberDto {
    id
    role
  }
`;
export const WritePostPopupChannelFieldsFragmentDoc = gql`
  fragment WritePostPopupChannelFields on ChannelDto {
    id
    channelType
  }
`;
export const WritePostChannelSelectorChannelFieldsFragmentDoc = gql`
  fragment WritePostChannelSelectorChannelFields on ChannelDto {
    id
    name
    canMemberWritePost
    isPrivate
    ...WritePostPopupChannelFields
  }
  ${WritePostPopupChannelFieldsFragmentDoc}
`;
export const CanWritePostChannelsChannelFieldsFragmentDoc = gql`
  fragment CanWritePostChannelsChannelFields on ChannelDto {
    id
    canMemberWritePost
    archived
    ...WritePostChannelSelectorChannelFields
  }
  ${WritePostChannelSelectorChannelFieldsFragmentDoc}
`;
export const WritePostChannelSelectorChannelGroupFieldsFragmentDoc = gql`
  fragment WritePostChannelSelectorChannelGroupFields on ChannelGroupDto {
    id
    name
    channels {
      ...WritePostChannelSelectorChannelFields
    }
  }
  ${WritePostChannelSelectorChannelFieldsFragmentDoc}
`;
export const CanWritePostChannelsChannelGroupFieldsFragmentDoc = gql`
  fragment CanWritePostChannelsChannelGroupFields on ChannelGroupDto {
    id
    channels {
      ...CanWritePostChannelsChannelFields
    }
    ...WritePostChannelSelectorChannelGroupFields
  }
  ${CanWritePostChannelsChannelFieldsFragmentDoc}
  ${WritePostChannelSelectorChannelGroupFieldsFragmentDoc}
`;
export const UpdatePostMutationDocument = gql`
  mutation updatePostMutation(
    $classroomId: String!
    $postId: String!
    $updatePostDtoInput: UpdatePostDtoInput!
  ) {
    post: updatePost(
      classroomId: $classroomId
      postId: $postId
      updatePostDtoInput: $updatePostDtoInput
    ) {
      id
      content
      title
      imageIds
      videoIds
      fileIds
      createdAt
      updatedAt
      channelId
    }
  }
`;
export type UpdatePostMutationMutationFn = Apollo.MutationFunction<
  UpdatePostMutation,
  UpdatePostMutationVariables
>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      updatePostDtoInput: // value for 'updatePostDtoInput'
 *   },
 * });
 */
export function useUpdatePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePostMutation,
    UpdatePostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(
    UpdatePostMutationDocument,
    options
  );
}
export type UpdatePostMutationHookResult = ReturnType<
  typeof useUpdatePostMutation
>;
export type UpdatePostMutationMutationResult =
  Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdatePostMutation,
  UpdatePostMutationVariables
>;
export const UpdateClassroomMemberMutationDocument = gql`
  mutation updateClassroomMemberMutation(
    $classroomId: String!
    $memberId: String!
    $updateMemberDtoInput: UpdateMemberDtoInput!
  ) {
    member: updateClassroomMember(
      classroomId: $classroomId
      memberId: $memberId
      updateMemberDtoInput: $updateMemberDtoInput
    ) {
      classroomId
      id
      name
      profileImageUrl
      role
    }
  }
`;
export type UpdateClassroomMemberMutationMutationFn = Apollo.MutationFunction<
  UpdateClassroomMemberMutation,
  UpdateClassroomMemberMutationVariables
>;

/**
 * __useUpdateClassroomMemberMutation__
 *
 * To run a mutation, you first call `useUpdateClassroomMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassroomMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassroomMemberMutation, { data, loading, error }] = useUpdateClassroomMemberMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *      updateMemberDtoInput: // value for 'updateMemberDtoInput'
 *   },
 * });
 */
export function useUpdateClassroomMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClassroomMemberMutation,
    UpdateClassroomMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateClassroomMemberMutation,
    UpdateClassroomMemberMutationVariables
  >(UpdateClassroomMemberMutationDocument, options);
}
export type UpdateClassroomMemberMutationHookResult = ReturnType<
  typeof useUpdateClassroomMemberMutation
>;
export type UpdateClassroomMemberMutationMutationResult =
  Apollo.MutationResult<UpdateClassroomMemberMutation>;
export type UpdateClassroomMemberMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateClassroomMemberMutation,
    UpdateClassroomMemberMutationVariables
  >;
export const CreateImageMutationDocument = gql`
  mutation createImageMutation($createImageDtoInput: CreateImageDtoInput!) {
    image: createImage(createImageDtoInput: $createImageDtoInput) {
      id
      userId
      contentType
      categoryId
      categoryType
      totalSize
      originalFileName
      createdAt
      presignedPost
      urls
    }
  }
`;
export type CreateImageMutationMutationFn = Apollo.MutationFunction<
  CreateImageMutation,
  CreateImageMutationVariables
>;

/**
 * __useCreateImageMutation__
 *
 * To run a mutation, you first call `useCreateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageMutation, { data, loading, error }] = useCreateImageMutation({
 *   variables: {
 *      createImageDtoInput: // value for 'createImageDtoInput'
 *   },
 * });
 */
export function useCreateImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateImageMutation,
    CreateImageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateImageMutation, CreateImageMutationVariables>(
    CreateImageMutationDocument,
    options
  );
}
export type CreateImageMutationHookResult = ReturnType<
  typeof useCreateImageMutation
>;
export type CreateImageMutationMutationResult =
  Apollo.MutationResult<CreateImageMutation>;
export type CreateImageMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateImageMutation,
  CreateImageMutationVariables
>;
export const CreateFileMutationDocument = gql`
  mutation createFileMutation($createFileDtoInput: CreateFileDtoInput!) {
    file: createFile(createFileDtoInput: $createFileDtoInput) {
      id
      userId
      contentType
      categoryId
      categoryType
      totalSize
      originalFileName
      createdAt
      presignedPost
      urls
    }
  }
`;
export type CreateFileMutationMutationFn = Apollo.MutationFunction<
  CreateFileMutation,
  CreateFileMutationVariables
>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      createFileDtoInput: // value for 'createFileDtoInput'
 *   },
 * });
 */
export function useCreateFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFileMutation,
    CreateFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(
    CreateFileMutationDocument,
    options
  );
}
export type CreateFileMutationHookResult = ReturnType<
  typeof useCreateFileMutation
>;
export type CreateFileMutationMutationResult =
  Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateFileMutation,
  CreateFileMutationVariables
>;
export const CreateVideoMutationDocument = gql`
  mutation createVideoMutation($createVideoDtoInput: CreateVideoDtoInput!) {
    video: createVideo(createVideoDtoInput: $createVideoDtoInput) {
      id
      userId
      contentType
      categoryId
      categoryType
      totalSize
      originalFileName
      createdAt
      presignedPost
      urls
      resourceKey
      posterUrl
    }
  }
`;
export type CreateVideoMutationMutationFn = Apollo.MutationFunction<
  CreateVideoMutation,
  CreateVideoMutationVariables
>;

/**
 * __useCreateVideoMutation__
 *
 * To run a mutation, you first call `useCreateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoMutation, { data, loading, error }] = useCreateVideoMutation({
 *   variables: {
 *      createVideoDtoInput: // value for 'createVideoDtoInput'
 *   },
 * });
 */
export function useCreateVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVideoMutation,
    CreateVideoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateVideoMutation, CreateVideoMutationVariables>(
    CreateVideoMutationDocument,
    options
  );
}
export type CreateVideoMutationHookResult = ReturnType<
  typeof useCreateVideoMutation
>;
export type CreateVideoMutationMutationResult =
  Apollo.MutationResult<CreateVideoMutation>;
export type CreateVideoMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateVideoMutation,
  CreateVideoMutationVariables
>;
export const InviteMembersMutationDocument = gql`
  mutation inviteMembersMutation(
    $classroomId: String!
    $inviteMembersDtoInput: InviteMembersDtoInput!
  ) {
    inviteMembers(
      classroomId: $classroomId
      inviteMembersDtoInput: $inviteMembersDtoInput
    )
  }
`;
export type InviteMembersMutationMutationFn = Apollo.MutationFunction<
  InviteMembersMutation,
  InviteMembersMutationVariables
>;

/**
 * __useInviteMembersMutation__
 *
 * To run a mutation, you first call `useInviteMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMembersMutation, { data, loading, error }] = useInviteMembersMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      inviteMembersDtoInput: // value for 'inviteMembersDtoInput'
 *   },
 * });
 */
export function useInviteMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InviteMembersMutation,
    InviteMembersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InviteMembersMutation,
    InviteMembersMutationVariables
  >(InviteMembersMutationDocument, options);
}
export type InviteMembersMutationHookResult = ReturnType<
  typeof useInviteMembersMutation
>;
export type InviteMembersMutationMutationResult =
  Apollo.MutationResult<InviteMembersMutation>;
export type InviteMembersMutationMutationOptions = Apollo.BaseMutationOptions<
  InviteMembersMutation,
  InviteMembersMutationVariables
>;
export const FetchClassCodeQueryDocument = gql`
  query fetchClassCodeQuery($code: String!) {
    classCode: getClassCode(code: $code) {
      classroomId
      code
    }
  }
`;

/**
 * __useFetchClassCodeQuery__
 *
 * To run a query within a React component, call `useFetchClassCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchClassCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchClassCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useFetchClassCodeQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchClassCodeQuery,
    FetchClassCodeQueryVariables
  > &
    (
      | { variables: FetchClassCodeQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchClassCodeQuery, FetchClassCodeQueryVariables>(
    FetchClassCodeQueryDocument,
    options
  );
}
export function useFetchClassCodeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchClassCodeQuery,
    FetchClassCodeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchClassCodeQuery, FetchClassCodeQueryVariables>(
    FetchClassCodeQueryDocument,
    options
  );
}
export function useFetchClassCodeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchClassCodeQuery,
        FetchClassCodeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchClassCodeQuery,
    FetchClassCodeQueryVariables
  >(FetchClassCodeQueryDocument, options);
}
export type FetchClassCodeQueryHookResult = ReturnType<
  typeof useFetchClassCodeQuery
>;
export type FetchClassCodeQueryLazyQueryHookResult = ReturnType<
  typeof useFetchClassCodeQueryLazyQuery
>;
export type FetchClassCodeQuerySuspenseQueryHookResult = ReturnType<
  typeof useFetchClassCodeQuerySuspenseQuery
>;
export type FetchClassCodeQueryQueryResult = Apollo.QueryResult<
  FetchClassCodeQuery,
  FetchClassCodeQueryVariables
>;
export const FetchPostQueryDocument = gql`
  query fetchPostQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      channelId
      classroomId
      id
      content
      title
      tags
      commentsCount
      repliesCount
      createdAt
      updatedAt
      imageIds
      videoIds
      fileIds
      readsCount
      status
      author {
        id
        name
        profileImageUrl
      }
      reactionsCount
      reactions {
        memberId
        name
      }
      isAnnouncement
    }
  }
`;

/**
 * __useFetchPostQuery__
 *
 * To run a query within a React component, call `useFetchPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPostQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useFetchPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchPostQuery,
    FetchPostQueryVariables
  > &
    ({ variables: FetchPostQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchPostQuery, FetchPostQueryVariables>(
    FetchPostQueryDocument,
    options
  );
}
export function useFetchPostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchPostQuery,
    FetchPostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchPostQuery, FetchPostQueryVariables>(
    FetchPostQueryDocument,
    options
  );
}
export function useFetchPostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FetchPostQuery, FetchPostQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FetchPostQuery, FetchPostQueryVariables>(
    FetchPostQueryDocument,
    options
  );
}
export type FetchPostQueryHookResult = ReturnType<typeof useFetchPostQuery>;
export type FetchPostQueryLazyQueryHookResult = ReturnType<
  typeof useFetchPostQueryLazyQuery
>;
export type FetchPostQuerySuspenseQueryHookResult = ReturnType<
  typeof useFetchPostQuerySuspenseQuery
>;
export type FetchPostQueryQueryResult = Apollo.QueryResult<
  FetchPostQuery,
  FetchPostQueryVariables
>;
export const CurrentMemberQueryDocument = gql`
  query CurrentMemberQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      classroomId
      id
      name
      profileImageUrl
      role
      active
      createdAt
      updatedAt
      group
    }
  }
`;

/**
 * __useCurrentMemberQuery__
 *
 * To run a query within a React component, call `useCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentMemberQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useCurrentMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    CurrentMemberQuery,
    CurrentMemberQueryVariables
  > &
    (
      | { variables: CurrentMemberQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(
    CurrentMemberQueryDocument,
    options
  );
}
export function useCurrentMemberQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentMemberQuery,
    CurrentMemberQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(
    CurrentMemberQueryDocument,
    options
  );
}
export function useCurrentMemberQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentMemberQuery,
        CurrentMemberQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CurrentMemberQuery,
    CurrentMemberQueryVariables
  >(CurrentMemberQueryDocument, options);
}
export type CurrentMemberQueryHookResult = ReturnType<
  typeof useCurrentMemberQuery
>;
export type CurrentMemberQueryLazyQueryHookResult = ReturnType<
  typeof useCurrentMemberQueryLazyQuery
>;
export type CurrentMemberQuerySuspenseQueryHookResult = ReturnType<
  typeof useCurrentMemberQuerySuspenseQuery
>;
export type CurrentMemberQueryQueryResult = Apollo.QueryResult<
  CurrentMemberQuery,
  CurrentMemberQueryVariables
>;
export const FetchUrlMetadataDocument = gql`
  query fetchUrlMetadata($url: String!) {
    urlMetadata: getUrlMetadata(url: $url) {
      url
      title
      description
      author
      image
      logo
      video
      publisher
    }
  }
`;

/**
 * __useFetchUrlMetadataQuery__
 *
 * To run a query within a React component, call `useFetchUrlMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUrlMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUrlMetadataQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useFetchUrlMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchUrlMetadataQuery,
    FetchUrlMetadataQueryVariables
  > &
    (
      | { variables: FetchUrlMetadataQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchUrlMetadataQuery, FetchUrlMetadataQueryVariables>(
    FetchUrlMetadataDocument,
    options
  );
}
export function useFetchUrlMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchUrlMetadataQuery,
    FetchUrlMetadataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchUrlMetadataQuery,
    FetchUrlMetadataQueryVariables
  >(FetchUrlMetadataDocument, options);
}
export function useFetchUrlMetadataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchUrlMetadataQuery,
        FetchUrlMetadataQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchUrlMetadataQuery,
    FetchUrlMetadataQueryVariables
  >(FetchUrlMetadataDocument, options);
}
export type FetchUrlMetadataQueryHookResult = ReturnType<
  typeof useFetchUrlMetadataQuery
>;
export type FetchUrlMetadataLazyQueryHookResult = ReturnType<
  typeof useFetchUrlMetadataLazyQuery
>;
export type FetchUrlMetadataSuspenseQueryHookResult = ReturnType<
  typeof useFetchUrlMetadataSuspenseQuery
>;
export type FetchUrlMetadataQueryResult = Apollo.QueryResult<
  FetchUrlMetadataQuery,
  FetchUrlMetadataQueryVariables
>;
export const FetchListClassroomsDocument = gql`
  query fetchListClassrooms {
    managingClassrooms: listClassrooms(role: "admin", limit: 100) {
      classrooms {
        id
        name
        grade
        about
        schoolYear
        createdAt
        updatedAt
      }
      cursor
    }
    joinedClassrooms: listClassrooms(role: "member", limit: 100) {
      classrooms {
        id
        name
        grade
        about
        schoolYear
        createdAt
        updatedAt
      }
      cursor
    }
  }
`;

/**
 * __useFetchListClassroomsQuery__
 *
 * To run a query within a React component, call `useFetchListClassroomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchListClassroomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchListClassroomsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchListClassroomsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchListClassroomsQuery,
    FetchListClassroomsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchListClassroomsQuery,
    FetchListClassroomsQueryVariables
  >(FetchListClassroomsDocument, options);
}
export function useFetchListClassroomsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchListClassroomsQuery,
    FetchListClassroomsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchListClassroomsQuery,
    FetchListClassroomsQueryVariables
  >(FetchListClassroomsDocument, options);
}
export function useFetchListClassroomsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchListClassroomsQuery,
        FetchListClassroomsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchListClassroomsQuery,
    FetchListClassroomsQueryVariables
  >(FetchListClassroomsDocument, options);
}
export type FetchListClassroomsQueryHookResult = ReturnType<
  typeof useFetchListClassroomsQuery
>;
export type FetchListClassroomsLazyQueryHookResult = ReturnType<
  typeof useFetchListClassroomsLazyQuery
>;
export type FetchListClassroomsSuspenseQueryHookResult = ReturnType<
  typeof useFetchListClassroomsSuspenseQuery
>;
export type FetchListClassroomsQueryResult = Apollo.QueryResult<
  FetchListClassroomsQuery,
  FetchListClassroomsQueryVariables
>;
export const ClassroomVersionQueryDocument = gql`
  query ClassroomVersionQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      version
    }
  }
`;

/**
 * __useClassroomVersionQuery__
 *
 * To run a query within a React component, call `useClassroomVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomVersionQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassroomVersionQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomVersionQuery,
    ClassroomVersionQueryVariables
  > &
    (
      | { variables: ClassroomVersionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClassroomVersionQuery, ClassroomVersionQueryVariables>(
    ClassroomVersionQueryDocument,
    options
  );
}
export function useClassroomVersionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomVersionQuery,
    ClassroomVersionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomVersionQuery,
    ClassroomVersionQueryVariables
  >(ClassroomVersionQueryDocument, options);
}
export function useClassroomVersionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomVersionQuery,
        ClassroomVersionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomVersionQuery,
    ClassroomVersionQueryVariables
  >(ClassroomVersionQueryDocument, options);
}
export type ClassroomVersionQueryHookResult = ReturnType<
  typeof useClassroomVersionQuery
>;
export type ClassroomVersionQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomVersionQueryLazyQuery
>;
export type ClassroomVersionQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomVersionQuerySuspenseQuery
>;
export type ClassroomVersionQueryQueryResult = Apollo.QueryResult<
  ClassroomVersionQuery,
  ClassroomVersionQueryVariables
>;
export const ClassroomFeaturesContextQueryDocument = gql`
  query ClassroomFeaturesContextQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      ...ClassroomFeaturesContextClassroomFields
    }
    featurePreferences: classroomFeaturePreferences(classroomId: $classroomId) {
      id
      ...ClassroomFeaturesContextClassroomFeaturePreferencesFields
    }
  }
  ${ClassroomFeaturesContextClassroomFieldsFragmentDoc}
  ${ClassroomFeaturesContextClassroomFeaturePreferencesFieldsFragmentDoc}
`;

/**
 * __useClassroomFeaturesContextQuery__
 *
 * To run a query within a React component, call `useClassroomFeaturesContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomFeaturesContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomFeaturesContextQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassroomFeaturesContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomFeaturesContextQuery,
    ClassroomFeaturesContextQueryVariables
  > &
    (
      | { variables: ClassroomFeaturesContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassroomFeaturesContextQuery,
    ClassroomFeaturesContextQueryVariables
  >(ClassroomFeaturesContextQueryDocument, options);
}
export function useClassroomFeaturesContextQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomFeaturesContextQuery,
    ClassroomFeaturesContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomFeaturesContextQuery,
    ClassroomFeaturesContextQueryVariables
  >(ClassroomFeaturesContextQueryDocument, options);
}
export function useClassroomFeaturesContextQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomFeaturesContextQuery,
        ClassroomFeaturesContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomFeaturesContextQuery,
    ClassroomFeaturesContextQueryVariables
  >(ClassroomFeaturesContextQueryDocument, options);
}
export type ClassroomFeaturesContextQueryHookResult = ReturnType<
  typeof useClassroomFeaturesContextQuery
>;
export type ClassroomFeaturesContextQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomFeaturesContextQueryLazyQuery
>;
export type ClassroomFeaturesContextQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomFeaturesContextQuerySuspenseQuery
>;
export type ClassroomFeaturesContextQueryQueryResult = Apollo.QueryResult<
  ClassroomFeaturesContextQuery,
  ClassroomFeaturesContextQueryVariables
>;
export const GrowthBookProviderQueryDocument = gql`
  query GrowthBookProviderQuery {
    me: getMe {
      id
      enterprise {
        id
      }
    }
  }
`;

/**
 * __useGrowthBookProviderQuery__
 *
 * To run a query within a React component, call `useGrowthBookProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowthBookProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowthBookProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGrowthBookProviderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GrowthBookProviderQuery,
    GrowthBookProviderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GrowthBookProviderQuery,
    GrowthBookProviderQueryVariables
  >(GrowthBookProviderQueryDocument, options);
}
export function useGrowthBookProviderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GrowthBookProviderQuery,
    GrowthBookProviderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GrowthBookProviderQuery,
    GrowthBookProviderQueryVariables
  >(GrowthBookProviderQueryDocument, options);
}
export function useGrowthBookProviderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GrowthBookProviderQuery,
        GrowthBookProviderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GrowthBookProviderQuery,
    GrowthBookProviderQueryVariables
  >(GrowthBookProviderQueryDocument, options);
}
export type GrowthBookProviderQueryHookResult = ReturnType<
  typeof useGrowthBookProviderQuery
>;
export type GrowthBookProviderQueryLazyQueryHookResult = ReturnType<
  typeof useGrowthBookProviderQueryLazyQuery
>;
export type GrowthBookProviderQuerySuspenseQueryHookResult = ReturnType<
  typeof useGrowthBookProviderQuerySuspenseQuery
>;
export type GrowthBookProviderQueryQueryResult = Apollo.QueryResult<
  GrowthBookProviderQuery,
  GrowthBookProviderQueryVariables
>;
export const SeoQueryDocument = gql`
  query SeoQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      enterpriseId
    }
  }
`;

/**
 * __useSeoQuery__
 *
 * To run a query within a React component, call `useSeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useSeoQuery(
  baseOptions: Apollo.QueryHookOptions<SeoQuery, SeoQueryVariables> &
    ({ variables: SeoQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SeoQuery, SeoQueryVariables>(
    SeoQueryDocument,
    options
  );
}
export function useSeoQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SeoQuery, SeoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SeoQuery, SeoQueryVariables>(
    SeoQueryDocument,
    options
  );
}
export function useSeoQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SeoQuery, SeoQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SeoQuery, SeoQueryVariables>(
    SeoQueryDocument,
    options
  );
}
export type SeoQueryHookResult = ReturnType<typeof useSeoQuery>;
export type SeoQueryLazyQueryHookResult = ReturnType<
  typeof useSeoQueryLazyQuery
>;
export type SeoQuerySuspenseQueryHookResult = ReturnType<
  typeof useSeoQuerySuspenseQuery
>;
export type SeoQueryQueryResult = Apollo.QueryResult<
  SeoQuery,
  SeoQueryVariables
>;
export const SeoClassCodeQueryDocument = gql`
  query SeoClassCodeQuery($code: String!) {
    classCode: getClassCode(code: $code) {
      classroomId
      code
    }
  }
`;

/**
 * __useSeoClassCodeQuery__
 *
 * To run a query within a React component, call `useSeoClassCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoClassCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoClassCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSeoClassCodeQuery(
  baseOptions: Apollo.QueryHookOptions<
    SeoClassCodeQuery,
    SeoClassCodeQueryVariables
  > &
    (
      | { variables: SeoClassCodeQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SeoClassCodeQuery, SeoClassCodeQueryVariables>(
    SeoClassCodeQueryDocument,
    options
  );
}
export function useSeoClassCodeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SeoClassCodeQuery,
    SeoClassCodeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SeoClassCodeQuery, SeoClassCodeQueryVariables>(
    SeoClassCodeQueryDocument,
    options
  );
}
export function useSeoClassCodeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SeoClassCodeQuery,
        SeoClassCodeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SeoClassCodeQuery, SeoClassCodeQueryVariables>(
    SeoClassCodeQueryDocument,
    options
  );
}
export type SeoClassCodeQueryHookResult = ReturnType<
  typeof useSeoClassCodeQuery
>;
export type SeoClassCodeQueryLazyQueryHookResult = ReturnType<
  typeof useSeoClassCodeQueryLazyQuery
>;
export type SeoClassCodeQuerySuspenseQueryHookResult = ReturnType<
  typeof useSeoClassCodeQuerySuspenseQuery
>;
export type SeoClassCodeQueryQueryResult = Apollo.QueryResult<
  SeoClassCodeQuery,
  SeoClassCodeQueryVariables
>;
export const SeoEnterpriseQueryDocument = gql`
  query SeoEnterpriseQuery($enterpriseId: String!) {
    enterprise(enterpriseId: $enterpriseId) {
      id
      branding {
        name
        appIconUrl
      }
      isWhiteLabeled
    }
  }
`;

/**
 * __useSeoEnterpriseQuery__
 *
 * To run a query within a React component, call `useSeoEnterpriseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoEnterpriseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoEnterpriseQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useSeoEnterpriseQuery(
  baseOptions: Apollo.QueryHookOptions<
    SeoEnterpriseQuery,
    SeoEnterpriseQueryVariables
  > &
    (
      | { variables: SeoEnterpriseQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SeoEnterpriseQuery, SeoEnterpriseQueryVariables>(
    SeoEnterpriseQueryDocument,
    options
  );
}
export function useSeoEnterpriseQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SeoEnterpriseQuery,
    SeoEnterpriseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SeoEnterpriseQuery, SeoEnterpriseQueryVariables>(
    SeoEnterpriseQueryDocument,
    options
  );
}
export function useSeoEnterpriseQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SeoEnterpriseQuery,
        SeoEnterpriseQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SeoEnterpriseQuery,
    SeoEnterpriseQueryVariables
  >(SeoEnterpriseQueryDocument, options);
}
export type SeoEnterpriseQueryHookResult = ReturnType<
  typeof useSeoEnterpriseQuery
>;
export type SeoEnterpriseQueryLazyQueryHookResult = ReturnType<
  typeof useSeoEnterpriseQueryLazyQuery
>;
export type SeoEnterpriseQuerySuspenseQueryHookResult = ReturnType<
  typeof useSeoEnterpriseQuerySuspenseQuery
>;
export type SeoEnterpriseQueryQueryResult = Apollo.QueryResult<
  SeoEnterpriseQuery,
  SeoEnterpriseQueryVariables
>;
export const SetupSentryQueryDocument = gql`
  query SetupSentryQuery {
    me: getMe {
      id
      email
    }
  }
`;

/**
 * __useSetupSentryQuery__
 *
 * To run a query within a React component, call `useSetupSentryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetupSentryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetupSentryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSetupSentryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SetupSentryQuery,
    SetupSentryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SetupSentryQuery, SetupSentryQueryVariables>(
    SetupSentryQueryDocument,
    options
  );
}
export function useSetupSentryQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SetupSentryQuery,
    SetupSentryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SetupSentryQuery, SetupSentryQueryVariables>(
    SetupSentryQueryDocument,
    options
  );
}
export function useSetupSentryQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SetupSentryQuery,
        SetupSentryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SetupSentryQuery, SetupSentryQueryVariables>(
    SetupSentryQueryDocument,
    options
  );
}
export type SetupSentryQueryHookResult = ReturnType<typeof useSetupSentryQuery>;
export type SetupSentryQueryLazyQueryHookResult = ReturnType<
  typeof useSetupSentryQueryLazyQuery
>;
export type SetupSentryQuerySuspenseQueryHookResult = ReturnType<
  typeof useSetupSentryQuerySuspenseQuery
>;
export type SetupSentryQueryQueryResult = Apollo.QueryResult<
  SetupSentryQuery,
  SetupSentryQueryVariables
>;
export const AdManagerQueryDocument = gql`
  query AdManagerQuery {
    me: getMe {
      id
      role
      schoolInfo {
        grade
      }
      schoolInfoForChildren {
        grade
      }
      isAdFreeSubscribed
    }
  }
`;

/**
 * __useAdManagerQuery__
 *
 * To run a query within a React component, call `useAdManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdManagerQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdManagerQuery(
  baseOptions?: Apollo.QueryHookOptions<AdManagerQuery, AdManagerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdManagerQuery, AdManagerQueryVariables>(
    AdManagerQueryDocument,
    options
  );
}
export function useAdManagerQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdManagerQuery,
    AdManagerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdManagerQuery, AdManagerQueryVariables>(
    AdManagerQueryDocument,
    options
  );
}
export function useAdManagerQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdManagerQuery, AdManagerQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdManagerQuery, AdManagerQueryVariables>(
    AdManagerQueryDocument,
    options
  );
}
export type AdManagerQueryHookResult = ReturnType<typeof useAdManagerQuery>;
export type AdManagerQueryLazyQueryHookResult = ReturnType<
  typeof useAdManagerQueryLazyQuery
>;
export type AdManagerQuerySuspenseQueryHookResult = ReturnType<
  typeof useAdManagerQuerySuspenseQuery
>;
export type AdManagerQueryQueryResult = Apollo.QueryResult<
  AdManagerQuery,
  AdManagerQueryVariables
>;
export const TaskItemExtensionQueryDocument = gql`
  query TaskItemExtensionQuery {
    me: getMe {
      id
    }
  }
`;

/**
 * __useTaskItemExtensionQuery__
 *
 * To run a query within a React component, call `useTaskItemExtensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskItemExtensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskItemExtensionQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskItemExtensionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TaskItemExtensionQuery,
    TaskItemExtensionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TaskItemExtensionQuery,
    TaskItemExtensionQueryVariables
  >(TaskItemExtensionQueryDocument, options);
}
export function useTaskItemExtensionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TaskItemExtensionQuery,
    TaskItemExtensionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TaskItemExtensionQuery,
    TaskItemExtensionQueryVariables
  >(TaskItemExtensionQueryDocument, options);
}
export function useTaskItemExtensionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TaskItemExtensionQuery,
        TaskItemExtensionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TaskItemExtensionQuery,
    TaskItemExtensionQueryVariables
  >(TaskItemExtensionQueryDocument, options);
}
export type TaskItemExtensionQueryHookResult = ReturnType<
  typeof useTaskItemExtensionQuery
>;
export type TaskItemExtensionQueryLazyQueryHookResult = ReturnType<
  typeof useTaskItemExtensionQueryLazyQuery
>;
export type TaskItemExtensionQuerySuspenseQueryHookResult = ReturnType<
  typeof useTaskItemExtensionQuerySuspenseQuery
>;
export type TaskItemExtensionQueryQueryResult = Apollo.QueryResult<
  TaskItemExtensionQuery,
  TaskItemExtensionQueryVariables
>;
export const TaskItemExtensionStatusQueryDocument = gql`
  query TaskItemExtensionStatusQuery($userId: String!, $taskItemId: String!) {
    taskItemStatus(userId: $userId, taskItemId: $taskItemId) @client {
      checked
    }
  }
`;

/**
 * __useTaskItemExtensionStatusQuery__
 *
 * To run a query within a React component, call `useTaskItemExtensionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskItemExtensionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskItemExtensionStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      taskItemId: // value for 'taskItemId'
 *   },
 * });
 */
export function useTaskItemExtensionStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    TaskItemExtensionStatusQuery,
    TaskItemExtensionStatusQueryVariables
  > &
    (
      | { variables: TaskItemExtensionStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TaskItemExtensionStatusQuery,
    TaskItemExtensionStatusQueryVariables
  >(TaskItemExtensionStatusQueryDocument, options);
}
export function useTaskItemExtensionStatusQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TaskItemExtensionStatusQuery,
    TaskItemExtensionStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TaskItemExtensionStatusQuery,
    TaskItemExtensionStatusQueryVariables
  >(TaskItemExtensionStatusQueryDocument, options);
}
export function useTaskItemExtensionStatusQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TaskItemExtensionStatusQuery,
        TaskItemExtensionStatusQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TaskItemExtensionStatusQuery,
    TaskItemExtensionStatusQueryVariables
  >(TaskItemExtensionStatusQueryDocument, options);
}
export type TaskItemExtensionStatusQueryHookResult = ReturnType<
  typeof useTaskItemExtensionStatusQuery
>;
export type TaskItemExtensionStatusQueryLazyQueryHookResult = ReturnType<
  typeof useTaskItemExtensionStatusQueryLazyQuery
>;
export type TaskItemExtensionStatusQuerySuspenseQueryHookResult = ReturnType<
  typeof useTaskItemExtensionStatusQuerySuspenseQuery
>;
export type TaskItemExtensionStatusQueryQueryResult = Apollo.QueryResult<
  TaskItemExtensionStatusQuery,
  TaskItemExtensionStatusQueryVariables
>;
export const VideoExtensionQueryDocument = gql`
  query VideoExtensionQuery($videoId: String!) {
    video: getVideo(videoId: $videoId) {
      id
      streamUrl
      posterUrl
      conversionStatus
      urls
      originalFileName
    }
  }
`;

/**
 * __useVideoExtensionQuery__
 *
 * To run a query within a React component, call `useVideoExtensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoExtensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoExtensionQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useVideoExtensionQuery(
  baseOptions: Apollo.QueryHookOptions<
    VideoExtensionQuery,
    VideoExtensionQueryVariables
  > &
    (
      | { variables: VideoExtensionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VideoExtensionQuery, VideoExtensionQueryVariables>(
    VideoExtensionQueryDocument,
    options
  );
}
export function useVideoExtensionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VideoExtensionQuery,
    VideoExtensionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VideoExtensionQuery, VideoExtensionQueryVariables>(
    VideoExtensionQueryDocument,
    options
  );
}
export function useVideoExtensionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VideoExtensionQuery,
        VideoExtensionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VideoExtensionQuery,
    VideoExtensionQueryVariables
  >(VideoExtensionQueryDocument, options);
}
export type VideoExtensionQueryHookResult = ReturnType<
  typeof useVideoExtensionQuery
>;
export type VideoExtensionQueryLazyQueryHookResult = ReturnType<
  typeof useVideoExtensionQueryLazyQuery
>;
export type VideoExtensionQuerySuspenseQueryHookResult = ReturnType<
  typeof useVideoExtensionQuerySuspenseQuery
>;
export type VideoExtensionQueryQueryResult = Apollo.QueryResult<
  VideoExtensionQuery,
  VideoExtensionQueryVariables
>;
export const TrackingPixelQueryDocument = gql`
  query TrackingPixelQuery {
    me: getMe {
      id
      name
      role
      profileImage
      countryCode
      language
      email
    }
  }
`;

/**
 * __useTrackingPixelQuery__
 *
 * To run a query within a React component, call `useTrackingPixelQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingPixelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingPixelQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrackingPixelQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TrackingPixelQuery,
    TrackingPixelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrackingPixelQuery, TrackingPixelQueryVariables>(
    TrackingPixelQueryDocument,
    options
  );
}
export function useTrackingPixelQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TrackingPixelQuery,
    TrackingPixelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrackingPixelQuery, TrackingPixelQueryVariables>(
    TrackingPixelQueryDocument,
    options
  );
}
export function useTrackingPixelQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TrackingPixelQuery,
        TrackingPixelQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TrackingPixelQuery,
    TrackingPixelQueryVariables
  >(TrackingPixelQueryDocument, options);
}
export type TrackingPixelQueryHookResult = ReturnType<
  typeof useTrackingPixelQuery
>;
export type TrackingPixelQueryLazyQueryHookResult = ReturnType<
  typeof useTrackingPixelQueryLazyQuery
>;
export type TrackingPixelQuerySuspenseQueryHookResult = ReturnType<
  typeof useTrackingPixelQuerySuspenseQuery
>;
export type TrackingPixelQueryQueryResult = Apollo.QueryResult<
  TrackingPixelQuery,
  TrackingPixelQueryVariables
>;
export const UpdateSchoolInfoMutationDocument = gql`
  mutation UpdateSchoolInfoMutation(
    $id: String!
    $updateAccountDtoInput: UpdateAccountDtoInput!
  ) {
    account: updateAccount(
      id: $id
      updateAccountDtoInput: $updateAccountDtoInput
    ) {
      id
      name
      schoolInfo {
        grade
        school {
          id
          name
        }
      }
      schoolInfoForChildren {
        grade
        school {
          id
          name
        }
      }
    }
  }
`;
export type UpdateSchoolInfoMutationMutationFn = Apollo.MutationFunction<
  UpdateSchoolInfoMutation,
  UpdateSchoolInfoMutationVariables
>;

/**
 * __useUpdateSchoolInfoMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolInfoMutation, { data, loading, error }] = useUpdateSchoolInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateAccountDtoInput: // value for 'updateAccountDtoInput'
 *   },
 * });
 */
export function useUpdateSchoolInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchoolInfoMutation,
    UpdateSchoolInfoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSchoolInfoMutation,
    UpdateSchoolInfoMutationVariables
  >(UpdateSchoolInfoMutationDocument, options);
}
export type UpdateSchoolInfoMutationHookResult = ReturnType<
  typeof useUpdateSchoolInfoMutation
>;
export type UpdateSchoolInfoMutationMutationResult =
  Apollo.MutationResult<UpdateSchoolInfoMutation>;
export type UpdateSchoolInfoMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSchoolInfoMutation,
    UpdateSchoolInfoMutationVariables
  >;
export const UpdateSchoolInfoForChildrenMutationDocument = gql`
  mutation UpdateSchoolInfoForChildrenMutation(
    $id: String!
    $updateChildSchoolInfoDtoInput: UpdateChildSchoolInfoDtoInput!
  ) {
    updateChildSchoolInfo(
      id: $id
      updateChildSchoolInfoDtoInput: $updateChildSchoolInfoDtoInput
    ) {
      id
      schoolInfoForChildren {
        grade
        school {
          id
          name
        }
      }
    }
  }
`;
export type UpdateSchoolInfoForChildrenMutationMutationFn =
  Apollo.MutationFunction<
    UpdateSchoolInfoForChildrenMutation,
    UpdateSchoolInfoForChildrenMutationVariables
  >;

/**
 * __useUpdateSchoolInfoForChildrenMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolInfoForChildrenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolInfoForChildrenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolInfoForChildrenMutation, { data, loading, error }] = useUpdateSchoolInfoForChildrenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateChildSchoolInfoDtoInput: // value for 'updateChildSchoolInfoDtoInput'
 *   },
 * });
 */
export function useUpdateSchoolInfoForChildrenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchoolInfoForChildrenMutation,
    UpdateSchoolInfoForChildrenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSchoolInfoForChildrenMutation,
    UpdateSchoolInfoForChildrenMutationVariables
  >(UpdateSchoolInfoForChildrenMutationDocument, options);
}
export type UpdateSchoolInfoForChildrenMutationHookResult = ReturnType<
  typeof useUpdateSchoolInfoForChildrenMutation
>;
export type UpdateSchoolInfoForChildrenMutationMutationResult =
  Apollo.MutationResult<UpdateSchoolInfoForChildrenMutation>;
export type UpdateSchoolInfoForChildrenMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSchoolInfoForChildrenMutation,
    UpdateSchoolInfoForChildrenMutationVariables
  >;
export const UpdateSchoolInfoPageQueryDocument = gql`
  query UpdateSchoolInfoPageQuery($classroomId: String!) {
    me: getMe {
      id
      schoolInfo {
        ...SchoolInfoFormSchoolInfoFields
      }
      schoolInfoForChildren {
        ...SchoolInfoForChildrenFormSchoolInfo2Fields
      }
    }
    classroom: getClassroom(classroomId: $classroomId) {
      grade
      id
      schoolId
      schoolName
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
      ...SchoolInfoFormMemberFields
    }
  }
  ${SchoolInfoFormSchoolInfoFieldsFragmentDoc}
  ${SchoolInfoForChildrenFormSchoolInfo2FieldsFragmentDoc}
  ${SchoolInfoFormMemberFieldsFragmentDoc}
`;

/**
 * __useUpdateSchoolInfoPageQuery__
 *
 * To run a query within a React component, call `useUpdateSchoolInfoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolInfoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateSchoolInfoPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useUpdateSchoolInfoPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    UpdateSchoolInfoPageQuery,
    UpdateSchoolInfoPageQueryVariables
  > &
    (
      | { variables: UpdateSchoolInfoPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UpdateSchoolInfoPageQuery,
    UpdateSchoolInfoPageQueryVariables
  >(UpdateSchoolInfoPageQueryDocument, options);
}
export function useUpdateSchoolInfoPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpdateSchoolInfoPageQuery,
    UpdateSchoolInfoPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UpdateSchoolInfoPageQuery,
    UpdateSchoolInfoPageQueryVariables
  >(UpdateSchoolInfoPageQueryDocument, options);
}
export function useUpdateSchoolInfoPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UpdateSchoolInfoPageQuery,
        UpdateSchoolInfoPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UpdateSchoolInfoPageQuery,
    UpdateSchoolInfoPageQueryVariables
  >(UpdateSchoolInfoPageQueryDocument, options);
}
export type UpdateSchoolInfoPageQueryHookResult = ReturnType<
  typeof useUpdateSchoolInfoPageQuery
>;
export type UpdateSchoolInfoPageQueryLazyQueryHookResult = ReturnType<
  typeof useUpdateSchoolInfoPageQueryLazyQuery
>;
export type UpdateSchoolInfoPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useUpdateSchoolInfoPageQuerySuspenseQuery
>;
export type UpdateSchoolInfoPageQueryQueryResult = Apollo.QueryResult<
  UpdateSchoolInfoPageQuery,
  UpdateSchoolInfoPageQueryVariables
>;
export const UpdateSchoolInfoPageOrganizationQueryDocument = gql`
  query UpdateSchoolInfoPageOrganizationQuery($organizationId: String!) {
    organization: organizationOrganization(organizationId: $organizationId) {
      id
      name
    }
  }
`;

/**
 * __useUpdateSchoolInfoPageOrganizationQuery__
 *
 * To run a query within a React component, call `useUpdateSchoolInfoPageOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolInfoPageOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateSchoolInfoPageOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUpdateSchoolInfoPageOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    UpdateSchoolInfoPageOrganizationQuery,
    UpdateSchoolInfoPageOrganizationQueryVariables
  > &
    (
      | {
          variables: UpdateSchoolInfoPageOrganizationQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UpdateSchoolInfoPageOrganizationQuery,
    UpdateSchoolInfoPageOrganizationQueryVariables
  >(UpdateSchoolInfoPageOrganizationQueryDocument, options);
}
export function useUpdateSchoolInfoPageOrganizationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpdateSchoolInfoPageOrganizationQuery,
    UpdateSchoolInfoPageOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UpdateSchoolInfoPageOrganizationQuery,
    UpdateSchoolInfoPageOrganizationQueryVariables
  >(UpdateSchoolInfoPageOrganizationQueryDocument, options);
}
export function useUpdateSchoolInfoPageOrganizationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UpdateSchoolInfoPageOrganizationQuery,
        UpdateSchoolInfoPageOrganizationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UpdateSchoolInfoPageOrganizationQuery,
    UpdateSchoolInfoPageOrganizationQueryVariables
  >(UpdateSchoolInfoPageOrganizationQueryDocument, options);
}
export type UpdateSchoolInfoPageOrganizationQueryHookResult = ReturnType<
  typeof useUpdateSchoolInfoPageOrganizationQuery
>;
export type UpdateSchoolInfoPageOrganizationQueryLazyQueryHookResult =
  ReturnType<typeof useUpdateSchoolInfoPageOrganizationQueryLazyQuery>;
export type UpdateSchoolInfoPageOrganizationQuerySuspenseQueryHookResult =
  ReturnType<typeof useUpdateSchoolInfoPageOrganizationQuerySuspenseQuery>;
export type UpdateSchoolInfoPageOrganizationQueryQueryResult =
  Apollo.QueryResult<
    UpdateSchoolInfoPageOrganizationQuery,
    UpdateSchoolInfoPageOrganizationQueryVariables
  >;
export const AdProviderQueryDocument = gql`
  query AdProviderQuery {
    me: getMe {
      id
      role
      grade
      language
      countryCode
      schoolInfoDto {
        grade
        school {
          zipcode
        }
      }
      schoolInfoDtoForChildren {
        grade
        school {
          zipcode
        }
      }
    }
  }
`;

/**
 * __useAdProviderQuery__
 *
 * To run a query within a React component, call `useAdProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdProviderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdProviderQuery,
    AdProviderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdProviderQuery, AdProviderQueryVariables>(
    AdProviderQueryDocument,
    options
  );
}
export function useAdProviderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdProviderQuery,
    AdProviderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdProviderQuery, AdProviderQueryVariables>(
    AdProviderQueryDocument,
    options
  );
}
export function useAdProviderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AdProviderQuery, AdProviderQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AdProviderQuery, AdProviderQueryVariables>(
    AdProviderQueryDocument,
    options
  );
}
export type AdProviderQueryHookResult = ReturnType<typeof useAdProviderQuery>;
export type AdProviderQueryLazyQueryHookResult = ReturnType<
  typeof useAdProviderQueryLazyQuery
>;
export type AdProviderQuerySuspenseQueryHookResult = ReturnType<
  typeof useAdProviderQuerySuspenseQuery
>;
export type AdProviderQueryQueryResult = Apollo.QueryResult<
  AdProviderQuery,
  AdProviderQueryVariables
>;
export const AiTestHistoryQueryDocument = gql`
  query AiTestHistoryQuery($classroomId: ID!) {
    latestAiAssignment(classroomId: $classroomId) {
      id
      title
      subTitle
      startAt
      subject {
        id
        name
      }
      units {
        id
        position
      }
      studentsCount
      completedStudentsCount
      isReserved
      aiAssignmentType
    }
  }
`;

/**
 * __useAiTestHistoryQuery__
 *
 * To run a query within a React component, call `useAiTestHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiTestHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiTestHistoryQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAiTestHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    AiTestHistoryQuery,
    AiTestHistoryQueryVariables
  > &
    (
      | { variables: AiTestHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiTestHistoryQuery, AiTestHistoryQueryVariables>(
    AiTestHistoryQueryDocument,
    options
  );
}
export function useAiTestHistoryQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiTestHistoryQuery,
    AiTestHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiTestHistoryQuery, AiTestHistoryQueryVariables>(
    AiTestHistoryQueryDocument,
    options
  );
}
export function useAiTestHistoryQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiTestHistoryQuery,
        AiTestHistoryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AiTestHistoryQuery,
    AiTestHistoryQueryVariables
  >(AiTestHistoryQueryDocument, options);
}
export type AiTestHistoryQueryHookResult = ReturnType<
  typeof useAiTestHistoryQuery
>;
export type AiTestHistoryQueryLazyQueryHookResult = ReturnType<
  typeof useAiTestHistoryQueryLazyQuery
>;
export type AiTestHistoryQuerySuspenseQueryHookResult = ReturnType<
  typeof useAiTestHistoryQuerySuspenseQuery
>;
export type AiTestHistoryQueryQueryResult = Apollo.QueryResult<
  AiTestHistoryQuery,
  AiTestHistoryQueryVariables
>;
export const DistributeAiTestDocument = gql`
  mutation DistributeAiTest($input: DistributeAiTestDtoInput!) {
    distributeAiTest(input: $input) {
      id
    }
  }
`;
export type DistributeAiTestMutationFn = Apollo.MutationFunction<
  DistributeAiTestMutation,
  DistributeAiTestMutationVariables
>;

/**
 * __useDistributeAiTestMutation__
 *
 * To run a mutation, you first call `useDistributeAiTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDistributeAiTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [distributeAiTestMutation, { data, loading, error }] = useDistributeAiTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDistributeAiTestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DistributeAiTestMutation,
    DistributeAiTestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DistributeAiTestMutation,
    DistributeAiTestMutationVariables
  >(DistributeAiTestDocument, options);
}
export type DistributeAiTestMutationHookResult = ReturnType<
  typeof useDistributeAiTestMutation
>;
export type DistributeAiTestMutationResult =
  Apollo.MutationResult<DistributeAiTestMutation>;
export type DistributeAiTestMutationOptions = Apollo.BaseMutationOptions<
  DistributeAiTestMutation,
  DistributeAiTestMutationVariables
>;
export const CompleteDistributeAiTestChecklistMutationDocument = gql`
  mutation CompleteDistributeAiTestChecklistMutation($classroomId: String!) {
    completeOnboardingChecklistAction(
      classroomId: $classroomId
      completeOnboardingChecklistActionDtoInput: {
        action: "distribute-ai-test"
      }
    ) {
      id
    }
  }
`;
export type CompleteDistributeAiTestChecklistMutationMutationFn =
  Apollo.MutationFunction<
    CompleteDistributeAiTestChecklistMutation,
    CompleteDistributeAiTestChecklistMutationVariables
  >;

/**
 * __useCompleteDistributeAiTestChecklistMutation__
 *
 * To run a mutation, you first call `useCompleteDistributeAiTestChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteDistributeAiTestChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeDistributeAiTestChecklistMutation, { data, loading, error }] = useCompleteDistributeAiTestChecklistMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useCompleteDistributeAiTestChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteDistributeAiTestChecklistMutation,
    CompleteDistributeAiTestChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteDistributeAiTestChecklistMutation,
    CompleteDistributeAiTestChecklistMutationVariables
  >(CompleteDistributeAiTestChecklistMutationDocument, options);
}
export type CompleteDistributeAiTestChecklistMutationHookResult = ReturnType<
  typeof useCompleteDistributeAiTestChecklistMutation
>;
export type CompleteDistributeAiTestChecklistMutationMutationResult =
  Apollo.MutationResult<CompleteDistributeAiTestChecklistMutation>;
export type CompleteDistributeAiTestChecklistMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteDistributeAiTestChecklistMutation,
    CompleteDistributeAiTestChecklistMutationVariables
  >;
export const AiTestPageQueryDocument = gql`
  query AiTestPageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      grade
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
      group
    }
  }
`;

/**
 * __useAiTestPageQuery__
 *
 * To run a query within a React component, call `useAiTestPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiTestPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiTestPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAiTestPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    AiTestPageQuery,
    AiTestPageQueryVariables
  > &
    (
      | { variables: AiTestPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiTestPageQuery, AiTestPageQueryVariables>(
    AiTestPageQueryDocument,
    options
  );
}
export function useAiTestPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiTestPageQuery,
    AiTestPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiTestPageQuery, AiTestPageQueryVariables>(
    AiTestPageQueryDocument,
    options
  );
}
export function useAiTestPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiTestPageQuery, AiTestPageQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiTestPageQuery, AiTestPageQueryVariables>(
    AiTestPageQueryDocument,
    options
  );
}
export type AiTestPageQueryHookResult = ReturnType<typeof useAiTestPageQuery>;
export type AiTestPageQueryLazyQueryHookResult = ReturnType<
  typeof useAiTestPageQueryLazyQuery
>;
export type AiTestPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useAiTestPageQuerySuspenseQuery
>;
export type AiTestPageQueryQueryResult = Apollo.QueryResult<
  AiTestPageQuery,
  AiTestPageQueryVariables
>;
export const AssignmentFormQueryDocument = gql`
  query AssignmentFormQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
      isPrivate
    }
    channelGroups: listChannelGroupsDto(classroomId: $classroomId, limit: 100) {
      name
      id
      channels {
        id
        name
        archived
        canMemberWritePost
        isPrivate
        canMemberWriteComment
        canMemberReactToPost
      }
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
`;

/**
 * __useAssignmentFormQuery__
 *
 * To run a query within a React component, call `useAssignmentFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentFormQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useAssignmentFormQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentFormQuery,
    AssignmentFormQueryVariables
  > &
    (
      | { variables: AssignmentFormQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssignmentFormQuery, AssignmentFormQueryVariables>(
    AssignmentFormQueryDocument,
    options
  );
}
export function useAssignmentFormQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentFormQuery,
    AssignmentFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AssignmentFormQuery, AssignmentFormQueryVariables>(
    AssignmentFormQueryDocument,
    options
  );
}
export function useAssignmentFormQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentFormQuery,
        AssignmentFormQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentFormQuery,
    AssignmentFormQueryVariables
  >(AssignmentFormQueryDocument, options);
}
export type AssignmentFormQueryHookResult = ReturnType<
  typeof useAssignmentFormQuery
>;
export type AssignmentFormQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentFormQueryLazyQuery
>;
export type AssignmentFormQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentFormQuerySuspenseQuery
>;
export type AssignmentFormQueryQueryResult = Apollo.QueryResult<
  AssignmentFormQuery,
  AssignmentFormQueryVariables
>;
export const ChannelAssigneeListQueryDocument = gql`
  query ChannelAssigneeListQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignedMemberList: listAssignmentAssignees(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...ChannelAssigneeListMemberDtoFields
    }
  }
  ${ChannelAssigneeListMemberDtoFieldsFragmentDoc}
`;

/**
 * __useChannelAssigneeListQuery__
 *
 * To run a query within a React component, call `useChannelAssigneeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelAssigneeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelAssigneeListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useChannelAssigneeListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelAssigneeListQuery,
    ChannelAssigneeListQueryVariables
  > &
    (
      | { variables: ChannelAssigneeListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChannelAssigneeListQuery,
    ChannelAssigneeListQueryVariables
  >(ChannelAssigneeListQueryDocument, options);
}
export function useChannelAssigneeListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelAssigneeListQuery,
    ChannelAssigneeListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelAssigneeListQuery,
    ChannelAssigneeListQueryVariables
  >(ChannelAssigneeListQueryDocument, options);
}
export function useChannelAssigneeListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelAssigneeListQuery,
        ChannelAssigneeListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelAssigneeListQuery,
    ChannelAssigneeListQueryVariables
  >(ChannelAssigneeListQueryDocument, options);
}
export type ChannelAssigneeListQueryHookResult = ReturnType<
  typeof useChannelAssigneeListQuery
>;
export type ChannelAssigneeListQueryLazyQueryHookResult = ReturnType<
  typeof useChannelAssigneeListQueryLazyQuery
>;
export type ChannelAssigneeListQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelAssigneeListQuerySuspenseQuery
>;
export type ChannelAssigneeListQueryQueryResult = Apollo.QueryResult<
  ChannelAssigneeListQuery,
  ChannelAssigneeListQueryVariables
>;
export const ChannelSelectDrawerChannelMemberListQueryDocument = gql`
  query ChannelSelectDrawerChannelMemberListQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    channelMembers: listChannelMembers(
      classroomId: $classroomId
      channelId: $channelId
      groups: "student"
    ) {
      ...ChannelSelectDrawerMemberFields
    }
  }
  ${ChannelSelectDrawerMemberFieldsFragmentDoc}
`;

/**
 * __useChannelSelectDrawerChannelMemberListQuery__
 *
 * To run a query within a React component, call `useChannelSelectDrawerChannelMemberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelSelectDrawerChannelMemberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelSelectDrawerChannelMemberListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelSelectDrawerChannelMemberListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelSelectDrawerChannelMemberListQuery,
    ChannelSelectDrawerChannelMemberListQueryVariables
  > &
    (
      | {
          variables: ChannelSelectDrawerChannelMemberListQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChannelSelectDrawerChannelMemberListQuery,
    ChannelSelectDrawerChannelMemberListQueryVariables
  >(ChannelSelectDrawerChannelMemberListQueryDocument, options);
}
export function useChannelSelectDrawerChannelMemberListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelSelectDrawerChannelMemberListQuery,
    ChannelSelectDrawerChannelMemberListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelSelectDrawerChannelMemberListQuery,
    ChannelSelectDrawerChannelMemberListQueryVariables
  >(ChannelSelectDrawerChannelMemberListQueryDocument, options);
}
export function useChannelSelectDrawerChannelMemberListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelSelectDrawerChannelMemberListQuery,
        ChannelSelectDrawerChannelMemberListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelSelectDrawerChannelMemberListQuery,
    ChannelSelectDrawerChannelMemberListQueryVariables
  >(ChannelSelectDrawerChannelMemberListQueryDocument, options);
}
export type ChannelSelectDrawerChannelMemberListQueryHookResult = ReturnType<
  typeof useChannelSelectDrawerChannelMemberListQuery
>;
export type ChannelSelectDrawerChannelMemberListQueryLazyQueryHookResult =
  ReturnType<typeof useChannelSelectDrawerChannelMemberListQueryLazyQuery>;
export type ChannelSelectDrawerChannelMemberListQuerySuspenseQueryHookResult =
  ReturnType<typeof useChannelSelectDrawerChannelMemberListQuerySuspenseQuery>;
export type ChannelSelectDrawerChannelMemberListQueryQueryResult =
  Apollo.QueryResult<
    ChannelSelectDrawerChannelMemberListQuery,
    ChannelSelectDrawerChannelMemberListQueryVariables
  >;
export const ChannelSelectDrawerCurrentMemberQueryDocument = gql`
  query ChannelSelectDrawerCurrentMemberQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useChannelSelectDrawerCurrentMemberQuery__
 *
 * To run a query within a React component, call `useChannelSelectDrawerCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelSelectDrawerCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelSelectDrawerCurrentMemberQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useChannelSelectDrawerCurrentMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelSelectDrawerCurrentMemberQuery,
    ChannelSelectDrawerCurrentMemberQueryVariables
  > &
    (
      | {
          variables: ChannelSelectDrawerCurrentMemberQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChannelSelectDrawerCurrentMemberQuery,
    ChannelSelectDrawerCurrentMemberQueryVariables
  >(ChannelSelectDrawerCurrentMemberQueryDocument, options);
}
export function useChannelSelectDrawerCurrentMemberQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelSelectDrawerCurrentMemberQuery,
    ChannelSelectDrawerCurrentMemberQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelSelectDrawerCurrentMemberQuery,
    ChannelSelectDrawerCurrentMemberQueryVariables
  >(ChannelSelectDrawerCurrentMemberQueryDocument, options);
}
export function useChannelSelectDrawerCurrentMemberQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelSelectDrawerCurrentMemberQuery,
        ChannelSelectDrawerCurrentMemberQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelSelectDrawerCurrentMemberQuery,
    ChannelSelectDrawerCurrentMemberQueryVariables
  >(ChannelSelectDrawerCurrentMemberQueryDocument, options);
}
export type ChannelSelectDrawerCurrentMemberQueryHookResult = ReturnType<
  typeof useChannelSelectDrawerCurrentMemberQuery
>;
export type ChannelSelectDrawerCurrentMemberQueryLazyQueryHookResult =
  ReturnType<typeof useChannelSelectDrawerCurrentMemberQueryLazyQuery>;
export type ChannelSelectDrawerCurrentMemberQuerySuspenseQueryHookResult =
  ReturnType<typeof useChannelSelectDrawerCurrentMemberQuerySuspenseQuery>;
export type ChannelSelectDrawerCurrentMemberQueryQueryResult =
  Apollo.QueryResult<
    ChannelSelectDrawerCurrentMemberQuery,
    ChannelSelectDrawerCurrentMemberQueryVariables
  >;
export const AssignmentInfoQueryDocument = gql`
  query AssignmentInfoQuery($classroomId: String!, $assignmentId: String!) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...AssignmentInfoAssignmentDtoFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
  ${AssignmentInfoAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __useAssignmentInfoQuery__
 *
 * To run a query within a React component, call `useAssignmentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentInfoQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useAssignmentInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentInfoQuery,
    AssignmentInfoQueryVariables
  > &
    (
      | { variables: AssignmentInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssignmentInfoQuery, AssignmentInfoQueryVariables>(
    AssignmentInfoQueryDocument,
    options
  );
}
export function useAssignmentInfoQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentInfoQuery,
    AssignmentInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AssignmentInfoQuery, AssignmentInfoQueryVariables>(
    AssignmentInfoQueryDocument,
    options
  );
}
export function useAssignmentInfoQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentInfoQuery,
        AssignmentInfoQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentInfoQuery,
    AssignmentInfoQueryVariables
  >(AssignmentInfoQueryDocument, options);
}
export type AssignmentInfoQueryHookResult = ReturnType<
  typeof useAssignmentInfoQuery
>;
export type AssignmentInfoQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentInfoQueryLazyQuery
>;
export type AssignmentInfoQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentInfoQuerySuspenseQuery
>;
export type AssignmentInfoQueryQueryResult = Apollo.QueryResult<
  AssignmentInfoQuery,
  AssignmentInfoQueryVariables
>;
export const SubmitSubmissionMutationDocument = gql`
  mutation SubmitSubmissionMutation(
    $classroomId: String!
    $assignmentId: String!
    $submitSubmissionDtoInput: SubmitSubmissionDtoInput!
  ) {
    submitSubmission(
      classroomId: $classroomId
      assignmentId: $assignmentId
      submitSubmissionDtoInput: $submitSubmissionDtoInput
    ) {
      ...AssignmentInfoForAssigneeAssignmentSubmissionDtoFields
    }
  }
  ${AssignmentInfoForAssigneeAssignmentSubmissionDtoFieldsFragmentDoc}
`;
export type SubmitSubmissionMutationMutationFn = Apollo.MutationFunction<
  SubmitSubmissionMutation,
  SubmitSubmissionMutationVariables
>;

/**
 * __useSubmitSubmissionMutation__
 *
 * To run a mutation, you first call `useSubmitSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSubmissionMutation, { data, loading, error }] = useSubmitSubmissionMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      submitSubmissionDtoInput: // value for 'submitSubmissionDtoInput'
 *   },
 * });
 */
export function useSubmitSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitSubmissionMutation,
    SubmitSubmissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitSubmissionMutation,
    SubmitSubmissionMutationVariables
  >(SubmitSubmissionMutationDocument, options);
}
export type SubmitSubmissionMutationHookResult = ReturnType<
  typeof useSubmitSubmissionMutation
>;
export type SubmitSubmissionMutationMutationResult =
  Apollo.MutationResult<SubmitSubmissionMutation>;
export type SubmitSubmissionMutationMutationOptions =
  Apollo.BaseMutationOptions<
    SubmitSubmissionMutation,
    SubmitSubmissionMutationVariables
  >;
export const AssignmentInfoForAssigneeQueryDocument = gql`
  query AssignmentInfoForAssigneeQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    permission: getAssignmentPermission(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      canSubmit
    }
  }
`;

/**
 * __useAssignmentInfoForAssigneeQuery__
 *
 * To run a query within a React component, call `useAssignmentInfoForAssigneeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentInfoForAssigneeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentInfoForAssigneeQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useAssignmentInfoForAssigneeQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentInfoForAssigneeQuery,
    AssignmentInfoForAssigneeQueryVariables
  > &
    (
      | { variables: AssignmentInfoForAssigneeQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentInfoForAssigneeQuery,
    AssignmentInfoForAssigneeQueryVariables
  >(AssignmentInfoForAssigneeQueryDocument, options);
}
export function useAssignmentInfoForAssigneeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentInfoForAssigneeQuery,
    AssignmentInfoForAssigneeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentInfoForAssigneeQuery,
    AssignmentInfoForAssigneeQueryVariables
  >(AssignmentInfoForAssigneeQueryDocument, options);
}
export function useAssignmentInfoForAssigneeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentInfoForAssigneeQuery,
        AssignmentInfoForAssigneeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentInfoForAssigneeQuery,
    AssignmentInfoForAssigneeQueryVariables
  >(AssignmentInfoForAssigneeQueryDocument, options);
}
export type AssignmentInfoForAssigneeQueryHookResult = ReturnType<
  typeof useAssignmentInfoForAssigneeQuery
>;
export type AssignmentInfoForAssigneeQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentInfoForAssigneeQueryLazyQuery
>;
export type AssignmentInfoForAssigneeQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentInfoForAssigneeQuerySuspenseQuery
>;
export type AssignmentInfoForAssigneeQueryQueryResult = Apollo.QueryResult<
  AssignmentInfoForAssigneeQuery,
  AssignmentInfoForAssigneeQueryVariables
>;
export const AssignmentInfoForAssigneeAssignmentSubmissionQueryDocument = gql`
  query AssignmentInfoForAssigneeAssignmentSubmissionQuery(
    $classroomId: String!
    $assignmentId: String!
    $assigneeId: String!
  ) {
    assignmentSubmission: getAssignmentSubmission(
      classroomId: $classroomId
      assignmentId: $assignmentId
      assigneeId: $assigneeId
    ) {
      ...AssignmentInfoForAssigneeAssignmentSubmissionDtoFields
    }
  }
  ${AssignmentInfoForAssigneeAssignmentSubmissionDtoFieldsFragmentDoc}
`;

/**
 * __useAssignmentInfoForAssigneeAssignmentSubmissionQuery__
 *
 * To run a query within a React component, call `useAssignmentInfoForAssigneeAssignmentSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentInfoForAssigneeAssignmentSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentInfoForAssigneeAssignmentSubmissionQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useAssignmentInfoForAssigneeAssignmentSubmissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentInfoForAssigneeAssignmentSubmissionQuery,
    AssignmentInfoForAssigneeAssignmentSubmissionQueryVariables
  > &
    (
      | {
          variables: AssignmentInfoForAssigneeAssignmentSubmissionQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentInfoForAssigneeAssignmentSubmissionQuery,
    AssignmentInfoForAssigneeAssignmentSubmissionQueryVariables
  >(AssignmentInfoForAssigneeAssignmentSubmissionQueryDocument, options);
}
export function useAssignmentInfoForAssigneeAssignmentSubmissionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentInfoForAssigneeAssignmentSubmissionQuery,
    AssignmentInfoForAssigneeAssignmentSubmissionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentInfoForAssigneeAssignmentSubmissionQuery,
    AssignmentInfoForAssigneeAssignmentSubmissionQueryVariables
  >(AssignmentInfoForAssigneeAssignmentSubmissionQueryDocument, options);
}
export function useAssignmentInfoForAssigneeAssignmentSubmissionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentInfoForAssigneeAssignmentSubmissionQuery,
        AssignmentInfoForAssigneeAssignmentSubmissionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentInfoForAssigneeAssignmentSubmissionQuery,
    AssignmentInfoForAssigneeAssignmentSubmissionQueryVariables
  >(AssignmentInfoForAssigneeAssignmentSubmissionQueryDocument, options);
}
export type AssignmentInfoForAssigneeAssignmentSubmissionQueryHookResult =
  ReturnType<typeof useAssignmentInfoForAssigneeAssignmentSubmissionQuery>;
export type AssignmentInfoForAssigneeAssignmentSubmissionQueryLazyQueryHookResult =
  ReturnType<
    typeof useAssignmentInfoForAssigneeAssignmentSubmissionQueryLazyQuery
  >;
export type AssignmentInfoForAssigneeAssignmentSubmissionQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useAssignmentInfoForAssigneeAssignmentSubmissionQuerySuspenseQuery
  >;
export type AssignmentInfoForAssigneeAssignmentSubmissionQueryQueryResult =
  Apollo.QueryResult<
    AssignmentInfoForAssigneeAssignmentSubmissionQuery,
    AssignmentInfoForAssigneeAssignmentSubmissionQueryVariables
  >;
export const AssignmentInfoForGraderQueryDocument = gql`
  query AssignmentInfoForGraderQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
`;

/**
 * __useAssignmentInfoForGraderQuery__
 *
 * To run a query within a React component, call `useAssignmentInfoForGraderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentInfoForGraderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentInfoForGraderQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useAssignmentInfoForGraderQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentInfoForGraderQuery,
    AssignmentInfoForGraderQueryVariables
  > &
    (
      | { variables: AssignmentInfoForGraderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentInfoForGraderQuery,
    AssignmentInfoForGraderQueryVariables
  >(AssignmentInfoForGraderQueryDocument, options);
}
export function useAssignmentInfoForGraderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentInfoForGraderQuery,
    AssignmentInfoForGraderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentInfoForGraderQuery,
    AssignmentInfoForGraderQueryVariables
  >(AssignmentInfoForGraderQueryDocument, options);
}
export function useAssignmentInfoForGraderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentInfoForGraderQuery,
        AssignmentInfoForGraderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentInfoForGraderQuery,
    AssignmentInfoForGraderQueryVariables
  >(AssignmentInfoForGraderQueryDocument, options);
}
export type AssignmentInfoForGraderQueryHookResult = ReturnType<
  typeof useAssignmentInfoForGraderQuery
>;
export type AssignmentInfoForGraderQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentInfoForGraderQueryLazyQuery
>;
export type AssignmentInfoForGraderQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentInfoForGraderQuerySuspenseQuery
>;
export type AssignmentInfoForGraderQueryQueryResult = Apollo.QueryResult<
  AssignmentInfoForGraderQuery,
  AssignmentInfoForGraderQueryVariables
>;
export const AssignmentInfoForGraderAssignmentSubmissionsQueryDocument = gql`
  query AssignmentInfoForGraderAssignmentSubmissionsQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignmentSubmissions: listAssignmentSubmissions(
      classroomId: $classroomId
      assignmentId: $assignmentId
      limit: 1000
    ) {
      id
      assignmentId
      assigneeId
      classroomId
      status
      points
      createdAt
      updatedAt
      gradingStatus
    }
  }
`;

/**
 * __useAssignmentInfoForGraderAssignmentSubmissionsQuery__
 *
 * To run a query within a React component, call `useAssignmentInfoForGraderAssignmentSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentInfoForGraderAssignmentSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentInfoForGraderAssignmentSubmissionsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useAssignmentInfoForGraderAssignmentSubmissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentInfoForGraderAssignmentSubmissionsQuery,
    AssignmentInfoForGraderAssignmentSubmissionsQueryVariables
  > &
    (
      | {
          variables: AssignmentInfoForGraderAssignmentSubmissionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentInfoForGraderAssignmentSubmissionsQuery,
    AssignmentInfoForGraderAssignmentSubmissionsQueryVariables
  >(AssignmentInfoForGraderAssignmentSubmissionsQueryDocument, options);
}
export function useAssignmentInfoForGraderAssignmentSubmissionsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentInfoForGraderAssignmentSubmissionsQuery,
    AssignmentInfoForGraderAssignmentSubmissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentInfoForGraderAssignmentSubmissionsQuery,
    AssignmentInfoForGraderAssignmentSubmissionsQueryVariables
  >(AssignmentInfoForGraderAssignmentSubmissionsQueryDocument, options);
}
export function useAssignmentInfoForGraderAssignmentSubmissionsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentInfoForGraderAssignmentSubmissionsQuery,
        AssignmentInfoForGraderAssignmentSubmissionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentInfoForGraderAssignmentSubmissionsQuery,
    AssignmentInfoForGraderAssignmentSubmissionsQueryVariables
  >(AssignmentInfoForGraderAssignmentSubmissionsQueryDocument, options);
}
export type AssignmentInfoForGraderAssignmentSubmissionsQueryHookResult =
  ReturnType<typeof useAssignmentInfoForGraderAssignmentSubmissionsQuery>;
export type AssignmentInfoForGraderAssignmentSubmissionsQueryLazyQueryHookResult =
  ReturnType<
    typeof useAssignmentInfoForGraderAssignmentSubmissionsQueryLazyQuery
  >;
export type AssignmentInfoForGraderAssignmentSubmissionsQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useAssignmentInfoForGraderAssignmentSubmissionsQuerySuspenseQuery
  >;
export type AssignmentInfoForGraderAssignmentSubmissionsQueryQueryResult =
  Apollo.QueryResult<
    AssignmentInfoForGraderAssignmentSubmissionsQuery,
    AssignmentInfoForGraderAssignmentSubmissionsQueryVariables
  >;
export const AssignmentItemPostQueryDocument = gql`
  query AssignmentItemPostQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...PostItemPostFields
    }
  }
  ${PostItemPostFieldsFragmentDoc}
`;

/**
 * __useAssignmentItemPostQuery__
 *
 * To run a query within a React component, call `useAssignmentItemPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentItemPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentItemPostQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useAssignmentItemPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentItemPostQuery,
    AssignmentItemPostQueryVariables
  > &
    (
      | { variables: AssignmentItemPostQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentItemPostQuery,
    AssignmentItemPostQueryVariables
  >(AssignmentItemPostQueryDocument, options);
}
export function useAssignmentItemPostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentItemPostQuery,
    AssignmentItemPostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentItemPostQuery,
    AssignmentItemPostQueryVariables
  >(AssignmentItemPostQueryDocument, options);
}
export function useAssignmentItemPostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentItemPostQuery,
        AssignmentItemPostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentItemPostQuery,
    AssignmentItemPostQueryVariables
  >(AssignmentItemPostQueryDocument, options);
}
export type AssignmentItemPostQueryHookResult = ReturnType<
  typeof useAssignmentItemPostQuery
>;
export type AssignmentItemPostQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentItemPostQueryLazyQuery
>;
export type AssignmentItemPostQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentItemPostQuerySuspenseQuery
>;
export type AssignmentItemPostQueryQueryResult = Apollo.QueryResult<
  AssignmentItemPostQuery,
  AssignmentItemPostQueryVariables
>;
export const AssignmentItemAssignmentQueryDocument = gql`
  query AssignmentItemAssignmentQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...PostItemBodyAssignmentDtoFields
    }
  }
  ${PostItemBodyAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __useAssignmentItemAssignmentQuery__
 *
 * To run a query within a React component, call `useAssignmentItemAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentItemAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentItemAssignmentQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useAssignmentItemAssignmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentItemAssignmentQuery,
    AssignmentItemAssignmentQueryVariables
  > &
    (
      | { variables: AssignmentItemAssignmentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentItemAssignmentQuery,
    AssignmentItemAssignmentQueryVariables
  >(AssignmentItemAssignmentQueryDocument, options);
}
export function useAssignmentItemAssignmentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentItemAssignmentQuery,
    AssignmentItemAssignmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentItemAssignmentQuery,
    AssignmentItemAssignmentQueryVariables
  >(AssignmentItemAssignmentQueryDocument, options);
}
export function useAssignmentItemAssignmentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentItemAssignmentQuery,
        AssignmentItemAssignmentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentItemAssignmentQuery,
    AssignmentItemAssignmentQueryVariables
  >(AssignmentItemAssignmentQueryDocument, options);
}
export type AssignmentItemAssignmentQueryHookResult = ReturnType<
  typeof useAssignmentItemAssignmentQuery
>;
export type AssignmentItemAssignmentQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentItemAssignmentQueryLazyQuery
>;
export type AssignmentItemAssignmentQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentItemAssignmentQuerySuspenseQuery
>;
export type AssignmentItemAssignmentQueryQueryResult = Apollo.QueryResult<
  AssignmentItemAssignmentQuery,
  AssignmentItemAssignmentQueryVariables
>;
export const AssignmentListQueryDocument = gql`
  query AssignmentListQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useAssignmentListQuery__
 *
 * To run a query within a React component, call `useAssignmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAssignmentListQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentListQuery,
    AssignmentListQueryVariables
  > &
    (
      | { variables: AssignmentListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssignmentListQuery, AssignmentListQueryVariables>(
    AssignmentListQueryDocument,
    options
  );
}
export function useAssignmentListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentListQuery,
    AssignmentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AssignmentListQuery, AssignmentListQueryVariables>(
    AssignmentListQueryDocument,
    options
  );
}
export function useAssignmentListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentListQuery,
        AssignmentListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentListQuery,
    AssignmentListQueryVariables
  >(AssignmentListQueryDocument, options);
}
export type AssignmentListQueryHookResult = ReturnType<
  typeof useAssignmentListQuery
>;
export type AssignmentListQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentListQueryLazyQuery
>;
export type AssignmentListQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentListQuerySuspenseQuery
>;
export type AssignmentListQueryQueryResult = Apollo.QueryResult<
  AssignmentListQuery,
  AssignmentListQueryVariables
>;
export const MemberAssignmentListQueryDocument = gql`
  query MemberAssignmentListQuery(
    $classroomId: String!
    $page: Float
    $perPage: Float
  ) {
    assignmentsCollection: listMemberAssignments(
      classroomId: $classroomId
      page: $page
      perPage: $perPage
    ) {
      assignments {
        ...PostItemBodyAssignmentDtoFields
      }
      page
      perPage
      totalPages
    }
  }
  ${PostItemBodyAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __useMemberAssignmentListQuery__
 *
 * To run a query within a React component, call `useMemberAssignmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberAssignmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberAssignmentListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMemberAssignmentListQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberAssignmentListQuery,
    MemberAssignmentListQueryVariables
  > &
    (
      | { variables: MemberAssignmentListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MemberAssignmentListQuery,
    MemberAssignmentListQueryVariables
  >(MemberAssignmentListQueryDocument, options);
}
export function useMemberAssignmentListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberAssignmentListQuery,
    MemberAssignmentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberAssignmentListQuery,
    MemberAssignmentListQueryVariables
  >(MemberAssignmentListQueryDocument, options);
}
export function useMemberAssignmentListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberAssignmentListQuery,
        MemberAssignmentListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberAssignmentListQuery,
    MemberAssignmentListQueryVariables
  >(MemberAssignmentListQueryDocument, options);
}
export type MemberAssignmentListQueryHookResult = ReturnType<
  typeof useMemberAssignmentListQuery
>;
export type MemberAssignmentListQueryLazyQueryHookResult = ReturnType<
  typeof useMemberAssignmentListQueryLazyQuery
>;
export type MemberAssignmentListQuerySuspenseQueryHookResult = ReturnType<
  typeof useMemberAssignmentListQuerySuspenseQuery
>;
export type MemberAssignmentListQueryQueryResult = Apollo.QueryResult<
  MemberAssignmentListQuery,
  MemberAssignmentListQueryVariables
>;
export const ClassroomAssignmentListQueryDocument = gql`
  query ClassroomAssignmentListQuery(
    $classroomId: String!
    $page: Float
    $perPage: Float
  ) {
    assignmentsCollection: listClassroomAssignments(
      classroomId: $classroomId
      page: $page
      perPage: $perPage
    ) {
      assignments {
        ...PostItemBodyAssignmentDtoFields
      }
      page
      perPage
      totalPages
    }
  }
  ${PostItemBodyAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __useClassroomAssignmentListQuery__
 *
 * To run a query within a React component, call `useClassroomAssignmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomAssignmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomAssignmentListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useClassroomAssignmentListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomAssignmentListQuery,
    ClassroomAssignmentListQueryVariables
  > &
    (
      | { variables: ClassroomAssignmentListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassroomAssignmentListQuery,
    ClassroomAssignmentListQueryVariables
  >(ClassroomAssignmentListQueryDocument, options);
}
export function useClassroomAssignmentListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomAssignmentListQuery,
    ClassroomAssignmentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomAssignmentListQuery,
    ClassroomAssignmentListQueryVariables
  >(ClassroomAssignmentListQueryDocument, options);
}
export function useClassroomAssignmentListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomAssignmentListQuery,
        ClassroomAssignmentListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomAssignmentListQuery,
    ClassroomAssignmentListQueryVariables
  >(ClassroomAssignmentListQueryDocument, options);
}
export type ClassroomAssignmentListQueryHookResult = ReturnType<
  typeof useClassroomAssignmentListQuery
>;
export type ClassroomAssignmentListQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomAssignmentListQueryLazyQuery
>;
export type ClassroomAssignmentListQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomAssignmentListQuerySuspenseQuery
>;
export type ClassroomAssignmentListQueryQueryResult = Apollo.QueryResult<
  ClassroomAssignmentListQuery,
  ClassroomAssignmentListQueryVariables
>;
export const AssignmentListPageHeaderQueryDocument = gql`
  query AssignmentListPageHeaderQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      countryCode
    }
  }
`;

/**
 * __useAssignmentListPageHeaderQuery__
 *
 * To run a query within a React component, call `useAssignmentListPageHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentListPageHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentListPageHeaderQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAssignmentListPageHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentListPageHeaderQuery,
    AssignmentListPageHeaderQueryVariables
  > &
    (
      | { variables: AssignmentListPageHeaderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentListPageHeaderQuery,
    AssignmentListPageHeaderQueryVariables
  >(AssignmentListPageHeaderQueryDocument, options);
}
export function useAssignmentListPageHeaderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentListPageHeaderQuery,
    AssignmentListPageHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentListPageHeaderQuery,
    AssignmentListPageHeaderQueryVariables
  >(AssignmentListPageHeaderQueryDocument, options);
}
export function useAssignmentListPageHeaderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentListPageHeaderQuery,
        AssignmentListPageHeaderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentListPageHeaderQuery,
    AssignmentListPageHeaderQueryVariables
  >(AssignmentListPageHeaderQueryDocument, options);
}
export type AssignmentListPageHeaderQueryHookResult = ReturnType<
  typeof useAssignmentListPageHeaderQuery
>;
export type AssignmentListPageHeaderQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentListPageHeaderQueryLazyQuery
>;
export type AssignmentListPageHeaderQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentListPageHeaderQuerySuspenseQuery
>;
export type AssignmentListPageHeaderQueryQueryResult = Apollo.QueryResult<
  AssignmentListPageHeaderQuery,
  AssignmentListPageHeaderQueryVariables
>;
export const DeleteAssignmentSubmissionCommentMutationDocument = gql`
  mutation DeleteAssignmentSubmissionCommentMutation(
    $assignmentSubmissionId: String!
    $commentId: String!
  ) {
    deleteAssignmentSubmissionComment(
      assignmentSubmissionId: $assignmentSubmissionId
      commentId: $commentId
    )
  }
`;
export type DeleteAssignmentSubmissionCommentMutationMutationFn =
  Apollo.MutationFunction<
    DeleteAssignmentSubmissionCommentMutation,
    DeleteAssignmentSubmissionCommentMutationVariables
  >;

/**
 * __useDeleteAssignmentSubmissionCommentMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentSubmissionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentSubmissionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentSubmissionCommentMutation, { data, loading, error }] = useDeleteAssignmentSubmissionCommentMutation({
 *   variables: {
 *      assignmentSubmissionId: // value for 'assignmentSubmissionId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteAssignmentSubmissionCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAssignmentSubmissionCommentMutation,
    DeleteAssignmentSubmissionCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAssignmentSubmissionCommentMutation,
    DeleteAssignmentSubmissionCommentMutationVariables
  >(DeleteAssignmentSubmissionCommentMutationDocument, options);
}
export type DeleteAssignmentSubmissionCommentMutationHookResult = ReturnType<
  typeof useDeleteAssignmentSubmissionCommentMutation
>;
export type DeleteAssignmentSubmissionCommentMutationMutationResult =
  Apollo.MutationResult<DeleteAssignmentSubmissionCommentMutation>;
export type DeleteAssignmentSubmissionCommentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteAssignmentSubmissionCommentMutation,
    DeleteAssignmentSubmissionCommentMutationVariables
  >;
export const UpdateAssignmentSubmissionCommentMutationDocument = gql`
  mutation UpdateAssignmentSubmissionCommentMutation(
    $assignmentSubmissionId: String!
    $commentId: String!
    $updateAssignmentSubmissionCommentDtoInput: UpdateAssignmentSubmissionCommentDtoInput!
  ) {
    comment: updateAssignmentSubmissionComment(
      assignmentSubmissionId: $assignmentSubmissionId
      commentId: $commentId
      updateAssignmentSubmissionCommentDtoInput: $updateAssignmentSubmissionCommentDtoInput
    ) {
      id
      content
    }
  }
`;
export type UpdateAssignmentSubmissionCommentMutationMutationFn =
  Apollo.MutationFunction<
    UpdateAssignmentSubmissionCommentMutation,
    UpdateAssignmentSubmissionCommentMutationVariables
  >;

/**
 * __useUpdateAssignmentSubmissionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentSubmissionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentSubmissionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentSubmissionCommentMutation, { data, loading, error }] = useUpdateAssignmentSubmissionCommentMutation({
 *   variables: {
 *      assignmentSubmissionId: // value for 'assignmentSubmissionId'
 *      commentId: // value for 'commentId'
 *      updateAssignmentSubmissionCommentDtoInput: // value for 'updateAssignmentSubmissionCommentDtoInput'
 *   },
 * });
 */
export function useUpdateAssignmentSubmissionCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAssignmentSubmissionCommentMutation,
    UpdateAssignmentSubmissionCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAssignmentSubmissionCommentMutation,
    UpdateAssignmentSubmissionCommentMutationVariables
  >(UpdateAssignmentSubmissionCommentMutationDocument, options);
}
export type UpdateAssignmentSubmissionCommentMutationHookResult = ReturnType<
  typeof useUpdateAssignmentSubmissionCommentMutation
>;
export type UpdateAssignmentSubmissionCommentMutationMutationResult =
  Apollo.MutationResult<UpdateAssignmentSubmissionCommentMutation>;
export type UpdateAssignmentSubmissionCommentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAssignmentSubmissionCommentMutation,
    UpdateAssignmentSubmissionCommentMutationVariables
  >;
export const AssignmentSubmissionCommentItemQueryDocument = gql`
  query AssignmentSubmissionCommentItemQuery(
    $classroomId: String!
    $assignmentSubmissionId: String!
    $commentId: String!
  ) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
    }
    commentPermission: getAssignmentSubmissionCommentPermission(
      assignmentSubmissionId: $assignmentSubmissionId
      commentId: $commentId
    ) {
      canDelete
      canEdit
    }
  }
`;

/**
 * __useAssignmentSubmissionCommentItemQuery__
 *
 * To run a query within a React component, call `useAssignmentSubmissionCommentItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentSubmissionCommentItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentSubmissionCommentItemQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentSubmissionId: // value for 'assignmentSubmissionId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useAssignmentSubmissionCommentItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentSubmissionCommentItemQuery,
    AssignmentSubmissionCommentItemQueryVariables
  > &
    (
      | {
          variables: AssignmentSubmissionCommentItemQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentSubmissionCommentItemQuery,
    AssignmentSubmissionCommentItemQueryVariables
  >(AssignmentSubmissionCommentItemQueryDocument, options);
}
export function useAssignmentSubmissionCommentItemQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentSubmissionCommentItemQuery,
    AssignmentSubmissionCommentItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentSubmissionCommentItemQuery,
    AssignmentSubmissionCommentItemQueryVariables
  >(AssignmentSubmissionCommentItemQueryDocument, options);
}
export function useAssignmentSubmissionCommentItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentSubmissionCommentItemQuery,
        AssignmentSubmissionCommentItemQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentSubmissionCommentItemQuery,
    AssignmentSubmissionCommentItemQueryVariables
  >(AssignmentSubmissionCommentItemQueryDocument, options);
}
export type AssignmentSubmissionCommentItemQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionCommentItemQuery
>;
export type AssignmentSubmissionCommentItemQueryLazyQueryHookResult =
  ReturnType<typeof useAssignmentSubmissionCommentItemQueryLazyQuery>;
export type AssignmentSubmissionCommentItemQuerySuspenseQueryHookResult =
  ReturnType<typeof useAssignmentSubmissionCommentItemQuerySuspenseQuery>;
export type AssignmentSubmissionCommentItemQueryQueryResult =
  Apollo.QueryResult<
    AssignmentSubmissionCommentItemQuery,
    AssignmentSubmissionCommentItemQueryVariables
  >;
export const AssignmentSubmissionCommentListCurrentMemberQueryDocument = gql`
  query AssignmentSubmissionCommentListCurrentMemberQuery(
    $classroomId: String!
  ) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      group
    }
  }
`;

/**
 * __useAssignmentSubmissionCommentListCurrentMemberQuery__
 *
 * To run a query within a React component, call `useAssignmentSubmissionCommentListCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentSubmissionCommentListCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentSubmissionCommentListCurrentMemberQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAssignmentSubmissionCommentListCurrentMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentSubmissionCommentListCurrentMemberQuery,
    AssignmentSubmissionCommentListCurrentMemberQueryVariables
  > &
    (
      | {
          variables: AssignmentSubmissionCommentListCurrentMemberQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentSubmissionCommentListCurrentMemberQuery,
    AssignmentSubmissionCommentListCurrentMemberQueryVariables
  >(AssignmentSubmissionCommentListCurrentMemberQueryDocument, options);
}
export function useAssignmentSubmissionCommentListCurrentMemberQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentSubmissionCommentListCurrentMemberQuery,
    AssignmentSubmissionCommentListCurrentMemberQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentSubmissionCommentListCurrentMemberQuery,
    AssignmentSubmissionCommentListCurrentMemberQueryVariables
  >(AssignmentSubmissionCommentListCurrentMemberQueryDocument, options);
}
export function useAssignmentSubmissionCommentListCurrentMemberQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentSubmissionCommentListCurrentMemberQuery,
        AssignmentSubmissionCommentListCurrentMemberQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentSubmissionCommentListCurrentMemberQuery,
    AssignmentSubmissionCommentListCurrentMemberQueryVariables
  >(AssignmentSubmissionCommentListCurrentMemberQueryDocument, options);
}
export type AssignmentSubmissionCommentListCurrentMemberQueryHookResult =
  ReturnType<typeof useAssignmentSubmissionCommentListCurrentMemberQuery>;
export type AssignmentSubmissionCommentListCurrentMemberQueryLazyQueryHookResult =
  ReturnType<
    typeof useAssignmentSubmissionCommentListCurrentMemberQueryLazyQuery
  >;
export type AssignmentSubmissionCommentListCurrentMemberQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useAssignmentSubmissionCommentListCurrentMemberQuerySuspenseQuery
  >;
export type AssignmentSubmissionCommentListCurrentMemberQueryQueryResult =
  Apollo.QueryResult<
    AssignmentSubmissionCommentListCurrentMemberQuery,
    AssignmentSubmissionCommentListCurrentMemberQueryVariables
  >;
export const AssignmentSubmissionCommentListQueryDocument = gql`
  query AssignmentSubmissionCommentListQuery(
    $assignmentSubmissionId: String!
    $cursor: String
    $limit: Float
  ) {
    assignmentSubmissionCommentsCollection: listAssignmentSubmissionComments(
      assignmentSubmissionId: $assignmentSubmissionId
      limit: $limit
      cursor: $cursor
    ) {
      assignmentSubmissionComments {
        ...AssignmentSubmissionCommentItemAssignmentSubmissionCommentFields
      }
      cursor
    }
  }
  ${AssignmentSubmissionCommentItemAssignmentSubmissionCommentFieldsFragmentDoc}
`;

/**
 * __useAssignmentSubmissionCommentListQuery__
 *
 * To run a query within a React component, call `useAssignmentSubmissionCommentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentSubmissionCommentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentSubmissionCommentListQuery({
 *   variables: {
 *      assignmentSubmissionId: // value for 'assignmentSubmissionId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAssignmentSubmissionCommentListQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentSubmissionCommentListQuery,
    AssignmentSubmissionCommentListQueryVariables
  > &
    (
      | {
          variables: AssignmentSubmissionCommentListQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentSubmissionCommentListQuery,
    AssignmentSubmissionCommentListQueryVariables
  >(AssignmentSubmissionCommentListQueryDocument, options);
}
export function useAssignmentSubmissionCommentListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentSubmissionCommentListQuery,
    AssignmentSubmissionCommentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentSubmissionCommentListQuery,
    AssignmentSubmissionCommentListQueryVariables
  >(AssignmentSubmissionCommentListQueryDocument, options);
}
export function useAssignmentSubmissionCommentListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentSubmissionCommentListQuery,
        AssignmentSubmissionCommentListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentSubmissionCommentListQuery,
    AssignmentSubmissionCommentListQueryVariables
  >(AssignmentSubmissionCommentListQueryDocument, options);
}
export type AssignmentSubmissionCommentListQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionCommentListQuery
>;
export type AssignmentSubmissionCommentListQueryLazyQueryHookResult =
  ReturnType<typeof useAssignmentSubmissionCommentListQueryLazyQuery>;
export type AssignmentSubmissionCommentListQuerySuspenseQueryHookResult =
  ReturnType<typeof useAssignmentSubmissionCommentListQuerySuspenseQuery>;
export type AssignmentSubmissionCommentListQueryQueryResult =
  Apollo.QueryResult<
    AssignmentSubmissionCommentListQuery,
    AssignmentSubmissionCommentListQueryVariables
  >;
export const CompleteAssignmentSubmissionMutationDocument = gql`
  mutation CompleteAssignmentSubmissionMutation(
    $assignmentId: String!
    $classroomId: String!
    $completeAssignmentSubmissionDtoInput: CompleteAssignmentSubmissionDtoInput!
  ) {
    completeAssignmentSubmission(
      assignmentId: $assignmentId
      classroomId: $classroomId
      completeAssignmentSubmissionDtoInput: $completeAssignmentSubmissionDtoInput
    ) {
      ...AssignmentSubmissionNavItemAssignmentSubmissionDtoFields
    }
  }
  ${AssignmentSubmissionNavItemAssignmentSubmissionDtoFieldsFragmentDoc}
`;
export type CompleteAssignmentSubmissionMutationMutationFn =
  Apollo.MutationFunction<
    CompleteAssignmentSubmissionMutation,
    CompleteAssignmentSubmissionMutationVariables
  >;

/**
 * __useCompleteAssignmentSubmissionMutation__
 *
 * To run a mutation, you first call `useCompleteAssignmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAssignmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAssignmentSubmissionMutation, { data, loading, error }] = useCompleteAssignmentSubmissionMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      classroomId: // value for 'classroomId'
 *      completeAssignmentSubmissionDtoInput: // value for 'completeAssignmentSubmissionDtoInput'
 *   },
 * });
 */
export function useCompleteAssignmentSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteAssignmentSubmissionMutation,
    CompleteAssignmentSubmissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteAssignmentSubmissionMutation,
    CompleteAssignmentSubmissionMutationVariables
  >(CompleteAssignmentSubmissionMutationDocument, options);
}
export type CompleteAssignmentSubmissionMutationHookResult = ReturnType<
  typeof useCompleteAssignmentSubmissionMutation
>;
export type CompleteAssignmentSubmissionMutationMutationResult =
  Apollo.MutationResult<CompleteAssignmentSubmissionMutation>;
export type CompleteAssignmentSubmissionMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteAssignmentSubmissionMutation,
    CompleteAssignmentSubmissionMutationVariables
  >;
export const SaveAssignmentSubmissionPointsMutationDocument = gql`
  mutation SaveAssignmentSubmissionPointsMutation(
    $assignmentId: String!
    $classroomId: String!
    $assigneeId: String!
    $saveAssignmentSubmissionPointsDtoInput: SaveAssignmentSubmissionPointsDtoInput!
  ) {
    saveAssignmentSubmissionPoints(
      assignmentId: $assignmentId
      classroomId: $classroomId
      assigneeId: $assigneeId
      saveAssignmentSubmissionPointsDtoInput: $saveAssignmentSubmissionPointsDtoInput
    ) {
      ...AssignmentSubmissionNavItemAssignmentSubmissionDtoFields
    }
  }
  ${AssignmentSubmissionNavItemAssignmentSubmissionDtoFieldsFragmentDoc}
`;
export type SaveAssignmentSubmissionPointsMutationMutationFn =
  Apollo.MutationFunction<
    SaveAssignmentSubmissionPointsMutation,
    SaveAssignmentSubmissionPointsMutationVariables
  >;

/**
 * __useSaveAssignmentSubmissionPointsMutation__
 *
 * To run a mutation, you first call `useSaveAssignmentSubmissionPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssignmentSubmissionPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssignmentSubmissionPointsMutation, { data, loading, error }] = useSaveAssignmentSubmissionPointsMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      classroomId: // value for 'classroomId'
 *      assigneeId: // value for 'assigneeId'
 *      saveAssignmentSubmissionPointsDtoInput: // value for 'saveAssignmentSubmissionPointsDtoInput'
 *   },
 * });
 */
export function useSaveAssignmentSubmissionPointsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveAssignmentSubmissionPointsMutation,
    SaveAssignmentSubmissionPointsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveAssignmentSubmissionPointsMutation,
    SaveAssignmentSubmissionPointsMutationVariables
  >(SaveAssignmentSubmissionPointsMutationDocument, options);
}
export type SaveAssignmentSubmissionPointsMutationHookResult = ReturnType<
  typeof useSaveAssignmentSubmissionPointsMutation
>;
export type SaveAssignmentSubmissionPointsMutationMutationResult =
  Apollo.MutationResult<SaveAssignmentSubmissionPointsMutation>;
export type SaveAssignmentSubmissionPointsMutationMutationOptions =
  Apollo.BaseMutationOptions<
    SaveAssignmentSubmissionPointsMutation,
    SaveAssignmentSubmissionPointsMutationVariables
  >;
export const AssignmentSubmissionNavItemQueryDocument = gql`
  query AssignmentSubmissionNavItemQuery(
    $classroomId: String!
    $memberId: String!
  ) {
    member: getClassroomMember(classroomId: $classroomId, memberId: $memberId) {
      id
      name
      profileImageUrl
    }
  }
`;

/**
 * __useAssignmentSubmissionNavItemQuery__
 *
 * To run a query within a React component, call `useAssignmentSubmissionNavItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentSubmissionNavItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentSubmissionNavItemQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useAssignmentSubmissionNavItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentSubmissionNavItemQuery,
    AssignmentSubmissionNavItemQueryVariables
  > &
    (
      | { variables: AssignmentSubmissionNavItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentSubmissionNavItemQuery,
    AssignmentSubmissionNavItemQueryVariables
  >(AssignmentSubmissionNavItemQueryDocument, options);
}
export function useAssignmentSubmissionNavItemQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentSubmissionNavItemQuery,
    AssignmentSubmissionNavItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentSubmissionNavItemQuery,
    AssignmentSubmissionNavItemQueryVariables
  >(AssignmentSubmissionNavItemQueryDocument, options);
}
export function useAssignmentSubmissionNavItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentSubmissionNavItemQuery,
        AssignmentSubmissionNavItemQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentSubmissionNavItemQuery,
    AssignmentSubmissionNavItemQueryVariables
  >(AssignmentSubmissionNavItemQueryDocument, options);
}
export type AssignmentSubmissionNavItemQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionNavItemQuery
>;
export type AssignmentSubmissionNavItemQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionNavItemQueryLazyQuery
>;
export type AssignmentSubmissionNavItemQuerySuspenseQueryHookResult =
  ReturnType<typeof useAssignmentSubmissionNavItemQuerySuspenseQuery>;
export type AssignmentSubmissionNavItemQueryQueryResult = Apollo.QueryResult<
  AssignmentSubmissionNavItemQuery,
  AssignmentSubmissionNavItemQueryVariables
>;
export const CompleteAllAssignmentSubmissionMutationDocument = gql`
  mutation CompleteAllAssignmentSubmissionMutation(
    $assignmentId: String!
    $classroomId: String!
  ) {
    completeAllAssignmentSubmission(
      assignmentId: $assignmentId
      classroomId: $classroomId
    ) {
      id
      gradingStatus
    }
  }
`;
export type CompleteAllAssignmentSubmissionMutationMutationFn =
  Apollo.MutationFunction<
    CompleteAllAssignmentSubmissionMutation,
    CompleteAllAssignmentSubmissionMutationVariables
  >;

/**
 * __useCompleteAllAssignmentSubmissionMutation__
 *
 * To run a mutation, you first call `useCompleteAllAssignmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAllAssignmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAllAssignmentSubmissionMutation, { data, loading, error }] = useCompleteAllAssignmentSubmissionMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useCompleteAllAssignmentSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteAllAssignmentSubmissionMutation,
    CompleteAllAssignmentSubmissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteAllAssignmentSubmissionMutation,
    CompleteAllAssignmentSubmissionMutationVariables
  >(CompleteAllAssignmentSubmissionMutationDocument, options);
}
export type CompleteAllAssignmentSubmissionMutationHookResult = ReturnType<
  typeof useCompleteAllAssignmentSubmissionMutation
>;
export type CompleteAllAssignmentSubmissionMutationMutationResult =
  Apollo.MutationResult<CompleteAllAssignmentSubmissionMutation>;
export type CompleteAllAssignmentSubmissionMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteAllAssignmentSubmissionMutation,
    CompleteAllAssignmentSubmissionMutationVariables
  >;
export const CommunityLearningCardListQueryDocument = gql`
  query CommunityLearningCardListQuery(
    $coreConceptId: String
    $gradeId: String
    $mediaType: String
    $offset: Float
    $limit: Float
    $orderBy: String = "updated_at"
    $publisherId: Float
    $schoolId: String
    $searchKeywords: String
    $shareLevel: Float
    $subjectId: Float
    $unitId: Float
  ) {
    learningCardCollection: listLearningCommunityCards(
      coreConceptId: $coreConceptId
      gradeId: $gradeId
      mediaType: $mediaType
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      publisherId: $publisherId
      schoolId: $schoolId
      searchKeywords: $searchKeywords
      shareLevel: $shareLevel
      subjectId: $subjectId
      unitId: $unitId
    ) {
      learningCards {
        ...LearningCardItemLearningCardFields
      }
      offset
      limit
    }
  }
  ${LearningCardItemLearningCardFieldsFragmentDoc}
`;

/**
 * __useCommunityLearningCardListQuery__
 *
 * To run a query within a React component, call `useCommunityLearningCardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityLearningCardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityLearningCardListQuery({
 *   variables: {
 *      coreConceptId: // value for 'coreConceptId'
 *      gradeId: // value for 'gradeId'
 *      mediaType: // value for 'mediaType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      publisherId: // value for 'publisherId'
 *      schoolId: // value for 'schoolId'
 *      searchKeywords: // value for 'searchKeywords'
 *      shareLevel: // value for 'shareLevel'
 *      subjectId: // value for 'subjectId'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useCommunityLearningCardListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CommunityLearningCardListQuery,
    CommunityLearningCardListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CommunityLearningCardListQuery,
    CommunityLearningCardListQueryVariables
  >(CommunityLearningCardListQueryDocument, options);
}
export function useCommunityLearningCardListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommunityLearningCardListQuery,
    CommunityLearningCardListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CommunityLearningCardListQuery,
    CommunityLearningCardListQueryVariables
  >(CommunityLearningCardListQueryDocument, options);
}
export function useCommunityLearningCardListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CommunityLearningCardListQuery,
        CommunityLearningCardListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CommunityLearningCardListQuery,
    CommunityLearningCardListQueryVariables
  >(CommunityLearningCardListQueryDocument, options);
}
export type CommunityLearningCardListQueryHookResult = ReturnType<
  typeof useCommunityLearningCardListQuery
>;
export type CommunityLearningCardListQueryLazyQueryHookResult = ReturnType<
  typeof useCommunityLearningCardListQueryLazyQuery
>;
export type CommunityLearningCardListQuerySuspenseQueryHookResult = ReturnType<
  typeof useCommunityLearningCardListQuerySuspenseQuery
>;
export type CommunityLearningCardListQueryQueryResult = Apollo.QueryResult<
  CommunityLearningCardListQuery,
  CommunityLearningCardListQueryVariables
>;
export const EditableLearningCardMyLearningCardQueryDocument = gql`
  query EditableLearningCardMyLearningCardQuery($learningCardId: Float!) {
    learningCard: getLearningCard(learningCardId: $learningCardId) {
      ...EditableLearningCardLearningCardFields
    }
  }
  ${EditableLearningCardLearningCardFieldsFragmentDoc}
`;

/**
 * __useEditableLearningCardMyLearningCardQuery__
 *
 * To run a query within a React component, call `useEditableLearningCardMyLearningCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditableLearningCardMyLearningCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditableLearningCardMyLearningCardQuery({
 *   variables: {
 *      learningCardId: // value for 'learningCardId'
 *   },
 * });
 */
export function useEditableLearningCardMyLearningCardQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditableLearningCardMyLearningCardQuery,
    EditableLearningCardMyLearningCardQueryVariables
  > &
    (
      | {
          variables: EditableLearningCardMyLearningCardQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EditableLearningCardMyLearningCardQuery,
    EditableLearningCardMyLearningCardQueryVariables
  >(EditableLearningCardMyLearningCardQueryDocument, options);
}
export function useEditableLearningCardMyLearningCardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditableLearningCardMyLearningCardQuery,
    EditableLearningCardMyLearningCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EditableLearningCardMyLearningCardQuery,
    EditableLearningCardMyLearningCardQueryVariables
  >(EditableLearningCardMyLearningCardQueryDocument, options);
}
export function useEditableLearningCardMyLearningCardQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditableLearningCardMyLearningCardQuery,
        EditableLearningCardMyLearningCardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EditableLearningCardMyLearningCardQuery,
    EditableLearningCardMyLearningCardQueryVariables
  >(EditableLearningCardMyLearningCardQueryDocument, options);
}
export type EditableLearningCardMyLearningCardQueryHookResult = ReturnType<
  typeof useEditableLearningCardMyLearningCardQuery
>;
export type EditableLearningCardMyLearningCardQueryLazyQueryHookResult =
  ReturnType<typeof useEditableLearningCardMyLearningCardQueryLazyQuery>;
export type EditableLearningCardMyLearningCardQuerySuspenseQueryHookResult =
  ReturnType<typeof useEditableLearningCardMyLearningCardQuerySuspenseQuery>;
export type EditableLearningCardMyLearningCardQueryQueryResult =
  Apollo.QueryResult<
    EditableLearningCardMyLearningCardQuery,
    EditableLearningCardMyLearningCardQueryVariables
  >;
export const SubmitLearningCardAnswerMutationDocument = gql`
  mutation SubmitLearningCardAnswerMutation(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignmentSubmission: submitLearningSubmission(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      id
      assigneeId
      status
      gradingStatus
      learningSubmission {
        id
      }
    }
  }
`;
export type SubmitLearningCardAnswerMutationMutationFn =
  Apollo.MutationFunction<
    SubmitLearningCardAnswerMutation,
    SubmitLearningCardAnswerMutationVariables
  >;

/**
 * __useSubmitLearningCardAnswerMutation__
 *
 * To run a mutation, you first call `useSubmitLearningCardAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLearningCardAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLearningCardAnswerMutation, { data, loading, error }] = useSubmitLearningCardAnswerMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useSubmitLearningCardAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitLearningCardAnswerMutation,
    SubmitLearningCardAnswerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitLearningCardAnswerMutation,
    SubmitLearningCardAnswerMutationVariables
  >(SubmitLearningCardAnswerMutationDocument, options);
}
export type SubmitLearningCardAnswerMutationHookResult = ReturnType<
  typeof useSubmitLearningCardAnswerMutation
>;
export type SubmitLearningCardAnswerMutationMutationResult =
  Apollo.MutationResult<SubmitLearningCardAnswerMutation>;
export type SubmitLearningCardAnswerMutationMutationOptions =
  Apollo.BaseMutationOptions<
    SubmitLearningCardAnswerMutation,
    SubmitLearningCardAnswerMutationVariables
  >;
export const LearningCardExtensionLearningStoreCardQueryDocument = gql`
  query LearningCardExtensionLearningStoreCardQuery(
    $learningStoreCardId: Float!
  ) {
    learningCard: getLearningStoreCard(
      learningStoreCardId: $learningStoreCardId
    ) {
      ...LearningCardExtensionLearningCardFields
    }
  }
  ${LearningCardExtensionLearningCardFieldsFragmentDoc}
`;

/**
 * __useLearningCardExtensionLearningStoreCardQuery__
 *
 * To run a query within a React component, call `useLearningCardExtensionLearningStoreCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardExtensionLearningStoreCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardExtensionLearningStoreCardQuery({
 *   variables: {
 *      learningStoreCardId: // value for 'learningStoreCardId'
 *   },
 * });
 */
export function useLearningCardExtensionLearningStoreCardQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardExtensionLearningStoreCardQuery,
    LearningCardExtensionLearningStoreCardQueryVariables
  > &
    (
      | {
          variables: LearningCardExtensionLearningStoreCardQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardExtensionLearningStoreCardQuery,
    LearningCardExtensionLearningStoreCardQueryVariables
  >(LearningCardExtensionLearningStoreCardQueryDocument, options);
}
export function useLearningCardExtensionLearningStoreCardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardExtensionLearningStoreCardQuery,
    LearningCardExtensionLearningStoreCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardExtensionLearningStoreCardQuery,
    LearningCardExtensionLearningStoreCardQueryVariables
  >(LearningCardExtensionLearningStoreCardQueryDocument, options);
}
export function useLearningCardExtensionLearningStoreCardQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardExtensionLearningStoreCardQuery,
        LearningCardExtensionLearningStoreCardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardExtensionLearningStoreCardQuery,
    LearningCardExtensionLearningStoreCardQueryVariables
  >(LearningCardExtensionLearningStoreCardQueryDocument, options);
}
export type LearningCardExtensionLearningStoreCardQueryHookResult = ReturnType<
  typeof useLearningCardExtensionLearningStoreCardQuery
>;
export type LearningCardExtensionLearningStoreCardQueryLazyQueryHookResult =
  ReturnType<typeof useLearningCardExtensionLearningStoreCardQueryLazyQuery>;
export type LearningCardExtensionLearningStoreCardQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useLearningCardExtensionLearningStoreCardQuerySuspenseQuery
  >;
export type LearningCardExtensionLearningStoreCardQueryQueryResult =
  Apollo.QueryResult<
    LearningCardExtensionLearningStoreCardQuery,
    LearningCardExtensionLearningStoreCardQueryVariables
  >;
export const LearningCardExtensionLearningCardQueryDocument = gql`
  query LearningCardExtensionLearningCardQuery($learningCardId: Float!) {
    learningCard: getLearningCard(learningCardId: $learningCardId) {
      ...LearningCardExtensionLearningCardFields
    }
  }
  ${LearningCardExtensionLearningCardFieldsFragmentDoc}
`;

/**
 * __useLearningCardExtensionLearningCardQuery__
 *
 * To run a query within a React component, call `useLearningCardExtensionLearningCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardExtensionLearningCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardExtensionLearningCardQuery({
 *   variables: {
 *      learningCardId: // value for 'learningCardId'
 *   },
 * });
 */
export function useLearningCardExtensionLearningCardQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardExtensionLearningCardQuery,
    LearningCardExtensionLearningCardQueryVariables
  > &
    (
      | {
          variables: LearningCardExtensionLearningCardQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardExtensionLearningCardQuery,
    LearningCardExtensionLearningCardQueryVariables
  >(LearningCardExtensionLearningCardQueryDocument, options);
}
export function useLearningCardExtensionLearningCardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardExtensionLearningCardQuery,
    LearningCardExtensionLearningCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardExtensionLearningCardQuery,
    LearningCardExtensionLearningCardQueryVariables
  >(LearningCardExtensionLearningCardQueryDocument, options);
}
export function useLearningCardExtensionLearningCardQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardExtensionLearningCardQuery,
        LearningCardExtensionLearningCardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardExtensionLearningCardQuery,
    LearningCardExtensionLearningCardQueryVariables
  >(LearningCardExtensionLearningCardQueryDocument, options);
}
export type LearningCardExtensionLearningCardQueryHookResult = ReturnType<
  typeof useLearningCardExtensionLearningCardQuery
>;
export type LearningCardExtensionLearningCardQueryLazyQueryHookResult =
  ReturnType<typeof useLearningCardExtensionLearningCardQueryLazyQuery>;
export type LearningCardExtensionLearningCardQuerySuspenseQueryHookResult =
  ReturnType<typeof useLearningCardExtensionLearningCardQuerySuspenseQuery>;
export type LearningCardExtensionLearningCardQueryQueryResult =
  Apollo.QueryResult<
    LearningCardExtensionLearningCardQuery,
    LearningCardExtensionLearningCardQueryVariables
  >;
export const LearningCardFilterQueryDocument = gql`
  query LearningCardFilterQuery {
    grades: listLearningGrades {
      id
      name
      schoolYear
    }
    subjects: listLearningSubjects {
      id
      name
      gradeLowerBound
      gradeUpperBound
    }
  }
`;

/**
 * __useLearningCardFilterQuery__
 *
 * To run a query within a React component, call `useLearningCardFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useLearningCardFilterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LearningCardFilterQuery,
    LearningCardFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardFilterQuery,
    LearningCardFilterQueryVariables
  >(LearningCardFilterQueryDocument, options);
}
export function useLearningCardFilterQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardFilterQuery,
    LearningCardFilterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardFilterQuery,
    LearningCardFilterQueryVariables
  >(LearningCardFilterQueryDocument, options);
}
export function useLearningCardFilterQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardFilterQuery,
        LearningCardFilterQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardFilterQuery,
    LearningCardFilterQueryVariables
  >(LearningCardFilterQueryDocument, options);
}
export type LearningCardFilterQueryHookResult = ReturnType<
  typeof useLearningCardFilterQuery
>;
export type LearningCardFilterQueryLazyQueryHookResult = ReturnType<
  typeof useLearningCardFilterQueryLazyQuery
>;
export type LearningCardFilterQuerySuspenseQueryHookResult = ReturnType<
  typeof useLearningCardFilterQuerySuspenseQuery
>;
export type LearningCardFilterQueryQueryResult = Apollo.QueryResult<
  LearningCardFilterQuery,
  LearningCardFilterQueryVariables
>;
export const LearningCardFilterUnitsQueryDocument = gql`
  query LearningCardFilterUnitsQuery($gradeId: ID!, $subjectId: ID!) {
    units: listLearningUnits(gradeId: $gradeId, subjectId: $subjectId) {
      id
      name
    }
  }
`;

/**
 * __useLearningCardFilterUnitsQuery__
 *
 * To run a query within a React component, call `useLearningCardFilterUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardFilterUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardFilterUnitsQuery({
 *   variables: {
 *      gradeId: // value for 'gradeId'
 *      subjectId: // value for 'subjectId'
 *   },
 * });
 */
export function useLearningCardFilterUnitsQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardFilterUnitsQuery,
    LearningCardFilterUnitsQueryVariables
  > &
    (
      | { variables: LearningCardFilterUnitsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardFilterUnitsQuery,
    LearningCardFilterUnitsQueryVariables
  >(LearningCardFilterUnitsQueryDocument, options);
}
export function useLearningCardFilterUnitsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardFilterUnitsQuery,
    LearningCardFilterUnitsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardFilterUnitsQuery,
    LearningCardFilterUnitsQueryVariables
  >(LearningCardFilterUnitsQueryDocument, options);
}
export function useLearningCardFilterUnitsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardFilterUnitsQuery,
        LearningCardFilterUnitsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardFilterUnitsQuery,
    LearningCardFilterUnitsQueryVariables
  >(LearningCardFilterUnitsQueryDocument, options);
}
export type LearningCardFilterUnitsQueryHookResult = ReturnType<
  typeof useLearningCardFilterUnitsQuery
>;
export type LearningCardFilterUnitsQueryLazyQueryHookResult = ReturnType<
  typeof useLearningCardFilterUnitsQueryLazyQuery
>;
export type LearningCardFilterUnitsQuerySuspenseQueryHookResult = ReturnType<
  typeof useLearningCardFilterUnitsQuerySuspenseQuery
>;
export type LearningCardFilterUnitsQueryQueryResult = Apollo.QueryResult<
  LearningCardFilterUnitsQuery,
  LearningCardFilterUnitsQueryVariables
>;
export const LearningCardPreviewPopupLearningStoreCardQueryDocument = gql`
  query LearningCardPreviewPopupLearningStoreCardQuery(
    $learningStoreCardId: Float!
  ) {
    learningCard: getLearningStoreCard(
      learningStoreCardId: $learningStoreCardId
    ) {
      id
      title
      pageCount
      copyId
    }
  }
`;

/**
 * __useLearningCardPreviewPopupLearningStoreCardQuery__
 *
 * To run a query within a React component, call `useLearningCardPreviewPopupLearningStoreCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardPreviewPopupLearningStoreCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardPreviewPopupLearningStoreCardQuery({
 *   variables: {
 *      learningStoreCardId: // value for 'learningStoreCardId'
 *   },
 * });
 */
export function useLearningCardPreviewPopupLearningStoreCardQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardPreviewPopupLearningStoreCardQuery,
    LearningCardPreviewPopupLearningStoreCardQueryVariables
  > &
    (
      | {
          variables: LearningCardPreviewPopupLearningStoreCardQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardPreviewPopupLearningStoreCardQuery,
    LearningCardPreviewPopupLearningStoreCardQueryVariables
  >(LearningCardPreviewPopupLearningStoreCardQueryDocument, options);
}
export function useLearningCardPreviewPopupLearningStoreCardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardPreviewPopupLearningStoreCardQuery,
    LearningCardPreviewPopupLearningStoreCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardPreviewPopupLearningStoreCardQuery,
    LearningCardPreviewPopupLearningStoreCardQueryVariables
  >(LearningCardPreviewPopupLearningStoreCardQueryDocument, options);
}
export function useLearningCardPreviewPopupLearningStoreCardQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardPreviewPopupLearningStoreCardQuery,
        LearningCardPreviewPopupLearningStoreCardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardPreviewPopupLearningStoreCardQuery,
    LearningCardPreviewPopupLearningStoreCardQueryVariables
  >(LearningCardPreviewPopupLearningStoreCardQueryDocument, options);
}
export type LearningCardPreviewPopupLearningStoreCardQueryHookResult =
  ReturnType<typeof useLearningCardPreviewPopupLearningStoreCardQuery>;
export type LearningCardPreviewPopupLearningStoreCardQueryLazyQueryHookResult =
  ReturnType<typeof useLearningCardPreviewPopupLearningStoreCardQueryLazyQuery>;
export type LearningCardPreviewPopupLearningStoreCardQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useLearningCardPreviewPopupLearningStoreCardQuerySuspenseQuery
  >;
export type LearningCardPreviewPopupLearningStoreCardQueryQueryResult =
  Apollo.QueryResult<
    LearningCardPreviewPopupLearningStoreCardQuery,
    LearningCardPreviewPopupLearningStoreCardQueryVariables
  >;
export const LearningCardPreviewPopupMyLearningCardQueryDocument = gql`
  query LearningCardPreviewPopupMyLearningCardQuery($learningCardId: Float!) {
    learningCard: getLearningCard(learningCardId: $learningCardId) {
      id
      title
      pageCount
    }
  }
`;

/**
 * __useLearningCardPreviewPopupMyLearningCardQuery__
 *
 * To run a query within a React component, call `useLearningCardPreviewPopupMyLearningCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardPreviewPopupMyLearningCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardPreviewPopupMyLearningCardQuery({
 *   variables: {
 *      learningCardId: // value for 'learningCardId'
 *   },
 * });
 */
export function useLearningCardPreviewPopupMyLearningCardQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardPreviewPopupMyLearningCardQuery,
    LearningCardPreviewPopupMyLearningCardQueryVariables
  > &
    (
      | {
          variables: LearningCardPreviewPopupMyLearningCardQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardPreviewPopupMyLearningCardQuery,
    LearningCardPreviewPopupMyLearningCardQueryVariables
  >(LearningCardPreviewPopupMyLearningCardQueryDocument, options);
}
export function useLearningCardPreviewPopupMyLearningCardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardPreviewPopupMyLearningCardQuery,
    LearningCardPreviewPopupMyLearningCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardPreviewPopupMyLearningCardQuery,
    LearningCardPreviewPopupMyLearningCardQueryVariables
  >(LearningCardPreviewPopupMyLearningCardQueryDocument, options);
}
export function useLearningCardPreviewPopupMyLearningCardQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardPreviewPopupMyLearningCardQuery,
        LearningCardPreviewPopupMyLearningCardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardPreviewPopupMyLearningCardQuery,
    LearningCardPreviewPopupMyLearningCardQueryVariables
  >(LearningCardPreviewPopupMyLearningCardQueryDocument, options);
}
export type LearningCardPreviewPopupMyLearningCardQueryHookResult = ReturnType<
  typeof useLearningCardPreviewPopupMyLearningCardQuery
>;
export type LearningCardPreviewPopupMyLearningCardQueryLazyQueryHookResult =
  ReturnType<typeof useLearningCardPreviewPopupMyLearningCardQueryLazyQuery>;
export type LearningCardPreviewPopupMyLearningCardQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useLearningCardPreviewPopupMyLearningCardQuerySuspenseQuery
  >;
export type LearningCardPreviewPopupMyLearningCardQueryQueryResult =
  Apollo.QueryResult<
    LearningCardPreviewPopupMyLearningCardQuery,
    LearningCardPreviewPopupMyLearningCardQueryVariables
  >;
export const LearningCardViewModeQueryDocument = gql`
  query LearningCardViewModeQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      id
      assignmentId
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useLearningCardViewModeQuery__
 *
 * To run a query within a React component, call `useLearningCardViewModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardViewModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardViewModeQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useLearningCardViewModeQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardViewModeQuery,
    LearningCardViewModeQueryVariables
  > &
    (
      | { variables: LearningCardViewModeQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardViewModeQuery,
    LearningCardViewModeQueryVariables
  >(LearningCardViewModeQueryDocument, options);
}
export function useLearningCardViewModeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardViewModeQuery,
    LearningCardViewModeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardViewModeQuery,
    LearningCardViewModeQueryVariables
  >(LearningCardViewModeQueryDocument, options);
}
export function useLearningCardViewModeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardViewModeQuery,
        LearningCardViewModeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardViewModeQuery,
    LearningCardViewModeQueryVariables
  >(LearningCardViewModeQueryDocument, options);
}
export type LearningCardViewModeQueryHookResult = ReturnType<
  typeof useLearningCardViewModeQuery
>;
export type LearningCardViewModeQueryLazyQueryHookResult = ReturnType<
  typeof useLearningCardViewModeQueryLazyQuery
>;
export type LearningCardViewModeQuerySuspenseQueryHookResult = ReturnType<
  typeof useLearningCardViewModeQuerySuspenseQuery
>;
export type LearningCardViewModeQueryQueryResult = Apollo.QueryResult<
  LearningCardViewModeQuery,
  LearningCardViewModeQueryVariables
>;
export const LearningCardViewModeAssignmentQueryDocument = gql`
  query LearningCardViewModeAssignmentQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      id
      assigneeIds
    }
  }
`;

/**
 * __useLearningCardViewModeAssignmentQuery__
 *
 * To run a query within a React component, call `useLearningCardViewModeAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardViewModeAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardViewModeAssignmentQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useLearningCardViewModeAssignmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardViewModeAssignmentQuery,
    LearningCardViewModeAssignmentQueryVariables
  > &
    (
      | {
          variables: LearningCardViewModeAssignmentQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardViewModeAssignmentQuery,
    LearningCardViewModeAssignmentQueryVariables
  >(LearningCardViewModeAssignmentQueryDocument, options);
}
export function useLearningCardViewModeAssignmentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardViewModeAssignmentQuery,
    LearningCardViewModeAssignmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardViewModeAssignmentQuery,
    LearningCardViewModeAssignmentQueryVariables
  >(LearningCardViewModeAssignmentQueryDocument, options);
}
export function useLearningCardViewModeAssignmentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardViewModeAssignmentQuery,
        LearningCardViewModeAssignmentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardViewModeAssignmentQuery,
    LearningCardViewModeAssignmentQueryVariables
  >(LearningCardViewModeAssignmentQueryDocument, options);
}
export type LearningCardViewModeAssignmentQueryHookResult = ReturnType<
  typeof useLearningCardViewModeAssignmentQuery
>;
export type LearningCardViewModeAssignmentQueryLazyQueryHookResult = ReturnType<
  typeof useLearningCardViewModeAssignmentQueryLazyQuery
>;
export type LearningCardViewModeAssignmentQuerySuspenseQueryHookResult =
  ReturnType<typeof useLearningCardViewModeAssignmentQuerySuspenseQuery>;
export type LearningCardViewModeAssignmentQueryQueryResult = Apollo.QueryResult<
  LearningCardViewModeAssignmentQuery,
  LearningCardViewModeAssignmentQueryVariables
>;
export const LearningCardViewModeAssignmentSubmissionQueryDocument = gql`
  query LearningCardViewModeAssignmentSubmissionQuery(
    $classroomId: String!
    $assignmentId: String!
    $assigneeId: String!
  ) {
    assignmentSubmission: getAssignmentSubmission(
      classroomId: $classroomId
      assignmentId: $assignmentId
      assigneeId: $assigneeId
    ) {
      id
      isSubmitted
      learningSubmission {
        id
      }
    }
  }
`;

/**
 * __useLearningCardViewModeAssignmentSubmissionQuery__
 *
 * To run a query within a React component, call `useLearningCardViewModeAssignmentSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardViewModeAssignmentSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardViewModeAssignmentSubmissionQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useLearningCardViewModeAssignmentSubmissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardViewModeAssignmentSubmissionQuery,
    LearningCardViewModeAssignmentSubmissionQueryVariables
  > &
    (
      | {
          variables: LearningCardViewModeAssignmentSubmissionQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardViewModeAssignmentSubmissionQuery,
    LearningCardViewModeAssignmentSubmissionQueryVariables
  >(LearningCardViewModeAssignmentSubmissionQueryDocument, options);
}
export function useLearningCardViewModeAssignmentSubmissionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardViewModeAssignmentSubmissionQuery,
    LearningCardViewModeAssignmentSubmissionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardViewModeAssignmentSubmissionQuery,
    LearningCardViewModeAssignmentSubmissionQueryVariables
  >(LearningCardViewModeAssignmentSubmissionQueryDocument, options);
}
export function useLearningCardViewModeAssignmentSubmissionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardViewModeAssignmentSubmissionQuery,
        LearningCardViewModeAssignmentSubmissionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardViewModeAssignmentSubmissionQuery,
    LearningCardViewModeAssignmentSubmissionQueryVariables
  >(LearningCardViewModeAssignmentSubmissionQueryDocument, options);
}
export type LearningCardViewModeAssignmentSubmissionQueryHookResult =
  ReturnType<typeof useLearningCardViewModeAssignmentSubmissionQuery>;
export type LearningCardViewModeAssignmentSubmissionQueryLazyQueryHookResult =
  ReturnType<typeof useLearningCardViewModeAssignmentSubmissionQueryLazyQuery>;
export type LearningCardViewModeAssignmentSubmissionQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useLearningCardViewModeAssignmentSubmissionQuerySuspenseQuery
  >;
export type LearningCardViewModeAssignmentSubmissionQueryQueryResult =
  Apollo.QueryResult<
    LearningCardViewModeAssignmentSubmissionQuery,
    LearningCardViewModeAssignmentSubmissionQueryVariables
  >;
export const SavePageResultMutationDocument = gql`
  mutation SavePageResultMutation(
    $classroomId: String!
    $assignmentId: String!
    $saveMemberAnswerToLearningAssignmentDtoInput: SaveMemberAnswerToLearningAssignmentDtoInput!
  ) {
    saveMemberAnswerToLearningAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
      saveMemberAnswerToLearningAssignmentDtoInput: $saveMemberAnswerToLearningAssignmentDtoInput
    ) {
      id
    }
  }
`;
export type SavePageResultMutationMutationFn = Apollo.MutationFunction<
  SavePageResultMutation,
  SavePageResultMutationVariables
>;

/**
 * __useSavePageResultMutation__
 *
 * To run a mutation, you first call `useSavePageResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePageResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePageResultMutation, { data, loading, error }] = useSavePageResultMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      saveMemberAnswerToLearningAssignmentDtoInput: // value for 'saveMemberAnswerToLearningAssignmentDtoInput'
 *   },
 * });
 */
export function useSavePageResultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SavePageResultMutation,
    SavePageResultMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SavePageResultMutation,
    SavePageResultMutationVariables
  >(SavePageResultMutationDocument, options);
}
export type SavePageResultMutationHookResult = ReturnType<
  typeof useSavePageResultMutation
>;
export type SavePageResultMutationMutationResult =
  Apollo.MutationResult<SavePageResultMutation>;
export type SavePageResultMutationMutationOptions = Apollo.BaseMutationOptions<
  SavePageResultMutation,
  SavePageResultMutationVariables
>;
export const LearningCardViewerIframeQueryDocument = gql`
  query LearningCardViewerIframeQuery(
    $classroomId: String!
    $assignmentId: String!
    $assigneeId: String!
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      id
      assigneeIds
      meta
      type
    }
    assignmentSubmission: getAssignmentSubmission(
      classroomId: $classroomId
      assignmentId: $assignmentId
      assigneeId: $assigneeId
    ) {
      id
      learningSubmission {
        id
        answers {
          ...LearningCardViewerIframeLearningUserAnswerDtoFields
        }
      }
      isSubmitted
    }
  }
  ${LearningCardViewerIframeLearningUserAnswerDtoFieldsFragmentDoc}
`;

/**
 * __useLearningCardViewerIframeQuery__
 *
 * To run a query within a React component, call `useLearningCardViewerIframeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardViewerIframeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardViewerIframeQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useLearningCardViewerIframeQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardViewerIframeQuery,
    LearningCardViewerIframeQueryVariables
  > &
    (
      | { variables: LearningCardViewerIframeQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardViewerIframeQuery,
    LearningCardViewerIframeQueryVariables
  >(LearningCardViewerIframeQueryDocument, options);
}
export function useLearningCardViewerIframeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardViewerIframeQuery,
    LearningCardViewerIframeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardViewerIframeQuery,
    LearningCardViewerIframeQueryVariables
  >(LearningCardViewerIframeQueryDocument, options);
}
export function useLearningCardViewerIframeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardViewerIframeQuery,
        LearningCardViewerIframeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardViewerIframeQuery,
    LearningCardViewerIframeQueryVariables
  >(LearningCardViewerIframeQueryDocument, options);
}
export type LearningCardViewerIframeQueryHookResult = ReturnType<
  typeof useLearningCardViewerIframeQuery
>;
export type LearningCardViewerIframeQueryLazyQueryHookResult = ReturnType<
  typeof useLearningCardViewerIframeQueryLazyQuery
>;
export type LearningCardViewerIframeQuerySuspenseQueryHookResult = ReturnType<
  typeof useLearningCardViewerIframeQuerySuspenseQuery
>;
export type LearningCardViewerIframeQueryQueryResult = Apollo.QueryResult<
  LearningCardViewerIframeQuery,
  LearningCardViewerIframeQueryVariables
>;
export const LearningSubmissionContentQueryDocument = gql`
  query LearningSubmissionContentQuery(
    $classroomId: String!
    $memberId: String!
  ) {
    member: getClassroomMember(classroomId: $classroomId, memberId: $memberId) {
      id
      name
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useLearningSubmissionContentQuery__
 *
 * To run a query within a React component, call `useLearningSubmissionContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningSubmissionContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningSubmissionContentQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useLearningSubmissionContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningSubmissionContentQuery,
    LearningSubmissionContentQueryVariables
  > &
    (
      | { variables: LearningSubmissionContentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningSubmissionContentQuery,
    LearningSubmissionContentQueryVariables
  >(LearningSubmissionContentQueryDocument, options);
}
export function useLearningSubmissionContentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningSubmissionContentQuery,
    LearningSubmissionContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningSubmissionContentQuery,
    LearningSubmissionContentQueryVariables
  >(LearningSubmissionContentQueryDocument, options);
}
export function useLearningSubmissionContentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningSubmissionContentQuery,
        LearningSubmissionContentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningSubmissionContentQuery,
    LearningSubmissionContentQueryVariables
  >(LearningSubmissionContentQueryDocument, options);
}
export type LearningSubmissionContentQueryHookResult = ReturnType<
  typeof useLearningSubmissionContentQuery
>;
export type LearningSubmissionContentQueryLazyQueryHookResult = ReturnType<
  typeof useLearningSubmissionContentQueryLazyQuery
>;
export type LearningSubmissionContentQuerySuspenseQueryHookResult = ReturnType<
  typeof useLearningSubmissionContentQuerySuspenseQuery
>;
export type LearningSubmissionContentQueryQueryResult = Apollo.QueryResult<
  LearningSubmissionContentQuery,
  LearningSubmissionContentQueryVariables
>;
export const EssayUserAnswerItemQueryDocument = gql`
  query EssayUserAnswerItemQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useEssayUserAnswerItemQuery__
 *
 * To run a query within a React component, call `useEssayUserAnswerItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useEssayUserAnswerItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEssayUserAnswerItemQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useEssayUserAnswerItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    EssayUserAnswerItemQuery,
    EssayUserAnswerItemQueryVariables
  > &
    (
      | { variables: EssayUserAnswerItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EssayUserAnswerItemQuery,
    EssayUserAnswerItemQueryVariables
  >(EssayUserAnswerItemQueryDocument, options);
}
export function useEssayUserAnswerItemQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EssayUserAnswerItemQuery,
    EssayUserAnswerItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EssayUserAnswerItemQuery,
    EssayUserAnswerItemQueryVariables
  >(EssayUserAnswerItemQueryDocument, options);
}
export function useEssayUserAnswerItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EssayUserAnswerItemQuery,
        EssayUserAnswerItemQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EssayUserAnswerItemQuery,
    EssayUserAnswerItemQueryVariables
  >(EssayUserAnswerItemQueryDocument, options);
}
export type EssayUserAnswerItemQueryHookResult = ReturnType<
  typeof useEssayUserAnswerItemQuery
>;
export type EssayUserAnswerItemQueryLazyQueryHookResult = ReturnType<
  typeof useEssayUserAnswerItemQueryLazyQuery
>;
export type EssayUserAnswerItemQuerySuspenseQueryHookResult = ReturnType<
  typeof useEssayUserAnswerItemQuerySuspenseQuery
>;
export type EssayUserAnswerItemQueryQueryResult = Apollo.QueryResult<
  EssayUserAnswerItemQuery,
  EssayUserAnswerItemQueryVariables
>;
export const SaveEssayAnswerPointsMutationDocument = gql`
  mutation SaveEssayAnswerPointsMutation(
    $classroomId: String!
    $assigneeId: String!
    $assignmentId: String!
    $saveEssayAnswerPoints: SaveEssayAnswerPointsToLearningAssignmentDtoInput!
  ) {
    saveEssayAnswerPointsToLearningAssignment(
      classroomId: $classroomId
      assigneeId: $assigneeId
      assignmentId: $assignmentId
      saveEssayAnswerPointsToLearningAssignmentDtoInput: $saveEssayAnswerPoints
    ) {
      id
      learningSubmission {
        answers {
          ...LearningSubmissionUserAnswerItemLearningUserAnswerDtoFields
        }
      }
    }
  }
  ${LearningSubmissionUserAnswerItemLearningUserAnswerDtoFieldsFragmentDoc}
`;
export type SaveEssayAnswerPointsMutationMutationFn = Apollo.MutationFunction<
  SaveEssayAnswerPointsMutation,
  SaveEssayAnswerPointsMutationVariables
>;

/**
 * __useSaveEssayAnswerPointsMutation__
 *
 * To run a mutation, you first call `useSaveEssayAnswerPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEssayAnswerPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEssayAnswerPointsMutation, { data, loading, error }] = useSaveEssayAnswerPointsMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assigneeId: // value for 'assigneeId'
 *      assignmentId: // value for 'assignmentId'
 *      saveEssayAnswerPoints: // value for 'saveEssayAnswerPoints'
 *   },
 * });
 */
export function useSaveEssayAnswerPointsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveEssayAnswerPointsMutation,
    SaveEssayAnswerPointsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveEssayAnswerPointsMutation,
    SaveEssayAnswerPointsMutationVariables
  >(SaveEssayAnswerPointsMutationDocument, options);
}
export type SaveEssayAnswerPointsMutationHookResult = ReturnType<
  typeof useSaveEssayAnswerPointsMutation
>;
export type SaveEssayAnswerPointsMutationMutationResult =
  Apollo.MutationResult<SaveEssayAnswerPointsMutation>;
export type SaveEssayAnswerPointsMutationMutationOptions =
  Apollo.BaseMutationOptions<
    SaveEssayAnswerPointsMutation,
    SaveEssayAnswerPointsMutationVariables
  >;
export const MyLearningCardListQueryDocument = gql`
  query MyLearningCardListQuery(
    $coreConceptId: String
    $gradeId: String
    $mediaType: String
    $offset: Float
    $limit: Float
    $orderBy: String = "updated_at"
    $publisherId: Float
    $schoolId: String
    $searchKeywords: String
    $shareLevel: Float
    $subjectId: Float
    $unitId: Float
    $authorId: String
  ) {
    learningCardCollection: listLearningCards(
      coreConceptId: $coreConceptId
      gradeId: $gradeId
      mediaType: $mediaType
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      publisherId: $publisherId
      schoolId: $schoolId
      searchKeywords: $searchKeywords
      shareLevel: $shareLevel
      subjectId: $subjectId
      unitId: $unitId
      authorId: $authorId
    ) {
      learningCards {
        ...LearningCardItemLearningCardFields
      }
      offset
      limit
    }
  }
  ${LearningCardItemLearningCardFieldsFragmentDoc}
`;

/**
 * __useMyLearningCardListQuery__
 *
 * To run a query within a React component, call `useMyLearningCardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLearningCardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLearningCardListQuery({
 *   variables: {
 *      coreConceptId: // value for 'coreConceptId'
 *      gradeId: // value for 'gradeId'
 *      mediaType: // value for 'mediaType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      publisherId: // value for 'publisherId'
 *      schoolId: // value for 'schoolId'
 *      searchKeywords: // value for 'searchKeywords'
 *      shareLevel: // value for 'shareLevel'
 *      subjectId: // value for 'subjectId'
 *      unitId: // value for 'unitId'
 *      authorId: // value for 'authorId'
 *   },
 * });
 */
export function useMyLearningCardListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyLearningCardListQuery,
    MyLearningCardListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MyLearningCardListQuery,
    MyLearningCardListQueryVariables
  >(MyLearningCardListQueryDocument, options);
}
export function useMyLearningCardListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyLearningCardListQuery,
    MyLearningCardListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MyLearningCardListQuery,
    MyLearningCardListQueryVariables
  >(MyLearningCardListQueryDocument, options);
}
export function useMyLearningCardListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyLearningCardListQuery,
        MyLearningCardListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MyLearningCardListQuery,
    MyLearningCardListQueryVariables
  >(MyLearningCardListQueryDocument, options);
}
export type MyLearningCardListQueryHookResult = ReturnType<
  typeof useMyLearningCardListQuery
>;
export type MyLearningCardListQueryLazyQueryHookResult = ReturnType<
  typeof useMyLearningCardListQueryLazyQuery
>;
export type MyLearningCardListQuerySuspenseQueryHookResult = ReturnType<
  typeof useMyLearningCardListQuerySuspenseQuery
>;
export type MyLearningCardListQueryQueryResult = Apollo.QueryResult<
  MyLearningCardListQuery,
  MyLearningCardListQueryVariables
>;
export const MyLearningCardListCurrentMemberQueryDocument = gql`
  query MyLearningCardListCurrentMemberQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useMyLearningCardListCurrentMemberQuery__
 *
 * To run a query within a React component, call `useMyLearningCardListCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLearningCardListCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLearningCardListCurrentMemberQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useMyLearningCardListCurrentMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyLearningCardListCurrentMemberQuery,
    MyLearningCardListCurrentMemberQueryVariables
  > &
    (
      | {
          variables: MyLearningCardListCurrentMemberQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MyLearningCardListCurrentMemberQuery,
    MyLearningCardListCurrentMemberQueryVariables
  >(MyLearningCardListCurrentMemberQueryDocument, options);
}
export function useMyLearningCardListCurrentMemberQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyLearningCardListCurrentMemberQuery,
    MyLearningCardListCurrentMemberQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MyLearningCardListCurrentMemberQuery,
    MyLearningCardListCurrentMemberQueryVariables
  >(MyLearningCardListCurrentMemberQueryDocument, options);
}
export function useMyLearningCardListCurrentMemberQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyLearningCardListCurrentMemberQuery,
        MyLearningCardListCurrentMemberQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MyLearningCardListCurrentMemberQuery,
    MyLearningCardListCurrentMemberQueryVariables
  >(MyLearningCardListCurrentMemberQueryDocument, options);
}
export type MyLearningCardListCurrentMemberQueryHookResult = ReturnType<
  typeof useMyLearningCardListCurrentMemberQuery
>;
export type MyLearningCardListCurrentMemberQueryLazyQueryHookResult =
  ReturnType<typeof useMyLearningCardListCurrentMemberQueryLazyQuery>;
export type MyLearningCardListCurrentMemberQuerySuspenseQueryHookResult =
  ReturnType<typeof useMyLearningCardListCurrentMemberQuerySuspenseQuery>;
export type MyLearningCardListCurrentMemberQueryQueryResult =
  Apollo.QueryResult<
    MyLearningCardListCurrentMemberQuery,
    MyLearningCardListCurrentMemberQueryVariables
  >;
export const PostFeedAssignmentItemPostQueryDocument = gql`
  query PostFeedAssignmentItemPostQuery(
    $classroomId: String!
    $postId: String!
  ) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...PostFeedItemPostFields
    }
  }
  ${PostFeedItemPostFieldsFragmentDoc}
`;

/**
 * __usePostFeedAssignmentItemPostQuery__
 *
 * To run a query within a React component, call `usePostFeedAssignmentItemPostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedAssignmentItemPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedAssignmentItemPostQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostFeedAssignmentItemPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedAssignmentItemPostQuery,
    PostFeedAssignmentItemPostQueryVariables
  > &
    (
      | { variables: PostFeedAssignmentItemPostQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedAssignmentItemPostQuery,
    PostFeedAssignmentItemPostQueryVariables
  >(PostFeedAssignmentItemPostQueryDocument, options);
}
export function usePostFeedAssignmentItemPostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedAssignmentItemPostQuery,
    PostFeedAssignmentItemPostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedAssignmentItemPostQuery,
    PostFeedAssignmentItemPostQueryVariables
  >(PostFeedAssignmentItemPostQueryDocument, options);
}
export function usePostFeedAssignmentItemPostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedAssignmentItemPostQuery,
        PostFeedAssignmentItemPostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedAssignmentItemPostQuery,
    PostFeedAssignmentItemPostQueryVariables
  >(PostFeedAssignmentItemPostQueryDocument, options);
}
export type PostFeedAssignmentItemPostQueryHookResult = ReturnType<
  typeof usePostFeedAssignmentItemPostQuery
>;
export type PostFeedAssignmentItemPostQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedAssignmentItemPostQueryLazyQuery
>;
export type PostFeedAssignmentItemPostQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedAssignmentItemPostQuerySuspenseQuery
>;
export type PostFeedAssignmentItemPostQueryQueryResult = Apollo.QueryResult<
  PostFeedAssignmentItemPostQuery,
  PostFeedAssignmentItemPostQueryVariables
>;
export const PostFeedAssignmentItemAssignmentQueryDocument = gql`
  query PostFeedAssignmentItemAssignmentQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...PostItemBodyAssignmentDtoFields
    }
  }
  ${PostItemBodyAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __usePostFeedAssignmentItemAssignmentQuery__
 *
 * To run a query within a React component, call `usePostFeedAssignmentItemAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedAssignmentItemAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedAssignmentItemAssignmentQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function usePostFeedAssignmentItemAssignmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedAssignmentItemAssignmentQuery,
    PostFeedAssignmentItemAssignmentQueryVariables
  > &
    (
      | {
          variables: PostFeedAssignmentItemAssignmentQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedAssignmentItemAssignmentQuery,
    PostFeedAssignmentItemAssignmentQueryVariables
  >(PostFeedAssignmentItemAssignmentQueryDocument, options);
}
export function usePostFeedAssignmentItemAssignmentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedAssignmentItemAssignmentQuery,
    PostFeedAssignmentItemAssignmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedAssignmentItemAssignmentQuery,
    PostFeedAssignmentItemAssignmentQueryVariables
  >(PostFeedAssignmentItemAssignmentQueryDocument, options);
}
export function usePostFeedAssignmentItemAssignmentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedAssignmentItemAssignmentQuery,
        PostFeedAssignmentItemAssignmentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedAssignmentItemAssignmentQuery,
    PostFeedAssignmentItemAssignmentQueryVariables
  >(PostFeedAssignmentItemAssignmentQueryDocument, options);
}
export type PostFeedAssignmentItemAssignmentQueryHookResult = ReturnType<
  typeof usePostFeedAssignmentItemAssignmentQuery
>;
export type PostFeedAssignmentItemAssignmentQueryLazyQueryHookResult =
  ReturnType<typeof usePostFeedAssignmentItemAssignmentQueryLazyQuery>;
export type PostFeedAssignmentItemAssignmentQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostFeedAssignmentItemAssignmentQuerySuspenseQuery>;
export type PostFeedAssignmentItemAssignmentQueryQueryResult =
  Apollo.QueryResult<
    PostFeedAssignmentItemAssignmentQuery,
    PostFeedAssignmentItemAssignmentQueryVariables
  >;
export const PostFeedAssignmentListAccountQueryDocument = gql`
  query PostFeedAssignmentListAccountQuery {
    me: getMe {
      id
      role
      isAdFreeSubscribed
      grade
      language
      countryCode
      schoolInfoDto {
        grade
        school {
          zipcode
        }
      }
      schoolInfoDtoForChildren {
        grade
        school {
          zipcode
        }
      }
    }
  }
`;

/**
 * __usePostFeedAssignmentListAccountQuery__
 *
 * To run a query within a React component, call `usePostFeedAssignmentListAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedAssignmentListAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedAssignmentListAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostFeedAssignmentListAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PostFeedAssignmentListAccountQuery,
    PostFeedAssignmentListAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedAssignmentListAccountQuery,
    PostFeedAssignmentListAccountQueryVariables
  >(PostFeedAssignmentListAccountQueryDocument, options);
}
export function usePostFeedAssignmentListAccountQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedAssignmentListAccountQuery,
    PostFeedAssignmentListAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedAssignmentListAccountQuery,
    PostFeedAssignmentListAccountQueryVariables
  >(PostFeedAssignmentListAccountQueryDocument, options);
}
export function usePostFeedAssignmentListAccountQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedAssignmentListAccountQuery,
        PostFeedAssignmentListAccountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedAssignmentListAccountQuery,
    PostFeedAssignmentListAccountQueryVariables
  >(PostFeedAssignmentListAccountQueryDocument, options);
}
export type PostFeedAssignmentListAccountQueryHookResult = ReturnType<
  typeof usePostFeedAssignmentListAccountQuery
>;
export type PostFeedAssignmentListAccountQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedAssignmentListAccountQueryLazyQuery
>;
export type PostFeedAssignmentListAccountQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostFeedAssignmentListAccountQuerySuspenseQuery>;
export type PostFeedAssignmentListAccountQueryQueryResult = Apollo.QueryResult<
  PostFeedAssignmentListAccountQuery,
  PostFeedAssignmentListAccountQueryVariables
>;
export const SchoolLearningCardListQueryDocument = gql`
  query SchoolLearningCardListQuery(
    $coreConceptId: String
    $gradeId: String
    $mediaType: String
    $offset: Float
    $limit: Float
    $orderBy: String = "updated_at"
    $publisherId: Float
    $schoolId: String!
    $searchKeywords: String
    $shareLevel: ID
    $subjectId: Float
    $unitId: Float
  ) {
    learningCardCollection: listLearningSchoolCards(
      coreConceptId: $coreConceptId
      gradeId: $gradeId
      mediaType: $mediaType
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      publisherId: $publisherId
      schoolId: $schoolId
      searchKeywords: $searchKeywords
      shareLevel: $shareLevel
      subjectId: $subjectId
      unitId: $unitId
    ) {
      learningCards {
        ...LearningCardItemLearningCardFields
      }
      offset
      limit
    }
  }
  ${LearningCardItemLearningCardFieldsFragmentDoc}
`;

/**
 * __useSchoolLearningCardListQuery__
 *
 * To run a query within a React component, call `useSchoolLearningCardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolLearningCardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolLearningCardListQuery({
 *   variables: {
 *      coreConceptId: // value for 'coreConceptId'
 *      gradeId: // value for 'gradeId'
 *      mediaType: // value for 'mediaType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      publisherId: // value for 'publisherId'
 *      schoolId: // value for 'schoolId'
 *      searchKeywords: // value for 'searchKeywords'
 *      shareLevel: // value for 'shareLevel'
 *      subjectId: // value for 'subjectId'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useSchoolLearningCardListQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchoolLearningCardListQuery,
    SchoolLearningCardListQueryVariables
  > &
    (
      | { variables: SchoolLearningCardListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchoolLearningCardListQuery,
    SchoolLearningCardListQueryVariables
  >(SchoolLearningCardListQueryDocument, options);
}
export function useSchoolLearningCardListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolLearningCardListQuery,
    SchoolLearningCardListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchoolLearningCardListQuery,
    SchoolLearningCardListQueryVariables
  >(SchoolLearningCardListQueryDocument, options);
}
export function useSchoolLearningCardListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolLearningCardListQuery,
        SchoolLearningCardListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchoolLearningCardListQuery,
    SchoolLearningCardListQueryVariables
  >(SchoolLearningCardListQueryDocument, options);
}
export type SchoolLearningCardListQueryHookResult = ReturnType<
  typeof useSchoolLearningCardListQuery
>;
export type SchoolLearningCardListQueryLazyQueryHookResult = ReturnType<
  typeof useSchoolLearningCardListQueryLazyQuery
>;
export type SchoolLearningCardListQuerySuspenseQueryHookResult = ReturnType<
  typeof useSchoolLearningCardListQuerySuspenseQuery
>;
export type SchoolLearningCardListQueryQueryResult = Apollo.QueryResult<
  SchoolLearningCardListQuery,
  SchoolLearningCardListQueryVariables
>;
export const SchoolLearningCardListMeQueryDocument = gql`
  query SchoolLearningCardListMeQuery {
    me: getMe {
      id
      schoolInfo {
        school {
          id
        }
      }
    }
  }
`;

/**
 * __useSchoolLearningCardListMeQuery__
 *
 * To run a query within a React component, call `useSchoolLearningCardListMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolLearningCardListMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolLearningCardListMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchoolLearningCardListMeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolLearningCardListMeQuery,
    SchoolLearningCardListMeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchoolLearningCardListMeQuery,
    SchoolLearningCardListMeQueryVariables
  >(SchoolLearningCardListMeQueryDocument, options);
}
export function useSchoolLearningCardListMeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolLearningCardListMeQuery,
    SchoolLearningCardListMeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchoolLearningCardListMeQuery,
    SchoolLearningCardListMeQueryVariables
  >(SchoolLearningCardListMeQueryDocument, options);
}
export function useSchoolLearningCardListMeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolLearningCardListMeQuery,
        SchoolLearningCardListMeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchoolLearningCardListMeQuery,
    SchoolLearningCardListMeQueryVariables
  >(SchoolLearningCardListMeQueryDocument, options);
}
export type SchoolLearningCardListMeQueryHookResult = ReturnType<
  typeof useSchoolLearningCardListMeQuery
>;
export type SchoolLearningCardListMeQueryLazyQueryHookResult = ReturnType<
  typeof useSchoolLearningCardListMeQueryLazyQuery
>;
export type SchoolLearningCardListMeQuerySuspenseQueryHookResult = ReturnType<
  typeof useSchoolLearningCardListMeQuerySuspenseQuery
>;
export type SchoolLearningCardListMeQueryQueryResult = Apollo.QueryResult<
  SchoolLearningCardListMeQuery,
  SchoolLearningCardListMeQueryVariables
>;
export const SubmissionContentQueryDocument = gql`
  query SubmissionContentQuery($classroomId: String!, $memberId: String!) {
    member: getClassroomMember(classroomId: $classroomId, memberId: $memberId) {
      id
      name
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useSubmissionContentQuery__
 *
 * To run a query within a React component, call `useSubmissionContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionContentQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useSubmissionContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubmissionContentQuery,
    SubmissionContentQueryVariables
  > &
    (
      | { variables: SubmissionContentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SubmissionContentQuery,
    SubmissionContentQueryVariables
  >(SubmissionContentQueryDocument, options);
}
export function useSubmissionContentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubmissionContentQuery,
    SubmissionContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SubmissionContentQuery,
    SubmissionContentQueryVariables
  >(SubmissionContentQueryDocument, options);
}
export function useSubmissionContentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubmissionContentQuery,
        SubmissionContentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SubmissionContentQuery,
    SubmissionContentQueryVariables
  >(SubmissionContentQueryDocument, options);
}
export type SubmissionContentQueryHookResult = ReturnType<
  typeof useSubmissionContentQuery
>;
export type SubmissionContentQueryLazyQueryHookResult = ReturnType<
  typeof useSubmissionContentQueryLazyQuery
>;
export type SubmissionContentQuerySuspenseQueryHookResult = ReturnType<
  typeof useSubmissionContentQuerySuspenseQuery
>;
export type SubmissionContentQueryQueryResult = Apollo.QueryResult<
  SubmissionContentQuery,
  SubmissionContentQueryVariables
>;
export const SubmissionMediaFileQueryDocument = gql`
  query SubmissionMediaFileQuery($fileId: String!) {
    file: getFile(fileId: $fileId) {
      id
      originalFileName
      totalSize
      urls
    }
  }
`;

/**
 * __useSubmissionMediaFileQuery__
 *
 * To run a query within a React component, call `useSubmissionMediaFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionMediaFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionMediaFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useSubmissionMediaFileQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubmissionMediaFileQuery,
    SubmissionMediaFileQueryVariables
  > &
    (
      | { variables: SubmissionMediaFileQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SubmissionMediaFileQuery,
    SubmissionMediaFileQueryVariables
  >(SubmissionMediaFileQueryDocument, options);
}
export function useSubmissionMediaFileQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubmissionMediaFileQuery,
    SubmissionMediaFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SubmissionMediaFileQuery,
    SubmissionMediaFileQueryVariables
  >(SubmissionMediaFileQueryDocument, options);
}
export function useSubmissionMediaFileQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubmissionMediaFileQuery,
        SubmissionMediaFileQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SubmissionMediaFileQuery,
    SubmissionMediaFileQueryVariables
  >(SubmissionMediaFileQueryDocument, options);
}
export type SubmissionMediaFileQueryHookResult = ReturnType<
  typeof useSubmissionMediaFileQuery
>;
export type SubmissionMediaFileQueryLazyQueryHookResult = ReturnType<
  typeof useSubmissionMediaFileQueryLazyQuery
>;
export type SubmissionMediaFileQuerySuspenseQueryHookResult = ReturnType<
  typeof useSubmissionMediaFileQuerySuspenseQuery
>;
export type SubmissionMediaFileQueryQueryResult = Apollo.QueryResult<
  SubmissionMediaFileQuery,
  SubmissionMediaFileQueryVariables
>;
export const SubmissionMediaImageQueryDocument = gql`
  query SubmissionMediaImageQuery($imageId: String!) {
    image: getImage(imageId: $imageId) {
      id
      urls
    }
  }
`;

/**
 * __useSubmissionMediaImageQuery__
 *
 * To run a query within a React component, call `useSubmissionMediaImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionMediaImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionMediaImageQuery({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useSubmissionMediaImageQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubmissionMediaImageQuery,
    SubmissionMediaImageQueryVariables
  > &
    (
      | { variables: SubmissionMediaImageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SubmissionMediaImageQuery,
    SubmissionMediaImageQueryVariables
  >(SubmissionMediaImageQueryDocument, options);
}
export function useSubmissionMediaImageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubmissionMediaImageQuery,
    SubmissionMediaImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SubmissionMediaImageQuery,
    SubmissionMediaImageQueryVariables
  >(SubmissionMediaImageQueryDocument, options);
}
export function useSubmissionMediaImageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubmissionMediaImageQuery,
        SubmissionMediaImageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SubmissionMediaImageQuery,
    SubmissionMediaImageQueryVariables
  >(SubmissionMediaImageQueryDocument, options);
}
export type SubmissionMediaImageQueryHookResult = ReturnType<
  typeof useSubmissionMediaImageQuery
>;
export type SubmissionMediaImageQueryLazyQueryHookResult = ReturnType<
  typeof useSubmissionMediaImageQueryLazyQuery
>;
export type SubmissionMediaImageQuerySuspenseQueryHookResult = ReturnType<
  typeof useSubmissionMediaImageQuerySuspenseQuery
>;
export type SubmissionMediaImageQueryQueryResult = Apollo.QueryResult<
  SubmissionMediaImageQuery,
  SubmissionMediaImageQueryVariables
>;
export const CreateAssignmentSubmissionCommentMutationDocument = gql`
  mutation CreateAssignmentSubmissionCommentMutation(
    $assignmentSubmissionId: String!
    $createAssignmentSubmissionCommentDtoInput: CreateAssignmentSubmissionCommentDtoInput!
  ) {
    comment: createAssignmentSubmissionComment(
      assignmentSubmissionId: $assignmentSubmissionId
      createAssignmentSubmissionCommentDtoInput: $createAssignmentSubmissionCommentDtoInput
    ) {
      ...AssignmentSubmissionCommentItemAssignmentSubmissionCommentFields
    }
  }
  ${AssignmentSubmissionCommentItemAssignmentSubmissionCommentFieldsFragmentDoc}
`;
export type CreateAssignmentSubmissionCommentMutationMutationFn =
  Apollo.MutationFunction<
    CreateAssignmentSubmissionCommentMutation,
    CreateAssignmentSubmissionCommentMutationVariables
  >;

/**
 * __useCreateAssignmentSubmissionCommentMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentSubmissionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentSubmissionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentSubmissionCommentMutation, { data, loading, error }] = useCreateAssignmentSubmissionCommentMutation({
 *   variables: {
 *      assignmentSubmissionId: // value for 'assignmentSubmissionId'
 *      createAssignmentSubmissionCommentDtoInput: // value for 'createAssignmentSubmissionCommentDtoInput'
 *   },
 * });
 */
export function useCreateAssignmentSubmissionCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAssignmentSubmissionCommentMutation,
    CreateAssignmentSubmissionCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAssignmentSubmissionCommentMutation,
    CreateAssignmentSubmissionCommentMutationVariables
  >(CreateAssignmentSubmissionCommentMutationDocument, options);
}
export type CreateAssignmentSubmissionCommentMutationHookResult = ReturnType<
  typeof useCreateAssignmentSubmissionCommentMutation
>;
export type CreateAssignmentSubmissionCommentMutationMutationResult =
  Apollo.MutationResult<CreateAssignmentSubmissionCommentMutation>;
export type CreateAssignmentSubmissionCommentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAssignmentSubmissionCommentMutation,
    CreateAssignmentSubmissionCommentMutationVariables
  >;
export const AssignmentListPageQueryDocument = gql`
  query AssignmentListPageQuery($classroomId: String!) {
    me: getMe {
      id
      countryCode
      isAdFreeSubscribed
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
`;

/**
 * __useAssignmentListPageQuery__
 *
 * To run a query within a React component, call `useAssignmentListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentListPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAssignmentListPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentListPageQuery,
    AssignmentListPageQueryVariables
  > &
    (
      | { variables: AssignmentListPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentListPageQuery,
    AssignmentListPageQueryVariables
  >(AssignmentListPageQueryDocument, options);
}
export function useAssignmentListPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentListPageQuery,
    AssignmentListPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentListPageQuery,
    AssignmentListPageQueryVariables
  >(AssignmentListPageQueryDocument, options);
}
export function useAssignmentListPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentListPageQuery,
        AssignmentListPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentListPageQuery,
    AssignmentListPageQueryVariables
  >(AssignmentListPageQueryDocument, options);
}
export type AssignmentListPageQueryHookResult = ReturnType<
  typeof useAssignmentListPageQuery
>;
export type AssignmentListPageQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentListPageQueryLazyQuery
>;
export type AssignmentListPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentListPageQuerySuspenseQuery
>;
export type AssignmentListPageQueryQueryResult = Apollo.QueryResult<
  AssignmentListPageQuery,
  AssignmentListPageQueryVariables
>;
export const AssignmentReportPageQueryDocument = gql`
  query AssignmentReportPageQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
    classroomMembers: listClassroomMembers(
      classroomId: $classroomId
      limit: 1000
      groups: "student"
      roles: "admin"
    ) {
      members {
        ...AssignmentReportMemberFields
      }
    }
  }
  ${AssignmentReportMemberFieldsFragmentDoc}
`;

/**
 * __useAssignmentReportPageQuery__
 *
 * To run a query within a React component, call `useAssignmentReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentReportPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAssignmentReportPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentReportPageQuery,
    AssignmentReportPageQueryVariables
  > &
    (
      | { variables: AssignmentReportPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentReportPageQuery,
    AssignmentReportPageQueryVariables
  >(AssignmentReportPageQueryDocument, options);
}
export function useAssignmentReportPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentReportPageQuery,
    AssignmentReportPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentReportPageQuery,
    AssignmentReportPageQueryVariables
  >(AssignmentReportPageQueryDocument, options);
}
export function useAssignmentReportPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentReportPageQuery,
        AssignmentReportPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentReportPageQuery,
    AssignmentReportPageQueryVariables
  >(AssignmentReportPageQueryDocument, options);
}
export type AssignmentReportPageQueryHookResult = ReturnType<
  typeof useAssignmentReportPageQuery
>;
export type AssignmentReportPageQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentReportPageQueryLazyQuery
>;
export type AssignmentReportPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentReportPageQuerySuspenseQuery
>;
export type AssignmentReportPageQueryQueryResult = Apollo.QueryResult<
  AssignmentReportPageQuery,
  AssignmentReportPageQueryVariables
>;
export const AssignmentReportAssignmentListQueryDocument = gql`
  query AssignmentReportAssignmentListQuery(
    $classroomId: String!
    $page: Float
    $perPage: Float
  ) {
    classroomAssignments: listClassroomAssignments(
      classroomId: $classroomId
      page: $page
      perPage: $perPage
    ) {
      assignments {
        id
      }
    }
  }
`;

/**
 * __useAssignmentReportAssignmentListQuery__
 *
 * To run a query within a React component, call `useAssignmentReportAssignmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentReportAssignmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentReportAssignmentListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAssignmentReportAssignmentListQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentReportAssignmentListQuery,
    AssignmentReportAssignmentListQueryVariables
  > &
    (
      | {
          variables: AssignmentReportAssignmentListQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentReportAssignmentListQuery,
    AssignmentReportAssignmentListQueryVariables
  >(AssignmentReportAssignmentListQueryDocument, options);
}
export function useAssignmentReportAssignmentListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentReportAssignmentListQuery,
    AssignmentReportAssignmentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentReportAssignmentListQuery,
    AssignmentReportAssignmentListQueryVariables
  >(AssignmentReportAssignmentListQueryDocument, options);
}
export function useAssignmentReportAssignmentListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentReportAssignmentListQuery,
        AssignmentReportAssignmentListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentReportAssignmentListQuery,
    AssignmentReportAssignmentListQueryVariables
  >(AssignmentReportAssignmentListQueryDocument, options);
}
export type AssignmentReportAssignmentListQueryHookResult = ReturnType<
  typeof useAssignmentReportAssignmentListQuery
>;
export type AssignmentReportAssignmentListQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentReportAssignmentListQueryLazyQuery
>;
export type AssignmentReportAssignmentListQuerySuspenseQueryHookResult =
  ReturnType<typeof useAssignmentReportAssignmentListQuerySuspenseQuery>;
export type AssignmentReportAssignmentListQueryQueryResult = Apollo.QueryResult<
  AssignmentReportAssignmentListQuery,
  AssignmentReportAssignmentListQueryVariables
>;
export const AssignmentReportAssigneeAssignmentSubmissionQueryDocument = gql`
  query AssignmentReportAssigneeAssignmentSubmissionQuery(
    $classroomId: String!
    $assignmentId: String!
    $assigneeId: String!
  ) {
    assignmentSubmission: getAssignmentSubmission(
      classroomId: $classroomId
      assignmentId: $assignmentId
      assigneeId: $assigneeId
    ) {
      ...AssignmentReportAssignmentSubmissionDtoFields
    }
  }
  ${AssignmentReportAssignmentSubmissionDtoFieldsFragmentDoc}
`;

/**
 * __useAssignmentReportAssigneeAssignmentSubmissionQuery__
 *
 * To run a query within a React component, call `useAssignmentReportAssigneeAssignmentSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentReportAssigneeAssignmentSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentReportAssigneeAssignmentSubmissionQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useAssignmentReportAssigneeAssignmentSubmissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentReportAssigneeAssignmentSubmissionQuery,
    AssignmentReportAssigneeAssignmentSubmissionQueryVariables
  > &
    (
      | {
          variables: AssignmentReportAssigneeAssignmentSubmissionQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentReportAssigneeAssignmentSubmissionQuery,
    AssignmentReportAssigneeAssignmentSubmissionQueryVariables
  >(AssignmentReportAssigneeAssignmentSubmissionQueryDocument, options);
}
export function useAssignmentReportAssigneeAssignmentSubmissionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentReportAssigneeAssignmentSubmissionQuery,
    AssignmentReportAssigneeAssignmentSubmissionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentReportAssigneeAssignmentSubmissionQuery,
    AssignmentReportAssigneeAssignmentSubmissionQueryVariables
  >(AssignmentReportAssigneeAssignmentSubmissionQueryDocument, options);
}
export function useAssignmentReportAssigneeAssignmentSubmissionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentReportAssigneeAssignmentSubmissionQuery,
        AssignmentReportAssigneeAssignmentSubmissionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentReportAssigneeAssignmentSubmissionQuery,
    AssignmentReportAssigneeAssignmentSubmissionQueryVariables
  >(AssignmentReportAssigneeAssignmentSubmissionQueryDocument, options);
}
export type AssignmentReportAssigneeAssignmentSubmissionQueryHookResult =
  ReturnType<typeof useAssignmentReportAssigneeAssignmentSubmissionQuery>;
export type AssignmentReportAssigneeAssignmentSubmissionQueryLazyQueryHookResult =
  ReturnType<
    typeof useAssignmentReportAssigneeAssignmentSubmissionQueryLazyQuery
  >;
export type AssignmentReportAssigneeAssignmentSubmissionQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useAssignmentReportAssigneeAssignmentSubmissionQuerySuspenseQuery
  >;
export type AssignmentReportAssigneeAssignmentSubmissionQueryQueryResult =
  Apollo.QueryResult<
    AssignmentReportAssigneeAssignmentSubmissionQuery,
    AssignmentReportAssigneeAssignmentSubmissionQueryVariables
  >;
export const AssignmentReportPostQueryDocument = gql`
  query AssignmentReportPostQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...AssignmentReportPostFields
    }
  }
  ${AssignmentReportPostFieldsFragmentDoc}
`;

/**
 * __useAssignmentReportPostQuery__
 *
 * To run a query within a React component, call `useAssignmentReportPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentReportPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentReportPostQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useAssignmentReportPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentReportPostQuery,
    AssignmentReportPostQueryVariables
  > &
    (
      | { variables: AssignmentReportPostQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentReportPostQuery,
    AssignmentReportPostQueryVariables
  >(AssignmentReportPostQueryDocument, options);
}
export function useAssignmentReportPostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentReportPostQuery,
    AssignmentReportPostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentReportPostQuery,
    AssignmentReportPostQueryVariables
  >(AssignmentReportPostQueryDocument, options);
}
export function useAssignmentReportPostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentReportPostQuery,
        AssignmentReportPostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentReportPostQuery,
    AssignmentReportPostQueryVariables
  >(AssignmentReportPostQueryDocument, options);
}
export type AssignmentReportPostQueryHookResult = ReturnType<
  typeof useAssignmentReportPostQuery
>;
export type AssignmentReportPostQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentReportPostQueryLazyQuery
>;
export type AssignmentReportPostQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentReportPostQuerySuspenseQuery
>;
export type AssignmentReportPostQueryQueryResult = Apollo.QueryResult<
  AssignmentReportPostQuery,
  AssignmentReportPostQueryVariables
>;
export const AssignmentReportAssignmentQueryDocument = gql`
  query AssignmentReportAssignmentQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...AssignmentReportAssignmentDtoFields
    }
  }
  ${AssignmentReportAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __useAssignmentReportAssignmentQuery__
 *
 * To run a query within a React component, call `useAssignmentReportAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentReportAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentReportAssignmentQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useAssignmentReportAssignmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentReportAssignmentQuery,
    AssignmentReportAssignmentQueryVariables
  > &
    (
      | { variables: AssignmentReportAssignmentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentReportAssignmentQuery,
    AssignmentReportAssignmentQueryVariables
  >(AssignmentReportAssignmentQueryDocument, options);
}
export function useAssignmentReportAssignmentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentReportAssignmentQuery,
    AssignmentReportAssignmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentReportAssignmentQuery,
    AssignmentReportAssignmentQueryVariables
  >(AssignmentReportAssignmentQueryDocument, options);
}
export function useAssignmentReportAssignmentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentReportAssignmentQuery,
        AssignmentReportAssignmentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentReportAssignmentQuery,
    AssignmentReportAssignmentQueryVariables
  >(AssignmentReportAssignmentQueryDocument, options);
}
export type AssignmentReportAssignmentQueryHookResult = ReturnType<
  typeof useAssignmentReportAssignmentQuery
>;
export type AssignmentReportAssignmentQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentReportAssignmentQueryLazyQuery
>;
export type AssignmentReportAssignmentQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentReportAssignmentQuerySuspenseQuery
>;
export type AssignmentReportAssignmentQueryQueryResult = Apollo.QueryResult<
  AssignmentReportAssignmentQuery,
  AssignmentReportAssignmentQueryVariables
>;
export const AssignmentSubmissionPageQueryDocument = gql`
  query AssignmentSubmissionPageQuery(
    $classroomId: String!
    $assignmentId: String!
    $limit: Int
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      id
      postId
      channelId
      ...SubmissionContentAssignmentDtoFields
      ...AssignmentSubmissionNavItemAssignmentDtoFields
    }
    submittedAssignmentSubmissions: listAssignmentSubmissions(
      classroomId: $classroomId
      assignmentId: $assignmentId
      limit: $limit
      submitted: "true"
    ) {
      ...AssignmentSubmissionPageAssignmentSubmissionDtoFields
    }
    notSubmittedAssignmentSubmissions: listAssignmentSubmissions(
      classroomId: $classroomId
      assignmentId: $assignmentId
      limit: $limit
      submitted: "false"
    ) {
      ...AssignmentSubmissionPageAssignmentSubmissionDtoFields
    }
  }
  ${SubmissionContentAssignmentDtoFieldsFragmentDoc}
  ${AssignmentSubmissionNavItemAssignmentDtoFieldsFragmentDoc}
  ${AssignmentSubmissionPageAssignmentSubmissionDtoFieldsFragmentDoc}
`;

/**
 * __useAssignmentSubmissionPageQuery__
 *
 * To run a query within a React component, call `useAssignmentSubmissionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentSubmissionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentSubmissionPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAssignmentSubmissionPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentSubmissionPageQuery,
    AssignmentSubmissionPageQueryVariables
  > &
    (
      | { variables: AssignmentSubmissionPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentSubmissionPageQuery,
    AssignmentSubmissionPageQueryVariables
  >(AssignmentSubmissionPageQueryDocument, options);
}
export function useAssignmentSubmissionPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentSubmissionPageQuery,
    AssignmentSubmissionPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentSubmissionPageQuery,
    AssignmentSubmissionPageQueryVariables
  >(AssignmentSubmissionPageQueryDocument, options);
}
export function useAssignmentSubmissionPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentSubmissionPageQuery,
        AssignmentSubmissionPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentSubmissionPageQuery,
    AssignmentSubmissionPageQueryVariables
  >(AssignmentSubmissionPageQueryDocument, options);
}
export type AssignmentSubmissionPageQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionPageQuery
>;
export type AssignmentSubmissionPageQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionPageQueryLazyQuery
>;
export type AssignmentSubmissionPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionPageQuerySuspenseQuery
>;
export type AssignmentSubmissionPageQueryQueryResult = Apollo.QueryResult<
  AssignmentSubmissionPageQuery,
  AssignmentSubmissionPageQueryVariables
>;
export const AssignmentSubmissionPagePostQueryDocument = gql`
  query AssignmentSubmissionPagePostQuery(
    $classroomId: String!
    $postId: String!
  ) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      id
      title
    }
  }
`;

/**
 * __useAssignmentSubmissionPagePostQuery__
 *
 * To run a query within a React component, call `useAssignmentSubmissionPagePostQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentSubmissionPagePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentSubmissionPagePostQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useAssignmentSubmissionPagePostQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentSubmissionPagePostQuery,
    AssignmentSubmissionPagePostQueryVariables
  > &
    (
      | {
          variables: AssignmentSubmissionPagePostQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentSubmissionPagePostQuery,
    AssignmentSubmissionPagePostQueryVariables
  >(AssignmentSubmissionPagePostQueryDocument, options);
}
export function useAssignmentSubmissionPagePostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentSubmissionPagePostQuery,
    AssignmentSubmissionPagePostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentSubmissionPagePostQuery,
    AssignmentSubmissionPagePostQueryVariables
  >(AssignmentSubmissionPagePostQueryDocument, options);
}
export function useAssignmentSubmissionPagePostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentSubmissionPagePostQuery,
        AssignmentSubmissionPagePostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentSubmissionPagePostQuery,
    AssignmentSubmissionPagePostQueryVariables
  >(AssignmentSubmissionPagePostQueryDocument, options);
}
export type AssignmentSubmissionPagePostQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionPagePostQuery
>;
export type AssignmentSubmissionPagePostQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionPagePostQueryLazyQuery
>;
export type AssignmentSubmissionPagePostQuerySuspenseQueryHookResult =
  ReturnType<typeof useAssignmentSubmissionPagePostQuerySuspenseQuery>;
export type AssignmentSubmissionPagePostQueryQueryResult = Apollo.QueryResult<
  AssignmentSubmissionPagePostQuery,
  AssignmentSubmissionPagePostQueryVariables
>;
export const AssignmentSubmissionPageAssignmentSubmissionQueryDocument = gql`
  query AssignmentSubmissionPageAssignmentSubmissionQuery(
    $classroomId: String!
    $assignmentSubmissionId: String!
  ) {
    assignmentSubmission: assignmentSubmission(
      classroomId: $classroomId
      assignmentSubmissionId: $assignmentSubmissionId
    ) {
      ...AssignmentSubmissionPageAssignmentSubmissionDtoFields
    }
  }
  ${AssignmentSubmissionPageAssignmentSubmissionDtoFieldsFragmentDoc}
`;

/**
 * __useAssignmentSubmissionPageAssignmentSubmissionQuery__
 *
 * To run a query within a React component, call `useAssignmentSubmissionPageAssignmentSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentSubmissionPageAssignmentSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentSubmissionPageAssignmentSubmissionQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentSubmissionId: // value for 'assignmentSubmissionId'
 *   },
 * });
 */
export function useAssignmentSubmissionPageAssignmentSubmissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentSubmissionPageAssignmentSubmissionQuery,
    AssignmentSubmissionPageAssignmentSubmissionQueryVariables
  > &
    (
      | {
          variables: AssignmentSubmissionPageAssignmentSubmissionQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentSubmissionPageAssignmentSubmissionQuery,
    AssignmentSubmissionPageAssignmentSubmissionQueryVariables
  >(AssignmentSubmissionPageAssignmentSubmissionQueryDocument, options);
}
export function useAssignmentSubmissionPageAssignmentSubmissionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentSubmissionPageAssignmentSubmissionQuery,
    AssignmentSubmissionPageAssignmentSubmissionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentSubmissionPageAssignmentSubmissionQuery,
    AssignmentSubmissionPageAssignmentSubmissionQueryVariables
  >(AssignmentSubmissionPageAssignmentSubmissionQueryDocument, options);
}
export function useAssignmentSubmissionPageAssignmentSubmissionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentSubmissionPageAssignmentSubmissionQuery,
        AssignmentSubmissionPageAssignmentSubmissionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentSubmissionPageAssignmentSubmissionQuery,
    AssignmentSubmissionPageAssignmentSubmissionQueryVariables
  >(AssignmentSubmissionPageAssignmentSubmissionQueryDocument, options);
}
export type AssignmentSubmissionPageAssignmentSubmissionQueryHookResult =
  ReturnType<typeof useAssignmentSubmissionPageAssignmentSubmissionQuery>;
export type AssignmentSubmissionPageAssignmentSubmissionQueryLazyQueryHookResult =
  ReturnType<
    typeof useAssignmentSubmissionPageAssignmentSubmissionQueryLazyQuery
  >;
export type AssignmentSubmissionPageAssignmentSubmissionQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useAssignmentSubmissionPageAssignmentSubmissionQuerySuspenseQuery
  >;
export type AssignmentSubmissionPageAssignmentSubmissionQueryQueryResult =
  Apollo.QueryResult<
    AssignmentSubmissionPageAssignmentSubmissionQuery,
    AssignmentSubmissionPageAssignmentSubmissionQueryVariables
  >;
export const AssignmentSubmissionRoutePageQueryDocument = gql`
  query AssignmentSubmissionRoutePageQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      id
      assigneeIds
    }
  }
`;

/**
 * __useAssignmentSubmissionRoutePageQuery__
 *
 * To run a query within a React component, call `useAssignmentSubmissionRoutePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentSubmissionRoutePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentSubmissionRoutePageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useAssignmentSubmissionRoutePageQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentSubmissionRoutePageQuery,
    AssignmentSubmissionRoutePageQueryVariables
  > &
    (
      | {
          variables: AssignmentSubmissionRoutePageQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentSubmissionRoutePageQuery,
    AssignmentSubmissionRoutePageQueryVariables
  >(AssignmentSubmissionRoutePageQueryDocument, options);
}
export function useAssignmentSubmissionRoutePageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentSubmissionRoutePageQuery,
    AssignmentSubmissionRoutePageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentSubmissionRoutePageQuery,
    AssignmentSubmissionRoutePageQueryVariables
  >(AssignmentSubmissionRoutePageQueryDocument, options);
}
export function useAssignmentSubmissionRoutePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentSubmissionRoutePageQuery,
        AssignmentSubmissionRoutePageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentSubmissionRoutePageQuery,
    AssignmentSubmissionRoutePageQueryVariables
  >(AssignmentSubmissionRoutePageQueryDocument, options);
}
export type AssignmentSubmissionRoutePageQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionRoutePageQuery
>;
export type AssignmentSubmissionRoutePageQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentSubmissionRoutePageQueryLazyQuery
>;
export type AssignmentSubmissionRoutePageQuerySuspenseQueryHookResult =
  ReturnType<typeof useAssignmentSubmissionRoutePageQuerySuspenseQuery>;
export type AssignmentSubmissionRoutePageQueryQueryResult = Apollo.QueryResult<
  AssignmentSubmissionRoutePageQuery,
  AssignmentSubmissionRoutePageQueryVariables
>;
export const UpdateAssignedAssignmentMutationDocument = gql`
  mutation UpdateAssignedAssignmentMutation(
    $classroomId: String!
    $assignmentId: String!
    $updateAssignedAssignmentDtoInput: UpdateAssignedAssignmentDtoInput!
  ) {
    updateAssignedAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
      updateAssignedAssignmentDtoInput: $updateAssignedAssignmentDtoInput
    ) {
      id
    }
  }
`;
export type UpdateAssignedAssignmentMutationMutationFn =
  Apollo.MutationFunction<
    UpdateAssignedAssignmentMutation,
    UpdateAssignedAssignmentMutationVariables
  >;

/**
 * __useUpdateAssignedAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignedAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignedAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignedAssignmentMutation, { data, loading, error }] = useUpdateAssignedAssignmentMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      updateAssignedAssignmentDtoInput: // value for 'updateAssignedAssignmentDtoInput'
 *   },
 * });
 */
export function useUpdateAssignedAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAssignedAssignmentMutation,
    UpdateAssignedAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAssignedAssignmentMutation,
    UpdateAssignedAssignmentMutationVariables
  >(UpdateAssignedAssignmentMutationDocument, options);
}
export type UpdateAssignedAssignmentMutationHookResult = ReturnType<
  typeof useUpdateAssignedAssignmentMutation
>;
export type UpdateAssignedAssignmentMutationMutationResult =
  Apollo.MutationResult<UpdateAssignedAssignmentMutation>;
export type UpdateAssignedAssignmentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAssignedAssignmentMutation,
    UpdateAssignedAssignmentMutationVariables
  >;
export const UpdateAssignedAssignmentPostMutationDocument = gql`
  mutation UpdateAssignedAssignmentPostMutation(
    $classroomId: String!
    $postId: String!
    $updatePostDtoInput: UpdatePostDtoInput!
  ) {
    updatePost(
      classroomId: $classroomId
      postId: $postId
      updatePostDtoInput: $updatePostDtoInput
    ) {
      id
    }
  }
`;
export type UpdateAssignedAssignmentPostMutationMutationFn =
  Apollo.MutationFunction<
    UpdateAssignedAssignmentPostMutation,
    UpdateAssignedAssignmentPostMutationVariables
  >;

/**
 * __useUpdateAssignedAssignmentPostMutation__
 *
 * To run a mutation, you first call `useUpdateAssignedAssignmentPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignedAssignmentPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignedAssignmentPostMutation, { data, loading, error }] = useUpdateAssignedAssignmentPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      updatePostDtoInput: // value for 'updatePostDtoInput'
 *   },
 * });
 */
export function useUpdateAssignedAssignmentPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAssignedAssignmentPostMutation,
    UpdateAssignedAssignmentPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAssignedAssignmentPostMutation,
    UpdateAssignedAssignmentPostMutationVariables
  >(UpdateAssignedAssignmentPostMutationDocument, options);
}
export type UpdateAssignedAssignmentPostMutationHookResult = ReturnType<
  typeof useUpdateAssignedAssignmentPostMutation
>;
export type UpdateAssignedAssignmentPostMutationMutationResult =
  Apollo.MutationResult<UpdateAssignedAssignmentPostMutation>;
export type UpdateAssignedAssignmentPostMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAssignedAssignmentPostMutation,
    UpdateAssignedAssignmentPostMutationVariables
  >;
export const EditAssignmentPageQueryDocument = gql`
  query EditAssignmentPageQuery($classroomId: String!, $assignmentId: String!) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...AssignmentFormAssignmentDtoFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
    }
  }
  ${AssignmentFormAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __useEditAssignmentPageQuery__
 *
 * To run a query within a React component, call `useEditAssignmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAssignmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAssignmentPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useEditAssignmentPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditAssignmentPageQuery,
    EditAssignmentPageQueryVariables
  > &
    (
      | { variables: EditAssignmentPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EditAssignmentPageQuery,
    EditAssignmentPageQueryVariables
  >(EditAssignmentPageQueryDocument, options);
}
export function useEditAssignmentPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditAssignmentPageQuery,
    EditAssignmentPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EditAssignmentPageQuery,
    EditAssignmentPageQueryVariables
  >(EditAssignmentPageQueryDocument, options);
}
export function useEditAssignmentPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditAssignmentPageQuery,
        EditAssignmentPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EditAssignmentPageQuery,
    EditAssignmentPageQueryVariables
  >(EditAssignmentPageQueryDocument, options);
}
export type EditAssignmentPageQueryHookResult = ReturnType<
  typeof useEditAssignmentPageQuery
>;
export type EditAssignmentPageQueryLazyQueryHookResult = ReturnType<
  typeof useEditAssignmentPageQueryLazyQuery
>;
export type EditAssignmentPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useEditAssignmentPageQuerySuspenseQuery
>;
export type EditAssignmentPageQueryQueryResult = Apollo.QueryResult<
  EditAssignmentPageQuery,
  EditAssignmentPageQueryVariables
>;
export const EditAssignmentPagePostQueryDocument = gql`
  query EditAssignmentPagePostQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...AssignmentFormPostDtoFields
    }
  }
  ${AssignmentFormPostDtoFieldsFragmentDoc}
`;

/**
 * __useEditAssignmentPagePostQuery__
 *
 * To run a query within a React component, call `useEditAssignmentPagePostQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAssignmentPagePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAssignmentPagePostQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useEditAssignmentPagePostQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditAssignmentPagePostQuery,
    EditAssignmentPagePostQueryVariables
  > &
    (
      | { variables: EditAssignmentPagePostQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EditAssignmentPagePostQuery,
    EditAssignmentPagePostQueryVariables
  >(EditAssignmentPagePostQueryDocument, options);
}
export function useEditAssignmentPagePostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditAssignmentPagePostQuery,
    EditAssignmentPagePostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EditAssignmentPagePostQuery,
    EditAssignmentPagePostQueryVariables
  >(EditAssignmentPagePostQueryDocument, options);
}
export function useEditAssignmentPagePostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditAssignmentPagePostQuery,
        EditAssignmentPagePostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EditAssignmentPagePostQuery,
    EditAssignmentPagePostQueryVariables
  >(EditAssignmentPagePostQueryDocument, options);
}
export type EditAssignmentPagePostQueryHookResult = ReturnType<
  typeof useEditAssignmentPagePostQuery
>;
export type EditAssignmentPagePostQueryLazyQueryHookResult = ReturnType<
  typeof useEditAssignmentPagePostQueryLazyQuery
>;
export type EditAssignmentPagePostQuerySuspenseQueryHookResult = ReturnType<
  typeof useEditAssignmentPagePostQuerySuspenseQuery
>;
export type EditAssignmentPagePostQueryQueryResult = Apollo.QueryResult<
  EditAssignmentPagePostQuery,
  EditAssignmentPagePostQueryVariables
>;
export const LearningCardViewerPageQueryDocument = gql`
  query LearningCardViewerPageQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      id
      title
      assignmentId
      type
      channelId
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useLearningCardViewerPageQuery__
 *
 * To run a query within a React component, call `useLearningCardViewerPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardViewerPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardViewerPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useLearningCardViewerPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardViewerPageQuery,
    LearningCardViewerPageQueryVariables
  > &
    (
      | { variables: LearningCardViewerPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardViewerPageQuery,
    LearningCardViewerPageQueryVariables
  >(LearningCardViewerPageQueryDocument, options);
}
export function useLearningCardViewerPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardViewerPageQuery,
    LearningCardViewerPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardViewerPageQuery,
    LearningCardViewerPageQueryVariables
  >(LearningCardViewerPageQueryDocument, options);
}
export function useLearningCardViewerPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardViewerPageQuery,
        LearningCardViewerPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardViewerPageQuery,
    LearningCardViewerPageQueryVariables
  >(LearningCardViewerPageQueryDocument, options);
}
export type LearningCardViewerPageQueryHookResult = ReturnType<
  typeof useLearningCardViewerPageQuery
>;
export type LearningCardViewerPageQueryLazyQueryHookResult = ReturnType<
  typeof useLearningCardViewerPageQueryLazyQuery
>;
export type LearningCardViewerPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useLearningCardViewerPageQuerySuspenseQuery
>;
export type LearningCardViewerPageQueryQueryResult = Apollo.QueryResult<
  LearningCardViewerPageQuery,
  LearningCardViewerPageQueryVariables
>;
export const LearningCardViewerPageAssignmentQueryDocument = gql`
  query LearningCardViewerPageAssignmentQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      id
      assigneeIds
      type
    }
  }
`;

/**
 * __useLearningCardViewerPageAssignmentQuery__
 *
 * To run a query within a React component, call `useLearningCardViewerPageAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCardViewerPageAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCardViewerPageAssignmentQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useLearningCardViewerPageAssignmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    LearningCardViewerPageAssignmentQuery,
    LearningCardViewerPageAssignmentQueryVariables
  > &
    (
      | {
          variables: LearningCardViewerPageAssignmentQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LearningCardViewerPageAssignmentQuery,
    LearningCardViewerPageAssignmentQueryVariables
  >(LearningCardViewerPageAssignmentQueryDocument, options);
}
export function useLearningCardViewerPageAssignmentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LearningCardViewerPageAssignmentQuery,
    LearningCardViewerPageAssignmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LearningCardViewerPageAssignmentQuery,
    LearningCardViewerPageAssignmentQueryVariables
  >(LearningCardViewerPageAssignmentQueryDocument, options);
}
export function useLearningCardViewerPageAssignmentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LearningCardViewerPageAssignmentQuery,
        LearningCardViewerPageAssignmentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LearningCardViewerPageAssignmentQuery,
    LearningCardViewerPageAssignmentQueryVariables
  >(LearningCardViewerPageAssignmentQueryDocument, options);
}
export type LearningCardViewerPageAssignmentQueryHookResult = ReturnType<
  typeof useLearningCardViewerPageAssignmentQuery
>;
export type LearningCardViewerPageAssignmentQueryLazyQueryHookResult =
  ReturnType<typeof useLearningCardViewerPageAssignmentQueryLazyQuery>;
export type LearningCardViewerPageAssignmentQuerySuspenseQueryHookResult =
  ReturnType<typeof useLearningCardViewerPageAssignmentQuerySuspenseQuery>;
export type LearningCardViewerPageAssignmentQueryQueryResult =
  Apollo.QueryResult<
    LearningCardViewerPageAssignmentQuery,
    LearningCardViewerPageAssignmentQueryVariables
  >;
export const SubmissionDetailPageQueryDocument = gql`
  query SubmissionDetailPageQuery(
    $classroomId: String!
    $assignmentId: String!
    $assignmentSubmissionId: String!
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      id
      postId
      channelId
      ...SubmissionContentAssignmentDtoFields
    }
    assignmentSubmission: assignmentSubmission(
      classroomId: $classroomId
      assignmentSubmissionId: $assignmentSubmissionId
    ) {
      ...SubmissionContentAssignmentSubmissionDtoFields
    }
  }
  ${SubmissionContentAssignmentDtoFieldsFragmentDoc}
  ${SubmissionContentAssignmentSubmissionDtoFieldsFragmentDoc}
`;

/**
 * __useSubmissionDetailPageQuery__
 *
 * To run a query within a React component, call `useSubmissionDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionDetailPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      assignmentSubmissionId: // value for 'assignmentSubmissionId'
 *   },
 * });
 */
export function useSubmissionDetailPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubmissionDetailPageQuery,
    SubmissionDetailPageQueryVariables
  > &
    (
      | { variables: SubmissionDetailPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SubmissionDetailPageQuery,
    SubmissionDetailPageQueryVariables
  >(SubmissionDetailPageQueryDocument, options);
}
export function useSubmissionDetailPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubmissionDetailPageQuery,
    SubmissionDetailPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SubmissionDetailPageQuery,
    SubmissionDetailPageQueryVariables
  >(SubmissionDetailPageQueryDocument, options);
}
export function useSubmissionDetailPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubmissionDetailPageQuery,
        SubmissionDetailPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SubmissionDetailPageQuery,
    SubmissionDetailPageQueryVariables
  >(SubmissionDetailPageQueryDocument, options);
}
export type SubmissionDetailPageQueryHookResult = ReturnType<
  typeof useSubmissionDetailPageQuery
>;
export type SubmissionDetailPageQueryLazyQueryHookResult = ReturnType<
  typeof useSubmissionDetailPageQueryLazyQuery
>;
export type SubmissionDetailPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useSubmissionDetailPageQuerySuspenseQuery
>;
export type SubmissionDetailPageQueryQueryResult = Apollo.QueryResult<
  SubmissionDetailPageQuery,
  SubmissionDetailPageQueryVariables
>;
export const SubmissionDetailPagePostQueryDocument = gql`
  query SubmissionDetailPagePostQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      id
      title
      channelId
    }
  }
`;

/**
 * __useSubmissionDetailPagePostQuery__
 *
 * To run a query within a React component, call `useSubmissionDetailPagePostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionDetailPagePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionDetailPagePostQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useSubmissionDetailPagePostQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubmissionDetailPagePostQuery,
    SubmissionDetailPagePostQueryVariables
  > &
    (
      | { variables: SubmissionDetailPagePostQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SubmissionDetailPagePostQuery,
    SubmissionDetailPagePostQueryVariables
  >(SubmissionDetailPagePostQueryDocument, options);
}
export function useSubmissionDetailPagePostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubmissionDetailPagePostQuery,
    SubmissionDetailPagePostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SubmissionDetailPagePostQuery,
    SubmissionDetailPagePostQueryVariables
  >(SubmissionDetailPagePostQueryDocument, options);
}
export function useSubmissionDetailPagePostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubmissionDetailPagePostQuery,
        SubmissionDetailPagePostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SubmissionDetailPagePostQuery,
    SubmissionDetailPagePostQueryVariables
  >(SubmissionDetailPagePostQueryDocument, options);
}
export type SubmissionDetailPagePostQueryHookResult = ReturnType<
  typeof useSubmissionDetailPagePostQuery
>;
export type SubmissionDetailPagePostQueryLazyQueryHookResult = ReturnType<
  typeof useSubmissionDetailPagePostQueryLazyQuery
>;
export type SubmissionDetailPagePostQuerySuspenseQueryHookResult = ReturnType<
  typeof useSubmissionDetailPagePostQuerySuspenseQuery
>;
export type SubmissionDetailPagePostQueryQueryResult = Apollo.QueryResult<
  SubmissionDetailPagePostQuery,
  SubmissionDetailPagePostQueryVariables
>;
export const SubmissionDetailPageCurrentMemberQueryDocument = gql`
  query SubmissionDetailPageCurrentMemberQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useSubmissionDetailPageCurrentMemberQuery__
 *
 * To run a query within a React component, call `useSubmissionDetailPageCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionDetailPageCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionDetailPageCurrentMemberQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useSubmissionDetailPageCurrentMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubmissionDetailPageCurrentMemberQuery,
    SubmissionDetailPageCurrentMemberQueryVariables
  > &
    (
      | {
          variables: SubmissionDetailPageCurrentMemberQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SubmissionDetailPageCurrentMemberQuery,
    SubmissionDetailPageCurrentMemberQueryVariables
  >(SubmissionDetailPageCurrentMemberQueryDocument, options);
}
export function useSubmissionDetailPageCurrentMemberQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubmissionDetailPageCurrentMemberQuery,
    SubmissionDetailPageCurrentMemberQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SubmissionDetailPageCurrentMemberQuery,
    SubmissionDetailPageCurrentMemberQueryVariables
  >(SubmissionDetailPageCurrentMemberQueryDocument, options);
}
export function useSubmissionDetailPageCurrentMemberQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubmissionDetailPageCurrentMemberQuery,
        SubmissionDetailPageCurrentMemberQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SubmissionDetailPageCurrentMemberQuery,
    SubmissionDetailPageCurrentMemberQueryVariables
  >(SubmissionDetailPageCurrentMemberQueryDocument, options);
}
export type SubmissionDetailPageCurrentMemberQueryHookResult = ReturnType<
  typeof useSubmissionDetailPageCurrentMemberQuery
>;
export type SubmissionDetailPageCurrentMemberQueryLazyQueryHookResult =
  ReturnType<typeof useSubmissionDetailPageCurrentMemberQueryLazyQuery>;
export type SubmissionDetailPageCurrentMemberQuerySuspenseQueryHookResult =
  ReturnType<typeof useSubmissionDetailPageCurrentMemberQuerySuspenseQuery>;
export type SubmissionDetailPageCurrentMemberQueryQueryResult =
  Apollo.QueryResult<
    SubmissionDetailPageCurrentMemberQuery,
    SubmissionDetailPageCurrentMemberQueryVariables
  >;
export const UpdateAssignmentMutationDocument = gql`
  mutation UpdateAssignmentMutation(
    $classroomId: String!
    $assignmentId: String!
    $updateAssignmentDtoInput: UpdateAssignmentDtoInput!
  ) {
    assignment: updateAssignment(
      assignmentId: $assignmentId
      classroomId: $classroomId
      updateAssignmentDtoInput: $updateAssignmentDtoInput
    ) {
      ...AssignmentFormAssignmentDtoFields
      createdAt
    }
  }
  ${AssignmentFormAssignmentDtoFieldsFragmentDoc}
`;
export type UpdateAssignmentMutationMutationFn = Apollo.MutationFunction<
  UpdateAssignmentMutation,
  UpdateAssignmentMutationVariables
>;

/**
 * __useUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentMutation, { data, loading, error }] = useUpdateAssignmentMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      updateAssignmentDtoInput: // value for 'updateAssignmentDtoInput'
 *   },
 * });
 */
export function useUpdateAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAssignmentMutation,
    UpdateAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAssignmentMutation,
    UpdateAssignmentMutationVariables
  >(UpdateAssignmentMutationDocument, options);
}
export type UpdateAssignmentMutationHookResult = ReturnType<
  typeof useUpdateAssignmentMutation
>;
export type UpdateAssignmentMutationMutationResult =
  Apollo.MutationResult<UpdateAssignmentMutation>;
export type UpdateAssignmentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAssignmentMutation,
    UpdateAssignmentMutationVariables
  >;
export const DraftAssignmentMutationDocument = gql`
  mutation DraftAssignmentMutation(
    $classroomId: String!
    $postId: String!
    $savePostAsDraftDtoInput: SavePostAsDraftDtoInput!
  ) {
    post: savePostAsDraft(
      classroomId: $classroomId
      postId: $postId
      savePostAsDraftDtoInput: $savePostAsDraftDtoInput
    ) {
      ...AssignmentFormPostDtoFields
      createdAt
    }
  }
  ${AssignmentFormPostDtoFieldsFragmentDoc}
`;
export type DraftAssignmentMutationMutationFn = Apollo.MutationFunction<
  DraftAssignmentMutation,
  DraftAssignmentMutationVariables
>;

/**
 * __useDraftAssignmentMutation__
 *
 * To run a mutation, you first call `useDraftAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftAssignmentMutation, { data, loading, error }] = useDraftAssignmentMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      savePostAsDraftDtoInput: // value for 'savePostAsDraftDtoInput'
 *   },
 * });
 */
export function useDraftAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DraftAssignmentMutation,
    DraftAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DraftAssignmentMutation,
    DraftAssignmentMutationVariables
  >(DraftAssignmentMutationDocument, options);
}
export type DraftAssignmentMutationHookResult = ReturnType<
  typeof useDraftAssignmentMutation
>;
export type DraftAssignmentMutationMutationResult =
  Apollo.MutationResult<DraftAssignmentMutation>;
export type DraftAssignmentMutationMutationOptions = Apollo.BaseMutationOptions<
  DraftAssignmentMutation,
  DraftAssignmentMutationVariables
>;
export const PublishAssignmentPostMutationDocument = gql`
  mutation PublishAssignmentPostMutation(
    $classroomId: String!
    $postId: String!
  ) {
    post: publishPost(classroomId: $classroomId, postId: $postId) {
      ...AssignmentFormPostDtoFields
      createdAt
    }
  }
  ${AssignmentFormPostDtoFieldsFragmentDoc}
`;
export type PublishAssignmentPostMutationMutationFn = Apollo.MutationFunction<
  PublishAssignmentPostMutation,
  PublishAssignmentPostMutationVariables
>;

/**
 * __usePublishAssignmentPostMutation__
 *
 * To run a mutation, you first call `usePublishAssignmentPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAssignmentPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAssignmentPostMutation, { data, loading, error }] = usePublishAssignmentPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePublishAssignmentPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishAssignmentPostMutation,
    PublishAssignmentPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishAssignmentPostMutation,
    PublishAssignmentPostMutationVariables
  >(PublishAssignmentPostMutationDocument, options);
}
export type PublishAssignmentPostMutationHookResult = ReturnType<
  typeof usePublishAssignmentPostMutation
>;
export type PublishAssignmentPostMutationMutationResult =
  Apollo.MutationResult<PublishAssignmentPostMutation>;
export type PublishAssignmentPostMutationMutationOptions =
  Apollo.BaseMutationOptions<
    PublishAssignmentPostMutation,
    PublishAssignmentPostMutationVariables
  >;
export const AssignAssignmentMutationDocument = gql`
  mutation AssignAssignmentMutation(
    $classroomId: String!
    $assignmentId: String!
    $assignAssignmentDtoInput: AssignAssignmentDtoInput!
  ) {
    assignment: assignAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
      assignAssignmentDtoInput: $assignAssignmentDtoInput
    ) {
      id
    }
  }
`;
export type AssignAssignmentMutationMutationFn = Apollo.MutationFunction<
  AssignAssignmentMutation,
  AssignAssignmentMutationVariables
>;

/**
 * __useAssignAssignmentMutation__
 *
 * To run a mutation, you first call `useAssignAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAssignmentMutation, { data, loading, error }] = useAssignAssignmentMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      assignAssignmentDtoInput: // value for 'assignAssignmentDtoInput'
 *   },
 * });
 */
export function useAssignAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignAssignmentMutation,
    AssignAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignAssignmentMutation,
    AssignAssignmentMutationVariables
  >(AssignAssignmentMutationDocument, options);
}
export type AssignAssignmentMutationHookResult = ReturnType<
  typeof useAssignAssignmentMutation
>;
export type AssignAssignmentMutationMutationResult =
  Apollo.MutationResult<AssignAssignmentMutation>;
export type AssignAssignmentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    AssignAssignmentMutation,
    AssignAssignmentMutationVariables
  >;
export const WriteAssignmentPageQueryDocument = gql`
  query WriteAssignmentPageQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...AssignmentFormAssignmentDtoFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
  ${AssignmentFormAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __useWriteAssignmentPageQuery__
 *
 * To run a query within a React component, call `useWriteAssignmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriteAssignmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriteAssignmentPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useWriteAssignmentPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    WriteAssignmentPageQuery,
    WriteAssignmentPageQueryVariables
  > &
    (
      | { variables: WriteAssignmentPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WriteAssignmentPageQuery,
    WriteAssignmentPageQueryVariables
  >(WriteAssignmentPageQueryDocument, options);
}
export function useWriteAssignmentPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WriteAssignmentPageQuery,
    WriteAssignmentPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WriteAssignmentPageQuery,
    WriteAssignmentPageQueryVariables
  >(WriteAssignmentPageQueryDocument, options);
}
export function useWriteAssignmentPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WriteAssignmentPageQuery,
        WriteAssignmentPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WriteAssignmentPageQuery,
    WriteAssignmentPageQueryVariables
  >(WriteAssignmentPageQueryDocument, options);
}
export type WriteAssignmentPageQueryHookResult = ReturnType<
  typeof useWriteAssignmentPageQuery
>;
export type WriteAssignmentPageQueryLazyQueryHookResult = ReturnType<
  typeof useWriteAssignmentPageQueryLazyQuery
>;
export type WriteAssignmentPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useWriteAssignmentPageQuerySuspenseQuery
>;
export type WriteAssignmentPageQueryQueryResult = Apollo.QueryResult<
  WriteAssignmentPageQuery,
  WriteAssignmentPageQueryVariables
>;
export const WriteAssignmentPagePostQueryDocument = gql`
  query WriteAssignmentPagePostQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...AssignmentFormPostDtoFields
    }
  }
  ${AssignmentFormPostDtoFieldsFragmentDoc}
`;

/**
 * __useWriteAssignmentPagePostQuery__
 *
 * To run a query within a React component, call `useWriteAssignmentPagePostQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriteAssignmentPagePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriteAssignmentPagePostQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useWriteAssignmentPagePostQuery(
  baseOptions: Apollo.QueryHookOptions<
    WriteAssignmentPagePostQuery,
    WriteAssignmentPagePostQueryVariables
  > &
    (
      | { variables: WriteAssignmentPagePostQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WriteAssignmentPagePostQuery,
    WriteAssignmentPagePostQueryVariables
  >(WriteAssignmentPagePostQueryDocument, options);
}
export function useWriteAssignmentPagePostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WriteAssignmentPagePostQuery,
    WriteAssignmentPagePostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WriteAssignmentPagePostQuery,
    WriteAssignmentPagePostQueryVariables
  >(WriteAssignmentPagePostQueryDocument, options);
}
export function useWriteAssignmentPagePostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WriteAssignmentPagePostQuery,
        WriteAssignmentPagePostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WriteAssignmentPagePostQuery,
    WriteAssignmentPagePostQueryVariables
  >(WriteAssignmentPagePostQueryDocument, options);
}
export type WriteAssignmentPagePostQueryHookResult = ReturnType<
  typeof useWriteAssignmentPagePostQuery
>;
export type WriteAssignmentPagePostQueryLazyQueryHookResult = ReturnType<
  typeof useWriteAssignmentPagePostQueryLazyQuery
>;
export type WriteAssignmentPagePostQuerySuspenseQueryHookResult = ReturnType<
  typeof useWriteAssignmentPagePostQuerySuspenseQuery
>;
export type WriteAssignmentPagePostQueryQueryResult = Apollo.QueryResult<
  WriteAssignmentPagePostQuery,
  WriteAssignmentPagePostQueryVariables
>;
export const SubmitAssignmentSubmissionMutationDocument = gql`
  mutation SubmitAssignmentSubmissionMutation(
    $classroomId: String!
    $assignmentId: String!
    $submitSubmissionDtoInput: SubmitSubmissionDtoInput!
  ) {
    submitSubmission(
      classroomId: $classroomId
      assignmentId: $assignmentId
      submitSubmissionDtoInput: $submitSubmissionDtoInput
    ) {
      id
      assignmentId
      classroomId
      points
      isSubmitted
      status
      gradingStatus
      createdAt
    }
  }
`;
export type SubmitAssignmentSubmissionMutationMutationFn =
  Apollo.MutationFunction<
    SubmitAssignmentSubmissionMutation,
    SubmitAssignmentSubmissionMutationVariables
  >;

/**
 * __useSubmitAssignmentSubmissionMutation__
 *
 * To run a mutation, you first call `useSubmitAssignmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAssignmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAssignmentSubmissionMutation, { data, loading, error }] = useSubmitAssignmentSubmissionMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      submitSubmissionDtoInput: // value for 'submitSubmissionDtoInput'
 *   },
 * });
 */
export function useSubmitAssignmentSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitAssignmentSubmissionMutation,
    SubmitAssignmentSubmissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitAssignmentSubmissionMutation,
    SubmitAssignmentSubmissionMutationVariables
  >(SubmitAssignmentSubmissionMutationDocument, options);
}
export type SubmitAssignmentSubmissionMutationHookResult = ReturnType<
  typeof useSubmitAssignmentSubmissionMutation
>;
export type SubmitAssignmentSubmissionMutationMutationResult =
  Apollo.MutationResult<SubmitAssignmentSubmissionMutation>;
export type SubmitAssignmentSubmissionMutationMutationOptions =
  Apollo.BaseMutationOptions<
    SubmitAssignmentSubmissionMutation,
    SubmitAssignmentSubmissionMutationVariables
  >;
export const ArchiveChannelMutationDocument = gql`
  mutation archiveChannelMutation($classroomId: String!, $channelId: String!) {
    channel: archiveChannelDto(
      classroomId: $classroomId
      channelId: $channelId
    ) {
      ...ChannelNavItemChannelFields
    }
  }
  ${ChannelNavItemChannelFieldsFragmentDoc}
`;
export type ArchiveChannelMutationMutationFn = Apollo.MutationFunction<
  ArchiveChannelMutation,
  ArchiveChannelMutationVariables
>;

/**
 * __useArchiveChannelMutation__
 *
 * To run a mutation, you first call `useArchiveChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveChannelMutation, { data, loading, error }] = useArchiveChannelMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useArchiveChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveChannelMutation,
    ArchiveChannelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveChannelMutation,
    ArchiveChannelMutationVariables
  >(ArchiveChannelMutationDocument, options);
}
export type ArchiveChannelMutationHookResult = ReturnType<
  typeof useArchiveChannelMutation
>;
export type ArchiveChannelMutationMutationResult =
  Apollo.MutationResult<ArchiveChannelMutation>;
export type ArchiveChannelMutationMutationOptions = Apollo.BaseMutationOptions<
  ArchiveChannelMutation,
  ArchiveChannelMutationVariables
>;
export const UnarchiveChannelMutationDocument = gql`
  mutation unarchiveChannelMutation(
    $classroomId: String!
    $channelId: String!
  ) {
    channel: unarchiveChannelDto(
      classroomId: $classroomId
      channelId: $channelId
    ) {
      ...ChannelNavItemChannelFields
    }
  }
  ${ChannelNavItemChannelFieldsFragmentDoc}
`;
export type UnarchiveChannelMutationMutationFn = Apollo.MutationFunction<
  UnarchiveChannelMutation,
  UnarchiveChannelMutationVariables
>;

/**
 * __useUnarchiveChannelMutation__
 *
 * To run a mutation, you first call `useUnarchiveChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveChannelMutation, { data, loading, error }] = useUnarchiveChannelMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useUnarchiveChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveChannelMutation,
    UnarchiveChannelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnarchiveChannelMutation,
    UnarchiveChannelMutationVariables
  >(UnarchiveChannelMutationDocument, options);
}
export type UnarchiveChannelMutationHookResult = ReturnType<
  typeof useUnarchiveChannelMutation
>;
export type UnarchiveChannelMutationMutationResult =
  Apollo.MutationResult<UnarchiveChannelMutation>;
export type UnarchiveChannelMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UnarchiveChannelMutation,
    UnarchiveChannelMutationVariables
  >;
export const ChannelFormQueryDocument = gql`
  query ChannelFormQuery($classroomId: String!, $channelId: String!) {
    channelMembers: listChannelMembers(
      classroomId: $classroomId
      channelId: $channelId
    ) {
      id
    }
  }
`;

/**
 * __useChannelFormQuery__
 *
 * To run a query within a React component, call `useChannelFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelFormQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelFormQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelFormQuery,
    ChannelFormQueryVariables
  > &
    (
      | { variables: ChannelFormQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelFormQuery, ChannelFormQueryVariables>(
    ChannelFormQueryDocument,
    options
  );
}
export function useChannelFormQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelFormQuery,
    ChannelFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelFormQuery, ChannelFormQueryVariables>(
    ChannelFormQueryDocument,
    options
  );
}
export function useChannelFormQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelFormQuery,
        ChannelFormQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelFormQuery, ChannelFormQueryVariables>(
    ChannelFormQueryDocument,
    options
  );
}
export type ChannelFormQueryHookResult = ReturnType<typeof useChannelFormQuery>;
export type ChannelFormQueryLazyQueryHookResult = ReturnType<
  typeof useChannelFormQueryLazyQuery
>;
export type ChannelFormQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelFormQuerySuspenseQuery
>;
export type ChannelFormQueryQueryResult = Apollo.QueryResult<
  ChannelFormQuery,
  ChannelFormQueryVariables
>;
export const ChannelMemberListQueryDocument = gql`
  query ChannelMemberListQuery($classroomId: String!, $channelId: String!) {
    members: listChannelMembers(
      classroomId: $classroomId
      channelId: $channelId
    ) {
      ...MemberItemMemberFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      isCommon
    }
  }
  ${MemberItemMemberFieldsFragmentDoc}
`;

/**
 * __useChannelMemberListQuery__
 *
 * To run a query within a React component, call `useChannelMemberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelMemberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelMemberListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelMemberListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelMemberListQuery,
    ChannelMemberListQueryVariables
  > &
    (
      | { variables: ChannelMemberListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChannelMemberListQuery,
    ChannelMemberListQueryVariables
  >(ChannelMemberListQueryDocument, options);
}
export function useChannelMemberListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelMemberListQuery,
    ChannelMemberListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelMemberListQuery,
    ChannelMemberListQueryVariables
  >(ChannelMemberListQueryDocument, options);
}
export function useChannelMemberListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelMemberListQuery,
        ChannelMemberListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelMemberListQuery,
    ChannelMemberListQueryVariables
  >(ChannelMemberListQueryDocument, options);
}
export type ChannelMemberListQueryHookResult = ReturnType<
  typeof useChannelMemberListQuery
>;
export type ChannelMemberListQueryLazyQueryHookResult = ReturnType<
  typeof useChannelMemberListQueryLazyQuery
>;
export type ChannelMemberListQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelMemberListQuerySuspenseQuery
>;
export type ChannelMemberListQueryQueryResult = Apollo.QueryResult<
  ChannelMemberListQuery,
  ChannelMemberListQueryVariables
>;
export const ChannelMembersSelectorByGroupQueryDocument = gql`
  query ChannelMembersSelectorByGroupQuery($classroomId: String!) {
    me: getMe {
      id
    }
    studentsCollection: listClassroomMembers(
      classroomId: $classroomId
      limit: 2000
      groups: "student"
    ) {
      members {
        ...ChannelMembersSelectorMemberFields
      }
    }
    guardiansCollection: listClassroomMembers(
      classroomId: $classroomId
      limit: 2000
      groups: "guardian"
    ) {
      members {
        ...ChannelMembersSelectorMemberFields
      }
    }
    teachersCollection: listClassroomMembers(
      classroomId: $classroomId
      limit: 2000
      groups: "teacher"
    ) {
      members {
        ...ChannelMembersSelectorMemberFields
      }
    }
  }
  ${ChannelMembersSelectorMemberFieldsFragmentDoc}
`;

/**
 * __useChannelMembersSelectorByGroupQuery__
 *
 * To run a query within a React component, call `useChannelMembersSelectorByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelMembersSelectorByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelMembersSelectorByGroupQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useChannelMembersSelectorByGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelMembersSelectorByGroupQuery,
    ChannelMembersSelectorByGroupQueryVariables
  > &
    (
      | {
          variables: ChannelMembersSelectorByGroupQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChannelMembersSelectorByGroupQuery,
    ChannelMembersSelectorByGroupQueryVariables
  >(ChannelMembersSelectorByGroupQueryDocument, options);
}
export function useChannelMembersSelectorByGroupQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelMembersSelectorByGroupQuery,
    ChannelMembersSelectorByGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelMembersSelectorByGroupQuery,
    ChannelMembersSelectorByGroupQueryVariables
  >(ChannelMembersSelectorByGroupQueryDocument, options);
}
export function useChannelMembersSelectorByGroupQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelMembersSelectorByGroupQuery,
        ChannelMembersSelectorByGroupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelMembersSelectorByGroupQuery,
    ChannelMembersSelectorByGroupQueryVariables
  >(ChannelMembersSelectorByGroupQueryDocument, options);
}
export type ChannelMembersSelectorByGroupQueryHookResult = ReturnType<
  typeof useChannelMembersSelectorByGroupQuery
>;
export type ChannelMembersSelectorByGroupQueryLazyQueryHookResult = ReturnType<
  typeof useChannelMembersSelectorByGroupQueryLazyQuery
>;
export type ChannelMembersSelectorByGroupQuerySuspenseQueryHookResult =
  ReturnType<typeof useChannelMembersSelectorByGroupQuerySuspenseQuery>;
export type ChannelMembersSelectorByGroupQueryQueryResult = Apollo.QueryResult<
  ChannelMembersSelectorByGroupQuery,
  ChannelMembersSelectorByGroupQueryVariables
>;
export const ChannelMembersSelectorByGroupChannelMembersQueryDocument = gql`
  query ChannelMembersSelectorByGroupChannelMembersQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    joinedStudents: listChannelMembers(
      classroomId: $classroomId
      channelId: $channelId
      groups: "student"
    ) {
      ...ChannelMembersSelectorMemberFields
    }
    joinedGuardians: listChannelMembers(
      classroomId: $classroomId
      channelId: $channelId
      groups: "guardian"
    ) {
      ...ChannelMembersSelectorMemberFields
    }
    joinedTeachers: listChannelMembers(
      classroomId: $classroomId
      channelId: $channelId
      groups: "teacher"
    ) {
      ...ChannelMembersSelectorMemberFields
    }
  }
  ${ChannelMembersSelectorMemberFieldsFragmentDoc}
`;

/**
 * __useChannelMembersSelectorByGroupChannelMembersQuery__
 *
 * To run a query within a React component, call `useChannelMembersSelectorByGroupChannelMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelMembersSelectorByGroupChannelMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelMembersSelectorByGroupChannelMembersQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelMembersSelectorByGroupChannelMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelMembersSelectorByGroupChannelMembersQuery,
    ChannelMembersSelectorByGroupChannelMembersQueryVariables
  > &
    (
      | {
          variables: ChannelMembersSelectorByGroupChannelMembersQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChannelMembersSelectorByGroupChannelMembersQuery,
    ChannelMembersSelectorByGroupChannelMembersQueryVariables
  >(ChannelMembersSelectorByGroupChannelMembersQueryDocument, options);
}
export function useChannelMembersSelectorByGroupChannelMembersQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelMembersSelectorByGroupChannelMembersQuery,
    ChannelMembersSelectorByGroupChannelMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelMembersSelectorByGroupChannelMembersQuery,
    ChannelMembersSelectorByGroupChannelMembersQueryVariables
  >(ChannelMembersSelectorByGroupChannelMembersQueryDocument, options);
}
export function useChannelMembersSelectorByGroupChannelMembersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelMembersSelectorByGroupChannelMembersQuery,
        ChannelMembersSelectorByGroupChannelMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelMembersSelectorByGroupChannelMembersQuery,
    ChannelMembersSelectorByGroupChannelMembersQueryVariables
  >(ChannelMembersSelectorByGroupChannelMembersQueryDocument, options);
}
export type ChannelMembersSelectorByGroupChannelMembersQueryHookResult =
  ReturnType<typeof useChannelMembersSelectorByGroupChannelMembersQuery>;
export type ChannelMembersSelectorByGroupChannelMembersQueryLazyQueryHookResult =
  ReturnType<
    typeof useChannelMembersSelectorByGroupChannelMembersQueryLazyQuery
  >;
export type ChannelMembersSelectorByGroupChannelMembersQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useChannelMembersSelectorByGroupChannelMembersQuerySuspenseQuery
  >;
export type ChannelMembersSelectorByGroupChannelMembersQueryQueryResult =
  Apollo.QueryResult<
    ChannelMembersSelectorByGroupChannelMembersQuery,
    ChannelMembersSelectorByGroupChannelMembersQueryVariables
  >;
export const ChannelNavQueryDocument = gql`
  query ChannelNavQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      archived
    }
    channelGroups: listChannelGroupsDto(classroomId: $classroomId) {
      id
      name
      primary
      channels {
        ...ChannelNavItemChannelFields
      }
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
  ${ChannelNavItemChannelFieldsFragmentDoc}
`;

/**
 * __useChannelNavQuery__
 *
 * To run a query within a React component, call `useChannelNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelNavQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useChannelNavQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelNavQuery,
    ChannelNavQueryVariables
  > &
    (
      | { variables: ChannelNavQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelNavQuery, ChannelNavQueryVariables>(
    ChannelNavQueryDocument,
    options
  );
}
export function useChannelNavQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelNavQuery,
    ChannelNavQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelNavQuery, ChannelNavQueryVariables>(
    ChannelNavQueryDocument,
    options
  );
}
export function useChannelNavQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChannelNavQuery, ChannelNavQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelNavQuery, ChannelNavQueryVariables>(
    ChannelNavQueryDocument,
    options
  );
}
export type ChannelNavQueryHookResult = ReturnType<typeof useChannelNavQuery>;
export type ChannelNavQueryLazyQueryHookResult = ReturnType<
  typeof useChannelNavQueryLazyQuery
>;
export type ChannelNavQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelNavQuerySuspenseQuery
>;
export type ChannelNavQueryQueryResult = Apollo.QueryResult<
  ChannelNavQuery,
  ChannelNavQueryVariables
>;
export const JoinChannelMutationDocument = gql`
  mutation JoinChannelMutation($classroomId: String!, $channelId: String!) {
    channel: joinChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
    }
  }
`;
export type JoinChannelMutationMutationFn = Apollo.MutationFunction<
  JoinChannelMutation,
  JoinChannelMutationVariables
>;

/**
 * __useJoinChannelMutation__
 *
 * To run a mutation, you first call `useJoinChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinChannelMutation, { data, loading, error }] = useJoinChannelMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useJoinChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinChannelMutation,
    JoinChannelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<JoinChannelMutation, JoinChannelMutationVariables>(
    JoinChannelMutationDocument,
    options
  );
}
export type JoinChannelMutationHookResult = ReturnType<
  typeof useJoinChannelMutation
>;
export type JoinChannelMutationMutationResult =
  Apollo.MutationResult<JoinChannelMutation>;
export type JoinChannelMutationMutationOptions = Apollo.BaseMutationOptions<
  JoinChannelMutation,
  JoinChannelMutationVariables
>;
export const ChannelPageHeaderQueryDocument = gql`
  query ChannelPageHeaderQuery($classroomId: String!, $channelId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      archived
    }
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
      purpose
      channelGroupId
      isPrivate
      meeting {
        id
        status
      }
      channelType
      isCommon
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    currentChannelMember: channelMember(
      classroomId: $classroomId
      channelId: $channelId
      memberId: "me"
    ) {
      id
    }
  }
`;

/**
 * __useChannelPageHeaderQuery__
 *
 * To run a query within a React component, call `useChannelPageHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelPageHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelPageHeaderQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelPageHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelPageHeaderQuery,
    ChannelPageHeaderQueryVariables
  > &
    (
      | { variables: ChannelPageHeaderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChannelPageHeaderQuery,
    ChannelPageHeaderQueryVariables
  >(ChannelPageHeaderQueryDocument, options);
}
export function useChannelPageHeaderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelPageHeaderQuery,
    ChannelPageHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelPageHeaderQuery,
    ChannelPageHeaderQueryVariables
  >(ChannelPageHeaderQueryDocument, options);
}
export function useChannelPageHeaderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelPageHeaderQuery,
        ChannelPageHeaderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelPageHeaderQuery,
    ChannelPageHeaderQueryVariables
  >(ChannelPageHeaderQueryDocument, options);
}
export type ChannelPageHeaderQueryHookResult = ReturnType<
  typeof useChannelPageHeaderQuery
>;
export type ChannelPageHeaderQueryLazyQueryHookResult = ReturnType<
  typeof useChannelPageHeaderQueryLazyQuery
>;
export type ChannelPageHeaderQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelPageHeaderQuerySuspenseQuery
>;
export type ChannelPageHeaderQueryQueryResult = Apollo.QueryResult<
  ChannelPageHeaderQuery,
  ChannelPageHeaderQueryVariables
>;
export const ChannelGroupNameQueryDocument = gql`
  query ChannelGroupNameQuery($classroomId: String!, $channelGroupId: String!) {
    channelGroup: getChannelGroupDto(
      classroomId: $classroomId
      channelGroupId: $channelGroupId
    ) {
      id
      name
    }
  }
`;

/**
 * __useChannelGroupNameQuery__
 *
 * To run a query within a React component, call `useChannelGroupNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelGroupNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelGroupNameQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelGroupId: // value for 'channelGroupId'
 *   },
 * });
 */
export function useChannelGroupNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelGroupNameQuery,
    ChannelGroupNameQueryVariables
  > &
    (
      | { variables: ChannelGroupNameQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelGroupNameQuery, ChannelGroupNameQueryVariables>(
    ChannelGroupNameQueryDocument,
    options
  );
}
export function useChannelGroupNameQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelGroupNameQuery,
    ChannelGroupNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelGroupNameQuery,
    ChannelGroupNameQueryVariables
  >(ChannelGroupNameQueryDocument, options);
}
export function useChannelGroupNameQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelGroupNameQuery,
        ChannelGroupNameQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelGroupNameQuery,
    ChannelGroupNameQueryVariables
  >(ChannelGroupNameQueryDocument, options);
}
export type ChannelGroupNameQueryHookResult = ReturnType<
  typeof useChannelGroupNameQuery
>;
export type ChannelGroupNameQueryLazyQueryHookResult = ReturnType<
  typeof useChannelGroupNameQueryLazyQuery
>;
export type ChannelGroupNameQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelGroupNameQuerySuspenseQuery
>;
export type ChannelGroupNameQueryQueryResult = Apollo.QueryResult<
  ChannelGroupNameQuery,
  ChannelGroupNameQueryVariables
>;
export const ClassGuideQueryDocument = gql`
  query ClassGuideQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useClassGuideQuery__
 *
 * To run a query within a React component, call `useClassGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassGuideQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassGuideQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassGuideQuery,
    ClassGuideQueryVariables
  > &
    (
      | { variables: ClassGuideQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClassGuideQuery, ClassGuideQueryVariables>(
    ClassGuideQueryDocument,
    options
  );
}
export function useClassGuideQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassGuideQuery,
    ClassGuideQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClassGuideQuery, ClassGuideQueryVariables>(
    ClassGuideQueryDocument,
    options
  );
}
export function useClassGuideQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ClassGuideQuery, ClassGuideQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ClassGuideQuery, ClassGuideQueryVariables>(
    ClassGuideQueryDocument,
    options
  );
}
export type ClassGuideQueryHookResult = ReturnType<typeof useClassGuideQuery>;
export type ClassGuideQueryLazyQueryHookResult = ReturnType<
  typeof useClassGuideQueryLazyQuery
>;
export type ClassGuideQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassGuideQuerySuspenseQuery
>;
export type ClassGuideQueryQueryResult = Apollo.QueryResult<
  ClassGuideQuery,
  ClassGuideQueryVariables
>;
export const DeleteChannelMutationDocument = gql`
  mutation DeleteChannelMutation(
    $classroomId: String!
    $channelGroupId: String!
    $channelId: String!
  ) {
    deleteChannel(
      classroomId: $classroomId
      channelGroupId: $channelGroupId
      channelId: $channelId
    )
  }
`;
export type DeleteChannelMutationMutationFn = Apollo.MutationFunction<
  DeleteChannelMutation,
  DeleteChannelMutationVariables
>;

/**
 * __useDeleteChannelMutation__
 *
 * To run a mutation, you first call `useDeleteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelMutation, { data, loading, error }] = useDeleteChannelMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelGroupId: // value for 'channelGroupId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDeleteChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteChannelMutation,
    DeleteChannelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteChannelMutation,
    DeleteChannelMutationVariables
  >(DeleteChannelMutationDocument, options);
}
export type DeleteChannelMutationHookResult = ReturnType<
  typeof useDeleteChannelMutation
>;
export type DeleteChannelMutationMutationResult =
  Apollo.MutationResult<DeleteChannelMutation>;
export type DeleteChannelMutationMutationOptions = Apollo.BaseMutationOptions<
  DeleteChannelMutation,
  DeleteChannelMutationVariables
>;
export const DeleteChannelGroupMutationDocument = gql`
  mutation deleteChannelGroupMutation(
    $channelGroupId: String!
    $classroomId: String!
  ) {
    deleteChannelGroup(
      channelGroupId: $channelGroupId
      classroomId: $classroomId
    )
  }
`;
export type DeleteChannelGroupMutationMutationFn = Apollo.MutationFunction<
  DeleteChannelGroupMutation,
  DeleteChannelGroupMutationVariables
>;

/**
 * __useDeleteChannelGroupMutation__
 *
 * To run a mutation, you first call `useDeleteChannelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelGroupMutation, { data, loading, error }] = useDeleteChannelGroupMutation({
 *   variables: {
 *      channelGroupId: // value for 'channelGroupId'
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useDeleteChannelGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteChannelGroupMutation,
    DeleteChannelGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteChannelGroupMutation,
    DeleteChannelGroupMutationVariables
  >(DeleteChannelGroupMutationDocument, options);
}
export type DeleteChannelGroupMutationHookResult = ReturnType<
  typeof useDeleteChannelGroupMutation
>;
export type DeleteChannelGroupMutationMutationResult =
  Apollo.MutationResult<DeleteChannelGroupMutation>;
export type DeleteChannelGroupMutationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteChannelGroupMutation,
    DeleteChannelGroupMutationVariables
  >;
export const LeaveChannelMutationDocument = gql`
  mutation leaveChannelMutation($channelId: String!, $classroomId: String!) {
    leaveChannelDto(channelId: $channelId, classroomId: $classroomId) {
      ...ChannelNavItemChannelFields
    }
  }
  ${ChannelNavItemChannelFieldsFragmentDoc}
`;
export type LeaveChannelMutationMutationFn = Apollo.MutationFunction<
  LeaveChannelMutation,
  LeaveChannelMutationVariables
>;

/**
 * __useLeaveChannelMutation__
 *
 * To run a mutation, you first call `useLeaveChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveChannelMutation, { data, loading, error }] = useLeaveChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useLeaveChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveChannelMutation,
    LeaveChannelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LeaveChannelMutation,
    LeaveChannelMutationVariables
  >(LeaveChannelMutationDocument, options);
}
export type LeaveChannelMutationHookResult = ReturnType<
  typeof useLeaveChannelMutation
>;
export type LeaveChannelMutationMutationResult =
  Apollo.MutationResult<LeaveChannelMutation>;
export type LeaveChannelMutationMutationOptions = Apollo.BaseMutationOptions<
  LeaveChannelMutation,
  LeaveChannelMutationVariables
>;
export const ChannelListPageQueryDocument = gql`
  query ChannelListPageQuery($classroomId: String!) {
    channelGroups: listChannelGroupsDto(classroomId: $classroomId, scope: ALL) {
      id
      name
      channels {
        ...ChannelListItemChannelFields
      }
    }
  }
  ${ChannelListItemChannelFieldsFragmentDoc}
`;

/**
 * __useChannelListPageQuery__
 *
 * To run a query within a React component, call `useChannelListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelListPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useChannelListPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelListPageQuery,
    ChannelListPageQueryVariables
  > &
    (
      | { variables: ChannelListPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelListPageQuery, ChannelListPageQueryVariables>(
    ChannelListPageQueryDocument,
    options
  );
}
export function useChannelListPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelListPageQuery,
    ChannelListPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelListPageQuery,
    ChannelListPageQueryVariables
  >(ChannelListPageQueryDocument, options);
}
export function useChannelListPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelListPageQuery,
        ChannelListPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelListPageQuery,
    ChannelListPageQueryVariables
  >(ChannelListPageQueryDocument, options);
}
export type ChannelListPageQueryHookResult = ReturnType<
  typeof useChannelListPageQuery
>;
export type ChannelListPageQueryLazyQueryHookResult = ReturnType<
  typeof useChannelListPageQueryLazyQuery
>;
export type ChannelListPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelListPageQuerySuspenseQuery
>;
export type ChannelListPageQueryQueryResult = Apollo.QueryResult<
  ChannelListPageQuery,
  ChannelListPageQueryVariables
>;
export const ChannelPageQueryDocument = gql`
  query ChannelPageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
      archived
      ...NavbarClassroomFields
    }
    me: getMe {
      id
      isAdFreeSubscribed
    }
  }
  ${NavbarClassroomFieldsFragmentDoc}
`;

/**
 * __useChannelPageQuery__
 *
 * To run a query within a React component, call `useChannelPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useChannelPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelPageQuery,
    ChannelPageQueryVariables
  > &
    (
      | { variables: ChannelPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelPageQuery, ChannelPageQueryVariables>(
    ChannelPageQueryDocument,
    options
  );
}
export function useChannelPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelPageQuery,
    ChannelPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelPageQuery, ChannelPageQueryVariables>(
    ChannelPageQueryDocument,
    options
  );
}
export function useChannelPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelPageQuery,
        ChannelPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelPageQuery, ChannelPageQueryVariables>(
    ChannelPageQueryDocument,
    options
  );
}
export type ChannelPageQueryHookResult = ReturnType<typeof useChannelPageQuery>;
export type ChannelPageQueryLazyQueryHookResult = ReturnType<
  typeof useChannelPageQueryLazyQuery
>;
export type ChannelPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelPageQuerySuspenseQuery
>;
export type ChannelPageQueryQueryResult = Apollo.QueryResult<
  ChannelPageQuery,
  ChannelPageQueryVariables
>;
export const CreateChannelGroupMutationDocument = gql`
  mutation createChannelGroupMutation(
    $classroomId: String!
    $createChannelGroupDtoInput: CreateChannelGroupDtoInput!
  ) {
    channelGroup: createChannelGroupDto(
      classroomId: $classroomId
      createChannelGroupDtoInput: $createChannelGroupDtoInput
    ) {
      ...ChannelGroupFormChannelGroupFields
      primary
      classroomId
      channelIds
      channels {
        ...ChannelNavItemChannelFields
      }
    }
  }
  ${ChannelGroupFormChannelGroupFieldsFragmentDoc}
  ${ChannelNavItemChannelFieldsFragmentDoc}
`;
export type CreateChannelGroupMutationMutationFn = Apollo.MutationFunction<
  CreateChannelGroupMutation,
  CreateChannelGroupMutationVariables
>;

/**
 * __useCreateChannelGroupMutation__
 *
 * To run a mutation, you first call `useCreateChannelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelGroupMutation, { data, loading, error }] = useCreateChannelGroupMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      createChannelGroupDtoInput: // value for 'createChannelGroupDtoInput'
 *   },
 * });
 */
export function useCreateChannelGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChannelGroupMutation,
    CreateChannelGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChannelGroupMutation,
    CreateChannelGroupMutationVariables
  >(CreateChannelGroupMutationDocument, options);
}
export type CreateChannelGroupMutationHookResult = ReturnType<
  typeof useCreateChannelGroupMutation
>;
export type CreateChannelGroupMutationMutationResult =
  Apollo.MutationResult<CreateChannelGroupMutation>;
export type CreateChannelGroupMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateChannelGroupMutation,
    CreateChannelGroupMutationVariables
  >;
export const CreateChannelMutationDocument = gql`
  mutation createChannelMutation(
    $classroomId: String!
    $createChannelDtoInput: CreateChannelDtoInput!
  ) {
    channel: createChannelDto(
      classroomId: $classroomId
      createChannelDtoInput: $createChannelDtoInput
    ) {
      ...ChannelFormChannelFields
    }
  }
  ${ChannelFormChannelFieldsFragmentDoc}
`;
export type CreateChannelMutationMutationFn = Apollo.MutationFunction<
  CreateChannelMutation,
  CreateChannelMutationVariables
>;

/**
 * __useCreateChannelMutation__
 *
 * To run a mutation, you first call `useCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMutation, { data, loading, error }] = useCreateChannelMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      createChannelDtoInput: // value for 'createChannelDtoInput'
 *   },
 * });
 */
export function useCreateChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChannelMutation,
    CreateChannelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChannelMutation,
    CreateChannelMutationVariables
  >(CreateChannelMutationDocument, options);
}
export type CreateChannelMutationHookResult = ReturnType<
  typeof useCreateChannelMutation
>;
export type CreateChannelMutationMutationResult =
  Apollo.MutationResult<CreateChannelMutation>;
export type CreateChannelMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateChannelMutation,
  CreateChannelMutationVariables
>;
export const CreateChannelPageQueryDocument = gql`
  query CreateChannelPageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      ...ChannelFormClassroomFields
    }
    channelGroupCollection: listChannelGroupsDto(classroomId: $classroomId) {
      channels {
        ...ChannelFormChannelFields
      }
      id
      name
      primary
    }
  }
  ${ChannelFormClassroomFieldsFragmentDoc}
  ${ChannelFormChannelFieldsFragmentDoc}
`;

/**
 * __useCreateChannelPageQuery__
 *
 * To run a query within a React component, call `useCreateChannelPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateChannelPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useCreateChannelPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreateChannelPageQuery,
    CreateChannelPageQueryVariables
  > &
    (
      | { variables: CreateChannelPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CreateChannelPageQuery,
    CreateChannelPageQueryVariables
  >(CreateChannelPageQueryDocument, options);
}
export function useCreateChannelPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreateChannelPageQuery,
    CreateChannelPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CreateChannelPageQuery,
    CreateChannelPageQueryVariables
  >(CreateChannelPageQueryDocument, options);
}
export function useCreateChannelPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreateChannelPageQuery,
        CreateChannelPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CreateChannelPageQuery,
    CreateChannelPageQueryVariables
  >(CreateChannelPageQueryDocument, options);
}
export type CreateChannelPageQueryHookResult = ReturnType<
  typeof useCreateChannelPageQuery
>;
export type CreateChannelPageQueryLazyQueryHookResult = ReturnType<
  typeof useCreateChannelPageQueryLazyQuery
>;
export type CreateChannelPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useCreateChannelPageQuerySuspenseQuery
>;
export type CreateChannelPageQueryQueryResult = Apollo.QueryResult<
  CreateChannelPageQuery,
  CreateChannelPageQueryVariables
>;
export const UpdateChannelGroupMutationDocument = gql`
  mutation updateChannelGroupMutation(
    $channelGroupId: String!
    $classroomId: String!
    $updateChannelGroupDtoInput: UpdateChannelGroupDtoInput!
  ) {
    channelGroup: updateChannelGroupDto(
      channelGroupId: $channelGroupId
      classroomId: $classroomId
      updateChannelGroupDtoInput: $updateChannelGroupDtoInput
    ) {
      ...ChannelGroupFormChannelGroupFields
    }
  }
  ${ChannelGroupFormChannelGroupFieldsFragmentDoc}
`;
export type UpdateChannelGroupMutationMutationFn = Apollo.MutationFunction<
  UpdateChannelGroupMutation,
  UpdateChannelGroupMutationVariables
>;

/**
 * __useUpdateChannelGroupMutation__
 *
 * To run a mutation, you first call `useUpdateChannelGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelGroupMutation, { data, loading, error }] = useUpdateChannelGroupMutation({
 *   variables: {
 *      channelGroupId: // value for 'channelGroupId'
 *      classroomId: // value for 'classroomId'
 *      updateChannelGroupDtoInput: // value for 'updateChannelGroupDtoInput'
 *   },
 * });
 */
export function useUpdateChannelGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChannelGroupMutation,
    UpdateChannelGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChannelGroupMutation,
    UpdateChannelGroupMutationVariables
  >(UpdateChannelGroupMutationDocument, options);
}
export type UpdateChannelGroupMutationHookResult = ReturnType<
  typeof useUpdateChannelGroupMutation
>;
export type UpdateChannelGroupMutationMutationResult =
  Apollo.MutationResult<UpdateChannelGroupMutation>;
export type UpdateChannelGroupMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateChannelGroupMutation,
    UpdateChannelGroupMutationVariables
  >;
export const EditChannelGroupPageQueryDocument = gql`
  query EditChannelGroupPageQuery(
    $classroomId: String!
    $channelGroupId: String!
  ) {
    channelGroup: getChannelGroupDto(
      classroomId: $classroomId
      channelGroupId: $channelGroupId
    ) {
      classroomId
      id
      primary
      ...ChannelGroupFormChannelGroupFields
    }
  }
  ${ChannelGroupFormChannelGroupFieldsFragmentDoc}
`;

/**
 * __useEditChannelGroupPageQuery__
 *
 * To run a query within a React component, call `useEditChannelGroupPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditChannelGroupPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditChannelGroupPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelGroupId: // value for 'channelGroupId'
 *   },
 * });
 */
export function useEditChannelGroupPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditChannelGroupPageQuery,
    EditChannelGroupPageQueryVariables
  > &
    (
      | { variables: EditChannelGroupPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EditChannelGroupPageQuery,
    EditChannelGroupPageQueryVariables
  >(EditChannelGroupPageQueryDocument, options);
}
export function useEditChannelGroupPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditChannelGroupPageQuery,
    EditChannelGroupPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EditChannelGroupPageQuery,
    EditChannelGroupPageQueryVariables
  >(EditChannelGroupPageQueryDocument, options);
}
export function useEditChannelGroupPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditChannelGroupPageQuery,
        EditChannelGroupPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EditChannelGroupPageQuery,
    EditChannelGroupPageQueryVariables
  >(EditChannelGroupPageQueryDocument, options);
}
export type EditChannelGroupPageQueryHookResult = ReturnType<
  typeof useEditChannelGroupPageQuery
>;
export type EditChannelGroupPageQueryLazyQueryHookResult = ReturnType<
  typeof useEditChannelGroupPageQueryLazyQuery
>;
export type EditChannelGroupPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useEditChannelGroupPageQuerySuspenseQuery
>;
export type EditChannelGroupPageQueryQueryResult = Apollo.QueryResult<
  EditChannelGroupPageQuery,
  EditChannelGroupPageQueryVariables
>;
export const UpdateChannelMutationDocument = gql`
  mutation updateChannelMutation(
    $classroomId: String!
    $channelId: String!
    $updateChannelDtoInput: UpdateChannelDtoInput!
  ) {
    channel: updateChannelDto(
      classroomId: $classroomId
      channelId: $channelId
      updateChannelDtoInput: $updateChannelDtoInput
    ) {
      ...ChannelFormChannelFields
    }
  }
  ${ChannelFormChannelFieldsFragmentDoc}
`;
export type UpdateChannelMutationMutationFn = Apollo.MutationFunction<
  UpdateChannelMutation,
  UpdateChannelMutationVariables
>;

/**
 * __useUpdateChannelMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMutation, { data, loading, error }] = useUpdateChannelMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      updateChannelDtoInput: // value for 'updateChannelDtoInput'
 *   },
 * });
 */
export function useUpdateChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChannelMutation,
    UpdateChannelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChannelMutation,
    UpdateChannelMutationVariables
  >(UpdateChannelMutationDocument, options);
}
export type UpdateChannelMutationHookResult = ReturnType<
  typeof useUpdateChannelMutation
>;
export type UpdateChannelMutationMutationResult =
  Apollo.MutationResult<UpdateChannelMutation>;
export type UpdateChannelMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateChannelMutation,
  UpdateChannelMutationVariables
>;
export const EditChannelPageQueryDocument = gql`
  query EditChannelPageQuery($classroomId: String!, $channelId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      ...ChannelFormClassroomFields
    }
    currentChannelMember: channelMember(
      classroomId: $classroomId
      channelId: $channelId
      memberId: "me"
    ) {
      id
      role
    }
    channelGroups: listChannelGroupsDto(classroomId: $classroomId) {
      ...ChannelFormChannelGroupFields
    }
  }
  ${ChannelFormClassroomFieldsFragmentDoc}
  ${ChannelFormChannelGroupFieldsFragmentDoc}
`;

/**
 * __useEditChannelPageQuery__
 *
 * To run a query within a React component, call `useEditChannelPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditChannelPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditChannelPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useEditChannelPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditChannelPageQuery,
    EditChannelPageQueryVariables
  > &
    (
      | { variables: EditChannelPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EditChannelPageQuery, EditChannelPageQueryVariables>(
    EditChannelPageQueryDocument,
    options
  );
}
export function useEditChannelPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditChannelPageQuery,
    EditChannelPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EditChannelPageQuery,
    EditChannelPageQueryVariables
  >(EditChannelPageQueryDocument, options);
}
export function useEditChannelPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditChannelPageQuery,
        EditChannelPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EditChannelPageQuery,
    EditChannelPageQueryVariables
  >(EditChannelPageQueryDocument, options);
}
export type EditChannelPageQueryHookResult = ReturnType<
  typeof useEditChannelPageQuery
>;
export type EditChannelPageQueryLazyQueryHookResult = ReturnType<
  typeof useEditChannelPageQueryLazyQuery
>;
export type EditChannelPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useEditChannelPageQuerySuspenseQuery
>;
export type EditChannelPageQueryQueryResult = Apollo.QueryResult<
  EditChannelPageQuery,
  EditChannelPageQueryVariables
>;
export const EditChannelPageChannelQueryDocument = gql`
  query EditChannelPageChannelQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      ...ChannelFormChannelFields
    }
  }
  ${ChannelFormChannelFieldsFragmentDoc}
`;

/**
 * __useEditChannelPageChannelQuery__
 *
 * To run a query within a React component, call `useEditChannelPageChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditChannelPageChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditChannelPageChannelQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useEditChannelPageChannelQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditChannelPageChannelQuery,
    EditChannelPageChannelQueryVariables
  > &
    (
      | { variables: EditChannelPageChannelQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EditChannelPageChannelQuery,
    EditChannelPageChannelQueryVariables
  >(EditChannelPageChannelQueryDocument, options);
}
export function useEditChannelPageChannelQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditChannelPageChannelQuery,
    EditChannelPageChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EditChannelPageChannelQuery,
    EditChannelPageChannelQueryVariables
  >(EditChannelPageChannelQueryDocument, options);
}
export function useEditChannelPageChannelQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditChannelPageChannelQuery,
        EditChannelPageChannelQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EditChannelPageChannelQuery,
    EditChannelPageChannelQueryVariables
  >(EditChannelPageChannelQueryDocument, options);
}
export type EditChannelPageChannelQueryHookResult = ReturnType<
  typeof useEditChannelPageChannelQuery
>;
export type EditChannelPageChannelQueryLazyQueryHookResult = ReturnType<
  typeof useEditChannelPageChannelQueryLazyQuery
>;
export type EditChannelPageChannelQuerySuspenseQueryHookResult = ReturnType<
  typeof useEditChannelPageChannelQuerySuspenseQuery
>;
export type EditChannelPageChannelQueryQueryResult = Apollo.QueryResult<
  EditChannelPageChannelQuery,
  EditChannelPageChannelQueryVariables
>;
export const ClassAiTutorBannerQueryDocument = gql`
  query ClassAiTutorBannerQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
      grade
      schoolId
      schoolName
    }
  }
`;

/**
 * __useClassAiTutorBannerQuery__
 *
 * To run a query within a React component, call `useClassAiTutorBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassAiTutorBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassAiTutorBannerQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassAiTutorBannerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassAiTutorBannerQuery,
    ClassAiTutorBannerQueryVariables
  > &
    (
      | { variables: ClassAiTutorBannerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassAiTutorBannerQuery,
    ClassAiTutorBannerQueryVariables
  >(ClassAiTutorBannerQueryDocument, options);
}
export function useClassAiTutorBannerQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassAiTutorBannerQuery,
    ClassAiTutorBannerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassAiTutorBannerQuery,
    ClassAiTutorBannerQueryVariables
  >(ClassAiTutorBannerQueryDocument, options);
}
export function useClassAiTutorBannerQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassAiTutorBannerQuery,
        ClassAiTutorBannerQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassAiTutorBannerQuery,
    ClassAiTutorBannerQueryVariables
  >(ClassAiTutorBannerQueryDocument, options);
}
export type ClassAiTutorBannerQueryHookResult = ReturnType<
  typeof useClassAiTutorBannerQuery
>;
export type ClassAiTutorBannerQueryLazyQueryHookResult = ReturnType<
  typeof useClassAiTutorBannerQueryLazyQuery
>;
export type ClassAiTutorBannerQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassAiTutorBannerQuerySuspenseQuery
>;
export type ClassAiTutorBannerQueryQueryResult = Apollo.QueryResult<
  ClassAiTutorBannerQuery,
  ClassAiTutorBannerQueryVariables
>;
export const ClassAiTutorBannerCurrentMemberQueryDocument = gql`
  query ClassAiTutorBannerCurrentMemberQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      group
      role
    }
  }
`;

/**
 * __useClassAiTutorBannerCurrentMemberQuery__
 *
 * To run a query within a React component, call `useClassAiTutorBannerCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassAiTutorBannerCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassAiTutorBannerCurrentMemberQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassAiTutorBannerCurrentMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassAiTutorBannerCurrentMemberQuery,
    ClassAiTutorBannerCurrentMemberQueryVariables
  > &
    (
      | {
          variables: ClassAiTutorBannerCurrentMemberQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassAiTutorBannerCurrentMemberQuery,
    ClassAiTutorBannerCurrentMemberQueryVariables
  >(ClassAiTutorBannerCurrentMemberQueryDocument, options);
}
export function useClassAiTutorBannerCurrentMemberQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassAiTutorBannerCurrentMemberQuery,
    ClassAiTutorBannerCurrentMemberQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassAiTutorBannerCurrentMemberQuery,
    ClassAiTutorBannerCurrentMemberQueryVariables
  >(ClassAiTutorBannerCurrentMemberQueryDocument, options);
}
export function useClassAiTutorBannerCurrentMemberQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassAiTutorBannerCurrentMemberQuery,
        ClassAiTutorBannerCurrentMemberQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassAiTutorBannerCurrentMemberQuery,
    ClassAiTutorBannerCurrentMemberQueryVariables
  >(ClassAiTutorBannerCurrentMemberQueryDocument, options);
}
export type ClassAiTutorBannerCurrentMemberQueryHookResult = ReturnType<
  typeof useClassAiTutorBannerCurrentMemberQuery
>;
export type ClassAiTutorBannerCurrentMemberQueryLazyQueryHookResult =
  ReturnType<typeof useClassAiTutorBannerCurrentMemberQueryLazyQuery>;
export type ClassAiTutorBannerCurrentMemberQuerySuspenseQueryHookResult =
  ReturnType<typeof useClassAiTutorBannerCurrentMemberQuerySuspenseQuery>;
export type ClassAiTutorBannerCurrentMemberQueryQueryResult =
  Apollo.QueryResult<
    ClassAiTutorBannerCurrentMemberQuery,
    ClassAiTutorBannerCurrentMemberQueryVariables
  >;
export const ClassAiTutorFloatingButtonQueryDocument = gql`
  query ClassAiTutorFloatingButtonQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
      grade
      schoolId
      schoolName
    }
  }
`;

/**
 * __useClassAiTutorFloatingButtonQuery__
 *
 * To run a query within a React component, call `useClassAiTutorFloatingButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassAiTutorFloatingButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassAiTutorFloatingButtonQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassAiTutorFloatingButtonQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassAiTutorFloatingButtonQuery,
    ClassAiTutorFloatingButtonQueryVariables
  > &
    (
      | { variables: ClassAiTutorFloatingButtonQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassAiTutorFloatingButtonQuery,
    ClassAiTutorFloatingButtonQueryVariables
  >(ClassAiTutorFloatingButtonQueryDocument, options);
}
export function useClassAiTutorFloatingButtonQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassAiTutorFloatingButtonQuery,
    ClassAiTutorFloatingButtonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassAiTutorFloatingButtonQuery,
    ClassAiTutorFloatingButtonQueryVariables
  >(ClassAiTutorFloatingButtonQueryDocument, options);
}
export function useClassAiTutorFloatingButtonQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassAiTutorFloatingButtonQuery,
        ClassAiTutorFloatingButtonQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassAiTutorFloatingButtonQuery,
    ClassAiTutorFloatingButtonQueryVariables
  >(ClassAiTutorFloatingButtonQueryDocument, options);
}
export type ClassAiTutorFloatingButtonQueryHookResult = ReturnType<
  typeof useClassAiTutorFloatingButtonQuery
>;
export type ClassAiTutorFloatingButtonQueryLazyQueryHookResult = ReturnType<
  typeof useClassAiTutorFloatingButtonQueryLazyQuery
>;
export type ClassAiTutorFloatingButtonQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassAiTutorFloatingButtonQuerySuspenseQuery
>;
export type ClassAiTutorFloatingButtonQueryQueryResult = Apollo.QueryResult<
  ClassAiTutorFloatingButtonQuery,
  ClassAiTutorFloatingButtonQueryVariables
>;
export const ClassAiTutorFloatingButtonCurrentMemberQueryDocument = gql`
  query ClassAiTutorFloatingButtonCurrentMemberQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      group
      role
    }
  }
`;

/**
 * __useClassAiTutorFloatingButtonCurrentMemberQuery__
 *
 * To run a query within a React component, call `useClassAiTutorFloatingButtonCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassAiTutorFloatingButtonCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassAiTutorFloatingButtonCurrentMemberQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassAiTutorFloatingButtonCurrentMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassAiTutorFloatingButtonCurrentMemberQuery,
    ClassAiTutorFloatingButtonCurrentMemberQueryVariables
  > &
    (
      | {
          variables: ClassAiTutorFloatingButtonCurrentMemberQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassAiTutorFloatingButtonCurrentMemberQuery,
    ClassAiTutorFloatingButtonCurrentMemberQueryVariables
  >(ClassAiTutorFloatingButtonCurrentMemberQueryDocument, options);
}
export function useClassAiTutorFloatingButtonCurrentMemberQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassAiTutorFloatingButtonCurrentMemberQuery,
    ClassAiTutorFloatingButtonCurrentMemberQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassAiTutorFloatingButtonCurrentMemberQuery,
    ClassAiTutorFloatingButtonCurrentMemberQueryVariables
  >(ClassAiTutorFloatingButtonCurrentMemberQueryDocument, options);
}
export function useClassAiTutorFloatingButtonCurrentMemberQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassAiTutorFloatingButtonCurrentMemberQuery,
        ClassAiTutorFloatingButtonCurrentMemberQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassAiTutorFloatingButtonCurrentMemberQuery,
    ClassAiTutorFloatingButtonCurrentMemberQueryVariables
  >(ClassAiTutorFloatingButtonCurrentMemberQueryDocument, options);
}
export type ClassAiTutorFloatingButtonCurrentMemberQueryHookResult = ReturnType<
  typeof useClassAiTutorFloatingButtonCurrentMemberQuery
>;
export type ClassAiTutorFloatingButtonCurrentMemberQueryLazyQueryHookResult =
  ReturnType<typeof useClassAiTutorFloatingButtonCurrentMemberQueryLazyQuery>;
export type ClassAiTutorFloatingButtonCurrentMemberQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useClassAiTutorFloatingButtonCurrentMemberQuerySuspenseQuery
  >;
export type ClassAiTutorFloatingButtonCurrentMemberQueryQueryResult =
  Apollo.QueryResult<
    ClassAiTutorFloatingButtonCurrentMemberQuery,
    ClassAiTutorFloatingButtonCurrentMemberQueryVariables
  >;
export const WritePostChannelSelectorQueryDocument = gql`
  query WritePostChannelSelectorQuery($classroomId: String!) {
    commonChannels: listCommonChannels(classroomId: $classroomId) {
      id
      channelType
      name
      canMemberWritePost
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useWritePostChannelSelectorQuery__
 *
 * To run a query within a React component, call `useWritePostChannelSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useWritePostChannelSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWritePostChannelSelectorQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useWritePostChannelSelectorQuery(
  baseOptions: Apollo.QueryHookOptions<
    WritePostChannelSelectorQuery,
    WritePostChannelSelectorQueryVariables
  > &
    (
      | { variables: WritePostChannelSelectorQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WritePostChannelSelectorQuery,
    WritePostChannelSelectorQueryVariables
  >(WritePostChannelSelectorQueryDocument, options);
}
export function useWritePostChannelSelectorQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WritePostChannelSelectorQuery,
    WritePostChannelSelectorQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WritePostChannelSelectorQuery,
    WritePostChannelSelectorQueryVariables
  >(WritePostChannelSelectorQueryDocument, options);
}
export function useWritePostChannelSelectorQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WritePostChannelSelectorQuery,
        WritePostChannelSelectorQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WritePostChannelSelectorQuery,
    WritePostChannelSelectorQueryVariables
  >(WritePostChannelSelectorQueryDocument, options);
}
export type WritePostChannelSelectorQueryHookResult = ReturnType<
  typeof useWritePostChannelSelectorQuery
>;
export type WritePostChannelSelectorQueryLazyQueryHookResult = ReturnType<
  typeof useWritePostChannelSelectorQueryLazyQuery
>;
export type WritePostChannelSelectorQuerySuspenseQueryHookResult = ReturnType<
  typeof useWritePostChannelSelectorQuerySuspenseQuery
>;
export type WritePostChannelSelectorQueryQueryResult = Apollo.QueryResult<
  WritePostChannelSelectorQuery,
  WritePostChannelSelectorQueryVariables
>;
export const ClassAiTutorDrawerQueryDocument = gql`
  query ClassAiTutorDrawerQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      ...ClassAiTutorDrawerClassroomFields
    }
    me: getClassroomMember(classroomId: $classroomId, memberId: "me") {
      id
      role
      group
    }
  }
  ${ClassAiTutorDrawerClassroomFieldsFragmentDoc}
`;

/**
 * __useClassAiTutorDrawerQuery__
 *
 * To run a query within a React component, call `useClassAiTutorDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassAiTutorDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassAiTutorDrawerQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassAiTutorDrawerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassAiTutorDrawerQuery,
    ClassAiTutorDrawerQueryVariables
  > &
    (
      | { variables: ClassAiTutorDrawerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassAiTutorDrawerQuery,
    ClassAiTutorDrawerQueryVariables
  >(ClassAiTutorDrawerQueryDocument, options);
}
export function useClassAiTutorDrawerQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassAiTutorDrawerQuery,
    ClassAiTutorDrawerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassAiTutorDrawerQuery,
    ClassAiTutorDrawerQueryVariables
  >(ClassAiTutorDrawerQueryDocument, options);
}
export function useClassAiTutorDrawerQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassAiTutorDrawerQuery,
        ClassAiTutorDrawerQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassAiTutorDrawerQuery,
    ClassAiTutorDrawerQueryVariables
  >(ClassAiTutorDrawerQueryDocument, options);
}
export type ClassAiTutorDrawerQueryHookResult = ReturnType<
  typeof useClassAiTutorDrawerQuery
>;
export type ClassAiTutorDrawerQueryLazyQueryHookResult = ReturnType<
  typeof useClassAiTutorDrawerQueryLazyQuery
>;
export type ClassAiTutorDrawerQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassAiTutorDrawerQuerySuspenseQuery
>;
export type ClassAiTutorDrawerQueryQueryResult = Apollo.QueryResult<
  ClassAiTutorDrawerQuery,
  ClassAiTutorDrawerQueryVariables
>;
export const ClassAiTutorDrawerMyLicenseQueryDocument = gql`
  query ClassAiTutorDrawerMyLicenseQuery($orgId: String!) {
    myLicense: organizationMyLicense(orgId: $orgId) {
      id
    }
  }
`;

/**
 * __useClassAiTutorDrawerMyLicenseQuery__
 *
 * To run a query within a React component, call `useClassAiTutorDrawerMyLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassAiTutorDrawerMyLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassAiTutorDrawerMyLicenseQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useClassAiTutorDrawerMyLicenseQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassAiTutorDrawerMyLicenseQuery,
    ClassAiTutorDrawerMyLicenseQueryVariables
  > &
    (
      | { variables: ClassAiTutorDrawerMyLicenseQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassAiTutorDrawerMyLicenseQuery,
    ClassAiTutorDrawerMyLicenseQueryVariables
  >(ClassAiTutorDrawerMyLicenseQueryDocument, options);
}
export function useClassAiTutorDrawerMyLicenseQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassAiTutorDrawerMyLicenseQuery,
    ClassAiTutorDrawerMyLicenseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassAiTutorDrawerMyLicenseQuery,
    ClassAiTutorDrawerMyLicenseQueryVariables
  >(ClassAiTutorDrawerMyLicenseQueryDocument, options);
}
export function useClassAiTutorDrawerMyLicenseQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassAiTutorDrawerMyLicenseQuery,
        ClassAiTutorDrawerMyLicenseQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassAiTutorDrawerMyLicenseQuery,
    ClassAiTutorDrawerMyLicenseQueryVariables
  >(ClassAiTutorDrawerMyLicenseQueryDocument, options);
}
export type ClassAiTutorDrawerMyLicenseQueryHookResult = ReturnType<
  typeof useClassAiTutorDrawerMyLicenseQuery
>;
export type ClassAiTutorDrawerMyLicenseQueryLazyQueryHookResult = ReturnType<
  typeof useClassAiTutorDrawerMyLicenseQueryLazyQuery
>;
export type ClassAiTutorDrawerMyLicenseQuerySuspenseQueryHookResult =
  ReturnType<typeof useClassAiTutorDrawerMyLicenseQuerySuspenseQuery>;
export type ClassAiTutorDrawerMyLicenseQueryQueryResult = Apollo.QueryResult<
  ClassAiTutorDrawerMyLicenseQuery,
  ClassAiTutorDrawerMyLicenseQueryVariables
>;
export const AppBarBottomQueryDocument = gql`
  query AppBarBottomQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      name
      profileImageUrl
    }
  }
`;

/**
 * __useAppBarBottomQuery__
 *
 * To run a query within a React component, call `useAppBarBottomQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppBarBottomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppBarBottomQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAppBarBottomQuery(
  baseOptions: Apollo.QueryHookOptions<
    AppBarBottomQuery,
    AppBarBottomQueryVariables
  > &
    (
      | { variables: AppBarBottomQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AppBarBottomQuery, AppBarBottomQueryVariables>(
    AppBarBottomQueryDocument,
    options
  );
}
export function useAppBarBottomQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppBarBottomQuery,
    AppBarBottomQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AppBarBottomQuery, AppBarBottomQueryVariables>(
    AppBarBottomQueryDocument,
    options
  );
}
export function useAppBarBottomQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AppBarBottomQuery,
        AppBarBottomQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AppBarBottomQuery, AppBarBottomQueryVariables>(
    AppBarBottomQueryDocument,
    options
  );
}
export type AppBarBottomQueryHookResult = ReturnType<
  typeof useAppBarBottomQuery
>;
export type AppBarBottomQueryLazyQueryHookResult = ReturnType<
  typeof useAppBarBottomQueryLazyQuery
>;
export type AppBarBottomQuerySuspenseQueryHookResult = ReturnType<
  typeof useAppBarBottomQuerySuspenseQuery
>;
export type AppBarBottomQueryQueryResult = Apollo.QueryResult<
  AppBarBottomQuery,
  AppBarBottomQueryVariables
>;
export const UnblockMemberMutationDocument = gql`
  mutation UnblockMemberMutation($classroomId: String!, $memberId: String!) {
    member: unblockMember(classroomId: $classroomId, memberId: $memberId) {
      id
      active
      blocked
    }
  }
`;
export type UnblockMemberMutationMutationFn = Apollo.MutationFunction<
  UnblockMemberMutation,
  UnblockMemberMutationVariables
>;

/**
 * __useUnblockMemberMutation__
 *
 * To run a mutation, you first call `useUnblockMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockMemberMutation, { data, loading, error }] = useUnblockMemberMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useUnblockMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnblockMemberMutation,
    UnblockMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnblockMemberMutation,
    UnblockMemberMutationVariables
  >(UnblockMemberMutationDocument, options);
}
export type UnblockMemberMutationHookResult = ReturnType<
  typeof useUnblockMemberMutation
>;
export type UnblockMemberMutationMutationResult =
  Apollo.MutationResult<UnblockMemberMutation>;
export type UnblockMemberMutationMutationOptions = Apollo.BaseMutationOptions<
  UnblockMemberMutation,
  UnblockMemberMutationVariables
>;
export const BlockedMemberListQueryDocument = gql`
  query BlockedMemberListQuery(
    $classroomId: String!
    $cursor: String
    $limit: Float
  ) {
    membersCollection: listClassroomBlockedMembers(
      classroomId: $classroomId
      cursor: $cursor
      limit: $limit
    ) {
      members {
        ...MemberItemMemberFields
      }
      cursor
    }
  }
  ${MemberItemMemberFieldsFragmentDoc}
`;

/**
 * __useBlockedMemberListQuery__
 *
 * To run a query within a React component, call `useBlockedMemberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockedMemberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockedMemberListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBlockedMemberListQuery(
  baseOptions: Apollo.QueryHookOptions<
    BlockedMemberListQuery,
    BlockedMemberListQueryVariables
  > &
    (
      | { variables: BlockedMemberListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BlockedMemberListQuery,
    BlockedMemberListQueryVariables
  >(BlockedMemberListQueryDocument, options);
}
export function useBlockedMemberListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BlockedMemberListQuery,
    BlockedMemberListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BlockedMemberListQuery,
    BlockedMemberListQueryVariables
  >(BlockedMemberListQueryDocument, options);
}
export function useBlockedMemberListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BlockedMemberListQuery,
        BlockedMemberListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BlockedMemberListQuery,
    BlockedMemberListQueryVariables
  >(BlockedMemberListQueryDocument, options);
}
export type BlockedMemberListQueryHookResult = ReturnType<
  typeof useBlockedMemberListQuery
>;
export type BlockedMemberListQueryLazyQueryHookResult = ReturnType<
  typeof useBlockedMemberListQueryLazyQuery
>;
export type BlockedMemberListQuerySuspenseQueryHookResult = ReturnType<
  typeof useBlockedMemberListQuerySuspenseQuery
>;
export type BlockedMemberListQueryQueryResult = Apollo.QueryResult<
  BlockedMemberListQuery,
  BlockedMemberListQueryVariables
>;
export const ClassroomArchiveBannerQueryDocument = gql`
  query ClassroomArchiveBannerQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      archived
    }
  }
`;

/**
 * __useClassroomArchiveBannerQuery__
 *
 * To run a query within a React component, call `useClassroomArchiveBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomArchiveBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomArchiveBannerQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassroomArchiveBannerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomArchiveBannerQuery,
    ClassroomArchiveBannerQueryVariables
  > &
    (
      | { variables: ClassroomArchiveBannerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassroomArchiveBannerQuery,
    ClassroomArchiveBannerQueryVariables
  >(ClassroomArchiveBannerQueryDocument, options);
}
export function useClassroomArchiveBannerQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomArchiveBannerQuery,
    ClassroomArchiveBannerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomArchiveBannerQuery,
    ClassroomArchiveBannerQueryVariables
  >(ClassroomArchiveBannerQueryDocument, options);
}
export function useClassroomArchiveBannerQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomArchiveBannerQuery,
        ClassroomArchiveBannerQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomArchiveBannerQuery,
    ClassroomArchiveBannerQueryVariables
  >(ClassroomArchiveBannerQueryDocument, options);
}
export type ClassroomArchiveBannerQueryHookResult = ReturnType<
  typeof useClassroomArchiveBannerQuery
>;
export type ClassroomArchiveBannerQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomArchiveBannerQueryLazyQuery
>;
export type ClassroomArchiveBannerQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomArchiveBannerQuerySuspenseQuery
>;
export type ClassroomArchiveBannerQueryQueryResult = Apollo.QueryResult<
  ClassroomArchiveBannerQuery,
  ClassroomArchiveBannerQueryVariables
>;
export const CreateClassroomWizardQueryDocument = gql`
  query CreateClassroomWizardQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      provisioningStatus
    }
  }
`;

/**
 * __useCreateClassroomWizardQuery__
 *
 * To run a query within a React component, call `useCreateClassroomWizardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateClassroomWizardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateClassroomWizardQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useCreateClassroomWizardQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreateClassroomWizardQuery,
    CreateClassroomWizardQueryVariables
  > &
    (
      | { variables: CreateClassroomWizardQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CreateClassroomWizardQuery,
    CreateClassroomWizardQueryVariables
  >(CreateClassroomWizardQueryDocument, options);
}
export function useCreateClassroomWizardQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreateClassroomWizardQuery,
    CreateClassroomWizardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CreateClassroomWizardQuery,
    CreateClassroomWizardQueryVariables
  >(CreateClassroomWizardQueryDocument, options);
}
export function useCreateClassroomWizardQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreateClassroomWizardQuery,
        CreateClassroomWizardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CreateClassroomWizardQuery,
    CreateClassroomWizardQueryVariables
  >(CreateClassroomWizardQueryDocument, options);
}
export type CreateClassroomWizardQueryHookResult = ReturnType<
  typeof useCreateClassroomWizardQuery
>;
export type CreateClassroomWizardQueryLazyQueryHookResult = ReturnType<
  typeof useCreateClassroomWizardQueryLazyQuery
>;
export type CreateClassroomWizardQuerySuspenseQueryHookResult = ReturnType<
  typeof useCreateClassroomWizardQuerySuspenseQuery
>;
export type CreateClassroomWizardQueryQueryResult = Apollo.QueryResult<
  CreateClassroomWizardQuery,
  CreateClassroomWizardQueryVariables
>;
export const SelectBelongedOrganizationQueryDocument = gql`
  query SelectBelongedOrganizationQuery {
    me: getMe {
      id
      name
      schoolInfo {
        school {
          id
        }
      }
    }
  }
`;

/**
 * __useSelectBelongedOrganizationQuery__
 *
 * To run a query within a React component, call `useSelectBelongedOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectBelongedOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectBelongedOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectBelongedOrganizationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SelectBelongedOrganizationQuery,
    SelectBelongedOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SelectBelongedOrganizationQuery,
    SelectBelongedOrganizationQueryVariables
  >(SelectBelongedOrganizationQueryDocument, options);
}
export function useSelectBelongedOrganizationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SelectBelongedOrganizationQuery,
    SelectBelongedOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SelectBelongedOrganizationQuery,
    SelectBelongedOrganizationQueryVariables
  >(SelectBelongedOrganizationQueryDocument, options);
}
export function useSelectBelongedOrganizationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SelectBelongedOrganizationQuery,
        SelectBelongedOrganizationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SelectBelongedOrganizationQuery,
    SelectBelongedOrganizationQueryVariables
  >(SelectBelongedOrganizationQueryDocument, options);
}
export type SelectBelongedOrganizationQueryHookResult = ReturnType<
  typeof useSelectBelongedOrganizationQuery
>;
export type SelectBelongedOrganizationQueryLazyQueryHookResult = ReturnType<
  typeof useSelectBelongedOrganizationQueryLazyQuery
>;
export type SelectBelongedOrganizationQuerySuspenseQueryHookResult = ReturnType<
  typeof useSelectBelongedOrganizationQuerySuspenseQuery
>;
export type SelectBelongedOrganizationQueryQueryResult = Apollo.QueryResult<
  SelectBelongedOrganizationQuery,
  SelectBelongedOrganizationQueryVariables
>;
export const SelectBelongedOrganizationOrganizationQueryDocument = gql`
  query SelectBelongedOrganizationOrganizationQuery($organizationId: String!) {
    organization: organizationOrganization(organizationId: $organizationId) {
      ...SelectBelongedOrganizationOrganizationDtoFields
    }
  }
  ${SelectBelongedOrganizationOrganizationDtoFieldsFragmentDoc}
`;

/**
 * __useSelectBelongedOrganizationOrganizationQuery__
 *
 * To run a query within a React component, call `useSelectBelongedOrganizationOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectBelongedOrganizationOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectBelongedOrganizationOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSelectBelongedOrganizationOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    SelectBelongedOrganizationOrganizationQuery,
    SelectBelongedOrganizationOrganizationQueryVariables
  > &
    (
      | {
          variables: SelectBelongedOrganizationOrganizationQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SelectBelongedOrganizationOrganizationQuery,
    SelectBelongedOrganizationOrganizationQueryVariables
  >(SelectBelongedOrganizationOrganizationQueryDocument, options);
}
export function useSelectBelongedOrganizationOrganizationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SelectBelongedOrganizationOrganizationQuery,
    SelectBelongedOrganizationOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SelectBelongedOrganizationOrganizationQuery,
    SelectBelongedOrganizationOrganizationQueryVariables
  >(SelectBelongedOrganizationOrganizationQueryDocument, options);
}
export function useSelectBelongedOrganizationOrganizationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SelectBelongedOrganizationOrganizationQuery,
        SelectBelongedOrganizationOrganizationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SelectBelongedOrganizationOrganizationQuery,
    SelectBelongedOrganizationOrganizationQueryVariables
  >(SelectBelongedOrganizationOrganizationQueryDocument, options);
}
export type SelectBelongedOrganizationOrganizationQueryHookResult = ReturnType<
  typeof useSelectBelongedOrganizationOrganizationQuery
>;
export type SelectBelongedOrganizationOrganizationQueryLazyQueryHookResult =
  ReturnType<typeof useSelectBelongedOrganizationOrganizationQueryLazyQuery>;
export type SelectBelongedOrganizationOrganizationQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useSelectBelongedOrganizationOrganizationQuerySuspenseQuery
  >;
export type SelectBelongedOrganizationOrganizationQueryQueryResult =
  Apollo.QueryResult<
    SelectBelongedOrganizationOrganizationQuery,
    SelectBelongedOrganizationOrganizationQueryVariables
  >;
export const DeactivateMyselfMutationDocument = gql`
  mutation DeactivateMyselfMutation($classroomId: String!, $memberId: String!) {
    member: deactivateClassroomMember(
      classroomId: $classroomId
      memberId: $memberId
    ) {
      id
      active
    }
  }
`;
export type DeactivateMyselfMutationMutationFn = Apollo.MutationFunction<
  DeactivateMyselfMutation,
  DeactivateMyselfMutationVariables
>;

/**
 * __useDeactivateMyselfMutation__
 *
 * To run a mutation, you first call `useDeactivateMyselfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateMyselfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateMyselfMutation, { data, loading, error }] = useDeactivateMyselfMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useDeactivateMyselfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateMyselfMutation,
    DeactivateMyselfMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeactivateMyselfMutation,
    DeactivateMyselfMutationVariables
  >(DeactivateMyselfMutationDocument, options);
}
export type DeactivateMyselfMutationHookResult = ReturnType<
  typeof useDeactivateMyselfMutation
>;
export type DeactivateMyselfMutationMutationResult =
  Apollo.MutationResult<DeactivateMyselfMutation>;
export type DeactivateMyselfMutationMutationOptions =
  Apollo.BaseMutationOptions<
    DeactivateMyselfMutation,
    DeactivateMyselfMutationVariables
  >;
export const DeactivateMyselfQueryDocument = gql`
  query DeactivateMyselfQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      ...DeactivateMyselfMemberFields
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      type
      name
    }
  }
  ${DeactivateMyselfMemberFieldsFragmentDoc}
`;

/**
 * __useDeactivateMyselfQuery__
 *
 * To run a query within a React component, call `useDeactivateMyselfQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeactivateMyselfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeactivateMyselfQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useDeactivateMyselfQuery(
  baseOptions: Apollo.QueryHookOptions<
    DeactivateMyselfQuery,
    DeactivateMyselfQueryVariables
  > &
    (
      | { variables: DeactivateMyselfQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DeactivateMyselfQuery, DeactivateMyselfQueryVariables>(
    DeactivateMyselfQueryDocument,
    options
  );
}
export function useDeactivateMyselfQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeactivateMyselfQuery,
    DeactivateMyselfQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DeactivateMyselfQuery,
    DeactivateMyselfQueryVariables
  >(DeactivateMyselfQueryDocument, options);
}
export function useDeactivateMyselfQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeactivateMyselfQuery,
        DeactivateMyselfQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DeactivateMyselfQuery,
    DeactivateMyselfQueryVariables
  >(DeactivateMyselfQueryDocument, options);
}
export type DeactivateMyselfQueryHookResult = ReturnType<
  typeof useDeactivateMyselfQuery
>;
export type DeactivateMyselfQueryLazyQueryHookResult = ReturnType<
  typeof useDeactivateMyselfQueryLazyQuery
>;
export type DeactivateMyselfQuerySuspenseQueryHookResult = ReturnType<
  typeof useDeactivateMyselfQuerySuspenseQuery
>;
export type DeactivateMyselfQueryQueryResult = Apollo.QueryResult<
  DeactivateMyselfQuery,
  DeactivateMyselfQueryVariables
>;
export const DeleteClassroomMutationDocument = gql`
  mutation DeleteClassroomMutation($classroomId: String!) {
    deleteClassroom(classroomId: $classroomId)
  }
`;
export type DeleteClassroomMutationMutationFn = Apollo.MutationFunction<
  DeleteClassroomMutation,
  DeleteClassroomMutationVariables
>;

/**
 * __useDeleteClassroomMutation__
 *
 * To run a mutation, you first call `useDeleteClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassroomMutation, { data, loading, error }] = useDeleteClassroomMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useDeleteClassroomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClassroomMutation,
    DeleteClassroomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteClassroomMutation,
    DeleteClassroomMutationVariables
  >(DeleteClassroomMutationDocument, options);
}
export type DeleteClassroomMutationHookResult = ReturnType<
  typeof useDeleteClassroomMutation
>;
export type DeleteClassroomMutationMutationResult =
  Apollo.MutationResult<DeleteClassroomMutation>;
export type DeleteClassroomMutationMutationOptions = Apollo.BaseMutationOptions<
  DeleteClassroomMutation,
  DeleteClassroomMutationVariables
>;
export const HideOnboardingChecklistMutationDocument = gql`
  mutation HideOnboardingChecklistMutation($classroomId: String!) {
    hideOnboardingChecklist(classroomId: $classroomId) {
      id
      isActive
    }
  }
`;
export type HideOnboardingChecklistMutationMutationFn = Apollo.MutationFunction<
  HideOnboardingChecklistMutation,
  HideOnboardingChecklistMutationVariables
>;

/**
 * __useHideOnboardingChecklistMutation__
 *
 * To run a mutation, you first call `useHideOnboardingChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideOnboardingChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideOnboardingChecklistMutation, { data, loading, error }] = useHideOnboardingChecklistMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useHideOnboardingChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HideOnboardingChecklistMutation,
    HideOnboardingChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HideOnboardingChecklistMutation,
    HideOnboardingChecklistMutationVariables
  >(HideOnboardingChecklistMutationDocument, options);
}
export type HideOnboardingChecklistMutationHookResult = ReturnType<
  typeof useHideOnboardingChecklistMutation
>;
export type HideOnboardingChecklistMutationMutationResult =
  Apollo.MutationResult<HideOnboardingChecklistMutation>;
export type HideOnboardingChecklistMutationMutationOptions =
  Apollo.BaseMutationOptions<
    HideOnboardingChecklistMutation,
    HideOnboardingChecklistMutationVariables
  >;
export const HomePageHeaderQueryDocument = gql`
  query HomePageHeaderQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
      about
      profileImageUrl
      archived
      schoolName
    }
  }
`;

/**
 * __useHomePageHeaderQuery__
 *
 * To run a query within a React component, call `useHomePageHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageHeaderQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useHomePageHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomePageHeaderQuery,
    HomePageHeaderQueryVariables
  > &
    (
      | { variables: HomePageHeaderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HomePageHeaderQuery, HomePageHeaderQueryVariables>(
    HomePageHeaderQueryDocument,
    options
  );
}
export function useHomePageHeaderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomePageHeaderQuery,
    HomePageHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HomePageHeaderQuery, HomePageHeaderQueryVariables>(
    HomePageHeaderQueryDocument,
    options
  );
}
export function useHomePageHeaderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomePageHeaderQuery,
        HomePageHeaderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HomePageHeaderQuery,
    HomePageHeaderQueryVariables
  >(HomePageHeaderQueryDocument, options);
}
export type HomePageHeaderQueryHookResult = ReturnType<
  typeof useHomePageHeaderQuery
>;
export type HomePageHeaderQueryLazyQueryHookResult = ReturnType<
  typeof useHomePageHeaderQueryLazyQuery
>;
export type HomePageHeaderQuerySuspenseQueryHookResult = ReturnType<
  typeof useHomePageHeaderQuerySuspenseQuery
>;
export type HomePageHeaderQueryQueryResult = Apollo.QueryResult<
  HomePageHeaderQuery,
  HomePageHeaderQueryVariables
>;
export const ReissueClassCodeMutationDocument = gql`
  mutation ReissueClassCodeMutation($classroomId: String!) {
    recreateClassroomClassCode(classroomId: $classroomId) {
      code
      classroomId
      expiresAt
    }
  }
`;
export type ReissueClassCodeMutationMutationFn = Apollo.MutationFunction<
  ReissueClassCodeMutation,
  ReissueClassCodeMutationVariables
>;

/**
 * __useReissueClassCodeMutation__
 *
 * To run a mutation, you first call `useReissueClassCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReissueClassCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reissueClassCodeMutation, { data, loading, error }] = useReissueClassCodeMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useReissueClassCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReissueClassCodeMutation,
    ReissueClassCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReissueClassCodeMutation,
    ReissueClassCodeMutationVariables
  >(ReissueClassCodeMutationDocument, options);
}
export type ReissueClassCodeMutationHookResult = ReturnType<
  typeof useReissueClassCodeMutation
>;
export type ReissueClassCodeMutationMutationResult =
  Apollo.MutationResult<ReissueClassCodeMutation>;
export type ReissueClassCodeMutationMutationOptions =
  Apollo.BaseMutationOptions<
    ReissueClassCodeMutation,
    ReissueClassCodeMutationVariables
  >;
export const InvitationByClassCodeClassroomQueryDocument = gql`
  query InvitationByClassCodeClassroomQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      grade
      id
      name
      schoolName
    }
  }
`;

/**
 * __useInvitationByClassCodeClassroomQuery__
 *
 * To run a query within a React component, call `useInvitationByClassCodeClassroomQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationByClassCodeClassroomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationByClassCodeClassroomQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useInvitationByClassCodeClassroomQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvitationByClassCodeClassroomQuery,
    InvitationByClassCodeClassroomQueryVariables
  > &
    (
      | {
          variables: InvitationByClassCodeClassroomQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InvitationByClassCodeClassroomQuery,
    InvitationByClassCodeClassroomQueryVariables
  >(InvitationByClassCodeClassroomQueryDocument, options);
}
export function useInvitationByClassCodeClassroomQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvitationByClassCodeClassroomQuery,
    InvitationByClassCodeClassroomQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InvitationByClassCodeClassroomQuery,
    InvitationByClassCodeClassroomQueryVariables
  >(InvitationByClassCodeClassroomQueryDocument, options);
}
export function useInvitationByClassCodeClassroomQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvitationByClassCodeClassroomQuery,
        InvitationByClassCodeClassroomQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InvitationByClassCodeClassroomQuery,
    InvitationByClassCodeClassroomQueryVariables
  >(InvitationByClassCodeClassroomQueryDocument, options);
}
export type InvitationByClassCodeClassroomQueryHookResult = ReturnType<
  typeof useInvitationByClassCodeClassroomQuery
>;
export type InvitationByClassCodeClassroomQueryLazyQueryHookResult = ReturnType<
  typeof useInvitationByClassCodeClassroomQueryLazyQuery
>;
export type InvitationByClassCodeClassroomQuerySuspenseQueryHookResult =
  ReturnType<typeof useInvitationByClassCodeClassroomQuerySuspenseQuery>;
export type InvitationByClassCodeClassroomQueryQueryResult = Apollo.QueryResult<
  InvitationByClassCodeClassroomQuery,
  InvitationByClassCodeClassroomQueryVariables
>;
export const InvitationByClassCodeQueryDocument = gql`
  query InvitationByClassCodeQuery($classroomId: String!) {
    classCode: getClassroomClassCode(id: $classroomId) {
      classroomId
      code
      expiresAt
      enterprise {
        slug
      }
    }
  }
`;

/**
 * __useInvitationByClassCodeQuery__
 *
 * To run a query within a React component, call `useInvitationByClassCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationByClassCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationByClassCodeQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useInvitationByClassCodeQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvitationByClassCodeQuery,
    InvitationByClassCodeQueryVariables
  > &
    (
      | { variables: InvitationByClassCodeQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InvitationByClassCodeQuery,
    InvitationByClassCodeQueryVariables
  >(InvitationByClassCodeQueryDocument, options);
}
export function useInvitationByClassCodeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvitationByClassCodeQuery,
    InvitationByClassCodeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InvitationByClassCodeQuery,
    InvitationByClassCodeQueryVariables
  >(InvitationByClassCodeQueryDocument, options);
}
export function useInvitationByClassCodeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvitationByClassCodeQuery,
        InvitationByClassCodeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InvitationByClassCodeQuery,
    InvitationByClassCodeQueryVariables
  >(InvitationByClassCodeQueryDocument, options);
}
export type InvitationByClassCodeQueryHookResult = ReturnType<
  typeof useInvitationByClassCodeQuery
>;
export type InvitationByClassCodeQueryLazyQueryHookResult = ReturnType<
  typeof useInvitationByClassCodeQueryLazyQuery
>;
export type InvitationByClassCodeQuerySuspenseQueryHookResult = ReturnType<
  typeof useInvitationByClassCodeQuerySuspenseQuery
>;
export type InvitationByClassCodeQueryQueryResult = Apollo.QueryResult<
  InvitationByClassCodeQuery,
  InvitationByClassCodeQueryVariables
>;
export const DeactivateClassroomMemberMutationDocument = gql`
  mutation DeactivateClassroomMemberMutation(
    $classroomId: String!
    $memberId: String!
  ) {
    member: deactivateClassroomMember(
      classroomId: $classroomId
      memberId: $memberId
    ) {
      id
      active
    }
  }
`;
export type DeactivateClassroomMemberMutationMutationFn =
  Apollo.MutationFunction<
    DeactivateClassroomMemberMutation,
    DeactivateClassroomMemberMutationVariables
  >;

/**
 * __useDeactivateClassroomMemberMutation__
 *
 * To run a mutation, you first call `useDeactivateClassroomMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateClassroomMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateClassroomMemberMutation, { data, loading, error }] = useDeactivateClassroomMemberMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useDeactivateClassroomMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateClassroomMemberMutation,
    DeactivateClassroomMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeactivateClassroomMemberMutation,
    DeactivateClassroomMemberMutationVariables
  >(DeactivateClassroomMemberMutationDocument, options);
}
export type DeactivateClassroomMemberMutationHookResult = ReturnType<
  typeof useDeactivateClassroomMemberMutation
>;
export type DeactivateClassroomMemberMutationMutationResult =
  Apollo.MutationResult<DeactivateClassroomMemberMutation>;
export type DeactivateClassroomMemberMutationMutationOptions =
  Apollo.BaseMutationOptions<
    DeactivateClassroomMemberMutation,
    DeactivateClassroomMemberMutationVariables
  >;
export const BlockClassroomMemberMutationDocument = gql`
  mutation BlockClassroomMemberMutation(
    $classroomId: String!
    $memberId: String!
  ) {
    member: blockMember(classroomId: $classroomId, memberId: $memberId) {
      id
      blocked
    }
  }
`;
export type BlockClassroomMemberMutationMutationFn = Apollo.MutationFunction<
  BlockClassroomMemberMutation,
  BlockClassroomMemberMutationVariables
>;

/**
 * __useBlockClassroomMemberMutation__
 *
 * To run a mutation, you first call `useBlockClassroomMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockClassroomMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockClassroomMemberMutation, { data, loading, error }] = useBlockClassroomMemberMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useBlockClassroomMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BlockClassroomMemberMutation,
    BlockClassroomMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BlockClassroomMemberMutation,
    BlockClassroomMemberMutationVariables
  >(BlockClassroomMemberMutationDocument, options);
}
export type BlockClassroomMemberMutationHookResult = ReturnType<
  typeof useBlockClassroomMemberMutation
>;
export type BlockClassroomMemberMutationMutationResult =
  Apollo.MutationResult<BlockClassroomMemberMutation>;
export type BlockClassroomMemberMutationMutationOptions =
  Apollo.BaseMutationOptions<
    BlockClassroomMemberMutation,
    BlockClassroomMemberMutationVariables
  >;
export const MemberListQueryDocument = gql`
  query MemberListQuery(
    $classroomId: String!
    $cursor: String
    $limit: Float
    $groups: String
  ) {
    membersCollection: listClassroomMembers(
      classroomId: $classroomId
      cursor: $cursor
      limit: $limit
      groups: $groups
    ) {
      members {
        ...MemberItemMemberFields
      }
      cursor
    }
  }
  ${MemberItemMemberFieldsFragmentDoc}
`;

/**
 * __useMemberListQuery__
 *
 * To run a query within a React component, call `useMemberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useMemberListQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberListQuery,
    MemberListQueryVariables
  > &
    (
      | { variables: MemberListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemberListQuery, MemberListQueryVariables>(
    MemberListQueryDocument,
    options
  );
}
export function useMemberListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberListQuery,
    MemberListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberListQuery, MemberListQueryVariables>(
    MemberListQueryDocument,
    options
  );
}
export function useMemberListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemberListQuery, MemberListQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MemberListQuery, MemberListQueryVariables>(
    MemberListQueryDocument,
    options
  );
}
export type MemberListQueryHookResult = ReturnType<typeof useMemberListQuery>;
export type MemberListQueryLazyQueryHookResult = ReturnType<
  typeof useMemberListQueryLazyQuery
>;
export type MemberListQuerySuspenseQueryHookResult = ReturnType<
  typeof useMemberListQuerySuspenseQuery
>;
export type MemberListQueryQueryResult = Apollo.QueryResult<
  MemberListQuery,
  MemberListQueryVariables
>;
export const MemberItemQueryDocument = gql`
  query MemberItemQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useMemberItemQuery__
 *
 * To run a query within a React component, call `useMemberItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberItemQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useMemberItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberItemQuery,
    MemberItemQueryVariables
  > &
    (
      | { variables: MemberItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemberItemQuery, MemberItemQueryVariables>(
    MemberItemQueryDocument,
    options
  );
}
export function useMemberItemQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberItemQuery,
    MemberItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberItemQuery, MemberItemQueryVariables>(
    MemberItemQueryDocument,
    options
  );
}
export function useMemberItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemberItemQuery, MemberItemQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MemberItemQuery, MemberItemQueryVariables>(
    MemberItemQueryDocument,
    options
  );
}
export type MemberItemQueryHookResult = ReturnType<typeof useMemberItemQuery>;
export type MemberItemQueryLazyQueryHookResult = ReturnType<
  typeof useMemberItemQueryLazyQuery
>;
export type MemberItemQuerySuspenseQueryHookResult = ReturnType<
  typeof useMemberItemQuerySuspenseQuery
>;
export type MemberItemQueryQueryResult = Apollo.QueryResult<
  MemberItemQuery,
  MemberItemQueryVariables
>;
export const AssignMemberRoleMutationDocument = gql`
  mutation AssignMemberRoleMutation(
    $classroomId: String!
    $memberId: String!
    $assignMemberRoleDtoInput: AssignMemberRoleDtoInput!
  ) {
    member: assignMemberRole(
      classroomId: $classroomId
      memberId: $memberId
      assignMemberRoleDtoInput: $assignMemberRoleDtoInput
    ) {
      id
      role
    }
  }
`;
export type AssignMemberRoleMutationMutationFn = Apollo.MutationFunction<
  AssignMemberRoleMutation,
  AssignMemberRoleMutationVariables
>;

/**
 * __useAssignMemberRoleMutation__
 *
 * To run a mutation, you first call `useAssignMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMemberRoleMutation, { data, loading, error }] = useAssignMemberRoleMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *      assignMemberRoleDtoInput: // value for 'assignMemberRoleDtoInput'
 *   },
 * });
 */
export function useAssignMemberRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignMemberRoleMutation,
    AssignMemberRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignMemberRoleMutation,
    AssignMemberRoleMutationVariables
  >(AssignMemberRoleMutationDocument, options);
}
export type AssignMemberRoleMutationHookResult = ReturnType<
  typeof useAssignMemberRoleMutation
>;
export type AssignMemberRoleMutationMutationResult =
  Apollo.MutationResult<AssignMemberRoleMutation>;
export type AssignMemberRoleMutationMutationOptions =
  Apollo.BaseMutationOptions<
    AssignMemberRoleMutation,
    AssignMemberRoleMutationVariables
  >;
export const NavigationMenuQueryDocument = gql`
  query NavigationMenuQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
      group
    }
    me: getMe {
      id
      language
    }
    checklist: getOnboardingChecklist(classroomId: $classroomId) {
      id
      ...SideMenuCheckListFields
    }
  }
  ${SideMenuCheckListFieldsFragmentDoc}
`;

/**
 * __useNavigationMenuQuery__
 *
 * To run a query within a React component, call `useNavigationMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationMenuQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useNavigationMenuQuery(
  baseOptions: Apollo.QueryHookOptions<
    NavigationMenuQuery,
    NavigationMenuQueryVariables
  > &
    (
      | { variables: NavigationMenuQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NavigationMenuQuery, NavigationMenuQueryVariables>(
    NavigationMenuQueryDocument,
    options
  );
}
export function useNavigationMenuQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NavigationMenuQuery,
    NavigationMenuQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NavigationMenuQuery, NavigationMenuQueryVariables>(
    NavigationMenuQueryDocument,
    options
  );
}
export function useNavigationMenuQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NavigationMenuQuery,
        NavigationMenuQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NavigationMenuQuery,
    NavigationMenuQueryVariables
  >(NavigationMenuQueryDocument, options);
}
export type NavigationMenuQueryHookResult = ReturnType<
  typeof useNavigationMenuQuery
>;
export type NavigationMenuQueryLazyQueryHookResult = ReturnType<
  typeof useNavigationMenuQueryLazyQuery
>;
export type NavigationMenuQuerySuspenseQueryHookResult = ReturnType<
  typeof useNavigationMenuQuerySuspenseQuery
>;
export type NavigationMenuQueryQueryResult = Apollo.QueryResult<
  NavigationMenuQuery,
  NavigationMenuQueryVariables
>;
export const NavigationMenuCommonChannelsQueryDocument = gql`
  query NavigationMenuCommonChannelsQuery($classroomId: String!) {
    commonChannels: listCommonChannels(classroomId: $classroomId) {
      id
      name
      iconUrl
    }
  }
`;

/**
 * __useNavigationMenuCommonChannelsQuery__
 *
 * To run a query within a React component, call `useNavigationMenuCommonChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationMenuCommonChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationMenuCommonChannelsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useNavigationMenuCommonChannelsQuery(
  baseOptions: Apollo.QueryHookOptions<
    NavigationMenuCommonChannelsQuery,
    NavigationMenuCommonChannelsQueryVariables
  > &
    (
      | {
          variables: NavigationMenuCommonChannelsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NavigationMenuCommonChannelsQuery,
    NavigationMenuCommonChannelsQueryVariables
  >(NavigationMenuCommonChannelsQueryDocument, options);
}
export function useNavigationMenuCommonChannelsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NavigationMenuCommonChannelsQuery,
    NavigationMenuCommonChannelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NavigationMenuCommonChannelsQuery,
    NavigationMenuCommonChannelsQueryVariables
  >(NavigationMenuCommonChannelsQueryDocument, options);
}
export function useNavigationMenuCommonChannelsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NavigationMenuCommonChannelsQuery,
        NavigationMenuCommonChannelsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NavigationMenuCommonChannelsQuery,
    NavigationMenuCommonChannelsQueryVariables
  >(NavigationMenuCommonChannelsQueryDocument, options);
}
export type NavigationMenuCommonChannelsQueryHookResult = ReturnType<
  typeof useNavigationMenuCommonChannelsQuery
>;
export type NavigationMenuCommonChannelsQueryLazyQueryHookResult = ReturnType<
  typeof useNavigationMenuCommonChannelsQueryLazyQuery
>;
export type NavigationMenuCommonChannelsQuerySuspenseQueryHookResult =
  ReturnType<typeof useNavigationMenuCommonChannelsQuerySuspenseQuery>;
export type NavigationMenuCommonChannelsQueryQueryResult = Apollo.QueryResult<
  NavigationMenuCommonChannelsQuery,
  NavigationMenuCommonChannelsQueryVariables
>;
export const CompleteVisitAiTestPageChecklistMutationDocument = gql`
  mutation CompleteVisitAiTestPageChecklistMutation($classroomId: String!) {
    completeOnboardingChecklistAction(
      classroomId: $classroomId
      completeOnboardingChecklistActionDtoInput: {
        action: "distribute-ai-test"
      }
    ) {
      id
      availableActions
      isComplete
      progress
    }
  }
`;
export type CompleteVisitAiTestPageChecklistMutationMutationFn =
  Apollo.MutationFunction<
    CompleteVisitAiTestPageChecklistMutation,
    CompleteVisitAiTestPageChecklistMutationVariables
  >;

/**
 * __useCompleteVisitAiTestPageChecklistMutation__
 *
 * To run a mutation, you first call `useCompleteVisitAiTestPageChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteVisitAiTestPageChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeVisitAiTestPageChecklistMutation, { data, loading, error }] = useCompleteVisitAiTestPageChecklistMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useCompleteVisitAiTestPageChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteVisitAiTestPageChecklistMutation,
    CompleteVisitAiTestPageChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteVisitAiTestPageChecklistMutation,
    CompleteVisitAiTestPageChecklistMutationVariables
  >(CompleteVisitAiTestPageChecklistMutationDocument, options);
}
export type CompleteVisitAiTestPageChecklistMutationHookResult = ReturnType<
  typeof useCompleteVisitAiTestPageChecklistMutation
>;
export type CompleteVisitAiTestPageChecklistMutationMutationResult =
  Apollo.MutationResult<CompleteVisitAiTestPageChecklistMutation>;
export type CompleteVisitAiTestPageChecklistMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteVisitAiTestPageChecklistMutation,
    CompleteVisitAiTestPageChecklistMutationVariables
  >;
export const CompleteVisitProductTourPageChecklistMutationDocument = gql`
  mutation CompleteVisitProductTourPageChecklistMutation(
    $classroomId: String!
  ) {
    completeOnboardingChecklistAction(
      classroomId: $classroomId
      completeOnboardingChecklistActionDtoInput: {
        action: "visit-product-tour-page"
      }
    ) {
      id
      availableActions
      isComplete
      progress
    }
  }
`;
export type CompleteVisitProductTourPageChecklistMutationMutationFn =
  Apollo.MutationFunction<
    CompleteVisitProductTourPageChecklistMutation,
    CompleteVisitProductTourPageChecklistMutationVariables
  >;

/**
 * __useCompleteVisitProductTourPageChecklistMutation__
 *
 * To run a mutation, you first call `useCompleteVisitProductTourPageChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteVisitProductTourPageChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeVisitProductTourPageChecklistMutation, { data, loading, error }] = useCompleteVisitProductTourPageChecklistMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useCompleteVisitProductTourPageChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteVisitProductTourPageChecklistMutation,
    CompleteVisitProductTourPageChecklistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteVisitProductTourPageChecklistMutation,
    CompleteVisitProductTourPageChecklistMutationVariables
  >(CompleteVisitProductTourPageChecklistMutationDocument, options);
}
export type CompleteVisitProductTourPageChecklistMutationHookResult =
  ReturnType<typeof useCompleteVisitProductTourPageChecklistMutation>;
export type CompleteVisitProductTourPageChecklistMutationMutationResult =
  Apollo.MutationResult<CompleteVisitProductTourPageChecklistMutation>;
export type CompleteVisitProductTourPageChecklistMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteVisitProductTourPageChecklistMutation,
    CompleteVisitProductTourPageChecklistMutationVariables
  >;
export const PostFeedMemberListQueryDocument = gql`
  query PostFeedMemberListQuery(
    $classroomId: String!
    $limit: Float
    $groups: String
  ) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      membersCount
    }
    membersCollection: listClassroomMembers(
      classroomId: $classroomId
      limit: $limit
      groups: $groups
    ) {
      members {
        ...MemberItemMemberFields
      }
    }
  }
  ${MemberItemMemberFieldsFragmentDoc}
`;

/**
 * __usePostFeedMemberListQuery__
 *
 * To run a query within a React component, call `usePostFeedMemberListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedMemberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedMemberListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      limit: // value for 'limit'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function usePostFeedMemberListQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedMemberListQuery,
    PostFeedMemberListQueryVariables
  > &
    (
      | { variables: PostFeedMemberListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedMemberListQuery,
    PostFeedMemberListQueryVariables
  >(PostFeedMemberListQueryDocument, options);
}
export function usePostFeedMemberListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedMemberListQuery,
    PostFeedMemberListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedMemberListQuery,
    PostFeedMemberListQueryVariables
  >(PostFeedMemberListQueryDocument, options);
}
export function usePostFeedMemberListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedMemberListQuery,
        PostFeedMemberListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedMemberListQuery,
    PostFeedMemberListQueryVariables
  >(PostFeedMemberListQueryDocument, options);
}
export type PostFeedMemberListQueryHookResult = ReturnType<
  typeof usePostFeedMemberListQuery
>;
export type PostFeedMemberListQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedMemberListQueryLazyQuery
>;
export type PostFeedMemberListQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedMemberListQuerySuspenseQuery
>;
export type PostFeedMemberListQueryQueryResult = Apollo.QueryResult<
  PostFeedMemberListQuery,
  PostFeedMemberListQueryVariables
>;
export const UpdatePushNotificationSettingsMutationDocument = gql`
  mutation UpdatePushNotificationSettingsMutation(
    $classroomId: String!
    $dto: UpdateMemberPushNotificationSettingsDtoInput!
  ) {
    result: updateMemberPushNotificationSettings(
      classroomId: $classroomId
      updateMemberPushNotificationSettingsDtoInput: $dto
    ) {
      id
      pushNotificationSettings {
        commentsAndRepliesEnabled
        reactionsEnabled
        postsEnabled
        announcementsEnabled
      }
    }
  }
`;
export type UpdatePushNotificationSettingsMutationMutationFn =
  Apollo.MutationFunction<
    UpdatePushNotificationSettingsMutation,
    UpdatePushNotificationSettingsMutationVariables
  >;

/**
 * __useUpdatePushNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePushNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePushNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePushNotificationSettingsMutation, { data, loading, error }] = useUpdatePushNotificationSettingsMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdatePushNotificationSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePushNotificationSettingsMutation,
    UpdatePushNotificationSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePushNotificationSettingsMutation,
    UpdatePushNotificationSettingsMutationVariables
  >(UpdatePushNotificationSettingsMutationDocument, options);
}
export type UpdatePushNotificationSettingsMutationHookResult = ReturnType<
  typeof useUpdatePushNotificationSettingsMutation
>;
export type UpdatePushNotificationSettingsMutationMutationResult =
  Apollo.MutationResult<UpdatePushNotificationSettingsMutation>;
export type UpdatePushNotificationSettingsMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePushNotificationSettingsMutation,
    UpdatePushNotificationSettingsMutationVariables
  >;
export const PushNotificationSettingsQueryDocument = gql`
  query PushNotificationSettingsQuery($classroomId: String!) {
    result: getMemberPushNotificationSettings(classroomId: $classroomId) {
      id
      pushNotificationSettings {
        commentsAndRepliesEnabled
        reactionsEnabled
        postsEnabled
        announcementsEnabled
      }
    }
  }
`;

/**
 * __usePushNotificationSettingsQuery__
 *
 * To run a query within a React component, call `usePushNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePushNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushNotificationSettingsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function usePushNotificationSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PushNotificationSettingsQuery,
    PushNotificationSettingsQueryVariables
  > &
    (
      | { variables: PushNotificationSettingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PushNotificationSettingsQuery,
    PushNotificationSettingsQueryVariables
  >(PushNotificationSettingsQueryDocument, options);
}
export function usePushNotificationSettingsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PushNotificationSettingsQuery,
    PushNotificationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PushNotificationSettingsQuery,
    PushNotificationSettingsQueryVariables
  >(PushNotificationSettingsQueryDocument, options);
}
export function usePushNotificationSettingsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PushNotificationSettingsQuery,
        PushNotificationSettingsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PushNotificationSettingsQuery,
    PushNotificationSettingsQueryVariables
  >(PushNotificationSettingsQueryDocument, options);
}
export type PushNotificationSettingsQueryHookResult = ReturnType<
  typeof usePushNotificationSettingsQuery
>;
export type PushNotificationSettingsQueryLazyQueryHookResult = ReturnType<
  typeof usePushNotificationSettingsQueryLazyQuery
>;
export type PushNotificationSettingsQuerySuspenseQueryHookResult = ReturnType<
  typeof usePushNotificationSettingsQuerySuspenseQuery
>;
export type PushNotificationSettingsQueryQueryResult = Apollo.QueryResult<
  PushNotificationSettingsQuery,
  PushNotificationSettingsQueryVariables
>;
export const SearchSchoolsQueryDocument = gql`
  query SearchSchoolsQuery($q: String, $page: Float, $perPage: Float) {
    schoolCollection: organizationSearchOrganizations(
      q: $q
      page: $page
      perPage: $perPage
    ) {
      organizations {
        ...SearchSchoolOrganizationDtoFields
      }
    }
  }
  ${SearchSchoolOrganizationDtoFieldsFragmentDoc}
`;

/**
 * __useSearchSchoolsQuery__
 *
 * To run a query within a React component, call `useSearchSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSchoolsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useSearchSchoolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SearchSchoolsQuery,
    SearchSchoolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchSchoolsQuery, SearchSchoolsQueryVariables>(
    SearchSchoolsQueryDocument,
    options
  );
}
export function useSearchSchoolsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchSchoolsQuery,
    SearchSchoolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchSchoolsQuery, SearchSchoolsQueryVariables>(
    SearchSchoolsQueryDocument,
    options
  );
}
export function useSearchSchoolsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchSchoolsQuery,
        SearchSchoolsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchSchoolsQuery,
    SearchSchoolsQueryVariables
  >(SearchSchoolsQueryDocument, options);
}
export type SearchSchoolsQueryHookResult = ReturnType<
  typeof useSearchSchoolsQuery
>;
export type SearchSchoolsQueryLazyQueryHookResult = ReturnType<
  typeof useSearchSchoolsQueryLazyQuery
>;
export type SearchSchoolsQuerySuspenseQueryHookResult = ReturnType<
  typeof useSearchSchoolsQuerySuspenseQuery
>;
export type SearchSchoolsQueryQueryResult = Apollo.QueryResult<
  SearchSchoolsQuery,
  SearchSchoolsQueryVariables
>;
export const HomePageTabQueryDocument = gql`
  query HomePageTabQuery($classroomId: String!) {
    commonChannels: listCommonChannels(classroomId: $classroomId) {
      id
      name
      channelType
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
      group
    }
  }
`;

/**
 * __useHomePageTabQuery__
 *
 * To run a query within a React component, call `useHomePageTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageTabQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useHomePageTabQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomePageTabQuery,
    HomePageTabQueryVariables
  > &
    (
      | { variables: HomePageTabQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HomePageTabQuery, HomePageTabQueryVariables>(
    HomePageTabQueryDocument,
    options
  );
}
export function useHomePageTabQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomePageTabQuery,
    HomePageTabQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HomePageTabQuery, HomePageTabQueryVariables>(
    HomePageTabQueryDocument,
    options
  );
}
export function useHomePageTabQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomePageTabQuery,
        HomePageTabQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HomePageTabQuery, HomePageTabQueryVariables>(
    HomePageTabQueryDocument,
    options
  );
}
export type HomePageTabQueryHookResult = ReturnType<typeof useHomePageTabQuery>;
export type HomePageTabQueryLazyQueryHookResult = ReturnType<
  typeof useHomePageTabQueryLazyQuery
>;
export type HomePageTabQuerySuspenseQueryHookResult = ReturnType<
  typeof useHomePageTabQuerySuspenseQuery
>;
export type HomePageTabQueryQueryResult = Apollo.QueryResult<
  HomePageTabQuery,
  HomePageTabQueryVariables
>;
export const LogoQueryDocument = gql`
  query LogoQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      enterpriseId
    }
  }
`;

/**
 * __useLogoQuery__
 *
 * To run a query within a React component, call `useLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogoQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useLogoQuery(
  baseOptions: Apollo.QueryHookOptions<LogoQuery, LogoQueryVariables> &
    ({ variables: LogoQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogoQuery, LogoQueryVariables>(
    LogoQueryDocument,
    options
  );
}
export function useLogoQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LogoQuery, LogoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LogoQuery, LogoQueryVariables>(
    LogoQueryDocument,
    options
  );
}
export function useLogoQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LogoQuery, LogoQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LogoQuery, LogoQueryVariables>(
    LogoQueryDocument,
    options
  );
}
export type LogoQueryHookResult = ReturnType<typeof useLogoQuery>;
export type LogoQueryLazyQueryHookResult = ReturnType<
  typeof useLogoQueryLazyQuery
>;
export type LogoQuerySuspenseQueryHookResult = ReturnType<
  typeof useLogoQuerySuspenseQuery
>;
export type LogoQueryQueryResult = Apollo.QueryResult<
  LogoQuery,
  LogoQueryVariables
>;
export const LogoEnterpriseQueryDocument = gql`
  query LogoEnterpriseQuery($enterpriseId: String!) {
    enterprise(enterpriseId: $enterpriseId) {
      id
      branding {
        appIconUrl
      }
      homeUrl
      isWhiteLabeled
    }
  }
`;

/**
 * __useLogoEnterpriseQuery__
 *
 * To run a query within a React component, call `useLogoEnterpriseQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoEnterpriseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogoEnterpriseQuery({
 *   variables: {
 *      enterpriseId: // value for 'enterpriseId'
 *   },
 * });
 */
export function useLogoEnterpriseQuery(
  baseOptions: Apollo.QueryHookOptions<
    LogoEnterpriseQuery,
    LogoEnterpriseQueryVariables
  > &
    (
      | { variables: LogoEnterpriseQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogoEnterpriseQuery, LogoEnterpriseQueryVariables>(
    LogoEnterpriseQueryDocument,
    options
  );
}
export function useLogoEnterpriseQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LogoEnterpriseQuery,
    LogoEnterpriseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LogoEnterpriseQuery, LogoEnterpriseQueryVariables>(
    LogoEnterpriseQueryDocument,
    options
  );
}
export function useLogoEnterpriseQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LogoEnterpriseQuery,
        LogoEnterpriseQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LogoEnterpriseQuery,
    LogoEnterpriseQueryVariables
  >(LogoEnterpriseQueryDocument, options);
}
export type LogoEnterpriseQueryHookResult = ReturnType<
  typeof useLogoEnterpriseQuery
>;
export type LogoEnterpriseQueryLazyQueryHookResult = ReturnType<
  typeof useLogoEnterpriseQueryLazyQuery
>;
export type LogoEnterpriseQuerySuspenseQueryHookResult = ReturnType<
  typeof useLogoEnterpriseQuerySuspenseQuery
>;
export type LogoEnterpriseQueryQueryResult = Apollo.QueryResult<
  LogoEnterpriseQuery,
  LogoEnterpriseQueryVariables
>;
export const ClassroomListPageQueryDocument = gql`
  query ClassroomListPageQuery {
    me: getMe {
      id
      role
    }
    managingClassrooms: listClassrooms(role: "admin", limit: 100) {
      classrooms {
        id
        name
        grade
        about
        schoolYear
        createdAt
        updatedAt
      }
      cursor
    }
    joinedClassrooms: listClassrooms(role: "member", limit: 100) {
      classrooms {
        id
        name
        grade
        about
        schoolYear
        createdAt
        updatedAt
      }
      cursor
    }
  }
`;

/**
 * __useClassroomListPageQuery__
 *
 * To run a query within a React component, call `useClassroomListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomListPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useClassroomListPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClassroomListPageQuery,
    ClassroomListPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassroomListPageQuery,
    ClassroomListPageQueryVariables
  >(ClassroomListPageQueryDocument, options);
}
export function useClassroomListPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomListPageQuery,
    ClassroomListPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomListPageQuery,
    ClassroomListPageQueryVariables
  >(ClassroomListPageQueryDocument, options);
}
export function useClassroomListPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomListPageQuery,
        ClassroomListPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomListPageQuery,
    ClassroomListPageQueryVariables
  >(ClassroomListPageQueryDocument, options);
}
export type ClassroomListPageQueryHookResult = ReturnType<
  typeof useClassroomListPageQuery
>;
export type ClassroomListPageQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomListPageQueryLazyQuery
>;
export type ClassroomListPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomListPageQuerySuspenseQuery
>;
export type ClassroomListPageQueryQueryResult = Apollo.QueryResult<
  ClassroomListPageQuery,
  ClassroomListPageQueryVariables
>;
export const ClassroomPageQueryDocument = gql`
  query ClassroomPageQuery($classroomId: String!) {
    me: getMe {
      id
      isAdFreeSubscribed
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
      grade
      archived
      version
      schoolId
      schoolName
      ...NavbarClassroomFields
      ...SideNavigationClassroomFields
      ...ClassroomInfoPageClassroomFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      active
      blocked
      isProvisioningCompleted
      ...SideNavigationMemberFields
    }
  }
  ${NavbarClassroomFieldsFragmentDoc}
  ${SideNavigationClassroomFieldsFragmentDoc}
  ${ClassroomInfoPageClassroomFieldsFragmentDoc}
  ${SideNavigationMemberFieldsFragmentDoc}
`;

/**
 * __useClassroomPageQuery__
 *
 * To run a query within a React component, call `useClassroomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassroomPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomPageQuery,
    ClassroomPageQueryVariables
  > &
    (
      | { variables: ClassroomPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClassroomPageQuery, ClassroomPageQueryVariables>(
    ClassroomPageQueryDocument,
    options
  );
}
export function useClassroomPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomPageQuery,
    ClassroomPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClassroomPageQuery, ClassroomPageQueryVariables>(
    ClassroomPageQueryDocument,
    options
  );
}
export function useClassroomPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomPageQuery,
        ClassroomPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomPageQuery,
    ClassroomPageQueryVariables
  >(ClassroomPageQueryDocument, options);
}
export type ClassroomPageQueryHookResult = ReturnType<
  typeof useClassroomPageQuery
>;
export type ClassroomPageQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomPageQueryLazyQuery
>;
export type ClassroomPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomPageQuerySuspenseQuery
>;
export type ClassroomPageQueryQueryResult = Apollo.QueryResult<
  ClassroomPageQuery,
  ClassroomPageQueryVariables
>;
export const ClassroomPageOrganizationInfoQueryDocument = gql`
  query ClassroomPageOrganizationInfoQuery($orgId: String!) {
    organizationMyLicense: organizationMyLicense(orgId: $orgId) {
      id
    }
    organization: organizationOrganization(organizationId: $orgId) {
      id
      category
      address
      licensed
    }
  }
`;

/**
 * __useClassroomPageOrganizationInfoQuery__
 *
 * To run a query within a React component, call `useClassroomPageOrganizationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomPageOrganizationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomPageOrganizationInfoQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useClassroomPageOrganizationInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomPageOrganizationInfoQuery,
    ClassroomPageOrganizationInfoQueryVariables
  > &
    (
      | {
          variables: ClassroomPageOrganizationInfoQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassroomPageOrganizationInfoQuery,
    ClassroomPageOrganizationInfoQueryVariables
  >(ClassroomPageOrganizationInfoQueryDocument, options);
}
export function useClassroomPageOrganizationInfoQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomPageOrganizationInfoQuery,
    ClassroomPageOrganizationInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomPageOrganizationInfoQuery,
    ClassroomPageOrganizationInfoQueryVariables
  >(ClassroomPageOrganizationInfoQueryDocument, options);
}
export function useClassroomPageOrganizationInfoQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomPageOrganizationInfoQuery,
        ClassroomPageOrganizationInfoQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomPageOrganizationInfoQuery,
    ClassroomPageOrganizationInfoQueryVariables
  >(ClassroomPageOrganizationInfoQueryDocument, options);
}
export type ClassroomPageOrganizationInfoQueryHookResult = ReturnType<
  typeof useClassroomPageOrganizationInfoQuery
>;
export type ClassroomPageOrganizationInfoQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomPageOrganizationInfoQueryLazyQuery
>;
export type ClassroomPageOrganizationInfoQuerySuspenseQueryHookResult =
  ReturnType<typeof useClassroomPageOrganizationInfoQuerySuspenseQuery>;
export type ClassroomPageOrganizationInfoQueryQueryResult = Apollo.QueryResult<
  ClassroomPageOrganizationInfoQuery,
  ClassroomPageOrganizationInfoQueryVariables
>;
export const ClassroomRegistrationPageQueryDocument = gql`
  query ClassroomRegistrationPageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      type
    }
  }
`;

/**
 * __useClassroomRegistrationPageQuery__
 *
 * To run a query within a React component, call `useClassroomRegistrationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomRegistrationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomRegistrationPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassroomRegistrationPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomRegistrationPageQuery,
    ClassroomRegistrationPageQueryVariables
  > &
    (
      | { variables: ClassroomRegistrationPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassroomRegistrationPageQuery,
    ClassroomRegistrationPageQueryVariables
  >(ClassroomRegistrationPageQueryDocument, options);
}
export function useClassroomRegistrationPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomRegistrationPageQuery,
    ClassroomRegistrationPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomRegistrationPageQuery,
    ClassroomRegistrationPageQueryVariables
  >(ClassroomRegistrationPageQueryDocument, options);
}
export function useClassroomRegistrationPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomRegistrationPageQuery,
        ClassroomRegistrationPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomRegistrationPageQuery,
    ClassroomRegistrationPageQueryVariables
  >(ClassroomRegistrationPageQueryDocument, options);
}
export type ClassroomRegistrationPageQueryHookResult = ReturnType<
  typeof useClassroomRegistrationPageQuery
>;
export type ClassroomRegistrationPageQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomRegistrationPageQueryLazyQuery
>;
export type ClassroomRegistrationPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomRegistrationPageQuerySuspenseQuery
>;
export type ClassroomRegistrationPageQueryQueryResult = Apollo.QueryResult<
  ClassroomRegistrationPageQuery,
  ClassroomRegistrationPageQueryVariables
>;
export const UpdateClassroomMutationDocument = gql`
  mutation UpdateClassroomMutation(
    $classroomId: String!
    $updateClassroomDtoInput: UpdateClassroomDtoInput!
  ) {
    classroom: updateClassroom(
      classroomId: $classroomId
      updateClassroomDtoInput: $updateClassroomDtoInput
    ) {
      profileImageUrl
      ...ClassroomFormClassroomFields
    }
  }
  ${ClassroomFormClassroomFieldsFragmentDoc}
`;
export type UpdateClassroomMutationMutationFn = Apollo.MutationFunction<
  UpdateClassroomMutation,
  UpdateClassroomMutationVariables
>;

/**
 * __useUpdateClassroomMutation__
 *
 * To run a mutation, you first call `useUpdateClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassroomMutation, { data, loading, error }] = useUpdateClassroomMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      updateClassroomDtoInput: // value for 'updateClassroomDtoInput'
 *   },
 * });
 */
export function useUpdateClassroomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClassroomMutation,
    UpdateClassroomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateClassroomMutation,
    UpdateClassroomMutationVariables
  >(UpdateClassroomMutationDocument, options);
}
export type UpdateClassroomMutationHookResult = ReturnType<
  typeof useUpdateClassroomMutation
>;
export type UpdateClassroomMutationMutationResult =
  Apollo.MutationResult<UpdateClassroomMutation>;
export type UpdateClassroomMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateClassroomMutation,
  UpdateClassroomMutationVariables
>;
export const ArchiveClassroomMutationDocument = gql`
  mutation ArchiveClassroomMutation($classroomId: String!) {
    classroom: archiveClassroom(classroomId: $classroomId) {
      id
      archived
    }
  }
`;
export type ArchiveClassroomMutationMutationFn = Apollo.MutationFunction<
  ArchiveClassroomMutation,
  ArchiveClassroomMutationVariables
>;

/**
 * __useArchiveClassroomMutation__
 *
 * To run a mutation, you first call `useArchiveClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveClassroomMutation, { data, loading, error }] = useArchiveClassroomMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useArchiveClassroomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveClassroomMutation,
    ArchiveClassroomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveClassroomMutation,
    ArchiveClassroomMutationVariables
  >(ArchiveClassroomMutationDocument, options);
}
export type ArchiveClassroomMutationHookResult = ReturnType<
  typeof useArchiveClassroomMutation
>;
export type ArchiveClassroomMutationMutationResult =
  Apollo.MutationResult<ArchiveClassroomMutation>;
export type ArchiveClassroomMutationMutationOptions =
  Apollo.BaseMutationOptions<
    ArchiveClassroomMutation,
    ArchiveClassroomMutationVariables
  >;
export const UnarchiveClassroomMutationDocument = gql`
  mutation UnarchiveClassroomMutation($classroomId: String!) {
    classroom: unarchiveClassroom(classroomId: $classroomId) {
      id
      archived
    }
  }
`;
export type UnarchiveClassroomMutationMutationFn = Apollo.MutationFunction<
  UnarchiveClassroomMutation,
  UnarchiveClassroomMutationVariables
>;

/**
 * __useUnarchiveClassroomMutation__
 *
 * To run a mutation, you first call `useUnarchiveClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveClassroomMutation, { data, loading, error }] = useUnarchiveClassroomMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useUnarchiveClassroomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveClassroomMutation,
    UnarchiveClassroomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnarchiveClassroomMutation,
    UnarchiveClassroomMutationVariables
  >(UnarchiveClassroomMutationDocument, options);
}
export type UnarchiveClassroomMutationHookResult = ReturnType<
  typeof useUnarchiveClassroomMutation
>;
export type UnarchiveClassroomMutationMutationResult =
  Apollo.MutationResult<UnarchiveClassroomMutation>;
export type UnarchiveClassroomMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UnarchiveClassroomMutation,
    UnarchiveClassroomMutationVariables
  >;
export const ClassroomSettingPageQueryDocument = gql`
  query ClassroomSettingPageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      archived
      profileImageUrl
      ...ClassroomFormClassroomFields
    }
    member: getClassroomMember(classroomId: $classroomId, memberId: "me") {
      id
      role
    }
  }
  ${ClassroomFormClassroomFieldsFragmentDoc}
`;

/**
 * __useClassroomSettingPageQuery__
 *
 * To run a query within a React component, call `useClassroomSettingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomSettingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomSettingPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassroomSettingPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomSettingPageQuery,
    ClassroomSettingPageQueryVariables
  > &
    (
      | { variables: ClassroomSettingPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassroomSettingPageQuery,
    ClassroomSettingPageQueryVariables
  >(ClassroomSettingPageQueryDocument, options);
}
export function useClassroomSettingPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomSettingPageQuery,
    ClassroomSettingPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomSettingPageQuery,
    ClassroomSettingPageQueryVariables
  >(ClassroomSettingPageQueryDocument, options);
}
export function useClassroomSettingPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomSettingPageQuery,
        ClassroomSettingPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomSettingPageQuery,
    ClassroomSettingPageQueryVariables
  >(ClassroomSettingPageQueryDocument, options);
}
export type ClassroomSettingPageQueryHookResult = ReturnType<
  typeof useClassroomSettingPageQuery
>;
export type ClassroomSettingPageQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomSettingPageQueryLazyQuery
>;
export type ClassroomSettingPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomSettingPageQuerySuspenseQuery
>;
export type ClassroomSettingPageQueryQueryResult = Apollo.QueryResult<
  ClassroomSettingPageQuery,
  ClassroomSettingPageQueryVariables
>;
export const CreateClassroomMutationDocument = gql`
  mutation CreateClassroomMutation(
    $createClassroomDtoInput: CreateClassroomDtoInput!
  ) {
    classroom: createClassroom(
      createClassroomDtoInput: $createClassroomDtoInput
    ) {
      id
      name
    }
  }
`;
export type CreateClassroomMutationMutationFn = Apollo.MutationFunction<
  CreateClassroomMutation,
  CreateClassroomMutationVariables
>;

/**
 * __useCreateClassroomMutation__
 *
 * To run a mutation, you first call `useCreateClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassroomMutation, { data, loading, error }] = useCreateClassroomMutation({
 *   variables: {
 *      createClassroomDtoInput: // value for 'createClassroomDtoInput'
 *   },
 * });
 */
export function useCreateClassroomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClassroomMutation,
    CreateClassroomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateClassroomMutation,
    CreateClassroomMutationVariables
  >(CreateClassroomMutationDocument, options);
}
export type CreateClassroomMutationHookResult = ReturnType<
  typeof useCreateClassroomMutation
>;
export type CreateClassroomMutationMutationResult =
  Apollo.MutationResult<CreateClassroomMutation>;
export type CreateClassroomMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateClassroomMutation,
  CreateClassroomMutationVariables
>;
export const EditProfileForClassroomPageQueryDocument = gql`
  query EditProfileForClassroomPageQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      ...MemberProfileImageMemberFields
    }
  }
  ${MemberProfileImageMemberFieldsFragmentDoc}
`;

/**
 * __useEditProfileForClassroomPageQuery__
 *
 * To run a query within a React component, call `useEditProfileForClassroomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProfileForClassroomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProfileForClassroomPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useEditProfileForClassroomPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditProfileForClassroomPageQuery,
    EditProfileForClassroomPageQueryVariables
  > &
    (
      | { variables: EditProfileForClassroomPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EditProfileForClassroomPageQuery,
    EditProfileForClassroomPageQueryVariables
  >(EditProfileForClassroomPageQueryDocument, options);
}
export function useEditProfileForClassroomPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditProfileForClassroomPageQuery,
    EditProfileForClassroomPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EditProfileForClassroomPageQuery,
    EditProfileForClassroomPageQueryVariables
  >(EditProfileForClassroomPageQueryDocument, options);
}
export function useEditProfileForClassroomPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditProfileForClassroomPageQuery,
        EditProfileForClassroomPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EditProfileForClassroomPageQuery,
    EditProfileForClassroomPageQueryVariables
  >(EditProfileForClassroomPageQueryDocument, options);
}
export type EditProfileForClassroomPageQueryHookResult = ReturnType<
  typeof useEditProfileForClassroomPageQuery
>;
export type EditProfileForClassroomPageQueryLazyQueryHookResult = ReturnType<
  typeof useEditProfileForClassroomPageQueryLazyQuery
>;
export type EditProfileForClassroomPageQuerySuspenseQueryHookResult =
  ReturnType<typeof useEditProfileForClassroomPageQuerySuspenseQuery>;
export type EditProfileForClassroomPageQueryQueryResult = Apollo.QueryResult<
  EditProfileForClassroomPageQuery,
  EditProfileForClassroomPageQueryVariables
>;
export const HomePageQueryDocument = gql`
  query HomePageQuery($classroomId: String!) {
    me: getMe {
      id
      isAdFreeSubscribed
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
      archived
    }
  }
`;

/**
 * __useHomePageQuery__
 *
 * To run a query within a React component, call `useHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useHomePageQuery(
  baseOptions: Apollo.QueryHookOptions<HomePageQuery, HomePageQueryVariables> &
    ({ variables: HomePageQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HomePageQuery, HomePageQueryVariables>(
    HomePageQueryDocument,
    options
  );
}
export function useHomePageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomePageQuery,
    HomePageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HomePageQuery, HomePageQueryVariables>(
    HomePageQueryDocument,
    options
  );
}
export function useHomePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HomePageQuery, HomePageQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HomePageQuery, HomePageQueryVariables>(
    HomePageQueryDocument,
    options
  );
}
export type HomePageQueryHookResult = ReturnType<typeof useHomePageQuery>;
export type HomePageQueryLazyQueryHookResult = ReturnType<
  typeof useHomePageQueryLazyQuery
>;
export type HomePageQuerySuspenseQueryHookResult = ReturnType<
  typeof useHomePageQuerySuspenseQuery
>;
export type HomePageQueryQueryResult = Apollo.QueryResult<
  HomePageQuery,
  HomePageQueryVariables
>;
export const InvitationHandoutPageQueryDocument = gql`
  query InvitationHandoutPageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      countryCode
      name
      schoolName
    }
    classroomClassCode: getClassroomClassCode(id: $classroomId) {
      classroomId
      code
      expiresAt
      enterprise {
        slug
      }
    }
  }
`;

/**
 * __useInvitationHandoutPageQuery__
 *
 * To run a query within a React component, call `useInvitationHandoutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationHandoutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationHandoutPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useInvitationHandoutPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvitationHandoutPageQuery,
    InvitationHandoutPageQueryVariables
  > &
    (
      | { variables: InvitationHandoutPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InvitationHandoutPageQuery,
    InvitationHandoutPageQueryVariables
  >(InvitationHandoutPageQueryDocument, options);
}
export function useInvitationHandoutPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvitationHandoutPageQuery,
    InvitationHandoutPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InvitationHandoutPageQuery,
    InvitationHandoutPageQueryVariables
  >(InvitationHandoutPageQueryDocument, options);
}
export function useInvitationHandoutPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvitationHandoutPageQuery,
        InvitationHandoutPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InvitationHandoutPageQuery,
    InvitationHandoutPageQueryVariables
  >(InvitationHandoutPageQueryDocument, options);
}
export type InvitationHandoutPageQueryHookResult = ReturnType<
  typeof useInvitationHandoutPageQuery
>;
export type InvitationHandoutPageQueryLazyQueryHookResult = ReturnType<
  typeof useInvitationHandoutPageQueryLazyQuery
>;
export type InvitationHandoutPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useInvitationHandoutPageQuerySuspenseQuery
>;
export type InvitationHandoutPageQueryQueryResult = Apollo.QueryResult<
  InvitationHandoutPageQuery,
  InvitationHandoutPageQueryVariables
>;
export const InvitationPageQueryDocument = gql`
  query InvitationPageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      countryCode
    }
    classCode: getClassroomClassCode(id: $classroomId) {
      classroomId
      code
      enterprise {
        ...InvitationByQrCodeClassroomEnterpriseDtoFields
      }
    }
  }
  ${InvitationByQrCodeClassroomEnterpriseDtoFieldsFragmentDoc}
`;

/**
 * __useInvitationPageQuery__
 *
 * To run a query within a React component, call `useInvitationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useInvitationPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvitationPageQuery,
    InvitationPageQueryVariables
  > &
    (
      | { variables: InvitationPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InvitationPageQuery, InvitationPageQueryVariables>(
    InvitationPageQueryDocument,
    options
  );
}
export function useInvitationPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvitationPageQuery,
    InvitationPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InvitationPageQuery, InvitationPageQueryVariables>(
    InvitationPageQueryDocument,
    options
  );
}
export function useInvitationPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvitationPageQuery,
        InvitationPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InvitationPageQuery,
    InvitationPageQueryVariables
  >(InvitationPageQueryDocument, options);
}
export type InvitationPageQueryHookResult = ReturnType<
  typeof useInvitationPageQuery
>;
export type InvitationPageQueryLazyQueryHookResult = ReturnType<
  typeof useInvitationPageQueryLazyQuery
>;
export type InvitationPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useInvitationPageQuerySuspenseQuery
>;
export type InvitationPageQueryQueryResult = Apollo.QueryResult<
  InvitationPageQuery,
  InvitationPageQueryVariables
>;
export const MemberListPageDocument = gql`
  query MemberListPage($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      membersCount
      countryCode
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      name
      role
    }
  }
`;

/**
 * __useMemberListPageQuery__
 *
 * To run a query within a React component, call `useMemberListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberListPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useMemberListPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberListPageQuery,
    MemberListPageQueryVariables
  > &
    (
      | { variables: MemberListPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemberListPageQuery, MemberListPageQueryVariables>(
    MemberListPageDocument,
    options
  );
}
export function useMemberListPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberListPageQuery,
    MemberListPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberListPageQuery, MemberListPageQueryVariables>(
    MemberListPageDocument,
    options
  );
}
export function useMemberListPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberListPageQuery,
        MemberListPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberListPageQuery,
    MemberListPageQueryVariables
  >(MemberListPageDocument, options);
}
export type MemberListPageQueryHookResult = ReturnType<
  typeof useMemberListPageQuery
>;
export type MemberListPageLazyQueryHookResult = ReturnType<
  typeof useMemberListPageLazyQuery
>;
export type MemberListPageSuspenseQueryHookResult = ReturnType<
  typeof useMemberListPageSuspenseQuery
>;
export type MemberListPageQueryResult = Apollo.QueryResult<
  MemberListPageQuery,
  MemberListPageQueryVariables
>;
export const MobileNavigationMenuQueryDocument = gql`
  query MobileNavigationMenuQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      ...ClassroomInfoClassroomFields
      ...NavigationMenuClassroomFields
    }
    me: getMe {
      id
      isAdFreeSubscribed
    }
  }
  ${ClassroomInfoClassroomFieldsFragmentDoc}
  ${NavigationMenuClassroomFieldsFragmentDoc}
`;

/**
 * __useMobileNavigationMenuQuery__
 *
 * To run a query within a React component, call `useMobileNavigationMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useMobileNavigationMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMobileNavigationMenuQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useMobileNavigationMenuQuery(
  baseOptions: Apollo.QueryHookOptions<
    MobileNavigationMenuQuery,
    MobileNavigationMenuQueryVariables
  > &
    (
      | { variables: MobileNavigationMenuQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MobileNavigationMenuQuery,
    MobileNavigationMenuQueryVariables
  >(MobileNavigationMenuQueryDocument, options);
}
export function useMobileNavigationMenuQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MobileNavigationMenuQuery,
    MobileNavigationMenuQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MobileNavigationMenuQuery,
    MobileNavigationMenuQueryVariables
  >(MobileNavigationMenuQueryDocument, options);
}
export function useMobileNavigationMenuQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MobileNavigationMenuQuery,
        MobileNavigationMenuQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MobileNavigationMenuQuery,
    MobileNavigationMenuQueryVariables
  >(MobileNavigationMenuQueryDocument, options);
}
export type MobileNavigationMenuQueryHookResult = ReturnType<
  typeof useMobileNavigationMenuQuery
>;
export type MobileNavigationMenuQueryLazyQueryHookResult = ReturnType<
  typeof useMobileNavigationMenuQueryLazyQuery
>;
export type MobileNavigationMenuQuerySuspenseQueryHookResult = ReturnType<
  typeof useMobileNavigationMenuQuerySuspenseQuery
>;
export type MobileNavigationMenuQueryQueryResult = Apollo.QueryResult<
  MobileNavigationMenuQuery,
  MobileNavigationMenuQueryVariables
>;
export const OnboardingChecklistPageQueryDocument = gql`
  query OnboardingChecklistPageQuery($classroomId: String!) {
    checklist: getOnboardingChecklist(classroomId: $classroomId) {
      id
      isActive
      isComplete
      availableActions
      progress
      ...OnboardingChecklistProgressOnboardingChecklistFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
  ${OnboardingChecklistProgressOnboardingChecklistFieldsFragmentDoc}
`;

/**
 * __useOnboardingChecklistPageQuery__
 *
 * To run a query within a React component, call `useOnboardingChecklistPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingChecklistPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingChecklistPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useOnboardingChecklistPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    OnboardingChecklistPageQuery,
    OnboardingChecklistPageQueryVariables
  > &
    (
      | { variables: OnboardingChecklistPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OnboardingChecklistPageQuery,
    OnboardingChecklistPageQueryVariables
  >(OnboardingChecklistPageQueryDocument, options);
}
export function useOnboardingChecklistPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingChecklistPageQuery,
    OnboardingChecklistPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OnboardingChecklistPageQuery,
    OnboardingChecklistPageQueryVariables
  >(OnboardingChecklistPageQueryDocument, options);
}
export function useOnboardingChecklistPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OnboardingChecklistPageQuery,
        OnboardingChecklistPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OnboardingChecklistPageQuery,
    OnboardingChecklistPageQueryVariables
  >(OnboardingChecklistPageQueryDocument, options);
}
export type OnboardingChecklistPageQueryHookResult = ReturnType<
  typeof useOnboardingChecklistPageQuery
>;
export type OnboardingChecklistPageQueryLazyQueryHookResult = ReturnType<
  typeof useOnboardingChecklistPageQueryLazyQuery
>;
export type OnboardingChecklistPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useOnboardingChecklistPageQuerySuspenseQuery
>;
export type OnboardingChecklistPageQueryQueryResult = Apollo.QueryResult<
  OnboardingChecklistPageQuery,
  OnboardingChecklistPageQueryVariables
>;
export const OnboardingLoadingPageMemberQueryDocument = gql`
  query OnboardingLoadingPageMemberQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      isProvisioningCompleted
    }
  }
`;

/**
 * __useOnboardingLoadingPageMemberQuery__
 *
 * To run a query within a React component, call `useOnboardingLoadingPageMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingLoadingPageMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingLoadingPageMemberQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useOnboardingLoadingPageMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    OnboardingLoadingPageMemberQuery,
    OnboardingLoadingPageMemberQueryVariables
  > &
    (
      | { variables: OnboardingLoadingPageMemberQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OnboardingLoadingPageMemberQuery,
    OnboardingLoadingPageMemberQueryVariables
  >(OnboardingLoadingPageMemberQueryDocument, options);
}
export function useOnboardingLoadingPageMemberQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingLoadingPageMemberQuery,
    OnboardingLoadingPageMemberQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OnboardingLoadingPageMemberQuery,
    OnboardingLoadingPageMemberQueryVariables
  >(OnboardingLoadingPageMemberQueryDocument, options);
}
export function useOnboardingLoadingPageMemberQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OnboardingLoadingPageMemberQuery,
        OnboardingLoadingPageMemberQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OnboardingLoadingPageMemberQuery,
    OnboardingLoadingPageMemberQueryVariables
  >(OnboardingLoadingPageMemberQueryDocument, options);
}
export type OnboardingLoadingPageMemberQueryHookResult = ReturnType<
  typeof useOnboardingLoadingPageMemberQuery
>;
export type OnboardingLoadingPageMemberQueryLazyQueryHookResult = ReturnType<
  typeof useOnboardingLoadingPageMemberQueryLazyQuery
>;
export type OnboardingLoadingPageMemberQuerySuspenseQueryHookResult =
  ReturnType<typeof useOnboardingLoadingPageMemberQuerySuspenseQuery>;
export type OnboardingLoadingPageMemberQueryQueryResult = Apollo.QueryResult<
  OnboardingLoadingPageMemberQuery,
  OnboardingLoadingPageMemberQueryVariables
>;
export const RegisterForClassroomMutationDocument = gql`
  mutation RegisterForClassroomMutation($registerDtoInput: RegisterDtoInput!) {
    member: registerForClassroom(registerDtoInput: $registerDtoInput) {
      classroomId
      id
      name
      profileImageUrl
    }
  }
`;
export type RegisterForClassroomMutationMutationFn = Apollo.MutationFunction<
  RegisterForClassroomMutation,
  RegisterForClassroomMutationVariables
>;

/**
 * __useRegisterForClassroomMutation__
 *
 * To run a mutation, you first call `useRegisterForClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterForClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerForClassroomMutation, { data, loading, error }] = useRegisterForClassroomMutation({
 *   variables: {
 *      registerDtoInput: // value for 'registerDtoInput'
 *   },
 * });
 */
export function useRegisterForClassroomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterForClassroomMutation,
    RegisterForClassroomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterForClassroomMutation,
    RegisterForClassroomMutationVariables
  >(RegisterForClassroomMutationDocument, options);
}
export type RegisterForClassroomMutationHookResult = ReturnType<
  typeof useRegisterForClassroomMutation
>;
export type RegisterForClassroomMutationMutationResult =
  Apollo.MutationResult<RegisterForClassroomMutation>;
export type RegisterForClassroomMutationMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterForClassroomMutation,
    RegisterForClassroomMutationVariables
  >;
export const RegisterForClassroomPageQueryDocument = gql`
  query RegisterForClassroomPageQuery($code: String!) {
    me: getMe {
      ...RegisterForClassroomFormAccountFields
    }
    classCode: getClassCode(code: $code) {
      classroomId
      code
    }
  }
  ${RegisterForClassroomFormAccountFieldsFragmentDoc}
`;

/**
 * __useRegisterForClassroomPageQuery__
 *
 * To run a query within a React component, call `useRegisterForClassroomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterForClassroomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterForClassroomPageQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRegisterForClassroomPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegisterForClassroomPageQuery,
    RegisterForClassroomPageQueryVariables
  > &
    (
      | { variables: RegisterForClassroomPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RegisterForClassroomPageQuery,
    RegisterForClassroomPageQueryVariables
  >(RegisterForClassroomPageQueryDocument, options);
}
export function useRegisterForClassroomPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegisterForClassroomPageQuery,
    RegisterForClassroomPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RegisterForClassroomPageQuery,
    RegisterForClassroomPageQueryVariables
  >(RegisterForClassroomPageQueryDocument, options);
}
export function useRegisterForClassroomPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterForClassroomPageQuery,
        RegisterForClassroomPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RegisterForClassroomPageQuery,
    RegisterForClassroomPageQueryVariables
  >(RegisterForClassroomPageQueryDocument, options);
}
export type RegisterForClassroomPageQueryHookResult = ReturnType<
  typeof useRegisterForClassroomPageQuery
>;
export type RegisterForClassroomPageQueryLazyQueryHookResult = ReturnType<
  typeof useRegisterForClassroomPageQueryLazyQuery
>;
export type RegisterForClassroomPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useRegisterForClassroomPageQuerySuspenseQuery
>;
export type RegisterForClassroomPageQueryQueryResult = Apollo.QueryResult<
  RegisterForClassroomPageQuery,
  RegisterForClassroomPageQueryVariables
>;
export const RegisterForClassroomPageClassroomQueryDocument = gql`
  query RegisterForClassroomPageClassroomQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
      schoolId
    }
  }
`;

/**
 * __useRegisterForClassroomPageClassroomQuery__
 *
 * To run a query within a React component, call `useRegisterForClassroomPageClassroomQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterForClassroomPageClassroomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterForClassroomPageClassroomQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useRegisterForClassroomPageClassroomQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegisterForClassroomPageClassroomQuery,
    RegisterForClassroomPageClassroomQueryVariables
  > &
    (
      | {
          variables: RegisterForClassroomPageClassroomQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RegisterForClassroomPageClassroomQuery,
    RegisterForClassroomPageClassroomQueryVariables
  >(RegisterForClassroomPageClassroomQueryDocument, options);
}
export function useRegisterForClassroomPageClassroomQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegisterForClassroomPageClassroomQuery,
    RegisterForClassroomPageClassroomQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RegisterForClassroomPageClassroomQuery,
    RegisterForClassroomPageClassroomQueryVariables
  >(RegisterForClassroomPageClassroomQueryDocument, options);
}
export function useRegisterForClassroomPageClassroomQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterForClassroomPageClassroomQuery,
        RegisterForClassroomPageClassroomQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RegisterForClassroomPageClassroomQuery,
    RegisterForClassroomPageClassroomQueryVariables
  >(RegisterForClassroomPageClassroomQueryDocument, options);
}
export type RegisterForClassroomPageClassroomQueryHookResult = ReturnType<
  typeof useRegisterForClassroomPageClassroomQuery
>;
export type RegisterForClassroomPageClassroomQueryLazyQueryHookResult =
  ReturnType<typeof useRegisterForClassroomPageClassroomQueryLazyQuery>;
export type RegisterForClassroomPageClassroomQuerySuspenseQueryHookResult =
  ReturnType<typeof useRegisterForClassroomPageClassroomQuerySuspenseQuery>;
export type RegisterForClassroomPageClassroomQueryQueryResult =
  Apollo.QueryResult<
    RegisterForClassroomPageClassroomQuery,
    RegisterForClassroomPageClassroomQueryVariables
  >;
export const RegisterForClassroomPageClassroomOrganizationQueryDocument = gql`
  query RegisterForClassroomPageClassroomOrganizationQuery(
    $organizationId: String!
  ) {
    organization: organizationOrganization(organizationId: $organizationId) {
      id
      enterpriseId
    }
  }
`;

/**
 * __useRegisterForClassroomPageClassroomOrganizationQuery__
 *
 * To run a query within a React component, call `useRegisterForClassroomPageClassroomOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterForClassroomPageClassroomOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterForClassroomPageClassroomOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRegisterForClassroomPageClassroomOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegisterForClassroomPageClassroomOrganizationQuery,
    RegisterForClassroomPageClassroomOrganizationQueryVariables
  > &
    (
      | {
          variables: RegisterForClassroomPageClassroomOrganizationQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RegisterForClassroomPageClassroomOrganizationQuery,
    RegisterForClassroomPageClassroomOrganizationQueryVariables
  >(RegisterForClassroomPageClassroomOrganizationQueryDocument, options);
}
export function useRegisterForClassroomPageClassroomOrganizationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegisterForClassroomPageClassroomOrganizationQuery,
    RegisterForClassroomPageClassroomOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RegisterForClassroomPageClassroomOrganizationQuery,
    RegisterForClassroomPageClassroomOrganizationQueryVariables
  >(RegisterForClassroomPageClassroomOrganizationQueryDocument, options);
}
export function useRegisterForClassroomPageClassroomOrganizationQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterForClassroomPageClassroomOrganizationQuery,
        RegisterForClassroomPageClassroomOrganizationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RegisterForClassroomPageClassroomOrganizationQuery,
    RegisterForClassroomPageClassroomOrganizationQueryVariables
  >(RegisterForClassroomPageClassroomOrganizationQueryDocument, options);
}
export type RegisterForClassroomPageClassroomOrganizationQueryHookResult =
  ReturnType<typeof useRegisterForClassroomPageClassroomOrganizationQuery>;
export type RegisterForClassroomPageClassroomOrganizationQueryLazyQueryHookResult =
  ReturnType<
    typeof useRegisterForClassroomPageClassroomOrganizationQueryLazyQuery
  >;
export type RegisterForClassroomPageClassroomOrganizationQuerySuspenseQueryHookResult =
  ReturnType<
    typeof useRegisterForClassroomPageClassroomOrganizationQuerySuspenseQuery
  >;
export type RegisterForClassroomPageClassroomOrganizationQueryQueryResult =
  Apollo.QueryResult<
    RegisterForClassroomPageClassroomOrganizationQuery,
    RegisterForClassroomPageClassroomOrganizationQueryVariables
  >;
export const RegisterForPublicClassroomPageQueryDocument = gql`
  query RegisterForPublicClassroomPageQuery {
    me: getMe {
      id
      name
      profileImage
    }
  }
`;

/**
 * __useRegisterForPublicClassroomPageQuery__
 *
 * To run a query within a React component, call `useRegisterForPublicClassroomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterForPublicClassroomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterForPublicClassroomPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegisterForPublicClassroomPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RegisterForPublicClassroomPageQuery,
    RegisterForPublicClassroomPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RegisterForPublicClassroomPageQuery,
    RegisterForPublicClassroomPageQueryVariables
  >(RegisterForPublicClassroomPageQueryDocument, options);
}
export function useRegisterForPublicClassroomPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegisterForPublicClassroomPageQuery,
    RegisterForPublicClassroomPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RegisterForPublicClassroomPageQuery,
    RegisterForPublicClassroomPageQueryVariables
  >(RegisterForPublicClassroomPageQueryDocument, options);
}
export function useRegisterForPublicClassroomPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterForPublicClassroomPageQuery,
        RegisterForPublicClassroomPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RegisterForPublicClassroomPageQuery,
    RegisterForPublicClassroomPageQueryVariables
  >(RegisterForPublicClassroomPageQueryDocument, options);
}
export type RegisterForPublicClassroomPageQueryHookResult = ReturnType<
  typeof useRegisterForPublicClassroomPageQuery
>;
export type RegisterForPublicClassroomPageQueryLazyQueryHookResult = ReturnType<
  typeof useRegisterForPublicClassroomPageQueryLazyQuery
>;
export type RegisterForPublicClassroomPageQuerySuspenseQueryHookResult =
  ReturnType<typeof useRegisterForPublicClassroomPageQuerySuspenseQuery>;
export type RegisterForPublicClassroomPageQueryQueryResult = Apollo.QueryResult<
  RegisterForPublicClassroomPageQuery,
  RegisterForPublicClassroomPageQueryVariables
>;
export const RegisterForPublicClassroomPageMutationDocument = gql`
  mutation RegisterForPublicClassroomPageMutation(
    $registerDtoInput: RegisterDtoInput!
  ) {
    member: registerForClassroom(registerDtoInput: $registerDtoInput) {
      id
      name
    }
  }
`;
export type RegisterForPublicClassroomPageMutationMutationFn =
  Apollo.MutationFunction<
    RegisterForPublicClassroomPageMutation,
    RegisterForPublicClassroomPageMutationVariables
  >;

/**
 * __useRegisterForPublicClassroomPageMutation__
 *
 * To run a mutation, you first call `useRegisterForPublicClassroomPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterForPublicClassroomPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerForPublicClassroomPageMutation, { data, loading, error }] = useRegisterForPublicClassroomPageMutation({
 *   variables: {
 *      registerDtoInput: // value for 'registerDtoInput'
 *   },
 * });
 */
export function useRegisterForPublicClassroomPageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterForPublicClassroomPageMutation,
    RegisterForPublicClassroomPageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterForPublicClassroomPageMutation,
    RegisterForPublicClassroomPageMutationVariables
  >(RegisterForPublicClassroomPageMutationDocument, options);
}
export type RegisterForPublicClassroomPageMutationHookResult = ReturnType<
  typeof useRegisterForPublicClassroomPageMutation
>;
export type RegisterForPublicClassroomPageMutationMutationResult =
  Apollo.MutationResult<RegisterForPublicClassroomPageMutation>;
export type RegisterForPublicClassroomPageMutationMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterForPublicClassroomPageMutation,
    RegisterForPublicClassroomPageMutationVariables
  >;
export const SignUpAdminPageQueryDocument = gql`
  query SignUpAdminPageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
      schoolId
      schoolName
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      ...SignUpAdminPageMemberFields
    }
  }
  ${SignUpAdminPageMemberFieldsFragmentDoc}
`;

/**
 * __useSignUpAdminPageQuery__
 *
 * To run a query within a React component, call `useSignUpAdminPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpAdminPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpAdminPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useSignUpAdminPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    SignUpAdminPageQuery,
    SignUpAdminPageQueryVariables
  > &
    (
      | { variables: SignUpAdminPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SignUpAdminPageQuery, SignUpAdminPageQueryVariables>(
    SignUpAdminPageQueryDocument,
    options
  );
}
export function useSignUpAdminPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SignUpAdminPageQuery,
    SignUpAdminPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SignUpAdminPageQuery,
    SignUpAdminPageQueryVariables
  >(SignUpAdminPageQueryDocument, options);
}
export function useSignUpAdminPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SignUpAdminPageQuery,
        SignUpAdminPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SignUpAdminPageQuery,
    SignUpAdminPageQueryVariables
  >(SignUpAdminPageQueryDocument, options);
}
export type SignUpAdminPageQueryHookResult = ReturnType<
  typeof useSignUpAdminPageQuery
>;
export type SignUpAdminPageQueryLazyQueryHookResult = ReturnType<
  typeof useSignUpAdminPageQueryLazyQuery
>;
export type SignUpAdminPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useSignUpAdminPageQuerySuspenseQuery
>;
export type SignUpAdminPageQueryQueryResult = Apollo.QueryResult<
  SignUpAdminPageQuery,
  SignUpAdminPageQueryVariables
>;
export const IntegrateZoomDocument = gql`
  mutation IntegrateZoom(
    $classroomId: String!
    $integrateZoomDtoInput: IntegrateZoomDtoInput!
  ) {
    integrateZoom(
      classroomId: $classroomId
      integrateZoomDtoInput: $integrateZoomDtoInput
    ) {
      userId
    }
  }
`;
export type IntegrateZoomMutationFn = Apollo.MutationFunction<
  IntegrateZoomMutation,
  IntegrateZoomMutationVariables
>;

/**
 * __useIntegrateZoomMutation__
 *
 * To run a mutation, you first call `useIntegrateZoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrateZoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrateZoomMutation, { data, loading, error }] = useIntegrateZoomMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      integrateZoomDtoInput: // value for 'integrateZoomDtoInput'
 *   },
 * });
 */
export function useIntegrateZoomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IntegrateZoomMutation,
    IntegrateZoomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IntegrateZoomMutation,
    IntegrateZoomMutationVariables
  >(IntegrateZoomDocument, options);
}
export type IntegrateZoomMutationHookResult = ReturnType<
  typeof useIntegrateZoomMutation
>;
export type IntegrateZoomMutationResult =
  Apollo.MutationResult<IntegrateZoomMutation>;
export type IntegrateZoomMutationOptions = Apollo.BaseMutationOptions<
  IntegrateZoomMutation,
  IntegrateZoomMutationVariables
>;
export const ClassTalkButtonQueryDocument = gql`
  query ClassTalkButtonQuery {
    currentChatUser {
      unreadCount
    }
  }
`;

/**
 * __useClassTalkButtonQuery__
 *
 * To run a query within a React component, call `useClassTalkButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassTalkButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassTalkButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useClassTalkButtonQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClassTalkButtonQuery,
    ClassTalkButtonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClassTalkButtonQuery, ClassTalkButtonQueryVariables>(
    ClassTalkButtonQueryDocument,
    options
  );
}
export function useClassTalkButtonQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassTalkButtonQuery,
    ClassTalkButtonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassTalkButtonQuery,
    ClassTalkButtonQueryVariables
  >(ClassTalkButtonQueryDocument, options);
}
export function useClassTalkButtonQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassTalkButtonQuery,
        ClassTalkButtonQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassTalkButtonQuery,
    ClassTalkButtonQueryVariables
  >(ClassTalkButtonQueryDocument, options);
}
export type ClassTalkButtonQueryHookResult = ReturnType<
  typeof useClassTalkButtonQuery
>;
export type ClassTalkButtonQueryLazyQueryHookResult = ReturnType<
  typeof useClassTalkButtonQueryLazyQuery
>;
export type ClassTalkButtonQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassTalkButtonQuerySuspenseQuery
>;
export type ClassTalkButtonQueryQueryResult = Apollo.QueryResult<
  ClassTalkButtonQuery,
  ClassTalkButtonQueryVariables
>;
export const ClassTalkMobileButtonQueryDocument = gql`
  query ClassTalkMobileButtonQuery {
    currentChatUser {
      unreadCount
    }
  }
`;

/**
 * __useClassTalkMobileButtonQuery__
 *
 * To run a query within a React component, call `useClassTalkMobileButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassTalkMobileButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassTalkMobileButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useClassTalkMobileButtonQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClassTalkMobileButtonQuery,
    ClassTalkMobileButtonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassTalkMobileButtonQuery,
    ClassTalkMobileButtonQueryVariables
  >(ClassTalkMobileButtonQueryDocument, options);
}
export function useClassTalkMobileButtonQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassTalkMobileButtonQuery,
    ClassTalkMobileButtonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassTalkMobileButtonQuery,
    ClassTalkMobileButtonQueryVariables
  >(ClassTalkMobileButtonQueryDocument, options);
}
export function useClassTalkMobileButtonQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassTalkMobileButtonQuery,
        ClassTalkMobileButtonQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassTalkMobileButtonQuery,
    ClassTalkMobileButtonQueryVariables
  >(ClassTalkMobileButtonQueryDocument, options);
}
export type ClassTalkMobileButtonQueryHookResult = ReturnType<
  typeof useClassTalkMobileButtonQuery
>;
export type ClassTalkMobileButtonQueryLazyQueryHookResult = ReturnType<
  typeof useClassTalkMobileButtonQueryLazyQuery
>;
export type ClassTalkMobileButtonQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassTalkMobileButtonQuerySuspenseQuery
>;
export type ClassTalkMobileButtonQueryQueryResult = Apollo.QueryResult<
  ClassTalkMobileButtonQuery,
  ClassTalkMobileButtonQueryVariables
>;
export const ClasstalkChatButtonQueryDocument = gql`
  query ClasstalkChatButtonQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
      profileImageUrl
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      ...ClasstalkChatButtonMemberFields
    }
  }
  ${ClasstalkChatButtonMemberFieldsFragmentDoc}
`;

/**
 * __useClasstalkChatButtonQuery__
 *
 * To run a query within a React component, call `useClasstalkChatButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useClasstalkChatButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClasstalkChatButtonQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClasstalkChatButtonQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClasstalkChatButtonQuery,
    ClasstalkChatButtonQueryVariables
  > &
    (
      | { variables: ClasstalkChatButtonQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClasstalkChatButtonQuery,
    ClasstalkChatButtonQueryVariables
  >(ClasstalkChatButtonQueryDocument, options);
}
export function useClasstalkChatButtonQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClasstalkChatButtonQuery,
    ClasstalkChatButtonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClasstalkChatButtonQuery,
    ClasstalkChatButtonQueryVariables
  >(ClasstalkChatButtonQueryDocument, options);
}
export function useClasstalkChatButtonQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClasstalkChatButtonQuery,
        ClasstalkChatButtonQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClasstalkChatButtonQuery,
    ClasstalkChatButtonQueryVariables
  >(ClasstalkChatButtonQueryDocument, options);
}
export type ClasstalkChatButtonQueryHookResult = ReturnType<
  typeof useClasstalkChatButtonQuery
>;
export type ClasstalkChatButtonQueryLazyQueryHookResult = ReturnType<
  typeof useClasstalkChatButtonQueryLazyQuery
>;
export type ClasstalkChatButtonQuerySuspenseQueryHookResult = ReturnType<
  typeof useClasstalkChatButtonQuerySuspenseQuery
>;
export type ClasstalkChatButtonQueryQueryResult = Apollo.QueryResult<
  ClasstalkChatButtonQuery,
  ClasstalkChatButtonQueryVariables
>;
export const DeleteCommentMutationDocument = gql`
  mutation DeleteCommentMutation($postId: String!, $commentId: String!) {
    deleteComment(postId: $postId, commentId: $commentId)
  }
`;
export type DeleteCommentMutationMutationFn = Apollo.MutationFunction<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCommentMutation,
    DeleteCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCommentMutation,
    DeleteCommentMutationVariables
  >(DeleteCommentMutationDocument, options);
}
export type DeleteCommentMutationHookResult = ReturnType<
  typeof useDeleteCommentMutation
>;
export type DeleteCommentMutationMutationResult =
  Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;
export const UpdateCommentMutationDocument = gql`
  mutation UpdateCommentMutation(
    $commentId: String!
    $postId: String!
    $updateCommentDtoInput: UpdateCommentDtoInput!
  ) {
    comment: updateComment(
      commentId: $commentId
      postId: $postId
      updateCommentDtoInput: $updateCommentDtoInput
    ) {
      ...CommentItemCommentFields
    }
  }
  ${CommentItemCommentFieldsFragmentDoc}
`;
export type UpdateCommentMutationMutationFn = Apollo.MutationFunction<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      postId: // value for 'postId'
 *      updateCommentDtoInput: // value for 'updateCommentDtoInput'
 *   },
 * });
 */
export function useUpdateCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCommentMutation,
    UpdateCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCommentMutation,
    UpdateCommentMutationVariables
  >(UpdateCommentMutationDocument, options);
}
export type UpdateCommentMutationHookResult = ReturnType<
  typeof useUpdateCommentMutation
>;
export type UpdateCommentMutationMutationResult =
  Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
>;
export const AddReactionToCommentMutationDocument = gql`
  mutation AddReactionToCommentMutation(
    $commentId: String!
    $postId: String!
    $addReactionToCommentDtoInput: AddReactionToCommentDtoInput!
  ) {
    addReactionToComment(
      commentId: $commentId
      postId: $postId
      addReactionToCommentDtoInput: $addReactionToCommentDtoInput
    ) {
      id
      reactions {
        memberId
        name
      }
      reactionsCount
    }
  }
`;
export type AddReactionToCommentMutationMutationFn = Apollo.MutationFunction<
  AddReactionToCommentMutation,
  AddReactionToCommentMutationVariables
>;

/**
 * __useAddReactionToCommentMutation__
 *
 * To run a mutation, you first call `useAddReactionToCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionToCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionToCommentMutation, { data, loading, error }] = useAddReactionToCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      postId: // value for 'postId'
 *      addReactionToCommentDtoInput: // value for 'addReactionToCommentDtoInput'
 *   },
 * });
 */
export function useAddReactionToCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddReactionToCommentMutation,
    AddReactionToCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddReactionToCommentMutation,
    AddReactionToCommentMutationVariables
  >(AddReactionToCommentMutationDocument, options);
}
export type AddReactionToCommentMutationHookResult = ReturnType<
  typeof useAddReactionToCommentMutation
>;
export type AddReactionToCommentMutationMutationResult =
  Apollo.MutationResult<AddReactionToCommentMutation>;
export type AddReactionToCommentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    AddReactionToCommentMutation,
    AddReactionToCommentMutationVariables
  >;
export const RemoveReactionFromCommentMutationDocument = gql`
  mutation RemoveReactionFromCommentMutation(
    $commentId: String!
    $postId: String!
    $removeReactionFromCommentDtoInput: RemoveReactionFromCommentDtoInput!
  ) {
    removeReactionFromComment(
      commentId: $commentId
      postId: $postId
      removeReactionFromCommentDtoInput: $removeReactionFromCommentDtoInput
    ) {
      id
      reactions {
        memberId
        name
      }
      reactionsCount
    }
  }
`;
export type RemoveReactionFromCommentMutationMutationFn =
  Apollo.MutationFunction<
    RemoveReactionFromCommentMutation,
    RemoveReactionFromCommentMutationVariables
  >;

/**
 * __useRemoveReactionFromCommentMutation__
 *
 * To run a mutation, you first call `useRemoveReactionFromCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReactionFromCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReactionFromCommentMutation, { data, loading, error }] = useRemoveReactionFromCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      postId: // value for 'postId'
 *      removeReactionFromCommentDtoInput: // value for 'removeReactionFromCommentDtoInput'
 *   },
 * });
 */
export function useRemoveReactionFromCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveReactionFromCommentMutation,
    RemoveReactionFromCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveReactionFromCommentMutation,
    RemoveReactionFromCommentMutationVariables
  >(RemoveReactionFromCommentMutationDocument, options);
}
export type RemoveReactionFromCommentMutationHookResult = ReturnType<
  typeof useRemoveReactionFromCommentMutation
>;
export type RemoveReactionFromCommentMutationMutationResult =
  Apollo.MutationResult<RemoveReactionFromCommentMutation>;
export type RemoveReactionFromCommentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveReactionFromCommentMutation,
    RemoveReactionFromCommentMutationVariables
  >;
export const CommentItemDocument = gql`
  query CommentItem(
    $classroomId: String!
    $commentId: String!
    $postId: String!
  ) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
    }
    commentPermission: getCommentPermission(
      commentId: $commentId
      postId: $postId
    ) {
      canEdit
      canDelete
      canReact
      canWriteReply
    }
  }
`;

/**
 * __useCommentItemQuery__
 *
 * To run a query within a React component, call `useCommentItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentItemQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      commentId: // value for 'commentId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useCommentItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    CommentItemQuery,
    CommentItemQueryVariables
  > &
    (
      | { variables: CommentItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CommentItemQuery, CommentItemQueryVariables>(
    CommentItemDocument,
    options
  );
}
export function useCommentItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommentItemQuery,
    CommentItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CommentItemQuery, CommentItemQueryVariables>(
    CommentItemDocument,
    options
  );
}
export function useCommentItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CommentItemQuery,
        CommentItemQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CommentItemQuery, CommentItemQueryVariables>(
    CommentItemDocument,
    options
  );
}
export type CommentItemQueryHookResult = ReturnType<typeof useCommentItemQuery>;
export type CommentItemLazyQueryHookResult = ReturnType<
  typeof useCommentItemLazyQuery
>;
export type CommentItemSuspenseQueryHookResult = ReturnType<
  typeof useCommentItemSuspenseQuery
>;
export type CommentItemQueryResult = Apollo.QueryResult<
  CommentItemQuery,
  CommentItemQueryVariables
>;
export const CommentListDocument = gql`
  query CommentList($classroomId: String!, $postId: String!) {
    postPermission: getPostPermission(
      classroomId: $classroomId
      postId: $postId
    ) {
      canWriteComment
    }
  }
`;

/**
 * __useCommentListQuery__
 *
 * To run a query within a React component, call `useCommentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useCommentListQuery(
  baseOptions: Apollo.QueryHookOptions<
    CommentListQuery,
    CommentListQueryVariables
  > &
    (
      | { variables: CommentListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CommentListQuery, CommentListQueryVariables>(
    CommentListDocument,
    options
  );
}
export function useCommentListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommentListQuery,
    CommentListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CommentListQuery, CommentListQueryVariables>(
    CommentListDocument,
    options
  );
}
export function useCommentListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CommentListQuery,
        CommentListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CommentListQuery, CommentListQueryVariables>(
    CommentListDocument,
    options
  );
}
export type CommentListQueryHookResult = ReturnType<typeof useCommentListQuery>;
export type CommentListLazyQueryHookResult = ReturnType<
  typeof useCommentListLazyQuery
>;
export type CommentListSuspenseQueryHookResult = ReturnType<
  typeof useCommentListSuspenseQuery
>;
export type CommentListQueryResult = Apollo.QueryResult<
  CommentListQuery,
  CommentListQueryVariables
>;
export const PostCommentsQueryDocument = gql`
  query PostCommentsQuery(
    $classroomId: String!
    $postId: String!
    $cursor: String
    $limit: Float
  ) {
    postComments: listPostComments(
      classroomId: $classroomId
      postId: $postId
      cursor: $cursor
      limit: $limit
    ) {
      cursor
      comments {
        ...CommentItemCommentFields
      }
    }
  }
  ${CommentItemCommentFieldsFragmentDoc}
`;

/**
 * __usePostCommentsQuery__
 *
 * To run a query within a React component, call `usePostCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostCommentsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePostCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostCommentsQuery,
    PostCommentsQueryVariables
  > &
    (
      | { variables: PostCommentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostCommentsQuery, PostCommentsQueryVariables>(
    PostCommentsQueryDocument,
    options
  );
}
export function usePostCommentsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostCommentsQuery,
    PostCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostCommentsQuery, PostCommentsQueryVariables>(
    PostCommentsQueryDocument,
    options
  );
}
export function usePostCommentsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostCommentsQuery,
        PostCommentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PostCommentsQuery, PostCommentsQueryVariables>(
    PostCommentsQueryDocument,
    options
  );
}
export type PostCommentsQueryHookResult = ReturnType<
  typeof usePostCommentsQuery
>;
export type PostCommentsQueryLazyQueryHookResult = ReturnType<
  typeof usePostCommentsQueryLazyQuery
>;
export type PostCommentsQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostCommentsQuerySuspenseQuery
>;
export type PostCommentsQueryQueryResult = Apollo.QueryResult<
  PostCommentsQuery,
  PostCommentsQueryVariables
>;
export const UpdateReplyMutationDocument = gql`
  mutation UpdateReplyMutation(
    $commentId: String!
    $replyId: String!
    $updateReplyDtoInput: UpdateReplyDtoInput!
  ) {
    reply: updateReply(
      commentId: $commentId
      replyId: $replyId
      updateReplyDtoInput: $updateReplyDtoInput
    ) {
      ...ReplyItemReplyFields
    }
  }
  ${ReplyItemReplyFieldsFragmentDoc}
`;
export type UpdateReplyMutationMutationFn = Apollo.MutationFunction<
  UpdateReplyMutation,
  UpdateReplyMutationVariables
>;

/**
 * __useUpdateReplyMutation__
 *
 * To run a mutation, you first call `useUpdateReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReplyMutation, { data, loading, error }] = useUpdateReplyMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *      updateReplyDtoInput: // value for 'updateReplyDtoInput'
 *   },
 * });
 */
export function useUpdateReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateReplyMutation,
    UpdateReplyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateReplyMutation, UpdateReplyMutationVariables>(
    UpdateReplyMutationDocument,
    options
  );
}
export type UpdateReplyMutationHookResult = ReturnType<
  typeof useUpdateReplyMutation
>;
export type UpdateReplyMutationMutationResult =
  Apollo.MutationResult<UpdateReplyMutation>;
export type UpdateReplyMutationMutationOptions = Apollo.BaseMutationOptions<
  UpdateReplyMutation,
  UpdateReplyMutationVariables
>;
export const DeleteReplyMutationDocument = gql`
  mutation DeleteReplyMutation($commentId: String!, $replyId: String!) {
    deleteReply(commentId: $commentId, replyId: $replyId)
  }
`;
export type DeleteReplyMutationMutationFn = Apollo.MutationFunction<
  DeleteReplyMutation,
  DeleteReplyMutationVariables
>;

/**
 * __useDeleteReplyMutation__
 *
 * To run a mutation, you first call `useDeleteReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReplyMutation, { data, loading, error }] = useDeleteReplyMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *   },
 * });
 */
export function useDeleteReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteReplyMutation,
    DeleteReplyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteReplyMutation, DeleteReplyMutationVariables>(
    DeleteReplyMutationDocument,
    options
  );
}
export type DeleteReplyMutationHookResult = ReturnType<
  typeof useDeleteReplyMutation
>;
export type DeleteReplyMutationMutationResult =
  Apollo.MutationResult<DeleteReplyMutation>;
export type DeleteReplyMutationMutationOptions = Apollo.BaseMutationOptions<
  DeleteReplyMutation,
  DeleteReplyMutationVariables
>;
export const AddReactionToReplyMutationDocument = gql`
  mutation AddReactionToReplyMutation(
    $postId: String!
    $commentId: String!
    $replyId: String!
    $addReactionToReplyDtoInput: AddReactionToReplyDtoInput!
  ) {
    addReactionToReply(
      postId: $postId
      commentId: $commentId
      replyId: $replyId
      addReactionToReplyDtoInput: $addReactionToReplyDtoInput
    ) {
      id
      reactions {
        memberId
        name
      }
      reactionsCount
    }
  }
`;
export type AddReactionToReplyMutationMutationFn = Apollo.MutationFunction<
  AddReactionToReplyMutation,
  AddReactionToReplyMutationVariables
>;

/**
 * __useAddReactionToReplyMutation__
 *
 * To run a mutation, you first call `useAddReactionToReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionToReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionToReplyMutation, { data, loading, error }] = useAddReactionToReplyMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *      addReactionToReplyDtoInput: // value for 'addReactionToReplyDtoInput'
 *   },
 * });
 */
export function useAddReactionToReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddReactionToReplyMutation,
    AddReactionToReplyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddReactionToReplyMutation,
    AddReactionToReplyMutationVariables
  >(AddReactionToReplyMutationDocument, options);
}
export type AddReactionToReplyMutationHookResult = ReturnType<
  typeof useAddReactionToReplyMutation
>;
export type AddReactionToReplyMutationMutationResult =
  Apollo.MutationResult<AddReactionToReplyMutation>;
export type AddReactionToReplyMutationMutationOptions =
  Apollo.BaseMutationOptions<
    AddReactionToReplyMutation,
    AddReactionToReplyMutationVariables
  >;
export const RemoveReactionFromReplyDocument = gql`
  mutation RemoveReactionFromReply(
    $postId: String!
    $commentId: String!
    $replyId: String!
    $removeReactionFromReplyDtoInput: RemoveReactionFromReplyDtoInput!
  ) {
    removeReactionFromReply(
      postId: $postId
      commentId: $commentId
      replyId: $replyId
      removeReactionFromReplyDtoInput: $removeReactionFromReplyDtoInput
    ) {
      id
      reactions {
        name
        memberId
      }
      reactionsCount
    }
  }
`;
export type RemoveReactionFromReplyMutationFn = Apollo.MutationFunction<
  RemoveReactionFromReplyMutation,
  RemoveReactionFromReplyMutationVariables
>;

/**
 * __useRemoveReactionFromReplyMutation__
 *
 * To run a mutation, you first call `useRemoveReactionFromReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReactionFromReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReactionFromReplyMutation, { data, loading, error }] = useRemoveReactionFromReplyMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *      removeReactionFromReplyDtoInput: // value for 'removeReactionFromReplyDtoInput'
 *   },
 * });
 */
export function useRemoveReactionFromReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveReactionFromReplyMutation,
    RemoveReactionFromReplyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveReactionFromReplyMutation,
    RemoveReactionFromReplyMutationVariables
  >(RemoveReactionFromReplyDocument, options);
}
export type RemoveReactionFromReplyMutationHookResult = ReturnType<
  typeof useRemoveReactionFromReplyMutation
>;
export type RemoveReactionFromReplyMutationResult =
  Apollo.MutationResult<RemoveReactionFromReplyMutation>;
export type RemoveReactionFromReplyMutationOptions = Apollo.BaseMutationOptions<
  RemoveReactionFromReplyMutation,
  RemoveReactionFromReplyMutationVariables
>;
export const ReplyItemQueryDocument = gql`
  query ReplyItemQuery(
    $classroomId: String!
    $commentId: String!
    $replyId: String!
  ) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
    }
    replyPermission: getReplyPermission(
      classroomId: $classroomId
      commentId: $commentId
      replyId: $replyId
    ) {
      canDelete
      canEdit
      canReact
    }
  }
`;

/**
 * __useReplyItemQuery__
 *
 * To run a query within a React component, call `useReplyItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplyItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplyItemQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *   },
 * });
 */
export function useReplyItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReplyItemQuery,
    ReplyItemQueryVariables
  > &
    ({ variables: ReplyItemQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReplyItemQuery, ReplyItemQueryVariables>(
    ReplyItemQueryDocument,
    options
  );
}
export function useReplyItemQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReplyItemQuery,
    ReplyItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReplyItemQuery, ReplyItemQueryVariables>(
    ReplyItemQueryDocument,
    options
  );
}
export function useReplyItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReplyItemQuery, ReplyItemQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReplyItemQuery, ReplyItemQueryVariables>(
    ReplyItemQueryDocument,
    options
  );
}
export type ReplyItemQueryHookResult = ReturnType<typeof useReplyItemQuery>;
export type ReplyItemQueryLazyQueryHookResult = ReturnType<
  typeof useReplyItemQueryLazyQuery
>;
export type ReplyItemQuerySuspenseQueryHookResult = ReturnType<
  typeof useReplyItemQuerySuspenseQuery
>;
export type ReplyItemQueryQueryResult = Apollo.QueryResult<
  ReplyItemQuery,
  ReplyItemQueryVariables
>;
export const ReplyListQueryDocument = gql`
  query ReplyListQuery($commentId: String!, $postId: String!) {
    commentPermission: getCommentPermission(
      commentId: $commentId
      postId: $postId
    ) {
      canEdit
      canDelete
      canReact
      canWriteReply
    }
  }
`;

/**
 * __useReplyListQuery__
 *
 * To run a query within a React component, call `useReplyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplyListQuery({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useReplyListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReplyListQuery,
    ReplyListQueryVariables
  > &
    ({ variables: ReplyListQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReplyListQuery, ReplyListQueryVariables>(
    ReplyListQueryDocument,
    options
  );
}
export function useReplyListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReplyListQuery,
    ReplyListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReplyListQuery, ReplyListQueryVariables>(
    ReplyListQueryDocument,
    options
  );
}
export function useReplyListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReplyListQuery, ReplyListQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReplyListQuery, ReplyListQueryVariables>(
    ReplyListQueryDocument,
    options
  );
}
export type ReplyListQueryHookResult = ReturnType<typeof useReplyListQuery>;
export type ReplyListQueryLazyQueryHookResult = ReturnType<
  typeof useReplyListQueryLazyQuery
>;
export type ReplyListQuerySuspenseQueryHookResult = ReturnType<
  typeof useReplyListQuerySuspenseQuery
>;
export type ReplyListQueryQueryResult = Apollo.QueryResult<
  ReplyListQuery,
  ReplyListQueryVariables
>;
export const RepliesQueryDocument = gql`
  query RepliesQuery(
    $classroomId: String!
    $postId: String!
    $commentId: String!
    $limit: Float
    $cursor: String
  ) {
    replyList: listReplies(
      classroomId: $classroomId
      postId: $postId
      commentId: $commentId
      limit: $limit
      cursor: $cursor
    ) {
      cursor
      replies {
        ...ReplyItemReplyFields
      }
    }
  }
  ${ReplyItemReplyFieldsFragmentDoc}
`;

/**
 * __useRepliesQuery__
 *
 * To run a query within a React component, call `useRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepliesQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useRepliesQuery(
  baseOptions: Apollo.QueryHookOptions<RepliesQuery, RepliesQueryVariables> &
    ({ variables: RepliesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RepliesQuery, RepliesQueryVariables>(
    RepliesQueryDocument,
    options
  );
}
export function useRepliesQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RepliesQuery, RepliesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RepliesQuery, RepliesQueryVariables>(
    RepliesQueryDocument,
    options
  );
}
export function useRepliesQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RepliesQuery, RepliesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RepliesQuery, RepliesQueryVariables>(
    RepliesQueryDocument,
    options
  );
}
export type RepliesQueryHookResult = ReturnType<typeof useRepliesQuery>;
export type RepliesQueryLazyQueryHookResult = ReturnType<
  typeof useRepliesQueryLazyQuery
>;
export type RepliesQuerySuspenseQueryHookResult = ReturnType<
  typeof useRepliesQuerySuspenseQuery
>;
export type RepliesQueryQueryResult = Apollo.QueryResult<
  RepliesQuery,
  RepliesQueryVariables
>;
export const CreateCommentMutationDocument = gql`
  mutation CreateCommentMutation(
    $classroomId: String!
    $postId: String!
    $createCommentDtoInput: CreateCommentDtoInput!
  ) {
    comment: createComment(
      classroomId: $classroomId
      postId: $postId
      createCommentDtoInput: $createCommentDtoInput
    ) {
      ...CommentItemCommentFields
    }
  }
  ${CommentItemCommentFieldsFragmentDoc}
`;
export type CreateCommentMutationMutationFn = Apollo.MutationFunction<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      createCommentDtoInput: // value for 'createCommentDtoInput'
 *   },
 * });
 */
export function useCreateCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCommentMutation,
    CreateCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCommentMutation,
    CreateCommentMutationVariables
  >(CreateCommentMutationDocument, options);
}
export type CreateCommentMutationHookResult = ReturnType<
  typeof useCreateCommentMutation
>;
export type CreateCommentMutationMutationResult =
  Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;
export const CreateReplyMutationDocument = gql`
  mutation CreateReplyMutation(
    $classroomId: String!
    $postId: String!
    $commentId: String!
    $createReplyDtoInput: CreateReplyDtoInput!
  ) {
    reply: createReply(
      classroomId: $classroomId
      postId: $postId
      commentId: $commentId
      createReplyDtoInput: $createReplyDtoInput
    ) {
      ...ReplyItemReplyFields
    }
  }
  ${ReplyItemReplyFieldsFragmentDoc}
`;
export type CreateReplyMutationMutationFn = Apollo.MutationFunction<
  CreateReplyMutation,
  CreateReplyMutationVariables
>;

/**
 * __useCreateReplyMutation__
 *
 * To run a mutation, you first call `useCreateReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReplyMutation, { data, loading, error }] = useCreateReplyMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      createReplyDtoInput: // value for 'createReplyDtoInput'
 *   },
 * });
 */
export function useCreateReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReplyMutation,
    CreateReplyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateReplyMutation, CreateReplyMutationVariables>(
    CreateReplyMutationDocument,
    options
  );
}
export type CreateReplyMutationHookResult = ReturnType<
  typeof useCreateReplyMutation
>;
export type CreateReplyMutationMutationResult =
  Apollo.MutationResult<CreateReplyMutation>;
export type CreateReplyMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateReplyMutation,
  CreateReplyMutationVariables
>;
export const CommentReactionsPageQueryDocument = gql`
  query CommentReactionsPageQuery(
    $classroomId: String!
    $postId: String!
    $commentId: String!
  ) {
    clap: listCommentReactions(
      classroomId: $classroomId
      postId: $postId
      commentId: $commentId
      name: "clap"
    ) {
      reactions {
        ...CommentItemCommentReactionFields
      }
    }
    check: listCommentReactions(
      classroomId: $classroomId
      postId: $postId
      commentId: $commentId
      name: "check"
    ) {
      reactions {
        ...CommentItemCommentReactionFields
      }
    }
  }
  ${CommentItemCommentReactionFieldsFragmentDoc}
`;

/**
 * __useCommentReactionsPageQuery__
 *
 * To run a query within a React component, call `useCommentReactionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentReactionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentReactionsPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useCommentReactionsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    CommentReactionsPageQuery,
    CommentReactionsPageQueryVariables
  > &
    (
      | { variables: CommentReactionsPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CommentReactionsPageQuery,
    CommentReactionsPageQueryVariables
  >(CommentReactionsPageQueryDocument, options);
}
export function useCommentReactionsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommentReactionsPageQuery,
    CommentReactionsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CommentReactionsPageQuery,
    CommentReactionsPageQueryVariables
  >(CommentReactionsPageQueryDocument, options);
}
export function useCommentReactionsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CommentReactionsPageQuery,
        CommentReactionsPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CommentReactionsPageQuery,
    CommentReactionsPageQueryVariables
  >(CommentReactionsPageQueryDocument, options);
}
export type CommentReactionsPageQueryHookResult = ReturnType<
  typeof useCommentReactionsPageQuery
>;
export type CommentReactionsPageQueryLazyQueryHookResult = ReturnType<
  typeof useCommentReactionsPageQueryLazyQuery
>;
export type CommentReactionsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useCommentReactionsPageQuerySuspenseQuery
>;
export type CommentReactionsPageQueryQueryResult = Apollo.QueryResult<
  CommentReactionsPageQuery,
  CommentReactionsPageQueryVariables
>;
export const ReplyReactionsPageQueryDocument = gql`
  query ReplyReactionsPageQuery(
    $classroomId: String!
    $commentId: String!
    $replyId: String!
  ) {
    clap: listReplyReactions(
      classroomId: $classroomId
      commentId: $commentId
      replyId: $replyId
      name: "clap"
    ) {
      reactions {
        ...ReplyItemReplyReactionFields
      }
    }
    check: listReplyReactions(
      classroomId: $classroomId
      commentId: $commentId
      replyId: $replyId
      name: "check"
    ) {
      reactions {
        ...ReplyItemReplyReactionFields
      }
    }
  }
  ${ReplyItemReplyReactionFieldsFragmentDoc}
`;

/**
 * __useReplyReactionsPageQuery__
 *
 * To run a query within a React component, call `useReplyReactionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplyReactionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplyReactionsPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *   },
 * });
 */
export function useReplyReactionsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReplyReactionsPageQuery,
    ReplyReactionsPageQueryVariables
  > &
    (
      | { variables: ReplyReactionsPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReplyReactionsPageQuery,
    ReplyReactionsPageQueryVariables
  >(ReplyReactionsPageQueryDocument, options);
}
export function useReplyReactionsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReplyReactionsPageQuery,
    ReplyReactionsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReplyReactionsPageQuery,
    ReplyReactionsPageQueryVariables
  >(ReplyReactionsPageQueryDocument, options);
}
export function useReplyReactionsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReplyReactionsPageQuery,
        ReplyReactionsPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ReplyReactionsPageQuery,
    ReplyReactionsPageQueryVariables
  >(ReplyReactionsPageQueryDocument, options);
}
export type ReplyReactionsPageQueryHookResult = ReturnType<
  typeof useReplyReactionsPageQuery
>;
export type ReplyReactionsPageQueryLazyQueryHookResult = ReturnType<
  typeof useReplyReactionsPageQueryLazyQuery
>;
export type ReplyReactionsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useReplyReactionsPageQuerySuspenseQuery
>;
export type ReplyReactionsPageQueryQueryResult = Apollo.QueryResult<
  ReplyReactionsPageQuery,
  ReplyReactionsPageQueryVariables
>;
export const CumulativeRecordsPageQueryDocument = gql`
  query CumulativeRecordsPageQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useCumulativeRecordsPageQuery__
 *
 * To run a query within a React component, call `useCumulativeRecordsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCumulativeRecordsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCumulativeRecordsPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useCumulativeRecordsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    CumulativeRecordsPageQuery,
    CumulativeRecordsPageQueryVariables
  > &
    (
      | { variables: CumulativeRecordsPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CumulativeRecordsPageQuery,
    CumulativeRecordsPageQueryVariables
  >(CumulativeRecordsPageQueryDocument, options);
}
export function useCumulativeRecordsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CumulativeRecordsPageQuery,
    CumulativeRecordsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CumulativeRecordsPageQuery,
    CumulativeRecordsPageQueryVariables
  >(CumulativeRecordsPageQueryDocument, options);
}
export function useCumulativeRecordsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CumulativeRecordsPageQuery,
        CumulativeRecordsPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CumulativeRecordsPageQuery,
    CumulativeRecordsPageQueryVariables
  >(CumulativeRecordsPageQueryDocument, options);
}
export type CumulativeRecordsPageQueryHookResult = ReturnType<
  typeof useCumulativeRecordsPageQuery
>;
export type CumulativeRecordsPageQueryLazyQueryHookResult = ReturnType<
  typeof useCumulativeRecordsPageQueryLazyQuery
>;
export type CumulativeRecordsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useCumulativeRecordsPageQuerySuspenseQuery
>;
export type CumulativeRecordsPageQueryQueryResult = Apollo.QueryResult<
  CumulativeRecordsPageQuery,
  CumulativeRecordsPageQueryVariables
>;
export const InsightsPageQueryDocument = gql`
  query InsightsPageQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
      group
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      countryCode
    }
    me: getMe {
      id
      language
    }
  }
`;

/**
 * __useInsightsPageQuery__
 *
 * To run a query within a React component, call `useInsightsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useInsightsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    InsightsPageQuery,
    InsightsPageQueryVariables
  > &
    (
      | { variables: InsightsPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InsightsPageQuery, InsightsPageQueryVariables>(
    InsightsPageQueryDocument,
    options
  );
}
export function useInsightsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InsightsPageQuery,
    InsightsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InsightsPageQuery, InsightsPageQueryVariables>(
    InsightsPageQueryDocument,
    options
  );
}
export function useInsightsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsightsPageQuery,
        InsightsPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InsightsPageQuery, InsightsPageQueryVariables>(
    InsightsPageQueryDocument,
    options
  );
}
export type InsightsPageQueryHookResult = ReturnType<
  typeof useInsightsPageQuery
>;
export type InsightsPageQueryLazyQueryHookResult = ReturnType<
  typeof useInsightsPageQueryLazyQuery
>;
export type InsightsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useInsightsPageQuerySuspenseQuery
>;
export type InsightsPageQueryQueryResult = Apollo.QueryResult<
  InsightsPageQuery,
  InsightsPageQueryVariables
>;
export const MemberInfoQueryDocument = gql`
  query MemberInfoQuery($classroomId: String!, $memberId: String!) {
    targetMember: getClassroomMember(
      classroomId: $classroomId
      memberId: $memberId
    ) {
      ...ClasstalkChatButtonMemberFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      ...ClasstalkChatButtonMemberFields
    }
  }
  ${ClasstalkChatButtonMemberFieldsFragmentDoc}
`;

/**
 * __useMemberInfoQuery__
 *
 * To run a query within a React component, call `useMemberInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberInfoQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberInfoQuery,
    MemberInfoQueryVariables
  > &
    (
      | { variables: MemberInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemberInfoQuery, MemberInfoQueryVariables>(
    MemberInfoQueryDocument,
    options
  );
}
export function useMemberInfoQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberInfoQuery,
    MemberInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberInfoQuery, MemberInfoQueryVariables>(
    MemberInfoQueryDocument,
    options
  );
}
export function useMemberInfoQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemberInfoQuery, MemberInfoQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MemberInfoQuery, MemberInfoQueryVariables>(
    MemberInfoQueryDocument,
    options
  );
}
export type MemberInfoQueryHookResult = ReturnType<typeof useMemberInfoQuery>;
export type MemberInfoQueryLazyQueryHookResult = ReturnType<
  typeof useMemberInfoQueryLazyQuery
>;
export type MemberInfoQuerySuspenseQueryHookResult = ReturnType<
  typeof useMemberInfoQuerySuspenseQuery
>;
export type MemberInfoQueryQueryResult = Apollo.QueryResult<
  MemberInfoQuery,
  MemberInfoQueryVariables
>;
export const MemberInfoChangePopupMutationDocument = gql`
  mutation MemberInfoChangePopupMutation(
    $classroomId: String!
    $memberId: String!
    $updateMemberDtoInput: UpdateMemberDtoInput!
  ) {
    member: updateClassroomMember(
      classroomId: $classroomId
      memberId: $memberId
      updateMemberDtoInput: $updateMemberDtoInput
    ) {
      ...MemberItemMemberFields
    }
  }
  ${MemberItemMemberFieldsFragmentDoc}
`;
export type MemberInfoChangePopupMutationMutationFn = Apollo.MutationFunction<
  MemberInfoChangePopupMutation,
  MemberInfoChangePopupMutationVariables
>;

/**
 * __useMemberInfoChangePopupMutation__
 *
 * To run a mutation, you first call `useMemberInfoChangePopupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMemberInfoChangePopupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [memberInfoChangePopupMutation, { data, loading, error }] = useMemberInfoChangePopupMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *      updateMemberDtoInput: // value for 'updateMemberDtoInput'
 *   },
 * });
 */
export function useMemberInfoChangePopupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MemberInfoChangePopupMutation,
    MemberInfoChangePopupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MemberInfoChangePopupMutation,
    MemberInfoChangePopupMutationVariables
  >(MemberInfoChangePopupMutationDocument, options);
}
export type MemberInfoChangePopupMutationHookResult = ReturnType<
  typeof useMemberInfoChangePopupMutation
>;
export type MemberInfoChangePopupMutationMutationResult =
  Apollo.MutationResult<MemberInfoChangePopupMutation>;
export type MemberInfoChangePopupMutationMutationOptions =
  Apollo.BaseMutationOptions<
    MemberInfoChangePopupMutation,
    MemberInfoChangePopupMutationVariables
  >;
export const MemberInfoChangePopupQueryDocument = gql`
  query MemberInfoChangePopupQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
`;

/**
 * __useMemberInfoChangePopupQuery__
 *
 * To run a query within a React component, call `useMemberInfoChangePopupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberInfoChangePopupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberInfoChangePopupQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useMemberInfoChangePopupQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberInfoChangePopupQuery,
    MemberInfoChangePopupQueryVariables
  > &
    (
      | { variables: MemberInfoChangePopupQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MemberInfoChangePopupQuery,
    MemberInfoChangePopupQueryVariables
  >(MemberInfoChangePopupQueryDocument, options);
}
export function useMemberInfoChangePopupQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberInfoChangePopupQuery,
    MemberInfoChangePopupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberInfoChangePopupQuery,
    MemberInfoChangePopupQueryVariables
  >(MemberInfoChangePopupQueryDocument, options);
}
export function useMemberInfoChangePopupQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberInfoChangePopupQuery,
        MemberInfoChangePopupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberInfoChangePopupQuery,
    MemberInfoChangePopupQueryVariables
  >(MemberInfoChangePopupQueryDocument, options);
}
export type MemberInfoChangePopupQueryHookResult = ReturnType<
  typeof useMemberInfoChangePopupQuery
>;
export type MemberInfoChangePopupQueryLazyQueryHookResult = ReturnType<
  typeof useMemberInfoChangePopupQueryLazyQuery
>;
export type MemberInfoChangePopupQuerySuspenseQueryHookResult = ReturnType<
  typeof useMemberInfoChangePopupQuerySuspenseQuery
>;
export type MemberInfoChangePopupQueryQueryResult = Apollo.QueryResult<
  MemberInfoChangePopupQuery,
  MemberInfoChangePopupQueryVariables
>;
export const MemberInsightsTabsQueryDocument = gql`
  query MemberInsightsTabsQuery($classroomId: String!, $memberId: String!) {
    member: getClassroomMember(classroomId: $classroomId, memberId: $memberId) {
      id
      role
      group
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useMemberInsightsTabsQuery__
 *
 * To run a query within a React component, call `useMemberInsightsTabsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberInsightsTabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberInsightsTabsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberInsightsTabsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberInsightsTabsQuery,
    MemberInsightsTabsQueryVariables
  > &
    (
      | { variables: MemberInsightsTabsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MemberInsightsTabsQuery,
    MemberInsightsTabsQueryVariables
  >(MemberInsightsTabsQueryDocument, options);
}
export function useMemberInsightsTabsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberInsightsTabsQuery,
    MemberInsightsTabsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberInsightsTabsQuery,
    MemberInsightsTabsQueryVariables
  >(MemberInsightsTabsQueryDocument, options);
}
export function useMemberInsightsTabsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberInsightsTabsQuery,
        MemberInsightsTabsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberInsightsTabsQuery,
    MemberInsightsTabsQueryVariables
  >(MemberInsightsTabsQueryDocument, options);
}
export type MemberInsightsTabsQueryHookResult = ReturnType<
  typeof useMemberInsightsTabsQuery
>;
export type MemberInsightsTabsQueryLazyQueryHookResult = ReturnType<
  typeof useMemberInsightsTabsQueryLazyQuery
>;
export type MemberInsightsTabsQuerySuspenseQueryHookResult = ReturnType<
  typeof useMemberInsightsTabsQuerySuspenseQuery
>;
export type MemberInsightsTabsQueryQueryResult = Apollo.QueryResult<
  MemberInsightsTabsQuery,
  MemberInsightsTabsQueryVariables
>;
export const MemberProfileImageQueryDocument = gql`
  query MemberProfileImageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
`;

/**
 * __useMemberProfileImageQuery__
 *
 * To run a query within a React component, call `useMemberProfileImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberProfileImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberProfileImageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useMemberProfileImageQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberProfileImageQuery,
    MemberProfileImageQueryVariables
  > &
    (
      | { variables: MemberProfileImageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MemberProfileImageQuery,
    MemberProfileImageQueryVariables
  >(MemberProfileImageQueryDocument, options);
}
export function useMemberProfileImageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberProfileImageQuery,
    MemberProfileImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberProfileImageQuery,
    MemberProfileImageQueryVariables
  >(MemberProfileImageQueryDocument, options);
}
export function useMemberProfileImageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberProfileImageQuery,
        MemberProfileImageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberProfileImageQuery,
    MemberProfileImageQueryVariables
  >(MemberProfileImageQueryDocument, options);
}
export type MemberProfileImageQueryHookResult = ReturnType<
  typeof useMemberProfileImageQuery
>;
export type MemberProfileImageQueryLazyQueryHookResult = ReturnType<
  typeof useMemberProfileImageQueryLazyQuery
>;
export type MemberProfileImageQuerySuspenseQueryHookResult = ReturnType<
  typeof useMemberProfileImageQuerySuspenseQuery
>;
export type MemberProfileImageQueryQueryResult = Apollo.QueryResult<
  MemberProfileImageQuery,
  MemberProfileImageQueryVariables
>;
export const NotificationBellQueryDocument = gql`
  query NotificationBellQuery($classroomId: String!) {
    notificationsCollection: listNotifications(limit: 1) {
      ...NotificationListNotificationsCollectionFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
    }
  }
  ${NotificationListNotificationsCollectionFieldsFragmentDoc}
`;

/**
 * __useNotificationBellQuery__
 *
 * To run a query within a React component, call `useNotificationBellQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationBellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationBellQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useNotificationBellQuery(
  baseOptions: Apollo.QueryHookOptions<
    NotificationBellQuery,
    NotificationBellQueryVariables
  > &
    (
      | { variables: NotificationBellQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotificationBellQuery, NotificationBellQueryVariables>(
    NotificationBellQueryDocument,
    options
  );
}
export function useNotificationBellQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotificationBellQuery,
    NotificationBellQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NotificationBellQuery,
    NotificationBellQueryVariables
  >(NotificationBellQueryDocument, options);
}
export function useNotificationBellQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NotificationBellQuery,
        NotificationBellQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NotificationBellQuery,
    NotificationBellQueryVariables
  >(NotificationBellQueryDocument, options);
}
export type NotificationBellQueryHookResult = ReturnType<
  typeof useNotificationBellQuery
>;
export type NotificationBellQueryLazyQueryHookResult = ReturnType<
  typeof useNotificationBellQueryLazyQuery
>;
export type NotificationBellQuerySuspenseQueryHookResult = ReturnType<
  typeof useNotificationBellQuerySuspenseQuery
>;
export type NotificationBellQueryQueryResult = Apollo.QueryResult<
  NotificationBellQuery,
  NotificationBellQueryVariables
>;
export const NotificationLastSeenQueryDocument = gql`
  query NotificationLastSeenQuery($userId: String!) {
    notificationLastSeen(userId: $userId) @client {
      timestamp
    }
  }
`;

/**
 * __useNotificationLastSeenQuery__
 *
 * To run a query within a React component, call `useNotificationLastSeenQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationLastSeenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationLastSeenQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotificationLastSeenQuery(
  baseOptions: Apollo.QueryHookOptions<
    NotificationLastSeenQuery,
    NotificationLastSeenQueryVariables
  > &
    (
      | { variables: NotificationLastSeenQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NotificationLastSeenQuery,
    NotificationLastSeenQueryVariables
  >(NotificationLastSeenQueryDocument, options);
}
export function useNotificationLastSeenQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotificationLastSeenQuery,
    NotificationLastSeenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NotificationLastSeenQuery,
    NotificationLastSeenQueryVariables
  >(NotificationLastSeenQueryDocument, options);
}
export function useNotificationLastSeenQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NotificationLastSeenQuery,
        NotificationLastSeenQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NotificationLastSeenQuery,
    NotificationLastSeenQueryVariables
  >(NotificationLastSeenQueryDocument, options);
}
export type NotificationLastSeenQueryHookResult = ReturnType<
  typeof useNotificationLastSeenQuery
>;
export type NotificationLastSeenQueryLazyQueryHookResult = ReturnType<
  typeof useNotificationLastSeenQueryLazyQuery
>;
export type NotificationLastSeenQuerySuspenseQueryHookResult = ReturnType<
  typeof useNotificationLastSeenQuerySuspenseQuery
>;
export type NotificationLastSeenQueryQueryResult = Apollo.QueryResult<
  NotificationLastSeenQuery,
  NotificationLastSeenQueryVariables
>;
export const MarkNotificationAsReadMutationDocument = gql`
  mutation MarkNotificationAsReadMutation($notificationId: String!) {
    markNotificationAsRead(notificationId: $notificationId) {
      id
      read
    }
  }
`;
export type MarkNotificationAsReadMutationMutationFn = Apollo.MutationFunction<
  MarkNotificationAsReadMutation,
  MarkNotificationAsReadMutationVariables
>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkNotificationAsReadMutation,
    MarkNotificationAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkNotificationAsReadMutation,
    MarkNotificationAsReadMutationVariables
  >(MarkNotificationAsReadMutationDocument, options);
}
export type MarkNotificationAsReadMutationHookResult = ReturnType<
  typeof useMarkNotificationAsReadMutation
>;
export type MarkNotificationAsReadMutationMutationResult =
  Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationMutationOptions =
  Apollo.BaseMutationOptions<
    MarkNotificationAsReadMutation,
    MarkNotificationAsReadMutationVariables
  >;
export const NotificationListAccountQueryDocument = gql`
  query NotificationListAccountQuery {
    me: getMe {
      id
      role
      isAdFreeSubscribed
      grade
      language
      countryCode
      schoolInfoDto {
        grade
        school {
          zipcode
        }
      }
      schoolInfoDtoForChildren {
        grade
        school {
          zipcode
        }
      }
    }
  }
`;

/**
 * __useNotificationListAccountQuery__
 *
 * To run a query within a React component, call `useNotificationListAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationListAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationListAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationListAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NotificationListAccountQuery,
    NotificationListAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NotificationListAccountQuery,
    NotificationListAccountQueryVariables
  >(NotificationListAccountQueryDocument, options);
}
export function useNotificationListAccountQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotificationListAccountQuery,
    NotificationListAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NotificationListAccountQuery,
    NotificationListAccountQueryVariables
  >(NotificationListAccountQueryDocument, options);
}
export function useNotificationListAccountQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NotificationListAccountQuery,
        NotificationListAccountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NotificationListAccountQuery,
    NotificationListAccountQueryVariables
  >(NotificationListAccountQueryDocument, options);
}
export type NotificationListAccountQueryHookResult = ReturnType<
  typeof useNotificationListAccountQuery
>;
export type NotificationListAccountQueryLazyQueryHookResult = ReturnType<
  typeof useNotificationListAccountQueryLazyQuery
>;
export type NotificationListAccountQuerySuspenseQueryHookResult = ReturnType<
  typeof useNotificationListAccountQuerySuspenseQuery
>;
export type NotificationListAccountQueryQueryResult = Apollo.QueryResult<
  NotificationListAccountQuery,
  NotificationListAccountQueryVariables
>;
export const ClassroomNotificationsPageQueryDocument = gql`
  query ClassroomNotificationsPageQuery($limit: Float, $cursor: String) {
    notificationsCollection: listNotifications(limit: $limit, cursor: $cursor) {
      ...NotificationListNotificationsCollectionFields
    }
  }
  ${NotificationListNotificationsCollectionFieldsFragmentDoc}
`;

/**
 * __useClassroomNotificationsPageQuery__
 *
 * To run a query within a React component, call `useClassroomNotificationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomNotificationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomNotificationsPageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useClassroomNotificationsPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClassroomNotificationsPageQuery,
    ClassroomNotificationsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassroomNotificationsPageQuery,
    ClassroomNotificationsPageQueryVariables
  >(ClassroomNotificationsPageQueryDocument, options);
}
export function useClassroomNotificationsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomNotificationsPageQuery,
    ClassroomNotificationsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomNotificationsPageQuery,
    ClassroomNotificationsPageQueryVariables
  >(ClassroomNotificationsPageQueryDocument, options);
}
export function useClassroomNotificationsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomNotificationsPageQuery,
        ClassroomNotificationsPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomNotificationsPageQuery,
    ClassroomNotificationsPageQueryVariables
  >(ClassroomNotificationsPageQueryDocument, options);
}
export type ClassroomNotificationsPageQueryHookResult = ReturnType<
  typeof useClassroomNotificationsPageQuery
>;
export type ClassroomNotificationsPageQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomNotificationsPageQueryLazyQuery
>;
export type ClassroomNotificationsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomNotificationsPageQuerySuspenseQuery
>;
export type ClassroomNotificationsPageQueryQueryResult = Apollo.QueryResult<
  ClassroomNotificationsPageQuery,
  ClassroomNotificationsPageQueryVariables
>;
export const NotificationsPageQueryDocument = gql`
  query NotificationsPageQuery($limit: Float, $cursor: String) {
    notificationsCollection: listNotifications(limit: $limit, cursor: $cursor) {
      ...NotificationListNotificationsCollectionFields
    }
    me: getMe {
      isAdFreeSubscribed
    }
  }
  ${NotificationListNotificationsCollectionFieldsFragmentDoc}
`;

/**
 * __useNotificationsPageQuery__
 *
 * To run a query within a React component, call `useNotificationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsPageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useNotificationsPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NotificationsPageQuery,
    NotificationsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NotificationsPageQuery,
    NotificationsPageQueryVariables
  >(NotificationsPageQueryDocument, options);
}
export function useNotificationsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotificationsPageQuery,
    NotificationsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NotificationsPageQuery,
    NotificationsPageQueryVariables
  >(NotificationsPageQueryDocument, options);
}
export function useNotificationsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NotificationsPageQuery,
        NotificationsPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NotificationsPageQuery,
    NotificationsPageQueryVariables
  >(NotificationsPageQueryDocument, options);
}
export type NotificationsPageQueryHookResult = ReturnType<
  typeof useNotificationsPageQuery
>;
export type NotificationsPageQueryLazyQueryHookResult = ReturnType<
  typeof useNotificationsPageQueryLazyQuery
>;
export type NotificationsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useNotificationsPageQuerySuspenseQuery
>;
export type NotificationsPageQueryQueryResult = Apollo.QueryResult<
  NotificationsPageQuery,
  NotificationsPageQueryVariables
>;
export const AuthorInfoQueryDocument = gql`
  query AuthorInfoQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useAuthorInfoQuery__
 *
 * To run a query within a React component, call `useAuthorInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorInfoQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAuthorInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    AuthorInfoQuery,
    AuthorInfoQueryVariables
  > &
    (
      | { variables: AuthorInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AuthorInfoQuery, AuthorInfoQueryVariables>(
    AuthorInfoQueryDocument,
    options
  );
}
export function useAuthorInfoQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthorInfoQuery,
    AuthorInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AuthorInfoQuery, AuthorInfoQueryVariables>(
    AuthorInfoQueryDocument,
    options
  );
}
export function useAuthorInfoQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AuthorInfoQuery, AuthorInfoQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AuthorInfoQuery, AuthorInfoQueryVariables>(
    AuthorInfoQueryDocument,
    options
  );
}
export type AuthorInfoQueryHookResult = ReturnType<typeof useAuthorInfoQuery>;
export type AuthorInfoQueryLazyQueryHookResult = ReturnType<
  typeof useAuthorInfoQueryLazyQuery
>;
export type AuthorInfoQuerySuspenseQueryHookResult = ReturnType<
  typeof useAuthorInfoQuerySuspenseQuery
>;
export type AuthorInfoQueryQueryResult = Apollo.QueryResult<
  AuthorInfoQuery,
  AuthorInfoQueryVariables
>;
export const ChannelGalleryQueryDocument = gql`
  query ChannelGalleryQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
`;

/**
 * __useChannelGalleryQuery__
 *
 * To run a query within a React component, call `useChannelGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelGalleryQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelGalleryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelGalleryQuery,
    ChannelGalleryQueryVariables
  > &
    (
      | { variables: ChannelGalleryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelGalleryQuery, ChannelGalleryQueryVariables>(
    ChannelGalleryQueryDocument,
    options
  );
}
export function useChannelGalleryQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelGalleryQuery,
    ChannelGalleryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelGalleryQuery, ChannelGalleryQueryVariables>(
    ChannelGalleryQueryDocument,
    options
  );
}
export function useChannelGalleryQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelGalleryQuery,
        ChannelGalleryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelGalleryQuery,
    ChannelGalleryQueryVariables
  >(ChannelGalleryQueryDocument, options);
}
export type ChannelGalleryQueryHookResult = ReturnType<
  typeof useChannelGalleryQuery
>;
export type ChannelGalleryQueryLazyQueryHookResult = ReturnType<
  typeof useChannelGalleryQueryLazyQuery
>;
export type ChannelGalleryQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelGalleryQuerySuspenseQuery
>;
export type ChannelGalleryQueryQueryResult = Apollo.QueryResult<
  ChannelGalleryQuery,
  ChannelGalleryQueryVariables
>;
export const ChannelMediaPostsQueryDocument = gql`
  query ChannelMediaPostsQuery(
    $classroomId: String!
    $channelId: String!
    $page: Float
    $perPage: Float
  ) {
    postsCollection: listChannelMediaPosts(
      classroomId: $classroomId
      channelId: $channelId
      page: $page
      perPage: $perPage
    ) {
      page
      totalPages
      posts {
        ...GalleryPostDtoFields
      }
    }
  }
  ${GalleryPostDtoFieldsFragmentDoc}
`;

/**
 * __useChannelMediaPostsQuery__
 *
 * To run a query within a React component, call `useChannelMediaPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelMediaPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelMediaPostsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useChannelMediaPostsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelMediaPostsQuery,
    ChannelMediaPostsQueryVariables
  > &
    (
      | { variables: ChannelMediaPostsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChannelMediaPostsQuery,
    ChannelMediaPostsQueryVariables
  >(ChannelMediaPostsQueryDocument, options);
}
export function useChannelMediaPostsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelMediaPostsQuery,
    ChannelMediaPostsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChannelMediaPostsQuery,
    ChannelMediaPostsQueryVariables
  >(ChannelMediaPostsQueryDocument, options);
}
export function useChannelMediaPostsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelMediaPostsQuery,
        ChannelMediaPostsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChannelMediaPostsQuery,
    ChannelMediaPostsQueryVariables
  >(ChannelMediaPostsQueryDocument, options);
}
export type ChannelMediaPostsQueryHookResult = ReturnType<
  typeof useChannelMediaPostsQuery
>;
export type ChannelMediaPostsQueryLazyQueryHookResult = ReturnType<
  typeof useChannelMediaPostsQueryLazyQuery
>;
export type ChannelMediaPostsQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelMediaPostsQuerySuspenseQuery
>;
export type ChannelMediaPostsQueryQueryResult = Apollo.QueryResult<
  ChannelMediaPostsQuery,
  ChannelMediaPostsQueryVariables
>;
export const ChannelLinkQueryDocument = gql`
  query ChannelLinkQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
      channelType
    }
  }
`;

/**
 * __useChannelLinkQuery__
 *
 * To run a query within a React component, call `useChannelLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelLinkQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChannelLinkQuery,
    ChannelLinkQueryVariables
  > &
    (
      | { variables: ChannelLinkQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChannelLinkQuery, ChannelLinkQueryVariables>(
    ChannelLinkQueryDocument,
    options
  );
}
export function useChannelLinkQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChannelLinkQuery,
    ChannelLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChannelLinkQuery, ChannelLinkQueryVariables>(
    ChannelLinkQueryDocument,
    options
  );
}
export function useChannelLinkQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChannelLinkQuery,
        ChannelLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChannelLinkQuery, ChannelLinkQueryVariables>(
    ChannelLinkQueryDocument,
    options
  );
}
export type ChannelLinkQueryHookResult = ReturnType<typeof useChannelLinkQuery>;
export type ChannelLinkQueryLazyQueryHookResult = ReturnType<
  typeof useChannelLinkQueryLazyQuery
>;
export type ChannelLinkQuerySuspenseQueryHookResult = ReturnType<
  typeof useChannelLinkQuerySuspenseQuery
>;
export type ChannelLinkQueryQueryResult = Apollo.QueryResult<
  ChannelLinkQuery,
  ChannelLinkQueryVariables
>;
export const ClassroomGalleryQueryDocument = gql`
  query ClassroomGalleryQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
`;

/**
 * __useClassroomGalleryQuery__
 *
 * To run a query within a React component, call `useClassroomGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomGalleryQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useClassroomGalleryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomGalleryQuery,
    ClassroomGalleryQueryVariables
  > &
    (
      | { variables: ClassroomGalleryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClassroomGalleryQuery, ClassroomGalleryQueryVariables>(
    ClassroomGalleryQueryDocument,
    options
  );
}
export function useClassroomGalleryQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomGalleryQuery,
    ClassroomGalleryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomGalleryQuery,
    ClassroomGalleryQueryVariables
  >(ClassroomGalleryQueryDocument, options);
}
export function useClassroomGalleryQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomGalleryQuery,
        ClassroomGalleryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomGalleryQuery,
    ClassroomGalleryQueryVariables
  >(ClassroomGalleryQueryDocument, options);
}
export type ClassroomGalleryQueryHookResult = ReturnType<
  typeof useClassroomGalleryQuery
>;
export type ClassroomGalleryQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomGalleryQueryLazyQuery
>;
export type ClassroomGalleryQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomGalleryQuerySuspenseQuery
>;
export type ClassroomGalleryQueryQueryResult = Apollo.QueryResult<
  ClassroomGalleryQuery,
  ClassroomGalleryQueryVariables
>;
export const ClassroomMediaPostsQueryDocument = gql`
  query ClassroomMediaPostsQuery(
    $classroomId: String!
    $page: Float
    $perPage: Float
  ) {
    postsCollection: listClassroomMediaPosts(
      classroomId: $classroomId
      page: $page
      perPage: $perPage
    ) {
      page
      totalPages
      posts {
        ...GalleryPostDtoFields
      }
    }
  }
  ${GalleryPostDtoFieldsFragmentDoc}
`;

/**
 * __useClassroomMediaPostsQuery__
 *
 * To run a query within a React component, call `useClassroomMediaPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomMediaPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomMediaPostsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useClassroomMediaPostsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassroomMediaPostsQuery,
    ClassroomMediaPostsQueryVariables
  > &
    (
      | { variables: ClassroomMediaPostsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassroomMediaPostsQuery,
    ClassroomMediaPostsQueryVariables
  >(ClassroomMediaPostsQueryDocument, options);
}
export function useClassroomMediaPostsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassroomMediaPostsQuery,
    ClassroomMediaPostsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassroomMediaPostsQuery,
    ClassroomMediaPostsQueryVariables
  >(ClassroomMediaPostsQueryDocument, options);
}
export function useClassroomMediaPostsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClassroomMediaPostsQuery,
        ClassroomMediaPostsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassroomMediaPostsQuery,
    ClassroomMediaPostsQueryVariables
  >(ClassroomMediaPostsQueryDocument, options);
}
export type ClassroomMediaPostsQueryHookResult = ReturnType<
  typeof useClassroomMediaPostsQuery
>;
export type ClassroomMediaPostsQueryLazyQueryHookResult = ReturnType<
  typeof useClassroomMediaPostsQueryLazyQuery
>;
export type ClassroomMediaPostsQuerySuspenseQueryHookResult = ReturnType<
  typeof useClassroomMediaPostsQuerySuspenseQuery
>;
export type ClassroomMediaPostsQueryQueryResult = Apollo.QueryResult<
  ClassroomMediaPostsQuery,
  ClassroomMediaPostsQueryVariables
>;
export const DeleteDraftPostMutationDocument = gql`
  mutation DeleteDraftPostMutation($classroomId: String!, $postId: String!) {
    deletePost(classroomId: $classroomId, postId: $postId)
  }
`;
export type DeleteDraftPostMutationMutationFn = Apollo.MutationFunction<
  DeleteDraftPostMutation,
  DeleteDraftPostMutationVariables
>;

/**
 * __useDeleteDraftPostMutation__
 *
 * To run a mutation, you first call `useDeleteDraftPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftPostMutation, { data, loading, error }] = useDeleteDraftPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeleteDraftPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDraftPostMutation,
    DeleteDraftPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDraftPostMutation,
    DeleteDraftPostMutationVariables
  >(DeleteDraftPostMutationDocument, options);
}
export type DeleteDraftPostMutationHookResult = ReturnType<
  typeof useDeleteDraftPostMutation
>;
export type DeleteDraftPostMutationMutationResult =
  Apollo.MutationResult<DeleteDraftPostMutation>;
export type DeleteDraftPostMutationMutationOptions = Apollo.BaseMutationOptions<
  DeleteDraftPostMutation,
  DeleteDraftPostMutationVariables
>;
export const DraftPostItemQueryDocument = gql`
  query DraftPostItemQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      ...DraftPostItemChannelFields
    }
  }
  ${DraftPostItemChannelFieldsFragmentDoc}
`;

/**
 * __useDraftPostItemQuery__
 *
 * To run a query within a React component, call `useDraftPostItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftPostItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftPostItemQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDraftPostItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    DraftPostItemQuery,
    DraftPostItemQueryVariables
  > &
    (
      | { variables: DraftPostItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DraftPostItemQuery, DraftPostItemQueryVariables>(
    DraftPostItemQueryDocument,
    options
  );
}
export function useDraftPostItemQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DraftPostItemQuery,
    DraftPostItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DraftPostItemQuery, DraftPostItemQueryVariables>(
    DraftPostItemQueryDocument,
    options
  );
}
export function useDraftPostItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DraftPostItemQuery,
        DraftPostItemQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DraftPostItemQuery,
    DraftPostItemQueryVariables
  >(DraftPostItemQueryDocument, options);
}
export type DraftPostItemQueryHookResult = ReturnType<
  typeof useDraftPostItemQuery
>;
export type DraftPostItemQueryLazyQueryHookResult = ReturnType<
  typeof useDraftPostItemQueryLazyQuery
>;
export type DraftPostItemQuerySuspenseQueryHookResult = ReturnType<
  typeof useDraftPostItemQuerySuspenseQuery
>;
export type DraftPostItemQueryQueryResult = Apollo.QueryResult<
  DraftPostItemQuery,
  DraftPostItemQueryVariables
>;
export const DraftPostListQueryDocument = gql`
  query DraftPostListQuery(
    $classroomId: String!
    $channelId: String
    $postType: PostType
    $page: Float
    $perPage: Float
  ) {
    postsCollection: listPostDrafts(
      classroomId: $classroomId
      channelId: $channelId
      postType: $postType
      page: $page
      perPage: $perPage
    ) {
      page
      totalPages
      posts {
        ...DraftPostItemPostFields
      }
    }
  }
  ${DraftPostItemPostFieldsFragmentDoc}
`;

/**
 * __useDraftPostListQuery__
 *
 * To run a query within a React component, call `useDraftPostListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftPostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftPostListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      postType: // value for 'postType'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useDraftPostListQuery(
  baseOptions: Apollo.QueryHookOptions<
    DraftPostListQuery,
    DraftPostListQueryVariables
  > &
    (
      | { variables: DraftPostListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DraftPostListQuery, DraftPostListQueryVariables>(
    DraftPostListQueryDocument,
    options
  );
}
export function useDraftPostListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DraftPostListQuery,
    DraftPostListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DraftPostListQuery, DraftPostListQueryVariables>(
    DraftPostListQueryDocument,
    options
  );
}
export function useDraftPostListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DraftPostListQuery,
        DraftPostListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DraftPostListQuery,
    DraftPostListQueryVariables
  >(DraftPostListQueryDocument, options);
}
export type DraftPostListQueryHookResult = ReturnType<
  typeof useDraftPostListQuery
>;
export type DraftPostListQueryLazyQueryHookResult = ReturnType<
  typeof useDraftPostListQueryLazyQuery
>;
export type DraftPostListQuerySuspenseQueryHookResult = ReturnType<
  typeof useDraftPostListQuerySuspenseQuery
>;
export type DraftPostListQueryQueryResult = Apollo.QueryResult<
  DraftPostListQuery,
  DraftPostListQueryVariables
>;
export const DraftPostsButtonQueryDocument = gql`
  query DraftPostsButtonQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      archived
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useDraftPostsButtonQuery__
 *
 * To run a query within a React component, call `useDraftPostsButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftPostsButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftPostsButtonQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useDraftPostsButtonQuery(
  baseOptions: Apollo.QueryHookOptions<
    DraftPostsButtonQuery,
    DraftPostsButtonQueryVariables
  > &
    (
      | { variables: DraftPostsButtonQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DraftPostsButtonQuery, DraftPostsButtonQueryVariables>(
    DraftPostsButtonQueryDocument,
    options
  );
}
export function useDraftPostsButtonQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DraftPostsButtonQuery,
    DraftPostsButtonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DraftPostsButtonQuery,
    DraftPostsButtonQueryVariables
  >(DraftPostsButtonQueryDocument, options);
}
export function useDraftPostsButtonQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DraftPostsButtonQuery,
        DraftPostsButtonQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DraftPostsButtonQuery,
    DraftPostsButtonQueryVariables
  >(DraftPostsButtonQueryDocument, options);
}
export type DraftPostsButtonQueryHookResult = ReturnType<
  typeof useDraftPostsButtonQuery
>;
export type DraftPostsButtonQueryLazyQueryHookResult = ReturnType<
  typeof useDraftPostsButtonQueryLazyQuery
>;
export type DraftPostsButtonQuerySuspenseQueryHookResult = ReturnType<
  typeof useDraftPostsButtonQuerySuspenseQuery
>;
export type DraftPostsButtonQueryQueryResult = Apollo.QueryResult<
  DraftPostsButtonQuery,
  DraftPostsButtonQueryVariables
>;
export const DraftPostsButtonChannelQueryDocument = gql`
  query DraftPostsButtonChannelQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      canMemberWritePost
      archived
    }
    currentChannelMember: channelMember(
      classroomId: $classroomId
      channelId: $channelId
      memberId: "me"
    ) {
      id
    }
  }
`;

/**
 * __useDraftPostsButtonChannelQuery__
 *
 * To run a query within a React component, call `useDraftPostsButtonChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftPostsButtonChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftPostsButtonChannelQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDraftPostsButtonChannelQuery(
  baseOptions: Apollo.QueryHookOptions<
    DraftPostsButtonChannelQuery,
    DraftPostsButtonChannelQueryVariables
  > &
    (
      | { variables: DraftPostsButtonChannelQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DraftPostsButtonChannelQuery,
    DraftPostsButtonChannelQueryVariables
  >(DraftPostsButtonChannelQueryDocument, options);
}
export function useDraftPostsButtonChannelQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DraftPostsButtonChannelQuery,
    DraftPostsButtonChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DraftPostsButtonChannelQuery,
    DraftPostsButtonChannelQueryVariables
  >(DraftPostsButtonChannelQueryDocument, options);
}
export function useDraftPostsButtonChannelQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DraftPostsButtonChannelQuery,
        DraftPostsButtonChannelQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DraftPostsButtonChannelQuery,
    DraftPostsButtonChannelQueryVariables
  >(DraftPostsButtonChannelQueryDocument, options);
}
export type DraftPostsButtonChannelQueryHookResult = ReturnType<
  typeof useDraftPostsButtonChannelQuery
>;
export type DraftPostsButtonChannelQueryLazyQueryHookResult = ReturnType<
  typeof useDraftPostsButtonChannelQueryLazyQuery
>;
export type DraftPostsButtonChannelQuerySuspenseQueryHookResult = ReturnType<
  typeof useDraftPostsButtonChannelQuerySuspenseQuery
>;
export type DraftPostsButtonChannelQueryQueryResult = Apollo.QueryResult<
  DraftPostsButtonChannelQuery,
  DraftPostsButtonChannelQueryVariables
>;
export const MarkPostAsReadMutationDocument = gql`
  mutation MarkPostAsReadMutation($classroomId: String!, $postId: String!) {
    markPostAsRead(classroomId: $classroomId, postId: $postId)
  }
`;
export type MarkPostAsReadMutationMutationFn = Apollo.MutationFunction<
  MarkPostAsReadMutation,
  MarkPostAsReadMutationVariables
>;

/**
 * __useMarkPostAsReadMutation__
 *
 * To run a mutation, you first call `useMarkPostAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPostAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPostAsReadMutation, { data, loading, error }] = useMarkPostAsReadMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useMarkPostAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkPostAsReadMutation,
    MarkPostAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkPostAsReadMutation,
    MarkPostAsReadMutationVariables
  >(MarkPostAsReadMutationDocument, options);
}
export type MarkPostAsReadMutationHookResult = ReturnType<
  typeof useMarkPostAsReadMutation
>;
export type MarkPostAsReadMutationMutationResult =
  Apollo.MutationResult<MarkPostAsReadMutation>;
export type MarkPostAsReadMutationMutationOptions = Apollo.BaseMutationOptions<
  MarkPostAsReadMutation,
  MarkPostAsReadMutationVariables
>;
export const PinnedPostItemQueryDocument = gql`
  query PinnedPostItemQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
`;

/**
 * __usePinnedPostItemQuery__
 *
 * To run a query within a React component, call `usePinnedPostItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinnedPostItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinnedPostItemQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePinnedPostItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    PinnedPostItemQuery,
    PinnedPostItemQueryVariables
  > &
    (
      | { variables: PinnedPostItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PinnedPostItemQuery, PinnedPostItemQueryVariables>(
    PinnedPostItemQueryDocument,
    options
  );
}
export function usePinnedPostItemQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PinnedPostItemQuery,
    PinnedPostItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PinnedPostItemQuery, PinnedPostItemQueryVariables>(
    PinnedPostItemQueryDocument,
    options
  );
}
export function usePinnedPostItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedPostItemQuery,
        PinnedPostItemQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PinnedPostItemQuery,
    PinnedPostItemQueryVariables
  >(PinnedPostItemQueryDocument, options);
}
export type PinnedPostItemQueryHookResult = ReturnType<
  typeof usePinnedPostItemQuery
>;
export type PinnedPostItemQueryLazyQueryHookResult = ReturnType<
  typeof usePinnedPostItemQueryLazyQuery
>;
export type PinnedPostItemQuerySuspenseQueryHookResult = ReturnType<
  typeof usePinnedPostItemQuerySuspenseQuery
>;
export type PinnedPostItemQueryQueryResult = Apollo.QueryResult<
  PinnedPostItemQuery,
  PinnedPostItemQueryVariables
>;
export const PinnedPostListQueryDocument = gql`
  query PinnedPostListQuery(
    $classroomId: String!
    $channelId: String
    $limit: Float
  ) {
    postPins: listPostPins(
      classroomId: $classroomId
      channelId: $channelId
      limit: $limit
    ) {
      id
      postId
      post {
        ...PinnedPostItemPostFields
      }
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
  ${PinnedPostItemPostFieldsFragmentDoc}
`;

/**
 * __usePinnedPostListQuery__
 *
 * To run a query within a React component, call `usePinnedPostListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinnedPostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinnedPostListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePinnedPostListQuery(
  baseOptions: Apollo.QueryHookOptions<
    PinnedPostListQuery,
    PinnedPostListQueryVariables
  > &
    (
      | { variables: PinnedPostListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PinnedPostListQuery, PinnedPostListQueryVariables>(
    PinnedPostListQueryDocument,
    options
  );
}
export function usePinnedPostListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PinnedPostListQuery,
    PinnedPostListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PinnedPostListQuery, PinnedPostListQueryVariables>(
    PinnedPostListQueryDocument,
    options
  );
}
export function usePinnedPostListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedPostListQuery,
        PinnedPostListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PinnedPostListQuery,
    PinnedPostListQueryVariables
  >(PinnedPostListQueryDocument, options);
}
export type PinnedPostListQueryHookResult = ReturnType<
  typeof usePinnedPostListQuery
>;
export type PinnedPostListQueryLazyQueryHookResult = ReturnType<
  typeof usePinnedPostListQueryLazyQuery
>;
export type PinnedPostListQuerySuspenseQueryHookResult = ReturnType<
  typeof usePinnedPostListQuerySuspenseQuery
>;
export type PinnedPostListQueryQueryResult = Apollo.QueryResult<
  PinnedPostListQuery,
  PinnedPostListQueryVariables
>;
export const PinnedPostListCheckedOnboardingPinnedPostQueryDocument = gql`
  query PinnedPostListCheckedOnboardingPinnedPostQuery(
    $userId: String!
    $classroomId: String!
  ) {
    CheckedOnboardingPinnedPost: getCheckedOnboardingPinnedPost(
      userId: $userId
      classroomId: $classroomId
    ) @client {
      isChecked
    }
  }
`;

/**
 * __usePinnedPostListCheckedOnboardingPinnedPostQuery__
 *
 * To run a query within a React component, call `usePinnedPostListCheckedOnboardingPinnedPostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinnedPostListCheckedOnboardingPinnedPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinnedPostListCheckedOnboardingPinnedPostQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function usePinnedPostListCheckedOnboardingPinnedPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    PinnedPostListCheckedOnboardingPinnedPostQuery,
    PinnedPostListCheckedOnboardingPinnedPostQueryVariables
  > &
    (
      | {
          variables: PinnedPostListCheckedOnboardingPinnedPostQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PinnedPostListCheckedOnboardingPinnedPostQuery,
    PinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >(PinnedPostListCheckedOnboardingPinnedPostQueryDocument, options);
}
export function usePinnedPostListCheckedOnboardingPinnedPostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PinnedPostListCheckedOnboardingPinnedPostQuery,
    PinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PinnedPostListCheckedOnboardingPinnedPostQuery,
    PinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >(PinnedPostListCheckedOnboardingPinnedPostQueryDocument, options);
}
export function usePinnedPostListCheckedOnboardingPinnedPostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedPostListCheckedOnboardingPinnedPostQuery,
        PinnedPostListCheckedOnboardingPinnedPostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PinnedPostListCheckedOnboardingPinnedPostQuery,
    PinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >(PinnedPostListCheckedOnboardingPinnedPostQueryDocument, options);
}
export type PinnedPostListCheckedOnboardingPinnedPostQueryHookResult =
  ReturnType<typeof usePinnedPostListCheckedOnboardingPinnedPostQuery>;
export type PinnedPostListCheckedOnboardingPinnedPostQueryLazyQueryHookResult =
  ReturnType<typeof usePinnedPostListCheckedOnboardingPinnedPostQueryLazyQuery>;
export type PinnedPostListCheckedOnboardingPinnedPostQuerySuspenseQueryHookResult =
  ReturnType<
    typeof usePinnedPostListCheckedOnboardingPinnedPostQuerySuspenseQuery
  >;
export type PinnedPostListCheckedOnboardingPinnedPostQueryQueryResult =
  Apollo.QueryResult<
    PinnedPostListCheckedOnboardingPinnedPostQuery,
    PinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >;
export const PostFeedAssignmentStatusQueryDocument = gql`
  query PostFeedAssignmentStatusQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...PostFeedAssignmentStatusAssignmentDtoFields
    }
  }
  ${PostFeedAssignmentStatusAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __usePostFeedAssignmentStatusQuery__
 *
 * To run a query within a React component, call `usePostFeedAssignmentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedAssignmentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedAssignmentStatusQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function usePostFeedAssignmentStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedAssignmentStatusQuery,
    PostFeedAssignmentStatusQueryVariables
  > &
    (
      | { variables: PostFeedAssignmentStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedAssignmentStatusQuery,
    PostFeedAssignmentStatusQueryVariables
  >(PostFeedAssignmentStatusQueryDocument, options);
}
export function usePostFeedAssignmentStatusQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedAssignmentStatusQuery,
    PostFeedAssignmentStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedAssignmentStatusQuery,
    PostFeedAssignmentStatusQueryVariables
  >(PostFeedAssignmentStatusQueryDocument, options);
}
export function usePostFeedAssignmentStatusQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedAssignmentStatusQuery,
        PostFeedAssignmentStatusQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedAssignmentStatusQuery,
    PostFeedAssignmentStatusQueryVariables
  >(PostFeedAssignmentStatusQueryDocument, options);
}
export type PostFeedAssignmentStatusQueryHookResult = ReturnType<
  typeof usePostFeedAssignmentStatusQuery
>;
export type PostFeedAssignmentStatusQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedAssignmentStatusQueryLazyQuery
>;
export type PostFeedAssignmentStatusQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedAssignmentStatusQuerySuspenseQuery
>;
export type PostFeedAssignmentStatusQueryQueryResult = Apollo.QueryResult<
  PostFeedAssignmentStatusQuery,
  PostFeedAssignmentStatusQueryVariables
>;
export const PostFeedItemBodyQueryDocument = gql`
  query PostFeedItemBodyQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __usePostFeedItemBodyQuery__
 *
 * To run a query within a React component, call `usePostFeedItemBodyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedItemBodyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedItemBodyQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function usePostFeedItemBodyQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedItemBodyQuery,
    PostFeedItemBodyQueryVariables
  > &
    (
      | { variables: PostFeedItemBodyQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostFeedItemBodyQuery, PostFeedItemBodyQueryVariables>(
    PostFeedItemBodyQueryDocument,
    options
  );
}
export function usePostFeedItemBodyQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedItemBodyQuery,
    PostFeedItemBodyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedItemBodyQuery,
    PostFeedItemBodyQueryVariables
  >(PostFeedItemBodyQueryDocument, options);
}
export function usePostFeedItemBodyQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedItemBodyQuery,
        PostFeedItemBodyQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedItemBodyQuery,
    PostFeedItemBodyQueryVariables
  >(PostFeedItemBodyQueryDocument, options);
}
export type PostFeedItemBodyQueryHookResult = ReturnType<
  typeof usePostFeedItemBodyQuery
>;
export type PostFeedItemBodyQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedItemBodyQueryLazyQuery
>;
export type PostFeedItemBodyQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedItemBodyQuerySuspenseQuery
>;
export type PostFeedItemBodyQueryQueryResult = Apollo.QueryResult<
  PostFeedItemBodyQuery,
  PostFeedItemBodyQueryVariables
>;
export const PostFeedItemHeaderQueryDocument = gql`
  query PostFeedItemHeaderQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
      isPrivate
    }
  }
`;

/**
 * __usePostFeedItemHeaderQuery__
 *
 * To run a query within a React component, call `usePostFeedItemHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedItemHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedItemHeaderQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostFeedItemHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedItemHeaderQuery,
    PostFeedItemHeaderQueryVariables
  > &
    (
      | { variables: PostFeedItemHeaderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedItemHeaderQuery,
    PostFeedItemHeaderQueryVariables
  >(PostFeedItemHeaderQueryDocument, options);
}
export function usePostFeedItemHeaderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedItemHeaderQuery,
    PostFeedItemHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedItemHeaderQuery,
    PostFeedItemHeaderQueryVariables
  >(PostFeedItemHeaderQueryDocument, options);
}
export function usePostFeedItemHeaderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedItemHeaderQuery,
        PostFeedItemHeaderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedItemHeaderQuery,
    PostFeedItemHeaderQueryVariables
  >(PostFeedItemHeaderQueryDocument, options);
}
export type PostFeedItemHeaderQueryHookResult = ReturnType<
  typeof usePostFeedItemHeaderQuery
>;
export type PostFeedItemHeaderQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedItemHeaderQueryLazyQuery
>;
export type PostFeedItemHeaderQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedItemHeaderQuerySuspenseQuery
>;
export type PostFeedItemHeaderQueryQueryResult = Apollo.QueryResult<
  PostFeedItemHeaderQuery,
  PostFeedItemHeaderQueryVariables
>;
export const PostFeedItemHeaderAssignmentQueryDocument = gql`
  query PostFeedItemHeaderAssignmentQuery(
    $classroomId: String!
    $assignmentId: String!
  ) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      id
      ...PostTypeTagAssignmentDtoFields
      ...AssignmentStatusTagAssignmentDtoFields
    }
  }
  ${PostTypeTagAssignmentDtoFieldsFragmentDoc}
  ${AssignmentStatusTagAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __usePostFeedItemHeaderAssignmentQuery__
 *
 * To run a query within a React component, call `usePostFeedItemHeaderAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedItemHeaderAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedItemHeaderAssignmentQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function usePostFeedItemHeaderAssignmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedItemHeaderAssignmentQuery,
    PostFeedItemHeaderAssignmentQueryVariables
  > &
    (
      | {
          variables: PostFeedItemHeaderAssignmentQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedItemHeaderAssignmentQuery,
    PostFeedItemHeaderAssignmentQueryVariables
  >(PostFeedItemHeaderAssignmentQueryDocument, options);
}
export function usePostFeedItemHeaderAssignmentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedItemHeaderAssignmentQuery,
    PostFeedItemHeaderAssignmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedItemHeaderAssignmentQuery,
    PostFeedItemHeaderAssignmentQueryVariables
  >(PostFeedItemHeaderAssignmentQueryDocument, options);
}
export function usePostFeedItemHeaderAssignmentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedItemHeaderAssignmentQuery,
        PostFeedItemHeaderAssignmentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedItemHeaderAssignmentQuery,
    PostFeedItemHeaderAssignmentQueryVariables
  >(PostFeedItemHeaderAssignmentQueryDocument, options);
}
export type PostFeedItemHeaderAssignmentQueryHookResult = ReturnType<
  typeof usePostFeedItemHeaderAssignmentQuery
>;
export type PostFeedItemHeaderAssignmentQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedItemHeaderAssignmentQueryLazyQuery
>;
export type PostFeedItemHeaderAssignmentQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostFeedItemHeaderAssignmentQuerySuspenseQuery>;
export type PostFeedItemHeaderAssignmentQueryQueryResult = Apollo.QueryResult<
  PostFeedItemHeaderAssignmentQuery,
  PostFeedItemHeaderAssignmentQueryVariables
>;
export const PostFeedListQueryDocument = gql`
  query PostFeedListQuery(
    $classroomId: String!
    $channelId: String
    $cursor: String
    $limit: Float
  ) {
    postsCollection: listPosts(
      classroomId: $classroomId
      channelId: $channelId
      cursor: $cursor
      limit: $limit
    ) {
      cursor
      posts {
        ...PostFeedItemPostFields
        ...PostMoreMenuPostFields
      }
    }
  }
  ${PostFeedItemPostFieldsFragmentDoc}
  ${PostMoreMenuPostFieldsFragmentDoc}
`;

/**
 * __usePostFeedListQuery__
 *
 * To run a query within a React component, call `usePostFeedListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePostFeedListQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedListQuery,
    PostFeedListQueryVariables
  > &
    (
      | { variables: PostFeedListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostFeedListQuery, PostFeedListQueryVariables>(
    PostFeedListQueryDocument,
    options
  );
}
export function usePostFeedListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedListQuery,
    PostFeedListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostFeedListQuery, PostFeedListQueryVariables>(
    PostFeedListQueryDocument,
    options
  );
}
export function usePostFeedListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedListQuery,
        PostFeedListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PostFeedListQuery, PostFeedListQueryVariables>(
    PostFeedListQueryDocument,
    options
  );
}
export type PostFeedListQueryHookResult = ReturnType<
  typeof usePostFeedListQuery
>;
export type PostFeedListQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedListQueryLazyQuery
>;
export type PostFeedListQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedListQuerySuspenseQuery
>;
export type PostFeedListQueryQueryResult = Apollo.QueryResult<
  PostFeedListQuery,
  PostFeedListQueryVariables
>;
export const PostFeedListChannelQueryDocument = gql`
  query PostFeedListChannelQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
`;

/**
 * __usePostFeedListChannelQuery__
 *
 * To run a query within a React component, call `usePostFeedListChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedListChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedListChannelQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostFeedListChannelQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedListChannelQuery,
    PostFeedListChannelQueryVariables
  > &
    (
      | { variables: PostFeedListChannelQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedListChannelQuery,
    PostFeedListChannelQueryVariables
  >(PostFeedListChannelQueryDocument, options);
}
export function usePostFeedListChannelQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedListChannelQuery,
    PostFeedListChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedListChannelQuery,
    PostFeedListChannelQueryVariables
  >(PostFeedListChannelQueryDocument, options);
}
export function usePostFeedListChannelQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedListChannelQuery,
        PostFeedListChannelQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedListChannelQuery,
    PostFeedListChannelQueryVariables
  >(PostFeedListChannelQueryDocument, options);
}
export type PostFeedListChannelQueryHookResult = ReturnType<
  typeof usePostFeedListChannelQuery
>;
export type PostFeedListChannelQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedListChannelQueryLazyQuery
>;
export type PostFeedListChannelQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedListChannelQuerySuspenseQuery
>;
export type PostFeedListChannelQueryQueryResult = Apollo.QueryResult<
  PostFeedListChannelQuery,
  PostFeedListChannelQueryVariables
>;
export const PostFeedListAccountQueryDocument = gql`
  query PostFeedListAccountQuery {
    me: getMe {
      id
      role
      isAdFreeSubscribed
      grade
      language
      countryCode
      schoolInfoDto {
        grade
        school {
          zipcode
        }
      }
      schoolInfoDtoForChildren {
        grade
        school {
          zipcode
        }
      }
    }
  }
`;

/**
 * __usePostFeedListAccountQuery__
 *
 * To run a query within a React component, call `usePostFeedListAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedListAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedListAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostFeedListAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PostFeedListAccountQuery,
    PostFeedListAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedListAccountQuery,
    PostFeedListAccountQueryVariables
  >(PostFeedListAccountQueryDocument, options);
}
export function usePostFeedListAccountQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedListAccountQuery,
    PostFeedListAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedListAccountQuery,
    PostFeedListAccountQueryVariables
  >(PostFeedListAccountQueryDocument, options);
}
export function usePostFeedListAccountQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedListAccountQuery,
        PostFeedListAccountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedListAccountQuery,
    PostFeedListAccountQueryVariables
  >(PostFeedListAccountQueryDocument, options);
}
export type PostFeedListAccountQueryHookResult = ReturnType<
  typeof usePostFeedListAccountQuery
>;
export type PostFeedListAccountQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedListAccountQueryLazyQuery
>;
export type PostFeedListAccountQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedListAccountQuerySuspenseQuery
>;
export type PostFeedListAccountQueryQueryResult = Apollo.QueryResult<
  PostFeedListAccountQuery,
  PostFeedListAccountQueryVariables
>;
export const PostFeedListSearchedByTagQueryDocument = gql`
  query PostFeedListSearchedByTagQuery(
    $classroomId: String!
    $channelId: String!
    $tag: String!
    $page: Float!
    $perPage: Float!
  ) {
    postsCollection: searchPosts(
      classroomId: $classroomId
      channelId: $channelId
      tag: $tag
      page: $page
      perPage: $perPage
    ) {
      posts {
        ...PostFeedItemPostFields
      }
      totalPages
      perPage
      page
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
  ${PostFeedItemPostFieldsFragmentDoc}
`;

/**
 * __usePostFeedListSearchedByTagQuery__
 *
 * To run a query within a React component, call `usePostFeedListSearchedByTagQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedListSearchedByTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedListSearchedByTagQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      tag: // value for 'tag'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function usePostFeedListSearchedByTagQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedListSearchedByTagQuery,
    PostFeedListSearchedByTagQueryVariables
  > &
    (
      | { variables: PostFeedListSearchedByTagQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedListSearchedByTagQuery,
    PostFeedListSearchedByTagQueryVariables
  >(PostFeedListSearchedByTagQueryDocument, options);
}
export function usePostFeedListSearchedByTagQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedListSearchedByTagQuery,
    PostFeedListSearchedByTagQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedListSearchedByTagQuery,
    PostFeedListSearchedByTagQueryVariables
  >(PostFeedListSearchedByTagQueryDocument, options);
}
export function usePostFeedListSearchedByTagQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedListSearchedByTagQuery,
        PostFeedListSearchedByTagQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedListSearchedByTagQuery,
    PostFeedListSearchedByTagQueryVariables
  >(PostFeedListSearchedByTagQueryDocument, options);
}
export type PostFeedListSearchedByTagQueryHookResult = ReturnType<
  typeof usePostFeedListSearchedByTagQuery
>;
export type PostFeedListSearchedByTagQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedListSearchedByTagQueryLazyQuery
>;
export type PostFeedListSearchedByTagQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedListSearchedByTagQuerySuspenseQuery
>;
export type PostFeedListSearchedByTagQueryQueryResult = Apollo.QueryResult<
  PostFeedListSearchedByTagQuery,
  PostFeedListSearchedByTagQueryVariables
>;
export const PostFeedListSearchedByTagChannelNameQueryDocument = gql`
  query PostFeedListSearchedByTagChannelNameQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
`;

/**
 * __usePostFeedListSearchedByTagChannelNameQuery__
 *
 * To run a query within a React component, call `usePostFeedListSearchedByTagChannelNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedListSearchedByTagChannelNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedListSearchedByTagChannelNameQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostFeedListSearchedByTagChannelNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedListSearchedByTagChannelNameQuery,
    PostFeedListSearchedByTagChannelNameQueryVariables
  > &
    (
      | {
          variables: PostFeedListSearchedByTagChannelNameQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedListSearchedByTagChannelNameQuery,
    PostFeedListSearchedByTagChannelNameQueryVariables
  >(PostFeedListSearchedByTagChannelNameQueryDocument, options);
}
export function usePostFeedListSearchedByTagChannelNameQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedListSearchedByTagChannelNameQuery,
    PostFeedListSearchedByTagChannelNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedListSearchedByTagChannelNameQuery,
    PostFeedListSearchedByTagChannelNameQueryVariables
  >(PostFeedListSearchedByTagChannelNameQueryDocument, options);
}
export function usePostFeedListSearchedByTagChannelNameQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedListSearchedByTagChannelNameQuery,
        PostFeedListSearchedByTagChannelNameQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedListSearchedByTagChannelNameQuery,
    PostFeedListSearchedByTagChannelNameQueryVariables
  >(PostFeedListSearchedByTagChannelNameQueryDocument, options);
}
export type PostFeedListSearchedByTagChannelNameQueryHookResult = ReturnType<
  typeof usePostFeedListSearchedByTagChannelNameQuery
>;
export type PostFeedListSearchedByTagChannelNameQueryLazyQueryHookResult =
  ReturnType<typeof usePostFeedListSearchedByTagChannelNameQueryLazyQuery>;
export type PostFeedListSearchedByTagChannelNameQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostFeedListSearchedByTagChannelNameQuerySuspenseQuery>;
export type PostFeedListSearchedByTagChannelNameQueryQueryResult =
  Apollo.QueryResult<
    PostFeedListSearchedByTagChannelNameQuery,
    PostFeedListSearchedByTagChannelNameQueryVariables
  >;
export const PostFeedListSearchedByTagAccountQueryDocument = gql`
  query PostFeedListSearchedByTagAccountQuery {
    me: getMe {
      id
      role
      isAdFreeSubscribed
      grade
      language
      countryCode
      schoolInfoDto {
        grade
        school {
          zipcode
        }
      }
      schoolInfoDtoForChildren {
        grade
        school {
          zipcode
        }
      }
    }
  }
`;

/**
 * __usePostFeedListSearchedByTagAccountQuery__
 *
 * To run a query within a React component, call `usePostFeedListSearchedByTagAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedListSearchedByTagAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedListSearchedByTagAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostFeedListSearchedByTagAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PostFeedListSearchedByTagAccountQuery,
    PostFeedListSearchedByTagAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedListSearchedByTagAccountQuery,
    PostFeedListSearchedByTagAccountQueryVariables
  >(PostFeedListSearchedByTagAccountQueryDocument, options);
}
export function usePostFeedListSearchedByTagAccountQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedListSearchedByTagAccountQuery,
    PostFeedListSearchedByTagAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedListSearchedByTagAccountQuery,
    PostFeedListSearchedByTagAccountQueryVariables
  >(PostFeedListSearchedByTagAccountQueryDocument, options);
}
export function usePostFeedListSearchedByTagAccountQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedListSearchedByTagAccountQuery,
        PostFeedListSearchedByTagAccountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedListSearchedByTagAccountQuery,
    PostFeedListSearchedByTagAccountQueryVariables
  >(PostFeedListSearchedByTagAccountQueryDocument, options);
}
export type PostFeedListSearchedByTagAccountQueryHookResult = ReturnType<
  typeof usePostFeedListSearchedByTagAccountQuery
>;
export type PostFeedListSearchedByTagAccountQueryLazyQueryHookResult =
  ReturnType<typeof usePostFeedListSearchedByTagAccountQueryLazyQuery>;
export type PostFeedListSearchedByTagAccountQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostFeedListSearchedByTagAccountQuerySuspenseQuery>;
export type PostFeedListSearchedByTagAccountQueryQueryResult =
  Apollo.QueryResult<
    PostFeedListSearchedByTagAccountQuery,
    PostFeedListSearchedByTagAccountQueryVariables
  >;
export const PostFeedPinnedPostItemQueryDocument = gql`
  query PostFeedPinnedPostItemQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
`;

/**
 * __usePostFeedPinnedPostItemQuery__
 *
 * To run a query within a React component, call `usePostFeedPinnedPostItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedPinnedPostItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedPinnedPostItemQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostFeedPinnedPostItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedPinnedPostItemQuery,
    PostFeedPinnedPostItemQueryVariables
  > &
    (
      | { variables: PostFeedPinnedPostItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedPinnedPostItemQuery,
    PostFeedPinnedPostItemQueryVariables
  >(PostFeedPinnedPostItemQueryDocument, options);
}
export function usePostFeedPinnedPostItemQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedPinnedPostItemQuery,
    PostFeedPinnedPostItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedPinnedPostItemQuery,
    PostFeedPinnedPostItemQueryVariables
  >(PostFeedPinnedPostItemQueryDocument, options);
}
export function usePostFeedPinnedPostItemQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedPinnedPostItemQuery,
        PostFeedPinnedPostItemQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedPinnedPostItemQuery,
    PostFeedPinnedPostItemQueryVariables
  >(PostFeedPinnedPostItemQueryDocument, options);
}
export type PostFeedPinnedPostItemQueryHookResult = ReturnType<
  typeof usePostFeedPinnedPostItemQuery
>;
export type PostFeedPinnedPostItemQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedPinnedPostItemQueryLazyQuery
>;
export type PostFeedPinnedPostItemQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedPinnedPostItemQuerySuspenseQuery
>;
export type PostFeedPinnedPostItemQueryQueryResult = Apollo.QueryResult<
  PostFeedPinnedPostItemQuery,
  PostFeedPinnedPostItemQueryVariables
>;
export const PostFeedPinnedPostListQueryDocument = gql`
  query PostFeedPinnedPostListQuery(
    $classroomId: String!
    $channelId: String
    $limit: Float
  ) {
    postPins: listPostPins(
      classroomId: $classroomId
      channelId: $channelId
      limit: $limit
    ) {
      ...PostFeedPinnedPostItemChannelPostPinDtoFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
  ${PostFeedPinnedPostItemChannelPostPinDtoFieldsFragmentDoc}
`;

/**
 * __usePostFeedPinnedPostListQuery__
 *
 * To run a query within a React component, call `usePostFeedPinnedPostListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedPinnedPostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedPinnedPostListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePostFeedPinnedPostListQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedPinnedPostListQuery,
    PostFeedPinnedPostListQueryVariables
  > &
    (
      | { variables: PostFeedPinnedPostListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedPinnedPostListQuery,
    PostFeedPinnedPostListQueryVariables
  >(PostFeedPinnedPostListQueryDocument, options);
}
export function usePostFeedPinnedPostListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedPinnedPostListQuery,
    PostFeedPinnedPostListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedPinnedPostListQuery,
    PostFeedPinnedPostListQueryVariables
  >(PostFeedPinnedPostListQueryDocument, options);
}
export function usePostFeedPinnedPostListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedPinnedPostListQuery,
        PostFeedPinnedPostListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedPinnedPostListQuery,
    PostFeedPinnedPostListQueryVariables
  >(PostFeedPinnedPostListQueryDocument, options);
}
export type PostFeedPinnedPostListQueryHookResult = ReturnType<
  typeof usePostFeedPinnedPostListQuery
>;
export type PostFeedPinnedPostListQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedPinnedPostListQueryLazyQuery
>;
export type PostFeedPinnedPostListQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedPinnedPostListQuerySuspenseQuery
>;
export type PostFeedPinnedPostListQueryQueryResult = Apollo.QueryResult<
  PostFeedPinnedPostListQuery,
  PostFeedPinnedPostListQueryVariables
>;
export const PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryDocument = gql`
  query PostFeedPinnedPostListCheckedOnboardingPinnedPostQuery(
    $userId: String!
    $classroomId: String!
  ) {
    CheckedOnboardingPinnedPost: getCheckedOnboardingPinnedPost(
      userId: $userId
      classroomId: $classroomId
    ) @client {
      isChecked
    }
  }
`;

/**
 * __usePostFeedPinnedPostListCheckedOnboardingPinnedPostQuery__
 *
 * To run a query within a React component, call `usePostFeedPinnedPostListCheckedOnboardingPinnedPostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedPinnedPostListCheckedOnboardingPinnedPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedPinnedPostListCheckedOnboardingPinnedPostQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function usePostFeedPinnedPostListCheckedOnboardingPinnedPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQuery,
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryVariables
  > &
    (
      | {
          variables: PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQuery,
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >(PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryDocument, options);
}
export function usePostFeedPinnedPostListCheckedOnboardingPinnedPostQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQuery,
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQuery,
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >(PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryDocument, options);
}
export function usePostFeedPinnedPostListCheckedOnboardingPinnedPostQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedPinnedPostListCheckedOnboardingPinnedPostQuery,
        PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQuery,
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >(PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryDocument, options);
}
export type PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryHookResult =
  ReturnType<typeof usePostFeedPinnedPostListCheckedOnboardingPinnedPostQuery>;
export type PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryLazyQueryHookResult =
  ReturnType<
    typeof usePostFeedPinnedPostListCheckedOnboardingPinnedPostQueryLazyQuery
  >;
export type PostFeedPinnedPostListCheckedOnboardingPinnedPostQuerySuspenseQueryHookResult =
  ReturnType<
    typeof usePostFeedPinnedPostListCheckedOnboardingPinnedPostQuerySuspenseQuery
  >;
export type PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryQueryResult =
  Apollo.QueryResult<
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQuery,
    PostFeedPinnedPostListCheckedOnboardingPinnedPostQueryVariables
  >;
export const PostFeedSearchPostsQueryDocument = gql`
  query PostFeedSearchPostsQuery(
    $classroomId: String!
    $q: String!
    $page: Float!
    $perPage: Float!
  ) {
    postsCollection: searchPosts(
      classroomId: $classroomId
      q: $q
      page: $page
      perPage: $perPage
    ) {
      posts {
        ...PostFeedItemPostFields
      }
      totalPages
      perPage
      page
    }
  }
  ${PostFeedItemPostFieldsFragmentDoc}
`;

/**
 * __usePostFeedSearchPostsQuery__
 *
 * To run a query within a React component, call `usePostFeedSearchPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedSearchPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedSearchPostsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      q: // value for 'q'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function usePostFeedSearchPostsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedSearchPostsQuery,
    PostFeedSearchPostsQueryVariables
  > &
    (
      | { variables: PostFeedSearchPostsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedSearchPostsQuery,
    PostFeedSearchPostsQueryVariables
  >(PostFeedSearchPostsQueryDocument, options);
}
export function usePostFeedSearchPostsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedSearchPostsQuery,
    PostFeedSearchPostsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedSearchPostsQuery,
    PostFeedSearchPostsQueryVariables
  >(PostFeedSearchPostsQueryDocument, options);
}
export function usePostFeedSearchPostsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedSearchPostsQuery,
        PostFeedSearchPostsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedSearchPostsQuery,
    PostFeedSearchPostsQueryVariables
  >(PostFeedSearchPostsQueryDocument, options);
}
export type PostFeedSearchPostsQueryHookResult = ReturnType<
  typeof usePostFeedSearchPostsQuery
>;
export type PostFeedSearchPostsQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedSearchPostsQueryLazyQuery
>;
export type PostFeedSearchPostsQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedSearchPostsQuerySuspenseQuery
>;
export type PostFeedSearchPostsQueryQueryResult = Apollo.QueryResult<
  PostFeedSearchPostsQuery,
  PostFeedSearchPostsQueryVariables
>;
export const PostFeedSearchPostsClassroomQueryDocument = gql`
  query PostFeedSearchPostsClassroomQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
`;

/**
 * __usePostFeedSearchPostsClassroomQuery__
 *
 * To run a query within a React component, call `usePostFeedSearchPostsClassroomQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedSearchPostsClassroomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedSearchPostsClassroomQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function usePostFeedSearchPostsClassroomQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedSearchPostsClassroomQuery,
    PostFeedSearchPostsClassroomQueryVariables
  > &
    (
      | {
          variables: PostFeedSearchPostsClassroomQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedSearchPostsClassroomQuery,
    PostFeedSearchPostsClassroomQueryVariables
  >(PostFeedSearchPostsClassroomQueryDocument, options);
}
export function usePostFeedSearchPostsClassroomQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedSearchPostsClassroomQuery,
    PostFeedSearchPostsClassroomQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedSearchPostsClassroomQuery,
    PostFeedSearchPostsClassroomQueryVariables
  >(PostFeedSearchPostsClassroomQueryDocument, options);
}
export function usePostFeedSearchPostsClassroomQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedSearchPostsClassroomQuery,
        PostFeedSearchPostsClassroomQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedSearchPostsClassroomQuery,
    PostFeedSearchPostsClassroomQueryVariables
  >(PostFeedSearchPostsClassroomQueryDocument, options);
}
export type PostFeedSearchPostsClassroomQueryHookResult = ReturnType<
  typeof usePostFeedSearchPostsClassroomQuery
>;
export type PostFeedSearchPostsClassroomQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedSearchPostsClassroomQueryLazyQuery
>;
export type PostFeedSearchPostsClassroomQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostFeedSearchPostsClassroomQuerySuspenseQuery>;
export type PostFeedSearchPostsClassroomQueryQueryResult = Apollo.QueryResult<
  PostFeedSearchPostsClassroomQuery,
  PostFeedSearchPostsClassroomQueryVariables
>;
export const PostFeedSearchPostsAccountQueryDocument = gql`
  query PostFeedSearchPostsAccountQuery {
    me: getMe {
      id
      role
      isAdFreeSubscribed
      grade
      language
      countryCode
      schoolInfoDto {
        grade
        school {
          zipcode
        }
      }
      schoolInfoDtoForChildren {
        grade
        school {
          zipcode
        }
      }
    }
  }
`;

/**
 * __usePostFeedSearchPostsAccountQuery__
 *
 * To run a query within a React component, call `usePostFeedSearchPostsAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedSearchPostsAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedSearchPostsAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostFeedSearchPostsAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PostFeedSearchPostsAccountQuery,
    PostFeedSearchPostsAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedSearchPostsAccountQuery,
    PostFeedSearchPostsAccountQueryVariables
  >(PostFeedSearchPostsAccountQueryDocument, options);
}
export function usePostFeedSearchPostsAccountQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedSearchPostsAccountQuery,
    PostFeedSearchPostsAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedSearchPostsAccountQuery,
    PostFeedSearchPostsAccountQueryVariables
  >(PostFeedSearchPostsAccountQueryDocument, options);
}
export function usePostFeedSearchPostsAccountQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedSearchPostsAccountQuery,
        PostFeedSearchPostsAccountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedSearchPostsAccountQuery,
    PostFeedSearchPostsAccountQueryVariables
  >(PostFeedSearchPostsAccountQueryDocument, options);
}
export type PostFeedSearchPostsAccountQueryHookResult = ReturnType<
  typeof usePostFeedSearchPostsAccountQuery
>;
export type PostFeedSearchPostsAccountQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedSearchPostsAccountQueryLazyQuery
>;
export type PostFeedSearchPostsAccountQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFeedSearchPostsAccountQuerySuspenseQuery
>;
export type PostFeedSearchPostsAccountQueryQueryResult = Apollo.QueryResult<
  PostFeedSearchPostsAccountQuery,
  PostFeedSearchPostsAccountQueryVariables
>;
export const UpdateTranslationLanguageMutationDocument = gql`
  mutation UpdateTranslationLanguageMutation(
    $id: String!
    $updateAccountDtoInput: UpdateAccountDtoInput!
  ) {
    updateTranslationLanguage: updateAccount(
      id: $id
      updateAccountDtoInput: $updateAccountDtoInput
    ) {
      id
      language
    }
  }
`;
export type UpdateTranslationLanguageMutationMutationFn =
  Apollo.MutationFunction<
    UpdateTranslationLanguageMutation,
    UpdateTranslationLanguageMutationVariables
  >;

/**
 * __useUpdateTranslationLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationLanguageMutation, { data, loading, error }] = useUpdateTranslationLanguageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateAccountDtoInput: // value for 'updateAccountDtoInput'
 *   },
 * });
 */
export function useUpdateTranslationLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTranslationLanguageMutation,
    UpdateTranslationLanguageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTranslationLanguageMutation,
    UpdateTranslationLanguageMutationVariables
  >(UpdateTranslationLanguageMutationDocument, options);
}
export type UpdateTranslationLanguageMutationHookResult = ReturnType<
  typeof useUpdateTranslationLanguageMutation
>;
export type UpdateTranslationLanguageMutationMutationResult =
  Apollo.MutationResult<UpdateTranslationLanguageMutation>;
export type UpdateTranslationLanguageMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateTranslationLanguageMutation,
    UpdateTranslationLanguageMutationVariables
  >;
export const ChangeLanguageToTranslationPopupQueryDocument = gql`
  query ChangeLanguageToTranslationPopupQuery {
    me: getMe {
      id
      language
    }
  }
`;

/**
 * __useChangeLanguageToTranslationPopupQuery__
 *
 * To run a query within a React component, call `useChangeLanguageToTranslationPopupQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeLanguageToTranslationPopupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeLanguageToTranslationPopupQuery({
 *   variables: {
 *   },
 * });
 */
export function useChangeLanguageToTranslationPopupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChangeLanguageToTranslationPopupQuery,
    ChangeLanguageToTranslationPopupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChangeLanguageToTranslationPopupQuery,
    ChangeLanguageToTranslationPopupQueryVariables
  >(ChangeLanguageToTranslationPopupQueryDocument, options);
}
export function useChangeLanguageToTranslationPopupQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChangeLanguageToTranslationPopupQuery,
    ChangeLanguageToTranslationPopupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChangeLanguageToTranslationPopupQuery,
    ChangeLanguageToTranslationPopupQueryVariables
  >(ChangeLanguageToTranslationPopupQueryDocument, options);
}
export function useChangeLanguageToTranslationPopupQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChangeLanguageToTranslationPopupQuery,
        ChangeLanguageToTranslationPopupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChangeLanguageToTranslationPopupQuery,
    ChangeLanguageToTranslationPopupQueryVariables
  >(ChangeLanguageToTranslationPopupQueryDocument, options);
}
export type ChangeLanguageToTranslationPopupQueryHookResult = ReturnType<
  typeof useChangeLanguageToTranslationPopupQuery
>;
export type ChangeLanguageToTranslationPopupQueryLazyQueryHookResult =
  ReturnType<typeof useChangeLanguageToTranslationPopupQueryLazyQuery>;
export type ChangeLanguageToTranslationPopupQuerySuspenseQueryHookResult =
  ReturnType<typeof useChangeLanguageToTranslationPopupQuerySuspenseQuery>;
export type ChangeLanguageToTranslationPopupQueryQueryResult =
  Apollo.QueryResult<
    ChangeLanguageToTranslationPopupQuery,
    ChangeLanguageToTranslationPopupQueryVariables
  >;
export const InsertLinkPopupQueryDocument = gql`
  query InsertLinkPopupQuery($url: String!) {
    urlMetadata: getUrlMetadata(url: $url) {
      id
      ...InsertLinkPopupUrlMetadataFields
    }
  }
  ${InsertLinkPopupUrlMetadataFieldsFragmentDoc}
`;

/**
 * __useInsertLinkPopupQuery__
 *
 * To run a query within a React component, call `useInsertLinkPopupQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsertLinkPopupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsertLinkPopupQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useInsertLinkPopupQuery(
  baseOptions: Apollo.QueryHookOptions<
    InsertLinkPopupQuery,
    InsertLinkPopupQueryVariables
  > &
    (
      | { variables: InsertLinkPopupQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InsertLinkPopupQuery, InsertLinkPopupQueryVariables>(
    InsertLinkPopupQueryDocument,
    options
  );
}
export function useInsertLinkPopupQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InsertLinkPopupQuery,
    InsertLinkPopupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InsertLinkPopupQuery,
    InsertLinkPopupQueryVariables
  >(InsertLinkPopupQueryDocument, options);
}
export function useInsertLinkPopupQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InsertLinkPopupQuery,
        InsertLinkPopupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InsertLinkPopupQuery,
    InsertLinkPopupQueryVariables
  >(InsertLinkPopupQueryDocument, options);
}
export type InsertLinkPopupQueryHookResult = ReturnType<
  typeof useInsertLinkPopupQuery
>;
export type InsertLinkPopupQueryLazyQueryHookResult = ReturnType<
  typeof useInsertLinkPopupQueryLazyQuery
>;
export type InsertLinkPopupQuerySuspenseQueryHookResult = ReturnType<
  typeof useInsertLinkPopupQuerySuspenseQuery
>;
export type InsertLinkPopupQueryQueryResult = Apollo.QueryResult<
  InsertLinkPopupQuery,
  InsertLinkPopupQueryVariables
>;
export const PostFormQueryDocument = gql`
  query PostFormQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      canMemberWriteComment
      canMemberReactToPost
      ...PostFormChannelFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      ...PostFormMemberFields
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
  ${PostFormChannelFieldsFragmentDoc}
  ${PostFormMemberFieldsFragmentDoc}
`;

/**
 * __usePostFormQuery__
 *
 * To run a query within a React component, call `usePostFormQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFormQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostFormQuery(
  baseOptions: Apollo.QueryHookOptions<PostFormQuery, PostFormQueryVariables> &
    ({ variables: PostFormQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostFormQuery, PostFormQueryVariables>(
    PostFormQueryDocument,
    options
  );
}
export function usePostFormQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFormQuery,
    PostFormQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostFormQuery, PostFormQueryVariables>(
    PostFormQueryDocument,
    options
  );
}
export function usePostFormQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PostFormQuery, PostFormQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PostFormQuery, PostFormQueryVariables>(
    PostFormQueryDocument,
    options
  );
}
export type PostFormQueryHookResult = ReturnType<typeof usePostFormQuery>;
export type PostFormQueryLazyQueryHookResult = ReturnType<
  typeof usePostFormQueryLazyQuery
>;
export type PostFormQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFormQuerySuspenseQuery
>;
export type PostFormQueryQueryResult = Apollo.QueryResult<
  PostFormQuery,
  PostFormQueryVariables
>;
export const PostFormChannelQueryDocument = gql`
  query PostFormChannelQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      canMemberWriteComment
      canMemberReactToPost
      ...PostFormChannelFields
    }
  }
  ${PostFormChannelFieldsFragmentDoc}
`;

/**
 * __usePostFormChannelQuery__
 *
 * To run a query within a React component, call `usePostFormChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFormChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFormChannelQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostFormChannelQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFormChannelQuery,
    PostFormChannelQueryVariables
  > &
    (
      | { variables: PostFormChannelQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostFormChannelQuery, PostFormChannelQueryVariables>(
    PostFormChannelQueryDocument,
    options
  );
}
export function usePostFormChannelQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFormChannelQuery,
    PostFormChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFormChannelQuery,
    PostFormChannelQueryVariables
  >(PostFormChannelQueryDocument, options);
}
export function usePostFormChannelQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFormChannelQuery,
        PostFormChannelQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFormChannelQuery,
    PostFormChannelQueryVariables
  >(PostFormChannelQueryDocument, options);
}
export type PostFormChannelQueryHookResult = ReturnType<
  typeof usePostFormChannelQuery
>;
export type PostFormChannelQueryLazyQueryHookResult = ReturnType<
  typeof usePostFormChannelQueryLazyQuery
>;
export type PostFormChannelQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostFormChannelQuerySuspenseQuery
>;
export type PostFormChannelQueryQueryResult = Apollo.QueryResult<
  PostFormChannelQuery,
  PostFormChannelQueryVariables
>;
export const PostHeaderQueryDocument = gql`
  query PostHeaderQuery($classroomId: String!, $assignmentId: String!) {
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...PostHeaderAssignmentFields
    }
  }
  ${PostHeaderAssignmentFieldsFragmentDoc}
`;

/**
 * __usePostHeaderQuery__
 *
 * To run a query within a React component, call `usePostHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostHeaderQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function usePostHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostHeaderQuery,
    PostHeaderQueryVariables
  > &
    (
      | { variables: PostHeaderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostHeaderQuery, PostHeaderQueryVariables>(
    PostHeaderQueryDocument,
    options
  );
}
export function usePostHeaderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostHeaderQuery,
    PostHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostHeaderQuery, PostHeaderQueryVariables>(
    PostHeaderQueryDocument,
    options
  );
}
export function usePostHeaderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PostHeaderQuery, PostHeaderQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PostHeaderQuery, PostHeaderQueryVariables>(
    PostHeaderQueryDocument,
    options
  );
}
export type PostHeaderQueryHookResult = ReturnType<typeof usePostHeaderQuery>;
export type PostHeaderQueryLazyQueryHookResult = ReturnType<
  typeof usePostHeaderQueryLazyQuery
>;
export type PostHeaderQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostHeaderQuerySuspenseQuery
>;
export type PostHeaderQueryQueryResult = Apollo.QueryResult<
  PostHeaderQuery,
  PostHeaderQueryVariables
>;
export const PostItemReadStatusQueryDocument = gql`
  query PostItemReadStatusQuery($postId: String!) {
    postReadStatus: getPostReadStatus(postId: $postId) {
      postId
      readStatus
    }
  }
`;

/**
 * __usePostItemReadStatusQuery__
 *
 * To run a query within a React component, call `usePostItemReadStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostItemReadStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostItemReadStatusQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostItemReadStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostItemReadStatusQuery,
    PostItemReadStatusQueryVariables
  > &
    (
      | { variables: PostItemReadStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostItemReadStatusQuery,
    PostItemReadStatusQueryVariables
  >(PostItemReadStatusQueryDocument, options);
}
export function usePostItemReadStatusQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostItemReadStatusQuery,
    PostItemReadStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostItemReadStatusQuery,
    PostItemReadStatusQueryVariables
  >(PostItemReadStatusQueryDocument, options);
}
export function usePostItemReadStatusQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostItemReadStatusQuery,
        PostItemReadStatusQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostItemReadStatusQuery,
    PostItemReadStatusQueryVariables
  >(PostItemReadStatusQueryDocument, options);
}
export type PostItemReadStatusQueryHookResult = ReturnType<
  typeof usePostItemReadStatusQuery
>;
export type PostItemReadStatusQueryLazyQueryHookResult = ReturnType<
  typeof usePostItemReadStatusQueryLazyQuery
>;
export type PostItemReadStatusQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostItemReadStatusQuerySuspenseQuery
>;
export type PostItemReadStatusQueryQueryResult = Apollo.QueryResult<
  PostItemReadStatusQuery,
  PostItemReadStatusQueryVariables
>;
export const AssignmentStatusTagQueryDocument = gql`
  query AssignmentStatusTagQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useAssignmentStatusTagQuery__
 *
 * To run a query within a React component, call `useAssignmentStatusTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentStatusTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentStatusTagQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAssignmentStatusTagQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentStatusTagQuery,
    AssignmentStatusTagQueryVariables
  > &
    (
      | { variables: AssignmentStatusTagQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentStatusTagQuery,
    AssignmentStatusTagQueryVariables
  >(AssignmentStatusTagQueryDocument, options);
}
export function useAssignmentStatusTagQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentStatusTagQuery,
    AssignmentStatusTagQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentStatusTagQuery,
    AssignmentStatusTagQueryVariables
  >(AssignmentStatusTagQueryDocument, options);
}
export function useAssignmentStatusTagQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentStatusTagQuery,
        AssignmentStatusTagQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentStatusTagQuery,
    AssignmentStatusTagQueryVariables
  >(AssignmentStatusTagQueryDocument, options);
}
export type AssignmentStatusTagQueryHookResult = ReturnType<
  typeof useAssignmentStatusTagQuery
>;
export type AssignmentStatusTagQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentStatusTagQueryLazyQuery
>;
export type AssignmentStatusTagQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentStatusTagQuerySuspenseQuery
>;
export type AssignmentStatusTagQueryQueryResult = Apollo.QueryResult<
  AssignmentStatusTagQuery,
  AssignmentStatusTagQueryVariables
>;
export const AssignmentStatusTagAssigneeQueryDocument = gql`
  query AssignmentStatusTagAssigneeQuery(
    $classroomId: String!
    $assignmentId: String!
    $assigneeId: String!
  ) {
    assignmentSubmission: getAssignmentSubmission(
      classroomId: $classroomId
      assignmentId: $assignmentId
      assigneeId: $assigneeId
    ) {
      id
      submissions {
        id
      }
      learningSubmission {
        id
      }
      isSubmitted
    }
  }
`;

/**
 * __useAssignmentStatusTagAssigneeQuery__
 *
 * To run a query within a React component, call `useAssignmentStatusTagAssigneeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentStatusTagAssigneeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentStatusTagAssigneeQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useAssignmentStatusTagAssigneeQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentStatusTagAssigneeQuery,
    AssignmentStatusTagAssigneeQueryVariables
  > &
    (
      | { variables: AssignmentStatusTagAssigneeQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentStatusTagAssigneeQuery,
    AssignmentStatusTagAssigneeQueryVariables
  >(AssignmentStatusTagAssigneeQueryDocument, options);
}
export function useAssignmentStatusTagAssigneeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentStatusTagAssigneeQuery,
    AssignmentStatusTagAssigneeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentStatusTagAssigneeQuery,
    AssignmentStatusTagAssigneeQueryVariables
  >(AssignmentStatusTagAssigneeQueryDocument, options);
}
export function useAssignmentStatusTagAssigneeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentStatusTagAssigneeQuery,
        AssignmentStatusTagAssigneeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentStatusTagAssigneeQuery,
    AssignmentStatusTagAssigneeQueryVariables
  >(AssignmentStatusTagAssigneeQueryDocument, options);
}
export type AssignmentStatusTagAssigneeQueryHookResult = ReturnType<
  typeof useAssignmentStatusTagAssigneeQuery
>;
export type AssignmentStatusTagAssigneeQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentStatusTagAssigneeQueryLazyQuery
>;
export type AssignmentStatusTagAssigneeQuerySuspenseQueryHookResult =
  ReturnType<typeof useAssignmentStatusTagAssigneeQuerySuspenseQuery>;
export type AssignmentStatusTagAssigneeQueryQueryResult = Apollo.QueryResult<
  AssignmentStatusTagAssigneeQuery,
  AssignmentStatusTagAssigneeQueryVariables
>;
export const AssignmentStatusTagGraderQueryDocument = gql`
  query AssignmentStatusTagGraderQuery(
    $classroomId: String!
    $assignmentId: String!
    $limit: Int
  ) {
    submittedAssignmentSubmissions: listAssignmentSubmissions(
      classroomId: $classroomId
      assignmentId: $assignmentId
      limit: $limit
      submitted: "true"
    ) {
      id
      gradingStatus
    }
    notSubmittedAssignmentSubmissions: listAssignmentSubmissions(
      classroomId: $classroomId
      assignmentId: $assignmentId
      limit: $limit
      submitted: "false"
    ) {
      id
      gradingStatus
    }
  }
`;

/**
 * __useAssignmentStatusTagGraderQuery__
 *
 * To run a query within a React component, call `useAssignmentStatusTagGraderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentStatusTagGraderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentStatusTagGraderQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAssignmentStatusTagGraderQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignmentStatusTagGraderQuery,
    AssignmentStatusTagGraderQueryVariables
  > &
    (
      | { variables: AssignmentStatusTagGraderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssignmentStatusTagGraderQuery,
    AssignmentStatusTagGraderQueryVariables
  >(AssignmentStatusTagGraderQueryDocument, options);
}
export function useAssignmentStatusTagGraderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignmentStatusTagGraderQuery,
    AssignmentStatusTagGraderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssignmentStatusTagGraderQuery,
    AssignmentStatusTagGraderQueryVariables
  >(AssignmentStatusTagGraderQueryDocument, options);
}
export function useAssignmentStatusTagGraderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignmentStatusTagGraderQuery,
        AssignmentStatusTagGraderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssignmentStatusTagGraderQuery,
    AssignmentStatusTagGraderQueryVariables
  >(AssignmentStatusTagGraderQueryDocument, options);
}
export type AssignmentStatusTagGraderQueryHookResult = ReturnType<
  typeof useAssignmentStatusTagGraderQuery
>;
export type AssignmentStatusTagGraderQueryLazyQueryHookResult = ReturnType<
  typeof useAssignmentStatusTagGraderQueryLazyQuery
>;
export type AssignmentStatusTagGraderQuerySuspenseQueryHookResult = ReturnType<
  typeof useAssignmentStatusTagGraderQuerySuspenseQuery
>;
export type AssignmentStatusTagGraderQueryQueryResult = Apollo.QueryResult<
  AssignmentStatusTagGraderQuery,
  AssignmentStatusTagGraderQueryVariables
>;
export const PostItemBodyQueryDocument = gql`
  query PostItemBodyQuery($classroomId: String!, $assignmentId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    assignment: getAssignment(
      classroomId: $classroomId
      assignmentId: $assignmentId
    ) {
      ...PostItemBodyAssignmentDtoFields
    }
  }
  ${PostItemBodyAssignmentDtoFieldsFragmentDoc}
`;

/**
 * __usePostItemBodyQuery__
 *
 * To run a query within a React component, call `usePostItemBodyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostItemBodyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostItemBodyQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function usePostItemBodyQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostItemBodyQuery,
    PostItemBodyQueryVariables
  > &
    (
      | { variables: PostItemBodyQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostItemBodyQuery, PostItemBodyQueryVariables>(
    PostItemBodyQueryDocument,
    options
  );
}
export function usePostItemBodyQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostItemBodyQuery,
    PostItemBodyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostItemBodyQuery, PostItemBodyQueryVariables>(
    PostItemBodyQueryDocument,
    options
  );
}
export function usePostItemBodyQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostItemBodyQuery,
        PostItemBodyQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PostItemBodyQuery, PostItemBodyQueryVariables>(
    PostItemBodyQueryDocument,
    options
  );
}
export type PostItemBodyQueryHookResult = ReturnType<
  typeof usePostItemBodyQuery
>;
export type PostItemBodyQueryLazyQueryHookResult = ReturnType<
  typeof usePostItemBodyQueryLazyQuery
>;
export type PostItemBodyQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostItemBodyQuerySuspenseQuery
>;
export type PostItemBodyQueryQueryResult = Apollo.QueryResult<
  PostItemBodyQuery,
  PostItemBodyQueryVariables
>;
export const PostItemHeaderQueryDocument = gql`
  query PostItemHeaderQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
      isPrivate
    }
  }
`;

/**
 * __usePostItemHeaderQuery__
 *
 * To run a query within a React component, call `usePostItemHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostItemHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostItemHeaderQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostItemHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostItemHeaderQuery,
    PostItemHeaderQueryVariables
  > &
    (
      | { variables: PostItemHeaderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostItemHeaderQuery, PostItemHeaderQueryVariables>(
    PostItemHeaderQueryDocument,
    options
  );
}
export function usePostItemHeaderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostItemHeaderQuery,
    PostItemHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostItemHeaderQuery, PostItemHeaderQueryVariables>(
    PostItemHeaderQueryDocument,
    options
  );
}
export function usePostItemHeaderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostItemHeaderQuery,
        PostItemHeaderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostItemHeaderQuery,
    PostItemHeaderQueryVariables
  >(PostItemHeaderQueryDocument, options);
}
export type PostItemHeaderQueryHookResult = ReturnType<
  typeof usePostItemHeaderQuery
>;
export type PostItemHeaderQueryLazyQueryHookResult = ReturnType<
  typeof usePostItemHeaderQueryLazyQuery
>;
export type PostItemHeaderQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostItemHeaderQuerySuspenseQuery
>;
export type PostItemHeaderQueryQueryResult = Apollo.QueryResult<
  PostItemHeaderQuery,
  PostItemHeaderQueryVariables
>;
export const PostListQueryDocument = gql`
  query PostListQuery(
    $classroomId: String!
    $channelId: String!
    $cursor: String
    $limit: Float
  ) {
    postsCollection: listPosts(
      classroomId: $classroomId
      channelId: $channelId
      cursor: $cursor
      limit: $limit
    ) {
      cursor
      posts {
        ...PostItemPostFields
      }
    }
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
  ${PostItemPostFieldsFragmentDoc}
`;

/**
 * __usePostListQuery__
 *
 * To run a query within a React component, call `usePostListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePostListQuery(
  baseOptions: Apollo.QueryHookOptions<PostListQuery, PostListQueryVariables> &
    ({ variables: PostListQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostListQuery, PostListQueryVariables>(
    PostListQueryDocument,
    options
  );
}
export function usePostListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostListQuery,
    PostListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostListQuery, PostListQueryVariables>(
    PostListQueryDocument,
    options
  );
}
export function usePostListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PostListQuery, PostListQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PostListQuery, PostListQueryVariables>(
    PostListQueryDocument,
    options
  );
}
export type PostListQueryHookResult = ReturnType<typeof usePostListQuery>;
export type PostListQueryLazyQueryHookResult = ReturnType<
  typeof usePostListQueryLazyQuery
>;
export type PostListQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostListQuerySuspenseQuery
>;
export type PostListQueryQueryResult = Apollo.QueryResult<
  PostListQuery,
  PostListQueryVariables
>;
export const PostListSearchedByTagQueryDocument = gql`
  query PostListSearchedByTagQuery(
    $classroomId: String!
    $channelId: String!
    $tag: String!
    $page: Float!
    $perPage: Float!
  ) {
    postsCollection: searchPosts(
      classroomId: $classroomId
      channelId: $channelId
      tag: $tag
      page: $page
      perPage: $perPage
    ) {
      posts {
        ...PostItemPostFields
      }
      totalPages
      perPage
      page
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
  ${PostItemPostFieldsFragmentDoc}
`;

/**
 * __usePostListSearchedByTagQuery__
 *
 * To run a query within a React component, call `usePostListSearchedByTagQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostListSearchedByTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostListSearchedByTagQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      tag: // value for 'tag'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function usePostListSearchedByTagQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostListSearchedByTagQuery,
    PostListSearchedByTagQueryVariables
  > &
    (
      | { variables: PostListSearchedByTagQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostListSearchedByTagQuery,
    PostListSearchedByTagQueryVariables
  >(PostListSearchedByTagQueryDocument, options);
}
export function usePostListSearchedByTagQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostListSearchedByTagQuery,
    PostListSearchedByTagQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostListSearchedByTagQuery,
    PostListSearchedByTagQueryVariables
  >(PostListSearchedByTagQueryDocument, options);
}
export function usePostListSearchedByTagQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostListSearchedByTagQuery,
        PostListSearchedByTagQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostListSearchedByTagQuery,
    PostListSearchedByTagQueryVariables
  >(PostListSearchedByTagQueryDocument, options);
}
export type PostListSearchedByTagQueryHookResult = ReturnType<
  typeof usePostListSearchedByTagQuery
>;
export type PostListSearchedByTagQueryLazyQueryHookResult = ReturnType<
  typeof usePostListSearchedByTagQueryLazyQuery
>;
export type PostListSearchedByTagQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostListSearchedByTagQuerySuspenseQuery
>;
export type PostListSearchedByTagQueryQueryResult = Apollo.QueryResult<
  PostListSearchedByTagQuery,
  PostListSearchedByTagQueryVariables
>;
export const PostChannelNameQueryDocument = gql`
  query PostChannelNameQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
`;

/**
 * __usePostChannelNameQuery__
 *
 * To run a query within a React component, call `usePostChannelNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostChannelNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostChannelNameQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostChannelNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostChannelNameQuery,
    PostChannelNameQueryVariables
  > &
    (
      | { variables: PostChannelNameQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostChannelNameQuery, PostChannelNameQueryVariables>(
    PostChannelNameQueryDocument,
    options
  );
}
export function usePostChannelNameQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostChannelNameQuery,
    PostChannelNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostChannelNameQuery,
    PostChannelNameQueryVariables
  >(PostChannelNameQueryDocument, options);
}
export function usePostChannelNameQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostChannelNameQuery,
        PostChannelNameQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostChannelNameQuery,
    PostChannelNameQueryVariables
  >(PostChannelNameQueryDocument, options);
}
export type PostChannelNameQueryHookResult = ReturnType<
  typeof usePostChannelNameQuery
>;
export type PostChannelNameQueryLazyQueryHookResult = ReturnType<
  typeof usePostChannelNameQueryLazyQuery
>;
export type PostChannelNameQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostChannelNameQuerySuspenseQuery
>;
export type PostChannelNameQueryQueryResult = Apollo.QueryResult<
  PostChannelNameQuery,
  PostChannelNameQueryVariables
>;
export const ReportPostMutationDocument = gql`
  mutation ReportPostMutation(
    $classroomId: String!
    $postId: String!
    $reportPostDtoInput: ReportPostDtoInput!
  ) {
    reportPost(
      classroomId: $classroomId
      postId: $postId
      reportPostDtoInput: $reportPostDtoInput
    ) {
      id
    }
  }
`;
export type ReportPostMutationMutationFn = Apollo.MutationFunction<
  ReportPostMutation,
  ReportPostMutationVariables
>;

/**
 * __useReportPostMutation__
 *
 * To run a mutation, you first call `useReportPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportPostMutation, { data, loading, error }] = useReportPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      reportPostDtoInput: // value for 'reportPostDtoInput'
 *   },
 * });
 */
export function useReportPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReportPostMutation,
    ReportPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReportPostMutation, ReportPostMutationVariables>(
    ReportPostMutationDocument,
    options
  );
}
export type ReportPostMutationHookResult = ReturnType<
  typeof useReportPostMutation
>;
export type ReportPostMutationMutationResult =
  Apollo.MutationResult<ReportPostMutation>;
export type ReportPostMutationMutationOptions = Apollo.BaseMutationOptions<
  ReportPostMutation,
  ReportPostMutationVariables
>;
export const DeletePostMutationDocument = gql`
  mutation DeletePostMutation($classroomId: String!, $postId: String!) {
    deletePost(classroomId: $classroomId, postId: $postId)
  }
`;
export type DeletePostMutationMutationFn = Apollo.MutationFunction<
  DeletePostMutation,
  DeletePostMutationVariables
>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePostMutation,
    DeletePostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(
    DeletePostMutationDocument,
    options
  );
}
export type DeletePostMutationHookResult = ReturnType<
  typeof useDeletePostMutation
>;
export type DeletePostMutationMutationResult =
  Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationMutationOptions = Apollo.BaseMutationOptions<
  DeletePostMutation,
  DeletePostMutationVariables
>;
export const PinPostMutationDocument = gql`
  mutation PinPostMutation(
    $classroomId: String!
    $channelId: String!
    $pinPostDtoInput: PinPostDtoInput!
  ) {
    pinPost(
      classroomId: $classroomId
      channelId: $channelId
      pinPostDtoInput: $pinPostDtoInput
    ) {
      ...PostFeedPinnedPostItemChannelPostPinDtoFields
    }
  }
  ${PostFeedPinnedPostItemChannelPostPinDtoFieldsFragmentDoc}
`;
export type PinPostMutationMutationFn = Apollo.MutationFunction<
  PinPostMutation,
  PinPostMutationVariables
>;

/**
 * __usePinPostMutation__
 *
 * To run a mutation, you first call `usePinPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinPostMutation, { data, loading, error }] = usePinPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      pinPostDtoInput: // value for 'pinPostDtoInput'
 *   },
 * });
 */
export function usePinPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PinPostMutation,
    PinPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PinPostMutation, PinPostMutationVariables>(
    PinPostMutationDocument,
    options
  );
}
export type PinPostMutationHookResult = ReturnType<typeof usePinPostMutation>;
export type PinPostMutationMutationResult =
  Apollo.MutationResult<PinPostMutation>;
export type PinPostMutationMutationOptions = Apollo.BaseMutationOptions<
  PinPostMutation,
  PinPostMutationVariables
>;
export const UnpinPostMutationDocument = gql`
  mutation UnpinPostMutation(
    $classroomId: String!
    $channelId: String!
    $unpinPostDtoInput: UnpinPostDtoInput!
  ) {
    unpinPost(
      classroomId: $classroomId
      channelId: $channelId
      unpinPostDtoInput: $unpinPostDtoInput
    )
  }
`;
export type UnpinPostMutationMutationFn = Apollo.MutationFunction<
  UnpinPostMutation,
  UnpinPostMutationVariables
>;

/**
 * __useUnpinPostMutation__
 *
 * To run a mutation, you first call `useUnpinPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinPostMutation, { data, loading, error }] = useUnpinPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      unpinPostDtoInput: // value for 'unpinPostDtoInput'
 *   },
 * });
 */
export function useUnpinPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnpinPostMutation,
    UnpinPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnpinPostMutation, UnpinPostMutationVariables>(
    UnpinPostMutationDocument,
    options
  );
}
export type UnpinPostMutationHookResult = ReturnType<
  typeof useUnpinPostMutation
>;
export type UnpinPostMutationMutationResult =
  Apollo.MutationResult<UnpinPostMutation>;
export type UnpinPostMutationMutationOptions = Apollo.BaseMutationOptions<
  UnpinPostMutation,
  UnpinPostMutationVariables
>;
export const UpdatePostChannelAdminMutationDocument = gql`
  mutation updatePostChannelAdminMutation(
    $classroomId: String!
    $postId: String!
    $updatePostChannelAdminDtoInput: UpdatePostChannelAdminDtoInput!
  ) {
    updatePostChannelAdmin(
      classroomId: $classroomId
      postId: $postId
      updatePostChannelAdminDtoInput: $updatePostChannelAdminDtoInput
    ) {
      channelId
    }
  }
`;
export type UpdatePostChannelAdminMutationMutationFn = Apollo.MutationFunction<
  UpdatePostChannelAdminMutation,
  UpdatePostChannelAdminMutationVariables
>;

/**
 * __useUpdatePostChannelAdminMutation__
 *
 * To run a mutation, you first call `useUpdatePostChannelAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostChannelAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostChannelAdminMutation, { data, loading, error }] = useUpdatePostChannelAdminMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      updatePostChannelAdminDtoInput: // value for 'updatePostChannelAdminDtoInput'
 *   },
 * });
 */
export function useUpdatePostChannelAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePostChannelAdminMutation,
    UpdatePostChannelAdminMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePostChannelAdminMutation,
    UpdatePostChannelAdminMutationVariables
  >(UpdatePostChannelAdminMutationDocument, options);
}
export type UpdatePostChannelAdminMutationHookResult = ReturnType<
  typeof useUpdatePostChannelAdminMutation
>;
export type UpdatePostChannelAdminMutationMutationResult =
  Apollo.MutationResult<UpdatePostChannelAdminMutation>;
export type UpdatePostChannelAdminMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePostChannelAdminMutation,
    UpdatePostChannelAdminMutationVariables
  >;
export const UpdateAdminExclusiveMutationDocument = gql`
  mutation updateAdminExclusiveMutation(
    $classroomId: String!
    $postId: String!
    $updatePostAdminExclusiveByAdminDtoInput: UpdatePostAdminExclusiveByAdminDtoInput!
  ) {
    updateAdminExclusive: updatePostAdminExclusiveByAdmin(
      classroomId: $classroomId
      postId: $postId
      updatePostAdminExclusiveByAdminDtoInput: $updatePostAdminExclusiveByAdminDtoInput
    ) {
      adminExclusive
      id
    }
  }
`;
export type UpdateAdminExclusiveMutationMutationFn = Apollo.MutationFunction<
  UpdateAdminExclusiveMutation,
  UpdateAdminExclusiveMutationVariables
>;

/**
 * __useUpdateAdminExclusiveMutation__
 *
 * To run a mutation, you first call `useUpdateAdminExclusiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminExclusiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminExclusiveMutation, { data, loading, error }] = useUpdateAdminExclusiveMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      updatePostAdminExclusiveByAdminDtoInput: // value for 'updatePostAdminExclusiveByAdminDtoInput'
 *   },
 * });
 */
export function useUpdateAdminExclusiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdminExclusiveMutation,
    UpdateAdminExclusiveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAdminExclusiveMutation,
    UpdateAdminExclusiveMutationVariables
  >(UpdateAdminExclusiveMutationDocument, options);
}
export type UpdateAdminExclusiveMutationHookResult = ReturnType<
  typeof useUpdateAdminExclusiveMutation
>;
export type UpdateAdminExclusiveMutationMutationResult =
  Apollo.MutationResult<UpdateAdminExclusiveMutation>;
export type UpdateAdminExclusiveMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAdminExclusiveMutation,
    UpdateAdminExclusiveMutationVariables
  >;
export const PostMoreMenuQueryDocument = gql`
  query PostMoreMenuQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __usePostMoreMenuQuery__
 *
 * To run a query within a React component, call `usePostMoreMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostMoreMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostMoreMenuQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function usePostMoreMenuQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostMoreMenuQuery,
    PostMoreMenuQueryVariables
  > &
    (
      | { variables: PostMoreMenuQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostMoreMenuQuery, PostMoreMenuQueryVariables>(
    PostMoreMenuQueryDocument,
    options
  );
}
export function usePostMoreMenuQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostMoreMenuQuery,
    PostMoreMenuQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostMoreMenuQuery, PostMoreMenuQueryVariables>(
    PostMoreMenuQueryDocument,
    options
  );
}
export function usePostMoreMenuQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostMoreMenuQuery,
        PostMoreMenuQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PostMoreMenuQuery, PostMoreMenuQueryVariables>(
    PostMoreMenuQueryDocument,
    options
  );
}
export type PostMoreMenuQueryHookResult = ReturnType<
  typeof usePostMoreMenuQuery
>;
export type PostMoreMenuQueryLazyQueryHookResult = ReturnType<
  typeof usePostMoreMenuQueryLazyQuery
>;
export type PostMoreMenuQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostMoreMenuQuerySuspenseQuery
>;
export type PostMoreMenuQueryQueryResult = Apollo.QueryResult<
  PostMoreMenuQuery,
  PostMoreMenuQueryVariables
>;
export const PostMoreMenuPostPermissionAndChannelQueryDocument = gql`
  query PostMoreMenuPostPermissionAndChannelQuery(
    $classroomId: String!
    $channelId: String!
    $postId: String!
  ) {
    postPermission: getPostPermission(
      classroomId: $classroomId
      postId: $postId
    ) {
      canDelete
      canEdit
      canPin
    }
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      channelType
      name
      isCommon
    }
  }
`;

/**
 * __usePostMoreMenuPostPermissionAndChannelQuery__
 *
 * To run a query within a React component, call `usePostMoreMenuPostPermissionAndChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostMoreMenuPostPermissionAndChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostMoreMenuPostPermissionAndChannelQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostMoreMenuPostPermissionAndChannelQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostMoreMenuPostPermissionAndChannelQuery,
    PostMoreMenuPostPermissionAndChannelQueryVariables
  > &
    (
      | {
          variables: PostMoreMenuPostPermissionAndChannelQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostMoreMenuPostPermissionAndChannelQuery,
    PostMoreMenuPostPermissionAndChannelQueryVariables
  >(PostMoreMenuPostPermissionAndChannelQueryDocument, options);
}
export function usePostMoreMenuPostPermissionAndChannelQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostMoreMenuPostPermissionAndChannelQuery,
    PostMoreMenuPostPermissionAndChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostMoreMenuPostPermissionAndChannelQuery,
    PostMoreMenuPostPermissionAndChannelQueryVariables
  >(PostMoreMenuPostPermissionAndChannelQueryDocument, options);
}
export function usePostMoreMenuPostPermissionAndChannelQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostMoreMenuPostPermissionAndChannelQuery,
        PostMoreMenuPostPermissionAndChannelQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostMoreMenuPostPermissionAndChannelQuery,
    PostMoreMenuPostPermissionAndChannelQueryVariables
  >(PostMoreMenuPostPermissionAndChannelQueryDocument, options);
}
export type PostMoreMenuPostPermissionAndChannelQueryHookResult = ReturnType<
  typeof usePostMoreMenuPostPermissionAndChannelQuery
>;
export type PostMoreMenuPostPermissionAndChannelQueryLazyQueryHookResult =
  ReturnType<typeof usePostMoreMenuPostPermissionAndChannelQueryLazyQuery>;
export type PostMoreMenuPostPermissionAndChannelQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostMoreMenuPostPermissionAndChannelQuerySuspenseQuery>;
export type PostMoreMenuPostPermissionAndChannelQueryQueryResult =
  Apollo.QueryResult<
    PostMoreMenuPostPermissionAndChannelQuery,
    PostMoreMenuPostPermissionAndChannelQueryVariables
  >;
export const AddReactionToPostDocument = gql`
  mutation AddReactionToPost(
    $classroomId: String!
    $postId: String!
    $addReactionToPostDtoInput: AddReactionToPostDtoInput!
  ) {
    addReactionToPost(
      classroomId: $classroomId
      postId: $postId
      addReactionToPostDtoInput: $addReactionToPostDtoInput
    ) {
      ...PostReactionPostFields
    }
  }
  ${PostReactionPostFieldsFragmentDoc}
`;
export type AddReactionToPostMutationFn = Apollo.MutationFunction<
  AddReactionToPostMutation,
  AddReactionToPostMutationVariables
>;

/**
 * __useAddReactionToPostMutation__
 *
 * To run a mutation, you first call `useAddReactionToPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionToPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionToPostMutation, { data, loading, error }] = useAddReactionToPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      addReactionToPostDtoInput: // value for 'addReactionToPostDtoInput'
 *   },
 * });
 */
export function useAddReactionToPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddReactionToPostMutation,
    AddReactionToPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddReactionToPostMutation,
    AddReactionToPostMutationVariables
  >(AddReactionToPostDocument, options);
}
export type AddReactionToPostMutationHookResult = ReturnType<
  typeof useAddReactionToPostMutation
>;
export type AddReactionToPostMutationResult =
  Apollo.MutationResult<AddReactionToPostMutation>;
export type AddReactionToPostMutationOptions = Apollo.BaseMutationOptions<
  AddReactionToPostMutation,
  AddReactionToPostMutationVariables
>;
export const RemoveReactionFromPostDocument = gql`
  mutation RemoveReactionFromPost(
    $classroomId: String!
    $postId: String!
    $removeReactionFromPostDtoInput: RemoveReactionFromPostDtoInput!
  ) {
    removeReactionFromPost(
      classroomId: $classroomId
      postId: $postId
      removeReactionFromPostDtoInput: $removeReactionFromPostDtoInput
    ) {
      ...PostReactionPostFields
    }
  }
  ${PostReactionPostFieldsFragmentDoc}
`;
export type RemoveReactionFromPostMutationFn = Apollo.MutationFunction<
  RemoveReactionFromPostMutation,
  RemoveReactionFromPostMutationVariables
>;

/**
 * __useRemoveReactionFromPostMutation__
 *
 * To run a mutation, you first call `useRemoveReactionFromPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReactionFromPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReactionFromPostMutation, { data, loading, error }] = useRemoveReactionFromPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      removeReactionFromPostDtoInput: // value for 'removeReactionFromPostDtoInput'
 *   },
 * });
 */
export function useRemoveReactionFromPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveReactionFromPostMutation,
    RemoveReactionFromPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveReactionFromPostMutation,
    RemoveReactionFromPostMutationVariables
  >(RemoveReactionFromPostDocument, options);
}
export type RemoveReactionFromPostMutationHookResult = ReturnType<
  typeof useRemoveReactionFromPostMutation
>;
export type RemoveReactionFromPostMutationResult =
  Apollo.MutationResult<RemoveReactionFromPostMutation>;
export type RemoveReactionFromPostMutationOptions = Apollo.BaseMutationOptions<
  RemoveReactionFromPostMutation,
  RemoveReactionFromPostMutationVariables
>;
export const PostReactionDocument = gql`
  query PostReaction($classroomId: String!, $postId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
    }
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...PostReactionPostFields
    }
  }
  ${PostReactionPostFieldsFragmentDoc}
`;

/**
 * __usePostReactionQuery__
 *
 * To run a query within a React component, call `usePostReactionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostReactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostReactionQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostReactionQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostReactionQuery,
    PostReactionQueryVariables
  > &
    (
      | { variables: PostReactionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostReactionQuery, PostReactionQueryVariables>(
    PostReactionDocument,
    options
  );
}
export function usePostReactionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostReactionQuery,
    PostReactionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostReactionQuery, PostReactionQueryVariables>(
    PostReactionDocument,
    options
  );
}
export function usePostReactionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostReactionQuery,
        PostReactionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PostReactionQuery, PostReactionQueryVariables>(
    PostReactionDocument,
    options
  );
}
export type PostReactionQueryHookResult = ReturnType<
  typeof usePostReactionQuery
>;
export type PostReactionLazyQueryHookResult = ReturnType<
  typeof usePostReactionLazyQuery
>;
export type PostReactionSuspenseQueryHookResult = ReturnType<
  typeof usePostReactionSuspenseQuery
>;
export type PostReactionQueryResult = Apollo.QueryResult<
  PostReactionQuery,
  PostReactionQueryVariables
>;
export const PostReactionListQueryDocument = gql`
  query PostReactionListQuery($classroomId: String!, $postId: String!) {
    postReactions: listPostReactions(
      classroomId: $classroomId
      postId: $postId
    ) {
      reactions {
        member {
          id
          name
          profileImageUrl
          blocked
          ...MemberItemMemberFields
        }
        name
      }
    }
  }
  ${MemberItemMemberFieldsFragmentDoc}
`;

/**
 * __usePostReactionListQuery__
 *
 * To run a query within a React component, call `usePostReactionListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostReactionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostReactionListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostReactionListQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostReactionListQuery,
    PostReactionListQueryVariables
  > &
    (
      | { variables: PostReactionListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostReactionListQuery, PostReactionListQueryVariables>(
    PostReactionListQueryDocument,
    options
  );
}
export function usePostReactionListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostReactionListQuery,
    PostReactionListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostReactionListQuery,
    PostReactionListQueryVariables
  >(PostReactionListQueryDocument, options);
}
export function usePostReactionListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostReactionListQuery,
        PostReactionListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostReactionListQuery,
    PostReactionListQueryVariables
  >(PostReactionListQueryDocument, options);
}
export type PostReactionListQueryHookResult = ReturnType<
  typeof usePostReactionListQuery
>;
export type PostReactionListQueryLazyQueryHookResult = ReturnType<
  typeof usePostReactionListQueryLazyQuery
>;
export type PostReactionListQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostReactionListQuerySuspenseQuery
>;
export type PostReactionListQueryQueryResult = Apollo.QueryResult<
  PostReactionListQuery,
  PostReactionListQueryVariables
>;
export const PostRecipientsQueryDocument = gql`
  query PostRecipientsQuery($classroomId: String!, $channelId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __usePostRecipientsQuery__
 *
 * To run a query within a React component, call `usePostRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostRecipientsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostRecipientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostRecipientsQuery,
    PostRecipientsQueryVariables
  > &
    (
      | { variables: PostRecipientsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostRecipientsQuery, PostRecipientsQueryVariables>(
    PostRecipientsQueryDocument,
    options
  );
}
export function usePostRecipientsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostRecipientsQuery,
    PostRecipientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostRecipientsQuery, PostRecipientsQueryVariables>(
    PostRecipientsQueryDocument,
    options
  );
}
export function usePostRecipientsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostRecipientsQuery,
        PostRecipientsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostRecipientsQuery,
    PostRecipientsQueryVariables
  >(PostRecipientsQueryDocument, options);
}
export type PostRecipientsQueryHookResult = ReturnType<
  typeof usePostRecipientsQuery
>;
export type PostRecipientsQueryLazyQueryHookResult = ReturnType<
  typeof usePostRecipientsQueryLazyQuery
>;
export type PostRecipientsQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostRecipientsQuerySuspenseQuery
>;
export type PostRecipientsQueryQueryResult = Apollo.QueryResult<
  PostRecipientsQuery,
  PostRecipientsQueryVariables
>;
export const PostReadUnreadMembersQueryDocument = gql`
  query PostReadUnreadMembersQuery($classroomId: String!, $postId: String!) {
    readMembers: listPostReads(classroomId: $classroomId, postId: $postId) {
      ...PostRecipientsMemberFields
    }
    unreadMembers: listPostUnreads(classroomId: $classroomId, postId: $postId) {
      ...PostRecipientsMemberFields
    }
  }
  ${PostRecipientsMemberFieldsFragmentDoc}
`;

/**
 * __usePostReadUnreadMembersQuery__
 *
 * To run a query within a React component, call `usePostReadUnreadMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostReadUnreadMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostReadUnreadMembersQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostReadUnreadMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostReadUnreadMembersQuery,
    PostReadUnreadMembersQueryVariables
  > &
    (
      | { variables: PostReadUnreadMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostReadUnreadMembersQuery,
    PostReadUnreadMembersQueryVariables
  >(PostReadUnreadMembersQueryDocument, options);
}
export function usePostReadUnreadMembersQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostReadUnreadMembersQuery,
    PostReadUnreadMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostReadUnreadMembersQuery,
    PostReadUnreadMembersQueryVariables
  >(PostReadUnreadMembersQueryDocument, options);
}
export function usePostReadUnreadMembersQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostReadUnreadMembersQuery,
        PostReadUnreadMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostReadUnreadMembersQuery,
    PostReadUnreadMembersQueryVariables
  >(PostReadUnreadMembersQueryDocument, options);
}
export type PostReadUnreadMembersQueryHookResult = ReturnType<
  typeof usePostReadUnreadMembersQuery
>;
export type PostReadUnreadMembersQueryLazyQueryHookResult = ReturnType<
  typeof usePostReadUnreadMembersQueryLazyQuery
>;
export type PostReadUnreadMembersQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostReadUnreadMembersQuerySuspenseQuery
>;
export type PostReadUnreadMembersQueryQueryResult = Apollo.QueryResult<
  PostReadUnreadMembersQuery,
  PostReadUnreadMembersQueryVariables
>;
export const RemindPostMutationDocument = gql`
  mutation remindPostMutation($classroomId: String!, $postId: String!) {
    post: remindPost(classroomId: $classroomId, postId: $postId) {
      id
      lastNotifiedAt
    }
  }
`;
export type RemindPostMutationMutationFn = Apollo.MutationFunction<
  RemindPostMutation,
  RemindPostMutationVariables
>;

/**
 * __useRemindPostMutation__
 *
 * To run a mutation, you first call `useRemindPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindPostMutation, { data, loading, error }] = useRemindPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useRemindPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemindPostMutation,
    RemindPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemindPostMutation, RemindPostMutationVariables>(
    RemindPostMutationDocument,
    options
  );
}
export type RemindPostMutationHookResult = ReturnType<
  typeof useRemindPostMutation
>;
export type RemindPostMutationMutationResult =
  Apollo.MutationResult<RemindPostMutation>;
export type RemindPostMutationMutationOptions = Apollo.BaseMutationOptions<
  RemindPostMutation,
  RemindPostMutationVariables
>;
export const CreateTagMutationDocument = gql`
  mutation CreateTagMutation(
    $classroomId: String!
    $createTagDtoInput: CreateTagDtoInput!
  ) {
    createTag(
      classroomId: $classroomId
      createTagDtoInput: $createTagDtoInput
    ) {
      id
      name
    }
  }
`;
export type CreateTagMutationMutationFn = Apollo.MutationFunction<
  CreateTagMutation,
  CreateTagMutationVariables
>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      createTagDtoInput: // value for 'createTagDtoInput'
 *   },
 * });
 */
export function useCreateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTagMutation,
    CreateTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(
    CreateTagMutationDocument,
    options
  );
}
export type CreateTagMutationHookResult = ReturnType<
  typeof useCreateTagMutation
>;
export type CreateTagMutationMutationResult =
  Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateTagMutation,
  CreateTagMutationVariables
>;
export const RecentPostListQueryDocument = gql`
  query RecentPostListQuery(
    $classroomId: String!
    $cursor: String
    $limit: Float
  ) {
    postsCollection: listPosts(
      classroomId: $classroomId
      cursor: $cursor
      limit: $limit
    ) {
      cursor
      posts {
        ...PostItemPostFields
      }
    }
  }
  ${PostItemPostFieldsFragmentDoc}
`;

/**
 * __useRecentPostListQuery__
 *
 * To run a query within a React component, call `useRecentPostListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentPostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentPostListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentPostListQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecentPostListQuery,
    RecentPostListQueryVariables
  > &
    (
      | { variables: RecentPostListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecentPostListQuery, RecentPostListQueryVariables>(
    RecentPostListQueryDocument,
    options
  );
}
export function useRecentPostListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecentPostListQuery,
    RecentPostListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecentPostListQuery, RecentPostListQueryVariables>(
    RecentPostListQueryDocument,
    options
  );
}
export function useRecentPostListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecentPostListQuery,
        RecentPostListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecentPostListQuery,
    RecentPostListQueryVariables
  >(RecentPostListQueryDocument, options);
}
export type RecentPostListQueryHookResult = ReturnType<
  typeof useRecentPostListQuery
>;
export type RecentPostListQueryLazyQueryHookResult = ReturnType<
  typeof useRecentPostListQueryLazyQuery
>;
export type RecentPostListQuerySuspenseQueryHookResult = ReturnType<
  typeof useRecentPostListQuerySuspenseQuery
>;
export type RecentPostListQueryQueryResult = Apollo.QueryResult<
  RecentPostListQuery,
  RecentPostListQueryVariables
>;
export const ScheduledPostListQueryDocument = gql`
  query ScheduledPostListQuery(
    $classroomId: String!
    $channelId: String
    $postType: PostType
    $page: Float
    $perPage: Float
  ) {
    postsCollection: listPostSchedules(
      classroomId: $classroomId
      channelId: $channelId
      postType: $postType
      page: $page
      perPage: $perPage
    ) {
      page
      totalPages
      posts {
        ...DraftPostItemPostFields
      }
    }
  }
  ${DraftPostItemPostFieldsFragmentDoc}
`;

/**
 * __useScheduledPostListQuery__
 *
 * To run a query within a React component, call `useScheduledPostListQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledPostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledPostListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *      postType: // value for 'postType'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useScheduledPostListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduledPostListQuery,
    ScheduledPostListQueryVariables
  > &
    (
      | { variables: ScheduledPostListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduledPostListQuery,
    ScheduledPostListQueryVariables
  >(ScheduledPostListQueryDocument, options);
}
export function useScheduledPostListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduledPostListQuery,
    ScheduledPostListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduledPostListQuery,
    ScheduledPostListQueryVariables
  >(ScheduledPostListQueryDocument, options);
}
export function useScheduledPostListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduledPostListQuery,
        ScheduledPostListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduledPostListQuery,
    ScheduledPostListQueryVariables
  >(ScheduledPostListQueryDocument, options);
}
export type ScheduledPostListQueryHookResult = ReturnType<
  typeof useScheduledPostListQuery
>;
export type ScheduledPostListQueryLazyQueryHookResult = ReturnType<
  typeof useScheduledPostListQueryLazyQuery
>;
export type ScheduledPostListQuerySuspenseQueryHookResult = ReturnType<
  typeof useScheduledPostListQuerySuspenseQuery
>;
export type ScheduledPostListQueryQueryResult = Apollo.QueryResult<
  ScheduledPostListQuery,
  ScheduledPostListQueryVariables
>;
export const TranslatePostMutationDocument = gql`
  mutation TranslatePostMutation(
    $classroomId: String!
    $postId: String!
    $translatePostDtoInput: TranslatePostDtoInput!
  ) {
    translatePost(
      classroomId: $classroomId
      postId: $postId
      translatePostDtoInput: $translatePostDtoInput
    ) {
      id
      content
      classroomId
    }
  }
`;
export type TranslatePostMutationMutationFn = Apollo.MutationFunction<
  TranslatePostMutation,
  TranslatePostMutationVariables
>;

/**
 * __useTranslatePostMutation__
 *
 * To run a mutation, you first call `useTranslatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTranslatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [translatePostMutation, { data, loading, error }] = useTranslatePostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      translatePostDtoInput: // value for 'translatePostDtoInput'
 *   },
 * });
 */
export function useTranslatePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TranslatePostMutation,
    TranslatePostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TranslatePostMutation,
    TranslatePostMutationVariables
  >(TranslatePostMutationDocument, options);
}
export type TranslatePostMutationHookResult = ReturnType<
  typeof useTranslatePostMutation
>;
export type TranslatePostMutationMutationResult =
  Apollo.MutationResult<TranslatePostMutation>;
export type TranslatePostMutationMutationOptions = Apollo.BaseMutationOptions<
  TranslatePostMutation,
  TranslatePostMutationVariables
>;
export const TranslationPostContentQueryDocument = gql`
  query TranslationPostContentQuery($classroomId: String!) {
    translationPermission: getTranslationPermission(classroomId: $classroomId) {
      canTranslatePost
      memberId
    }
    me: getMe {
      id
      language
    }
  }
`;

/**
 * __useTranslationPostContentQuery__
 *
 * To run a query within a React component, call `useTranslationPostContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationPostContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationPostContentQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useTranslationPostContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    TranslationPostContentQuery,
    TranslationPostContentQueryVariables
  > &
    (
      | { variables: TranslationPostContentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TranslationPostContentQuery,
    TranslationPostContentQueryVariables
  >(TranslationPostContentQueryDocument, options);
}
export function useTranslationPostContentQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TranslationPostContentQuery,
    TranslationPostContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TranslationPostContentQuery,
    TranslationPostContentQueryVariables
  >(TranslationPostContentQueryDocument, options);
}
export function useTranslationPostContentQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TranslationPostContentQuery,
        TranslationPostContentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TranslationPostContentQuery,
    TranslationPostContentQueryVariables
  >(TranslationPostContentQueryDocument, options);
}
export type TranslationPostContentQueryHookResult = ReturnType<
  typeof useTranslationPostContentQuery
>;
export type TranslationPostContentQueryLazyQueryHookResult = ReturnType<
  typeof useTranslationPostContentQueryLazyQuery
>;
export type TranslationPostContentQuerySuspenseQueryHookResult = ReturnType<
  typeof useTranslationPostContentQuerySuspenseQuery
>;
export type TranslationPostContentQueryQueryResult = Apollo.QueryResult<
  TranslationPostContentQuery,
  TranslationPostContentQueryVariables
>;
export const WriteAllTypePostButtonQueryDocument = gql`
  query WriteAllTypePostButtonQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      archived
      countryCode
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    commonChannels: listCommonChannels(classroomId: $classroomId) {
      id
      name
      channelType
    }
  }
`;

/**
 * __useWriteAllTypePostButtonQuery__
 *
 * To run a query within a React component, call `useWriteAllTypePostButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriteAllTypePostButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriteAllTypePostButtonQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useWriteAllTypePostButtonQuery(
  baseOptions: Apollo.QueryHookOptions<
    WriteAllTypePostButtonQuery,
    WriteAllTypePostButtonQueryVariables
  > &
    (
      | { variables: WriteAllTypePostButtonQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WriteAllTypePostButtonQuery,
    WriteAllTypePostButtonQueryVariables
  >(WriteAllTypePostButtonQueryDocument, options);
}
export function useWriteAllTypePostButtonQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WriteAllTypePostButtonQuery,
    WriteAllTypePostButtonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WriteAllTypePostButtonQuery,
    WriteAllTypePostButtonQueryVariables
  >(WriteAllTypePostButtonQueryDocument, options);
}
export function useWriteAllTypePostButtonQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WriteAllTypePostButtonQuery,
        WriteAllTypePostButtonQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WriteAllTypePostButtonQuery,
    WriteAllTypePostButtonQueryVariables
  >(WriteAllTypePostButtonQueryDocument, options);
}
export type WriteAllTypePostButtonQueryHookResult = ReturnType<
  typeof useWriteAllTypePostButtonQuery
>;
export type WriteAllTypePostButtonQueryLazyQueryHookResult = ReturnType<
  typeof useWriteAllTypePostButtonQueryLazyQuery
>;
export type WriteAllTypePostButtonQuerySuspenseQueryHookResult = ReturnType<
  typeof useWriteAllTypePostButtonQuerySuspenseQuery
>;
export type WriteAllTypePostButtonQueryQueryResult = Apollo.QueryResult<
  WriteAllTypePostButtonQuery,
  WriteAllTypePostButtonQueryVariables
>;
export const WritePostButtonQueryDocument = gql`
  query WritePostButtonQuery($classroomId: String!, $channelId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      archived
      countryCode
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    currentChannelMember: channelMember(
      classroomId: $classroomId
      channelId: $channelId
      memberId: "me"
    ) {
      id
    }
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      canMemberWritePost
      archived
      channelType
    }
  }
`;

/**
 * __useWritePostButtonQuery__
 *
 * To run a query within a React component, call `useWritePostButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useWritePostButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWritePostButtonQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useWritePostButtonQuery(
  baseOptions: Apollo.QueryHookOptions<
    WritePostButtonQuery,
    WritePostButtonQueryVariables
  > &
    (
      | { variables: WritePostButtonQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WritePostButtonQuery, WritePostButtonQueryVariables>(
    WritePostButtonQueryDocument,
    options
  );
}
export function useWritePostButtonQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WritePostButtonQuery,
    WritePostButtonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WritePostButtonQuery,
    WritePostButtonQueryVariables
  >(WritePostButtonQueryDocument, options);
}
export function useWritePostButtonQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WritePostButtonQuery,
        WritePostButtonQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WritePostButtonQuery,
    WritePostButtonQueryVariables
  >(WritePostButtonQueryDocument, options);
}
export type WritePostButtonQueryHookResult = ReturnType<
  typeof useWritePostButtonQuery
>;
export type WritePostButtonQueryLazyQueryHookResult = ReturnType<
  typeof useWritePostButtonQueryLazyQuery
>;
export type WritePostButtonQuerySuspenseQueryHookResult = ReturnType<
  typeof useWritePostButtonQuerySuspenseQuery
>;
export type WritePostButtonQueryQueryResult = Apollo.QueryResult<
  WritePostButtonQuery,
  WritePostButtonQueryVariables
>;
export const AnnouncementPostListQueryDocument = gql`
  query AnnouncementPostListQuery(
    $classroomId: String!
    $page: Float!
    $perPage: Float!
  ) {
    postsCollection: searchPosts(
      classroomId: $classroomId
      isAnnouncement: true
      page: $page
      perPage: $perPage
      orderBy: "announcedAt desc"
    ) {
      posts {
        ...PostItemPostFields
      }
      totalPages
      perPage
      page
    }
  }
  ${PostItemPostFieldsFragmentDoc}
`;

/**
 * __useAnnouncementPostListQuery__
 *
 * To run a query within a React component, call `useAnnouncementPostListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementPostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementPostListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAnnouncementPostListQuery(
  baseOptions: Apollo.QueryHookOptions<
    AnnouncementPostListQuery,
    AnnouncementPostListQueryVariables
  > &
    (
      | { variables: AnnouncementPostListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AnnouncementPostListQuery,
    AnnouncementPostListQueryVariables
  >(AnnouncementPostListQueryDocument, options);
}
export function useAnnouncementPostListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AnnouncementPostListQuery,
    AnnouncementPostListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AnnouncementPostListQuery,
    AnnouncementPostListQueryVariables
  >(AnnouncementPostListQueryDocument, options);
}
export function useAnnouncementPostListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AnnouncementPostListQuery,
        AnnouncementPostListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AnnouncementPostListQuery,
    AnnouncementPostListQueryVariables
  >(AnnouncementPostListQueryDocument, options);
}
export type AnnouncementPostListQueryHookResult = ReturnType<
  typeof useAnnouncementPostListQuery
>;
export type AnnouncementPostListQueryLazyQueryHookResult = ReturnType<
  typeof useAnnouncementPostListQueryLazyQuery
>;
export type AnnouncementPostListQuerySuspenseQueryHookResult = ReturnType<
  typeof useAnnouncementPostListQuerySuspenseQuery
>;
export type AnnouncementPostListQueryQueryResult = Apollo.QueryResult<
  AnnouncementPostListQuery,
  AnnouncementPostListQueryVariables
>;
export const AnnouncementsPageHeaderQueryDocument = gql`
  query AnnouncementsPageHeaderQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      ...AnnouncementsPageHeaderCurrentMemberFields
    }
  }
  ${AnnouncementsPageHeaderCurrentMemberFieldsFragmentDoc}
`;

/**
 * __useAnnouncementsPageHeaderQuery__
 *
 * To run a query within a React component, call `useAnnouncementsPageHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementsPageHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementsPageHeaderQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAnnouncementsPageHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    AnnouncementsPageHeaderQuery,
    AnnouncementsPageHeaderQueryVariables
  > &
    (
      | { variables: AnnouncementsPageHeaderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AnnouncementsPageHeaderQuery,
    AnnouncementsPageHeaderQueryVariables
  >(AnnouncementsPageHeaderQueryDocument, options);
}
export function useAnnouncementsPageHeaderQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AnnouncementsPageHeaderQuery,
    AnnouncementsPageHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AnnouncementsPageHeaderQuery,
    AnnouncementsPageHeaderQueryVariables
  >(AnnouncementsPageHeaderQueryDocument, options);
}
export function useAnnouncementsPageHeaderQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AnnouncementsPageHeaderQuery,
        AnnouncementsPageHeaderQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AnnouncementsPageHeaderQuery,
    AnnouncementsPageHeaderQueryVariables
  >(AnnouncementsPageHeaderQueryDocument, options);
}
export type AnnouncementsPageHeaderQueryHookResult = ReturnType<
  typeof useAnnouncementsPageHeaderQuery
>;
export type AnnouncementsPageHeaderQueryLazyQueryHookResult = ReturnType<
  typeof useAnnouncementsPageHeaderQueryLazyQuery
>;
export type AnnouncementsPageHeaderQuerySuspenseQueryHookResult = ReturnType<
  typeof useAnnouncementsPageHeaderQuerySuspenseQuery
>;
export type AnnouncementsPageHeaderQueryQueryResult = Apollo.QueryResult<
  AnnouncementsPageHeaderQuery,
  AnnouncementsPageHeaderQueryVariables
>;
export const PostFeedAnnouncementPostListQueryDocument = gql`
  query PostFeedAnnouncementPostListQuery(
    $classroomId: String!
    $page: Float!
    $perPage: Float!
  ) {
    postsCollection: searchPosts(
      classroomId: $classroomId
      isAnnouncement: true
      page: $page
      perPage: $perPage
      orderBy: "announcedAt desc"
    ) {
      posts {
        ...PostFeedItemPostFields
      }
      totalPages
      perPage
      page
    }
  }
  ${PostFeedItemPostFieldsFragmentDoc}
`;

/**
 * __usePostFeedAnnouncementPostListQuery__
 *
 * To run a query within a React component, call `usePostFeedAnnouncementPostListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedAnnouncementPostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedAnnouncementPostListQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function usePostFeedAnnouncementPostListQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostFeedAnnouncementPostListQuery,
    PostFeedAnnouncementPostListQueryVariables
  > &
    (
      | {
          variables: PostFeedAnnouncementPostListQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedAnnouncementPostListQuery,
    PostFeedAnnouncementPostListQueryVariables
  >(PostFeedAnnouncementPostListQueryDocument, options);
}
export function usePostFeedAnnouncementPostListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedAnnouncementPostListQuery,
    PostFeedAnnouncementPostListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedAnnouncementPostListQuery,
    PostFeedAnnouncementPostListQueryVariables
  >(PostFeedAnnouncementPostListQueryDocument, options);
}
export function usePostFeedAnnouncementPostListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedAnnouncementPostListQuery,
        PostFeedAnnouncementPostListQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedAnnouncementPostListQuery,
    PostFeedAnnouncementPostListQueryVariables
  >(PostFeedAnnouncementPostListQueryDocument, options);
}
export type PostFeedAnnouncementPostListQueryHookResult = ReturnType<
  typeof usePostFeedAnnouncementPostListQuery
>;
export type PostFeedAnnouncementPostListQueryLazyQueryHookResult = ReturnType<
  typeof usePostFeedAnnouncementPostListQueryLazyQuery
>;
export type PostFeedAnnouncementPostListQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostFeedAnnouncementPostListQuerySuspenseQuery>;
export type PostFeedAnnouncementPostListQueryQueryResult = Apollo.QueryResult<
  PostFeedAnnouncementPostListQuery,
  PostFeedAnnouncementPostListQueryVariables
>;
export const PostFeedAnnouncementPostListAccountQueryDocument = gql`
  query PostFeedAnnouncementPostListAccountQuery {
    me: getMe {
      id
      role
      isAdFreeSubscribed
      grade
      language
      countryCode
      schoolInfoDto {
        grade
        school {
          zipcode
        }
      }
      schoolInfoDtoForChildren {
        grade
        school {
          zipcode
        }
      }
    }
  }
`;

/**
 * __usePostFeedAnnouncementPostListAccountQuery__
 *
 * To run a query within a React component, call `usePostFeedAnnouncementPostListAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostFeedAnnouncementPostListAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostFeedAnnouncementPostListAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostFeedAnnouncementPostListAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PostFeedAnnouncementPostListAccountQuery,
    PostFeedAnnouncementPostListAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostFeedAnnouncementPostListAccountQuery,
    PostFeedAnnouncementPostListAccountQueryVariables
  >(PostFeedAnnouncementPostListAccountQueryDocument, options);
}
export function usePostFeedAnnouncementPostListAccountQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostFeedAnnouncementPostListAccountQuery,
    PostFeedAnnouncementPostListAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostFeedAnnouncementPostListAccountQuery,
    PostFeedAnnouncementPostListAccountQueryVariables
  >(PostFeedAnnouncementPostListAccountQueryDocument, options);
}
export function usePostFeedAnnouncementPostListAccountQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostFeedAnnouncementPostListAccountQuery,
        PostFeedAnnouncementPostListAccountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostFeedAnnouncementPostListAccountQuery,
    PostFeedAnnouncementPostListAccountQueryVariables
  >(PostFeedAnnouncementPostListAccountQueryDocument, options);
}
export type PostFeedAnnouncementPostListAccountQueryHookResult = ReturnType<
  typeof usePostFeedAnnouncementPostListAccountQuery
>;
export type PostFeedAnnouncementPostListAccountQueryLazyQueryHookResult =
  ReturnType<typeof usePostFeedAnnouncementPostListAccountQueryLazyQuery>;
export type PostFeedAnnouncementPostListAccountQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostFeedAnnouncementPostListAccountQuerySuspenseQuery>;
export type PostFeedAnnouncementPostListAccountQueryQueryResult =
  Apollo.QueryResult<
    PostFeedAnnouncementPostListAccountQuery,
    PostFeedAnnouncementPostListAccountQueryVariables
  >;
export const CanWritePostChannelsQueryDocument = gql`
  query CanWritePostChannelsQuery($classroomId: String!) {
    channelGroups: listChannelGroupsDto(classroomId: $classroomId, limit: 100) {
      ...CanWritePostChannelsChannelGroupFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      ...PostFormMemberFields
    }
  }
  ${CanWritePostChannelsChannelGroupFieldsFragmentDoc}
  ${PostFormMemberFieldsFragmentDoc}
`;

/**
 * __useCanWritePostChannelsQuery__
 *
 * To run a query within a React component, call `useCanWritePostChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanWritePostChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanWritePostChannelsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useCanWritePostChannelsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CanWritePostChannelsQuery,
    CanWritePostChannelsQueryVariables
  > &
    (
      | { variables: CanWritePostChannelsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CanWritePostChannelsQuery,
    CanWritePostChannelsQueryVariables
  >(CanWritePostChannelsQueryDocument, options);
}
export function useCanWritePostChannelsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CanWritePostChannelsQuery,
    CanWritePostChannelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CanWritePostChannelsQuery,
    CanWritePostChannelsQueryVariables
  >(CanWritePostChannelsQueryDocument, options);
}
export function useCanWritePostChannelsQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CanWritePostChannelsQuery,
        CanWritePostChannelsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CanWritePostChannelsQuery,
    CanWritePostChannelsQueryVariables
  >(CanWritePostChannelsQueryDocument, options);
}
export type CanWritePostChannelsQueryHookResult = ReturnType<
  typeof useCanWritePostChannelsQuery
>;
export type CanWritePostChannelsQueryLazyQueryHookResult = ReturnType<
  typeof useCanWritePostChannelsQueryLazyQuery
>;
export type CanWritePostChannelsQuerySuspenseQueryHookResult = ReturnType<
  typeof useCanWritePostChannelsQuerySuspenseQuery
>;
export type CanWritePostChannelsQueryQueryResult = Apollo.QueryResult<
  CanWritePostChannelsQuery,
  CanWritePostChannelsQueryVariables
>;
export const AnnouncementsPageQueryDocument = gql`
  query AnnouncementsPageQuery($classroomId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
    me: getMe {
      id
      isAdFreeSubscribed
    }
  }
`;

/**
 * __useAnnouncementsPageQuery__
 *
 * To run a query within a React component, call `useAnnouncementsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementsPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useAnnouncementsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    AnnouncementsPageQuery,
    AnnouncementsPageQueryVariables
  > &
    (
      | { variables: AnnouncementsPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AnnouncementsPageQuery,
    AnnouncementsPageQueryVariables
  >(AnnouncementsPageQueryDocument, options);
}
export function useAnnouncementsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AnnouncementsPageQuery,
    AnnouncementsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AnnouncementsPageQuery,
    AnnouncementsPageQueryVariables
  >(AnnouncementsPageQueryDocument, options);
}
export function useAnnouncementsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AnnouncementsPageQuery,
        AnnouncementsPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AnnouncementsPageQuery,
    AnnouncementsPageQueryVariables
  >(AnnouncementsPageQueryDocument, options);
}
export type AnnouncementsPageQueryHookResult = ReturnType<
  typeof useAnnouncementsPageQuery
>;
export type AnnouncementsPageQueryLazyQueryHookResult = ReturnType<
  typeof useAnnouncementsPageQueryLazyQuery
>;
export type AnnouncementsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useAnnouncementsPageQuerySuspenseQuery
>;
export type AnnouncementsPageQueryQueryResult = Apollo.QueryResult<
  AnnouncementsPageQuery,
  AnnouncementsPageQueryVariables
>;
export const CreateAnnouncementMutationDocument = gql`
  mutation CreateAnnouncementMutation(
    $classroomId: String!
    $createPostDtoInput: CreatePostDtoInput!
  ) {
    post: createPost(
      classroomId: $classroomId
      createPostDtoInput: $createPostDtoInput
    ) {
      id
    }
  }
`;
export type CreateAnnouncementMutationMutationFn = Apollo.MutationFunction<
  CreateAnnouncementMutation,
  CreateAnnouncementMutationVariables
>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      createPostDtoInput: // value for 'createPostDtoInput'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAnnouncementMutation,
    CreateAnnouncementMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAnnouncementMutation,
    CreateAnnouncementMutationVariables
  >(CreateAnnouncementMutationDocument, options);
}
export type CreateAnnouncementMutationHookResult = ReturnType<
  typeof useCreateAnnouncementMutation
>;
export type CreateAnnouncementMutationMutationResult =
  Apollo.MutationResult<CreateAnnouncementMutation>;
export type CreateAnnouncementMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAnnouncementMutation,
    CreateAnnouncementMutationVariables
  >;
export const CreatePostMutationDocument = gql`
  mutation CreatePostMutation(
    $classroomId: String!
    $createPostDtoInput: CreatePostDtoInput!
  ) {
    post: createPost(
      classroomId: $classroomId
      createPostDtoInput: $createPostDtoInput
    ) {
      id
    }
  }
`;
export type CreatePostMutationMutationFn = Apollo.MutationFunction<
  CreatePostMutation,
  CreatePostMutationVariables
>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      createPostDtoInput: // value for 'createPostDtoInput'
 *   },
 * });
 */
export function useCreatePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePostMutation,
    CreatePostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(
    CreatePostMutationDocument,
    options
  );
}
export type CreatePostMutationHookResult = ReturnType<
  typeof useCreatePostMutation
>;
export type CreatePostMutationMutationResult =
  Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationMutationOptions = Apollo.BaseMutationOptions<
  CreatePostMutation,
  CreatePostMutationVariables
>;
export const CreateAssignmentMutationDocument = gql`
  mutation CreateAssignmentMutation(
    $classroomId: String!
    $createAssignmentDtoInput: CreateAssignmentDtoInput!
  ) {
    assignment: createAssignment(
      classroomId: $classroomId
      createAssignmentDtoInput: $createAssignmentDtoInput
    ) {
      id
    }
  }
`;
export type CreateAssignmentMutationMutationFn = Apollo.MutationFunction<
  CreateAssignmentMutation,
  CreateAssignmentMutationVariables
>;

/**
 * __useCreateAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentMutation, { data, loading, error }] = useCreateAssignmentMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      createAssignmentDtoInput: // value for 'createAssignmentDtoInput'
 *   },
 * });
 */
export function useCreateAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAssignmentMutation,
    CreateAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAssignmentMutation,
    CreateAssignmentMutationVariables
  >(CreateAssignmentMutationDocument, options);
}
export type CreateAssignmentMutationHookResult = ReturnType<
  typeof useCreateAssignmentMutation
>;
export type CreateAssignmentMutationMutationResult =
  Apollo.MutationResult<CreateAssignmentMutation>;
export type CreateAssignmentMutationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAssignmentMutation,
    CreateAssignmentMutationVariables
  >;
export const DraftPostListPopupQueryDocument = gql`
  query DraftPostListPopupQuery($classroomId: String!) {
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
  }
`;

/**
 * __useDraftPostListPopupQuery__
 *
 * To run a query within a React component, call `useDraftPostListPopupQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftPostListPopupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftPostListPopupQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useDraftPostListPopupQuery(
  baseOptions: Apollo.QueryHookOptions<
    DraftPostListPopupQuery,
    DraftPostListPopupQueryVariables
  > &
    (
      | { variables: DraftPostListPopupQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DraftPostListPopupQuery,
    DraftPostListPopupQueryVariables
  >(DraftPostListPopupQueryDocument, options);
}
export function useDraftPostListPopupQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DraftPostListPopupQuery,
    DraftPostListPopupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DraftPostListPopupQuery,
    DraftPostListPopupQueryVariables
  >(DraftPostListPopupQueryDocument, options);
}
export function useDraftPostListPopupQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DraftPostListPopupQuery,
        DraftPostListPopupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DraftPostListPopupQuery,
    DraftPostListPopupQueryVariables
  >(DraftPostListPopupQueryDocument, options);
}
export type DraftPostListPopupQueryHookResult = ReturnType<
  typeof useDraftPostListPopupQuery
>;
export type DraftPostListPopupQueryLazyQueryHookResult = ReturnType<
  typeof useDraftPostListPopupQueryLazyQuery
>;
export type DraftPostListPopupQuerySuspenseQueryHookResult = ReturnType<
  typeof useDraftPostListPopupQuerySuspenseQuery
>;
export type DraftPostListPopupQueryQueryResult = Apollo.QueryResult<
  DraftPostListPopupQuery,
  DraftPostListPopupQueryVariables
>;
export const UpdateAnnouncementMutationDocument = gql`
  mutation UpdateAnnouncementMutation(
    $classroomId: String!
    $postId: String!
    $updatePostDtoInput: UpdatePostDtoInput!
  ) {
    post: updatePost(
      classroomId: $classroomId
      postId: $postId
      updatePostDtoInput: $updatePostDtoInput
    ) {
      id
      content
      title
      imageIds
      videoIds
      fileIds
      createdAt
      updatedAt
      channelId
    }
  }
`;
export type UpdateAnnouncementMutationMutationFn = Apollo.MutationFunction<
  UpdateAnnouncementMutation,
  UpdateAnnouncementMutationVariables
>;

/**
 * __useUpdateAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementMutation, { data, loading, error }] = useUpdateAnnouncementMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      updatePostDtoInput: // value for 'updatePostDtoInput'
 *   },
 * });
 */
export function useUpdateAnnouncementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAnnouncementMutation,
    UpdateAnnouncementMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAnnouncementMutation,
    UpdateAnnouncementMutationVariables
  >(UpdateAnnouncementMutationDocument, options);
}
export type UpdateAnnouncementMutationHookResult = ReturnType<
  typeof useUpdateAnnouncementMutation
>;
export type UpdateAnnouncementMutationMutationResult =
  Apollo.MutationResult<UpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAnnouncementMutation,
    UpdateAnnouncementMutationVariables
  >;
export const EditAnnouncementPageQueryDocument = gql`
  query EditAnnouncementPageQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...AnnouncementFormPostFields
      author {
        id
      }
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
  ${AnnouncementFormPostFieldsFragmentDoc}
`;

/**
 * __useEditAnnouncementPageQuery__
 *
 * To run a query within a React component, call `useEditAnnouncementPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAnnouncementPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAnnouncementPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useEditAnnouncementPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditAnnouncementPageQuery,
    EditAnnouncementPageQueryVariables
  > &
    (
      | { variables: EditAnnouncementPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EditAnnouncementPageQuery,
    EditAnnouncementPageQueryVariables
  >(EditAnnouncementPageQueryDocument, options);
}
export function useEditAnnouncementPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditAnnouncementPageQuery,
    EditAnnouncementPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EditAnnouncementPageQuery,
    EditAnnouncementPageQueryVariables
  >(EditAnnouncementPageQueryDocument, options);
}
export function useEditAnnouncementPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditAnnouncementPageQuery,
        EditAnnouncementPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EditAnnouncementPageQuery,
    EditAnnouncementPageQueryVariables
  >(EditAnnouncementPageQueryDocument, options);
}
export type EditAnnouncementPageQueryHookResult = ReturnType<
  typeof useEditAnnouncementPageQuery
>;
export type EditAnnouncementPageQueryLazyQueryHookResult = ReturnType<
  typeof useEditAnnouncementPageQueryLazyQuery
>;
export type EditAnnouncementPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useEditAnnouncementPageQuerySuspenseQuery
>;
export type EditAnnouncementPageQueryQueryResult = Apollo.QueryResult<
  EditAnnouncementPageQuery,
  EditAnnouncementPageQueryVariables
>;
export const EditAnnouncementPageChannelQueryDocument = gql`
  query EditAnnouncementPageChannelQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      editorMode
    }
  }
`;

/**
 * __useEditAnnouncementPageChannelQuery__
 *
 * To run a query within a React component, call `useEditAnnouncementPageChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAnnouncementPageChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAnnouncementPageChannelQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useEditAnnouncementPageChannelQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditAnnouncementPageChannelQuery,
    EditAnnouncementPageChannelQueryVariables
  > &
    (
      | { variables: EditAnnouncementPageChannelQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EditAnnouncementPageChannelQuery,
    EditAnnouncementPageChannelQueryVariables
  >(EditAnnouncementPageChannelQueryDocument, options);
}
export function useEditAnnouncementPageChannelQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditAnnouncementPageChannelQuery,
    EditAnnouncementPageChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EditAnnouncementPageChannelQuery,
    EditAnnouncementPageChannelQueryVariables
  >(EditAnnouncementPageChannelQueryDocument, options);
}
export function useEditAnnouncementPageChannelQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditAnnouncementPageChannelQuery,
        EditAnnouncementPageChannelQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EditAnnouncementPageChannelQuery,
    EditAnnouncementPageChannelQueryVariables
  >(EditAnnouncementPageChannelQueryDocument, options);
}
export type EditAnnouncementPageChannelQueryHookResult = ReturnType<
  typeof useEditAnnouncementPageChannelQuery
>;
export type EditAnnouncementPageChannelQueryLazyQueryHookResult = ReturnType<
  typeof useEditAnnouncementPageChannelQueryLazyQuery
>;
export type EditAnnouncementPageChannelQuerySuspenseQueryHookResult =
  ReturnType<typeof useEditAnnouncementPageChannelQuerySuspenseQuery>;
export type EditAnnouncementPageChannelQueryQueryResult = Apollo.QueryResult<
  EditAnnouncementPageChannelQuery,
  EditAnnouncementPageChannelQueryVariables
>;
export const EditPostPageQueryDocument = gql`
  query EditPostPageQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...PostFormPostFields
      author {
        id
      }
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
  ${PostFormPostFieldsFragmentDoc}
`;

/**
 * __useEditPostPageQuery__
 *
 * To run a query within a React component, call `useEditPostPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPostPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPostPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useEditPostPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    EditPostPageQuery,
    EditPostPageQueryVariables
  > &
    (
      | { variables: EditPostPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EditPostPageQuery, EditPostPageQueryVariables>(
    EditPostPageQueryDocument,
    options
  );
}
export function useEditPostPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EditPostPageQuery,
    EditPostPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EditPostPageQuery, EditPostPageQueryVariables>(
    EditPostPageQueryDocument,
    options
  );
}
export function useEditPostPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EditPostPageQuery,
        EditPostPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EditPostPageQuery, EditPostPageQueryVariables>(
    EditPostPageQueryDocument,
    options
  );
}
export type EditPostPageQueryHookResult = ReturnType<
  typeof useEditPostPageQuery
>;
export type EditPostPageQueryLazyQueryHookResult = ReturnType<
  typeof useEditPostPageQueryLazyQuery
>;
export type EditPostPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useEditPostPageQuerySuspenseQuery
>;
export type EditPostPageQueryQueryResult = Apollo.QueryResult<
  EditPostPageQuery,
  EditPostPageQueryVariables
>;
export const PostDetailPageQueryDocument = gql`
  query PostDetailPageQuery($classroomId: String!, $postId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
    post: getPost(classroomId: $classroomId, postId: $postId) {
      id
      ...PostHeaderPostFields
      ...PostContentPostFields
      ...MarkPostAsReadPostFields
      ...CommentListPostDtoFields
      tags
      readsCount
      assignmentId
      type
    }
    me: getMe {
      id
      role
      isAdFreeSubscribed
      grade
      language
      countryCode
      schoolInfoDto {
        grade
        school {
          zipcode
        }
      }
      schoolInfoDtoForChildren {
        grade
        school {
          zipcode
        }
      }
    }
  }
  ${PostHeaderPostFieldsFragmentDoc}
  ${PostContentPostFieldsFragmentDoc}
  ${MarkPostAsReadPostFieldsFragmentDoc}
  ${CommentListPostDtoFieldsFragmentDoc}
`;

/**
 * __usePostDetailPageQuery__
 *
 * To run a query within a React component, call `usePostDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDetailPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostDetailPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostDetailPageQuery,
    PostDetailPageQueryVariables
  > &
    (
      | { variables: PostDetailPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostDetailPageQuery, PostDetailPageQueryVariables>(
    PostDetailPageQueryDocument,
    options
  );
}
export function usePostDetailPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostDetailPageQuery,
    PostDetailPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostDetailPageQuery, PostDetailPageQueryVariables>(
    PostDetailPageQueryDocument,
    options
  );
}
export function usePostDetailPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostDetailPageQuery,
        PostDetailPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostDetailPageQuery,
    PostDetailPageQueryVariables
  >(PostDetailPageQueryDocument, options);
}
export type PostDetailPageQueryHookResult = ReturnType<
  typeof usePostDetailPageQuery
>;
export type PostDetailPageQueryLazyQueryHookResult = ReturnType<
  typeof usePostDetailPageQueryLazyQuery
>;
export type PostDetailPageQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostDetailPageQuerySuspenseQuery
>;
export type PostDetailPageQueryQueryResult = Apollo.QueryResult<
  PostDetailPageQuery,
  PostDetailPageQueryVariables
>;
export const PostDetailPagePostPermissionQueryDocument = gql`
  query PostDetailPagePostPermissionQuery(
    $classroomId: String!
    $postId: String!
  ) {
    postPermission: getPostPermission(
      classroomId: $classroomId
      postId: $postId
    ) {
      canReact
    }
  }
`;

/**
 * __usePostDetailPagePostPermissionQuery__
 *
 * To run a query within a React component, call `usePostDetailPagePostPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostDetailPagePostPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDetailPagePostPermissionQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostDetailPagePostPermissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostDetailPagePostPermissionQuery,
    PostDetailPagePostPermissionQueryVariables
  > &
    (
      | {
          variables: PostDetailPagePostPermissionQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostDetailPagePostPermissionQuery,
    PostDetailPagePostPermissionQueryVariables
  >(PostDetailPagePostPermissionQueryDocument, options);
}
export function usePostDetailPagePostPermissionQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostDetailPagePostPermissionQuery,
    PostDetailPagePostPermissionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostDetailPagePostPermissionQuery,
    PostDetailPagePostPermissionQueryVariables
  >(PostDetailPagePostPermissionQueryDocument, options);
}
export function usePostDetailPagePostPermissionQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostDetailPagePostPermissionQuery,
        PostDetailPagePostPermissionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostDetailPagePostPermissionQuery,
    PostDetailPagePostPermissionQueryVariables
  >(PostDetailPagePostPermissionQueryDocument, options);
}
export type PostDetailPagePostPermissionQueryHookResult = ReturnType<
  typeof usePostDetailPagePostPermissionQuery
>;
export type PostDetailPagePostPermissionQueryLazyQueryHookResult = ReturnType<
  typeof usePostDetailPagePostPermissionQueryLazyQuery
>;
export type PostDetailPagePostPermissionQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostDetailPagePostPermissionQuerySuspenseQuery>;
export type PostDetailPagePostPermissionQueryQueryResult = Apollo.QueryResult<
  PostDetailPagePostPermissionQuery,
  PostDetailPagePostPermissionQueryVariables
>;
export const PostDetailPageChannelQueryDocument = gql`
  query PostDetailPageChannelQuery($classroomId: String!, $channelId: String!) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
      canMemberWriteComment
      isPrivate
    }
  }
`;

/**
 * __usePostDetailPageChannelQuery__
 *
 * To run a query within a React component, call `usePostDetailPageChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostDetailPageChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDetailPageChannelQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostDetailPageChannelQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostDetailPageChannelQuery,
    PostDetailPageChannelQueryVariables
  > &
    (
      | { variables: PostDetailPageChannelQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostDetailPageChannelQuery,
    PostDetailPageChannelQueryVariables
  >(PostDetailPageChannelQueryDocument, options);
}
export function usePostDetailPageChannelQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostDetailPageChannelQuery,
    PostDetailPageChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostDetailPageChannelQuery,
    PostDetailPageChannelQueryVariables
  >(PostDetailPageChannelQueryDocument, options);
}
export function usePostDetailPageChannelQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostDetailPageChannelQuery,
        PostDetailPageChannelQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostDetailPageChannelQuery,
    PostDetailPageChannelQueryVariables
  >(PostDetailPageChannelQueryDocument, options);
}
export type PostDetailPageChannelQueryHookResult = ReturnType<
  typeof usePostDetailPageChannelQuery
>;
export type PostDetailPageChannelQueryLazyQueryHookResult = ReturnType<
  typeof usePostDetailPageChannelQueryLazyQuery
>;
export type PostDetailPageChannelQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostDetailPageChannelQuerySuspenseQuery
>;
export type PostDetailPageChannelQueryQueryResult = Apollo.QueryResult<
  PostDetailPageChannelQuery,
  PostDetailPageChannelQueryVariables
>;
export const PostListSearchedByTagPageQueryDocument = gql`
  query PostListSearchedByTagPageQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
    }
  }
`;

/**
 * __usePostListSearchedByTagPageQuery__
 *
 * To run a query within a React component, call `usePostListSearchedByTagPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostListSearchedByTagPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostListSearchedByTagPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostListSearchedByTagPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostListSearchedByTagPageQuery,
    PostListSearchedByTagPageQueryVariables
  > &
    (
      | { variables: PostListSearchedByTagPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostListSearchedByTagPageQuery,
    PostListSearchedByTagPageQueryVariables
  >(PostListSearchedByTagPageQueryDocument, options);
}
export function usePostListSearchedByTagPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostListSearchedByTagPageQuery,
    PostListSearchedByTagPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostListSearchedByTagPageQuery,
    PostListSearchedByTagPageQueryVariables
  >(PostListSearchedByTagPageQueryDocument, options);
}
export function usePostListSearchedByTagPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostListSearchedByTagPageQuery,
        PostListSearchedByTagPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostListSearchedByTagPageQuery,
    PostListSearchedByTagPageQueryVariables
  >(PostListSearchedByTagPageQueryDocument, options);
}
export type PostListSearchedByTagPageQueryHookResult = ReturnType<
  typeof usePostListSearchedByTagPageQuery
>;
export type PostListSearchedByTagPageQueryLazyQueryHookResult = ReturnType<
  typeof usePostListSearchedByTagPageQueryLazyQuery
>;
export type PostListSearchedByTagPageQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostListSearchedByTagPageQuerySuspenseQuery
>;
export type PostListSearchedByTagPageQueryQueryResult = Apollo.QueryResult<
  PostListSearchedByTagPageQuery,
  PostListSearchedByTagPageQueryVariables
>;
export const PostPresentationModePageQueryDocument = gql`
  query PostPresentationModePageQuery($classroomId: String!, $postId: String!) {
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
    post: getPost(classroomId: $classroomId, postId: $postId) {
      id
      title
      channelId
      ...PostContentPostFields
      ...MarkPostAsReadPostFields
    }
  }
  ${PostContentPostFieldsFragmentDoc}
  ${MarkPostAsReadPostFieldsFragmentDoc}
`;

/**
 * __usePostPresentationModePageQuery__
 *
 * To run a query within a React component, call `usePostPresentationModePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostPresentationModePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostPresentationModePageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostPresentationModePageQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostPresentationModePageQuery,
    PostPresentationModePageQueryVariables
  > &
    (
      | { variables: PostPresentationModePageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostPresentationModePageQuery,
    PostPresentationModePageQueryVariables
  >(PostPresentationModePageQueryDocument, options);
}
export function usePostPresentationModePageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostPresentationModePageQuery,
    PostPresentationModePageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostPresentationModePageQuery,
    PostPresentationModePageQueryVariables
  >(PostPresentationModePageQueryDocument, options);
}
export function usePostPresentationModePageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostPresentationModePageQuery,
        PostPresentationModePageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostPresentationModePageQuery,
    PostPresentationModePageQueryVariables
  >(PostPresentationModePageQueryDocument, options);
}
export type PostPresentationModePageQueryHookResult = ReturnType<
  typeof usePostPresentationModePageQuery
>;
export type PostPresentationModePageQueryLazyQueryHookResult = ReturnType<
  typeof usePostPresentationModePageQueryLazyQuery
>;
export type PostPresentationModePageQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostPresentationModePageQuerySuspenseQuery
>;
export type PostPresentationModePageQueryQueryResult = Apollo.QueryResult<
  PostPresentationModePageQuery,
  PostPresentationModePageQueryVariables
>;
export const PostPresentationModePageChannelQueryDocument = gql`
  query PostPresentationModePageChannelQuery(
    $classroomId: String!
    $channelId: String!
  ) {
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      name
      isPrivate
    }
  }
`;

/**
 * __usePostPresentationModePageChannelQuery__
 *
 * To run a query within a React component, call `usePostPresentationModePageChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostPresentationModePageChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostPresentationModePageChannelQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostPresentationModePageChannelQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostPresentationModePageChannelQuery,
    PostPresentationModePageChannelQueryVariables
  > &
    (
      | {
          variables: PostPresentationModePageChannelQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostPresentationModePageChannelQuery,
    PostPresentationModePageChannelQueryVariables
  >(PostPresentationModePageChannelQueryDocument, options);
}
export function usePostPresentationModePageChannelQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostPresentationModePageChannelQuery,
    PostPresentationModePageChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostPresentationModePageChannelQuery,
    PostPresentationModePageChannelQueryVariables
  >(PostPresentationModePageChannelQueryDocument, options);
}
export function usePostPresentationModePageChannelQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostPresentationModePageChannelQuery,
        PostPresentationModePageChannelQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostPresentationModePageChannelQuery,
    PostPresentationModePageChannelQueryVariables
  >(PostPresentationModePageChannelQueryDocument, options);
}
export type PostPresentationModePageChannelQueryHookResult = ReturnType<
  typeof usePostPresentationModePageChannelQuery
>;
export type PostPresentationModePageChannelQueryLazyQueryHookResult =
  ReturnType<typeof usePostPresentationModePageChannelQueryLazyQuery>;
export type PostPresentationModePageChannelQuerySuspenseQueryHookResult =
  ReturnType<typeof usePostPresentationModePageChannelQuerySuspenseQuery>;
export type PostPresentationModePageChannelQueryQueryResult =
  Apollo.QueryResult<
    PostPresentationModePageChannelQuery,
    PostPresentationModePageChannelQueryVariables
  >;
export const PostRecipientsPageQueryDocument = gql`
  query PostRecipientsPageQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      id
      ...PostRecipientsPostFields
    }
    readMembers: listPostReads(classroomId: $classroomId, postId: $postId) {
      ...PostRecipientsMemberFields
    }
    unreadMembers: listPostUnreads(classroomId: $classroomId, postId: $postId) {
      ...PostRecipientsMemberFields
    }
  }
  ${PostRecipientsPostFieldsFragmentDoc}
  ${PostRecipientsMemberFieldsFragmentDoc}
`;

/**
 * __usePostRecipientsPageQuery__
 *
 * To run a query within a React component, call `usePostRecipientsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostRecipientsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostRecipientsPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostRecipientsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostRecipientsPageQuery,
    PostRecipientsPageQueryVariables
  > &
    (
      | { variables: PostRecipientsPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PostRecipientsPageQuery,
    PostRecipientsPageQueryVariables
  >(PostRecipientsPageQueryDocument, options);
}
export function usePostRecipientsPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostRecipientsPageQuery,
    PostRecipientsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PostRecipientsPageQuery,
    PostRecipientsPageQueryVariables
  >(PostRecipientsPageQueryDocument, options);
}
export function usePostRecipientsPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PostRecipientsPageQuery,
        PostRecipientsPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PostRecipientsPageQuery,
    PostRecipientsPageQueryVariables
  >(PostRecipientsPageQueryDocument, options);
}
export type PostRecipientsPageQueryHookResult = ReturnType<
  typeof usePostRecipientsPageQuery
>;
export type PostRecipientsPageQueryLazyQueryHookResult = ReturnType<
  typeof usePostRecipientsPageQueryLazyQuery
>;
export type PostRecipientsPageQuerySuspenseQueryHookResult = ReturnType<
  typeof usePostRecipientsPageQuerySuspenseQuery
>;
export type PostRecipientsPageQueryQueryResult = Apollo.QueryResult<
  PostRecipientsPageQuery,
  PostRecipientsPageQueryVariables
>;
export const SavePostAsDraftMutationDocument = gql`
  mutation SavePostAsDraftMutation(
    $classroomId: String!
    $postId: String!
    $savePostAsDraftDtoInput: SavePostAsDraftDtoInput!
  ) {
    post: savePostAsDraft(
      classroomId: $classroomId
      postId: $postId
      savePostAsDraftDtoInput: $savePostAsDraftDtoInput
    ) {
      id
      authorId
      channelId
      title
      content
      status
      createdAt
    }
  }
`;
export type SavePostAsDraftMutationMutationFn = Apollo.MutationFunction<
  SavePostAsDraftMutation,
  SavePostAsDraftMutationVariables
>;

/**
 * __useSavePostAsDraftMutation__
 *
 * To run a mutation, you first call `useSavePostAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostAsDraftMutation, { data, loading, error }] = useSavePostAsDraftMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      savePostAsDraftDtoInput: // value for 'savePostAsDraftDtoInput'
 *   },
 * });
 */
export function useSavePostAsDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SavePostAsDraftMutation,
    SavePostAsDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SavePostAsDraftMutation,
    SavePostAsDraftMutationVariables
  >(SavePostAsDraftMutationDocument, options);
}
export type SavePostAsDraftMutationHookResult = ReturnType<
  typeof useSavePostAsDraftMutation
>;
export type SavePostAsDraftMutationMutationResult =
  Apollo.MutationResult<SavePostAsDraftMutation>;
export type SavePostAsDraftMutationMutationOptions = Apollo.BaseMutationOptions<
  SavePostAsDraftMutation,
  SavePostAsDraftMutationVariables
>;
export const PublishPostMutationDocument = gql`
  mutation PublishPostMutation($classroomId: String!, $postId: String!) {
    post: publishPost(classroomId: $classroomId, postId: $postId) {
      id
      authorId
      channelId
      title
      content
      status
      createdAt
    }
  }
`;
export type PublishPostMutationMutationFn = Apollo.MutationFunction<
  PublishPostMutation,
  PublishPostMutationVariables
>;

/**
 * __usePublishPostMutation__
 *
 * To run a mutation, you first call `usePublishPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPostMutation, { data, loading, error }] = usePublishPostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePublishPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishPostMutation,
    PublishPostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PublishPostMutation, PublishPostMutationVariables>(
    PublishPostMutationDocument,
    options
  );
}
export type PublishPostMutationHookResult = ReturnType<
  typeof usePublishPostMutation
>;
export type PublishPostMutationMutationResult =
  Apollo.MutationResult<PublishPostMutation>;
export type PublishPostMutationMutationOptions = Apollo.BaseMutationOptions<
  PublishPostMutation,
  PublishPostMutationVariables
>;
export const SchedulePostMutationDocument = gql`
  mutation SchedulePostMutation($classroomId: String!, $postId: String!) {
    post: schedulePost(classroomId: $classroomId, postId: $postId) {
      id
      channelId
      title
      content
      status
      scheduledAt
    }
  }
`;
export type SchedulePostMutationMutationFn = Apollo.MutationFunction<
  SchedulePostMutation,
  SchedulePostMutationVariables
>;

/**
 * __useSchedulePostMutation__
 *
 * To run a mutation, you first call `useSchedulePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulePostMutation, { data, loading, error }] = useSchedulePostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useSchedulePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SchedulePostMutation,
    SchedulePostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SchedulePostMutation,
    SchedulePostMutationVariables
  >(SchedulePostMutationDocument, options);
}
export type SchedulePostMutationHookResult = ReturnType<
  typeof useSchedulePostMutation
>;
export type SchedulePostMutationMutationResult =
  Apollo.MutationResult<SchedulePostMutation>;
export type SchedulePostMutationMutationOptions = Apollo.BaseMutationOptions<
  SchedulePostMutation,
  SchedulePostMutationVariables
>;
export const UnschedulePostMutationDocument = gql`
  mutation UnschedulePostMutation($classroomId: String!, $postId: String!) {
    post: unschedulePost(classroomId: $classroomId, postId: $postId) {
      id
      channelId
      title
      content
      status
      scheduledAt
    }
  }
`;
export type UnschedulePostMutationMutationFn = Apollo.MutationFunction<
  UnschedulePostMutation,
  UnschedulePostMutationVariables
>;

/**
 * __useUnschedulePostMutation__
 *
 * To run a mutation, you first call `useUnschedulePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnschedulePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unschedulePostMutation, { data, loading, error }] = useUnschedulePostMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useUnschedulePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnschedulePostMutation,
    UnschedulePostMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnschedulePostMutation,
    UnschedulePostMutationVariables
  >(UnschedulePostMutationDocument, options);
}
export type UnschedulePostMutationHookResult = ReturnType<
  typeof useUnschedulePostMutation
>;
export type UnschedulePostMutationMutationResult =
  Apollo.MutationResult<UnschedulePostMutation>;
export type UnschedulePostMutationMutationOptions = Apollo.BaseMutationOptions<
  UnschedulePostMutation,
  UnschedulePostMutationVariables
>;
export const WriteAnnouncementPageQueryDocument = gql`
  query WriteAnnouncementPageQuery(
    $classroomId: String!
    $postId: String!
    $channelId: String!
  ) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...PostFormPostFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
    channel: getChannelDto(classroomId: $classroomId, channelId: $channelId) {
      id
      editorMode
    }
  }
  ${PostFormPostFieldsFragmentDoc}
`;

/**
 * __useWriteAnnouncementPageQuery__
 *
 * To run a query within a React component, call `useWriteAnnouncementPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWriteAnnouncementPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWriteAnnouncementPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useWriteAnnouncementPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    WriteAnnouncementPageQuery,
    WriteAnnouncementPageQueryVariables
  > &
    (
      | { variables: WriteAnnouncementPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WriteAnnouncementPageQuery,
    WriteAnnouncementPageQueryVariables
  >(WriteAnnouncementPageQueryDocument, options);
}
export function useWriteAnnouncementPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WriteAnnouncementPageQuery,
    WriteAnnouncementPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WriteAnnouncementPageQuery,
    WriteAnnouncementPageQueryVariables
  >(WriteAnnouncementPageQueryDocument, options);
}
export function useWriteAnnouncementPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WriteAnnouncementPageQuery,
        WriteAnnouncementPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WriteAnnouncementPageQuery,
    WriteAnnouncementPageQueryVariables
  >(WriteAnnouncementPageQueryDocument, options);
}
export type WriteAnnouncementPageQueryHookResult = ReturnType<
  typeof useWriteAnnouncementPageQuery
>;
export type WriteAnnouncementPageQueryLazyQueryHookResult = ReturnType<
  typeof useWriteAnnouncementPageQueryLazyQuery
>;
export type WriteAnnouncementPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useWriteAnnouncementPageQuerySuspenseQuery
>;
export type WriteAnnouncementPageQueryQueryResult = Apollo.QueryResult<
  WriteAnnouncementPageQuery,
  WriteAnnouncementPageQueryVariables
>;
export const WritePostPageQueryDocument = gql`
  query WritePostPageQuery($classroomId: String!, $postId: String!) {
    post: getPost(classroomId: $classroomId, postId: $postId) {
      ...PostFormPostFields
    }
    currentMember: getClassroomMember(
      classroomId: $classroomId
      memberId: "me"
    ) {
      id
      role
    }
    classroom: getClassroom(classroomId: $classroomId) {
      id
      name
    }
  }
  ${PostFormPostFieldsFragmentDoc}
`;

/**
 * __useWritePostPageQuery__
 *
 * To run a query within a React component, call `useWritePostPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWritePostPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWritePostPageQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useWritePostPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    WritePostPageQuery,
    WritePostPageQueryVariables
  > &
    (
      | { variables: WritePostPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WritePostPageQuery, WritePostPageQueryVariables>(
    WritePostPageQueryDocument,
    options
  );
}
export function useWritePostPageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WritePostPageQuery,
    WritePostPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WritePostPageQuery, WritePostPageQueryVariables>(
    WritePostPageQueryDocument,
    options
  );
}
export function useWritePostPageQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WritePostPageQuery,
        WritePostPageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WritePostPageQuery,
    WritePostPageQueryVariables
  >(WritePostPageQueryDocument, options);
}
export type WritePostPageQueryHookResult = ReturnType<
  typeof useWritePostPageQuery
>;
export type WritePostPageQueryLazyQueryHookResult = ReturnType<
  typeof useWritePostPageQueryLazyQuery
>;
export type WritePostPageQuerySuspenseQueryHookResult = ReturnType<
  typeof useWritePostPageQuerySuspenseQuery
>;
export type WritePostPageQueryQueryResult = Apollo.QueryResult<
  WritePostPageQuery,
  WritePostPageQueryVariables
>;
